var T4 = Object.defineProperty;
var O4 = (t, e, r) => e in t ? T4(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var Le = (t, e, r) => (O4(t, typeof e != "symbol" ? e + "" : e, r), r), Md = (t, e, r) => {
  if (!e.has(t))
    throw TypeError("Cannot " + r);
};
var Se = (t, e, r) => (Md(t, e, "read from private field"), r ? r.call(t) : e.get(t)), Ve = (t, e, r) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, r);
}, Nt = (t, e, r, n) => (Md(t, e, "write to private field"), n ? n.call(t, r) : e.set(t, r), r);
var fn = (t, e, r) => (Md(t, e, "access private method"), r);
import { z as Lr } from "zod";
function k4(t, e) {
  for (var r = 0; r < e.length; r++) {
    const n = e[r];
    if (typeof n != "string" && !Array.isArray(n)) {
      for (const i in n)
        if (i !== "default" && !(i in t)) {
          const o = Object.getOwnPropertyDescriptor(n, i);
          o && Object.defineProperty(t, i, o.get ? o : {
            enumerable: !0,
            get: () => n[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
}
function C4(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var fm = { exports: {} }, Mr = fm.exports = {}, pi, yi;
function g0() {
  throw new Error("setTimeout has not been defined");
}
function v0() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? pi = setTimeout : pi = g0;
  } catch {
    pi = g0;
  }
  try {
    typeof clearTimeout == "function" ? yi = clearTimeout : yi = v0;
  } catch {
    yi = v0;
  }
})();
function cm(t) {
  if (pi === setTimeout)
    return setTimeout(t, 0);
  if ((pi === g0 || !pi) && setTimeout)
    return pi = setTimeout, setTimeout(t, 0);
  try {
    return pi(t, 0);
  } catch {
    try {
      return pi.call(null, t, 0);
    } catch {
      return pi.call(this, t, 0);
    }
  }
}
function P4(t) {
  if (yi === clearTimeout)
    return clearTimeout(t);
  if ((yi === v0 || !yi) && clearTimeout)
    return yi = clearTimeout, clearTimeout(t);
  try {
    return yi(t);
  } catch {
    try {
      return yi.call(null, t);
    } catch {
      return yi.call(this, t);
    }
  }
}
var Ci = [], Aa = !1, bo, lc = -1;
function N4() {
  !Aa || !bo || (Aa = !1, bo.length ? Ci = bo.concat(Ci) : lc = -1, Ci.length && um());
}
function um() {
  if (!Aa) {
    var t = cm(N4);
    Aa = !0;
    for (var e = Ci.length; e; ) {
      for (bo = Ci, Ci = []; ++lc < e; )
        bo && bo[lc].run();
      lc = -1, e = Ci.length;
    }
    bo = null, Aa = !1, P4(t);
  }
}
Mr.nextTick = function(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var r = 1; r < arguments.length; r++)
      e[r - 1] = arguments[r];
  Ci.push(new dm(t, e)), Ci.length === 1 && !Aa && cm(um);
};
function dm(t, e) {
  this.fun = t, this.array = e;
}
dm.prototype.run = function() {
  this.fun.apply(null, this.array);
};
Mr.title = "browser";
Mr.browser = !0;
Mr.env = {};
Mr.argv = [];
Mr.version = "";
Mr.versions = {};
function ji() {
}
Mr.on = ji;
Mr.addListener = ji;
Mr.once = ji;
Mr.off = ji;
Mr.removeListener = ji;
Mr.removeAllListeners = ji;
Mr.emit = ji;
Mr.prependListener = ji;
Mr.prependOnceListener = ji;
Mr.listeners = function(t) {
  return [];
};
Mr.binding = function(t) {
  throw new Error("process.binding is not supported");
};
Mr.cwd = function() {
  return "/";
};
Mr.chdir = function(t) {
  throw new Error("process.chdir is not supported");
};
Mr.umask = function() {
  return 0;
};
var U4 = fm.exports;
const Ye = /* @__PURE__ */ C4(U4);
function m0() {
  const t = {};
  return t.promise = new Promise((e, r) => {
    t.resolve = e, t.reject = r;
  }), t;
}
const F4 = "3.3.7", H1 = Lr.object({
  dangerouslyInjectWindow: Lr.boolean().optional().default(!1),
  walletStandard: Lr.boolean().optional().default(!0)
}), G1 = Lr.object({
  dangerouslyInjectWindow: Lr.boolean().optional().default(!1),
  eip6963: Lr.boolean().optional().default(!0)
}), V1 = Lr.object({
  dangerouslyInjectWindow: Lr.boolean().optional().default(!1),
  walletStandard: Lr.boolean().optional().default(!0)
}), Y1 = Lr.object({
  bitcoin: Lr.union([Lr.boolean(), H1]).default(!1).transform((t) => t === !0 ? H1.parse({}) : t),
  ethereum: Lr.union([Lr.boolean(), G1]).default(!1).transform((t) => t === !0 ? G1.parse({}) : t),
  solana: Lr.union([Lr.boolean(), V1]).default(!1).transform((t) => t === !0 ? V1.parse({}) : t)
}), L4 = Lr.object({
  appId: Lr.string().uuid().optional(),
  providers: Y1.optional().default({}),
  /** @deprecated Use `providers` instead. */
  networks: Y1.optional()
}).default({});
function j4(t) {
  return L4.parse(t);
}
const J1 = {
  code: -32e3,
  // The codes between -32000 to -32099 are custom server-errors according to https://www.jsonrpc.org/specification.
  message: "This domain should be whitelisted before loading Passkeys Wallet."
}, bn = "https://embedded.passkeys.foundation", lm = "https://my.passkeys.network", D4 = "wallet:ready", $4 = "wallet:locked", q4 = "wallet:navigate", z4 = "wallet:widget:config", K4 = "provider:request", qf = "provider:response", w0 = "rpc";
var Da = "isPasskeys", dp = "isPasskey", lp = "Passkeys", hp = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMWVtIiBoZWlnaHQ9IjFlbSIgdmlld0JveD0iMCAwIDMyIDMyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJ0cmFuc2l0aW9uLWFsbCBib3gtY29udGVudCBhbmltYXRlLW5vbmUiIHNpemU9IjE4IiBzdHlsZT0id2lkdGg6IDE4cHg7IGhlaWdodDogMThweDsiIGlkPSJzdmdnIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiByPSIxNiIgZmlsbD0iI0UzQUZCRSIvPjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xMzNfMjYxMikiPjxwYXRoIGQ9Ik0xMi4yMjU0IDUuNzA4OTRMOC45NzU0NiA3LjU4NTU1QzguODgwNjIgNy42NDA4NiA4Ljg0OTAxIDcuNzYxMzYgOC45MDIzNiA3Ljg1NjE4TDEyLjQwNzIgMTMuOTI2NUg1LjM5NzUyQzUuMjg4ODYgMTMuOTI2NSA1LjE5OTk1IDE0LjAxNTQgNS4xOTk5NSAxNC4xMjQxVjE3Ljg3NzNDNS4xOTk5NSAxNy45ODU5IDUuMjg4ODYgMTguMDc0OCA1LjM5NzUyIDE4LjA3NDhIMTIuNDA3MkwxMy42MDQ1IDE2LjAwMDdMMTQuODAxNyAxMy45MjY1TDE1Ljk5OSAxMS44NTI0TDEyLjQ5NjEgNS43ODIwM0MxMi40NDA4IDUuNjg3MjEgMTIuMzIwMyA1LjY1NTYgMTIuMjI1NCA1LjcwODk0WiIgZmlsbD0iIzE4MTgxOCIvPjxwYXRoIGQ9Ik0xOS41OTI4IDE4LjA3NTJIMTIuNDA3M0w4LjkwMjQ1IDI0LjE0NTVDOC44NDcxMyAyNC4yNDA0IDguODgwNzIgMjQuMzYwOSA4Ljk3NTU1IDI0LjQxNjJMMTIuMjI1NSAyNi4yOTI4QzEyLjMyMDQgMjYuMzQ4MSAxMi40NDA5IDI2LjMxNDUgMTIuNDk2MiAyNi4yMTk3TDE2LjAwMSAyMC4xNDkzTDE5LjUwNTkgMjYuMjE5N0MxOS41NjEyIDI2LjMxNDUgMTkuNjgxNyAyNi4zNDYxIDE5Ljc3NjUgMjYuMjkyOEwyMy4wMjY1IDI0LjQxNjJDMjMuMTIxMyAyNC4zNjA5IDIzLjE1MyAyNC4yNDA0IDIzLjA5OTYgMjQuMTQ1NUwxOS41OTQ4IDE4LjA3NTJIMTkuNTkyOFoiIGZpbGw9IiMxODE4MTgiLz48cGF0aCBkPSJNMTkuNTkyOCAxMy45MjY5TDIzLjA5NzYgNy44NTY1N0MyMy4xNTI5IDcuNzYxNzUgMjMuMTE5MyA3LjY0MTI1IDIzLjAyNDUgNy41ODU5NEwxOS43NzQ1IDUuNzA5MzNDMTkuNjc5NyA1LjY1NDAyIDE5LjU1OTIgNS42ODc2IDE5LjUwMzkgNS43ODI0MkwxNS45OTkgMTEuODUyOEwxNy4xOTYzIDEzLjkyNjlMMTguMzkzNSAxNi4wMDExTDE5LjU5MDggMTguMDc1MkgyNi42MDA1QzI2LjcwOTEgMTguMDc1MiAyNi43OTggMTcuOTg2MyAyNi43OTggMTcuODc3N1YxNC4xMjQ0QzI2Ljc5OCAxNC4wMTU4IDI2LjcwOTEgMTMuOTI2OSAyNi42MDA1IDEzLjkyNjlIMTkuNTkwOEgxOS41OTI4WiIgZmlsbD0iIzE4MTgxOCIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImNsaXAwXzEzM18yNjEyIj48cmVjdCB3aWR0aD0iMjEuNiIgaGVpZ2h0PSIyMC42MzI4IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS4xOTk5NSA1LjY4MzU5KSIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==", pp = (t, e, r) => {
  Object.defineProperty(t, e, { get() {
    return console.warn(`"${e}" is deprecated, please use "${r}" instead.`), !0;
  } });
}, yt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function sn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function _f(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(n) {
    var i = Object.getOwnPropertyDescriptor(t, n);
    Object.defineProperty(r, n, i.get ? i : {
      enumerable: !0,
      get: function() {
        return t[n];
      }
    });
  }), r;
}
const X1 = globalThis.crypto;
var hm = X1.randomUUID.bind(X1), W4 = {
  PARSE_ERROR: {
    code: -32700,
    message: "Parse error"
  },
  INVALID_REQUEST: {
    code: -32600,
    message: "Invalid request"
  },
  METHOD_NOT_FOUND: {
    code: -32601,
    message: "Method not found"
  },
  INVALID_PARAMS: {
    code: -32602,
    message: "Invalid parameters"
  },
  INTERNAL_ERROR: {
    code: -32603,
    message: "Internal error"
  }
};
const ra = W4, H4 = () => {
  let t = 0;
  return () => t++;
}, G4 = (t) => Number.isInteger(t) || typeof t == "string" || t === null;
class V4 {
  constructor({
    transport: e,
    requestTimeout: r = 2e4,
    generateId: n = H4,
    methods: i = /* @__PURE__ */ new Map(),
    parse: o = JSON.parse,
    stringify: a = JSON.stringify,
    getIsDevelopmentMode: s = () => !1
  } = {}) {
    if (!e)
      throw new Error("TRANSPORT_REQUIRED");
    if (this._transport = e, this._requestTimeout = r, this._pendingRequest = /* @__PURE__ */ new Map(), this._generateId = n(), this._processResponse = this._processResponse.bind(this), this._methods = i, this.parse = o, this._stringify = a, typeof s != "function")
      throw new Error("getIsDevelopmentMode must be a function");
    this._getIsDevelopmentMode = s, e.on("data", this._processResponse);
  }
  end() {
    this._transport.removeListener("data", this._processResponse);
  }
  exposeMethods(e) {
    e instanceof Map || (e = Object.entries(e).reduce(
      (n, [i, o]) => n.set(i, o),
      /* @__PURE__ */ new Map()
    ));
    const r = this._methods;
    return this._methods = e, r;
  }
  exposeFunction(e, r) {
    if (typeof e != "string")
      throw new Error("Function name must be a string");
    if (typeof r != "function")
      throw new Error("Invalid function implementation");
    this._methods.set(e, r);
  }
  async callMethod(e, r) {
    const n = this._generateId(), i = this._makeRequestObject({ method: e, params: r, id: n });
    return this._sendRequest({ request: i });
  }
  async callMethodWithRawResponse(e, r) {
    const n = this._generateId(), i = this._makeRequestObject({ method: e, params: r, id: n });
    return this._sendRequest({ request: i, getRawResponse: !0 });
  }
  async notify(e, r) {
    const n = this._makeRequestObject({ method: e, params: r });
    this._transport.write(this._stringify(n));
  }
  _sendRequest({ request: e, getRawResponse: r = !1 }) {
    const { id: n } = e, i = this._stringify(e);
    return new Promise((o, a) => {
      const s = setTimeout(() => {
        this._pendingRequest.has(n) && (this._pendingRequest.delete(n), a(new Error(`JSON-RPC: method call timeout calling ${e.method}`)));
      }, this._requestTimeout);
      this._pendingRequest.set(n, { resolve: o, reject: a, timeoutTimer: s, getRawResponse: r }), (async () => {
        try {
          await this._transport.write(i);
        } catch (f) {
          clearTimeout(s), this._pendingRequest.delete(n), a(f);
        }
      })();
    });
  }
  _processResponse(e) {
    let r;
    try {
      r = this.parse(e);
    } catch (a) {
      const s = typeof e == "string" ? JSON.parse(e).id : e.id;
      if (!G4(s))
        throw a;
      const { message: f } = a;
      this._sendError({ ...ra.INVALID_REQUEST, message: f }, s);
      return;
    }
    if (Object.hasOwnProperty.call(r, "method"))
      return this._processCallMethod(r);
    const i = Object.hasOwnProperty.call(r, "error"), o = this._pendingRequest.get(r.id);
    if (o)
      if (this._pendingRequest.delete(r.id), clearTimeout(o.timeoutTimer), o.getRawResponse)
        o.resolve(r);
      else if (i) {
        const a = this._makeErrorObject(r.error);
        o.reject(a);
      } else
        o.resolve(r.result);
  }
  async _processCallMethod(e) {
    const { method: r, params: n = [], id: i } = e, o = this._methods.get(r);
    if (!o)
      this._sendError({
        ...ra.METHOD_NOT_FOUND,
        methodName: r
      }, i);
    else if (typeof o != "function")
      this._sendError(ra.INTERNAL_ERROR, i);
    else {
      const a = Array.isArray(n) ? n : [n];
      try {
        const s = await Promise.resolve(
          o.apply(this._methods, a)
        );
        this._sendSuccess({
          result: s,
          id: i
        });
      } catch (s) {
        this._sendError(s, i);
      }
    }
  }
  // https://www.jsonrpc.org/specification#error_object
  _sendError(e, r) {
    let {
      message: n = ra.INTERNAL_ERROR.message,
      code: i = ra.INTERNAL_ERROR.code,
      cause: o,
      stack: a,
      ...s
    } = e || {};
    typeof e != "object" && (s = e), e === null && (s = null), e instanceof Error && this._getIsDevelopmentMode() && (s.cause = {
      message: n,
      stack: a,
      cause: o
    });
    const f = this._stringify({
      jsonrpc: "2.0",
      id: r,
      error: {
        code: i,
        message: n,
        data: s
      }
    });
    this._transport.write(f);
  }
  _sendSuccess({ result: e, id: r }) {
    if (typeof r > "u")
      return;
    const i = this._stringify({
      jsonrpc: "2.0",
      id: r,
      result: e
    });
    this._transport.write(i);
  }
  _makeRequestObject({ method: e, params: r, id: n }) {
    return {
      jsonrpc: "2.0",
      method: e,
      params: r,
      id: n
    };
  }
  _createRecursiveError(e) {
    if (typeof e != "object" || e === null)
      return null;
    let r = null;
    e.cause && (r = this._createRecursiveError(e.cause));
    const n = new Error(e.message, { cause: r });
    return n.stack = e.stack, n;
  }
  _makeErrorObject(e) {
    const r = e.code, n = ra[r], i = e.message || n && n.message, o = new Error(i);
    if (o.code = r, Object.hasOwnProperty.call(e, "data"))
      if (typeof e.data == "object" && e.data !== null) {
        const { name: a, cause: s, ...f } = e.data;
        o.name = a, s && (o.cause = this._createRecursiveError(s)), o.data = f;
      } else
        o.data = e.data;
    return o;
  }
}
var Y4 = V4;
const J4 = /* @__PURE__ */ sn(Y4), X4 = 5 * 60 * 1e3;
var pm = { exports: {} };
(function(t) {
  var e = Object.prototype.hasOwnProperty, r = "~";
  function n() {
  }
  Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
  function i(f, u, c) {
    this.fn = f, this.context = u, this.once = c || !1;
  }
  function o(f, u, c, d, l) {
    if (typeof c != "function")
      throw new TypeError("The listener must be a function");
    var h = new i(c, d || f, l), y = r ? r + u : u;
    return f._events[y] ? f._events[y].fn ? f._events[y] = [f._events[y], h] : f._events[y].push(h) : (f._events[y] = h, f._eventsCount++), f;
  }
  function a(f, u) {
    --f._eventsCount === 0 ? f._events = new n() : delete f._events[u];
  }
  function s() {
    this._events = new n(), this._eventsCount = 0;
  }
  s.prototype.eventNames = function() {
    var u = [], c, d;
    if (this._eventsCount === 0)
      return u;
    for (d in c = this._events)
      e.call(c, d) && u.push(r ? d.slice(1) : d);
    return Object.getOwnPropertySymbols ? u.concat(Object.getOwnPropertySymbols(c)) : u;
  }, s.prototype.listeners = function(u) {
    var c = r ? r + u : u, d = this._events[c];
    if (!d)
      return [];
    if (d.fn)
      return [d.fn];
    for (var l = 0, h = d.length, y = new Array(h); l < h; l++)
      y[l] = d[l].fn;
    return y;
  }, s.prototype.listenerCount = function(u) {
    var c = r ? r + u : u, d = this._events[c];
    return d ? d.fn ? 1 : d.length : 0;
  }, s.prototype.emit = function(u, c, d, l, h, y) {
    var b = r ? r + u : u;
    if (!this._events[b])
      return !1;
    var w = this._events[b], A = arguments.length, M, N;
    if (w.fn) {
      switch (w.once && this.removeListener(u, w.fn, void 0, !0), A) {
        case 1:
          return w.fn.call(w.context), !0;
        case 2:
          return w.fn.call(w.context, c), !0;
        case 3:
          return w.fn.call(w.context, c, d), !0;
        case 4:
          return w.fn.call(w.context, c, d, l), !0;
        case 5:
          return w.fn.call(w.context, c, d, l, h), !0;
        case 6:
          return w.fn.call(w.context, c, d, l, h, y), !0;
      }
      for (N = 1, M = new Array(A - 1); N < A; N++)
        M[N - 1] = arguments[N];
      w.fn.apply(w.context, M);
    } else {
      var G = w.length, z;
      for (N = 0; N < G; N++)
        switch (w[N].once && this.removeListener(u, w[N].fn, void 0, !0), A) {
          case 1:
            w[N].fn.call(w[N].context);
            break;
          case 2:
            w[N].fn.call(w[N].context, c);
            break;
          case 3:
            w[N].fn.call(w[N].context, c, d);
            break;
          case 4:
            w[N].fn.call(w[N].context, c, d, l);
            break;
          default:
            if (!M)
              for (z = 1, M = new Array(A - 1); z < A; z++)
                M[z - 1] = arguments[z];
            w[N].fn.apply(w[N].context, M);
        }
    }
    return !0;
  }, s.prototype.on = function(u, c, d) {
    return o(this, u, c, d, !1);
  }, s.prototype.once = function(u, c, d) {
    return o(this, u, c, d, !0);
  }, s.prototype.removeListener = function(u, c, d, l) {
    var h = r ? r + u : u;
    if (!this._events[h])
      return this;
    if (!c)
      return a(this, h), this;
    var y = this._events[h];
    if (y.fn)
      y.fn === c && (!l || y.once) && (!d || y.context === d) && a(this, h);
    else {
      for (var b = 0, w = [], A = y.length; b < A; b++)
        (y[b].fn !== c || l && !y[b].once || d && y[b].context !== d) && w.push(y[b]);
      w.length ? this._events[h] = w.length === 1 ? w[0] : w : a(this, h);
    }
    return this;
  }, s.prototype.removeAllListeners = function(u) {
    var c;
    return u ? (c = r ? r + u : u, this._events[c] && a(this, c)) : (this._events = new n(), this._eventsCount = 0), this;
  }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = r, s.EventEmitter = s, t.exports = s;
})(pm);
var Z4 = pm.exports;
const x0 = /* @__PURE__ */ sn(Z4), Q4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EventEmitter: x0,
  default: x0
}, Symbol.toStringTag, { value: "Module" }));
var Js;
class yp extends x0 {
  constructor({ transport: r }) {
    super();
    Ve(this, Js, null);
    Nt(this, Js, new J4({
      transport: r,
      generateId: () => hm,
      requestTimeout: X4
    }));
  }
  _callRpcMethod(r, n) {
    return Se(this, Js).callMethod(r, n);
  }
  defineFlag(r) {
    r in this || (this[r] = !0);
  }
  emitAndIgnoreErrors(r, ...n) {
    try {
      this.emit(r, ...n);
    } catch (i) {
      console.error(i);
    }
  }
}
Js = new WeakMap();
var hu, bm;
class ym {
  constructor(e) {
    Ve(this, hu);
    fn(this, hu, bm).call(this, e);
  }
}
hu = new WeakSet(), bm = function({ name: e, icon: r }) {
  if (!e)
    throw new Error('"name" parameter is required');
  if (!r)
    throw new Error('"icon" parameter is required');
};
var xo, _o, pu, yu;
class e8 extends yp {
  constructor({ transport: r, accountsObservable: n }) {
    super({ transport: r });
    Ve(this, xo, !1);
    Ve(this, _o, []);
    Ve(this, pu, () => {
      Se(this, xo) || (Nt(this, xo, !0), this.emitAndIgnoreErrors("connect"));
    });
    Ve(this, yu, (r) => {
      if (r.length === 0) {
        Nt(this, xo, !1), this.emit("disconnect"), this.emitAndIgnoreErrors("accountsChanged", r);
        return;
      }
      const n = (s) => s.slice().sort((f, u) => f.address.localeCompare(u.address)), i = n(Se(this, _o)), o = n(r);
      (i.length !== o.length || i.some((s, f) => s.address !== o[f].address)) && (Nt(this, _o, o), this.emitAndIgnoreErrors("accountsChanged", o));
    });
    this.on("connect", () => {
      const i = n.observe((o) => {
        Se(this, yu).call(this, o);
      });
      this.on("disconnect", i);
    }), this.on("connect", () => {
      Nt(this, xo, !0);
    });
  }
  get accounts() {
    return Se(this, _o);
  }
  call(r) {
    return this._callRpcMethod("bitcoin_call", [r]);
  }
  async isConnected() {
    return await this._callRpcMethod("bitcoin_isConnected", []);
  }
  async connect(r) {
    const n = await this._callRpcMethod("bitcoin_connect", [r]), i = n.map((o) => ({
      address: o.address,
      purpose: o.purpose
    }));
    return Nt(this, _o, i), Se(this, pu).call(this), {
      addresses: n
    };
  }
  sendBtcTransaction(r) {
    return this._callRpcMethod("bitcoin_sendBtcTransaction", [
      r
    ]);
  }
  signMessage(r) {
    return this._callRpcMethod("bitcoin_signMessage", [
      r
    ]);
  }
  signTransaction(r) {
    return this._callRpcMethod("bitcoin_signTransaction", [r]);
  }
}
xo = new WeakMap(), _o = new WeakMap(), pu = new WeakMap(), yu = new WeakMap();
const t8 = "sats-connect:";
var bu, Xs, Zs, Qs;
class r8 extends ym {
  constructor({ name: r, icon: n, provider: i }) {
    super({ name: r, icon: n });
    Ve(this, bu, "1.0.0");
    Ve(this, Xs, void 0);
    Ve(this, Zs, void 0);
    Ve(this, Qs, void 0);
    if (!i)
      throw new Error("Bitcoin Provider parameter is required!");
    Nt(this, Xs, r), Nt(this, Zs, n), Nt(this, Qs, i);
  }
  get version() {
    return Se(this, bu);
  }
  get name() {
    return Se(this, Xs);
  }
  get icon() {
    return Se(this, Zs);
  }
  get chains() {
    return [];
  }
  get features() {
    return {
      [t8]: {
        provider: Se(this, Qs)
      }
    };
  }
  get accounts() {
    return [];
  }
}
bu = new WeakMap(), Xs = new WeakMap(), Zs = new WeakMap(), Qs = new WeakMap();
var n8 = function(t, e, r, n, i) {
  if (n === "m")
    throw new TypeError("Private method is not writable");
  if (n === "a" && !i)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? i.call(t, r) : i ? i.value = r : e.set(t, r), r;
}, i8 = function(t, e, r, n) {
  if (r === "a" && !n)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !n : !e.has(t))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(t) : n ? n.value : e.get(t);
}, hc;
function gm(t) {
  const e = ({ register: r }) => r(t);
  try {
    window.dispatchEvent(new o8(e));
  } catch (r) {
    console.error(`wallet-standard:register-wallet event could not be dispatched
`, r);
  }
  try {
    window.addEventListener("wallet-standard:app-ready", ({ detail: r }) => e(r));
  } catch (r) {
    console.error(`wallet-standard:app-ready event listener could not be added
`, r);
  }
}
class o8 extends Event {
  constructor(e) {
    super("wallet-standard:register-wallet", {
      bubbles: !1,
      cancelable: !1,
      composed: !1
    }), hc.set(this, void 0), n8(this, hc, e, "f");
  }
  get detail() {
    return i8(this, hc, "f");
  }
  get type() {
    return "wallet-standard:register-wallet";
  }
  /** @deprecated */
  preventDefault() {
    throw new Error("preventDefault cannot be called");
  }
  /** @deprecated */
  stopImmediatePropagation() {
    throw new Error("stopImmediatePropagation cannot be called");
  }
  /** @deprecated */
  stopPropagation() {
    throw new Error("stopPropagation cannot be called");
  }
}
hc = /* @__PURE__ */ new WeakMap();
var a8 = ({ accountsObservable: t, transport: e, injectWindow: r = !1, walletStandard: n = !0 }) => {
  let i = new e8({ accountsObservable: t, transport: e });
  return i.defineFlag(Da), pp(i, dp, Da), n && gm(new r8({ name: lp, icon: hp, provider: i })), r && (window.BitcoinProvider = i), i;
}, pa = {}, Zi = {}, s8 = Fs;
Fs.default = Fs;
Fs.stable = wm;
Fs.stableStringify = wm;
var Tc = "[...]", vm = "[Circular]", Fo = [], go = [];
function mm() {
  return {
    depthLimit: Number.MAX_SAFE_INTEGER,
    edgesLimit: Number.MAX_SAFE_INTEGER
  };
}
function Fs(t, e, r, n) {
  typeof n > "u" && (n = mm()), _0(t, "", 0, [], void 0, 0, n);
  var i;
  try {
    go.length === 0 ? i = JSON.stringify(t, e, r) : i = JSON.stringify(t, xm(e), r);
  } catch {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; Fo.length !== 0; ) {
      var o = Fo.pop();
      o.length === 4 ? Object.defineProperty(o[0], o[1], o[3]) : o[0][o[1]] = o[2];
    }
  }
  return i;
}
function Ia(t, e, r, n) {
  var i = Object.getOwnPropertyDescriptor(n, r);
  i.get !== void 0 ? i.configurable ? (Object.defineProperty(n, r, { value: t }), Fo.push([n, r, e, i])) : go.push([e, r, t]) : (n[r] = t, Fo.push([n, r, e]));
}
function _0(t, e, r, n, i, o, a) {
  o += 1;
  var s;
  if (typeof t == "object" && t !== null) {
    for (s = 0; s < n.length; s++)
      if (n[s] === t) {
        Ia(vm, t, e, i);
        return;
      }
    if (typeof a.depthLimit < "u" && o > a.depthLimit) {
      Ia(Tc, t, e, i);
      return;
    }
    if (typeof a.edgesLimit < "u" && r + 1 > a.edgesLimit) {
      Ia(Tc, t, e, i);
      return;
    }
    if (n.push(t), Array.isArray(t))
      for (s = 0; s < t.length; s++)
        _0(t[s], s, s, n, t, o, a);
    else {
      var f = Object.keys(t);
      for (s = 0; s < f.length; s++) {
        var u = f[s];
        _0(t[u], u, s, n, t, o, a);
      }
    }
    n.pop();
  }
}
function f8(t, e) {
  return t < e ? -1 : t > e ? 1 : 0;
}
function wm(t, e, r, n) {
  typeof n > "u" && (n = mm());
  var i = E0(t, "", 0, [], void 0, 0, n) || t, o;
  try {
    go.length === 0 ? o = JSON.stringify(i, e, r) : o = JSON.stringify(i, xm(e), r);
  } catch {
    return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
  } finally {
    for (; Fo.length !== 0; ) {
      var a = Fo.pop();
      a.length === 4 ? Object.defineProperty(a[0], a[1], a[3]) : a[0][a[1]] = a[2];
    }
  }
  return o;
}
function E0(t, e, r, n, i, o, a) {
  o += 1;
  var s;
  if (typeof t == "object" && t !== null) {
    for (s = 0; s < n.length; s++)
      if (n[s] === t) {
        Ia(vm, t, e, i);
        return;
      }
    try {
      if (typeof t.toJSON == "function")
        return;
    } catch {
      return;
    }
    if (typeof a.depthLimit < "u" && o > a.depthLimit) {
      Ia(Tc, t, e, i);
      return;
    }
    if (typeof a.edgesLimit < "u" && r + 1 > a.edgesLimit) {
      Ia(Tc, t, e, i);
      return;
    }
    if (n.push(t), Array.isArray(t))
      for (s = 0; s < t.length; s++)
        E0(t[s], s, s, n, t, o, a);
    else {
      var f = {}, u = Object.keys(t).sort(f8);
      for (s = 0; s < u.length; s++) {
        var c = u[s];
        E0(t[c], c, s, n, t, o, a), f[c] = t[c];
      }
      if (typeof i < "u")
        Fo.push([i, e, t]), i[e] = f;
      else
        return f;
    }
    n.pop();
  }
}
function xm(t) {
  return t = typeof t < "u" ? t : function(e, r) {
    return r;
  }, function(e, r) {
    if (go.length > 0)
      for (var n = 0; n < go.length; n++) {
        var i = go[n];
        if (i[1] === e && i[0] === r) {
          r = i[2], go.splice(n, 1);
          break;
        }
      }
    return t.call(this, e, r);
  };
}
Object.defineProperty(Zi, "__esModule", { value: !0 });
Zi.EthereumProviderError = Zi.EthereumRpcError = void 0;
const c8 = s8;
class _m extends Error {
  constructor(e, r, n) {
    if (!Number.isInteger(e))
      throw new Error('"code" must be an integer.');
    if (!r || typeof r != "string")
      throw new Error('"message" must be a nonempty string.');
    super(r), this.code = e, n !== void 0 && (this.data = n);
  }
  /**
   * Returns a plain object with all public class properties.
   */
  serialize() {
    const e = {
      code: this.code,
      message: this.message
    };
    return this.data !== void 0 && (e.data = this.data), this.stack && (e.stack = this.stack), e;
  }
  /**
   * Return a string representation of the serialized error, omitting
   * any circular references.
   */
  toString() {
    return c8.default(this.serialize(), l8, 2);
  }
}
Zi.EthereumRpcError = _m;
class u8 extends _m {
  /**
   * Create an Ethereum Provider JSON-RPC error.
   * `code` must be an integer in the 1000 <= 4999 range.
   */
  constructor(e, r, n) {
    if (!d8(e))
      throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
    super(e, r, n);
  }
}
Zi.EthereumProviderError = u8;
function d8(t) {
  return Number.isInteger(t) && t >= 1e3 && t <= 4999;
}
function l8(t, e) {
  if (e !== "[Circular]")
    return e;
}
var bp = {}, Qi = {};
Object.defineProperty(Qi, "__esModule", { value: !0 });
Qi.errorValues = Qi.errorCodes = void 0;
Qi.errorCodes = {
  rpc: {
    invalidInput: -32e3,
    resourceNotFound: -32001,
    resourceUnavailable: -32002,
    transactionRejected: -32003,
    methodNotSupported: -32004,
    limitExceeded: -32005,
    parse: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internal: -32603
  },
  provider: {
    userRejectedRequest: 4001,
    unauthorized: 4100,
    unsupportedMethod: 4200,
    disconnected: 4900,
    chainDisconnected: 4901
  }
};
Qi.errorValues = {
  "-32700": {
    standard: "JSON RPC 2.0",
    message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
  },
  "-32600": {
    standard: "JSON RPC 2.0",
    message: "The JSON sent is not a valid Request object."
  },
  "-32601": {
    standard: "JSON RPC 2.0",
    message: "The method does not exist / is not available."
  },
  "-32602": {
    standard: "JSON RPC 2.0",
    message: "Invalid method parameter(s)."
  },
  "-32603": {
    standard: "JSON RPC 2.0",
    message: "Internal JSON-RPC error."
  },
  "-32000": {
    standard: "EIP-1474",
    message: "Invalid input."
  },
  "-32001": {
    standard: "EIP-1474",
    message: "Resource not found."
  },
  "-32002": {
    standard: "EIP-1474",
    message: "Resource unavailable."
  },
  "-32003": {
    standard: "EIP-1474",
    message: "Transaction rejected."
  },
  "-32004": {
    standard: "EIP-1474",
    message: "Method not supported."
  },
  "-32005": {
    standard: "EIP-1474",
    message: "Request limit exceeded."
  },
  4001: {
    standard: "EIP-1193",
    message: "User rejected the request."
  },
  4100: {
    standard: "EIP-1193",
    message: "The requested account and/or method has not been authorized by the user."
  },
  4200: {
    standard: "EIP-1193",
    message: "The requested method is not supported by this Ethereum provider."
  },
  4900: {
    standard: "EIP-1193",
    message: "The provider is disconnected from all chains."
  },
  4901: {
    standard: "EIP-1193",
    message: "The provider is disconnected from the specified chain."
  }
};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.serializeError = t.isValidCode = t.getMessageFromCode = t.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
  const e = Qi, r = Zi, n = e.errorCodes.rpc.internal, i = "Unspecified error message. This is a bug, please report it.", o = {
    code: n,
    message: a(n)
  };
  t.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
  function a(l, h = i) {
    if (Number.isInteger(l)) {
      const y = l.toString();
      if (d(e.errorValues, y))
        return e.errorValues[y].message;
      if (u(l))
        return t.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return h;
  }
  t.getMessageFromCode = a;
  function s(l) {
    if (!Number.isInteger(l))
      return !1;
    const h = l.toString();
    return !!(e.errorValues[h] || u(l));
  }
  t.isValidCode = s;
  function f(l, { fallbackError: h = o, shouldIncludeStack: y = !1 } = {}) {
    var b, w;
    if (!h || !Number.isInteger(h.code) || typeof h.message != "string")
      throw new Error("Must provide fallback error with integer number code and string message.");
    if (l instanceof r.EthereumRpcError)
      return l.serialize();
    const A = {};
    if (l && typeof l == "object" && !Array.isArray(l) && d(l, "code") && s(l.code)) {
      const N = l;
      A.code = N.code, N.message && typeof N.message == "string" ? (A.message = N.message, d(N, "data") && (A.data = N.data)) : (A.message = a(A.code), A.data = { originalError: c(l) });
    } else {
      A.code = h.code;
      const N = (b = l) === null || b === void 0 ? void 0 : b.message;
      A.message = N && typeof N == "string" ? N : h.message, A.data = { originalError: c(l) };
    }
    const M = (w = l) === null || w === void 0 ? void 0 : w.stack;
    return y && l && M && typeof M == "string" && (A.stack = M), A;
  }
  t.serializeError = f;
  function u(l) {
    return l >= -32099 && l <= -32e3;
  }
  function c(l) {
    return l && typeof l == "object" && !Array.isArray(l) ? Object.assign({}, l) : l;
  }
  function d(l, h) {
    return Object.prototype.hasOwnProperty.call(l, h);
  }
})(bp);
var ku = {};
Object.defineProperty(ku, "__esModule", { value: !0 });
ku.ethErrors = void 0;
const gp = Zi, Em = bp, Yr = Qi;
ku.ethErrors = {
  rpc: {
    /**
     * Get a JSON RPC 2.0 Parse (-32700) error.
     */
    parse: (t) => Cn(Yr.errorCodes.rpc.parse, t),
    /**
     * Get a JSON RPC 2.0 Invalid Request (-32600) error.
     */
    invalidRequest: (t) => Cn(Yr.errorCodes.rpc.invalidRequest, t),
    /**
     * Get a JSON RPC 2.0 Invalid Params (-32602) error.
     */
    invalidParams: (t) => Cn(Yr.errorCodes.rpc.invalidParams, t),
    /**
     * Get a JSON RPC 2.0 Method Not Found (-32601) error.
     */
    methodNotFound: (t) => Cn(Yr.errorCodes.rpc.methodNotFound, t),
    /**
     * Get a JSON RPC 2.0 Internal (-32603) error.
     */
    internal: (t) => Cn(Yr.errorCodes.rpc.internal, t),
    /**
     * Get a JSON RPC 2.0 Server error.
     * Permits integer error codes in the [ -32099 <= -32005 ] range.
     * Codes -32000 through -32004 are reserved by EIP-1474.
     */
    server: (t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        throw new Error("Ethereum RPC Server errors must provide single object argument.");
      const { code: e } = t;
      if (!Number.isInteger(e) || e > -32005 || e < -32099)
        throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
      return Cn(e, t);
    },
    /**
     * Get an Ethereum JSON RPC Invalid Input (-32000) error.
     */
    invalidInput: (t) => Cn(Yr.errorCodes.rpc.invalidInput, t),
    /**
     * Get an Ethereum JSON RPC Resource Not Found (-32001) error.
     */
    resourceNotFound: (t) => Cn(Yr.errorCodes.rpc.resourceNotFound, t),
    /**
     * Get an Ethereum JSON RPC Resource Unavailable (-32002) error.
     */
    resourceUnavailable: (t) => Cn(Yr.errorCodes.rpc.resourceUnavailable, t),
    /**
     * Get an Ethereum JSON RPC Transaction Rejected (-32003) error.
     */
    transactionRejected: (t) => Cn(Yr.errorCodes.rpc.transactionRejected, t),
    /**
     * Get an Ethereum JSON RPC Method Not Supported (-32004) error.
     */
    methodNotSupported: (t) => Cn(Yr.errorCodes.rpc.methodNotSupported, t),
    /**
     * Get an Ethereum JSON RPC Limit Exceeded (-32005) error.
     */
    limitExceeded: (t) => Cn(Yr.errorCodes.rpc.limitExceeded, t)
  },
  provider: {
    /**
     * Get an Ethereum Provider User Rejected Request (4001) error.
     */
    userRejectedRequest: (t) => ds(Yr.errorCodes.provider.userRejectedRequest, t),
    /**
     * Get an Ethereum Provider Unauthorized (4100) error.
     */
    unauthorized: (t) => ds(Yr.errorCodes.provider.unauthorized, t),
    /**
     * Get an Ethereum Provider Unsupported Method (4200) error.
     */
    unsupportedMethod: (t) => ds(Yr.errorCodes.provider.unsupportedMethod, t),
    /**
     * Get an Ethereum Provider Not Connected (4900) error.
     */
    disconnected: (t) => ds(Yr.errorCodes.provider.disconnected, t),
    /**
     * Get an Ethereum Provider Chain Not Connected (4901) error.
     */
    chainDisconnected: (t) => ds(Yr.errorCodes.provider.chainDisconnected, t),
    /**
     * Get a custom Ethereum Provider error.
     */
    custom: (t) => {
      if (!t || typeof t != "object" || Array.isArray(t))
        throw new Error("Ethereum Provider custom errors must provide single object argument.");
      const { code: e, message: r, data: n } = t;
      if (!r || typeof r != "string")
        throw new Error('"message" must be a nonempty string');
      return new gp.EthereumProviderError(e, r, n);
    }
  }
};
function Cn(t, e) {
  const [r, n] = Sm(e);
  return new gp.EthereumRpcError(t, r || Em.getMessageFromCode(t), n);
}
function ds(t, e) {
  const [r, n] = Sm(e);
  return new gp.EthereumProviderError(t, r || Em.getMessageFromCode(t), n);
}
function Sm(t) {
  if (t) {
    if (typeof t == "string")
      return [t];
    if (typeof t == "object" && !Array.isArray(t)) {
      const { message: e, data: r } = t;
      if (e && typeof e != "string")
        throw new Error("Must specify string message.");
      return [e || void 0, r];
    }
  }
  return [];
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getMessageFromCode = t.serializeError = t.EthereumProviderError = t.EthereumRpcError = t.ethErrors = t.errorCodes = void 0;
  const e = Zi;
  Object.defineProperty(t, "EthereumRpcError", { enumerable: !0, get: function() {
    return e.EthereumRpcError;
  } }), Object.defineProperty(t, "EthereumProviderError", { enumerable: !0, get: function() {
    return e.EthereumProviderError;
  } });
  const r = bp;
  Object.defineProperty(t, "serializeError", { enumerable: !0, get: function() {
    return r.serializeError;
  } }), Object.defineProperty(t, "getMessageFromCode", { enumerable: !0, get: function() {
    return r.getMessageFromCode;
  } });
  const n = ku;
  Object.defineProperty(t, "ethErrors", { enumerable: !0, get: function() {
    return n.ethErrors;
  } });
  const i = Qi;
  Object.defineProperty(t, "errorCodes", { enumerable: !0, get: function() {
    return i.errorCodes;
  } });
})(pa);
function h8(t, e) {
  const r = `${e}:ethereum:chainId`;
  async function n() {
    try {
      return await t.getItem(r);
    } catch {
      return null;
    }
  }
  async function i(a) {
    try {
      await t.setItem(r, a);
    } catch {
    }
  }
  async function o() {
    try {
      await t.removeItem(r);
    } catch {
    }
  }
  return { getChainId: n, setChainId: i, clearChainId: o };
}
const p8 = "0x1";
var Pa, Ri, ef, Eo, Na, So, Ti, Ao, tf, rf, gu, vu, mu, wu, xu, Io, _u, nf, Ua, of, Eu, af;
class y8 extends yp {
  constructor({ accountsObservable: r, transport: n, storage: i, storageKeyPrefix: o, supportedChainIds: a = [p8], getDefaultChainId: s = () => Promise.resolve(null) }) {
    super({ transport: n });
    Ve(this, Pa, void 0);
    Ve(this, Ri, void 0);
    Ve(this, ef, void 0);
    Ve(this, Eo, null);
    Ve(this, Na, !1);
    Ve(this, So, !1);
    Ve(this, Ti, null);
    Ve(this, Ao, []);
    Ve(this, tf, null);
    Ve(this, rf, () => {
      if (!this.isConnected())
        throw pa.ethErrors.provider.disconnected({
          message: "The Provider is disconnected from all chains."
        });
    });
    Ve(this, gu, (r) => {
      if (!Se(this, Ri).includes(r))
        throw pa.ethErrors.provider.custom({
          message: "The Provider does not support the requested chain.",
          code: 4902
        });
    });
    Ve(this, vu, async () => {
      const r = await Se(this, Pa).getChainId();
      if (r)
        return r;
      const n = await Se(this, ef).call(this);
      return n || Se(this, Ri)[0];
    });
    Ve(this, mu, async () => this._callRpcMethod("eth_accounts", []));
    Ve(this, wu, async () => {
      const r = await Se(this, vu).call(this);
      Se(this, _u).call(this, r), Se(this, nf).call(this, r);
      const n = await Se(this, mu).call(this);
      Nt(this, Na, !0), Nt(this, Eo, null), Se(this, Ua).call(this, n);
    });
    Ve(this, xu, async () => {
      Se(this, Eo) && await Se(this, Eo);
    });
    Ve(this, Io, (r) => r.toLowerCase());
    Ve(this, _u, (r) => {
      Se(this, So) || (Nt(this, So, !0), this.emitAndIgnoreErrors("connect", { chainId: r }));
    });
    Ve(this, nf, (r) => {
      !r || typeof r != "string" || !r.startsWith("0x") || r !== Se(this, Ti) && (Nt(this, Ti, r), Se(this, Na) && this.emitAndIgnoreErrors("chainChanged", r));
    });
    Ve(this, Ua, (r) => {
      Se(this, Ao)[0] !== r[0] && (Nt(this, Ao, r), Nt(this, tf, r[0] ?? null), Se(this, Na) && this.emitAndIgnoreErrors("accountsChanged", r));
    });
    Ve(this, of, async () => {
      const r = { eth_accounts: {} };
      await this._callRpcMethod("wallet_requestPermissions", [r]);
      const n = await this._callRpcMethod("eth_accounts", []);
      return Se(this, Ua).call(this, n), n;
    });
    Ve(this, Eu, async (r) => {
      const n = Se(this, Io).call(this, r.chainId);
      return Se(this, Ri).includes(n) || (await this._callRpcMethod("wallet_addEthereumChain", [r]), Se(this, Ri).push(n)), Se(this, af).call(this, n);
    });
    Ve(this, af, async (r) => {
      if (r !== Se(this, Ti)) {
        try {
          Se(this, gu).call(this, r);
        } catch (n) {
          if (!await this._callRpcMethod("wallet_switchEthereumChain", [{ chainId: r }]))
            throw n;
          Se(this, Ri).push(r);
        }
        Se(this, nf).call(this, r), await Se(this, Pa).setChainId(r);
      }
      return null;
    });
    Le(this, "request", async (r) => {
      await Se(this, xu).call(this), Se(this, rf).call(this);
      const { method: n, params: i = [] } = r;
      if (typeof n != "string" || n.length === 0)
        throw pa.ethErrors.rpc.invalidRequest({
          message: "'args.method' must be a non-empty string.",
          data: r
        });
      if (!Array.isArray(i) && (typeof i != "object" || i === null))
        throw pa.ethErrors.rpc.invalidRequest({
          message: "'args.params' must be an object or array if provided.",
          data: r
        });
      if (n === "eth_chainId")
        return Se(this, Ti);
      if (n === "eth_requestAccounts")
        return Se(this, of).call(this);
      if (n === "wallet_addEthereumChain")
        return Se(this, Eu).call(this, i[0]);
      if (n === "wallet_switchEthereumChain") {
        const { chainId: a } = i[0];
        return Se(this, af).call(this, Se(this, Io).call(this, a));
      }
      let o = i;
      return n === "personal_sign" && (o = i.slice(0, 2)), this._callRpcMethod(n, o);
    });
    /**
     * Experimental API
     */
    Le(this, "_metamask", {
      /**
       * Determines if MetaMask is unlocked by the user.
       *
       * @returns Promise resolving to true if MetaMask is currently unlocked.
       */
      // TODO: improve this, atm heurestic if we have accounts, assume unlocked
      isUnlocked: async () => Array.isArray(Se(this, Ao)) && Se(this, Ao).length > 0,
      /**
       * Make a batch RPC request.
       *
       * @param requests - The RPC requests to make.
       */
      requestBatch: async (r) => {
        if (!Array.isArray(r))
          throw pa.ethErrors.rpc.invalidRequest({
            message: "Batch requests must be made with an array of request objects.",
            data: r
          });
        const n = [];
        for (const i of r)
          n.push(await this.request(i));
        return n;
      }
    });
    Le(this, "enable", async () => (console.warn(`Exodus: "ethereum.enable()" is deprecated and may be removed in the future. Please use "ethereum.request({ method: 'eth_requestAccounts' })" instead.
For more information, see: https://eips.ethereum.org/EIPS/eip-1102.`), Se(this, rf).call(this), Se(this, of).call(this)));
    Le(this, "send", async (r, n) => {
      console.warn('Exodus: "ethereum.send()" is deprecated and may be removed in the future. Please use "ethereum.request()" instead.');
      const i = typeof r == "string", o = Array.isArray(n);
      if (i && (!n || o)) {
        const f = r, u = n;
        return new Promise((c, d) => this.request({ method: f, params: u }).then((l) => c({ id: "1", jsonrpc: "2.0", result: l })).catch((l) => d({ id: "1", jsonrpc: "2.0", error: l })));
      }
      const a = r, s = n;
      this.sendAsync(a, s);
    });
    Le(this, "sendAsync", (r, n) => {
      console.warn('Exodus: "ethereum.sendAsync()" is deprecated and may be removed in the future. Please use "ethereum.request()" instead.');
      const { id: i, jsonrpc: o, method: a, params: s } = r, f = n && typeof n == "function";
      this.request({ method: a, params: s }).then((u) => {
        f && n(null, { id: i, jsonrpc: o, result: u });
      }).catch((u) => {
        f && n(u, { id: i, jsonrpc: o, error: u });
      });
    });
    if (!o)
      throw new Error('"storageKeyPrefix" must be provided.');
    Nt(this, Pa, h8(i, o)), Nt(this, Ri, a.map(Se(this, Io)).sort()), Nt(this, ef, async () => s().then((f) => f ? Se(this, Io).call(this, f) : null)), this.on("connect", () => {
      const f = r.observe((u) => {
        Se(this, Ua).call(this, u);
      });
      this.on("disconnect", f);
    }), this.on("connect", () => {
      Nt(this, So, !0);
    }), Nt(this, Eo, Se(this, wu).call(this));
  }
  _callRpcMethod(r, n) {
    const i = Se(this, Ti);
    return super._callRpcMethod(`${i}_${r}`, n);
  }
  isConnected() {
    return Se(this, So);
  }
  /*
   * Legacy API.
   */
  get chainId() {
    return console.warn(`Exodus: "ethereum.chainId" is deprecated and may be removed in the future. Please use "ethereum.request({ method: 'eth_chainId' })" instead.`), Se(this, Ti);
  }
  get selectedAddress() {
    return console.warn(`Exodus: "ethereum.selectedAddress" is deprecated and may be removed in the future. Please use "ethereum.request({ method: 'eth_accounts' })" instead.`), Se(this, tf);
  }
}
Pa = new WeakMap(), Ri = new WeakMap(), ef = new WeakMap(), Eo = new WeakMap(), Na = new WeakMap(), So = new WeakMap(), Ti = new WeakMap(), Ao = new WeakMap(), tf = new WeakMap(), rf = new WeakMap(), gu = new WeakMap(), vu = new WeakMap(), mu = new WeakMap(), wu = new WeakMap(), xu = new WeakMap(), Io = new WeakMap(), _u = new WeakMap(), nf = new WeakMap(), Ua = new WeakMap(), of = new WeakMap(), Eu = new WeakMap(), af = new WeakMap();
const b8 = ({ uuid: t, name: e, icon: r, rdns: n, provider: i }) => {
  const o = {
    info: { name: e, icon: r, uuid: t || hm(), rdns: n },
    provider: i
  };
  return Object.freeze(o);
}, g8 = (t, { name: e, icon: r, uuid: n, rdns: i }) => {
  if (!e)
    throw new Error("'name' parameter is required.");
  if (!r)
    throw new Error("'icon' parameter is required.");
  if (!i)
    throw new Error("'rdns' parameter is required.");
  const o = b8({
    name: e,
    icon: r,
    rdns: i,
    uuid: n,
    provider: t
  }), a = () => {
    window.dispatchEvent(new CustomEvent("eip6963:announceProvider", {
      detail: o
    }));
  };
  window.addEventListener("eip6963:requestProvider", () => {
    a();
  }), a();
};
var v8 = "network.passkeys", m8 = "165de3e5-9b1b-4312-aaf8-364facf4b82d", w8 = ({ transport: t, accountsObservable: e, injectWindow: r = !1, eip6963: n = !0 }) => {
  let i = new y8({ transport: t, accountsObservable: e, storage: window.localStorage, storageKeyPrefix: "passkey" });
  return i.defineFlag(Da), pp(i, dp, Da), n && g8(i, { name: lp, icon: hp, rdns: v8, uuid: m8 }), r && (window.ethereum = i), i;
}, Am = {}, Cu = {};
Cu.byteLength = E8;
Cu.toByteArray = A8;
Cu.fromByteArray = M8;
var gi = [], jn = [], x8 = typeof Uint8Array < "u" ? Uint8Array : Array, Rd = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var na = 0, _8 = Rd.length; na < _8; ++na)
  gi[na] = Rd[na], jn[Rd.charCodeAt(na)] = na;
jn[45] = 62;
jn[95] = 63;
function Im(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  r === -1 && (r = e);
  var n = r === e ? 0 : 4 - r % 4;
  return [r, n];
}
function E8(t) {
  var e = Im(t), r = e[0], n = e[1];
  return (r + n) * 3 / 4 - n;
}
function S8(t, e, r) {
  return (e + r) * 3 / 4 - r;
}
function A8(t) {
  var e, r = Im(t), n = r[0], i = r[1], o = new x8(S8(t, n, i)), a = 0, s = i > 0 ? n - 4 : n, f;
  for (f = 0; f < s; f += 4)
    e = jn[t.charCodeAt(f)] << 18 | jn[t.charCodeAt(f + 1)] << 12 | jn[t.charCodeAt(f + 2)] << 6 | jn[t.charCodeAt(f + 3)], o[a++] = e >> 16 & 255, o[a++] = e >> 8 & 255, o[a++] = e & 255;
  return i === 2 && (e = jn[t.charCodeAt(f)] << 2 | jn[t.charCodeAt(f + 1)] >> 4, o[a++] = e & 255), i === 1 && (e = jn[t.charCodeAt(f)] << 10 | jn[t.charCodeAt(f + 1)] << 4 | jn[t.charCodeAt(f + 2)] >> 2, o[a++] = e >> 8 & 255, o[a++] = e & 255), o;
}
function I8(t) {
  return gi[t >> 18 & 63] + gi[t >> 12 & 63] + gi[t >> 6 & 63] + gi[t & 63];
}
function B8(t, e, r) {
  for (var n, i = [], o = e; o < r; o += 3)
    n = (t[o] << 16 & 16711680) + (t[o + 1] << 8 & 65280) + (t[o + 2] & 255), i.push(I8(n));
  return i.join("");
}
function M8(t) {
  for (var e, r = t.length, n = r % 3, i = [], o = 16383, a = 0, s = r - n; a < s; a += o)
    i.push(B8(t, a, a + o > s ? s : a + o));
  return n === 1 ? (e = t[r - 1], i.push(
    gi[e >> 2] + gi[e << 4 & 63] + "=="
  )) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i.push(
    gi[e >> 10] + gi[e >> 4 & 63] + gi[e << 2 & 63] + "="
  )), i.join("");
}
var vp = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
vp.read = function(t, e, r, n, i) {
  var o, a, s = i * 8 - n - 1, f = (1 << s) - 1, u = f >> 1, c = -7, d = r ? i - 1 : 0, l = r ? -1 : 1, h = t[e + d];
  for (d += l, o = h & (1 << -c) - 1, h >>= -c, c += s; c > 0; o = o * 256 + t[e + d], d += l, c -= 8)
    ;
  for (a = o & (1 << -c) - 1, o >>= -c, c += n; c > 0; a = a * 256 + t[e + d], d += l, c -= 8)
    ;
  if (o === 0)
    o = 1 - u;
  else {
    if (o === f)
      return a ? NaN : (h ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, n), o = o - u;
  }
  return (h ? -1 : 1) * a * Math.pow(2, o - n);
};
vp.write = function(t, e, r, n, i, o) {
  var a, s, f, u = o * 8 - i - 1, c = (1 << u) - 1, d = c >> 1, l = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = n ? 0 : o - 1, y = n ? 1 : -1, b = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e) / Math.LN2), e * (f = Math.pow(2, -a)) < 1 && (a--, f *= 2), a + d >= 1 ? e += l / f : e += l * Math.pow(2, 1 - d), e * f >= 2 && (a++, f /= 2), a + d >= c ? (s = 0, a = c) : a + d >= 1 ? (s = (e * f - 1) * Math.pow(2, i), a = a + d) : (s = e * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + h] = s & 255, h += y, s /= 256, i -= 8)
    ;
  for (a = a << i | s, u += i; u > 0; t[r + h] = a & 255, h += y, a /= 256, u -= 8)
    ;
  t[r + h - y] |= b * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(t) {
  const e = Cu, r = vp, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = c, t.SlowBuffer = z, t.INSPECT_MAX_BYTES = 50;
  const i = 2147483647;
  t.kMaxLength = i;
  const { Uint8Array: o, ArrayBuffer: a, SharedArrayBuffer: s } = globalThis;
  c.TYPED_ARRAY_SUPPORT = f(), !c.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function f() {
    try {
      const _ = new o(1), p = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(p, o.prototype), Object.setPrototypeOf(_, p), _.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(c.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (c.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(c.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (c.isBuffer(this))
        return this.byteOffset;
    }
  });
  function u(_) {
    if (_ > i)
      throw new RangeError('The value "' + _ + '" is invalid for option "size"');
    const p = new o(_);
    return Object.setPrototypeOf(p, c.prototype), p;
  }
  function c(_, p, m) {
    if (typeof _ == "number") {
      if (typeof p == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return y(_);
    }
    return d(_, p, m);
  }
  c.poolSize = 8192;
  function d(_, p, m) {
    if (typeof _ == "string")
      return b(_, p);
    if (a.isView(_))
      return A(_);
    if (_ == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof _
      );
    if (ue(_, a) || _ && ue(_.buffer, a) || typeof s < "u" && (ue(_, s) || _ && ue(_.buffer, s)))
      return M(_, p, m);
    if (typeof _ == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const O = _.valueOf && _.valueOf();
    if (O != null && O !== _)
      return c.from(O, p, m);
    const Q = N(_);
    if (Q)
      return Q;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof _[Symbol.toPrimitive] == "function")
      return c.from(_[Symbol.toPrimitive]("string"), p, m);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof _
    );
  }
  c.from = function(_, p, m) {
    return d(_, p, m);
  }, Object.setPrototypeOf(c.prototype, o.prototype), Object.setPrototypeOf(c, o);
  function l(_) {
    if (typeof _ != "number")
      throw new TypeError('"size" argument must be of type number');
    if (_ < 0)
      throw new RangeError('The value "' + _ + '" is invalid for option "size"');
  }
  function h(_, p, m) {
    return l(_), _ <= 0 ? u(_) : p !== void 0 ? typeof m == "string" ? u(_).fill(p, m) : u(_).fill(p) : u(_);
  }
  c.alloc = function(_, p, m) {
    return h(_, p, m);
  };
  function y(_) {
    return l(_), u(_ < 0 ? 0 : G(_) | 0);
  }
  c.allocUnsafe = function(_) {
    return y(_);
  }, c.allocUnsafeSlow = function(_) {
    return y(_);
  };
  function b(_, p) {
    if ((typeof p != "string" || p === "") && (p = "utf8"), !c.isEncoding(p))
      throw new TypeError("Unknown encoding: " + p);
    const m = J(_, p) | 0;
    let O = u(m);
    const Q = O.write(_, p);
    return Q !== m && (O = O.slice(0, Q)), O;
  }
  function w(_) {
    const p = _.length < 0 ? 0 : G(_.length) | 0, m = u(p);
    for (let O = 0; O < p; O += 1)
      m[O] = _[O] & 255;
    return m;
  }
  function A(_) {
    if (ue(_, o)) {
      const p = new o(_);
      return M(p.buffer, p.byteOffset, p.byteLength);
    }
    return w(_);
  }
  function M(_, p, m) {
    if (p < 0 || _.byteLength < p)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (_.byteLength < p + (m || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let O;
    return p === void 0 && m === void 0 ? O = new o(_) : m === void 0 ? O = new o(_, p) : O = new o(_, p, m), Object.setPrototypeOf(O, c.prototype), O;
  }
  function N(_) {
    if (c.isBuffer(_)) {
      const p = G(_.length) | 0, m = u(p);
      return m.length === 0 || _.copy(m, 0, 0, p), m;
    }
    if (_.length !== void 0)
      return typeof _.length != "number" || Ee(_.length) ? u(0) : w(_);
    if (_.type === "Buffer" && Array.isArray(_.data))
      return w(_.data);
  }
  function G(_) {
    if (_ >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return _ | 0;
  }
  function z(_) {
    return +_ != _ && (_ = 0), c.alloc(+_);
  }
  c.isBuffer = function(p) {
    return p != null && p._isBuffer === !0 && p !== c.prototype;
  }, c.compare = function(p, m) {
    if (ue(p, o) && (p = c.from(p, p.offset, p.byteLength)), ue(m, o) && (m = c.from(m, m.offset, m.byteLength)), !c.isBuffer(p) || !c.isBuffer(m))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (p === m)
      return 0;
    let O = p.length, Q = m.length;
    for (let ie = 0, ce = Math.min(O, Q); ie < ce; ++ie)
      if (p[ie] !== m[ie]) {
        O = p[ie], Q = m[ie];
        break;
      }
    return O < Q ? -1 : Q < O ? 1 : 0;
  }, c.isEncoding = function(p) {
    switch (String(p).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, c.concat = function(p, m) {
    if (!Array.isArray(p))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (p.length === 0)
      return c.alloc(0);
    let O;
    if (m === void 0)
      for (m = 0, O = 0; O < p.length; ++O)
        m += p[O].length;
    const Q = c.allocUnsafe(m);
    let ie = 0;
    for (O = 0; O < p.length; ++O) {
      let ce = p[O];
      if (ue(ce, o))
        ie + ce.length > Q.length ? (c.isBuffer(ce) || (ce = c.from(ce)), ce.copy(Q, ie)) : o.prototype.set.call(
          Q,
          ce,
          ie
        );
      else if (c.isBuffer(ce))
        ce.copy(Q, ie);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      ie += ce.length;
    }
    return Q;
  };
  function J(_, p) {
    if (c.isBuffer(_))
      return _.length;
    if (a.isView(_) || ue(_, a))
      return _.byteLength;
    if (typeof _ != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof _
      );
    const m = _.length, O = arguments.length > 2 && arguments[2] === !0;
    if (!O && m === 0)
      return 0;
    let Q = !1;
    for (; ; )
      switch (p) {
        case "ascii":
        case "latin1":
        case "binary":
          return m;
        case "utf8":
        case "utf-8":
          return at(_).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return m * 2;
        case "hex":
          return m >>> 1;
        case "base64":
          return it(_).length;
        default:
          if (Q)
            return O ? -1 : at(_).length;
          p = ("" + p).toLowerCase(), Q = !0;
      }
  }
  c.byteLength = J;
  function oe(_, p, m) {
    let O = !1;
    if ((p === void 0 || p < 0) && (p = 0), p > this.length || ((m === void 0 || m > this.length) && (m = this.length), m <= 0) || (m >>>= 0, p >>>= 0, m <= p))
      return "";
    for (_ || (_ = "utf8"); ; )
      switch (_) {
        case "hex":
          return g(this, p, m);
        case "utf8":
        case "utf-8":
          return L(this, p, m);
        case "ascii":
          return j(this, p, m);
        case "latin1":
        case "binary":
          return k(this, p, m);
        case "base64":
          return P(this, p, m);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return R(this, p, m);
        default:
          if (O)
            throw new TypeError("Unknown encoding: " + _);
          _ = (_ + "").toLowerCase(), O = !0;
      }
  }
  c.prototype._isBuffer = !0;
  function ee(_, p, m) {
    const O = _[p];
    _[p] = _[m], _[m] = O;
  }
  c.prototype.swap16 = function() {
    const p = this.length;
    if (p % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let m = 0; m < p; m += 2)
      ee(this, m, m + 1);
    return this;
  }, c.prototype.swap32 = function() {
    const p = this.length;
    if (p % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let m = 0; m < p; m += 4)
      ee(this, m, m + 3), ee(this, m + 1, m + 2);
    return this;
  }, c.prototype.swap64 = function() {
    const p = this.length;
    if (p % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let m = 0; m < p; m += 8)
      ee(this, m, m + 7), ee(this, m + 1, m + 6), ee(this, m + 2, m + 5), ee(this, m + 3, m + 4);
    return this;
  }, c.prototype.toString = function() {
    const p = this.length;
    return p === 0 ? "" : arguments.length === 0 ? L(this, 0, p) : oe.apply(this, arguments);
  }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function(p) {
    if (!c.isBuffer(p))
      throw new TypeError("Argument must be a Buffer");
    return this === p ? !0 : c.compare(this, p) === 0;
  }, c.prototype.inspect = function() {
    let p = "";
    const m = t.INSPECT_MAX_BYTES;
    return p = this.toString("hex", 0, m).replace(/(.{2})/g, "$1 ").trim(), this.length > m && (p += " ... "), "<Buffer " + p + ">";
  }, n && (c.prototype[n] = c.prototype.inspect), c.prototype.compare = function(p, m, O, Q, ie) {
    if (ue(p, o) && (p = c.from(p, p.offset, p.byteLength)), !c.isBuffer(p))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof p
      );
    if (m === void 0 && (m = 0), O === void 0 && (O = p ? p.length : 0), Q === void 0 && (Q = 0), ie === void 0 && (ie = this.length), m < 0 || O > p.length || Q < 0 || ie > this.length)
      throw new RangeError("out of range index");
    if (Q >= ie && m >= O)
      return 0;
    if (Q >= ie)
      return -1;
    if (m >= O)
      return 1;
    if (m >>>= 0, O >>>= 0, Q >>>= 0, ie >>>= 0, this === p)
      return 0;
    let ce = ie - Q, Ne = O - m;
    const Te = Math.min(ce, Ne), Je = this.slice(Q, ie), Dt = p.slice(m, O);
    for (let nt = 0; nt < Te; ++nt)
      if (Je[nt] !== Dt[nt]) {
        ce = Je[nt], Ne = Dt[nt];
        break;
      }
    return ce < Ne ? -1 : Ne < ce ? 1 : 0;
  };
  function ae(_, p, m, O, Q) {
    if (_.length === 0)
      return -1;
    if (typeof m == "string" ? (O = m, m = 0) : m > 2147483647 ? m = 2147483647 : m < -2147483648 && (m = -2147483648), m = +m, Ee(m) && (m = Q ? 0 : _.length - 1), m < 0 && (m = _.length + m), m >= _.length) {
      if (Q)
        return -1;
      m = _.length - 1;
    } else if (m < 0)
      if (Q)
        m = 0;
      else
        return -1;
    if (typeof p == "string" && (p = c.from(p, O)), c.isBuffer(p))
      return p.length === 0 ? -1 : ye(_, p, m, O, Q);
    if (typeof p == "number")
      return p = p & 255, typeof o.prototype.indexOf == "function" ? Q ? o.prototype.indexOf.call(_, p, m) : o.prototype.lastIndexOf.call(_, p, m) : ye(_, [p], m, O, Q);
    throw new TypeError("val must be string, number or Buffer");
  }
  function ye(_, p, m, O, Q) {
    let ie = 1, ce = _.length, Ne = p.length;
    if (O !== void 0 && (O = String(O).toLowerCase(), O === "ucs2" || O === "ucs-2" || O === "utf16le" || O === "utf-16le")) {
      if (_.length < 2 || p.length < 2)
        return -1;
      ie = 2, ce /= 2, Ne /= 2, m /= 2;
    }
    function Te(Dt, nt) {
      return ie === 1 ? Dt[nt] : Dt.readUInt16BE(nt * ie);
    }
    let Je;
    if (Q) {
      let Dt = -1;
      for (Je = m; Je < ce; Je++)
        if (Te(_, Je) === Te(p, Dt === -1 ? 0 : Je - Dt)) {
          if (Dt === -1 && (Dt = Je), Je - Dt + 1 === Ne)
            return Dt * ie;
        } else
          Dt !== -1 && (Je -= Je - Dt), Dt = -1;
    } else
      for (m + Ne > ce && (m = ce - Ne), Je = m; Je >= 0; Je--) {
        let Dt = !0;
        for (let nt = 0; nt < Ne; nt++)
          if (Te(_, Je + nt) !== Te(p, nt)) {
            Dt = !1;
            break;
          }
        if (Dt)
          return Je;
      }
    return -1;
  }
  c.prototype.includes = function(p, m, O) {
    return this.indexOf(p, m, O) !== -1;
  }, c.prototype.indexOf = function(p, m, O) {
    return ae(this, p, m, O, !0);
  }, c.prototype.lastIndexOf = function(p, m, O) {
    return ae(this, p, m, O, !1);
  };
  function pe(_, p, m, O) {
    m = Number(m) || 0;
    const Q = _.length - m;
    O ? (O = Number(O), O > Q && (O = Q)) : O = Q;
    const ie = p.length;
    O > ie / 2 && (O = ie / 2);
    let ce;
    for (ce = 0; ce < O; ++ce) {
      const Ne = parseInt(p.substr(ce * 2, 2), 16);
      if (Ee(Ne))
        return ce;
      _[m + ce] = Ne;
    }
    return ce;
  }
  function te(_, p, m, O) {
    return se(at(p, _.length - m), _, m, O);
  }
  function F(_, p, m, O) {
    return se(rt(p), _, m, O);
  }
  function v(_, p, m, O) {
    return se(it(p), _, m, O);
  }
  function B(_, p, m, O) {
    return se(It(p, _.length - m), _, m, O);
  }
  c.prototype.write = function(p, m, O, Q) {
    if (m === void 0)
      Q = "utf8", O = this.length, m = 0;
    else if (O === void 0 && typeof m == "string")
      Q = m, O = this.length, m = 0;
    else if (isFinite(m))
      m = m >>> 0, isFinite(O) ? (O = O >>> 0, Q === void 0 && (Q = "utf8")) : (Q = O, O = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const ie = this.length - m;
    if ((O === void 0 || O > ie) && (O = ie), p.length > 0 && (O < 0 || m < 0) || m > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    Q || (Q = "utf8");
    let ce = !1;
    for (; ; )
      switch (Q) {
        case "hex":
          return pe(this, p, m, O);
        case "utf8":
        case "utf-8":
          return te(this, p, m, O);
        case "ascii":
        case "latin1":
        case "binary":
          return F(this, p, m, O);
        case "base64":
          return v(this, p, m, O);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return B(this, p, m, O);
        default:
          if (ce)
            throw new TypeError("Unknown encoding: " + Q);
          Q = ("" + Q).toLowerCase(), ce = !0;
      }
  }, c.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function P(_, p, m) {
    return p === 0 && m === _.length ? e.fromByteArray(_) : e.fromByteArray(_.slice(p, m));
  }
  function L(_, p, m) {
    m = Math.min(_.length, m);
    const O = [];
    let Q = p;
    for (; Q < m; ) {
      const ie = _[Q];
      let ce = null, Ne = ie > 239 ? 4 : ie > 223 ? 3 : ie > 191 ? 2 : 1;
      if (Q + Ne <= m) {
        let Te, Je, Dt, nt;
        switch (Ne) {
          case 1:
            ie < 128 && (ce = ie);
            break;
          case 2:
            Te = _[Q + 1], (Te & 192) === 128 && (nt = (ie & 31) << 6 | Te & 63, nt > 127 && (ce = nt));
            break;
          case 3:
            Te = _[Q + 1], Je = _[Q + 2], (Te & 192) === 128 && (Je & 192) === 128 && (nt = (ie & 15) << 12 | (Te & 63) << 6 | Je & 63, nt > 2047 && (nt < 55296 || nt > 57343) && (ce = nt));
            break;
          case 4:
            Te = _[Q + 1], Je = _[Q + 2], Dt = _[Q + 3], (Te & 192) === 128 && (Je & 192) === 128 && (Dt & 192) === 128 && (nt = (ie & 15) << 18 | (Te & 63) << 12 | (Je & 63) << 6 | Dt & 63, nt > 65535 && nt < 1114112 && (ce = nt));
        }
      }
      ce === null ? (ce = 65533, Ne = 1) : ce > 65535 && (ce -= 65536, O.push(ce >>> 10 & 1023 | 55296), ce = 56320 | ce & 1023), O.push(ce), Q += Ne;
    }
    return C(O);
  }
  const x = 4096;
  function C(_) {
    const p = _.length;
    if (p <= x)
      return String.fromCharCode.apply(String, _);
    let m = "", O = 0;
    for (; O < p; )
      m += String.fromCharCode.apply(
        String,
        _.slice(O, O += x)
      );
    return m;
  }
  function j(_, p, m) {
    let O = "";
    m = Math.min(_.length, m);
    for (let Q = p; Q < m; ++Q)
      O += String.fromCharCode(_[Q] & 127);
    return O;
  }
  function k(_, p, m) {
    let O = "";
    m = Math.min(_.length, m);
    for (let Q = p; Q < m; ++Q)
      O += String.fromCharCode(_[Q]);
    return O;
  }
  function g(_, p, m) {
    const O = _.length;
    (!p || p < 0) && (p = 0), (!m || m < 0 || m > O) && (m = O);
    let Q = "";
    for (let ie = p; ie < m; ++ie)
      Q += U[_[ie]];
    return Q;
  }
  function R(_, p, m) {
    const O = _.slice(p, m);
    let Q = "";
    for (let ie = 0; ie < O.length - 1; ie += 2)
      Q += String.fromCharCode(O[ie] + O[ie + 1] * 256);
    return Q;
  }
  c.prototype.slice = function(p, m) {
    const O = this.length;
    p = ~~p, m = m === void 0 ? O : ~~m, p < 0 ? (p += O, p < 0 && (p = 0)) : p > O && (p = O), m < 0 ? (m += O, m < 0 && (m = 0)) : m > O && (m = O), m < p && (m = p);
    const Q = this.subarray(p, m);
    return Object.setPrototypeOf(Q, c.prototype), Q;
  };
  function X(_, p, m) {
    if (_ % 1 !== 0 || _ < 0)
      throw new RangeError("offset is not uint");
    if (_ + p > m)
      throw new RangeError("Trying to access beyond buffer length");
  }
  c.prototype.readUintLE = c.prototype.readUIntLE = function(p, m, O) {
    p = p >>> 0, m = m >>> 0, O || X(p, m, this.length);
    let Q = this[p], ie = 1, ce = 0;
    for (; ++ce < m && (ie *= 256); )
      Q += this[p + ce] * ie;
    return Q;
  }, c.prototype.readUintBE = c.prototype.readUIntBE = function(p, m, O) {
    p = p >>> 0, m = m >>> 0, O || X(p, m, this.length);
    let Q = this[p + --m], ie = 1;
    for (; m > 0 && (ie *= 256); )
      Q += this[p + --m] * ie;
    return Q;
  }, c.prototype.readUint8 = c.prototype.readUInt8 = function(p, m) {
    return p = p >>> 0, m || X(p, 1, this.length), this[p];
  }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function(p, m) {
    return p = p >>> 0, m || X(p, 2, this.length), this[p] | this[p + 1] << 8;
  }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function(p, m) {
    return p = p >>> 0, m || X(p, 2, this.length), this[p] << 8 | this[p + 1];
  }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function(p, m) {
    return p = p >>> 0, m || X(p, 4, this.length), (this[p] | this[p + 1] << 8 | this[p + 2] << 16) + this[p + 3] * 16777216;
  }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function(p, m) {
    return p = p >>> 0, m || X(p, 4, this.length), this[p] * 16777216 + (this[p + 1] << 16 | this[p + 2] << 8 | this[p + 3]);
  }, c.prototype.readBigUInt64LE = S(function(p) {
    p = p >>> 0, je(p, "offset");
    const m = this[p], O = this[p + 7];
    (m === void 0 || O === void 0) && Ue(p, this.length - 8);
    const Q = m + this[++p] * 2 ** 8 + this[++p] * 2 ** 16 + this[++p] * 2 ** 24, ie = this[++p] + this[++p] * 2 ** 8 + this[++p] * 2 ** 16 + O * 2 ** 24;
    return BigInt(Q) + (BigInt(ie) << BigInt(32));
  }), c.prototype.readBigUInt64BE = S(function(p) {
    p = p >>> 0, je(p, "offset");
    const m = this[p], O = this[p + 7];
    (m === void 0 || O === void 0) && Ue(p, this.length - 8);
    const Q = m * 2 ** 24 + this[++p] * 2 ** 16 + this[++p] * 2 ** 8 + this[++p], ie = this[++p] * 2 ** 24 + this[++p] * 2 ** 16 + this[++p] * 2 ** 8 + O;
    return (BigInt(Q) << BigInt(32)) + BigInt(ie);
  }), c.prototype.readIntLE = function(p, m, O) {
    p = p >>> 0, m = m >>> 0, O || X(p, m, this.length);
    let Q = this[p], ie = 1, ce = 0;
    for (; ++ce < m && (ie *= 256); )
      Q += this[p + ce] * ie;
    return ie *= 128, Q >= ie && (Q -= Math.pow(2, 8 * m)), Q;
  }, c.prototype.readIntBE = function(p, m, O) {
    p = p >>> 0, m = m >>> 0, O || X(p, m, this.length);
    let Q = m, ie = 1, ce = this[p + --Q];
    for (; Q > 0 && (ie *= 256); )
      ce += this[p + --Q] * ie;
    return ie *= 128, ce >= ie && (ce -= Math.pow(2, 8 * m)), ce;
  }, c.prototype.readInt8 = function(p, m) {
    return p = p >>> 0, m || X(p, 1, this.length), this[p] & 128 ? (255 - this[p] + 1) * -1 : this[p];
  }, c.prototype.readInt16LE = function(p, m) {
    p = p >>> 0, m || X(p, 2, this.length);
    const O = this[p] | this[p + 1] << 8;
    return O & 32768 ? O | 4294901760 : O;
  }, c.prototype.readInt16BE = function(p, m) {
    p = p >>> 0, m || X(p, 2, this.length);
    const O = this[p + 1] | this[p] << 8;
    return O & 32768 ? O | 4294901760 : O;
  }, c.prototype.readInt32LE = function(p, m) {
    return p = p >>> 0, m || X(p, 4, this.length), this[p] | this[p + 1] << 8 | this[p + 2] << 16 | this[p + 3] << 24;
  }, c.prototype.readInt32BE = function(p, m) {
    return p = p >>> 0, m || X(p, 4, this.length), this[p] << 24 | this[p + 1] << 16 | this[p + 2] << 8 | this[p + 3];
  }, c.prototype.readBigInt64LE = S(function(p) {
    p = p >>> 0, je(p, "offset");
    const m = this[p], O = this[p + 7];
    (m === void 0 || O === void 0) && Ue(p, this.length - 8);
    const Q = this[p + 4] + this[p + 5] * 2 ** 8 + this[p + 6] * 2 ** 16 + (O << 24);
    return (BigInt(Q) << BigInt(32)) + BigInt(m + this[++p] * 2 ** 8 + this[++p] * 2 ** 16 + this[++p] * 2 ** 24);
  }), c.prototype.readBigInt64BE = S(function(p) {
    p = p >>> 0, je(p, "offset");
    const m = this[p], O = this[p + 7];
    (m === void 0 || O === void 0) && Ue(p, this.length - 8);
    const Q = (m << 24) + // Overflow
    this[++p] * 2 ** 16 + this[++p] * 2 ** 8 + this[++p];
    return (BigInt(Q) << BigInt(32)) + BigInt(this[++p] * 2 ** 24 + this[++p] * 2 ** 16 + this[++p] * 2 ** 8 + O);
  }), c.prototype.readFloatLE = function(p, m) {
    return p = p >>> 0, m || X(p, 4, this.length), r.read(this, p, !0, 23, 4);
  }, c.prototype.readFloatBE = function(p, m) {
    return p = p >>> 0, m || X(p, 4, this.length), r.read(this, p, !1, 23, 4);
  }, c.prototype.readDoubleLE = function(p, m) {
    return p = p >>> 0, m || X(p, 8, this.length), r.read(this, p, !0, 52, 8);
  }, c.prototype.readDoubleBE = function(p, m) {
    return p = p >>> 0, m || X(p, 8, this.length), r.read(this, p, !1, 52, 8);
  };
  function re(_, p, m, O, Q, ie) {
    if (!c.isBuffer(_))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (p > Q || p < ie)
      throw new RangeError('"value" argument is out of bounds');
    if (m + O > _.length)
      throw new RangeError("Index out of range");
  }
  c.prototype.writeUintLE = c.prototype.writeUIntLE = function(p, m, O, Q) {
    if (p = +p, m = m >>> 0, O = O >>> 0, !Q) {
      const Ne = Math.pow(2, 8 * O) - 1;
      re(this, p, m, O, Ne, 0);
    }
    let ie = 1, ce = 0;
    for (this[m] = p & 255; ++ce < O && (ie *= 256); )
      this[m + ce] = p / ie & 255;
    return m + O;
  }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function(p, m, O, Q) {
    if (p = +p, m = m >>> 0, O = O >>> 0, !Q) {
      const Ne = Math.pow(2, 8 * O) - 1;
      re(this, p, m, O, Ne, 0);
    }
    let ie = O - 1, ce = 1;
    for (this[m + ie] = p & 255; --ie >= 0 && (ce *= 256); )
      this[m + ie] = p / ce & 255;
    return m + O;
  }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function(p, m, O) {
    return p = +p, m = m >>> 0, O || re(this, p, m, 1, 255, 0), this[m] = p & 255, m + 1;
  }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function(p, m, O) {
    return p = +p, m = m >>> 0, O || re(this, p, m, 2, 65535, 0), this[m] = p & 255, this[m + 1] = p >>> 8, m + 2;
  }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function(p, m, O) {
    return p = +p, m = m >>> 0, O || re(this, p, m, 2, 65535, 0), this[m] = p >>> 8, this[m + 1] = p & 255, m + 2;
  }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function(p, m, O) {
    return p = +p, m = m >>> 0, O || re(this, p, m, 4, 4294967295, 0), this[m + 3] = p >>> 24, this[m + 2] = p >>> 16, this[m + 1] = p >>> 8, this[m] = p & 255, m + 4;
  }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function(p, m, O) {
    return p = +p, m = m >>> 0, O || re(this, p, m, 4, 4294967295, 0), this[m] = p >>> 24, this[m + 1] = p >>> 16, this[m + 2] = p >>> 8, this[m + 3] = p & 255, m + 4;
  };
  function V(_, p, m, O, Q) {
    Ce(p, O, Q, _, m, 7);
    let ie = Number(p & BigInt(4294967295));
    _[m++] = ie, ie = ie >> 8, _[m++] = ie, ie = ie >> 8, _[m++] = ie, ie = ie >> 8, _[m++] = ie;
    let ce = Number(p >> BigInt(32) & BigInt(4294967295));
    return _[m++] = ce, ce = ce >> 8, _[m++] = ce, ce = ce >> 8, _[m++] = ce, ce = ce >> 8, _[m++] = ce, m;
  }
  function $(_, p, m, O, Q) {
    Ce(p, O, Q, _, m, 7);
    let ie = Number(p & BigInt(4294967295));
    _[m + 7] = ie, ie = ie >> 8, _[m + 6] = ie, ie = ie >> 8, _[m + 5] = ie, ie = ie >> 8, _[m + 4] = ie;
    let ce = Number(p >> BigInt(32) & BigInt(4294967295));
    return _[m + 3] = ce, ce = ce >> 8, _[m + 2] = ce, ce = ce >> 8, _[m + 1] = ce, ce = ce >> 8, _[m] = ce, m + 8;
  }
  c.prototype.writeBigUInt64LE = S(function(p, m = 0) {
    return V(this, p, m, BigInt(0), BigInt("0xffffffffffffffff"));
  }), c.prototype.writeBigUInt64BE = S(function(p, m = 0) {
    return $(this, p, m, BigInt(0), BigInt("0xffffffffffffffff"));
  }), c.prototype.writeIntLE = function(p, m, O, Q) {
    if (p = +p, m = m >>> 0, !Q) {
      const Te = Math.pow(2, 8 * O - 1);
      re(this, p, m, O, Te - 1, -Te);
    }
    let ie = 0, ce = 1, Ne = 0;
    for (this[m] = p & 255; ++ie < O && (ce *= 256); )
      p < 0 && Ne === 0 && this[m + ie - 1] !== 0 && (Ne = 1), this[m + ie] = (p / ce >> 0) - Ne & 255;
    return m + O;
  }, c.prototype.writeIntBE = function(p, m, O, Q) {
    if (p = +p, m = m >>> 0, !Q) {
      const Te = Math.pow(2, 8 * O - 1);
      re(this, p, m, O, Te - 1, -Te);
    }
    let ie = O - 1, ce = 1, Ne = 0;
    for (this[m + ie] = p & 255; --ie >= 0 && (ce *= 256); )
      p < 0 && Ne === 0 && this[m + ie + 1] !== 0 && (Ne = 1), this[m + ie] = (p / ce >> 0) - Ne & 255;
    return m + O;
  }, c.prototype.writeInt8 = function(p, m, O) {
    return p = +p, m = m >>> 0, O || re(this, p, m, 1, 127, -128), p < 0 && (p = 255 + p + 1), this[m] = p & 255, m + 1;
  }, c.prototype.writeInt16LE = function(p, m, O) {
    return p = +p, m = m >>> 0, O || re(this, p, m, 2, 32767, -32768), this[m] = p & 255, this[m + 1] = p >>> 8, m + 2;
  }, c.prototype.writeInt16BE = function(p, m, O) {
    return p = +p, m = m >>> 0, O || re(this, p, m, 2, 32767, -32768), this[m] = p >>> 8, this[m + 1] = p & 255, m + 2;
  }, c.prototype.writeInt32LE = function(p, m, O) {
    return p = +p, m = m >>> 0, O || re(this, p, m, 4, 2147483647, -2147483648), this[m] = p & 255, this[m + 1] = p >>> 8, this[m + 2] = p >>> 16, this[m + 3] = p >>> 24, m + 4;
  }, c.prototype.writeInt32BE = function(p, m, O) {
    return p = +p, m = m >>> 0, O || re(this, p, m, 4, 2147483647, -2147483648), p < 0 && (p = 4294967295 + p + 1), this[m] = p >>> 24, this[m + 1] = p >>> 16, this[m + 2] = p >>> 8, this[m + 3] = p & 255, m + 4;
  }, c.prototype.writeBigInt64LE = S(function(p, m = 0) {
    return V(this, p, m, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), c.prototype.writeBigInt64BE = S(function(p, m = 0) {
    return $(this, p, m, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function W(_, p, m, O, Q, ie) {
    if (m + O > _.length)
      throw new RangeError("Index out of range");
    if (m < 0)
      throw new RangeError("Index out of range");
  }
  function Z(_, p, m, O, Q) {
    return p = +p, m = m >>> 0, Q || W(_, p, m, 4), r.write(_, p, m, O, 23, 4), m + 4;
  }
  c.prototype.writeFloatLE = function(p, m, O) {
    return Z(this, p, m, !0, O);
  }, c.prototype.writeFloatBE = function(p, m, O) {
    return Z(this, p, m, !1, O);
  };
  function fe(_, p, m, O, Q) {
    return p = +p, m = m >>> 0, Q || W(_, p, m, 8), r.write(_, p, m, O, 52, 8), m + 8;
  }
  c.prototype.writeDoubleLE = function(p, m, O) {
    return fe(this, p, m, !0, O);
  }, c.prototype.writeDoubleBE = function(p, m, O) {
    return fe(this, p, m, !1, O);
  }, c.prototype.copy = function(p, m, O, Q) {
    if (!c.isBuffer(p))
      throw new TypeError("argument should be a Buffer");
    if (O || (O = 0), !Q && Q !== 0 && (Q = this.length), m >= p.length && (m = p.length), m || (m = 0), Q > 0 && Q < O && (Q = O), Q === O || p.length === 0 || this.length === 0)
      return 0;
    if (m < 0)
      throw new RangeError("targetStart out of bounds");
    if (O < 0 || O >= this.length)
      throw new RangeError("Index out of range");
    if (Q < 0)
      throw new RangeError("sourceEnd out of bounds");
    Q > this.length && (Q = this.length), p.length - m < Q - O && (Q = p.length - m + O);
    const ie = Q - O;
    return this === p && typeof o.prototype.copyWithin == "function" ? this.copyWithin(m, O, Q) : o.prototype.set.call(
      p,
      this.subarray(O, Q),
      m
    ), ie;
  }, c.prototype.fill = function(p, m, O, Q) {
    if (typeof p == "string") {
      if (typeof m == "string" ? (Q = m, m = 0, O = this.length) : typeof O == "string" && (Q = O, O = this.length), Q !== void 0 && typeof Q != "string")
        throw new TypeError("encoding must be a string");
      if (typeof Q == "string" && !c.isEncoding(Q))
        throw new TypeError("Unknown encoding: " + Q);
      if (p.length === 1) {
        const ce = p.charCodeAt(0);
        (Q === "utf8" && ce < 128 || Q === "latin1") && (p = ce);
      }
    } else
      typeof p == "number" ? p = p & 255 : typeof p == "boolean" && (p = Number(p));
    if (m < 0 || this.length < m || this.length < O)
      throw new RangeError("Out of range index");
    if (O <= m)
      return this;
    m = m >>> 0, O = O === void 0 ? this.length : O >>> 0, p || (p = 0);
    let ie;
    if (typeof p == "number")
      for (ie = m; ie < O; ++ie)
        this[ie] = p;
    else {
      const ce = c.isBuffer(p) ? p : c.from(p, Q), Ne = ce.length;
      if (Ne === 0)
        throw new TypeError('The value "' + p + '" is invalid for argument "value"');
      for (ie = 0; ie < O - m; ++ie)
        this[ie + m] = ce[ie % Ne];
    }
    return this;
  };
  const D = {};
  function K(_, p, m) {
    D[_] = class extends m {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: p.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${_}]`, this.stack, delete this.name;
      }
      get code() {
        return _;
      }
      set code(Q) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: Q,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${_}]: ${this.message}`;
      }
    };
  }
  K(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(_) {
      return _ ? `${_} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), K(
    "ERR_INVALID_ARG_TYPE",
    function(_, p) {
      return `The "${_}" argument must be of type number. Received type ${typeof p}`;
    },
    TypeError
  ), K(
    "ERR_OUT_OF_RANGE",
    function(_, p, m) {
      let O = `The value of "${_}" is out of range.`, Q = m;
      return Number.isInteger(m) && Math.abs(m) > 2 ** 32 ? Q = he(String(m)) : typeof m == "bigint" && (Q = String(m), (m > BigInt(2) ** BigInt(32) || m < -(BigInt(2) ** BigInt(32))) && (Q = he(Q)), Q += "n"), O += ` It must be ${p}. Received ${Q}`, O;
    },
    RangeError
  );
  function he(_) {
    let p = "", m = _.length;
    const O = _[0] === "-" ? 1 : 0;
    for (; m >= O + 4; m -= 3)
      p = `_${_.slice(m - 3, m)}${p}`;
    return `${_.slice(0, m)}${p}`;
  }
  function be(_, p, m) {
    je(p, "offset"), (_[p] === void 0 || _[p + m] === void 0) && Ue(p, _.length - (m + 1));
  }
  function Ce(_, p, m, O, Q, ie) {
    if (_ > m || _ < p) {
      const ce = typeof p == "bigint" ? "n" : "";
      let Ne;
      throw ie > 3 ? p === 0 || p === BigInt(0) ? Ne = `>= 0${ce} and < 2${ce} ** ${(ie + 1) * 8}${ce}` : Ne = `>= -(2${ce} ** ${(ie + 1) * 8 - 1}${ce}) and < 2 ** ${(ie + 1) * 8 - 1}${ce}` : Ne = `>= ${p}${ce} and <= ${m}${ce}`, new D.ERR_OUT_OF_RANGE("value", Ne, _);
    }
    be(O, Q, ie);
  }
  function je(_, p) {
    if (typeof _ != "number")
      throw new D.ERR_INVALID_ARG_TYPE(p, "number", _);
  }
  function Ue(_, p, m) {
    throw Math.floor(_) !== _ ? (je(_, m), new D.ERR_OUT_OF_RANGE(m || "offset", "an integer", _)) : p < 0 ? new D.ERR_BUFFER_OUT_OF_BOUNDS() : new D.ERR_OUT_OF_RANGE(
      m || "offset",
      `>= ${m ? 1 : 0} and <= ${p}`,
      _
    );
  }
  const Qe = /[^+/0-9A-Za-z-_]/g;
  function we(_) {
    if (_ = _.split("=")[0], _ = _.trim().replace(Qe, ""), _.length < 2)
      return "";
    for (; _.length % 4 !== 0; )
      _ = _ + "=";
    return _;
  }
  function at(_, p) {
    p = p || 1 / 0;
    let m;
    const O = _.length;
    let Q = null;
    const ie = [];
    for (let ce = 0; ce < O; ++ce) {
      if (m = _.charCodeAt(ce), m > 55295 && m < 57344) {
        if (!Q) {
          if (m > 56319) {
            (p -= 3) > -1 && ie.push(239, 191, 189);
            continue;
          } else if (ce + 1 === O) {
            (p -= 3) > -1 && ie.push(239, 191, 189);
            continue;
          }
          Q = m;
          continue;
        }
        if (m < 56320) {
          (p -= 3) > -1 && ie.push(239, 191, 189), Q = m;
          continue;
        }
        m = (Q - 55296 << 10 | m - 56320) + 65536;
      } else
        Q && (p -= 3) > -1 && ie.push(239, 191, 189);
      if (Q = null, m < 128) {
        if ((p -= 1) < 0)
          break;
        ie.push(m);
      } else if (m < 2048) {
        if ((p -= 2) < 0)
          break;
        ie.push(
          m >> 6 | 192,
          m & 63 | 128
        );
      } else if (m < 65536) {
        if ((p -= 3) < 0)
          break;
        ie.push(
          m >> 12 | 224,
          m >> 6 & 63 | 128,
          m & 63 | 128
        );
      } else if (m < 1114112) {
        if ((p -= 4) < 0)
          break;
        ie.push(
          m >> 18 | 240,
          m >> 12 & 63 | 128,
          m >> 6 & 63 | 128,
          m & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return ie;
  }
  function rt(_) {
    const p = [];
    for (let m = 0; m < _.length; ++m)
      p.push(_.charCodeAt(m) & 255);
    return p;
  }
  function It(_, p) {
    let m, O, Q;
    const ie = [];
    for (let ce = 0; ce < _.length && !((p -= 2) < 0); ++ce)
      m = _.charCodeAt(ce), O = m >> 8, Q = m % 256, ie.push(Q), ie.push(O);
    return ie;
  }
  function it(_) {
    return e.toByteArray(we(_));
  }
  function se(_, p, m, O) {
    let Q;
    for (Q = 0; Q < O && !(Q + m >= p.length || Q >= _.length); ++Q)
      p[Q + m] = _[Q];
    return Q;
  }
  function ue(_, p) {
    return _ instanceof p || _ != null && _.constructor != null && _.constructor.name != null && _.constructor.name === p.name;
  }
  function Ee(_) {
    return _ !== _;
  }
  const U = function() {
    const _ = "0123456789abcdef", p = new Array(256);
    for (let m = 0; m < 16; ++m) {
      const O = m * 16;
      for (let Q = 0; Q < 16; ++Q)
        p[O + Q] = _[m] + _[Q];
    }
    return p;
  }();
  function S(_) {
    return typeof BigInt > "u" ? I : _;
  }
  function I() {
    throw new Error("BigInt not supported");
  }
})(Am);
const Ie = Am.Buffer;
var mt = {}, Pu = {};
Pu.byteLength = O8;
Pu.toByteArray = C8;
Pu.fromByteArray = U8;
var vi = [], Dn = [], R8 = typeof Uint8Array < "u" ? Uint8Array : Array, Td = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var ia = 0, T8 = Td.length; ia < T8; ++ia)
  vi[ia] = Td[ia], Dn[Td.charCodeAt(ia)] = ia;
Dn[45] = 62;
Dn[95] = 63;
function Bm(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  r === -1 && (r = e);
  var n = r === e ? 0 : 4 - r % 4;
  return [r, n];
}
function O8(t) {
  var e = Bm(t), r = e[0], n = e[1];
  return (r + n) * 3 / 4 - n;
}
function k8(t, e, r) {
  return (e + r) * 3 / 4 - r;
}
function C8(t) {
  var e, r = Bm(t), n = r[0], i = r[1], o = new R8(k8(t, n, i)), a = 0, s = i > 0 ? n - 4 : n, f;
  for (f = 0; f < s; f += 4)
    e = Dn[t.charCodeAt(f)] << 18 | Dn[t.charCodeAt(f + 1)] << 12 | Dn[t.charCodeAt(f + 2)] << 6 | Dn[t.charCodeAt(f + 3)], o[a++] = e >> 16 & 255, o[a++] = e >> 8 & 255, o[a++] = e & 255;
  return i === 2 && (e = Dn[t.charCodeAt(f)] << 2 | Dn[t.charCodeAt(f + 1)] >> 4, o[a++] = e & 255), i === 1 && (e = Dn[t.charCodeAt(f)] << 10 | Dn[t.charCodeAt(f + 1)] << 4 | Dn[t.charCodeAt(f + 2)] >> 2, o[a++] = e >> 8 & 255, o[a++] = e & 255), o;
}
function P8(t) {
  return vi[t >> 18 & 63] + vi[t >> 12 & 63] + vi[t >> 6 & 63] + vi[t & 63];
}
function N8(t, e, r) {
  for (var n, i = [], o = e; o < r; o += 3)
    n = (t[o] << 16 & 16711680) + (t[o + 1] << 8 & 65280) + (t[o + 2] & 255), i.push(P8(n));
  return i.join("");
}
function U8(t) {
  for (var e, r = t.length, n = r % 3, i = [], o = 16383, a = 0, s = r - n; a < s; a += o)
    i.push(N8(t, a, a + o > s ? s : a + o));
  return n === 1 ? (e = t[r - 1], i.push(
    vi[e >> 2] + vi[e << 4 & 63] + "=="
  )) : n === 2 && (e = (t[r - 2] << 8) + t[r - 1], i.push(
    vi[e >> 10] + vi[e >> 4 & 63] + vi[e << 2 & 63] + "="
  )), i.join("");
}
var mp = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
mp.read = function(t, e, r, n, i) {
  var o, a, s = i * 8 - n - 1, f = (1 << s) - 1, u = f >> 1, c = -7, d = r ? i - 1 : 0, l = r ? -1 : 1, h = t[e + d];
  for (d += l, o = h & (1 << -c) - 1, h >>= -c, c += s; c > 0; o = o * 256 + t[e + d], d += l, c -= 8)
    ;
  for (a = o & (1 << -c) - 1, o >>= -c, c += n; c > 0; a = a * 256 + t[e + d], d += l, c -= 8)
    ;
  if (o === 0)
    o = 1 - u;
  else {
    if (o === f)
      return a ? NaN : (h ? -1 : 1) * (1 / 0);
    a = a + Math.pow(2, n), o = o - u;
  }
  return (h ? -1 : 1) * a * Math.pow(2, o - n);
};
mp.write = function(t, e, r, n, i, o) {
  var a, s, f, u = o * 8 - i - 1, c = (1 << u) - 1, d = c >> 1, l = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, h = n ? 0 : o - 1, y = n ? 1 : -1, b = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, a = c) : (a = Math.floor(Math.log(e) / Math.LN2), e * (f = Math.pow(2, -a)) < 1 && (a--, f *= 2), a + d >= 1 ? e += l / f : e += l * Math.pow(2, 1 - d), e * f >= 2 && (a++, f /= 2), a + d >= c ? (s = 0, a = c) : a + d >= 1 ? (s = (e * f - 1) * Math.pow(2, i), a = a + d) : (s = e * Math.pow(2, d - 1) * Math.pow(2, i), a = 0)); i >= 8; t[r + h] = s & 255, h += y, s /= 256, i -= 8)
    ;
  for (a = a << i | s, u += i; u > 0; t[r + h] = a & 255, h += y, a /= 256, u -= 8)
    ;
  t[r + h - y] |= b * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(t) {
  const e = Pu, r = mp, n = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = s, t.SlowBuffer = M, t.INSPECT_MAX_BYTES = 50;
  const i = 2147483647;
  t.kMaxLength = i, s.TYPED_ARRAY_SUPPORT = o(), !s.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function o() {
    try {
      const U = new Uint8Array(1), S = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(S, Uint8Array.prototype), Object.setPrototypeOf(U, S), U.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(s.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (s.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(s.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (s.isBuffer(this))
        return this.byteOffset;
    }
  });
  function a(U) {
    if (U > i)
      throw new RangeError('The value "' + U + '" is invalid for option "size"');
    const S = new Uint8Array(U);
    return Object.setPrototypeOf(S, s.prototype), S;
  }
  function s(U, S, I) {
    if (typeof U == "number") {
      if (typeof S == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return d(U);
    }
    return f(U, S, I);
  }
  s.poolSize = 8192;
  function f(U, S, I) {
    if (typeof U == "string")
      return l(U, S);
    if (ArrayBuffer.isView(U))
      return y(U);
    if (U == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof U
      );
    if (It(U, ArrayBuffer) || U && It(U.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (It(U, SharedArrayBuffer) || U && It(U.buffer, SharedArrayBuffer)))
      return b(U, S, I);
    if (typeof U == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const _ = U.valueOf && U.valueOf();
    if (_ != null && _ !== U)
      return s.from(_, S, I);
    const p = w(U);
    if (p)
      return p;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof U[Symbol.toPrimitive] == "function")
      return s.from(U[Symbol.toPrimitive]("string"), S, I);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof U
    );
  }
  s.from = function(U, S, I) {
    return f(U, S, I);
  }, Object.setPrototypeOf(s.prototype, Uint8Array.prototype), Object.setPrototypeOf(s, Uint8Array);
  function u(U) {
    if (typeof U != "number")
      throw new TypeError('"size" argument must be of type number');
    if (U < 0)
      throw new RangeError('The value "' + U + '" is invalid for option "size"');
  }
  function c(U, S, I) {
    return u(U), U <= 0 ? a(U) : S !== void 0 ? typeof I == "string" ? a(U).fill(S, I) : a(U).fill(S) : a(U);
  }
  s.alloc = function(U, S, I) {
    return c(U, S, I);
  };
  function d(U) {
    return u(U), a(U < 0 ? 0 : A(U) | 0);
  }
  s.allocUnsafe = function(U) {
    return d(U);
  }, s.allocUnsafeSlow = function(U) {
    return d(U);
  };
  function l(U, S) {
    if ((typeof S != "string" || S === "") && (S = "utf8"), !s.isEncoding(S))
      throw new TypeError("Unknown encoding: " + S);
    const I = N(U, S) | 0;
    let _ = a(I);
    const p = _.write(U, S);
    return p !== I && (_ = _.slice(0, p)), _;
  }
  function h(U) {
    const S = U.length < 0 ? 0 : A(U.length) | 0, I = a(S);
    for (let _ = 0; _ < S; _ += 1)
      I[_] = U[_] & 255;
    return I;
  }
  function y(U) {
    if (It(U, Uint8Array)) {
      const S = new Uint8Array(U);
      return b(S.buffer, S.byteOffset, S.byteLength);
    }
    return h(U);
  }
  function b(U, S, I) {
    if (S < 0 || U.byteLength < S)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (U.byteLength < S + (I || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let _;
    return S === void 0 && I === void 0 ? _ = new Uint8Array(U) : I === void 0 ? _ = new Uint8Array(U, S) : _ = new Uint8Array(U, S, I), Object.setPrototypeOf(_, s.prototype), _;
  }
  function w(U) {
    if (s.isBuffer(U)) {
      const S = A(U.length) | 0, I = a(S);
      return I.length === 0 || U.copy(I, 0, 0, S), I;
    }
    if (U.length !== void 0)
      return typeof U.length != "number" || it(U.length) ? a(0) : h(U);
    if (U.type === "Buffer" && Array.isArray(U.data))
      return h(U.data);
  }
  function A(U) {
    if (U >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return U | 0;
  }
  function M(U) {
    return +U != U && (U = 0), s.alloc(+U);
  }
  s.isBuffer = function(S) {
    return S != null && S._isBuffer === !0 && S !== s.prototype;
  }, s.compare = function(S, I) {
    if (It(S, Uint8Array) && (S = s.from(S, S.offset, S.byteLength)), It(I, Uint8Array) && (I = s.from(I, I.offset, I.byteLength)), !s.isBuffer(S) || !s.isBuffer(I))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (S === I)
      return 0;
    let _ = S.length, p = I.length;
    for (let m = 0, O = Math.min(_, p); m < O; ++m)
      if (S[m] !== I[m]) {
        _ = S[m], p = I[m];
        break;
      }
    return _ < p ? -1 : p < _ ? 1 : 0;
  }, s.isEncoding = function(S) {
    switch (String(S).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, s.concat = function(S, I) {
    if (!Array.isArray(S))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (S.length === 0)
      return s.alloc(0);
    let _;
    if (I === void 0)
      for (I = 0, _ = 0; _ < S.length; ++_)
        I += S[_].length;
    const p = s.allocUnsafe(I);
    let m = 0;
    for (_ = 0; _ < S.length; ++_) {
      let O = S[_];
      if (It(O, Uint8Array))
        m + O.length > p.length ? (s.isBuffer(O) || (O = s.from(O)), O.copy(p, m)) : Uint8Array.prototype.set.call(
          p,
          O,
          m
        );
      else if (s.isBuffer(O))
        O.copy(p, m);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      m += O.length;
    }
    return p;
  };
  function N(U, S) {
    if (s.isBuffer(U))
      return U.length;
    if (ArrayBuffer.isView(U) || It(U, ArrayBuffer))
      return U.byteLength;
    if (typeof U != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof U
      );
    const I = U.length, _ = arguments.length > 2 && arguments[2] === !0;
    if (!_ && I === 0)
      return 0;
    let p = !1;
    for (; ; )
      switch (S) {
        case "ascii":
        case "latin1":
        case "binary":
          return I;
        case "utf8":
        case "utf-8":
          return Ue(U).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return I * 2;
        case "hex":
          return I >>> 1;
        case "base64":
          return at(U).length;
        default:
          if (p)
            return _ ? -1 : Ue(U).length;
          S = ("" + S).toLowerCase(), p = !0;
      }
  }
  s.byteLength = N;
  function G(U, S, I) {
    let _ = !1;
    if ((S === void 0 || S < 0) && (S = 0), S > this.length || ((I === void 0 || I > this.length) && (I = this.length), I <= 0) || (I >>>= 0, S >>>= 0, I <= S))
      return "";
    for (U || (U = "utf8"); ; )
      switch (U) {
        case "hex":
          return C(this, S, I);
        case "utf8":
        case "utf-8":
          return v(this, S, I);
        case "ascii":
          return L(this, S, I);
        case "latin1":
        case "binary":
          return x(this, S, I);
        case "base64":
          return F(this, S, I);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return j(this, S, I);
        default:
          if (_)
            throw new TypeError("Unknown encoding: " + U);
          U = (U + "").toLowerCase(), _ = !0;
      }
  }
  s.prototype._isBuffer = !0;
  function z(U, S, I) {
    const _ = U[S];
    U[S] = U[I], U[I] = _;
  }
  s.prototype.swap16 = function() {
    const S = this.length;
    if (S % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let I = 0; I < S; I += 2)
      z(this, I, I + 1);
    return this;
  }, s.prototype.swap32 = function() {
    const S = this.length;
    if (S % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let I = 0; I < S; I += 4)
      z(this, I, I + 3), z(this, I + 1, I + 2);
    return this;
  }, s.prototype.swap64 = function() {
    const S = this.length;
    if (S % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let I = 0; I < S; I += 8)
      z(this, I, I + 7), z(this, I + 1, I + 6), z(this, I + 2, I + 5), z(this, I + 3, I + 4);
    return this;
  }, s.prototype.toString = function() {
    const S = this.length;
    return S === 0 ? "" : arguments.length === 0 ? v(this, 0, S) : G.apply(this, arguments);
  }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(S) {
    if (!s.isBuffer(S))
      throw new TypeError("Argument must be a Buffer");
    return this === S ? !0 : s.compare(this, S) === 0;
  }, s.prototype.inspect = function() {
    let S = "";
    const I = t.INSPECT_MAX_BYTES;
    return S = this.toString("hex", 0, I).replace(/(.{2})/g, "$1 ").trim(), this.length > I && (S += " ... "), "<Buffer " + S + ">";
  }, n && (s.prototype[n] = s.prototype.inspect), s.prototype.compare = function(S, I, _, p, m) {
    if (It(S, Uint8Array) && (S = s.from(S, S.offset, S.byteLength)), !s.isBuffer(S))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof S
      );
    if (I === void 0 && (I = 0), _ === void 0 && (_ = S ? S.length : 0), p === void 0 && (p = 0), m === void 0 && (m = this.length), I < 0 || _ > S.length || p < 0 || m > this.length)
      throw new RangeError("out of range index");
    if (p >= m && I >= _)
      return 0;
    if (p >= m)
      return -1;
    if (I >= _)
      return 1;
    if (I >>>= 0, _ >>>= 0, p >>>= 0, m >>>= 0, this === S)
      return 0;
    let O = m - p, Q = _ - I;
    const ie = Math.min(O, Q), ce = this.slice(p, m), Ne = S.slice(I, _);
    for (let Te = 0; Te < ie; ++Te)
      if (ce[Te] !== Ne[Te]) {
        O = ce[Te], Q = Ne[Te];
        break;
      }
    return O < Q ? -1 : Q < O ? 1 : 0;
  };
  function J(U, S, I, _, p) {
    if (U.length === 0)
      return -1;
    if (typeof I == "string" ? (_ = I, I = 0) : I > 2147483647 ? I = 2147483647 : I < -2147483648 && (I = -2147483648), I = +I, it(I) && (I = p ? 0 : U.length - 1), I < 0 && (I = U.length + I), I >= U.length) {
      if (p)
        return -1;
      I = U.length - 1;
    } else if (I < 0)
      if (p)
        I = 0;
      else
        return -1;
    if (typeof S == "string" && (S = s.from(S, _)), s.isBuffer(S))
      return S.length === 0 ? -1 : oe(U, S, I, _, p);
    if (typeof S == "number")
      return S = S & 255, typeof Uint8Array.prototype.indexOf == "function" ? p ? Uint8Array.prototype.indexOf.call(U, S, I) : Uint8Array.prototype.lastIndexOf.call(U, S, I) : oe(U, [S], I, _, p);
    throw new TypeError("val must be string, number or Buffer");
  }
  function oe(U, S, I, _, p) {
    let m = 1, O = U.length, Q = S.length;
    if (_ !== void 0 && (_ = String(_).toLowerCase(), _ === "ucs2" || _ === "ucs-2" || _ === "utf16le" || _ === "utf-16le")) {
      if (U.length < 2 || S.length < 2)
        return -1;
      m = 2, O /= 2, Q /= 2, I /= 2;
    }
    function ie(Ne, Te) {
      return m === 1 ? Ne[Te] : Ne.readUInt16BE(Te * m);
    }
    let ce;
    if (p) {
      let Ne = -1;
      for (ce = I; ce < O; ce++)
        if (ie(U, ce) === ie(S, Ne === -1 ? 0 : ce - Ne)) {
          if (Ne === -1 && (Ne = ce), ce - Ne + 1 === Q)
            return Ne * m;
        } else
          Ne !== -1 && (ce -= ce - Ne), Ne = -1;
    } else
      for (I + Q > O && (I = O - Q), ce = I; ce >= 0; ce--) {
        let Ne = !0;
        for (let Te = 0; Te < Q; Te++)
          if (ie(U, ce + Te) !== ie(S, Te)) {
            Ne = !1;
            break;
          }
        if (Ne)
          return ce;
      }
    return -1;
  }
  s.prototype.includes = function(S, I, _) {
    return this.indexOf(S, I, _) !== -1;
  }, s.prototype.indexOf = function(S, I, _) {
    return J(this, S, I, _, !0);
  }, s.prototype.lastIndexOf = function(S, I, _) {
    return J(this, S, I, _, !1);
  };
  function ee(U, S, I, _) {
    I = Number(I) || 0;
    const p = U.length - I;
    _ ? (_ = Number(_), _ > p && (_ = p)) : _ = p;
    const m = S.length;
    _ > m / 2 && (_ = m / 2);
    let O;
    for (O = 0; O < _; ++O) {
      const Q = parseInt(S.substr(O * 2, 2), 16);
      if (it(Q))
        return O;
      U[I + O] = Q;
    }
    return O;
  }
  function ae(U, S, I, _) {
    return rt(Ue(S, U.length - I), U, I, _);
  }
  function ye(U, S, I, _) {
    return rt(Qe(S), U, I, _);
  }
  function pe(U, S, I, _) {
    return rt(at(S), U, I, _);
  }
  function te(U, S, I, _) {
    return rt(we(S, U.length - I), U, I, _);
  }
  s.prototype.write = function(S, I, _, p) {
    if (I === void 0)
      p = "utf8", _ = this.length, I = 0;
    else if (_ === void 0 && typeof I == "string")
      p = I, _ = this.length, I = 0;
    else if (isFinite(I))
      I = I >>> 0, isFinite(_) ? (_ = _ >>> 0, p === void 0 && (p = "utf8")) : (p = _, _ = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const m = this.length - I;
    if ((_ === void 0 || _ > m) && (_ = m), S.length > 0 && (_ < 0 || I < 0) || I > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    p || (p = "utf8");
    let O = !1;
    for (; ; )
      switch (p) {
        case "hex":
          return ee(this, S, I, _);
        case "utf8":
        case "utf-8":
          return ae(this, S, I, _);
        case "ascii":
        case "latin1":
        case "binary":
          return ye(this, S, I, _);
        case "base64":
          return pe(this, S, I, _);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return te(this, S, I, _);
        default:
          if (O)
            throw new TypeError("Unknown encoding: " + p);
          p = ("" + p).toLowerCase(), O = !0;
      }
  }, s.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function F(U, S, I) {
    return S === 0 && I === U.length ? e.fromByteArray(U) : e.fromByteArray(U.slice(S, I));
  }
  function v(U, S, I) {
    I = Math.min(U.length, I);
    const _ = [];
    let p = S;
    for (; p < I; ) {
      const m = U[p];
      let O = null, Q = m > 239 ? 4 : m > 223 ? 3 : m > 191 ? 2 : 1;
      if (p + Q <= I) {
        let ie, ce, Ne, Te;
        switch (Q) {
          case 1:
            m < 128 && (O = m);
            break;
          case 2:
            ie = U[p + 1], (ie & 192) === 128 && (Te = (m & 31) << 6 | ie & 63, Te > 127 && (O = Te));
            break;
          case 3:
            ie = U[p + 1], ce = U[p + 2], (ie & 192) === 128 && (ce & 192) === 128 && (Te = (m & 15) << 12 | (ie & 63) << 6 | ce & 63, Te > 2047 && (Te < 55296 || Te > 57343) && (O = Te));
            break;
          case 4:
            ie = U[p + 1], ce = U[p + 2], Ne = U[p + 3], (ie & 192) === 128 && (ce & 192) === 128 && (Ne & 192) === 128 && (Te = (m & 15) << 18 | (ie & 63) << 12 | (ce & 63) << 6 | Ne & 63, Te > 65535 && Te < 1114112 && (O = Te));
        }
      }
      O === null ? (O = 65533, Q = 1) : O > 65535 && (O -= 65536, _.push(O >>> 10 & 1023 | 55296), O = 56320 | O & 1023), _.push(O), p += Q;
    }
    return P(_);
  }
  const B = 4096;
  function P(U) {
    const S = U.length;
    if (S <= B)
      return String.fromCharCode.apply(String, U);
    let I = "", _ = 0;
    for (; _ < S; )
      I += String.fromCharCode.apply(
        String,
        U.slice(_, _ += B)
      );
    return I;
  }
  function L(U, S, I) {
    let _ = "";
    I = Math.min(U.length, I);
    for (let p = S; p < I; ++p)
      _ += String.fromCharCode(U[p] & 127);
    return _;
  }
  function x(U, S, I) {
    let _ = "";
    I = Math.min(U.length, I);
    for (let p = S; p < I; ++p)
      _ += String.fromCharCode(U[p]);
    return _;
  }
  function C(U, S, I) {
    const _ = U.length;
    (!S || S < 0) && (S = 0), (!I || I < 0 || I > _) && (I = _);
    let p = "";
    for (let m = S; m < I; ++m)
      p += se[U[m]];
    return p;
  }
  function j(U, S, I) {
    const _ = U.slice(S, I);
    let p = "";
    for (let m = 0; m < _.length - 1; m += 2)
      p += String.fromCharCode(_[m] + _[m + 1] * 256);
    return p;
  }
  s.prototype.slice = function(S, I) {
    const _ = this.length;
    S = ~~S, I = I === void 0 ? _ : ~~I, S < 0 ? (S += _, S < 0 && (S = 0)) : S > _ && (S = _), I < 0 ? (I += _, I < 0 && (I = 0)) : I > _ && (I = _), I < S && (I = S);
    const p = this.subarray(S, I);
    return Object.setPrototypeOf(p, s.prototype), p;
  };
  function k(U, S, I) {
    if (U % 1 !== 0 || U < 0)
      throw new RangeError("offset is not uint");
    if (U + S > I)
      throw new RangeError("Trying to access beyond buffer length");
  }
  s.prototype.readUintLE = s.prototype.readUIntLE = function(S, I, _) {
    S = S >>> 0, I = I >>> 0, _ || k(S, I, this.length);
    let p = this[S], m = 1, O = 0;
    for (; ++O < I && (m *= 256); )
      p += this[S + O] * m;
    return p;
  }, s.prototype.readUintBE = s.prototype.readUIntBE = function(S, I, _) {
    S = S >>> 0, I = I >>> 0, _ || k(S, I, this.length);
    let p = this[S + --I], m = 1;
    for (; I > 0 && (m *= 256); )
      p += this[S + --I] * m;
    return p;
  }, s.prototype.readUint8 = s.prototype.readUInt8 = function(S, I) {
    return S = S >>> 0, I || k(S, 1, this.length), this[S];
  }, s.prototype.readUint16LE = s.prototype.readUInt16LE = function(S, I) {
    return S = S >>> 0, I || k(S, 2, this.length), this[S] | this[S + 1] << 8;
  }, s.prototype.readUint16BE = s.prototype.readUInt16BE = function(S, I) {
    return S = S >>> 0, I || k(S, 2, this.length), this[S] << 8 | this[S + 1];
  }, s.prototype.readUint32LE = s.prototype.readUInt32LE = function(S, I) {
    return S = S >>> 0, I || k(S, 4, this.length), (this[S] | this[S + 1] << 8 | this[S + 2] << 16) + this[S + 3] * 16777216;
  }, s.prototype.readUint32BE = s.prototype.readUInt32BE = function(S, I) {
    return S = S >>> 0, I || k(S, 4, this.length), this[S] * 16777216 + (this[S + 1] << 16 | this[S + 2] << 8 | this[S + 3]);
  }, s.prototype.readBigUInt64LE = ue(function(S) {
    S = S >>> 0, he(S, "offset");
    const I = this[S], _ = this[S + 7];
    (I === void 0 || _ === void 0) && be(S, this.length - 8);
    const p = I + this[++S] * 2 ** 8 + this[++S] * 2 ** 16 + this[++S] * 2 ** 24, m = this[++S] + this[++S] * 2 ** 8 + this[++S] * 2 ** 16 + _ * 2 ** 24;
    return BigInt(p) + (BigInt(m) << BigInt(32));
  }), s.prototype.readBigUInt64BE = ue(function(S) {
    S = S >>> 0, he(S, "offset");
    const I = this[S], _ = this[S + 7];
    (I === void 0 || _ === void 0) && be(S, this.length - 8);
    const p = I * 2 ** 24 + this[++S] * 2 ** 16 + this[++S] * 2 ** 8 + this[++S], m = this[++S] * 2 ** 24 + this[++S] * 2 ** 16 + this[++S] * 2 ** 8 + _;
    return (BigInt(p) << BigInt(32)) + BigInt(m);
  }), s.prototype.readIntLE = function(S, I, _) {
    S = S >>> 0, I = I >>> 0, _ || k(S, I, this.length);
    let p = this[S], m = 1, O = 0;
    for (; ++O < I && (m *= 256); )
      p += this[S + O] * m;
    return m *= 128, p >= m && (p -= Math.pow(2, 8 * I)), p;
  }, s.prototype.readIntBE = function(S, I, _) {
    S = S >>> 0, I = I >>> 0, _ || k(S, I, this.length);
    let p = I, m = 1, O = this[S + --p];
    for (; p > 0 && (m *= 256); )
      O += this[S + --p] * m;
    return m *= 128, O >= m && (O -= Math.pow(2, 8 * I)), O;
  }, s.prototype.readInt8 = function(S, I) {
    return S = S >>> 0, I || k(S, 1, this.length), this[S] & 128 ? (255 - this[S] + 1) * -1 : this[S];
  }, s.prototype.readInt16LE = function(S, I) {
    S = S >>> 0, I || k(S, 2, this.length);
    const _ = this[S] | this[S + 1] << 8;
    return _ & 32768 ? _ | 4294901760 : _;
  }, s.prototype.readInt16BE = function(S, I) {
    S = S >>> 0, I || k(S, 2, this.length);
    const _ = this[S + 1] | this[S] << 8;
    return _ & 32768 ? _ | 4294901760 : _;
  }, s.prototype.readInt32LE = function(S, I) {
    return S = S >>> 0, I || k(S, 4, this.length), this[S] | this[S + 1] << 8 | this[S + 2] << 16 | this[S + 3] << 24;
  }, s.prototype.readInt32BE = function(S, I) {
    return S = S >>> 0, I || k(S, 4, this.length), this[S] << 24 | this[S + 1] << 16 | this[S + 2] << 8 | this[S + 3];
  }, s.prototype.readBigInt64LE = ue(function(S) {
    S = S >>> 0, he(S, "offset");
    const I = this[S], _ = this[S + 7];
    (I === void 0 || _ === void 0) && be(S, this.length - 8);
    const p = this[S + 4] + this[S + 5] * 2 ** 8 + this[S + 6] * 2 ** 16 + (_ << 24);
    return (BigInt(p) << BigInt(32)) + BigInt(I + this[++S] * 2 ** 8 + this[++S] * 2 ** 16 + this[++S] * 2 ** 24);
  }), s.prototype.readBigInt64BE = ue(function(S) {
    S = S >>> 0, he(S, "offset");
    const I = this[S], _ = this[S + 7];
    (I === void 0 || _ === void 0) && be(S, this.length - 8);
    const p = (I << 24) + // Overflow
    this[++S] * 2 ** 16 + this[++S] * 2 ** 8 + this[++S];
    return (BigInt(p) << BigInt(32)) + BigInt(this[++S] * 2 ** 24 + this[++S] * 2 ** 16 + this[++S] * 2 ** 8 + _);
  }), s.prototype.readFloatLE = function(S, I) {
    return S = S >>> 0, I || k(S, 4, this.length), r.read(this, S, !0, 23, 4);
  }, s.prototype.readFloatBE = function(S, I) {
    return S = S >>> 0, I || k(S, 4, this.length), r.read(this, S, !1, 23, 4);
  }, s.prototype.readDoubleLE = function(S, I) {
    return S = S >>> 0, I || k(S, 8, this.length), r.read(this, S, !0, 52, 8);
  }, s.prototype.readDoubleBE = function(S, I) {
    return S = S >>> 0, I || k(S, 8, this.length), r.read(this, S, !1, 52, 8);
  };
  function g(U, S, I, _, p, m) {
    if (!s.isBuffer(U))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (S > p || S < m)
      throw new RangeError('"value" argument is out of bounds');
    if (I + _ > U.length)
      throw new RangeError("Index out of range");
  }
  s.prototype.writeUintLE = s.prototype.writeUIntLE = function(S, I, _, p) {
    if (S = +S, I = I >>> 0, _ = _ >>> 0, !p) {
      const Q = Math.pow(2, 8 * _) - 1;
      g(this, S, I, _, Q, 0);
    }
    let m = 1, O = 0;
    for (this[I] = S & 255; ++O < _ && (m *= 256); )
      this[I + O] = S / m & 255;
    return I + _;
  }, s.prototype.writeUintBE = s.prototype.writeUIntBE = function(S, I, _, p) {
    if (S = +S, I = I >>> 0, _ = _ >>> 0, !p) {
      const Q = Math.pow(2, 8 * _) - 1;
      g(this, S, I, _, Q, 0);
    }
    let m = _ - 1, O = 1;
    for (this[I + m] = S & 255; --m >= 0 && (O *= 256); )
      this[I + m] = S / O & 255;
    return I + _;
  }, s.prototype.writeUint8 = s.prototype.writeUInt8 = function(S, I, _) {
    return S = +S, I = I >>> 0, _ || g(this, S, I, 1, 255, 0), this[I] = S & 255, I + 1;
  }, s.prototype.writeUint16LE = s.prototype.writeUInt16LE = function(S, I, _) {
    return S = +S, I = I >>> 0, _ || g(this, S, I, 2, 65535, 0), this[I] = S & 255, this[I + 1] = S >>> 8, I + 2;
  }, s.prototype.writeUint16BE = s.prototype.writeUInt16BE = function(S, I, _) {
    return S = +S, I = I >>> 0, _ || g(this, S, I, 2, 65535, 0), this[I] = S >>> 8, this[I + 1] = S & 255, I + 2;
  }, s.prototype.writeUint32LE = s.prototype.writeUInt32LE = function(S, I, _) {
    return S = +S, I = I >>> 0, _ || g(this, S, I, 4, 4294967295, 0), this[I + 3] = S >>> 24, this[I + 2] = S >>> 16, this[I + 1] = S >>> 8, this[I] = S & 255, I + 4;
  }, s.prototype.writeUint32BE = s.prototype.writeUInt32BE = function(S, I, _) {
    return S = +S, I = I >>> 0, _ || g(this, S, I, 4, 4294967295, 0), this[I] = S >>> 24, this[I + 1] = S >>> 16, this[I + 2] = S >>> 8, this[I + 3] = S & 255, I + 4;
  };
  function R(U, S, I, _, p) {
    K(S, _, p, U, I, 7);
    let m = Number(S & BigInt(4294967295));
    U[I++] = m, m = m >> 8, U[I++] = m, m = m >> 8, U[I++] = m, m = m >> 8, U[I++] = m;
    let O = Number(S >> BigInt(32) & BigInt(4294967295));
    return U[I++] = O, O = O >> 8, U[I++] = O, O = O >> 8, U[I++] = O, O = O >> 8, U[I++] = O, I;
  }
  function X(U, S, I, _, p) {
    K(S, _, p, U, I, 7);
    let m = Number(S & BigInt(4294967295));
    U[I + 7] = m, m = m >> 8, U[I + 6] = m, m = m >> 8, U[I + 5] = m, m = m >> 8, U[I + 4] = m;
    let O = Number(S >> BigInt(32) & BigInt(4294967295));
    return U[I + 3] = O, O = O >> 8, U[I + 2] = O, O = O >> 8, U[I + 1] = O, O = O >> 8, U[I] = O, I + 8;
  }
  s.prototype.writeBigUInt64LE = ue(function(S, I = 0) {
    return R(this, S, I, BigInt(0), BigInt("0xffffffffffffffff"));
  }), s.prototype.writeBigUInt64BE = ue(function(S, I = 0) {
    return X(this, S, I, BigInt(0), BigInt("0xffffffffffffffff"));
  }), s.prototype.writeIntLE = function(S, I, _, p) {
    if (S = +S, I = I >>> 0, !p) {
      const ie = Math.pow(2, 8 * _ - 1);
      g(this, S, I, _, ie - 1, -ie);
    }
    let m = 0, O = 1, Q = 0;
    for (this[I] = S & 255; ++m < _ && (O *= 256); )
      S < 0 && Q === 0 && this[I + m - 1] !== 0 && (Q = 1), this[I + m] = (S / O >> 0) - Q & 255;
    return I + _;
  }, s.prototype.writeIntBE = function(S, I, _, p) {
    if (S = +S, I = I >>> 0, !p) {
      const ie = Math.pow(2, 8 * _ - 1);
      g(this, S, I, _, ie - 1, -ie);
    }
    let m = _ - 1, O = 1, Q = 0;
    for (this[I + m] = S & 255; --m >= 0 && (O *= 256); )
      S < 0 && Q === 0 && this[I + m + 1] !== 0 && (Q = 1), this[I + m] = (S / O >> 0) - Q & 255;
    return I + _;
  }, s.prototype.writeInt8 = function(S, I, _) {
    return S = +S, I = I >>> 0, _ || g(this, S, I, 1, 127, -128), S < 0 && (S = 255 + S + 1), this[I] = S & 255, I + 1;
  }, s.prototype.writeInt16LE = function(S, I, _) {
    return S = +S, I = I >>> 0, _ || g(this, S, I, 2, 32767, -32768), this[I] = S & 255, this[I + 1] = S >>> 8, I + 2;
  }, s.prototype.writeInt16BE = function(S, I, _) {
    return S = +S, I = I >>> 0, _ || g(this, S, I, 2, 32767, -32768), this[I] = S >>> 8, this[I + 1] = S & 255, I + 2;
  }, s.prototype.writeInt32LE = function(S, I, _) {
    return S = +S, I = I >>> 0, _ || g(this, S, I, 4, 2147483647, -2147483648), this[I] = S & 255, this[I + 1] = S >>> 8, this[I + 2] = S >>> 16, this[I + 3] = S >>> 24, I + 4;
  }, s.prototype.writeInt32BE = function(S, I, _) {
    return S = +S, I = I >>> 0, _ || g(this, S, I, 4, 2147483647, -2147483648), S < 0 && (S = 4294967295 + S + 1), this[I] = S >>> 24, this[I + 1] = S >>> 16, this[I + 2] = S >>> 8, this[I + 3] = S & 255, I + 4;
  }, s.prototype.writeBigInt64LE = ue(function(S, I = 0) {
    return R(this, S, I, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), s.prototype.writeBigInt64BE = ue(function(S, I = 0) {
    return X(this, S, I, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function re(U, S, I, _, p, m) {
    if (I + _ > U.length)
      throw new RangeError("Index out of range");
    if (I < 0)
      throw new RangeError("Index out of range");
  }
  function V(U, S, I, _, p) {
    return S = +S, I = I >>> 0, p || re(U, S, I, 4), r.write(U, S, I, _, 23, 4), I + 4;
  }
  s.prototype.writeFloatLE = function(S, I, _) {
    return V(this, S, I, !0, _);
  }, s.prototype.writeFloatBE = function(S, I, _) {
    return V(this, S, I, !1, _);
  };
  function $(U, S, I, _, p) {
    return S = +S, I = I >>> 0, p || re(U, S, I, 8), r.write(U, S, I, _, 52, 8), I + 8;
  }
  s.prototype.writeDoubleLE = function(S, I, _) {
    return $(this, S, I, !0, _);
  }, s.prototype.writeDoubleBE = function(S, I, _) {
    return $(this, S, I, !1, _);
  }, s.prototype.copy = function(S, I, _, p) {
    if (!s.isBuffer(S))
      throw new TypeError("argument should be a Buffer");
    if (_ || (_ = 0), !p && p !== 0 && (p = this.length), I >= S.length && (I = S.length), I || (I = 0), p > 0 && p < _ && (p = _), p === _ || S.length === 0 || this.length === 0)
      return 0;
    if (I < 0)
      throw new RangeError("targetStart out of bounds");
    if (_ < 0 || _ >= this.length)
      throw new RangeError("Index out of range");
    if (p < 0)
      throw new RangeError("sourceEnd out of bounds");
    p > this.length && (p = this.length), S.length - I < p - _ && (p = S.length - I + _);
    const m = p - _;
    return this === S && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(I, _, p) : Uint8Array.prototype.set.call(
      S,
      this.subarray(_, p),
      I
    ), m;
  }, s.prototype.fill = function(S, I, _, p) {
    if (typeof S == "string") {
      if (typeof I == "string" ? (p = I, I = 0, _ = this.length) : typeof _ == "string" && (p = _, _ = this.length), p !== void 0 && typeof p != "string")
        throw new TypeError("encoding must be a string");
      if (typeof p == "string" && !s.isEncoding(p))
        throw new TypeError("Unknown encoding: " + p);
      if (S.length === 1) {
        const O = S.charCodeAt(0);
        (p === "utf8" && O < 128 || p === "latin1") && (S = O);
      }
    } else
      typeof S == "number" ? S = S & 255 : typeof S == "boolean" && (S = Number(S));
    if (I < 0 || this.length < I || this.length < _)
      throw new RangeError("Out of range index");
    if (_ <= I)
      return this;
    I = I >>> 0, _ = _ === void 0 ? this.length : _ >>> 0, S || (S = 0);
    let m;
    if (typeof S == "number")
      for (m = I; m < _; ++m)
        this[m] = S;
    else {
      const O = s.isBuffer(S) ? S : s.from(S, p), Q = O.length;
      if (Q === 0)
        throw new TypeError('The value "' + S + '" is invalid for argument "value"');
      for (m = 0; m < _ - I; ++m)
        this[m + I] = O[m % Q];
    }
    return this;
  };
  const W = {};
  function Z(U, S, I) {
    W[U] = class extends I {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: S.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${U}]`, this.stack, delete this.name;
      }
      get code() {
        return U;
      }
      set code(p) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: p,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${U}]: ${this.message}`;
      }
    };
  }
  Z(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(U) {
      return U ? `${U} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Z(
    "ERR_INVALID_ARG_TYPE",
    function(U, S) {
      return `The "${U}" argument must be of type number. Received type ${typeof S}`;
    },
    TypeError
  ), Z(
    "ERR_OUT_OF_RANGE",
    function(U, S, I) {
      let _ = `The value of "${U}" is out of range.`, p = I;
      return Number.isInteger(I) && Math.abs(I) > 2 ** 32 ? p = fe(String(I)) : typeof I == "bigint" && (p = String(I), (I > BigInt(2) ** BigInt(32) || I < -(BigInt(2) ** BigInt(32))) && (p = fe(p)), p += "n"), _ += ` It must be ${S}. Received ${p}`, _;
    },
    RangeError
  );
  function fe(U) {
    let S = "", I = U.length;
    const _ = U[0] === "-" ? 1 : 0;
    for (; I >= _ + 4; I -= 3)
      S = `_${U.slice(I - 3, I)}${S}`;
    return `${U.slice(0, I)}${S}`;
  }
  function D(U, S, I) {
    he(S, "offset"), (U[S] === void 0 || U[S + I] === void 0) && be(S, U.length - (I + 1));
  }
  function K(U, S, I, _, p, m) {
    if (U > I || U < S) {
      const O = typeof S == "bigint" ? "n" : "";
      let Q;
      throw m > 3 ? S === 0 || S === BigInt(0) ? Q = `>= 0${O} and < 2${O} ** ${(m + 1) * 8}${O}` : Q = `>= -(2${O} ** ${(m + 1) * 8 - 1}${O}) and < 2 ** ${(m + 1) * 8 - 1}${O}` : Q = `>= ${S}${O} and <= ${I}${O}`, new W.ERR_OUT_OF_RANGE("value", Q, U);
    }
    D(_, p, m);
  }
  function he(U, S) {
    if (typeof U != "number")
      throw new W.ERR_INVALID_ARG_TYPE(S, "number", U);
  }
  function be(U, S, I) {
    throw Math.floor(U) !== U ? (he(U, I), new W.ERR_OUT_OF_RANGE(I || "offset", "an integer", U)) : S < 0 ? new W.ERR_BUFFER_OUT_OF_BOUNDS() : new W.ERR_OUT_OF_RANGE(
      I || "offset",
      `>= ${I ? 1 : 0} and <= ${S}`,
      U
    );
  }
  const Ce = /[^+/0-9A-Za-z-_]/g;
  function je(U) {
    if (U = U.split("=")[0], U = U.trim().replace(Ce, ""), U.length < 2)
      return "";
    for (; U.length % 4 !== 0; )
      U = U + "=";
    return U;
  }
  function Ue(U, S) {
    S = S || 1 / 0;
    let I;
    const _ = U.length;
    let p = null;
    const m = [];
    for (let O = 0; O < _; ++O) {
      if (I = U.charCodeAt(O), I > 55295 && I < 57344) {
        if (!p) {
          if (I > 56319) {
            (S -= 3) > -1 && m.push(239, 191, 189);
            continue;
          } else if (O + 1 === _) {
            (S -= 3) > -1 && m.push(239, 191, 189);
            continue;
          }
          p = I;
          continue;
        }
        if (I < 56320) {
          (S -= 3) > -1 && m.push(239, 191, 189), p = I;
          continue;
        }
        I = (p - 55296 << 10 | I - 56320) + 65536;
      } else
        p && (S -= 3) > -1 && m.push(239, 191, 189);
      if (p = null, I < 128) {
        if ((S -= 1) < 0)
          break;
        m.push(I);
      } else if (I < 2048) {
        if ((S -= 2) < 0)
          break;
        m.push(
          I >> 6 | 192,
          I & 63 | 128
        );
      } else if (I < 65536) {
        if ((S -= 3) < 0)
          break;
        m.push(
          I >> 12 | 224,
          I >> 6 & 63 | 128,
          I & 63 | 128
        );
      } else if (I < 1114112) {
        if ((S -= 4) < 0)
          break;
        m.push(
          I >> 18 | 240,
          I >> 12 & 63 | 128,
          I >> 6 & 63 | 128,
          I & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return m;
  }
  function Qe(U) {
    const S = [];
    for (let I = 0; I < U.length; ++I)
      S.push(U.charCodeAt(I) & 255);
    return S;
  }
  function we(U, S) {
    let I, _, p;
    const m = [];
    for (let O = 0; O < U.length && !((S -= 2) < 0); ++O)
      I = U.charCodeAt(O), _ = I >> 8, p = I % 256, m.push(p), m.push(_);
    return m;
  }
  function at(U) {
    return e.toByteArray(je(U));
  }
  function rt(U, S, I, _) {
    let p;
    for (p = 0; p < _ && !(p + I >= S.length || p >= U.length); ++p)
      S[p + I] = U[p];
    return p;
  }
  function It(U, S) {
    return U instanceof S || U != null && U.constructor != null && U.constructor.name != null && U.constructor.name === S.name;
  }
  function it(U) {
    return U !== U;
  }
  const se = function() {
    const U = "0123456789abcdef", S = new Array(256);
    for (let I = 0; I < 16; ++I) {
      const _ = I * 16;
      for (let p = 0; p < 16; ++p)
        S[_ + p] = U[I] + U[p];
    }
    return S;
  }();
  function ue(U) {
    return typeof BigInt > "u" ? Ee : U;
  }
  function Ee() {
    throw new Error("BigInt not supported");
  }
})(mt);
function F8(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Mm = { exports: {} }, At = {}, zf = { exports: {} }, S0 = { exports: {} };
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
(function(t, e) {
  var r = mt, n = r.Buffer;
  function i(a, s) {
    for (var f in a)
      s[f] = a[f];
  }
  n.from && n.alloc && n.allocUnsafe && n.allocUnsafeSlow ? t.exports = r : (i(r, e), e.Buffer = o);
  function o(a, s, f) {
    return n(a, s, f);
  }
  o.prototype = Object.create(n.prototype), i(n, o), o.from = function(a, s, f) {
    if (typeof a == "number")
      throw new TypeError("Argument must not be a number");
    return n(a, s, f);
  }, o.alloc = function(a, s, f) {
    if (typeof a != "number")
      throw new TypeError("Argument must be a number");
    var u = n(a);
    return s !== void 0 ? typeof f == "string" ? u.fill(s, f) : u.fill(s) : u.fill(0), u;
  }, o.allocUnsafe = function(a) {
    if (typeof a != "number")
      throw new TypeError("Argument must be a number");
    return n(a);
  }, o.allocUnsafeSlow = function(a) {
    if (typeof a != "number")
      throw new TypeError("Argument must be a number");
    return r.SlowBuffer(a);
  };
})(S0, S0.exports);
var Et = S0.exports, Z1;
function es() {
  if (Z1)
    return zf.exports;
  Z1 = 1;
  var t = 65536, e = 4294967295;
  function r() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var n = Et.Buffer, i = yt.crypto || yt.msCrypto;
  i && i.getRandomValues ? zf.exports = o : zf.exports = r;
  function o(a, s) {
    if (a > e)
      throw new RangeError("requested too many random bytes");
    var f = n.allocUnsafe(a);
    if (a > 0)
      if (a > t)
        for (var u = 0; u < a; u += t)
          i.getRandomValues(f.slice(u, u + t));
      else
        i.getRandomValues(f);
    return typeof s == "function" ? Ye.nextTick(function() {
      s(null, f);
    }) : f;
  }
  return zf.exports;
}
var A0 = { exports: {} };
typeof Object.create == "function" ? A0.exports = function(e, r) {
  r && (e.super_ = r, e.prototype = Object.create(r.prototype, {
    constructor: {
      value: e,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : A0.exports = function(e, r) {
  if (r) {
    e.super_ = r;
    var n = function() {
    };
    n.prototype = r.prototype, e.prototype = new n(), e.prototype.constructor = e;
  }
};
var Mt = A0.exports, I0 = { exports: {} }, wp = { exports: {} }, Ba = typeof Reflect == "object" ? Reflect : null, Q1 = Ba && typeof Ba.apply == "function" ? Ba.apply : function(e, r, n) {
  return Function.prototype.apply.call(e, r, n);
}, pc;
Ba && typeof Ba.ownKeys == "function" ? pc = Ba.ownKeys : Object.getOwnPropertySymbols ? pc = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : pc = function(e) {
  return Object.getOwnPropertyNames(e);
};
function L8(t) {
  console && console.warn && console.warn(t);
}
var Rm = Number.isNaN || function(e) {
  return e !== e;
};
function cr() {
  cr.init.call(this);
}
wp.exports = cr;
wp.exports.once = q8;
cr.EventEmitter = cr;
cr.prototype._events = void 0;
cr.prototype._eventsCount = 0;
cr.prototype._maxListeners = void 0;
var ey = 10;
function Nu(t) {
  if (typeof t != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
}
Object.defineProperty(cr, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return ey;
  },
  set: function(t) {
    if (typeof t != "number" || t < 0 || Rm(t))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
    ey = t;
  }
});
cr.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
cr.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || Rm(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function Tm(t) {
  return t._maxListeners === void 0 ? cr.defaultMaxListeners : t._maxListeners;
}
cr.prototype.getMaxListeners = function() {
  return Tm(this);
};
cr.prototype.emit = function(e) {
  for (var r = [], n = 1; n < arguments.length; n++)
    r.push(arguments[n]);
  var i = e === "error", o = this._events;
  if (o !== void 0)
    i = i && o.error === void 0;
  else if (!i)
    return !1;
  if (i) {
    var a;
    if (r.length > 0 && (a = r[0]), a instanceof Error)
      throw a;
    var s = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
    throw s.context = a, s;
  }
  var f = o[e];
  if (f === void 0)
    return !1;
  if (typeof f == "function")
    Q1(f, this, r);
  else
    for (var u = f.length, c = Nm(f, u), n = 0; n < u; ++n)
      Q1(c[n], this, r);
  return !0;
};
function Om(t, e, r, n) {
  var i, o, a;
  if (Nu(r), o = t._events, o === void 0 ? (o = t._events = /* @__PURE__ */ Object.create(null), t._eventsCount = 0) : (o.newListener !== void 0 && (t.emit(
    "newListener",
    e,
    r.listener ? r.listener : r
  ), o = t._events), a = o[e]), a === void 0)
    a = o[e] = r, ++t._eventsCount;
  else if (typeof a == "function" ? a = o[e] = n ? [r, a] : [a, r] : n ? a.unshift(r) : a.push(r), i = Tm(t), i > 0 && a.length > i && !a.warned) {
    a.warned = !0;
    var s = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    s.name = "MaxListenersExceededWarning", s.emitter = t, s.type = e, s.count = a.length, L8(s);
  }
  return t;
}
cr.prototype.addListener = function(e, r) {
  return Om(this, e, r, !1);
};
cr.prototype.on = cr.prototype.addListener;
cr.prototype.prependListener = function(e, r) {
  return Om(this, e, r, !0);
};
function j8() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function km(t, e, r) {
  var n = { fired: !1, wrapFn: void 0, target: t, type: e, listener: r }, i = j8.bind(n);
  return i.listener = r, n.wrapFn = i, i;
}
cr.prototype.once = function(e, r) {
  return Nu(r), this.on(e, km(this, e, r)), this;
};
cr.prototype.prependOnceListener = function(e, r) {
  return Nu(r), this.prependListener(e, km(this, e, r)), this;
};
cr.prototype.removeListener = function(e, r) {
  var n, i, o, a, s;
  if (Nu(r), i = this._events, i === void 0)
    return this;
  if (n = i[e], n === void 0)
    return this;
  if (n === r || n.listener === r)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[e], i.removeListener && this.emit("removeListener", e, n.listener || r));
  else if (typeof n != "function") {
    for (o = -1, a = n.length - 1; a >= 0; a--)
      if (n[a] === r || n[a].listener === r) {
        s = n[a].listener, o = a;
        break;
      }
    if (o < 0)
      return this;
    o === 0 ? n.shift() : D8(n, o), n.length === 1 && (i[e] = n[0]), i.removeListener !== void 0 && this.emit("removeListener", e, s || r);
  }
  return this;
};
cr.prototype.off = cr.prototype.removeListener;
cr.prototype.removeAllListeners = function(e) {
  var r, n, i;
  if (n = this._events, n === void 0)
    return this;
  if (n.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : n[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete n[e]), this;
  if (arguments.length === 0) {
    var o = Object.keys(n), a;
    for (i = 0; i < o.length; ++i)
      a = o[i], a !== "removeListener" && this.removeAllListeners(a);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (r = n[e], typeof r == "function")
    this.removeListener(e, r);
  else if (r !== void 0)
    for (i = r.length - 1; i >= 0; i--)
      this.removeListener(e, r[i]);
  return this;
};
function Cm(t, e, r) {
  var n = t._events;
  if (n === void 0)
    return [];
  var i = n[e];
  return i === void 0 ? [] : typeof i == "function" ? r ? [i.listener || i] : [i] : r ? $8(i) : Nm(i, i.length);
}
cr.prototype.listeners = function(e) {
  return Cm(this, e, !0);
};
cr.prototype.rawListeners = function(e) {
  return Cm(this, e, !1);
};
cr.listenerCount = function(t, e) {
  return typeof t.listenerCount == "function" ? t.listenerCount(e) : Pm.call(t, e);
};
cr.prototype.listenerCount = Pm;
function Pm(t) {
  var e = this._events;
  if (e !== void 0) {
    var r = e[t];
    if (typeof r == "function")
      return 1;
    if (r !== void 0)
      return r.length;
  }
  return 0;
}
cr.prototype.eventNames = function() {
  return this._eventsCount > 0 ? pc(this._events) : [];
};
function Nm(t, e) {
  for (var r = new Array(e), n = 0; n < e; ++n)
    r[n] = t[n];
  return r;
}
function D8(t, e) {
  for (; e + 1 < t.length; e++)
    t[e] = t[e + 1];
  t.pop();
}
function $8(t) {
  for (var e = new Array(t.length), r = 0; r < e.length; ++r)
    e[r] = t[r].listener || t[r];
  return e;
}
function q8(t, e) {
  return new Promise(function(r, n) {
    function i(a) {
      t.removeListener(e, o), n(a);
    }
    function o() {
      typeof t.removeListener == "function" && t.removeListener("error", i), r([].slice.call(arguments));
    }
    Um(t, e, o, { once: !0 }), e !== "error" && z8(t, i, { once: !0 });
  });
}
function z8(t, e, r) {
  typeof t.on == "function" && Um(t, "error", e, r);
}
function Um(t, e, r, n) {
  if (typeof t.on == "function")
    n.once ? t.once(e, r) : t.on(e, r);
  else if (typeof t.addEventListener == "function")
    t.addEventListener(e, function i(o) {
      n.once && t.removeEventListener(e, i), r(o);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof t);
}
var xp = wp.exports, Fm = xp.EventEmitter;
const K8 = {}, W8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: K8
}, Symbol.toStringTag, { value: "Module" })), _p = /* @__PURE__ */ _f(W8);
var Od, ty;
function H8() {
  if (ty)
    return Od;
  ty = 1;
  function t(y, b) {
    var w = Object.keys(y);
    if (Object.getOwnPropertySymbols) {
      var A = Object.getOwnPropertySymbols(y);
      b && (A = A.filter(function(M) {
        return Object.getOwnPropertyDescriptor(y, M).enumerable;
      })), w.push.apply(w, A);
    }
    return w;
  }
  function e(y) {
    for (var b = 1; b < arguments.length; b++) {
      var w = arguments[b] != null ? arguments[b] : {};
      b % 2 ? t(Object(w), !0).forEach(function(A) {
        r(y, A, w[A]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(w)) : t(Object(w)).forEach(function(A) {
        Object.defineProperty(y, A, Object.getOwnPropertyDescriptor(w, A));
      });
    }
    return y;
  }
  function r(y, b, w) {
    return b = a(b), b in y ? Object.defineProperty(y, b, { value: w, enumerable: !0, configurable: !0, writable: !0 }) : y[b] = w, y;
  }
  function n(y, b) {
    if (!(y instanceof b))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(y, b) {
    for (var w = 0; w < b.length; w++) {
      var A = b[w];
      A.enumerable = A.enumerable || !1, A.configurable = !0, "value" in A && (A.writable = !0), Object.defineProperty(y, a(A.key), A);
    }
  }
  function o(y, b, w) {
    return b && i(y.prototype, b), w && i(y, w), Object.defineProperty(y, "prototype", { writable: !1 }), y;
  }
  function a(y) {
    var b = s(y, "string");
    return typeof b == "symbol" ? b : String(b);
  }
  function s(y, b) {
    if (typeof y != "object" || y === null)
      return y;
    var w = y[Symbol.toPrimitive];
    if (w !== void 0) {
      var A = w.call(y, b || "default");
      if (typeof A != "object")
        return A;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (b === "string" ? String : Number)(y);
  }
  var f = mt, u = f.Buffer, c = _p, d = c.inspect, l = d && d.custom || "inspect";
  function h(y, b, w) {
    u.prototype.copy.call(y, b, w);
  }
  return Od = /* @__PURE__ */ function() {
    function y() {
      n(this, y), this.head = null, this.tail = null, this.length = 0;
    }
    return o(y, [{
      key: "push",
      value: function(w) {
        var A = {
          data: w,
          next: null
        };
        this.length > 0 ? this.tail.next = A : this.head = A, this.tail = A, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(w) {
        var A = {
          data: w,
          next: this.head
        };
        this.length === 0 && (this.tail = A), this.head = A, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var w = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, w;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(w) {
        if (this.length === 0)
          return "";
        for (var A = this.head, M = "" + A.data; A = A.next; )
          M += w + A.data;
        return M;
      }
    }, {
      key: "concat",
      value: function(w) {
        if (this.length === 0)
          return u.alloc(0);
        for (var A = u.allocUnsafe(w >>> 0), M = this.head, N = 0; M; )
          h(M.data, A, N), N += M.data.length, M = M.next;
        return A;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(w, A) {
        var M;
        return w < this.head.data.length ? (M = this.head.data.slice(0, w), this.head.data = this.head.data.slice(w)) : w === this.head.data.length ? M = this.shift() : M = A ? this._getString(w) : this._getBuffer(w), M;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(w) {
        var A = this.head, M = 1, N = A.data;
        for (w -= N.length; A = A.next; ) {
          var G = A.data, z = w > G.length ? G.length : w;
          if (z === G.length ? N += G : N += G.slice(0, w), w -= z, w === 0) {
            z === G.length ? (++M, A.next ? this.head = A.next : this.head = this.tail = null) : (this.head = A, A.data = G.slice(z));
            break;
          }
          ++M;
        }
        return this.length -= M, N;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(w) {
        var A = u.allocUnsafe(w), M = this.head, N = 1;
        for (M.data.copy(A), w -= M.data.length; M = M.next; ) {
          var G = M.data, z = w > G.length ? G.length : w;
          if (G.copy(A, A.length - w, 0, z), w -= z, w === 0) {
            z === G.length ? (++N, M.next ? this.head = M.next : this.head = this.tail = null) : (this.head = M, M.data = G.slice(z));
            break;
          }
          ++N;
        }
        return this.length -= N, A;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: l,
      value: function(w, A) {
        return d(this, e(e({}, A), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), y;
  }(), Od;
}
function G8(t, e) {
  var r = this, n = this._readableState && this._readableState.destroyed, i = this._writableState && this._writableState.destroyed;
  return n || i ? (e ? e(t) : t && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, Ye.nextTick(B0, this, t)) : Ye.nextTick(B0, this, t)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function(o) {
    !e && o ? r._writableState ? r._writableState.errorEmitted ? Ye.nextTick(yc, r) : (r._writableState.errorEmitted = !0, Ye.nextTick(ry, r, o)) : Ye.nextTick(ry, r, o) : e ? (Ye.nextTick(yc, r), e(o)) : Ye.nextTick(yc, r);
  }), this);
}
function ry(t, e) {
  B0(t, e), yc(t);
}
function yc(t) {
  t._writableState && !t._writableState.emitClose || t._readableState && !t._readableState.emitClose || t.emit("close");
}
function V8() {
  this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
}
function B0(t, e) {
  t.emit("error", e);
}
function Y8(t, e) {
  var r = t._readableState, n = t._writableState;
  r && r.autoDestroy || n && n.autoDestroy ? t.destroy(e) : t.emit("error", e);
}
var Lm = {
  destroy: G8,
  undestroy: V8,
  errorOrDestroy: Y8
}, Go = {};
function J8(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
var jm = {};
function Gn(t, e, r) {
  r || (r = Error);
  function n(o, a, s) {
    return typeof e == "string" ? e : e(o, a, s);
  }
  var i = /* @__PURE__ */ function(o) {
    J8(a, o);
    function a(s, f, u) {
      return o.call(this, n(s, f, u)) || this;
    }
    return a;
  }(r);
  i.prototype.name = r.name, i.prototype.code = t, jm[t] = i;
}
function ny(t, e) {
  if (Array.isArray(t)) {
    var r = t.length;
    return t = t.map(function(n) {
      return String(n);
    }), r > 2 ? "one of ".concat(e, " ").concat(t.slice(0, r - 1).join(", "), ", or ") + t[r - 1] : r === 2 ? "one of ".concat(e, " ").concat(t[0], " or ").concat(t[1]) : "of ".concat(e, " ").concat(t[0]);
  } else
    return "of ".concat(e, " ").concat(String(t));
}
function X8(t, e, r) {
  return t.substr(!r || r < 0 ? 0 : +r, e.length) === e;
}
function Z8(t, e, r) {
  return (r === void 0 || r > t.length) && (r = t.length), t.substring(r - e.length, r) === e;
}
function Q8(t, e, r) {
  return typeof r != "number" && (r = 0), r + e.length > t.length ? !1 : t.indexOf(e, r) !== -1;
}
Gn("ERR_INVALID_OPT_VALUE", function(t, e) {
  return 'The value "' + e + '" is invalid for option "' + t + '"';
}, TypeError);
Gn("ERR_INVALID_ARG_TYPE", function(t, e, r) {
  var n;
  typeof e == "string" && X8(e, "not ") ? (n = "must not be", e = e.replace(/^not /, "")) : n = "must be";
  var i;
  if (Z8(t, " argument"))
    i = "The ".concat(t, " ").concat(n, " ").concat(ny(e, "type"));
  else {
    var o = Q8(t, ".") ? "property" : "argument";
    i = 'The "'.concat(t, '" ').concat(o, " ").concat(n, " ").concat(ny(e, "type"));
  }
  return i += ". Received type ".concat(typeof r), i;
}, TypeError);
Gn("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
Gn("ERR_METHOD_NOT_IMPLEMENTED", function(t) {
  return "The " + t + " method is not implemented";
});
Gn("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
Gn("ERR_STREAM_DESTROYED", function(t) {
  return "Cannot call " + t + " after a stream was destroyed";
});
Gn("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
Gn("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
Gn("ERR_STREAM_WRITE_AFTER_END", "write after end");
Gn("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
Gn("ERR_UNKNOWN_ENCODING", function(t) {
  return "Unknown encoding: " + t;
}, TypeError);
Gn("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
Go.codes = jm;
var e5 = Go.codes.ERR_INVALID_OPT_VALUE;
function t5(t, e, r) {
  return t.highWaterMark != null ? t.highWaterMark : e ? t[r] : null;
}
function r5(t, e, r, n) {
  var i = t5(e, n, r);
  if (i != null) {
    if (!(isFinite(i) && Math.floor(i) === i) || i < 0) {
      var o = n ? r : "highWaterMark";
      throw new e5(o, i);
    }
    return Math.floor(i);
  }
  return t.objectMode ? 16 : 16 * 1024;
}
var Dm = {
  getHighWaterMark: r5
}, n5 = i5;
function i5(t, e) {
  if (kd("noDeprecation"))
    return t;
  var r = !1;
  function n() {
    if (!r) {
      if (kd("throwDeprecation"))
        throw new Error(e);
      kd("traceDeprecation") ? console.trace(e) : console.warn(e), r = !0;
    }
    return t.apply(this, arguments);
  }
  return n;
}
function kd(t) {
  try {
    if (!yt.localStorage)
      return !1;
  } catch {
    return !1;
  }
  var e = yt.localStorage[t];
  return e == null ? !1 : String(e).toLowerCase() === "true";
}
var Cd, iy;
function Ep() {
  if (iy)
    return Cd;
  iy = 1, Cd = ee;
  function t(V) {
    var $ = this;
    this.next = null, this.entry = null, this.finish = function() {
      re($, V);
    };
  }
  var e;
  ee.WritableState = J;
  var r = {
    deprecate: n5
  }, n = Fm, i = mt.Buffer, o = (typeof yt < "u" ? yt : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function a(V) {
    return i.from(V);
  }
  function s(V) {
    return i.isBuffer(V) || V instanceof o;
  }
  var f = Lm, u = Dm, c = u.getHighWaterMark, d = Go.codes, l = d.ERR_INVALID_ARG_TYPE, h = d.ERR_METHOD_NOT_IMPLEMENTED, y = d.ERR_MULTIPLE_CALLBACK, b = d.ERR_STREAM_CANNOT_PIPE, w = d.ERR_STREAM_DESTROYED, A = d.ERR_STREAM_NULL_VALUES, M = d.ERR_STREAM_WRITE_AFTER_END, N = d.ERR_UNKNOWN_ENCODING, G = f.errorOrDestroy;
  Mt(ee, n);
  function z() {
  }
  function J(V, $, W) {
    e = e || Lo(), V = V || {}, typeof W != "boolean" && (W = $ instanceof e), this.objectMode = !!V.objectMode, W && (this.objectMode = this.objectMode || !!V.writableObjectMode), this.highWaterMark = c(this, V, "writableHighWaterMark", W), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var Z = V.decodeStrings === !1;
    this.decodeStrings = !Z, this.defaultEncoding = V.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(fe) {
      P($, fe);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = V.emitClose !== !1, this.autoDestroy = !!V.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  J.prototype.getBuffer = function() {
    for (var $ = this.bufferedRequest, W = []; $; )
      W.push($), $ = $.next;
    return W;
  }, function() {
    try {
      Object.defineProperty(J.prototype, "buffer", {
        get: r.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var oe;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (oe = Function.prototype[Symbol.hasInstance], Object.defineProperty(ee, Symbol.hasInstance, {
    value: function($) {
      return oe.call(this, $) ? !0 : this !== ee ? !1 : $ && $._writableState instanceof J;
    }
  })) : oe = function($) {
    return $ instanceof this;
  };
  function ee(V) {
    e = e || Lo();
    var $ = this instanceof e;
    if (!$ && !oe.call(ee, this))
      return new ee(V);
    this._writableState = new J(V, this, $), this.writable = !0, V && (typeof V.write == "function" && (this._write = V.write), typeof V.writev == "function" && (this._writev = V.writev), typeof V.destroy == "function" && (this._destroy = V.destroy), typeof V.final == "function" && (this._final = V.final)), n.call(this);
  }
  ee.prototype.pipe = function() {
    G(this, new b());
  };
  function ae(V, $) {
    var W = new M();
    G(V, W), Ye.nextTick($, W);
  }
  function ye(V, $, W, Z) {
    var fe;
    return W === null ? fe = new A() : typeof W != "string" && !$.objectMode && (fe = new l("chunk", ["string", "Buffer"], W)), fe ? (G(V, fe), Ye.nextTick(Z, fe), !1) : !0;
  }
  ee.prototype.write = function(V, $, W) {
    var Z = this._writableState, fe = !1, D = !Z.objectMode && s(V);
    return D && !i.isBuffer(V) && (V = a(V)), typeof $ == "function" && (W = $, $ = null), D ? $ = "buffer" : $ || ($ = Z.defaultEncoding), typeof W != "function" && (W = z), Z.ending ? ae(this, W) : (D || ye(this, Z, V, W)) && (Z.pendingcb++, fe = te(this, Z, D, V, $, W)), fe;
  }, ee.prototype.cork = function() {
    this._writableState.corked++;
  }, ee.prototype.uncork = function() {
    var V = this._writableState;
    V.corked && (V.corked--, !V.writing && !V.corked && !V.bufferProcessing && V.bufferedRequest && C(this, V));
  }, ee.prototype.setDefaultEncoding = function($) {
    if (typeof $ == "string" && ($ = $.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf(($ + "").toLowerCase()) > -1))
      throw new N($);
    return this._writableState.defaultEncoding = $, this;
  }, Object.defineProperty(ee.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function pe(V, $, W) {
    return !V.objectMode && V.decodeStrings !== !1 && typeof $ == "string" && ($ = i.from($, W)), $;
  }
  Object.defineProperty(ee.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function te(V, $, W, Z, fe, D) {
    if (!W) {
      var K = pe($, Z, fe);
      Z !== K && (W = !0, fe = "buffer", Z = K);
    }
    var he = $.objectMode ? 1 : Z.length;
    $.length += he;
    var be = $.length < $.highWaterMark;
    if (be || ($.needDrain = !0), $.writing || $.corked) {
      var Ce = $.lastBufferedRequest;
      $.lastBufferedRequest = {
        chunk: Z,
        encoding: fe,
        isBuf: W,
        callback: D,
        next: null
      }, Ce ? Ce.next = $.lastBufferedRequest : $.bufferedRequest = $.lastBufferedRequest, $.bufferedRequestCount += 1;
    } else
      F(V, $, !1, he, Z, fe, D);
    return be;
  }
  function F(V, $, W, Z, fe, D, K) {
    $.writelen = Z, $.writecb = K, $.writing = !0, $.sync = !0, $.destroyed ? $.onwrite(new w("write")) : W ? V._writev(fe, $.onwrite) : V._write(fe, D, $.onwrite), $.sync = !1;
  }
  function v(V, $, W, Z, fe) {
    --$.pendingcb, W ? (Ye.nextTick(fe, Z), Ye.nextTick(R, V, $), V._writableState.errorEmitted = !0, G(V, Z)) : (fe(Z), V._writableState.errorEmitted = !0, G(V, Z), R(V, $));
  }
  function B(V) {
    V.writing = !1, V.writecb = null, V.length -= V.writelen, V.writelen = 0;
  }
  function P(V, $) {
    var W = V._writableState, Z = W.sync, fe = W.writecb;
    if (typeof fe != "function")
      throw new y();
    if (B(W), $)
      v(V, W, Z, $, fe);
    else {
      var D = j(W) || V.destroyed;
      !D && !W.corked && !W.bufferProcessing && W.bufferedRequest && C(V, W), Z ? Ye.nextTick(L, V, W, D, fe) : L(V, W, D, fe);
    }
  }
  function L(V, $, W, Z) {
    W || x(V, $), $.pendingcb--, Z(), R(V, $);
  }
  function x(V, $) {
    $.length === 0 && $.needDrain && ($.needDrain = !1, V.emit("drain"));
  }
  function C(V, $) {
    $.bufferProcessing = !0;
    var W = $.bufferedRequest;
    if (V._writev && W && W.next) {
      var Z = $.bufferedRequestCount, fe = new Array(Z), D = $.corkedRequestsFree;
      D.entry = W;
      for (var K = 0, he = !0; W; )
        fe[K] = W, W.isBuf || (he = !1), W = W.next, K += 1;
      fe.allBuffers = he, F(V, $, !0, $.length, fe, "", D.finish), $.pendingcb++, $.lastBufferedRequest = null, D.next ? ($.corkedRequestsFree = D.next, D.next = null) : $.corkedRequestsFree = new t($), $.bufferedRequestCount = 0;
    } else {
      for (; W; ) {
        var be = W.chunk, Ce = W.encoding, je = W.callback, Ue = $.objectMode ? 1 : be.length;
        if (F(V, $, !1, Ue, be, Ce, je), W = W.next, $.bufferedRequestCount--, $.writing)
          break;
      }
      W === null && ($.lastBufferedRequest = null);
    }
    $.bufferedRequest = W, $.bufferProcessing = !1;
  }
  ee.prototype._write = function(V, $, W) {
    W(new h("_write()"));
  }, ee.prototype._writev = null, ee.prototype.end = function(V, $, W) {
    var Z = this._writableState;
    return typeof V == "function" ? (W = V, V = null, $ = null) : typeof $ == "function" && (W = $, $ = null), V != null && this.write(V, $), Z.corked && (Z.corked = 1, this.uncork()), Z.ending || X(this, Z, W), this;
  }, Object.defineProperty(ee.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function j(V) {
    return V.ending && V.length === 0 && V.bufferedRequest === null && !V.finished && !V.writing;
  }
  function k(V, $) {
    V._final(function(W) {
      $.pendingcb--, W && G(V, W), $.prefinished = !0, V.emit("prefinish"), R(V, $);
    });
  }
  function g(V, $) {
    !$.prefinished && !$.finalCalled && (typeof V._final == "function" && !$.destroyed ? ($.pendingcb++, $.finalCalled = !0, Ye.nextTick(k, V, $)) : ($.prefinished = !0, V.emit("prefinish")));
  }
  function R(V, $) {
    var W = j($);
    if (W && (g(V, $), $.pendingcb === 0 && ($.finished = !0, V.emit("finish"), $.autoDestroy))) {
      var Z = V._readableState;
      (!Z || Z.autoDestroy && Z.endEmitted) && V.destroy();
    }
    return W;
  }
  function X(V, $, W) {
    $.ending = !0, R(V, $), W && ($.finished ? Ye.nextTick(W) : V.once("finish", W)), $.ended = !0, V.writable = !1;
  }
  function re(V, $, W) {
    var Z = V.entry;
    for (V.entry = null; Z; ) {
      var fe = Z.callback;
      $.pendingcb--, fe(W), Z = Z.next;
    }
    $.corkedRequestsFree.next = V;
  }
  return Object.defineProperty(ee.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function($) {
      this._writableState && (this._writableState.destroyed = $);
    }
  }), ee.prototype.destroy = f.destroy, ee.prototype._undestroy = f.undestroy, ee.prototype._destroy = function(V, $) {
    $(V);
  }, Cd;
}
var Pd, oy;
function Lo() {
  if (oy)
    return Pd;
  oy = 1;
  var t = Object.keys || function(u) {
    var c = [];
    for (var d in u)
      c.push(d);
    return c;
  };
  Pd = a;
  var e = Ap(), r = Ep();
  Mt(a, e);
  for (var n = t(r.prototype), i = 0; i < n.length; i++) {
    var o = n[i];
    a.prototype[o] || (a.prototype[o] = r.prototype[o]);
  }
  function a(u) {
    if (!(this instanceof a))
      return new a(u);
    e.call(this, u), r.call(this, u), this.allowHalfOpen = !0, u && (u.readable === !1 && (this.readable = !1), u.writable === !1 && (this.writable = !1), u.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", s)));
  }
  Object.defineProperty(a.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(a.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(a.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function s() {
    this._writableState.ended || Ye.nextTick(f, this);
  }
  function f(u) {
    u.end();
  }
  return Object.defineProperty(a.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(c) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = c, this._writableState.destroyed = c);
    }
  }), Pd;
}
var Oc = {}, Sp = Et.Buffer, ay = Sp.isEncoding || function(t) {
  switch (t = "" + t, t && t.toLowerCase()) {
    case "hex":
    case "utf8":
    case "utf-8":
    case "ascii":
    case "binary":
    case "base64":
    case "ucs2":
    case "ucs-2":
    case "utf16le":
    case "utf-16le":
    case "raw":
      return !0;
    default:
      return !1;
  }
};
function o5(t) {
  if (!t)
    return "utf8";
  for (var e; ; )
    switch (t) {
      case "utf8":
      case "utf-8":
        return "utf8";
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return "utf16le";
      case "latin1":
      case "binary":
        return "latin1";
      case "base64":
      case "ascii":
      case "hex":
        return t;
      default:
        if (e)
          return;
        t = ("" + t).toLowerCase(), e = !0;
    }
}
function a5(t) {
  var e = o5(t);
  if (typeof e != "string" && (Sp.isEncoding === ay || !ay(t)))
    throw new Error("Unknown encoding: " + t);
  return e || t;
}
Oc.StringDecoder = Ef;
function Ef(t) {
  this.encoding = a5(t);
  var e;
  switch (this.encoding) {
    case "utf16le":
      this.text = l5, this.end = h5, e = 4;
      break;
    case "utf8":
      this.fillLast = c5, e = 4;
      break;
    case "base64":
      this.text = p5, this.end = y5, e = 3;
      break;
    default:
      this.write = b5, this.end = g5;
      return;
  }
  this.lastNeed = 0, this.lastTotal = 0, this.lastChar = Sp.allocUnsafe(e);
}
Ef.prototype.write = function(t) {
  if (t.length === 0)
    return "";
  var e, r;
  if (this.lastNeed) {
    if (e = this.fillLast(t), e === void 0)
      return "";
    r = this.lastNeed, this.lastNeed = 0;
  } else
    r = 0;
  return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
};
Ef.prototype.end = d5;
Ef.prototype.text = u5;
Ef.prototype.fillLast = function(t) {
  if (this.lastNeed <= t.length)
    return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
};
function Nd(t) {
  return t <= 127 ? 0 : t >> 5 === 6 ? 2 : t >> 4 === 14 ? 3 : t >> 3 === 30 ? 4 : t >> 6 === 2 ? -1 : -2;
}
function s5(t, e, r) {
  var n = e.length - 1;
  if (n < r)
    return 0;
  var i = Nd(e[n]);
  return i >= 0 ? (i > 0 && (t.lastNeed = i - 1), i) : --n < r || i === -2 ? 0 : (i = Nd(e[n]), i >= 0 ? (i > 0 && (t.lastNeed = i - 2), i) : --n < r || i === -2 ? 0 : (i = Nd(e[n]), i >= 0 ? (i > 0 && (i === 2 ? i = 0 : t.lastNeed = i - 3), i) : 0));
}
function f5(t, e, r) {
  if ((e[0] & 192) !== 128)
    return t.lastNeed = 0, "�";
  if (t.lastNeed > 1 && e.length > 1) {
    if ((e[1] & 192) !== 128)
      return t.lastNeed = 1, "�";
    if (t.lastNeed > 2 && e.length > 2 && (e[2] & 192) !== 128)
      return t.lastNeed = 2, "�";
  }
}
function c5(t) {
  var e = this.lastTotal - this.lastNeed, r = f5(this, t);
  if (r !== void 0)
    return r;
  if (this.lastNeed <= t.length)
    return t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
  t.copy(this.lastChar, e, 0, t.length), this.lastNeed -= t.length;
}
function u5(t, e) {
  var r = s5(this, t, e);
  if (!this.lastNeed)
    return t.toString("utf8", e);
  this.lastTotal = r;
  var n = t.length - (r - this.lastNeed);
  return t.copy(this.lastChar, 0, n), t.toString("utf8", e, n);
}
function d5(t) {
  var e = t && t.length ? this.write(t) : "";
  return this.lastNeed ? e + "�" : e;
}
function l5(t, e) {
  if ((t.length - e) % 2 === 0) {
    var r = t.toString("utf16le", e);
    if (r) {
      var n = r.charCodeAt(r.length - 1);
      if (n >= 55296 && n <= 56319)
        return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
    }
    return r;
  }
  return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
}
function h5(t) {
  var e = t && t.length ? this.write(t) : "";
  if (this.lastNeed) {
    var r = this.lastTotal - this.lastNeed;
    return e + this.lastChar.toString("utf16le", 0, r);
  }
  return e;
}
function p5(t, e) {
  var r = (t.length - e) % 3;
  return r === 0 ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, r === 1 ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
}
function y5(t) {
  var e = t && t.length ? this.write(t) : "";
  return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
}
function b5(t) {
  return t.toString(this.encoding);
}
function g5(t) {
  return t && t.length ? this.write(t) : "";
}
var sy = Go.codes.ERR_STREAM_PREMATURE_CLOSE;
function v5(t) {
  var e = !1;
  return function() {
    if (!e) {
      e = !0;
      for (var r = arguments.length, n = new Array(r), i = 0; i < r; i++)
        n[i] = arguments[i];
      t.apply(this, n);
    }
  };
}
function m5() {
}
function w5(t) {
  return t.setHeader && typeof t.abort == "function";
}
function $m(t, e, r) {
  if (typeof e == "function")
    return $m(t, null, e);
  e || (e = {}), r = v5(r || m5);
  var n = e.readable || e.readable !== !1 && t.readable, i = e.writable || e.writable !== !1 && t.writable, o = function() {
    t.writable || s();
  }, a = t._writableState && t._writableState.finished, s = function() {
    i = !1, a = !0, n || r.call(t);
  }, f = t._readableState && t._readableState.endEmitted, u = function() {
    n = !1, f = !0, i || r.call(t);
  }, c = function(y) {
    r.call(t, y);
  }, d = function() {
    var y;
    if (n && !f)
      return (!t._readableState || !t._readableState.ended) && (y = new sy()), r.call(t, y);
    if (i && !a)
      return (!t._writableState || !t._writableState.ended) && (y = new sy()), r.call(t, y);
  }, l = function() {
    t.req.on("finish", s);
  };
  return w5(t) ? (t.on("complete", s), t.on("abort", d), t.req ? l() : t.on("request", l)) : i && !t._writableState && (t.on("end", o), t.on("close", o)), t.on("end", u), t.on("finish", s), e.error !== !1 && t.on("error", c), t.on("close", d), function() {
    t.removeListener("complete", s), t.removeListener("abort", d), t.removeListener("request", l), t.req && t.req.removeListener("finish", s), t.removeListener("end", o), t.removeListener("close", o), t.removeListener("finish", s), t.removeListener("end", u), t.removeListener("error", c), t.removeListener("close", d);
  };
}
var Uu = $m, Ud, fy;
function x5() {
  if (fy)
    return Ud;
  fy = 1;
  var t;
  function e(N, G, z) {
    return G = r(G), G in N ? Object.defineProperty(N, G, { value: z, enumerable: !0, configurable: !0, writable: !0 }) : N[G] = z, N;
  }
  function r(N) {
    var G = n(N, "string");
    return typeof G == "symbol" ? G : String(G);
  }
  function n(N, G) {
    if (typeof N != "object" || N === null)
      return N;
    var z = N[Symbol.toPrimitive];
    if (z !== void 0) {
      var J = z.call(N, G || "default");
      if (typeof J != "object")
        return J;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (G === "string" ? String : Number)(N);
  }
  var i = Uu, o = Symbol("lastResolve"), a = Symbol("lastReject"), s = Symbol("error"), f = Symbol("ended"), u = Symbol("lastPromise"), c = Symbol("handlePromise"), d = Symbol("stream");
  function l(N, G) {
    return {
      value: N,
      done: G
    };
  }
  function h(N) {
    var G = N[o];
    if (G !== null) {
      var z = N[d].read();
      z !== null && (N[u] = null, N[o] = null, N[a] = null, G(l(z, !1)));
    }
  }
  function y(N) {
    Ye.nextTick(h, N);
  }
  function b(N, G) {
    return function(z, J) {
      N.then(function() {
        if (G[f]) {
          z(l(void 0, !0));
          return;
        }
        G[c](z, J);
      }, J);
    };
  }
  var w = Object.getPrototypeOf(function() {
  }), A = Object.setPrototypeOf((t = {
    get stream() {
      return this[d];
    },
    next: function() {
      var G = this, z = this[s];
      if (z !== null)
        return Promise.reject(z);
      if (this[f])
        return Promise.resolve(l(void 0, !0));
      if (this[d].destroyed)
        return new Promise(function(ae, ye) {
          Ye.nextTick(function() {
            G[s] ? ye(G[s]) : ae(l(void 0, !0));
          });
        });
      var J = this[u], oe;
      if (J)
        oe = new Promise(b(J, this));
      else {
        var ee = this[d].read();
        if (ee !== null)
          return Promise.resolve(l(ee, !1));
        oe = new Promise(this[c]);
      }
      return this[u] = oe, oe;
    }
  }, e(t, Symbol.asyncIterator, function() {
    return this;
  }), e(t, "return", function() {
    var G = this;
    return new Promise(function(z, J) {
      G[d].destroy(null, function(oe) {
        if (oe) {
          J(oe);
          return;
        }
        z(l(void 0, !0));
      });
    });
  }), t), w), M = function(G) {
    var z, J = Object.create(A, (z = {}, e(z, d, {
      value: G,
      writable: !0
    }), e(z, o, {
      value: null,
      writable: !0
    }), e(z, a, {
      value: null,
      writable: !0
    }), e(z, s, {
      value: null,
      writable: !0
    }), e(z, f, {
      value: G._readableState.endEmitted,
      writable: !0
    }), e(z, c, {
      value: function(ee, ae) {
        var ye = J[d].read();
        ye ? (J[u] = null, J[o] = null, J[a] = null, ee(l(ye, !1))) : (J[o] = ee, J[a] = ae);
      },
      writable: !0
    }), z));
    return J[u] = null, i(G, function(oe) {
      if (oe && oe.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var ee = J[a];
        ee !== null && (J[u] = null, J[o] = null, J[a] = null, ee(oe)), J[s] = oe;
        return;
      }
      var ae = J[o];
      ae !== null && (J[u] = null, J[o] = null, J[a] = null, ae(l(void 0, !0))), J[f] = !0;
    }), G.on("readable", y.bind(null, J)), J;
  };
  return Ud = M, Ud;
}
var Fd, cy;
function _5() {
  return cy || (cy = 1, Fd = function() {
    throw new Error("Readable.from is not available in the browser");
  }), Fd;
}
var Ld, uy;
function Ap() {
  if (uy)
    return Ld;
  uy = 1, Ld = ae;
  var t;
  ae.ReadableState = ee, xp.EventEmitter;
  var e = function(K, he) {
    return K.listeners(he).length;
  }, r = Fm, n = mt.Buffer, i = (typeof yt < "u" ? yt : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function o(D) {
    return n.from(D);
  }
  function a(D) {
    return n.isBuffer(D) || D instanceof i;
  }
  var s = _p, f;
  s && s.debuglog ? f = s.debuglog("stream") : f = function() {
  };
  var u = H8(), c = Lm, d = Dm, l = d.getHighWaterMark, h = Go.codes, y = h.ERR_INVALID_ARG_TYPE, b = h.ERR_STREAM_PUSH_AFTER_EOF, w = h.ERR_METHOD_NOT_IMPLEMENTED, A = h.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, M, N, G;
  Mt(ae, r);
  var z = c.errorOrDestroy, J = ["error", "close", "destroy", "pause", "resume"];
  function oe(D, K, he) {
    if (typeof D.prependListener == "function")
      return D.prependListener(K, he);
    !D._events || !D._events[K] ? D.on(K, he) : Array.isArray(D._events[K]) ? D._events[K].unshift(he) : D._events[K] = [he, D._events[K]];
  }
  function ee(D, K, he) {
    t = t || Lo(), D = D || {}, typeof he != "boolean" && (he = K instanceof t), this.objectMode = !!D.objectMode, he && (this.objectMode = this.objectMode || !!D.readableObjectMode), this.highWaterMark = l(this, D, "readableHighWaterMark", he), this.buffer = new u(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = D.emitClose !== !1, this.autoDestroy = !!D.autoDestroy, this.destroyed = !1, this.defaultEncoding = D.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, D.encoding && (M || (M = Oc.StringDecoder), this.decoder = new M(D.encoding), this.encoding = D.encoding);
  }
  function ae(D) {
    if (t = t || Lo(), !(this instanceof ae))
      return new ae(D);
    var K = this instanceof t;
    this._readableState = new ee(D, this, K), this.readable = !0, D && (typeof D.read == "function" && (this._read = D.read), typeof D.destroy == "function" && (this._destroy = D.destroy)), r.call(this);
  }
  Object.defineProperty(ae.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(K) {
      this._readableState && (this._readableState.destroyed = K);
    }
  }), ae.prototype.destroy = c.destroy, ae.prototype._undestroy = c.undestroy, ae.prototype._destroy = function(D, K) {
    K(D);
  }, ae.prototype.push = function(D, K) {
    var he = this._readableState, be;
    return he.objectMode ? be = !0 : typeof D == "string" && (K = K || he.defaultEncoding, K !== he.encoding && (D = n.from(D, K), K = ""), be = !0), ye(this, D, K, !1, be);
  }, ae.prototype.unshift = function(D) {
    return ye(this, D, null, !0, !1);
  };
  function ye(D, K, he, be, Ce) {
    f("readableAddChunk", K);
    var je = D._readableState;
    if (K === null)
      je.reading = !1, P(D, je);
    else {
      var Ue;
      if (Ce || (Ue = te(je, K)), Ue)
        z(D, Ue);
      else if (je.objectMode || K && K.length > 0)
        if (typeof K != "string" && !je.objectMode && Object.getPrototypeOf(K) !== n.prototype && (K = o(K)), be)
          je.endEmitted ? z(D, new A()) : pe(D, je, K, !0);
        else if (je.ended)
          z(D, new b());
        else {
          if (je.destroyed)
            return !1;
          je.reading = !1, je.decoder && !he ? (K = je.decoder.write(K), je.objectMode || K.length !== 0 ? pe(D, je, K, !1) : C(D, je)) : pe(D, je, K, !1);
        }
      else
        be || (je.reading = !1, C(D, je));
    }
    return !je.ended && (je.length < je.highWaterMark || je.length === 0);
  }
  function pe(D, K, he, be) {
    K.flowing && K.length === 0 && !K.sync ? (K.awaitDrain = 0, D.emit("data", he)) : (K.length += K.objectMode ? 1 : he.length, be ? K.buffer.unshift(he) : K.buffer.push(he), K.needReadable && L(D)), C(D, K);
  }
  function te(D, K) {
    var he;
    return !a(K) && typeof K != "string" && K !== void 0 && !D.objectMode && (he = new y("chunk", ["string", "Buffer", "Uint8Array"], K)), he;
  }
  ae.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, ae.prototype.setEncoding = function(D) {
    M || (M = Oc.StringDecoder);
    var K = new M(D);
    this._readableState.decoder = K, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var he = this._readableState.buffer.head, be = ""; he !== null; )
      be += K.write(he.data), he = he.next;
    return this._readableState.buffer.clear(), be !== "" && this._readableState.buffer.push(be), this._readableState.length = be.length, this;
  };
  var F = 1073741824;
  function v(D) {
    return D >= F ? D = F : (D--, D |= D >>> 1, D |= D >>> 2, D |= D >>> 4, D |= D >>> 8, D |= D >>> 16, D++), D;
  }
  function B(D, K) {
    return D <= 0 || K.length === 0 && K.ended ? 0 : K.objectMode ? 1 : D !== D ? K.flowing && K.length ? K.buffer.head.data.length : K.length : (D > K.highWaterMark && (K.highWaterMark = v(D)), D <= K.length ? D : K.ended ? K.length : (K.needReadable = !0, 0));
  }
  ae.prototype.read = function(D) {
    f("read", D), D = parseInt(D, 10);
    var K = this._readableState, he = D;
    if (D !== 0 && (K.emittedReadable = !1), D === 0 && K.needReadable && ((K.highWaterMark !== 0 ? K.length >= K.highWaterMark : K.length > 0) || K.ended))
      return f("read: emitReadable", K.length, K.ended), K.length === 0 && K.ended ? W(this) : L(this), null;
    if (D = B(D, K), D === 0 && K.ended)
      return K.length === 0 && W(this), null;
    var be = K.needReadable;
    f("need readable", be), (K.length === 0 || K.length - D < K.highWaterMark) && (be = !0, f("length less than watermark", be)), K.ended || K.reading ? (be = !1, f("reading or ended", be)) : be && (f("do read"), K.reading = !0, K.sync = !0, K.length === 0 && (K.needReadable = !0), this._read(K.highWaterMark), K.sync = !1, K.reading || (D = B(he, K)));
    var Ce;
    return D > 0 ? Ce = $(D, K) : Ce = null, Ce === null ? (K.needReadable = K.length <= K.highWaterMark, D = 0) : (K.length -= D, K.awaitDrain = 0), K.length === 0 && (K.ended || (K.needReadable = !0), he !== D && K.ended && W(this)), Ce !== null && this.emit("data", Ce), Ce;
  };
  function P(D, K) {
    if (f("onEofChunk"), !K.ended) {
      if (K.decoder) {
        var he = K.decoder.end();
        he && he.length && (K.buffer.push(he), K.length += K.objectMode ? 1 : he.length);
      }
      K.ended = !0, K.sync ? L(D) : (K.needReadable = !1, K.emittedReadable || (K.emittedReadable = !0, x(D)));
    }
  }
  function L(D) {
    var K = D._readableState;
    f("emitReadable", K.needReadable, K.emittedReadable), K.needReadable = !1, K.emittedReadable || (f("emitReadable", K.flowing), K.emittedReadable = !0, Ye.nextTick(x, D));
  }
  function x(D) {
    var K = D._readableState;
    f("emitReadable_", K.destroyed, K.length, K.ended), !K.destroyed && (K.length || K.ended) && (D.emit("readable"), K.emittedReadable = !1), K.needReadable = !K.flowing && !K.ended && K.length <= K.highWaterMark, V(D);
  }
  function C(D, K) {
    K.readingMore || (K.readingMore = !0, Ye.nextTick(j, D, K));
  }
  function j(D, K) {
    for (; !K.reading && !K.ended && (K.length < K.highWaterMark || K.flowing && K.length === 0); ) {
      var he = K.length;
      if (f("maybeReadMore read 0"), D.read(0), he === K.length)
        break;
    }
    K.readingMore = !1;
  }
  ae.prototype._read = function(D) {
    z(this, new w("_read()"));
  }, ae.prototype.pipe = function(D, K) {
    var he = this, be = this._readableState;
    switch (be.pipesCount) {
      case 0:
        be.pipes = D;
        break;
      case 1:
        be.pipes = [be.pipes, D];
        break;
      default:
        be.pipes.push(D);
        break;
    }
    be.pipesCount += 1, f("pipe count=%d opts=%j", be.pipesCount, K);
    var Ce = (!K || K.end !== !1) && D !== Ye.stdout && D !== Ye.stderr, je = Ce ? Qe : Ee;
    be.endEmitted ? Ye.nextTick(je) : he.once("end", je), D.on("unpipe", Ue);
    function Ue(U, S) {
      f("onunpipe"), U === he && S && S.hasUnpiped === !1 && (S.hasUnpiped = !0, rt());
    }
    function Qe() {
      f("onend"), D.end();
    }
    var we = k(he);
    D.on("drain", we);
    var at = !1;
    function rt() {
      f("cleanup"), D.removeListener("close", se), D.removeListener("finish", ue), D.removeListener("drain", we), D.removeListener("error", it), D.removeListener("unpipe", Ue), he.removeListener("end", Qe), he.removeListener("end", Ee), he.removeListener("data", It), at = !0, be.awaitDrain && (!D._writableState || D._writableState.needDrain) && we();
    }
    he.on("data", It);
    function It(U) {
      f("ondata");
      var S = D.write(U);
      f("dest.write", S), S === !1 && ((be.pipesCount === 1 && be.pipes === D || be.pipesCount > 1 && fe(be.pipes, D) !== -1) && !at && (f("false write response, pause", be.awaitDrain), be.awaitDrain++), he.pause());
    }
    function it(U) {
      f("onerror", U), Ee(), D.removeListener("error", it), e(D, "error") === 0 && z(D, U);
    }
    oe(D, "error", it);
    function se() {
      D.removeListener("finish", ue), Ee();
    }
    D.once("close", se);
    function ue() {
      f("onfinish"), D.removeListener("close", se), Ee();
    }
    D.once("finish", ue);
    function Ee() {
      f("unpipe"), he.unpipe(D);
    }
    return D.emit("pipe", he), be.flowing || (f("pipe resume"), he.resume()), D;
  };
  function k(D) {
    return function() {
      var he = D._readableState;
      f("pipeOnDrain", he.awaitDrain), he.awaitDrain && he.awaitDrain--, he.awaitDrain === 0 && e(D, "data") && (he.flowing = !0, V(D));
    };
  }
  ae.prototype.unpipe = function(D) {
    var K = this._readableState, he = {
      hasUnpiped: !1
    };
    if (K.pipesCount === 0)
      return this;
    if (K.pipesCount === 1)
      return D && D !== K.pipes ? this : (D || (D = K.pipes), K.pipes = null, K.pipesCount = 0, K.flowing = !1, D && D.emit("unpipe", this, he), this);
    if (!D) {
      var be = K.pipes, Ce = K.pipesCount;
      K.pipes = null, K.pipesCount = 0, K.flowing = !1;
      for (var je = 0; je < Ce; je++)
        be[je].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var Ue = fe(K.pipes, D);
    return Ue === -1 ? this : (K.pipes.splice(Ue, 1), K.pipesCount -= 1, K.pipesCount === 1 && (K.pipes = K.pipes[0]), D.emit("unpipe", this, he), this);
  }, ae.prototype.on = function(D, K) {
    var he = r.prototype.on.call(this, D, K), be = this._readableState;
    return D === "data" ? (be.readableListening = this.listenerCount("readable") > 0, be.flowing !== !1 && this.resume()) : D === "readable" && !be.endEmitted && !be.readableListening && (be.readableListening = be.needReadable = !0, be.flowing = !1, be.emittedReadable = !1, f("on readable", be.length, be.reading), be.length ? L(this) : be.reading || Ye.nextTick(R, this)), he;
  }, ae.prototype.addListener = ae.prototype.on, ae.prototype.removeListener = function(D, K) {
    var he = r.prototype.removeListener.call(this, D, K);
    return D === "readable" && Ye.nextTick(g, this), he;
  }, ae.prototype.removeAllListeners = function(D) {
    var K = r.prototype.removeAllListeners.apply(this, arguments);
    return (D === "readable" || D === void 0) && Ye.nextTick(g, this), K;
  };
  function g(D) {
    var K = D._readableState;
    K.readableListening = D.listenerCount("readable") > 0, K.resumeScheduled && !K.paused ? K.flowing = !0 : D.listenerCount("data") > 0 && D.resume();
  }
  function R(D) {
    f("readable nexttick read 0"), D.read(0);
  }
  ae.prototype.resume = function() {
    var D = this._readableState;
    return D.flowing || (f("resume"), D.flowing = !D.readableListening, X(this, D)), D.paused = !1, this;
  };
  function X(D, K) {
    K.resumeScheduled || (K.resumeScheduled = !0, Ye.nextTick(re, D, K));
  }
  function re(D, K) {
    f("resume", K.reading), K.reading || D.read(0), K.resumeScheduled = !1, D.emit("resume"), V(D), K.flowing && !K.reading && D.read(0);
  }
  ae.prototype.pause = function() {
    return f("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (f("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function V(D) {
    var K = D._readableState;
    for (f("flow", K.flowing); K.flowing && D.read() !== null; )
      ;
  }
  ae.prototype.wrap = function(D) {
    var K = this, he = this._readableState, be = !1;
    D.on("end", function() {
      if (f("wrapped end"), he.decoder && !he.ended) {
        var Ue = he.decoder.end();
        Ue && Ue.length && K.push(Ue);
      }
      K.push(null);
    }), D.on("data", function(Ue) {
      if (f("wrapped data"), he.decoder && (Ue = he.decoder.write(Ue)), !(he.objectMode && Ue == null) && !(!he.objectMode && (!Ue || !Ue.length))) {
        var Qe = K.push(Ue);
        Qe || (be = !0, D.pause());
      }
    });
    for (var Ce in D)
      this[Ce] === void 0 && typeof D[Ce] == "function" && (this[Ce] = /* @__PURE__ */ function(Qe) {
        return function() {
          return D[Qe].apply(D, arguments);
        };
      }(Ce));
    for (var je = 0; je < J.length; je++)
      D.on(J[je], this.emit.bind(this, J[je]));
    return this._read = function(Ue) {
      f("wrapped _read", Ue), be && (be = !1, D.resume());
    }, this;
  }, typeof Symbol == "function" && (ae.prototype[Symbol.asyncIterator] = function() {
    return N === void 0 && (N = x5()), N(this);
  }), Object.defineProperty(ae.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(ae.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(ae.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(K) {
      this._readableState && (this._readableState.flowing = K);
    }
  }), ae._fromList = $, Object.defineProperty(ae.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function $(D, K) {
    if (K.length === 0)
      return null;
    var he;
    return K.objectMode ? he = K.buffer.shift() : !D || D >= K.length ? (K.decoder ? he = K.buffer.join("") : K.buffer.length === 1 ? he = K.buffer.first() : he = K.buffer.concat(K.length), K.buffer.clear()) : he = K.buffer.consume(D, K.decoder), he;
  }
  function W(D) {
    var K = D._readableState;
    f("endReadable", K.endEmitted), K.endEmitted || (K.ended = !0, Ye.nextTick(Z, K, D));
  }
  function Z(D, K) {
    if (f("endReadableNT", D.endEmitted, D.length), !D.endEmitted && D.length === 0 && (D.endEmitted = !0, K.readable = !1, K.emit("end"), D.autoDestroy)) {
      var he = K._writableState;
      (!he || he.autoDestroy && he.finished) && K.destroy();
    }
  }
  typeof Symbol == "function" && (ae.from = function(D, K) {
    return G === void 0 && (G = _5()), G(ae, D, K);
  });
  function fe(D, K) {
    for (var he = 0, be = D.length; he < be; he++)
      if (D[he] === K)
        return he;
    return -1;
  }
  return Ld;
}
var Ip = Ui, Fu = Go.codes, E5 = Fu.ERR_METHOD_NOT_IMPLEMENTED, S5 = Fu.ERR_MULTIPLE_CALLBACK, A5 = Fu.ERR_TRANSFORM_ALREADY_TRANSFORMING, I5 = Fu.ERR_TRANSFORM_WITH_LENGTH_0, Lu = Lo();
Mt(Ui, Lu);
function B5(t, e) {
  var r = this._transformState;
  r.transforming = !1;
  var n = r.writecb;
  if (n === null)
    return this.emit("error", new S5());
  r.writechunk = null, r.writecb = null, e != null && this.push(e), n(t);
  var i = this._readableState;
  i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
}
function Ui(t) {
  if (!(this instanceof Ui))
    return new Ui(t);
  Lu.call(this, t), this._transformState = {
    afterTransform: B5.bind(this),
    needTransform: !1,
    transforming: !1,
    writecb: null,
    writechunk: null,
    writeencoding: null
  }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && (typeof t.transform == "function" && (this._transform = t.transform), typeof t.flush == "function" && (this._flush = t.flush)), this.on("prefinish", M5);
}
function M5() {
  var t = this;
  typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(e, r) {
    dy(t, e, r);
  }) : dy(this, null, null);
}
Ui.prototype.push = function(t, e) {
  return this._transformState.needTransform = !1, Lu.prototype.push.call(this, t, e);
};
Ui.prototype._transform = function(t, e, r) {
  r(new E5("_transform()"));
};
Ui.prototype._write = function(t, e, r) {
  var n = this._transformState;
  if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
    var i = this._readableState;
    (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
  }
};
Ui.prototype._read = function(t) {
  var e = this._transformState;
  e.writechunk !== null && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
};
Ui.prototype._destroy = function(t, e) {
  Lu.prototype._destroy.call(this, t, function(r) {
    e(r);
  });
};
function dy(t, e, r) {
  if (e)
    return t.emit("error", e);
  if (r != null && t.push(r), t._writableState.length)
    throw new I5();
  if (t._transformState.transforming)
    throw new A5();
  return t.push(null);
}
var qm = Ls, zm = Ip;
Mt(Ls, zm);
function Ls(t) {
  if (!(this instanceof Ls))
    return new Ls(t);
  zm.call(this, t);
}
Ls.prototype._transform = function(t, e, r) {
  r(null, t);
};
var jd;
function R5(t) {
  var e = !1;
  return function() {
    e || (e = !0, t.apply(void 0, arguments));
  };
}
var Km = Go.codes, T5 = Km.ERR_MISSING_ARGS, O5 = Km.ERR_STREAM_DESTROYED;
function ly(t) {
  if (t)
    throw t;
}
function k5(t) {
  return t.setHeader && typeof t.abort == "function";
}
function C5(t, e, r, n) {
  n = R5(n);
  var i = !1;
  t.on("close", function() {
    i = !0;
  }), jd === void 0 && (jd = Uu), jd(t, {
    readable: e,
    writable: r
  }, function(a) {
    if (a)
      return n(a);
    i = !0, n();
  });
  var o = !1;
  return function(a) {
    if (!i && !o) {
      if (o = !0, k5(t))
        return t.abort();
      if (typeof t.destroy == "function")
        return t.destroy();
      n(a || new O5("pipe"));
    }
  };
}
function hy(t) {
  t();
}
function P5(t, e) {
  return t.pipe(e);
}
function N5(t) {
  return !t.length || typeof t[t.length - 1] != "function" ? ly : t.pop();
}
function U5() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  var n = N5(e);
  if (Array.isArray(e[0]) && (e = e[0]), e.length < 2)
    throw new T5("streams");
  var i, o = e.map(function(a, s) {
    var f = s < e.length - 1, u = s > 0;
    return C5(a, f, u, function(c) {
      i || (i = c), c && o.forEach(hy), !f && (o.forEach(hy), n(i));
    });
  });
  return e.reduce(P5);
}
var Wm = U5;
(function(t, e) {
  e = t.exports = Ap(), e.Stream = e, e.Readable = e, e.Writable = Ep(), e.Duplex = Lo(), e.Transform = Ip, e.PassThrough = qm, e.finished = Uu, e.pipeline = Wm;
})(I0, I0.exports);
var Hm = I0.exports, kc = Et.Buffer, Gm = Hm.Transform, F5 = Mt;
function L5(t, e) {
  if (!kc.isBuffer(t) && typeof t != "string")
    throw new TypeError(e + " must be a string or a buffer");
}
function ro(t) {
  Gm.call(this), this._block = kc.allocUnsafe(t), this._blockSize = t, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
}
F5(ro, Gm);
ro.prototype._transform = function(t, e, r) {
  var n = null;
  try {
    this.update(t, e);
  } catch (i) {
    n = i;
  }
  r(n);
};
ro.prototype._flush = function(t) {
  var e = null;
  try {
    this.push(this.digest());
  } catch (r) {
    e = r;
  }
  t(e);
};
ro.prototype.update = function(t, e) {
  if (L5(t, "Data"), this._finalized)
    throw new Error("Digest already called");
  kc.isBuffer(t) || (t = kc.from(t, e));
  for (var r = this._block, n = 0; this._blockOffset + t.length - n >= this._blockSize; ) {
    for (var i = this._blockOffset; i < this._blockSize; )
      r[i++] = t[n++];
    this._update(), this._blockOffset = 0;
  }
  for (; n < t.length; )
    r[this._blockOffset++] = t[n++];
  for (var o = 0, a = t.length * 8; a > 0; ++o)
    this._length[o] += a, a = this._length[o] / 4294967296 | 0, a > 0 && (this._length[o] -= 4294967296 * a);
  return this;
};
ro.prototype._update = function() {
  throw new Error("_update is not implemented");
};
ro.prototype.digest = function(t) {
  if (this._finalized)
    throw new Error("Digest already called");
  this._finalized = !0;
  var e = this._digest();
  t !== void 0 && (e = e.toString(t)), this._block.fill(0), this._blockOffset = 0;
  for (var r = 0; r < 4; ++r)
    this._length[r] = 0;
  return e;
};
ro.prototype._digest = function() {
  throw new Error("_digest is not implemented");
};
var Vm = ro, j5 = Mt, Ym = Vm, D5 = Et.Buffer, $5 = new Array(16);
function ju() {
  Ym.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
}
j5(ju, Ym);
ju.prototype._update = function() {
  for (var t = $5, e = 0; e < 16; ++e)
    t[e] = this._block.readInt32LE(e * 4);
  var r = this._a, n = this._b, i = this._c, o = this._d;
  r = Jr(r, n, i, o, t[0], 3614090360, 7), o = Jr(o, r, n, i, t[1], 3905402710, 12), i = Jr(i, o, r, n, t[2], 606105819, 17), n = Jr(n, i, o, r, t[3], 3250441966, 22), r = Jr(r, n, i, o, t[4], 4118548399, 7), o = Jr(o, r, n, i, t[5], 1200080426, 12), i = Jr(i, o, r, n, t[6], 2821735955, 17), n = Jr(n, i, o, r, t[7], 4249261313, 22), r = Jr(r, n, i, o, t[8], 1770035416, 7), o = Jr(o, r, n, i, t[9], 2336552879, 12), i = Jr(i, o, r, n, t[10], 4294925233, 17), n = Jr(n, i, o, r, t[11], 2304563134, 22), r = Jr(r, n, i, o, t[12], 1804603682, 7), o = Jr(o, r, n, i, t[13], 4254626195, 12), i = Jr(i, o, r, n, t[14], 2792965006, 17), n = Jr(n, i, o, r, t[15], 1236535329, 22), r = Xr(r, n, i, o, t[1], 4129170786, 5), o = Xr(o, r, n, i, t[6], 3225465664, 9), i = Xr(i, o, r, n, t[11], 643717713, 14), n = Xr(n, i, o, r, t[0], 3921069994, 20), r = Xr(r, n, i, o, t[5], 3593408605, 5), o = Xr(o, r, n, i, t[10], 38016083, 9), i = Xr(i, o, r, n, t[15], 3634488961, 14), n = Xr(n, i, o, r, t[4], 3889429448, 20), r = Xr(r, n, i, o, t[9], 568446438, 5), o = Xr(o, r, n, i, t[14], 3275163606, 9), i = Xr(i, o, r, n, t[3], 4107603335, 14), n = Xr(n, i, o, r, t[8], 1163531501, 20), r = Xr(r, n, i, o, t[13], 2850285829, 5), o = Xr(o, r, n, i, t[2], 4243563512, 9), i = Xr(i, o, r, n, t[7], 1735328473, 14), n = Xr(n, i, o, r, t[12], 2368359562, 20), r = Zr(r, n, i, o, t[5], 4294588738, 4), o = Zr(o, r, n, i, t[8], 2272392833, 11), i = Zr(i, o, r, n, t[11], 1839030562, 16), n = Zr(n, i, o, r, t[14], 4259657740, 23), r = Zr(r, n, i, o, t[1], 2763975236, 4), o = Zr(o, r, n, i, t[4], 1272893353, 11), i = Zr(i, o, r, n, t[7], 4139469664, 16), n = Zr(n, i, o, r, t[10], 3200236656, 23), r = Zr(r, n, i, o, t[13], 681279174, 4), o = Zr(o, r, n, i, t[0], 3936430074, 11), i = Zr(i, o, r, n, t[3], 3572445317, 16), n = Zr(n, i, o, r, t[6], 76029189, 23), r = Zr(r, n, i, o, t[9], 3654602809, 4), o = Zr(o, r, n, i, t[12], 3873151461, 11), i = Zr(i, o, r, n, t[15], 530742520, 16), n = Zr(n, i, o, r, t[2], 3299628645, 23), r = Qr(r, n, i, o, t[0], 4096336452, 6), o = Qr(o, r, n, i, t[7], 1126891415, 10), i = Qr(i, o, r, n, t[14], 2878612391, 15), n = Qr(n, i, o, r, t[5], 4237533241, 21), r = Qr(r, n, i, o, t[12], 1700485571, 6), o = Qr(o, r, n, i, t[3], 2399980690, 10), i = Qr(i, o, r, n, t[10], 4293915773, 15), n = Qr(n, i, o, r, t[1], 2240044497, 21), r = Qr(r, n, i, o, t[8], 1873313359, 6), o = Qr(o, r, n, i, t[15], 4264355552, 10), i = Qr(i, o, r, n, t[6], 2734768916, 15), n = Qr(n, i, o, r, t[13], 1309151649, 21), r = Qr(r, n, i, o, t[4], 4149444226, 6), o = Qr(o, r, n, i, t[11], 3174756917, 10), i = Qr(i, o, r, n, t[2], 718787259, 15), n = Qr(n, i, o, r, t[9], 3951481745, 21), this._a = this._a + r | 0, this._b = this._b + n | 0, this._c = this._c + i | 0, this._d = this._d + o | 0;
};
ju.prototype._digest = function() {
  this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
  var t = D5.allocUnsafe(16);
  return t.writeInt32LE(this._a, 0), t.writeInt32LE(this._b, 4), t.writeInt32LE(this._c, 8), t.writeInt32LE(this._d, 12), t;
};
function Du(t, e) {
  return t << e | t >>> 32 - e;
}
function Jr(t, e, r, n, i, o, a) {
  return Du(t + (e & r | ~e & n) + i + o | 0, a) + e | 0;
}
function Xr(t, e, r, n, i, o, a) {
  return Du(t + (e & n | r & ~n) + i + o | 0, a) + e | 0;
}
function Zr(t, e, r, n, i, o, a) {
  return Du(t + (e ^ r ^ n) + i + o | 0, a) + e | 0;
}
function Qr(t, e, r, n, i, o, a) {
  return Du(t + (r ^ (e | ~n)) + i + o | 0, a) + e | 0;
}
var Bp = ju, Dd = mt.Buffer, q5 = Mt, Jm = Vm, z5 = new Array(16), ls = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  7,
  4,
  13,
  1,
  10,
  6,
  15,
  3,
  12,
  0,
  9,
  5,
  2,
  14,
  11,
  8,
  3,
  10,
  14,
  4,
  9,
  15,
  8,
  1,
  2,
  7,
  0,
  6,
  13,
  11,
  5,
  12,
  1,
  9,
  11,
  10,
  0,
  8,
  12,
  4,
  13,
  3,
  7,
  15,
  14,
  5,
  6,
  2,
  4,
  0,
  5,
  9,
  7,
  12,
  2,
  10,
  14,
  1,
  3,
  8,
  11,
  6,
  15,
  13
], hs = [
  5,
  14,
  7,
  0,
  9,
  2,
  11,
  4,
  13,
  6,
  15,
  8,
  1,
  10,
  3,
  12,
  6,
  11,
  3,
  7,
  0,
  13,
  5,
  10,
  14,
  15,
  8,
  12,
  4,
  9,
  1,
  2,
  15,
  5,
  1,
  3,
  7,
  14,
  6,
  9,
  11,
  8,
  12,
  2,
  10,
  0,
  4,
  13,
  8,
  6,
  4,
  1,
  3,
  11,
  15,
  0,
  5,
  12,
  2,
  13,
  9,
  7,
  10,
  14,
  12,
  15,
  10,
  4,
  1,
  5,
  8,
  7,
  6,
  2,
  13,
  14,
  0,
  3,
  9,
  11
], ps = [
  11,
  14,
  15,
  12,
  5,
  8,
  7,
  9,
  11,
  13,
  14,
  15,
  6,
  7,
  9,
  8,
  7,
  6,
  8,
  13,
  11,
  9,
  7,
  15,
  7,
  12,
  15,
  9,
  11,
  7,
  13,
  12,
  11,
  13,
  6,
  7,
  14,
  9,
  13,
  15,
  14,
  8,
  13,
  6,
  5,
  12,
  7,
  5,
  11,
  12,
  14,
  15,
  14,
  15,
  9,
  8,
  9,
  14,
  5,
  6,
  8,
  6,
  5,
  12,
  9,
  15,
  5,
  11,
  6,
  8,
  13,
  12,
  5,
  12,
  13,
  14,
  11,
  8,
  5,
  6
], ys = [
  8,
  9,
  9,
  11,
  13,
  15,
  15,
  5,
  7,
  7,
  8,
  11,
  14,
  14,
  12,
  6,
  9,
  13,
  15,
  7,
  12,
  8,
  9,
  11,
  7,
  7,
  12,
  7,
  6,
  15,
  13,
  11,
  9,
  7,
  15,
  11,
  8,
  6,
  6,
  14,
  12,
  13,
  5,
  14,
  13,
  13,
  7,
  5,
  15,
  5,
  8,
  11,
  14,
  14,
  6,
  14,
  6,
  9,
  12,
  9,
  12,
  5,
  15,
  8,
  8,
  5,
  12,
  9,
  12,
  5,
  14,
  6,
  8,
  13,
  6,
  5,
  15,
  13,
  11,
  11
], bs = [0, 1518500249, 1859775393, 2400959708, 2840853838], gs = [1352829926, 1548603684, 1836072691, 2053994217, 0];
function $u() {
  Jm.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
}
q5($u, Jm);
$u.prototype._update = function() {
  for (var t = z5, e = 0; e < 16; ++e)
    t[e] = this._block.readInt32LE(e * 4);
  for (var r = this._a | 0, n = this._b | 0, i = this._c | 0, o = this._d | 0, a = this._e | 0, s = this._a | 0, f = this._b | 0, u = this._c | 0, c = this._d | 0, d = this._e | 0, l = 0; l < 80; l += 1) {
    var h, y;
    l < 16 ? (h = py(r, n, i, o, a, t[ls[l]], bs[0], ps[l]), y = vy(s, f, u, c, d, t[hs[l]], gs[0], ys[l])) : l < 32 ? (h = yy(r, n, i, o, a, t[ls[l]], bs[1], ps[l]), y = gy(s, f, u, c, d, t[hs[l]], gs[1], ys[l])) : l < 48 ? (h = by(r, n, i, o, a, t[ls[l]], bs[2], ps[l]), y = by(s, f, u, c, d, t[hs[l]], gs[2], ys[l])) : l < 64 ? (h = gy(r, n, i, o, a, t[ls[l]], bs[3], ps[l]), y = yy(s, f, u, c, d, t[hs[l]], gs[3], ys[l])) : (h = vy(r, n, i, o, a, t[ls[l]], bs[4], ps[l]), y = py(s, f, u, c, d, t[hs[l]], gs[4], ys[l])), r = a, a = o, o = jo(i, 10), i = n, n = h, s = d, d = c, c = jo(u, 10), u = f, f = y;
  }
  var b = this._b + i + c | 0;
  this._b = this._c + o + d | 0, this._c = this._d + a + s | 0, this._d = this._e + r + f | 0, this._e = this._a + n + u | 0, this._a = b;
};
$u.prototype._digest = function() {
  this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
  var t = Dd.alloc ? Dd.alloc(20) : new Dd(20);
  return t.writeInt32LE(this._a, 0), t.writeInt32LE(this._b, 4), t.writeInt32LE(this._c, 8), t.writeInt32LE(this._d, 12), t.writeInt32LE(this._e, 16), t;
};
function jo(t, e) {
  return t << e | t >>> 32 - e;
}
function py(t, e, r, n, i, o, a, s) {
  return jo(t + (e ^ r ^ n) + o + a | 0, s) + i | 0;
}
function yy(t, e, r, n, i, o, a, s) {
  return jo(t + (e & r | ~e & n) + o + a | 0, s) + i | 0;
}
function by(t, e, r, n, i, o, a, s) {
  return jo(t + ((e | ~r) ^ n) + o + a | 0, s) + i | 0;
}
function gy(t, e, r, n, i, o, a, s) {
  return jo(t + (e & n | r & ~n) + o + a | 0, s) + i | 0;
}
function vy(t, e, r, n, i, o, a, s) {
  return jo(t + (e ^ (r | ~n)) + o + a | 0, s) + i | 0;
}
var qu = $u, Xm = { exports: {} }, Zm = Et.Buffer;
function zu(t, e) {
  this._block = Zm.alloc(t), this._finalSize = e, this._blockSize = t, this._len = 0;
}
zu.prototype.update = function(t, e) {
  typeof t == "string" && (e = e || "utf8", t = Zm.from(t, e));
  for (var r = this._block, n = this._blockSize, i = t.length, o = this._len, a = 0; a < i; ) {
    for (var s = o % n, f = Math.min(i - a, n - s), u = 0; u < f; u++)
      r[s + u] = t[a + u];
    o += f, a += f, o % n === 0 && this._update(r);
  }
  return this._len += i, this;
};
zu.prototype.digest = function(t) {
  var e = this._len % this._blockSize;
  this._block[e] = 128, this._block.fill(0, e + 1), e >= this._finalSize && (this._update(this._block), this._block.fill(0));
  var r = this._len * 8;
  if (r <= 4294967295)
    this._block.writeUInt32BE(r, this._blockSize - 4);
  else {
    var n = (r & 4294967295) >>> 0, i = (r - n) / 4294967296;
    this._block.writeUInt32BE(i, this._blockSize - 8), this._block.writeUInt32BE(n, this._blockSize - 4);
  }
  this._update(this._block);
  var o = this._hash();
  return t ? o.toString(t) : o;
};
zu.prototype._update = function() {
  throw new Error("_update must be implemented by subclass");
};
var ts = zu, K5 = Mt, Qm = ts, W5 = Et.Buffer, H5 = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], G5 = new Array(80);
function Sf() {
  this.init(), this._w = G5, Qm.call(this, 64, 56);
}
K5(Sf, Qm);
Sf.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function V5(t) {
  return t << 5 | t >>> 27;
}
function Y5(t) {
  return t << 30 | t >>> 2;
}
function J5(t, e, r, n) {
  return t === 0 ? e & r | ~e & n : t === 2 ? e & r | e & n | r & n : e ^ r ^ n;
}
Sf.prototype._update = function(t) {
  for (var e = this._w, r = this._a | 0, n = this._b | 0, i = this._c | 0, o = this._d | 0, a = this._e | 0, s = 0; s < 16; ++s)
    e[s] = t.readInt32BE(s * 4);
  for (; s < 80; ++s)
    e[s] = e[s - 3] ^ e[s - 8] ^ e[s - 14] ^ e[s - 16];
  for (var f = 0; f < 80; ++f) {
    var u = ~~(f / 20), c = V5(r) + J5(u, n, i, o) + a + e[f] + H5[u] | 0;
    a = o, o = i, i = Y5(n), n = r, r = c;
  }
  this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = i + this._c | 0, this._d = o + this._d | 0, this._e = a + this._e | 0;
};
Sf.prototype._hash = function() {
  var t = W5.allocUnsafe(20);
  return t.writeInt32BE(this._a | 0, 0), t.writeInt32BE(this._b | 0, 4), t.writeInt32BE(this._c | 0, 8), t.writeInt32BE(this._d | 0, 12), t.writeInt32BE(this._e | 0, 16), t;
};
var X5 = Sf, Z5 = Mt, e3 = ts, Q5 = Et.Buffer, ex = [
  1518500249,
  1859775393,
  -1894007588,
  -899497514
], tx = new Array(80);
function Af() {
  this.init(), this._w = tx, e3.call(this, 64, 56);
}
Z5(Af, e3);
Af.prototype.init = function() {
  return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
};
function rx(t) {
  return t << 1 | t >>> 31;
}
function nx(t) {
  return t << 5 | t >>> 27;
}
function ix(t) {
  return t << 30 | t >>> 2;
}
function ox(t, e, r, n) {
  return t === 0 ? e & r | ~e & n : t === 2 ? e & r | e & n | r & n : e ^ r ^ n;
}
Af.prototype._update = function(t) {
  for (var e = this._w, r = this._a | 0, n = this._b | 0, i = this._c | 0, o = this._d | 0, a = this._e | 0, s = 0; s < 16; ++s)
    e[s] = t.readInt32BE(s * 4);
  for (; s < 80; ++s)
    e[s] = rx(e[s - 3] ^ e[s - 8] ^ e[s - 14] ^ e[s - 16]);
  for (var f = 0; f < 80; ++f) {
    var u = ~~(f / 20), c = nx(r) + ox(u, n, i, o) + a + e[f] + ex[u] | 0;
    a = o, o = i, i = ix(n), n = r, r = c;
  }
  this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = i + this._c | 0, this._d = o + this._d | 0, this._e = a + this._e | 0;
};
Af.prototype._hash = function() {
  var t = Q5.allocUnsafe(20);
  return t.writeInt32BE(this._a | 0, 0), t.writeInt32BE(this._b | 0, 4), t.writeInt32BE(this._c | 0, 8), t.writeInt32BE(this._d | 0, 12), t.writeInt32BE(this._e | 0, 16), t;
};
var ax = Af, sx = Mt, t3 = ts, fx = Et.Buffer, cx = [
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
], ux = new Array(64);
function If() {
  this.init(), this._w = ux, t3.call(this, 64, 56);
}
sx(If, t3);
If.prototype.init = function() {
  return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
};
function dx(t, e, r) {
  return r ^ t & (e ^ r);
}
function lx(t, e, r) {
  return t & e | r & (t | e);
}
function hx(t) {
  return (t >>> 2 | t << 30) ^ (t >>> 13 | t << 19) ^ (t >>> 22 | t << 10);
}
function px(t) {
  return (t >>> 6 | t << 26) ^ (t >>> 11 | t << 21) ^ (t >>> 25 | t << 7);
}
function yx(t) {
  return (t >>> 7 | t << 25) ^ (t >>> 18 | t << 14) ^ t >>> 3;
}
function bx(t) {
  return (t >>> 17 | t << 15) ^ (t >>> 19 | t << 13) ^ t >>> 10;
}
If.prototype._update = function(t) {
  for (var e = this._w, r = this._a | 0, n = this._b | 0, i = this._c | 0, o = this._d | 0, a = this._e | 0, s = this._f | 0, f = this._g | 0, u = this._h | 0, c = 0; c < 16; ++c)
    e[c] = t.readInt32BE(c * 4);
  for (; c < 64; ++c)
    e[c] = bx(e[c - 2]) + e[c - 7] + yx(e[c - 15]) + e[c - 16] | 0;
  for (var d = 0; d < 64; ++d) {
    var l = u + px(a) + dx(a, s, f) + cx[d] + e[d] | 0, h = hx(r) + lx(r, n, i) | 0;
    u = f, f = s, s = a, a = o + l | 0, o = i, i = n, n = r, r = l + h | 0;
  }
  this._a = r + this._a | 0, this._b = n + this._b | 0, this._c = i + this._c | 0, this._d = o + this._d | 0, this._e = a + this._e | 0, this._f = s + this._f | 0, this._g = f + this._g | 0, this._h = u + this._h | 0;
};
If.prototype._hash = function() {
  var t = fx.allocUnsafe(32);
  return t.writeInt32BE(this._a, 0), t.writeInt32BE(this._b, 4), t.writeInt32BE(this._c, 8), t.writeInt32BE(this._d, 12), t.writeInt32BE(this._e, 16), t.writeInt32BE(this._f, 20), t.writeInt32BE(this._g, 24), t.writeInt32BE(this._h, 28), t;
};
var r3 = If, gx = Mt, vx = r3, mx = ts, wx = Et.Buffer, xx = new Array(64);
function Ku() {
  this.init(), this._w = xx, mx.call(this, 64, 56);
}
gx(Ku, vx);
Ku.prototype.init = function() {
  return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
};
Ku.prototype._hash = function() {
  var t = wx.allocUnsafe(28);
  return t.writeInt32BE(this._a, 0), t.writeInt32BE(this._b, 4), t.writeInt32BE(this._c, 8), t.writeInt32BE(this._d, 12), t.writeInt32BE(this._e, 16), t.writeInt32BE(this._f, 20), t.writeInt32BE(this._g, 24), t;
};
var _x = Ku, Ex = Mt, n3 = ts, Sx = Et.Buffer, my = [
  1116352408,
  3609767458,
  1899447441,
  602891725,
  3049323471,
  3964484399,
  3921009573,
  2173295548,
  961987163,
  4081628472,
  1508970993,
  3053834265,
  2453635748,
  2937671579,
  2870763221,
  3664609560,
  3624381080,
  2734883394,
  310598401,
  1164996542,
  607225278,
  1323610764,
  1426881987,
  3590304994,
  1925078388,
  4068182383,
  2162078206,
  991336113,
  2614888103,
  633803317,
  3248222580,
  3479774868,
  3835390401,
  2666613458,
  4022224774,
  944711139,
  264347078,
  2341262773,
  604807628,
  2007800933,
  770255983,
  1495990901,
  1249150122,
  1856431235,
  1555081692,
  3175218132,
  1996064986,
  2198950837,
  2554220882,
  3999719339,
  2821834349,
  766784016,
  2952996808,
  2566594879,
  3210313671,
  3203337956,
  3336571891,
  1034457026,
  3584528711,
  2466948901,
  113926993,
  3758326383,
  338241895,
  168717936,
  666307205,
  1188179964,
  773529912,
  1546045734,
  1294757372,
  1522805485,
  1396182291,
  2643833823,
  1695183700,
  2343527390,
  1986661051,
  1014477480,
  2177026350,
  1206759142,
  2456956037,
  344077627,
  2730485921,
  1290863460,
  2820302411,
  3158454273,
  3259730800,
  3505952657,
  3345764771,
  106217008,
  3516065817,
  3606008344,
  3600352804,
  1432725776,
  4094571909,
  1467031594,
  275423344,
  851169720,
  430227734,
  3100823752,
  506948616,
  1363258195,
  659060556,
  3750685593,
  883997877,
  3785050280,
  958139571,
  3318307427,
  1322822218,
  3812723403,
  1537002063,
  2003034995,
  1747873779,
  3602036899,
  1955562222,
  1575990012,
  2024104815,
  1125592928,
  2227730452,
  2716904306,
  2361852424,
  442776044,
  2428436474,
  593698344,
  2756734187,
  3733110249,
  3204031479,
  2999351573,
  3329325298,
  3815920427,
  3391569614,
  3928383900,
  3515267271,
  566280711,
  3940187606,
  3454069534,
  4118630271,
  4000239992,
  116418474,
  1914138554,
  174292421,
  2731055270,
  289380356,
  3203993006,
  460393269,
  320620315,
  685471733,
  587496836,
  852142971,
  1086792851,
  1017036298,
  365543100,
  1126000580,
  2618297676,
  1288033470,
  3409855158,
  1501505948,
  4234509866,
  1607167915,
  987167468,
  1816402316,
  1246189591
], Ax = new Array(160);
function Bf() {
  this.init(), this._w = Ax, n3.call(this, 128, 112);
}
Ex(Bf, n3);
Bf.prototype.init = function() {
  return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
};
function wy(t, e, r) {
  return r ^ t & (e ^ r);
}
function xy(t, e, r) {
  return t & e | r & (t | e);
}
function _y(t, e) {
  return (t >>> 28 | e << 4) ^ (e >>> 2 | t << 30) ^ (e >>> 7 | t << 25);
}
function Ey(t, e) {
  return (t >>> 14 | e << 18) ^ (t >>> 18 | e << 14) ^ (e >>> 9 | t << 23);
}
function Ix(t, e) {
  return (t >>> 1 | e << 31) ^ (t >>> 8 | e << 24) ^ t >>> 7;
}
function Bx(t, e) {
  return (t >>> 1 | e << 31) ^ (t >>> 8 | e << 24) ^ (t >>> 7 | e << 25);
}
function Mx(t, e) {
  return (t >>> 19 | e << 13) ^ (e >>> 29 | t << 3) ^ t >>> 6;
}
function Rx(t, e) {
  return (t >>> 19 | e << 13) ^ (e >>> 29 | t << 3) ^ (t >>> 6 | e << 26);
}
function Ur(t, e) {
  return t >>> 0 < e >>> 0 ? 1 : 0;
}
Bf.prototype._update = function(t) {
  for (var e = this._w, r = this._ah | 0, n = this._bh | 0, i = this._ch | 0, o = this._dh | 0, a = this._eh | 0, s = this._fh | 0, f = this._gh | 0, u = this._hh | 0, c = this._al | 0, d = this._bl | 0, l = this._cl | 0, h = this._dl | 0, y = this._el | 0, b = this._fl | 0, w = this._gl | 0, A = this._hl | 0, M = 0; M < 32; M += 2)
    e[M] = t.readInt32BE(M * 4), e[M + 1] = t.readInt32BE(M * 4 + 4);
  for (; M < 160; M += 2) {
    var N = e[M - 30], G = e[M - 15 * 2 + 1], z = Ix(N, G), J = Bx(G, N);
    N = e[M - 2 * 2], G = e[M - 2 * 2 + 1];
    var oe = Mx(N, G), ee = Rx(G, N), ae = e[M - 7 * 2], ye = e[M - 7 * 2 + 1], pe = e[M - 16 * 2], te = e[M - 16 * 2 + 1], F = J + ye | 0, v = z + ae + Ur(F, J) | 0;
    F = F + ee | 0, v = v + oe + Ur(F, ee) | 0, F = F + te | 0, v = v + pe + Ur(F, te) | 0, e[M] = v, e[M + 1] = F;
  }
  for (var B = 0; B < 160; B += 2) {
    v = e[B], F = e[B + 1];
    var P = xy(r, n, i), L = xy(c, d, l), x = _y(r, c), C = _y(c, r), j = Ey(a, y), k = Ey(y, a), g = my[B], R = my[B + 1], X = wy(a, s, f), re = wy(y, b, w), V = A + k | 0, $ = u + j + Ur(V, A) | 0;
    V = V + re | 0, $ = $ + X + Ur(V, re) | 0, V = V + R | 0, $ = $ + g + Ur(V, R) | 0, V = V + F | 0, $ = $ + v + Ur(V, F) | 0;
    var W = C + L | 0, Z = x + P + Ur(W, C) | 0;
    u = f, A = w, f = s, w = b, s = a, b = y, y = h + V | 0, a = o + $ + Ur(y, h) | 0, o = i, h = l, i = n, l = d, n = r, d = c, c = V + W | 0, r = $ + Z + Ur(c, V) | 0;
  }
  this._al = this._al + c | 0, this._bl = this._bl + d | 0, this._cl = this._cl + l | 0, this._dl = this._dl + h | 0, this._el = this._el + y | 0, this._fl = this._fl + b | 0, this._gl = this._gl + w | 0, this._hl = this._hl + A | 0, this._ah = this._ah + r + Ur(this._al, c) | 0, this._bh = this._bh + n + Ur(this._bl, d) | 0, this._ch = this._ch + i + Ur(this._cl, l) | 0, this._dh = this._dh + o + Ur(this._dl, h) | 0, this._eh = this._eh + a + Ur(this._el, y) | 0, this._fh = this._fh + s + Ur(this._fl, b) | 0, this._gh = this._gh + f + Ur(this._gl, w) | 0, this._hh = this._hh + u + Ur(this._hl, A) | 0;
};
Bf.prototype._hash = function() {
  var t = Sx.allocUnsafe(64);
  function e(r, n, i) {
    t.writeInt32BE(r, i), t.writeInt32BE(n, i + 4);
  }
  return e(this._ah, this._al, 0), e(this._bh, this._bl, 8), e(this._ch, this._cl, 16), e(this._dh, this._dl, 24), e(this._eh, this._el, 32), e(this._fh, this._fl, 40), e(this._gh, this._gl, 48), e(this._hh, this._hl, 56), t;
};
var i3 = Bf, Tx = Mt, Ox = i3, kx = ts, Cx = Et.Buffer, Px = new Array(160);
function Wu() {
  this.init(), this._w = Px, kx.call(this, 128, 112);
}
Tx(Wu, Ox);
Wu.prototype.init = function() {
  return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
};
Wu.prototype._hash = function() {
  var t = Cx.allocUnsafe(48);
  function e(r, n, i) {
    t.writeInt32BE(r, i), t.writeInt32BE(n, i + 4);
  }
  return e(this._ah, this._al, 0), e(this._bh, this._bl, 8), e(this._ch, this._cl, 16), e(this._dh, this._dl, 24), e(this._eh, this._el, 32), e(this._fh, this._fl, 40), t;
};
var Nx = Wu, Vo = Xm.exports = function(e) {
  e = e.toLowerCase();
  var r = Vo[e];
  if (!r)
    throw new Error(e + " is not supported (we accept pull requests)");
  return new r();
};
Vo.sha = X5;
Vo.sha1 = ax;
Vo.sha224 = _x;
Vo.sha256 = r3;
Vo.sha384 = Nx;
Vo.sha512 = i3;
var js = Xm.exports, Ux = Wn, Mp = xp.EventEmitter, Fx = Mt;
Fx(Wn, Mp);
Wn.Readable = Ap();
Wn.Writable = Ep();
Wn.Duplex = Lo();
Wn.Transform = Ip;
Wn.PassThrough = qm;
Wn.finished = Uu;
Wn.pipeline = Wm;
Wn.Stream = Wn;
function Wn() {
  Mp.call(this);
}
Wn.prototype.pipe = function(t, e) {
  var r = this;
  function n(c) {
    t.writable && t.write(c) === !1 && r.pause && r.pause();
  }
  r.on("data", n);
  function i() {
    r.readable && r.resume && r.resume();
  }
  t.on("drain", i), !t._isStdio && (!e || e.end !== !1) && (r.on("end", a), r.on("close", s));
  var o = !1;
  function a() {
    o || (o = !0, t.end());
  }
  function s() {
    o || (o = !0, typeof t.destroy == "function" && t.destroy());
  }
  function f(c) {
    if (u(), Mp.listenerCount(this, "error") === 0)
      throw c;
  }
  r.on("error", f), t.on("error", f);
  function u() {
    r.removeListener("data", n), t.removeListener("drain", i), r.removeListener("end", a), r.removeListener("close", s), r.removeListener("error", f), t.removeListener("error", f), r.removeListener("end", u), r.removeListener("close", u), t.removeListener("close", u);
  }
  return r.on("end", u), r.on("close", u), t.on("close", u), t.emit("pipe", r), t;
};
var o3 = Et.Buffer, a3 = Ux.Transform, Lx = Oc.StringDecoder, jx = Mt;
function oi(t) {
  a3.call(this), this.hashMode = typeof t == "string", this.hashMode ? this[t] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
}
jx(oi, a3);
oi.prototype.update = function(t, e, r) {
  typeof t == "string" && (t = o3.from(t, e));
  var n = this._update(t);
  return this.hashMode ? this : (r && (n = this._toString(n, r)), n);
};
oi.prototype.setAutoPadding = function() {
};
oi.prototype.getAuthTag = function() {
  throw new Error("trying to get auth tag in unsupported state");
};
oi.prototype.setAuthTag = function() {
  throw new Error("trying to set auth tag in unsupported state");
};
oi.prototype.setAAD = function() {
  throw new Error("trying to set aad in unsupported state");
};
oi.prototype._transform = function(t, e, r) {
  var n;
  try {
    this.hashMode ? this._update(t) : this.push(this._update(t));
  } catch (i) {
    n = i;
  } finally {
    r(n);
  }
};
oi.prototype._flush = function(t) {
  var e;
  try {
    this.push(this.__final());
  } catch (r) {
    e = r;
  }
  t(e);
};
oi.prototype._finalOrDigest = function(t) {
  var e = this.__final() || o3.alloc(0);
  return t && (e = this._toString(e, t, !0)), e;
};
oi.prototype._toString = function(t, e, r) {
  if (this._decoder || (this._decoder = new Lx(e), this._encoding = e), this._encoding !== e)
    throw new Error("can't switch encodings");
  var n = this._decoder.write(t);
  return r && (n += this._decoder.end()), n;
};
var no = oi, $d, Sy;
function Yo() {
  if (Sy)
    return $d;
  Sy = 1;
  var t = Mt, e = Bp, r = qu, n = js, i = no;
  function o(a) {
    i.call(this, "digest"), this._hash = a;
  }
  return t(o, i), o.prototype._update = function(a) {
    this._hash.update(a);
  }, o.prototype._final = function() {
    return this._hash.digest();
  }, $d = function(s) {
    return s = s.toLowerCase(), s === "md5" ? new e() : s === "rmd160" || s === "ripemd160" ? new r() : new o(n(s));
  }, $d;
}
var Dx = Mt, vo = Et.Buffer, s3 = no, $x = vo.alloc(128), oa = 64;
function Hu(t, e) {
  s3.call(this, "digest"), typeof e == "string" && (e = vo.from(e)), this._alg = t, this._key = e, e.length > oa ? e = t(e) : e.length < oa && (e = vo.concat([e, $x], oa));
  for (var r = this._ipad = vo.allocUnsafe(oa), n = this._opad = vo.allocUnsafe(oa), i = 0; i < oa; i++)
    r[i] = e[i] ^ 54, n[i] = e[i] ^ 92;
  this._hash = [r];
}
Dx(Hu, s3);
Hu.prototype._update = function(t) {
  this._hash.push(t);
};
Hu.prototype._final = function() {
  var t = this._alg(vo.concat(this._hash));
  return this._alg(vo.concat([this._opad, t]));
};
var qx = Hu, zx = Bp, f3 = function(t) {
  return new zx().update(t).digest();
}, Kx = Mt, Wx = qx, c3 = no, Ms = Et.Buffer, Hx = f3, M0 = qu, R0 = js, Gx = Ms.alloc(128);
function Ds(t, e) {
  c3.call(this, "digest"), typeof e == "string" && (e = Ms.from(e));
  var r = t === "sha512" || t === "sha384" ? 128 : 64;
  if (this._alg = t, this._key = e, e.length > r) {
    var n = t === "rmd160" ? new M0() : R0(t);
    e = n.update(e).digest();
  } else
    e.length < r && (e = Ms.concat([e, Gx], r));
  for (var i = this._ipad = Ms.allocUnsafe(r), o = this._opad = Ms.allocUnsafe(r), a = 0; a < r; a++)
    i[a] = e[a] ^ 54, o[a] = e[a] ^ 92;
  this._hash = t === "rmd160" ? new M0() : R0(t), this._hash.update(i);
}
Kx(Ds, c3);
Ds.prototype._update = function(t) {
  this._hash.update(t);
};
Ds.prototype._final = function() {
  var t = this._hash.digest(), e = this._alg === "rmd160" ? new M0() : R0(this._alg);
  return e.update(this._opad).update(t).digest();
};
var Gu = function(e, r) {
  return e = e.toLowerCase(), e === "rmd160" || e === "ripemd160" ? new Ds("rmd160", r) : e === "md5" ? new Wx(Hx, r) : new Ds(e, r);
};
const Vx = /* @__PURE__ */ sn(Gu), Yx = /* @__PURE__ */ k4({
  __proto__: null,
  default: Vx
}, [Gu]), Jx = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, Xx = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, Zx = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, Qx = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, e_ = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, t_ = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, r_ = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, n_ = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, i_ = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, o_ = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, a_ = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, u3 = {
  sha224WithRSAEncryption: Jx,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption: Xx,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption: Zx,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption: Qx,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: e_,
  sha224: t_,
  sha384: r_,
  sha512: n_,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA: i_,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA: o_,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption: a_,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var qd, Ay;
function s_() {
  return Ay || (Ay = 1, qd = u3), qd;
}
var Kf = {}, zd, Iy;
function d3() {
  if (Iy)
    return zd;
  Iy = 1;
  var t = Math.pow(2, 30) - 1;
  return zd = function(e, r) {
    if (typeof e != "number")
      throw new TypeError("Iterations not a number");
    if (e < 0)
      throw new TypeError("Bad iterations");
    if (typeof r != "number")
      throw new TypeError("Key length not a number");
    if (r < 0 || r > t || r !== r)
      throw new TypeError("Bad key length");
  }, zd;
}
var Kd, By;
function l3() {
  if (By)
    return Kd;
  By = 1;
  var t;
  if (yt.process && yt.process.browser)
    t = "utf-8";
  else if (yt.process && yt.process.version) {
    var e = parseInt(Ye.version.split(".")[0].slice(1), 10);
    t = e >= 6 ? "utf-8" : "binary";
  } else
    t = "utf-8";
  return Kd = t, Kd;
}
var Wd, My;
function h3() {
  if (My)
    return Wd;
  My = 1;
  var t = Et.Buffer;
  return Wd = function(e, r, n) {
    if (t.isBuffer(e))
      return e;
    if (typeof e == "string")
      return t.from(e, r);
    if (ArrayBuffer.isView(e))
      return t.from(e.buffer);
    throw new TypeError(n + " must be a string, a Buffer, a typed array or a DataView");
  }, Wd;
}
var Hd, Ry;
function p3() {
  if (Ry)
    return Hd;
  Ry = 1;
  var t = f3, e = qu, r = js, n = Et.Buffer, i = d3(), o = l3(), a = h3(), s = n.alloc(128), f = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };
  function u(l, h, y) {
    var b = c(l), w = l === "sha512" || l === "sha384" ? 128 : 64;
    h.length > w ? h = b(h) : h.length < w && (h = n.concat([h, s], w));
    for (var A = n.allocUnsafe(w + f[l]), M = n.allocUnsafe(w + f[l]), N = 0; N < w; N++)
      A[N] = h[N] ^ 54, M[N] = h[N] ^ 92;
    var G = n.allocUnsafe(w + y + 4);
    A.copy(G, 0, 0, w), this.ipad1 = G, this.ipad2 = A, this.opad = M, this.alg = l, this.blocksize = w, this.hash = b, this.size = f[l];
  }
  u.prototype.run = function(l, h) {
    l.copy(h, this.blocksize);
    var y = this.hash(h);
    return y.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function c(l) {
    function h(b) {
      return r(l).update(b).digest();
    }
    function y(b) {
      return new e().update(b).digest();
    }
    return l === "rmd160" || l === "ripemd160" ? y : l === "md5" ? t : h;
  }
  function d(l, h, y, b, w) {
    i(y, b), l = a(l, o, "Password"), h = a(h, o, "Salt"), w = w || "sha1";
    var A = new u(w, l, h.length), M = n.allocUnsafe(b), N = n.allocUnsafe(h.length + 4);
    h.copy(N, 0, 0, h.length);
    for (var G = 0, z = f[w], J = Math.ceil(b / z), oe = 1; oe <= J; oe++) {
      N.writeUInt32BE(oe, h.length);
      for (var ee = A.run(N, A.ipad1), ae = ee, ye = 1; ye < y; ye++) {
        ae = A.run(ae, A.ipad2);
        for (var pe = 0; pe < z; pe++)
          ee[pe] ^= ae[pe];
      }
      ee.copy(M, G), G += z;
    }
    return M;
  }
  return Hd = d, Hd;
}
var Gd, Ty;
function f_() {
  if (Ty)
    return Gd;
  Ty = 1;
  var t = Et.Buffer, e = d3(), r = l3(), n = p3(), i = h3(), o, a = yt.crypto && yt.crypto.subtle, s = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, f = [];
  function u(y) {
    if (yt.process && !yt.process.browser || !a || !a.importKey || !a.deriveBits)
      return Promise.resolve(!1);
    if (f[y] !== void 0)
      return f[y];
    o = o || t.alloc(8);
    var b = l(o, o, 10, 128, y).then(function() {
      return !0;
    }).catch(function() {
      return !1;
    });
    return f[y] = b, b;
  }
  var c;
  function d() {
    return c || (yt.process && yt.process.nextTick ? c = yt.process.nextTick : yt.queueMicrotask ? c = yt.queueMicrotask : yt.setImmediate ? c = yt.setImmediate : c = yt.setTimeout, c);
  }
  function l(y, b, w, A, M) {
    return a.importKey(
      "raw",
      y,
      { name: "PBKDF2" },
      !1,
      ["deriveBits"]
    ).then(function(N) {
      return a.deriveBits({
        name: "PBKDF2",
        salt: b,
        iterations: w,
        hash: {
          name: M
        }
      }, N, A << 3);
    }).then(function(N) {
      return t.from(N);
    });
  }
  function h(y, b) {
    y.then(function(w) {
      d()(function() {
        b(null, w);
      });
    }, function(w) {
      d()(function() {
        b(w);
      });
    });
  }
  return Gd = function(y, b, w, A, M, N) {
    typeof M == "function" && (N = M, M = void 0), M = M || "sha1";
    var G = s[M.toLowerCase()];
    if (!G || typeof yt.Promise != "function") {
      d()(function() {
        var z;
        try {
          z = n(y, b, w, A, M);
        } catch (J) {
          return N(J);
        }
        N(null, z);
      });
      return;
    }
    if (e(w, A), y = i(y, r, "Password"), b = i(b, r, "Salt"), typeof N != "function")
      throw new Error("No callback provided to pbkdf2");
    h(u(G).then(function(z) {
      return z ? l(y, b, w, A, G) : n(y, b, w, A, M);
    }), N);
  }, Gd;
}
var Oy;
function y3() {
  return Oy || (Oy = 1, Kf.pbkdf2 = f_(), Kf.pbkdf2Sync = p3()), Kf;
}
var Pn = {}, oo = {}, Sn = {}, ky;
function b3() {
  if (ky)
    return Sn;
  ky = 1, Sn.readUInt32BE = function(i, o) {
    var a = i[0 + o] << 24 | i[1 + o] << 16 | i[2 + o] << 8 | i[3 + o];
    return a >>> 0;
  }, Sn.writeUInt32BE = function(i, o, a) {
    i[0 + a] = o >>> 24, i[1 + a] = o >>> 16 & 255, i[2 + a] = o >>> 8 & 255, i[3 + a] = o & 255;
  }, Sn.ip = function(i, o, a, s) {
    for (var f = 0, u = 0, c = 6; c >= 0; c -= 2) {
      for (var d = 0; d <= 24; d += 8)
        f <<= 1, f |= o >>> d + c & 1;
      for (var d = 0; d <= 24; d += 8)
        f <<= 1, f |= i >>> d + c & 1;
    }
    for (var c = 6; c >= 0; c -= 2) {
      for (var d = 1; d <= 25; d += 8)
        u <<= 1, u |= o >>> d + c & 1;
      for (var d = 1; d <= 25; d += 8)
        u <<= 1, u |= i >>> d + c & 1;
    }
    a[s + 0] = f >>> 0, a[s + 1] = u >>> 0;
  }, Sn.rip = function(i, o, a, s) {
    for (var f = 0, u = 0, c = 0; c < 4; c++)
      for (var d = 24; d >= 0; d -= 8)
        f <<= 1, f |= o >>> d + c & 1, f <<= 1, f |= i >>> d + c & 1;
    for (var c = 4; c < 8; c++)
      for (var d = 24; d >= 0; d -= 8)
        u <<= 1, u |= o >>> d + c & 1, u <<= 1, u |= i >>> d + c & 1;
    a[s + 0] = f >>> 0, a[s + 1] = u >>> 0;
  }, Sn.pc1 = function(i, o, a, s) {
    for (var f = 0, u = 0, c = 7; c >= 5; c--) {
      for (var d = 0; d <= 24; d += 8)
        f <<= 1, f |= o >> d + c & 1;
      for (var d = 0; d <= 24; d += 8)
        f <<= 1, f |= i >> d + c & 1;
    }
    for (var d = 0; d <= 24; d += 8)
      f <<= 1, f |= o >> d + c & 1;
    for (var c = 1; c <= 3; c++) {
      for (var d = 0; d <= 24; d += 8)
        u <<= 1, u |= o >> d + c & 1;
      for (var d = 0; d <= 24; d += 8)
        u <<= 1, u |= i >> d + c & 1;
    }
    for (var d = 0; d <= 24; d += 8)
      u <<= 1, u |= i >> d + c & 1;
    a[s + 0] = f >>> 0, a[s + 1] = u >>> 0;
  }, Sn.r28shl = function(i, o) {
    return i << o & 268435455 | i >>> 28 - o;
  };
  var t = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  Sn.pc2 = function(i, o, a, s) {
    for (var f = 0, u = 0, c = t.length >>> 1, d = 0; d < c; d++)
      f <<= 1, f |= i >>> t[d] & 1;
    for (var d = c; d < t.length; d++)
      u <<= 1, u |= o >>> t[d] & 1;
    a[s + 0] = f >>> 0, a[s + 1] = u >>> 0;
  }, Sn.expand = function(i, o, a) {
    var s = 0, f = 0;
    s = (i & 1) << 5 | i >>> 27;
    for (var u = 23; u >= 15; u -= 4)
      s <<= 6, s |= i >>> u & 63;
    for (var u = 11; u >= 3; u -= 4)
      f |= i >>> u & 63, f <<= 6;
    f |= (i & 31) << 1 | i >>> 31, o[a + 0] = s >>> 0, o[a + 1] = f >>> 0;
  };
  var e = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  Sn.substitute = function(i, o) {
    for (var a = 0, s = 0; s < 4; s++) {
      var f = i >>> 18 - s * 6 & 63, u = e[s * 64 + f];
      a <<= 4, a |= u;
    }
    for (var s = 0; s < 4; s++) {
      var f = o >>> 18 - s * 6 & 63, u = e[4 * 64 + s * 64 + f];
      a <<= 4, a |= u;
    }
    return a >>> 0;
  };
  var r = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return Sn.permute = function(i) {
    for (var o = 0, a = 0; a < r.length; a++)
      o <<= 1, o |= i >>> r[a] & 1;
    return o >>> 0;
  }, Sn.padSplit = function(i, o, a) {
    for (var s = i.toString(2); s.length < o; )
      s = "0" + s;
    for (var f = [], u = 0; u < o; u += a)
      f.push(s.slice(u, u + a));
    return f.join(" ");
  }, Sn;
}
var On = g3;
function g3(t, e) {
  if (!t)
    throw new Error(e || "Assertion failed");
}
g3.equal = function(e, r, n) {
  if (e != r)
    throw new Error(n || "Assertion failed: " + e + " != " + r);
};
const $e = /* @__PURE__ */ sn(On);
var Vd, Cy;
function Rp() {
  if (Cy)
    return Vd;
  Cy = 1;
  var t = On;
  function e(r) {
    this.options = r, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = r.padding !== !1;
  }
  return Vd = e, e.prototype._init = function() {
  }, e.prototype.update = function(n) {
    return n.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(n) : this._updateEncrypt(n);
  }, e.prototype._buffer = function(n, i) {
    for (var o = Math.min(this.buffer.length - this.bufferOff, n.length - i), a = 0; a < o; a++)
      this.buffer[this.bufferOff + a] = n[i + a];
    return this.bufferOff += o, o;
  }, e.prototype._flushBuffer = function(n, i) {
    return this._update(this.buffer, 0, n, i), this.bufferOff = 0, this.blockSize;
  }, e.prototype._updateEncrypt = function(n) {
    var i = 0, o = 0, a = (this.bufferOff + n.length) / this.blockSize | 0, s = new Array(a * this.blockSize);
    this.bufferOff !== 0 && (i += this._buffer(n, i), this.bufferOff === this.buffer.length && (o += this._flushBuffer(s, o)));
    for (var f = n.length - (n.length - i) % this.blockSize; i < f; i += this.blockSize)
      this._update(n, i, s, o), o += this.blockSize;
    for (; i < n.length; i++, this.bufferOff++)
      this.buffer[this.bufferOff] = n[i];
    return s;
  }, e.prototype._updateDecrypt = function(n) {
    for (var i = 0, o = 0, a = Math.ceil((this.bufferOff + n.length) / this.blockSize) - 1, s = new Array(a * this.blockSize); a > 0; a--)
      i += this._buffer(n, i), o += this._flushBuffer(s, o);
    return i += this._buffer(n, i), s;
  }, e.prototype.final = function(n) {
    var i;
    n && (i = this.update(n));
    var o;
    return this.type === "encrypt" ? o = this._finalEncrypt() : o = this._finalDecrypt(), i ? i.concat(o) : o;
  }, e.prototype._pad = function(n, i) {
    if (i === 0)
      return !1;
    for (; i < n.length; )
      n[i++] = 0;
    return !0;
  }, e.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var n = new Array(this.blockSize);
    return this._update(this.buffer, 0, n, 0), n;
  }, e.prototype._unpad = function(n) {
    return n;
  }, e.prototype._finalDecrypt = function() {
    t.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var n = new Array(this.blockSize);
    return this._flushBuffer(n, 0), this._unpad(n);
  }, Vd;
}
var Yd, Py;
function v3() {
  if (Py)
    return Yd;
  Py = 1;
  var t = On, e = Mt, r = b3(), n = Rp();
  function i() {
    this.tmp = new Array(2), this.keys = null;
  }
  function o(s) {
    n.call(this, s);
    var f = new i();
    this._desState = f, this.deriveKeys(f, s.key);
  }
  e(o, n), Yd = o, o.create = function(f) {
    return new o(f);
  };
  var a = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return o.prototype.deriveKeys = function(f, u) {
    f.keys = new Array(16 * 2), t.equal(u.length, this.blockSize, "Invalid key length");
    var c = r.readUInt32BE(u, 0), d = r.readUInt32BE(u, 4);
    r.pc1(c, d, f.tmp, 0), c = f.tmp[0], d = f.tmp[1];
    for (var l = 0; l < f.keys.length; l += 2) {
      var h = a[l >>> 1];
      c = r.r28shl(c, h), d = r.r28shl(d, h), r.pc2(c, d, f.keys, l);
    }
  }, o.prototype._update = function(f, u, c, d) {
    var l = this._desState, h = r.readUInt32BE(f, u), y = r.readUInt32BE(f, u + 4);
    r.ip(h, y, l.tmp, 0), h = l.tmp[0], y = l.tmp[1], this.type === "encrypt" ? this._encrypt(l, h, y, l.tmp, 0) : this._decrypt(l, h, y, l.tmp, 0), h = l.tmp[0], y = l.tmp[1], r.writeUInt32BE(c, h, d), r.writeUInt32BE(c, y, d + 4);
  }, o.prototype._pad = function(f, u) {
    if (this.padding === !1)
      return !1;
    for (var c = f.length - u, d = u; d < f.length; d++)
      f[d] = c;
    return !0;
  }, o.prototype._unpad = function(f) {
    if (this.padding === !1)
      return f;
    for (var u = f[f.length - 1], c = f.length - u; c < f.length; c++)
      t.equal(f[c], u);
    return f.slice(0, f.length - u);
  }, o.prototype._encrypt = function(f, u, c, d, l) {
    for (var h = u, y = c, b = 0; b < f.keys.length; b += 2) {
      var w = f.keys[b], A = f.keys[b + 1];
      r.expand(y, f.tmp, 0), w ^= f.tmp[0], A ^= f.tmp[1];
      var M = r.substitute(w, A), N = r.permute(M), G = y;
      y = (h ^ N) >>> 0, h = G;
    }
    r.rip(y, h, d, l);
  }, o.prototype._decrypt = function(f, u, c, d, l) {
    for (var h = c, y = u, b = f.keys.length - 2; b >= 0; b -= 2) {
      var w = f.keys[b], A = f.keys[b + 1];
      r.expand(h, f.tmp, 0), w ^= f.tmp[0], A ^= f.tmp[1];
      var M = r.substitute(w, A), N = r.permute(M), G = h;
      h = (y ^ N) >>> 0, y = G;
    }
    r.rip(h, y, d, l);
  }, Yd;
}
var Jd = {}, Ny;
function c_() {
  if (Ny)
    return Jd;
  Ny = 1;
  var t = On, e = Mt, r = {};
  function n(o) {
    t.equal(o.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var a = 0; a < this.iv.length; a++)
      this.iv[a] = o[a];
  }
  function i(o) {
    function a(c) {
      o.call(this, c), this._cbcInit();
    }
    e(a, o);
    for (var s = Object.keys(r), f = 0; f < s.length; f++) {
      var u = s[f];
      a.prototype[u] = r[u];
    }
    return a.create = function(d) {
      return new a(d);
    }, a;
  }
  return Jd.instantiate = i, r._cbcInit = function() {
    var a = new n(this.options.iv);
    this._cbcState = a;
  }, r._update = function(a, s, f, u) {
    var c = this._cbcState, d = this.constructor.super_.prototype, l = c.iv;
    if (this.type === "encrypt") {
      for (var h = 0; h < this.blockSize; h++)
        l[h] ^= a[s + h];
      d._update.call(this, l, 0, f, u);
      for (var h = 0; h < this.blockSize; h++)
        l[h] = f[u + h];
    } else {
      d._update.call(this, a, s, f, u);
      for (var h = 0; h < this.blockSize; h++)
        f[u + h] ^= l[h];
      for (var h = 0; h < this.blockSize; h++)
        l[h] = a[s + h];
    }
  }, Jd;
}
var Xd, Uy;
function u_() {
  if (Uy)
    return Xd;
  Uy = 1;
  var t = On, e = Mt, r = Rp(), n = v3();
  function i(a, s) {
    t.equal(s.length, 24, "Invalid key length");
    var f = s.slice(0, 8), u = s.slice(8, 16), c = s.slice(16, 24);
    a === "encrypt" ? this.ciphers = [
      n.create({ type: "encrypt", key: f }),
      n.create({ type: "decrypt", key: u }),
      n.create({ type: "encrypt", key: c })
    ] : this.ciphers = [
      n.create({ type: "decrypt", key: c }),
      n.create({ type: "encrypt", key: u }),
      n.create({ type: "decrypt", key: f })
    ];
  }
  function o(a) {
    r.call(this, a);
    var s = new i(this.type, this.options.key);
    this._edeState = s;
  }
  return e(o, r), Xd = o, o.create = function(s) {
    return new o(s);
  }, o.prototype._update = function(s, f, u, c) {
    var d = this._edeState;
    d.ciphers[0]._update(s, f, u, c), d.ciphers[1]._update(u, c, u, c), d.ciphers[2]._update(u, c, u, c);
  }, o.prototype._pad = n.prototype._pad, o.prototype._unpad = n.prototype._unpad, Xd;
}
var Fy;
function d_() {
  return Fy || (Fy = 1, oo.utils = b3(), oo.Cipher = Rp(), oo.DES = v3(), oo.CBC = c_(), oo.EDE = u_()), oo;
}
var Zd, Ly;
function l_() {
  if (Ly)
    return Zd;
  Ly = 1;
  var t = no, e = d_(), r = Mt, n = Et.Buffer, i = {
    "des-ede3-cbc": e.CBC.instantiate(e.EDE),
    "des-ede3": e.EDE,
    "des-ede-cbc": e.CBC.instantiate(e.EDE),
    "des-ede": e.EDE,
    "des-cbc": e.CBC.instantiate(e.DES),
    "des-ecb": e.DES
  };
  i.des = i["des-cbc"], i.des3 = i["des-ede3-cbc"], Zd = o, r(o, t);
  function o(a) {
    t.call(this);
    var s = a.mode.toLowerCase(), f = i[s], u;
    a.decrypt ? u = "decrypt" : u = "encrypt";
    var c = a.key;
    n.isBuffer(c) || (c = n.from(c)), (s === "des-ede" || s === "des-ede-cbc") && (c = n.concat([c, c.slice(0, 8)]));
    var d = a.iv;
    n.isBuffer(d) || (d = n.from(d)), this._des = f.create({
      key: c,
      iv: d,
      type: u
    });
  }
  return o.prototype._update = function(a) {
    return n.from(this._des.update(a));
  }, o.prototype._final = function() {
    return n.from(this._des.final());
  }, Zd;
}
var Nn = {}, Wf = {}, Hf = {}, jy;
function h_() {
  return jy || (jy = 1, Hf.encrypt = function(t, e) {
    return t._cipher.encryptBlock(e);
  }, Hf.decrypt = function(t, e) {
    return t._cipher.decryptBlock(e);
  }), Hf;
}
var Gf = {}, Qd, Dy;
function Mf() {
  return Dy || (Dy = 1, Qd = function(e, r) {
    for (var n = Math.min(e.length, r.length), i = new Ie(n), o = 0; o < n; ++o)
      i[o] = e[o] ^ r[o];
    return i;
  }), Qd;
}
var $y;
function p_() {
  if ($y)
    return Gf;
  $y = 1;
  var t = Mf();
  return Gf.encrypt = function(e, r) {
    var n = t(r, e._prev);
    return e._prev = e._cipher.encryptBlock(n), e._prev;
  }, Gf.decrypt = function(e, r) {
    var n = e._prev;
    e._prev = r;
    var i = e._cipher.decryptBlock(r);
    return t(i, n);
  }, Gf;
}
var el = {}, qy;
function y_() {
  if (qy)
    return el;
  qy = 1;
  var t = Et.Buffer, e = Mf();
  function r(n, i, o) {
    var a = i.length, s = e(i, n._cache);
    return n._cache = n._cache.slice(a), n._prev = t.concat([n._prev, o ? i : s]), s;
  }
  return el.encrypt = function(n, i, o) {
    for (var a = t.allocUnsafe(0), s; i.length; )
      if (n._cache.length === 0 && (n._cache = n._cipher.encryptBlock(n._prev), n._prev = t.allocUnsafe(0)), n._cache.length <= i.length)
        s = n._cache.length, a = t.concat([a, r(n, i.slice(0, s), o)]), i = i.slice(s);
      else {
        a = t.concat([a, r(n, i, o)]);
        break;
      }
    return a;
  }, el;
}
var tl = {}, zy;
function b_() {
  if (zy)
    return tl;
  zy = 1;
  var t = Et.Buffer;
  function e(r, n, i) {
    var o = r._cipher.encryptBlock(r._prev), a = o[0] ^ n;
    return r._prev = t.concat([
      r._prev.slice(1),
      t.from([i ? n : a])
    ]), a;
  }
  return tl.encrypt = function(r, n, i) {
    for (var o = n.length, a = t.allocUnsafe(o), s = -1; ++s < o; )
      a[s] = e(r, n[s], i);
    return a;
  }, tl;
}
var rl = {}, Ky;
function g_() {
  if (Ky)
    return rl;
  Ky = 1;
  var t = Et.Buffer;
  function e(n, i, o) {
    for (var a, s = -1, f = 8, u = 0, c, d; ++s < f; )
      a = n._cipher.encryptBlock(n._prev), c = i & 1 << 7 - s ? 128 : 0, d = a[0] ^ c, u += (d & 128) >> s % 8, n._prev = r(n._prev, o ? c : d);
    return u;
  }
  function r(n, i) {
    var o = n.length, a = -1, s = t.allocUnsafe(n.length);
    for (n = t.concat([n, t.from([i])]); ++a < o; )
      s[a] = n[a] << 1 | n[a + 1] >> 7;
    return s;
  }
  return rl.encrypt = function(n, i, o) {
    for (var a = i.length, s = t.allocUnsafe(a), f = -1; ++f < a; )
      s[f] = e(n, i[f], o);
    return s;
  }, rl;
}
var nl = {}, Wy;
function v_() {
  if (Wy)
    return nl;
  Wy = 1;
  var t = Mf();
  function e(r) {
    return r._prev = r._cipher.encryptBlock(r._prev), r._prev;
  }
  return nl.encrypt = function(r, n) {
    for (; r._cache.length < n.length; )
      r._cache = Ie.concat([r._cache, e(r)]);
    var i = r._cache.slice(0, n.length);
    return r._cache = r._cache.slice(n.length), t(n, i);
  }, nl;
}
var il = {}, ol, Hy;
function m3() {
  if (Hy)
    return ol;
  Hy = 1;
  function t(e) {
    for (var r = e.length, n; r--; )
      if (n = e.readUInt8(r), n === 255)
        e.writeUInt8(0, r);
      else {
        n++, e.writeUInt8(n, r);
        break;
      }
  }
  return ol = t, ol;
}
var Gy;
function Vy() {
  if (Gy)
    return il;
  Gy = 1;
  var t = Mf(), e = Et.Buffer, r = m3();
  function n(o) {
    var a = o._cipher.encryptBlockRaw(o._prev);
    return r(o._prev), a;
  }
  var i = 16;
  return il.encrypt = function(o, a) {
    var s = Math.ceil(a.length / i), f = o._cache.length;
    o._cache = e.concat([
      o._cache,
      e.allocUnsafe(s * i)
    ]);
    for (var u = 0; u < s; u++) {
      var c = n(o), d = f + u * i;
      o._cache.writeUInt32BE(c[0], d + 0), o._cache.writeUInt32BE(c[1], d + 4), o._cache.writeUInt32BE(c[2], d + 8), o._cache.writeUInt32BE(c[3], d + 12);
    }
    var l = o._cache.slice(0, a.length);
    return o._cache = o._cache.slice(a.length), t(a, l);
  }, il;
}
const m_ = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, w_ = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, x_ = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, w3 = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128: m_,
  aes192: w_,
  aes256: x_,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var al, Yy;
function Tp() {
  if (Yy)
    return al;
  Yy = 1;
  var t = {
    ECB: h_(),
    CBC: p_(),
    CFB: y_(),
    CFB8: b_(),
    CFB1: g_(),
    OFB: v_(),
    CTR: Vy(),
    GCM: Vy()
  }, e = w3;
  for (var r in e)
    e[r].module = t[e[r].mode];
  return al = e, al;
}
var sl = {}, Jy;
function Vu() {
  if (Jy)
    return sl;
  Jy = 1;
  var t = Et.Buffer;
  function e(s) {
    t.isBuffer(s) || (s = t.from(s));
    for (var f = s.length / 4 | 0, u = new Array(f), c = 0; c < f; c++)
      u[c] = s.readUInt32BE(c * 4);
    return u;
  }
  function r(s) {
    for (var f = 0; f < s.length; s++)
      s[f] = 0;
  }
  function n(s, f, u, c, d) {
    for (var l = u[0], h = u[1], y = u[2], b = u[3], w = s[0] ^ f[0], A = s[1] ^ f[1], M = s[2] ^ f[2], N = s[3] ^ f[3], G, z, J, oe, ee = 4, ae = 1; ae < d; ae++)
      G = l[w >>> 24] ^ h[A >>> 16 & 255] ^ y[M >>> 8 & 255] ^ b[N & 255] ^ f[ee++], z = l[A >>> 24] ^ h[M >>> 16 & 255] ^ y[N >>> 8 & 255] ^ b[w & 255] ^ f[ee++], J = l[M >>> 24] ^ h[N >>> 16 & 255] ^ y[w >>> 8 & 255] ^ b[A & 255] ^ f[ee++], oe = l[N >>> 24] ^ h[w >>> 16 & 255] ^ y[A >>> 8 & 255] ^ b[M & 255] ^ f[ee++], w = G, A = z, M = J, N = oe;
    return G = (c[w >>> 24] << 24 | c[A >>> 16 & 255] << 16 | c[M >>> 8 & 255] << 8 | c[N & 255]) ^ f[ee++], z = (c[A >>> 24] << 24 | c[M >>> 16 & 255] << 16 | c[N >>> 8 & 255] << 8 | c[w & 255]) ^ f[ee++], J = (c[M >>> 24] << 24 | c[N >>> 16 & 255] << 16 | c[w >>> 8 & 255] << 8 | c[A & 255]) ^ f[ee++], oe = (c[N >>> 24] << 24 | c[w >>> 16 & 255] << 16 | c[A >>> 8 & 255] << 8 | c[M & 255]) ^ f[ee++], G = G >>> 0, z = z >>> 0, J = J >>> 0, oe = oe >>> 0, [G, z, J, oe];
  }
  var i = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], o = function() {
    for (var s = new Array(256), f = 0; f < 256; f++)
      f < 128 ? s[f] = f << 1 : s[f] = f << 1 ^ 283;
    for (var u = [], c = [], d = [[], [], [], []], l = [[], [], [], []], h = 0, y = 0, b = 0; b < 256; ++b) {
      var w = y ^ y << 1 ^ y << 2 ^ y << 3 ^ y << 4;
      w = w >>> 8 ^ w & 255 ^ 99, u[h] = w, c[w] = h;
      var A = s[h], M = s[A], N = s[M], G = s[w] * 257 ^ w * 16843008;
      d[0][h] = G << 24 | G >>> 8, d[1][h] = G << 16 | G >>> 16, d[2][h] = G << 8 | G >>> 24, d[3][h] = G, G = N * 16843009 ^ M * 65537 ^ A * 257 ^ h * 16843008, l[0][w] = G << 24 | G >>> 8, l[1][w] = G << 16 | G >>> 16, l[2][w] = G << 8 | G >>> 24, l[3][w] = G, h === 0 ? h = y = 1 : (h = A ^ s[s[s[N ^ A]]], y ^= s[s[y]]);
    }
    return {
      SBOX: u,
      INV_SBOX: c,
      SUB_MIX: d,
      INV_SUB_MIX: l
    };
  }();
  function a(s) {
    this._key = e(s), this._reset();
  }
  return a.blockSize = 4 * 4, a.keySize = 256 / 8, a.prototype.blockSize = a.blockSize, a.prototype.keySize = a.keySize, a.prototype._reset = function() {
    for (var s = this._key, f = s.length, u = f + 6, c = (u + 1) * 4, d = [], l = 0; l < f; l++)
      d[l] = s[l];
    for (l = f; l < c; l++) {
      var h = d[l - 1];
      l % f === 0 ? (h = h << 8 | h >>> 24, h = o.SBOX[h >>> 24] << 24 | o.SBOX[h >>> 16 & 255] << 16 | o.SBOX[h >>> 8 & 255] << 8 | o.SBOX[h & 255], h ^= i[l / f | 0] << 24) : f > 6 && l % f === 4 && (h = o.SBOX[h >>> 24] << 24 | o.SBOX[h >>> 16 & 255] << 16 | o.SBOX[h >>> 8 & 255] << 8 | o.SBOX[h & 255]), d[l] = d[l - f] ^ h;
    }
    for (var y = [], b = 0; b < c; b++) {
      var w = c - b, A = d[w - (b % 4 ? 0 : 4)];
      b < 4 || w <= 4 ? y[b] = A : y[b] = o.INV_SUB_MIX[0][o.SBOX[A >>> 24]] ^ o.INV_SUB_MIX[1][o.SBOX[A >>> 16 & 255]] ^ o.INV_SUB_MIX[2][o.SBOX[A >>> 8 & 255]] ^ o.INV_SUB_MIX[3][o.SBOX[A & 255]];
    }
    this._nRounds = u, this._keySchedule = d, this._invKeySchedule = y;
  }, a.prototype.encryptBlockRaw = function(s) {
    return s = e(s), n(s, this._keySchedule, o.SUB_MIX, o.SBOX, this._nRounds);
  }, a.prototype.encryptBlock = function(s) {
    var f = this.encryptBlockRaw(s), u = t.allocUnsafe(16);
    return u.writeUInt32BE(f[0], 0), u.writeUInt32BE(f[1], 4), u.writeUInt32BE(f[2], 8), u.writeUInt32BE(f[3], 12), u;
  }, a.prototype.decryptBlock = function(s) {
    s = e(s);
    var f = s[1];
    s[1] = s[3], s[3] = f;
    var u = n(s, this._invKeySchedule, o.INV_SUB_MIX, o.INV_SBOX, this._nRounds), c = t.allocUnsafe(16);
    return c.writeUInt32BE(u[0], 0), c.writeUInt32BE(u[3], 4), c.writeUInt32BE(u[2], 8), c.writeUInt32BE(u[1], 12), c;
  }, a.prototype.scrub = function() {
    r(this._keySchedule), r(this._invKeySchedule), r(this._key);
  }, sl.AES = a, sl;
}
var fl, Xy;
function __() {
  if (Xy)
    return fl;
  Xy = 1;
  var t = Et.Buffer, e = t.alloc(16, 0);
  function r(o) {
    return [
      o.readUInt32BE(0),
      o.readUInt32BE(4),
      o.readUInt32BE(8),
      o.readUInt32BE(12)
    ];
  }
  function n(o) {
    var a = t.allocUnsafe(16);
    return a.writeUInt32BE(o[0] >>> 0, 0), a.writeUInt32BE(o[1] >>> 0, 4), a.writeUInt32BE(o[2] >>> 0, 8), a.writeUInt32BE(o[3] >>> 0, 12), a;
  }
  function i(o) {
    this.h = o, this.state = t.alloc(16, 0), this.cache = t.allocUnsafe(0);
  }
  return i.prototype.ghash = function(o) {
    for (var a = -1; ++a < o.length; )
      this.state[a] ^= o[a];
    this._multiply();
  }, i.prototype._multiply = function() {
    for (var o = r(this.h), a = [0, 0, 0, 0], s, f, u, c = -1; ++c < 128; ) {
      for (f = (this.state[~~(c / 8)] & 1 << 7 - c % 8) !== 0, f && (a[0] ^= o[0], a[1] ^= o[1], a[2] ^= o[2], a[3] ^= o[3]), u = (o[3] & 1) !== 0, s = 3; s > 0; s--)
        o[s] = o[s] >>> 1 | (o[s - 1] & 1) << 31;
      o[0] = o[0] >>> 1, u && (o[0] = o[0] ^ 225 << 24);
    }
    this.state = n(a);
  }, i.prototype.update = function(o) {
    this.cache = t.concat([this.cache, o]);
    for (var a; this.cache.length >= 16; )
      a = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(a);
  }, i.prototype.final = function(o, a) {
    return this.cache.length && this.ghash(t.concat([this.cache, e], 16)), this.ghash(n([0, o, 0, a])), this.state;
  }, fl = i, fl;
}
var cl, Zy;
function x3() {
  if (Zy)
    return cl;
  Zy = 1;
  var t = Vu(), e = Et.Buffer, r = no, n = Mt, i = __(), o = Mf(), a = m3();
  function s(c, d) {
    var l = 0;
    c.length !== d.length && l++;
    for (var h = Math.min(c.length, d.length), y = 0; y < h; ++y)
      l += c[y] ^ d[y];
    return l;
  }
  function f(c, d, l) {
    if (d.length === 12)
      return c._finID = e.concat([d, e.from([0, 0, 0, 1])]), e.concat([d, e.from([0, 0, 0, 2])]);
    var h = new i(l), y = d.length, b = y % 16;
    h.update(d), b && (b = 16 - b, h.update(e.alloc(b, 0))), h.update(e.alloc(8, 0));
    var w = y * 8, A = e.alloc(8);
    A.writeUIntBE(w, 0, 8), h.update(A), c._finID = h.state;
    var M = e.from(c._finID);
    return a(M), M;
  }
  function u(c, d, l, h) {
    r.call(this);
    var y = e.alloc(4, 0);
    this._cipher = new t.AES(d);
    var b = this._cipher.encryptBlock(y);
    this._ghash = new i(b), l = f(this, l, b), this._prev = e.from(l), this._cache = e.allocUnsafe(0), this._secCache = e.allocUnsafe(0), this._decrypt = h, this._alen = 0, this._len = 0, this._mode = c, this._authTag = null, this._called = !1;
  }
  return n(u, r), u.prototype._update = function(c) {
    if (!this._called && this._alen) {
      var d = 16 - this._alen % 16;
      d < 16 && (d = e.alloc(d, 0), this._ghash.update(d));
    }
    this._called = !0;
    var l = this._mode.encrypt(this, c);
    return this._decrypt ? this._ghash.update(c) : this._ghash.update(l), this._len += c.length, l;
  }, u.prototype._final = function() {
    if (this._decrypt && !this._authTag)
      throw new Error("Unsupported state or unable to authenticate data");
    var c = o(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && s(c, this._authTag))
      throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = c, this._cipher.scrub();
  }, u.prototype.getAuthTag = function() {
    if (this._decrypt || !e.isBuffer(this._authTag))
      throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, u.prototype.setAuthTag = function(d) {
    if (!this._decrypt)
      throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = d;
  }, u.prototype.setAAD = function(d) {
    if (this._called)
      throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(d), this._alen += d.length;
  }, cl = u, cl;
}
var ul, Qy;
function _3() {
  if (Qy)
    return ul;
  Qy = 1;
  var t = Vu(), e = Et.Buffer, r = no, n = Mt;
  function i(o, a, s, f) {
    r.call(this), this._cipher = new t.AES(a), this._prev = e.from(s), this._cache = e.allocUnsafe(0), this._secCache = e.allocUnsafe(0), this._decrypt = f, this._mode = o;
  }
  return n(i, r), i.prototype._update = function(o) {
    return this._mode.encrypt(this, o, this._decrypt);
  }, i.prototype._final = function() {
    this._cipher.scrub();
  }, ul = i, ul;
}
var dl, eb;
function Yu() {
  if (eb)
    return dl;
  eb = 1;
  var t = Et.Buffer, e = Bp;
  function r(n, i, o, a) {
    if (t.isBuffer(n) || (n = t.from(n, "binary")), i && (t.isBuffer(i) || (i = t.from(i, "binary")), i.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var s = o / 8, f = t.alloc(s), u = t.alloc(a || 0), c = t.alloc(0); s > 0 || a > 0; ) {
      var d = new e();
      d.update(c), d.update(n), i && d.update(i), c = d.digest();
      var l = 0;
      if (s > 0) {
        var h = f.length - s;
        l = Math.min(s, c.length), c.copy(f, h, 0, l), s -= l;
      }
      if (l < c.length && a > 0) {
        var y = u.length - a, b = Math.min(a, c.length - l);
        c.copy(u, y, l, l + b), a -= b;
      }
    }
    return c.fill(0), { key: f, iv: u };
  }
  return dl = r, dl;
}
var tb;
function E_() {
  if (tb)
    return Wf;
  tb = 1;
  var t = Tp(), e = x3(), r = Et.Buffer, n = _3(), i = no, o = Vu(), a = Yu(), s = Mt;
  function f(h, y, b) {
    i.call(this), this._cache = new c(), this._cipher = new o.AES(y), this._prev = r.from(b), this._mode = h, this._autopadding = !0;
  }
  s(f, i), f.prototype._update = function(h) {
    this._cache.add(h);
    for (var y, b, w = []; y = this._cache.get(); )
      b = this._mode.encrypt(this, y), w.push(b);
    return r.concat(w);
  };
  var u = r.alloc(16, 16);
  f.prototype._final = function() {
    var h = this._cache.flush();
    if (this._autopadding)
      return h = this._mode.encrypt(this, h), this._cipher.scrub(), h;
    if (!h.equals(u))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, f.prototype.setAutoPadding = function(h) {
    return this._autopadding = !!h, this;
  };
  function c() {
    this.cache = r.allocUnsafe(0);
  }
  c.prototype.add = function(h) {
    this.cache = r.concat([this.cache, h]);
  }, c.prototype.get = function() {
    if (this.cache.length > 15) {
      var h = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), h;
    }
    return null;
  }, c.prototype.flush = function() {
    for (var h = 16 - this.cache.length, y = r.allocUnsafe(h), b = -1; ++b < h; )
      y.writeUInt8(h, b);
    return r.concat([this.cache, y]);
  };
  function d(h, y, b) {
    var w = t[h.toLowerCase()];
    if (!w)
      throw new TypeError("invalid suite type");
    if (typeof y == "string" && (y = r.from(y)), y.length !== w.key / 8)
      throw new TypeError("invalid key length " + y.length);
    if (typeof b == "string" && (b = r.from(b)), w.mode !== "GCM" && b.length !== w.iv)
      throw new TypeError("invalid iv length " + b.length);
    return w.type === "stream" ? new n(w.module, y, b) : w.type === "auth" ? new e(w.module, y, b) : new f(w.module, y, b);
  }
  function l(h, y) {
    var b = t[h.toLowerCase()];
    if (!b)
      throw new TypeError("invalid suite type");
    var w = a(y, !1, b.key, b.iv);
    return d(h, w.key, w.iv);
  }
  return Wf.createCipheriv = d, Wf.createCipher = l, Wf;
}
var Vf = {}, rb;
function S_() {
  if (rb)
    return Vf;
  rb = 1;
  var t = x3(), e = Et.Buffer, r = Tp(), n = _3(), i = no, o = Vu(), a = Yu(), s = Mt;
  function f(h, y, b) {
    i.call(this), this._cache = new u(), this._last = void 0, this._cipher = new o.AES(y), this._prev = e.from(b), this._mode = h, this._autopadding = !0;
  }
  s(f, i), f.prototype._update = function(h) {
    this._cache.add(h);
    for (var y, b, w = []; y = this._cache.get(this._autopadding); )
      b = this._mode.decrypt(this, y), w.push(b);
    return e.concat(w);
  }, f.prototype._final = function() {
    var h = this._cache.flush();
    if (this._autopadding)
      return c(this._mode.decrypt(this, h));
    if (h)
      throw new Error("data not multiple of block length");
  }, f.prototype.setAutoPadding = function(h) {
    return this._autopadding = !!h, this;
  };
  function u() {
    this.cache = e.allocUnsafe(0);
  }
  u.prototype.add = function(h) {
    this.cache = e.concat([this.cache, h]);
  }, u.prototype.get = function(h) {
    var y;
    if (h) {
      if (this.cache.length > 16)
        return y = this.cache.slice(0, 16), this.cache = this.cache.slice(16), y;
    } else if (this.cache.length >= 16)
      return y = this.cache.slice(0, 16), this.cache = this.cache.slice(16), y;
    return null;
  }, u.prototype.flush = function() {
    if (this.cache.length)
      return this.cache;
  };
  function c(h) {
    var y = h[15];
    if (y < 1 || y > 16)
      throw new Error("unable to decrypt data");
    for (var b = -1; ++b < y; )
      if (h[b + (16 - y)] !== y)
        throw new Error("unable to decrypt data");
    if (y !== 16)
      return h.slice(0, 16 - y);
  }
  function d(h, y, b) {
    var w = r[h.toLowerCase()];
    if (!w)
      throw new TypeError("invalid suite type");
    if (typeof b == "string" && (b = e.from(b)), w.mode !== "GCM" && b.length !== w.iv)
      throw new TypeError("invalid iv length " + b.length);
    if (typeof y == "string" && (y = e.from(y)), y.length !== w.key / 8)
      throw new TypeError("invalid key length " + y.length);
    return w.type === "stream" ? new n(w.module, y, b, !0) : w.type === "auth" ? new t(w.module, y, b, !0) : new f(w.module, y, b);
  }
  function l(h, y) {
    var b = r[h.toLowerCase()];
    if (!b)
      throw new TypeError("invalid suite type");
    var w = a(y, !1, b.key, b.iv);
    return d(h, w.key, w.iv);
  }
  return Vf.createDecipher = l, Vf.createDecipheriv = d, Vf;
}
var nb;
function Op() {
  if (nb)
    return Nn;
  nb = 1;
  var t = E_(), e = S_(), r = w3;
  function n() {
    return Object.keys(r);
  }
  return Nn.createCipher = Nn.Cipher = t.createCipher, Nn.createCipheriv = Nn.Cipheriv = t.createCipheriv, Nn.createDecipher = Nn.Decipher = e.createDecipher, Nn.createDecipheriv = Nn.Decipheriv = e.createDecipheriv, Nn.listCiphers = Nn.getCiphers = n, Nn;
}
var ll = {}, ib;
function A_() {
  return ib || (ib = 1, function(t) {
    t["des-ecb"] = {
      key: 8,
      iv: 0
    }, t["des-cbc"] = t.des = {
      key: 8,
      iv: 8
    }, t["des-ede3-cbc"] = t.des3 = {
      key: 24,
      iv: 8
    }, t["des-ede3"] = {
      key: 24,
      iv: 0
    }, t["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, t["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(ll)), ll;
}
var ob;
function I_() {
  if (ob)
    return Pn;
  ob = 1;
  var t = l_(), e = Op(), r = Tp(), n = A_(), i = Yu();
  function o(c, d) {
    c = c.toLowerCase();
    var l, h;
    if (r[c])
      l = r[c].key, h = r[c].iv;
    else if (n[c])
      l = n[c].key * 8, h = n[c].iv;
    else
      throw new TypeError("invalid suite type");
    var y = i(d, !1, l, h);
    return s(c, y.key, y.iv);
  }
  function a(c, d) {
    c = c.toLowerCase();
    var l, h;
    if (r[c])
      l = r[c].key, h = r[c].iv;
    else if (n[c])
      l = n[c].key * 8, h = n[c].iv;
    else
      throw new TypeError("invalid suite type");
    var y = i(d, !1, l, h);
    return f(c, y.key, y.iv);
  }
  function s(c, d, l) {
    if (c = c.toLowerCase(), r[c])
      return e.createCipheriv(c, d, l);
    if (n[c])
      return new t({ key: d, iv: l, mode: c });
    throw new TypeError("invalid suite type");
  }
  function f(c, d, l) {
    if (c = c.toLowerCase(), r[c])
      return e.createDecipheriv(c, d, l);
    if (n[c])
      return new t({ key: d, iv: l, mode: c, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function u() {
    return Object.keys(n).concat(e.getCiphers());
  }
  return Pn.createCipher = Pn.Cipher = o, Pn.createCipheriv = Pn.Cipheriv = s, Pn.createDecipher = Pn.Decipher = a, Pn.createDecipheriv = Pn.Decipheriv = f, Pn.listCiphers = Pn.getCiphers = u, Pn;
}
var ao = {}, kp = { exports: {} };
kp.exports;
(function(t) {
  (function(e, r) {
    function n(F, v) {
      if (!F)
        throw new Error(v || "Assertion failed");
    }
    function i(F, v) {
      F.super_ = v;
      var B = function() {
      };
      B.prototype = v.prototype, F.prototype = new B(), F.prototype.constructor = F;
    }
    function o(F, v, B) {
      if (o.isBN(F))
        return F;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, F !== null && ((v === "le" || v === "be") && (B = v, v = 10), this._init(F || 0, v || 10, B || "be"));
    }
    typeof e == "object" ? e.exports = o : r.BN = o, o.BN = o, o.wordSize = 26;
    var a;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? a = window.Buffer : a = _p.Buffer;
    } catch {
    }
    o.isBN = function(v) {
      return v instanceof o ? !0 : v !== null && typeof v == "object" && v.constructor.wordSize === o.wordSize && Array.isArray(v.words);
    }, o.max = function(v, B) {
      return v.cmp(B) > 0 ? v : B;
    }, o.min = function(v, B) {
      return v.cmp(B) < 0 ? v : B;
    }, o.prototype._init = function(v, B, P) {
      if (typeof v == "number")
        return this._initNumber(v, B, P);
      if (typeof v == "object")
        return this._initArray(v, B, P);
      B === "hex" && (B = 16), n(B === (B | 0) && B >= 2 && B <= 36), v = v.toString().replace(/\s+/g, "");
      var L = 0;
      v[0] === "-" && (L++, this.negative = 1), L < v.length && (B === 16 ? this._parseHex(v, L, P) : (this._parseBase(v, B, L), P === "le" && this._initArray(this.toArray(), B, P)));
    }, o.prototype._initNumber = function(v, B, P) {
      v < 0 && (this.negative = 1, v = -v), v < 67108864 ? (this.words = [v & 67108863], this.length = 1) : v < 4503599627370496 ? (this.words = [
        v & 67108863,
        v / 67108864 & 67108863
      ], this.length = 2) : (n(v < 9007199254740992), this.words = [
        v & 67108863,
        v / 67108864 & 67108863,
        1
      ], this.length = 3), P === "le" && this._initArray(this.toArray(), B, P);
    }, o.prototype._initArray = function(v, B, P) {
      if (n(typeof v.length == "number"), v.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(v.length / 3), this.words = new Array(this.length);
      for (var L = 0; L < this.length; L++)
        this.words[L] = 0;
      var x, C, j = 0;
      if (P === "be")
        for (L = v.length - 1, x = 0; L >= 0; L -= 3)
          C = v[L] | v[L - 1] << 8 | v[L - 2] << 16, this.words[x] |= C << j & 67108863, this.words[x + 1] = C >>> 26 - j & 67108863, j += 24, j >= 26 && (j -= 26, x++);
      else if (P === "le")
        for (L = 0, x = 0; L < v.length; L += 3)
          C = v[L] | v[L + 1] << 8 | v[L + 2] << 16, this.words[x] |= C << j & 67108863, this.words[x + 1] = C >>> 26 - j & 67108863, j += 24, j >= 26 && (j -= 26, x++);
      return this._strip();
    };
    function s(F, v) {
      var B = F.charCodeAt(v);
      if (B >= 48 && B <= 57)
        return B - 48;
      if (B >= 65 && B <= 70)
        return B - 55;
      if (B >= 97 && B <= 102)
        return B - 87;
      n(!1, "Invalid character in " + F);
    }
    function f(F, v, B) {
      var P = s(F, B);
      return B - 1 >= v && (P |= s(F, B - 1) << 4), P;
    }
    o.prototype._parseHex = function(v, B, P) {
      this.length = Math.ceil((v.length - B) / 6), this.words = new Array(this.length);
      for (var L = 0; L < this.length; L++)
        this.words[L] = 0;
      var x = 0, C = 0, j;
      if (P === "be")
        for (L = v.length - 1; L >= B; L -= 2)
          j = f(v, B, L) << x, this.words[C] |= j & 67108863, x >= 18 ? (x -= 18, C += 1, this.words[C] |= j >>> 26) : x += 8;
      else {
        var k = v.length - B;
        for (L = k % 2 === 0 ? B + 1 : B; L < v.length; L += 2)
          j = f(v, B, L) << x, this.words[C] |= j & 67108863, x >= 18 ? (x -= 18, C += 1, this.words[C] |= j >>> 26) : x += 8;
      }
      this._strip();
    };
    function u(F, v, B, P) {
      for (var L = 0, x = 0, C = Math.min(F.length, B), j = v; j < C; j++) {
        var k = F.charCodeAt(j) - 48;
        L *= P, k >= 49 ? x = k - 49 + 10 : k >= 17 ? x = k - 17 + 10 : x = k, n(k >= 0 && x < P, "Invalid character"), L += x;
      }
      return L;
    }
    o.prototype._parseBase = function(v, B, P) {
      this.words = [0], this.length = 1;
      for (var L = 0, x = 1; x <= 67108863; x *= B)
        L++;
      L--, x = x / B | 0;
      for (var C = v.length - P, j = C % L, k = Math.min(C, C - j) + P, g = 0, R = P; R < k; R += L)
        g = u(v, R, R + L, B), this.imuln(x), this.words[0] + g < 67108864 ? this.words[0] += g : this._iaddn(g);
      if (j !== 0) {
        var X = 1;
        for (g = u(v, R, v.length, B), R = 0; R < j; R++)
          X *= B;
        this.imuln(X), this.words[0] + g < 67108864 ? this.words[0] += g : this._iaddn(g);
      }
      this._strip();
    }, o.prototype.copy = function(v) {
      v.words = new Array(this.length);
      for (var B = 0; B < this.length; B++)
        v.words[B] = this.words[B];
      v.length = this.length, v.negative = this.negative, v.red = this.red;
    };
    function c(F, v) {
      F.words = v.words, F.length = v.length, F.negative = v.negative, F.red = v.red;
    }
    if (o.prototype._move = function(v) {
      c(v, this);
    }, o.prototype.clone = function() {
      var v = new o(null);
      return this.copy(v), v;
    }, o.prototype._expand = function(v) {
      for (; this.length < v; )
        this.words[this.length++] = 0;
      return this;
    }, o.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, o.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        o.prototype[Symbol.for("nodejs.util.inspect.custom")] = d;
      } catch {
        o.prototype.inspect = d;
      }
    else
      o.prototype.inspect = d;
    function d() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var l = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], h = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], y = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    o.prototype.toString = function(v, B) {
      v = v || 10, B = B | 0 || 1;
      var P;
      if (v === 16 || v === "hex") {
        P = "";
        for (var L = 0, x = 0, C = 0; C < this.length; C++) {
          var j = this.words[C], k = ((j << L | x) & 16777215).toString(16);
          x = j >>> 24 - L & 16777215, L += 2, L >= 26 && (L -= 26, C--), x !== 0 || C !== this.length - 1 ? P = l[6 - k.length] + k + P : P = k + P;
        }
        for (x !== 0 && (P = x.toString(16) + P); P.length % B !== 0; )
          P = "0" + P;
        return this.negative !== 0 && (P = "-" + P), P;
      }
      if (v === (v | 0) && v >= 2 && v <= 36) {
        var g = h[v], R = y[v];
        P = "";
        var X = this.clone();
        for (X.negative = 0; !X.isZero(); ) {
          var re = X.modrn(R).toString(v);
          X = X.idivn(R), X.isZero() ? P = re + P : P = l[g - re.length] + re + P;
        }
        for (this.isZero() && (P = "0" + P); P.length % B !== 0; )
          P = "0" + P;
        return this.negative !== 0 && (P = "-" + P), P;
      }
      n(!1, "Base should be between 2 and 36");
    }, o.prototype.toNumber = function() {
      var v = this.words[0];
      return this.length === 2 ? v += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? v += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && n(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -v : v;
    }, o.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, a && (o.prototype.toBuffer = function(v, B) {
      return this.toArrayLike(a, v, B);
    }), o.prototype.toArray = function(v, B) {
      return this.toArrayLike(Array, v, B);
    };
    var b = function(v, B) {
      return v.allocUnsafe ? v.allocUnsafe(B) : new v(B);
    };
    o.prototype.toArrayLike = function(v, B, P) {
      this._strip();
      var L = this.byteLength(), x = P || Math.max(1, L);
      n(L <= x, "byte array longer than desired length"), n(x > 0, "Requested array length <= 0");
      var C = b(v, x), j = B === "le" ? "LE" : "BE";
      return this["_toArrayLike" + j](C, L), C;
    }, o.prototype._toArrayLikeLE = function(v, B) {
      for (var P = 0, L = 0, x = 0, C = 0; x < this.length; x++) {
        var j = this.words[x] << C | L;
        v[P++] = j & 255, P < v.length && (v[P++] = j >> 8 & 255), P < v.length && (v[P++] = j >> 16 & 255), C === 6 ? (P < v.length && (v[P++] = j >> 24 & 255), L = 0, C = 0) : (L = j >>> 24, C += 2);
      }
      if (P < v.length)
        for (v[P++] = L; P < v.length; )
          v[P++] = 0;
    }, o.prototype._toArrayLikeBE = function(v, B) {
      for (var P = v.length - 1, L = 0, x = 0, C = 0; x < this.length; x++) {
        var j = this.words[x] << C | L;
        v[P--] = j & 255, P >= 0 && (v[P--] = j >> 8 & 255), P >= 0 && (v[P--] = j >> 16 & 255), C === 6 ? (P >= 0 && (v[P--] = j >> 24 & 255), L = 0, C = 0) : (L = j >>> 24, C += 2);
      }
      if (P >= 0)
        for (v[P--] = L; P >= 0; )
          v[P--] = 0;
    }, Math.clz32 ? o.prototype._countBits = function(v) {
      return 32 - Math.clz32(v);
    } : o.prototype._countBits = function(v) {
      var B = v, P = 0;
      return B >= 4096 && (P += 13, B >>>= 13), B >= 64 && (P += 7, B >>>= 7), B >= 8 && (P += 4, B >>>= 4), B >= 2 && (P += 2, B >>>= 2), P + B;
    }, o.prototype._zeroBits = function(v) {
      if (v === 0)
        return 26;
      var B = v, P = 0;
      return B & 8191 || (P += 13, B >>>= 13), B & 127 || (P += 7, B >>>= 7), B & 15 || (P += 4, B >>>= 4), B & 3 || (P += 2, B >>>= 2), B & 1 || P++, P;
    }, o.prototype.bitLength = function() {
      var v = this.words[this.length - 1], B = this._countBits(v);
      return (this.length - 1) * 26 + B;
    };
    function w(F) {
      for (var v = new Array(F.bitLength()), B = 0; B < v.length; B++) {
        var P = B / 26 | 0, L = B % 26;
        v[B] = F.words[P] >>> L & 1;
      }
      return v;
    }
    o.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var v = 0, B = 0; B < this.length; B++) {
        var P = this._zeroBits(this.words[B]);
        if (v += P, P !== 26)
          break;
      }
      return v;
    }, o.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, o.prototype.toTwos = function(v) {
      return this.negative !== 0 ? this.abs().inotn(v).iaddn(1) : this.clone();
    }, o.prototype.fromTwos = function(v) {
      return this.testn(v - 1) ? this.notn(v).iaddn(1).ineg() : this.clone();
    }, o.prototype.isNeg = function() {
      return this.negative !== 0;
    }, o.prototype.neg = function() {
      return this.clone().ineg();
    }, o.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, o.prototype.iuor = function(v) {
      for (; this.length < v.length; )
        this.words[this.length++] = 0;
      for (var B = 0; B < v.length; B++)
        this.words[B] = this.words[B] | v.words[B];
      return this._strip();
    }, o.prototype.ior = function(v) {
      return n((this.negative | v.negative) === 0), this.iuor(v);
    }, o.prototype.or = function(v) {
      return this.length > v.length ? this.clone().ior(v) : v.clone().ior(this);
    }, o.prototype.uor = function(v) {
      return this.length > v.length ? this.clone().iuor(v) : v.clone().iuor(this);
    }, o.prototype.iuand = function(v) {
      var B;
      this.length > v.length ? B = v : B = this;
      for (var P = 0; P < B.length; P++)
        this.words[P] = this.words[P] & v.words[P];
      return this.length = B.length, this._strip();
    }, o.prototype.iand = function(v) {
      return n((this.negative | v.negative) === 0), this.iuand(v);
    }, o.prototype.and = function(v) {
      return this.length > v.length ? this.clone().iand(v) : v.clone().iand(this);
    }, o.prototype.uand = function(v) {
      return this.length > v.length ? this.clone().iuand(v) : v.clone().iuand(this);
    }, o.prototype.iuxor = function(v) {
      var B, P;
      this.length > v.length ? (B = this, P = v) : (B = v, P = this);
      for (var L = 0; L < P.length; L++)
        this.words[L] = B.words[L] ^ P.words[L];
      if (this !== B)
        for (; L < B.length; L++)
          this.words[L] = B.words[L];
      return this.length = B.length, this._strip();
    }, o.prototype.ixor = function(v) {
      return n((this.negative | v.negative) === 0), this.iuxor(v);
    }, o.prototype.xor = function(v) {
      return this.length > v.length ? this.clone().ixor(v) : v.clone().ixor(this);
    }, o.prototype.uxor = function(v) {
      return this.length > v.length ? this.clone().iuxor(v) : v.clone().iuxor(this);
    }, o.prototype.inotn = function(v) {
      n(typeof v == "number" && v >= 0);
      var B = Math.ceil(v / 26) | 0, P = v % 26;
      this._expand(B), P > 0 && B--;
      for (var L = 0; L < B; L++)
        this.words[L] = ~this.words[L] & 67108863;
      return P > 0 && (this.words[L] = ~this.words[L] & 67108863 >> 26 - P), this._strip();
    }, o.prototype.notn = function(v) {
      return this.clone().inotn(v);
    }, o.prototype.setn = function(v, B) {
      n(typeof v == "number" && v >= 0);
      var P = v / 26 | 0, L = v % 26;
      return this._expand(P + 1), B ? this.words[P] = this.words[P] | 1 << L : this.words[P] = this.words[P] & ~(1 << L), this._strip();
    }, o.prototype.iadd = function(v) {
      var B;
      if (this.negative !== 0 && v.negative === 0)
        return this.negative = 0, B = this.isub(v), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && v.negative !== 0)
        return v.negative = 0, B = this.isub(v), v.negative = 1, B._normSign();
      var P, L;
      this.length > v.length ? (P = this, L = v) : (P = v, L = this);
      for (var x = 0, C = 0; C < L.length; C++)
        B = (P.words[C] | 0) + (L.words[C] | 0) + x, this.words[C] = B & 67108863, x = B >>> 26;
      for (; x !== 0 && C < P.length; C++)
        B = (P.words[C] | 0) + x, this.words[C] = B & 67108863, x = B >>> 26;
      if (this.length = P.length, x !== 0)
        this.words[this.length] = x, this.length++;
      else if (P !== this)
        for (; C < P.length; C++)
          this.words[C] = P.words[C];
      return this;
    }, o.prototype.add = function(v) {
      var B;
      return v.negative !== 0 && this.negative === 0 ? (v.negative = 0, B = this.sub(v), v.negative ^= 1, B) : v.negative === 0 && this.negative !== 0 ? (this.negative = 0, B = v.sub(this), this.negative = 1, B) : this.length > v.length ? this.clone().iadd(v) : v.clone().iadd(this);
    }, o.prototype.isub = function(v) {
      if (v.negative !== 0) {
        v.negative = 0;
        var B = this.iadd(v);
        return v.negative = 1, B._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(v), this.negative = 1, this._normSign();
      var P = this.cmp(v);
      if (P === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var L, x;
      P > 0 ? (L = this, x = v) : (L = v, x = this);
      for (var C = 0, j = 0; j < x.length; j++)
        B = (L.words[j] | 0) - (x.words[j] | 0) + C, C = B >> 26, this.words[j] = B & 67108863;
      for (; C !== 0 && j < L.length; j++)
        B = (L.words[j] | 0) + C, C = B >> 26, this.words[j] = B & 67108863;
      if (C === 0 && j < L.length && L !== this)
        for (; j < L.length; j++)
          this.words[j] = L.words[j];
      return this.length = Math.max(this.length, j), L !== this && (this.negative = 1), this._strip();
    }, o.prototype.sub = function(v) {
      return this.clone().isub(v);
    };
    function A(F, v, B) {
      B.negative = v.negative ^ F.negative;
      var P = F.length + v.length | 0;
      B.length = P, P = P - 1 | 0;
      var L = F.words[0] | 0, x = v.words[0] | 0, C = L * x, j = C & 67108863, k = C / 67108864 | 0;
      B.words[0] = j;
      for (var g = 1; g < P; g++) {
        for (var R = k >>> 26, X = k & 67108863, re = Math.min(g, v.length - 1), V = Math.max(0, g - F.length + 1); V <= re; V++) {
          var $ = g - V | 0;
          L = F.words[$] | 0, x = v.words[V] | 0, C = L * x + X, R += C / 67108864 | 0, X = C & 67108863;
        }
        B.words[g] = X | 0, k = R | 0;
      }
      return k !== 0 ? B.words[g] = k | 0 : B.length--, B._strip();
    }
    var M = function(v, B, P) {
      var L = v.words, x = B.words, C = P.words, j = 0, k, g, R, X = L[0] | 0, re = X & 8191, V = X >>> 13, $ = L[1] | 0, W = $ & 8191, Z = $ >>> 13, fe = L[2] | 0, D = fe & 8191, K = fe >>> 13, he = L[3] | 0, be = he & 8191, Ce = he >>> 13, je = L[4] | 0, Ue = je & 8191, Qe = je >>> 13, we = L[5] | 0, at = we & 8191, rt = we >>> 13, It = L[6] | 0, it = It & 8191, se = It >>> 13, ue = L[7] | 0, Ee = ue & 8191, U = ue >>> 13, S = L[8] | 0, I = S & 8191, _ = S >>> 13, p = L[9] | 0, m = p & 8191, O = p >>> 13, Q = x[0] | 0, ie = Q & 8191, ce = Q >>> 13, Ne = x[1] | 0, Te = Ne & 8191, Je = Ne >>> 13, Dt = x[2] | 0, nt = Dt & 8191, ur = Dt >>> 13, Mi = x[3] | 0, Lt = Mi & 8191, Wt = Mi >>> 13, pn = x[4] | 0, tr = pn & 8191, rr = pn >>> 13, fi = x[5] | 0, dr = fi & 8191, Rt = fi >>> 13, ci = x[6] | 0, T = ci & 8191, q = ci >>> 13, H = x[7] | 0, E = H & 8191, Y = H >>> 13, le = x[8] | 0, de = le & 8191, xe = le >>> 13, Re = x[9] | 0, Fe = Re & 8191, ke = Re >>> 13;
      P.negative = v.negative ^ B.negative, P.length = 19, k = Math.imul(re, ie), g = Math.imul(re, ce), g = g + Math.imul(V, ie) | 0, R = Math.imul(V, ce);
      var Pt = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (Pt >>> 26) | 0, Pt &= 67108863, k = Math.imul(W, ie), g = Math.imul(W, ce), g = g + Math.imul(Z, ie) | 0, R = Math.imul(Z, ce), k = k + Math.imul(re, Te) | 0, g = g + Math.imul(re, Je) | 0, g = g + Math.imul(V, Te) | 0, R = R + Math.imul(V, Je) | 0;
      var ze = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (ze >>> 26) | 0, ze &= 67108863, k = Math.imul(D, ie), g = Math.imul(D, ce), g = g + Math.imul(K, ie) | 0, R = Math.imul(K, ce), k = k + Math.imul(W, Te) | 0, g = g + Math.imul(W, Je) | 0, g = g + Math.imul(Z, Te) | 0, R = R + Math.imul(Z, Je) | 0, k = k + Math.imul(re, nt) | 0, g = g + Math.imul(re, ur) | 0, g = g + Math.imul(V, nt) | 0, R = R + Math.imul(V, ur) | 0;
      var ct = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, k = Math.imul(be, ie), g = Math.imul(be, ce), g = g + Math.imul(Ce, ie) | 0, R = Math.imul(Ce, ce), k = k + Math.imul(D, Te) | 0, g = g + Math.imul(D, Je) | 0, g = g + Math.imul(K, Te) | 0, R = R + Math.imul(K, Je) | 0, k = k + Math.imul(W, nt) | 0, g = g + Math.imul(W, ur) | 0, g = g + Math.imul(Z, nt) | 0, R = R + Math.imul(Z, ur) | 0, k = k + Math.imul(re, Lt) | 0, g = g + Math.imul(re, Wt) | 0, g = g + Math.imul(V, Lt) | 0, R = R + Math.imul(V, Wt) | 0;
      var dt = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (dt >>> 26) | 0, dt &= 67108863, k = Math.imul(Ue, ie), g = Math.imul(Ue, ce), g = g + Math.imul(Qe, ie) | 0, R = Math.imul(Qe, ce), k = k + Math.imul(be, Te) | 0, g = g + Math.imul(be, Je) | 0, g = g + Math.imul(Ce, Te) | 0, R = R + Math.imul(Ce, Je) | 0, k = k + Math.imul(D, nt) | 0, g = g + Math.imul(D, ur) | 0, g = g + Math.imul(K, nt) | 0, R = R + Math.imul(K, ur) | 0, k = k + Math.imul(W, Lt) | 0, g = g + Math.imul(W, Wt) | 0, g = g + Math.imul(Z, Lt) | 0, R = R + Math.imul(Z, Wt) | 0, k = k + Math.imul(re, tr) | 0, g = g + Math.imul(re, rr) | 0, g = g + Math.imul(V, tr) | 0, R = R + Math.imul(V, rr) | 0;
      var vt = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (vt >>> 26) | 0, vt &= 67108863, k = Math.imul(at, ie), g = Math.imul(at, ce), g = g + Math.imul(rt, ie) | 0, R = Math.imul(rt, ce), k = k + Math.imul(Ue, Te) | 0, g = g + Math.imul(Ue, Je) | 0, g = g + Math.imul(Qe, Te) | 0, R = R + Math.imul(Qe, Je) | 0, k = k + Math.imul(be, nt) | 0, g = g + Math.imul(be, ur) | 0, g = g + Math.imul(Ce, nt) | 0, R = R + Math.imul(Ce, ur) | 0, k = k + Math.imul(D, Lt) | 0, g = g + Math.imul(D, Wt) | 0, g = g + Math.imul(K, Lt) | 0, R = R + Math.imul(K, Wt) | 0, k = k + Math.imul(W, tr) | 0, g = g + Math.imul(W, rr) | 0, g = g + Math.imul(Z, tr) | 0, R = R + Math.imul(Z, rr) | 0, k = k + Math.imul(re, dr) | 0, g = g + Math.imul(re, Rt) | 0, g = g + Math.imul(V, dr) | 0, R = R + Math.imul(V, Rt) | 0;
      var gt = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, k = Math.imul(it, ie), g = Math.imul(it, ce), g = g + Math.imul(se, ie) | 0, R = Math.imul(se, ce), k = k + Math.imul(at, Te) | 0, g = g + Math.imul(at, Je) | 0, g = g + Math.imul(rt, Te) | 0, R = R + Math.imul(rt, Je) | 0, k = k + Math.imul(Ue, nt) | 0, g = g + Math.imul(Ue, ur) | 0, g = g + Math.imul(Qe, nt) | 0, R = R + Math.imul(Qe, ur) | 0, k = k + Math.imul(be, Lt) | 0, g = g + Math.imul(be, Wt) | 0, g = g + Math.imul(Ce, Lt) | 0, R = R + Math.imul(Ce, Wt) | 0, k = k + Math.imul(D, tr) | 0, g = g + Math.imul(D, rr) | 0, g = g + Math.imul(K, tr) | 0, R = R + Math.imul(K, rr) | 0, k = k + Math.imul(W, dr) | 0, g = g + Math.imul(W, Rt) | 0, g = g + Math.imul(Z, dr) | 0, R = R + Math.imul(Z, Rt) | 0, k = k + Math.imul(re, T) | 0, g = g + Math.imul(re, q) | 0, g = g + Math.imul(V, T) | 0, R = R + Math.imul(V, q) | 0;
      var lt = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, k = Math.imul(Ee, ie), g = Math.imul(Ee, ce), g = g + Math.imul(U, ie) | 0, R = Math.imul(U, ce), k = k + Math.imul(it, Te) | 0, g = g + Math.imul(it, Je) | 0, g = g + Math.imul(se, Te) | 0, R = R + Math.imul(se, Je) | 0, k = k + Math.imul(at, nt) | 0, g = g + Math.imul(at, ur) | 0, g = g + Math.imul(rt, nt) | 0, R = R + Math.imul(rt, ur) | 0, k = k + Math.imul(Ue, Lt) | 0, g = g + Math.imul(Ue, Wt) | 0, g = g + Math.imul(Qe, Lt) | 0, R = R + Math.imul(Qe, Wt) | 0, k = k + Math.imul(be, tr) | 0, g = g + Math.imul(be, rr) | 0, g = g + Math.imul(Ce, tr) | 0, R = R + Math.imul(Ce, rr) | 0, k = k + Math.imul(D, dr) | 0, g = g + Math.imul(D, Rt) | 0, g = g + Math.imul(K, dr) | 0, R = R + Math.imul(K, Rt) | 0, k = k + Math.imul(W, T) | 0, g = g + Math.imul(W, q) | 0, g = g + Math.imul(Z, T) | 0, R = R + Math.imul(Z, q) | 0, k = k + Math.imul(re, E) | 0, g = g + Math.imul(re, Y) | 0, g = g + Math.imul(V, E) | 0, R = R + Math.imul(V, Y) | 0;
      var pt = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, k = Math.imul(I, ie), g = Math.imul(I, ce), g = g + Math.imul(_, ie) | 0, R = Math.imul(_, ce), k = k + Math.imul(Ee, Te) | 0, g = g + Math.imul(Ee, Je) | 0, g = g + Math.imul(U, Te) | 0, R = R + Math.imul(U, Je) | 0, k = k + Math.imul(it, nt) | 0, g = g + Math.imul(it, ur) | 0, g = g + Math.imul(se, nt) | 0, R = R + Math.imul(se, ur) | 0, k = k + Math.imul(at, Lt) | 0, g = g + Math.imul(at, Wt) | 0, g = g + Math.imul(rt, Lt) | 0, R = R + Math.imul(rt, Wt) | 0, k = k + Math.imul(Ue, tr) | 0, g = g + Math.imul(Ue, rr) | 0, g = g + Math.imul(Qe, tr) | 0, R = R + Math.imul(Qe, rr) | 0, k = k + Math.imul(be, dr) | 0, g = g + Math.imul(be, Rt) | 0, g = g + Math.imul(Ce, dr) | 0, R = R + Math.imul(Ce, Rt) | 0, k = k + Math.imul(D, T) | 0, g = g + Math.imul(D, q) | 0, g = g + Math.imul(K, T) | 0, R = R + Math.imul(K, q) | 0, k = k + Math.imul(W, E) | 0, g = g + Math.imul(W, Y) | 0, g = g + Math.imul(Z, E) | 0, R = R + Math.imul(Z, Y) | 0, k = k + Math.imul(re, de) | 0, g = g + Math.imul(re, xe) | 0, g = g + Math.imul(V, de) | 0, R = R + Math.imul(V, xe) | 0;
      var ht = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (ht >>> 26) | 0, ht &= 67108863, k = Math.imul(m, ie), g = Math.imul(m, ce), g = g + Math.imul(O, ie) | 0, R = Math.imul(O, ce), k = k + Math.imul(I, Te) | 0, g = g + Math.imul(I, Je) | 0, g = g + Math.imul(_, Te) | 0, R = R + Math.imul(_, Je) | 0, k = k + Math.imul(Ee, nt) | 0, g = g + Math.imul(Ee, ur) | 0, g = g + Math.imul(U, nt) | 0, R = R + Math.imul(U, ur) | 0, k = k + Math.imul(it, Lt) | 0, g = g + Math.imul(it, Wt) | 0, g = g + Math.imul(se, Lt) | 0, R = R + Math.imul(se, Wt) | 0, k = k + Math.imul(at, tr) | 0, g = g + Math.imul(at, rr) | 0, g = g + Math.imul(rt, tr) | 0, R = R + Math.imul(rt, rr) | 0, k = k + Math.imul(Ue, dr) | 0, g = g + Math.imul(Ue, Rt) | 0, g = g + Math.imul(Qe, dr) | 0, R = R + Math.imul(Qe, Rt) | 0, k = k + Math.imul(be, T) | 0, g = g + Math.imul(be, q) | 0, g = g + Math.imul(Ce, T) | 0, R = R + Math.imul(Ce, q) | 0, k = k + Math.imul(D, E) | 0, g = g + Math.imul(D, Y) | 0, g = g + Math.imul(K, E) | 0, R = R + Math.imul(K, Y) | 0, k = k + Math.imul(W, de) | 0, g = g + Math.imul(W, xe) | 0, g = g + Math.imul(Z, de) | 0, R = R + Math.imul(Z, xe) | 0, k = k + Math.imul(re, Fe) | 0, g = g + Math.imul(re, ke) | 0, g = g + Math.imul(V, Fe) | 0, R = R + Math.imul(V, ke) | 0;
      var We = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (We >>> 26) | 0, We &= 67108863, k = Math.imul(m, Te), g = Math.imul(m, Je), g = g + Math.imul(O, Te) | 0, R = Math.imul(O, Je), k = k + Math.imul(I, nt) | 0, g = g + Math.imul(I, ur) | 0, g = g + Math.imul(_, nt) | 0, R = R + Math.imul(_, ur) | 0, k = k + Math.imul(Ee, Lt) | 0, g = g + Math.imul(Ee, Wt) | 0, g = g + Math.imul(U, Lt) | 0, R = R + Math.imul(U, Wt) | 0, k = k + Math.imul(it, tr) | 0, g = g + Math.imul(it, rr) | 0, g = g + Math.imul(se, tr) | 0, R = R + Math.imul(se, rr) | 0, k = k + Math.imul(at, dr) | 0, g = g + Math.imul(at, Rt) | 0, g = g + Math.imul(rt, dr) | 0, R = R + Math.imul(rt, Rt) | 0, k = k + Math.imul(Ue, T) | 0, g = g + Math.imul(Ue, q) | 0, g = g + Math.imul(Qe, T) | 0, R = R + Math.imul(Qe, q) | 0, k = k + Math.imul(be, E) | 0, g = g + Math.imul(be, Y) | 0, g = g + Math.imul(Ce, E) | 0, R = R + Math.imul(Ce, Y) | 0, k = k + Math.imul(D, de) | 0, g = g + Math.imul(D, xe) | 0, g = g + Math.imul(K, de) | 0, R = R + Math.imul(K, xe) | 0, k = k + Math.imul(W, Fe) | 0, g = g + Math.imul(W, ke) | 0, g = g + Math.imul(Z, Fe) | 0, R = R + Math.imul(Z, ke) | 0;
      var Xe = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, k = Math.imul(m, nt), g = Math.imul(m, ur), g = g + Math.imul(O, nt) | 0, R = Math.imul(O, ur), k = k + Math.imul(I, Lt) | 0, g = g + Math.imul(I, Wt) | 0, g = g + Math.imul(_, Lt) | 0, R = R + Math.imul(_, Wt) | 0, k = k + Math.imul(Ee, tr) | 0, g = g + Math.imul(Ee, rr) | 0, g = g + Math.imul(U, tr) | 0, R = R + Math.imul(U, rr) | 0, k = k + Math.imul(it, dr) | 0, g = g + Math.imul(it, Rt) | 0, g = g + Math.imul(se, dr) | 0, R = R + Math.imul(se, Rt) | 0, k = k + Math.imul(at, T) | 0, g = g + Math.imul(at, q) | 0, g = g + Math.imul(rt, T) | 0, R = R + Math.imul(rt, q) | 0, k = k + Math.imul(Ue, E) | 0, g = g + Math.imul(Ue, Y) | 0, g = g + Math.imul(Qe, E) | 0, R = R + Math.imul(Qe, Y) | 0, k = k + Math.imul(be, de) | 0, g = g + Math.imul(be, xe) | 0, g = g + Math.imul(Ce, de) | 0, R = R + Math.imul(Ce, xe) | 0, k = k + Math.imul(D, Fe) | 0, g = g + Math.imul(D, ke) | 0, g = g + Math.imul(K, Fe) | 0, R = R + Math.imul(K, ke) | 0;
      var qe = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (qe >>> 26) | 0, qe &= 67108863, k = Math.imul(m, Lt), g = Math.imul(m, Wt), g = g + Math.imul(O, Lt) | 0, R = Math.imul(O, Wt), k = k + Math.imul(I, tr) | 0, g = g + Math.imul(I, rr) | 0, g = g + Math.imul(_, tr) | 0, R = R + Math.imul(_, rr) | 0, k = k + Math.imul(Ee, dr) | 0, g = g + Math.imul(Ee, Rt) | 0, g = g + Math.imul(U, dr) | 0, R = R + Math.imul(U, Rt) | 0, k = k + Math.imul(it, T) | 0, g = g + Math.imul(it, q) | 0, g = g + Math.imul(se, T) | 0, R = R + Math.imul(se, q) | 0, k = k + Math.imul(at, E) | 0, g = g + Math.imul(at, Y) | 0, g = g + Math.imul(rt, E) | 0, R = R + Math.imul(rt, Y) | 0, k = k + Math.imul(Ue, de) | 0, g = g + Math.imul(Ue, xe) | 0, g = g + Math.imul(Qe, de) | 0, R = R + Math.imul(Qe, xe) | 0, k = k + Math.imul(be, Fe) | 0, g = g + Math.imul(be, ke) | 0, g = g + Math.imul(Ce, Fe) | 0, R = R + Math.imul(Ce, ke) | 0;
      var He = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (He >>> 26) | 0, He &= 67108863, k = Math.imul(m, tr), g = Math.imul(m, rr), g = g + Math.imul(O, tr) | 0, R = Math.imul(O, rr), k = k + Math.imul(I, dr) | 0, g = g + Math.imul(I, Rt) | 0, g = g + Math.imul(_, dr) | 0, R = R + Math.imul(_, Rt) | 0, k = k + Math.imul(Ee, T) | 0, g = g + Math.imul(Ee, q) | 0, g = g + Math.imul(U, T) | 0, R = R + Math.imul(U, q) | 0, k = k + Math.imul(it, E) | 0, g = g + Math.imul(it, Y) | 0, g = g + Math.imul(se, E) | 0, R = R + Math.imul(se, Y) | 0, k = k + Math.imul(at, de) | 0, g = g + Math.imul(at, xe) | 0, g = g + Math.imul(rt, de) | 0, R = R + Math.imul(rt, xe) | 0, k = k + Math.imul(Ue, Fe) | 0, g = g + Math.imul(Ue, ke) | 0, g = g + Math.imul(Qe, Fe) | 0, R = R + Math.imul(Qe, ke) | 0;
      var Ge = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (Ge >>> 26) | 0, Ge &= 67108863, k = Math.imul(m, dr), g = Math.imul(m, Rt), g = g + Math.imul(O, dr) | 0, R = Math.imul(O, Rt), k = k + Math.imul(I, T) | 0, g = g + Math.imul(I, q) | 0, g = g + Math.imul(_, T) | 0, R = R + Math.imul(_, q) | 0, k = k + Math.imul(Ee, E) | 0, g = g + Math.imul(Ee, Y) | 0, g = g + Math.imul(U, E) | 0, R = R + Math.imul(U, Y) | 0, k = k + Math.imul(it, de) | 0, g = g + Math.imul(it, xe) | 0, g = g + Math.imul(se, de) | 0, R = R + Math.imul(se, xe) | 0, k = k + Math.imul(at, Fe) | 0, g = g + Math.imul(at, ke) | 0, g = g + Math.imul(rt, Fe) | 0, R = R + Math.imul(rt, ke) | 0;
      var De = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (De >>> 26) | 0, De &= 67108863, k = Math.imul(m, T), g = Math.imul(m, q), g = g + Math.imul(O, T) | 0, R = Math.imul(O, q), k = k + Math.imul(I, E) | 0, g = g + Math.imul(I, Y) | 0, g = g + Math.imul(_, E) | 0, R = R + Math.imul(_, Y) | 0, k = k + Math.imul(Ee, de) | 0, g = g + Math.imul(Ee, xe) | 0, g = g + Math.imul(U, de) | 0, R = R + Math.imul(U, xe) | 0, k = k + Math.imul(it, Fe) | 0, g = g + Math.imul(it, ke) | 0, g = g + Math.imul(se, Fe) | 0, R = R + Math.imul(se, ke) | 0;
      var ve = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, k = Math.imul(m, E), g = Math.imul(m, Y), g = g + Math.imul(O, E) | 0, R = Math.imul(O, Y), k = k + Math.imul(I, de) | 0, g = g + Math.imul(I, xe) | 0, g = g + Math.imul(_, de) | 0, R = R + Math.imul(_, xe) | 0, k = k + Math.imul(Ee, Fe) | 0, g = g + Math.imul(Ee, ke) | 0, g = g + Math.imul(U, Fe) | 0, R = R + Math.imul(U, ke) | 0;
      var me = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (me >>> 26) | 0, me &= 67108863, k = Math.imul(m, de), g = Math.imul(m, xe), g = g + Math.imul(O, de) | 0, R = Math.imul(O, xe), k = k + Math.imul(I, Fe) | 0, g = g + Math.imul(I, ke) | 0, g = g + Math.imul(_, Fe) | 0, R = R + Math.imul(_, ke) | 0;
      var Me = (j + k | 0) + ((g & 8191) << 13) | 0;
      j = (R + (g >>> 13) | 0) + (Me >>> 26) | 0, Me &= 67108863, k = Math.imul(m, Fe), g = Math.imul(m, ke), g = g + Math.imul(O, Fe) | 0, R = Math.imul(O, ke);
      var Ae = (j + k | 0) + ((g & 8191) << 13) | 0;
      return j = (R + (g >>> 13) | 0) + (Ae >>> 26) | 0, Ae &= 67108863, C[0] = Pt, C[1] = ze, C[2] = ct, C[3] = dt, C[4] = vt, C[5] = gt, C[6] = lt, C[7] = pt, C[8] = ht, C[9] = We, C[10] = Xe, C[11] = qe, C[12] = He, C[13] = Ge, C[14] = De, C[15] = ve, C[16] = me, C[17] = Me, C[18] = Ae, j !== 0 && (C[19] = j, P.length++), P;
    };
    Math.imul || (M = A);
    function N(F, v, B) {
      B.negative = v.negative ^ F.negative, B.length = F.length + v.length;
      for (var P = 0, L = 0, x = 0; x < B.length - 1; x++) {
        var C = L;
        L = 0;
        for (var j = P & 67108863, k = Math.min(x, v.length - 1), g = Math.max(0, x - F.length + 1); g <= k; g++) {
          var R = x - g, X = F.words[R] | 0, re = v.words[g] | 0, V = X * re, $ = V & 67108863;
          C = C + (V / 67108864 | 0) | 0, $ = $ + j | 0, j = $ & 67108863, C = C + ($ >>> 26) | 0, L += C >>> 26, C &= 67108863;
        }
        B.words[x] = j, P = C, C = L;
      }
      return P !== 0 ? B.words[x] = P : B.length--, B._strip();
    }
    function G(F, v, B) {
      return N(F, v, B);
    }
    o.prototype.mulTo = function(v, B) {
      var P, L = this.length + v.length;
      return this.length === 10 && v.length === 10 ? P = M(this, v, B) : L < 63 ? P = A(this, v, B) : L < 1024 ? P = N(this, v, B) : P = G(this, v, B), P;
    }, o.prototype.mul = function(v) {
      var B = new o(null);
      return B.words = new Array(this.length + v.length), this.mulTo(v, B);
    }, o.prototype.mulf = function(v) {
      var B = new o(null);
      return B.words = new Array(this.length + v.length), G(this, v, B);
    }, o.prototype.imul = function(v) {
      return this.clone().mulTo(v, this);
    }, o.prototype.imuln = function(v) {
      var B = v < 0;
      B && (v = -v), n(typeof v == "number"), n(v < 67108864);
      for (var P = 0, L = 0; L < this.length; L++) {
        var x = (this.words[L] | 0) * v, C = (x & 67108863) + (P & 67108863);
        P >>= 26, P += x / 67108864 | 0, P += C >>> 26, this.words[L] = C & 67108863;
      }
      return P !== 0 && (this.words[L] = P, this.length++), B ? this.ineg() : this;
    }, o.prototype.muln = function(v) {
      return this.clone().imuln(v);
    }, o.prototype.sqr = function() {
      return this.mul(this);
    }, o.prototype.isqr = function() {
      return this.imul(this.clone());
    }, o.prototype.pow = function(v) {
      var B = w(v);
      if (B.length === 0)
        return new o(1);
      for (var P = this, L = 0; L < B.length && B[L] === 0; L++, P = P.sqr())
        ;
      if (++L < B.length)
        for (var x = P.sqr(); L < B.length; L++, x = x.sqr())
          B[L] !== 0 && (P = P.mul(x));
      return P;
    }, o.prototype.iushln = function(v) {
      n(typeof v == "number" && v >= 0);
      var B = v % 26, P = (v - B) / 26, L = 67108863 >>> 26 - B << 26 - B, x;
      if (B !== 0) {
        var C = 0;
        for (x = 0; x < this.length; x++) {
          var j = this.words[x] & L, k = (this.words[x] | 0) - j << B;
          this.words[x] = k | C, C = j >>> 26 - B;
        }
        C && (this.words[x] = C, this.length++);
      }
      if (P !== 0) {
        for (x = this.length - 1; x >= 0; x--)
          this.words[x + P] = this.words[x];
        for (x = 0; x < P; x++)
          this.words[x] = 0;
        this.length += P;
      }
      return this._strip();
    }, o.prototype.ishln = function(v) {
      return n(this.negative === 0), this.iushln(v);
    }, o.prototype.iushrn = function(v, B, P) {
      n(typeof v == "number" && v >= 0);
      var L;
      B ? L = (B - B % 26) / 26 : L = 0;
      var x = v % 26, C = Math.min((v - x) / 26, this.length), j = 67108863 ^ 67108863 >>> x << x, k = P;
      if (L -= C, L = Math.max(0, L), k) {
        for (var g = 0; g < C; g++)
          k.words[g] = this.words[g];
        k.length = C;
      }
      if (C !== 0)
        if (this.length > C)
          for (this.length -= C, g = 0; g < this.length; g++)
            this.words[g] = this.words[g + C];
        else
          this.words[0] = 0, this.length = 1;
      var R = 0;
      for (g = this.length - 1; g >= 0 && (R !== 0 || g >= L); g--) {
        var X = this.words[g] | 0;
        this.words[g] = R << 26 - x | X >>> x, R = X & j;
      }
      return k && R !== 0 && (k.words[k.length++] = R), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, o.prototype.ishrn = function(v, B, P) {
      return n(this.negative === 0), this.iushrn(v, B, P);
    }, o.prototype.shln = function(v) {
      return this.clone().ishln(v);
    }, o.prototype.ushln = function(v) {
      return this.clone().iushln(v);
    }, o.prototype.shrn = function(v) {
      return this.clone().ishrn(v);
    }, o.prototype.ushrn = function(v) {
      return this.clone().iushrn(v);
    }, o.prototype.testn = function(v) {
      n(typeof v == "number" && v >= 0);
      var B = v % 26, P = (v - B) / 26, L = 1 << B;
      if (this.length <= P)
        return !1;
      var x = this.words[P];
      return !!(x & L);
    }, o.prototype.imaskn = function(v) {
      n(typeof v == "number" && v >= 0);
      var B = v % 26, P = (v - B) / 26;
      if (n(this.negative === 0, "imaskn works only with positive numbers"), this.length <= P)
        return this;
      if (B !== 0 && P++, this.length = Math.min(P, this.length), B !== 0) {
        var L = 67108863 ^ 67108863 >>> B << B;
        this.words[this.length - 1] &= L;
      }
      return this._strip();
    }, o.prototype.maskn = function(v) {
      return this.clone().imaskn(v);
    }, o.prototype.iaddn = function(v) {
      return n(typeof v == "number"), n(v < 67108864), v < 0 ? this.isubn(-v) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= v ? (this.words[0] = v - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(v), this.negative = 1, this) : this._iaddn(v);
    }, o.prototype._iaddn = function(v) {
      this.words[0] += v;
      for (var B = 0; B < this.length && this.words[B] >= 67108864; B++)
        this.words[B] -= 67108864, B === this.length - 1 ? this.words[B + 1] = 1 : this.words[B + 1]++;
      return this.length = Math.max(this.length, B + 1), this;
    }, o.prototype.isubn = function(v) {
      if (n(typeof v == "number"), n(v < 67108864), v < 0)
        return this.iaddn(-v);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(v), this.negative = 1, this;
      if (this.words[0] -= v, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var B = 0; B < this.length && this.words[B] < 0; B++)
          this.words[B] += 67108864, this.words[B + 1] -= 1;
      return this._strip();
    }, o.prototype.addn = function(v) {
      return this.clone().iaddn(v);
    }, o.prototype.subn = function(v) {
      return this.clone().isubn(v);
    }, o.prototype.iabs = function() {
      return this.negative = 0, this;
    }, o.prototype.abs = function() {
      return this.clone().iabs();
    }, o.prototype._ishlnsubmul = function(v, B, P) {
      var L = v.length + P, x;
      this._expand(L);
      var C, j = 0;
      for (x = 0; x < v.length; x++) {
        C = (this.words[x + P] | 0) + j;
        var k = (v.words[x] | 0) * B;
        C -= k & 67108863, j = (C >> 26) - (k / 67108864 | 0), this.words[x + P] = C & 67108863;
      }
      for (; x < this.length - P; x++)
        C = (this.words[x + P] | 0) + j, j = C >> 26, this.words[x + P] = C & 67108863;
      if (j === 0)
        return this._strip();
      for (n(j === -1), j = 0, x = 0; x < this.length; x++)
        C = -(this.words[x] | 0) + j, j = C >> 26, this.words[x] = C & 67108863;
      return this.negative = 1, this._strip();
    }, o.prototype._wordDiv = function(v, B) {
      var P = this.length - v.length, L = this.clone(), x = v, C = x.words[x.length - 1] | 0, j = this._countBits(C);
      P = 26 - j, P !== 0 && (x = x.ushln(P), L.iushln(P), C = x.words[x.length - 1] | 0);
      var k = L.length - x.length, g;
      if (B !== "mod") {
        g = new o(null), g.length = k + 1, g.words = new Array(g.length);
        for (var R = 0; R < g.length; R++)
          g.words[R] = 0;
      }
      var X = L.clone()._ishlnsubmul(x, 1, k);
      X.negative === 0 && (L = X, g && (g.words[k] = 1));
      for (var re = k - 1; re >= 0; re--) {
        var V = (L.words[x.length + re] | 0) * 67108864 + (L.words[x.length + re - 1] | 0);
        for (V = Math.min(V / C | 0, 67108863), L._ishlnsubmul(x, V, re); L.negative !== 0; )
          V--, L.negative = 0, L._ishlnsubmul(x, 1, re), L.isZero() || (L.negative ^= 1);
        g && (g.words[re] = V);
      }
      return g && g._strip(), L._strip(), B !== "div" && P !== 0 && L.iushrn(P), {
        div: g || null,
        mod: L
      };
    }, o.prototype.divmod = function(v, B, P) {
      if (n(!v.isZero()), this.isZero())
        return {
          div: new o(0),
          mod: new o(0)
        };
      var L, x, C;
      return this.negative !== 0 && v.negative === 0 ? (C = this.neg().divmod(v, B), B !== "mod" && (L = C.div.neg()), B !== "div" && (x = C.mod.neg(), P && x.negative !== 0 && x.iadd(v)), {
        div: L,
        mod: x
      }) : this.negative === 0 && v.negative !== 0 ? (C = this.divmod(v.neg(), B), B !== "mod" && (L = C.div.neg()), {
        div: L,
        mod: C.mod
      }) : this.negative & v.negative ? (C = this.neg().divmod(v.neg(), B), B !== "div" && (x = C.mod.neg(), P && x.negative !== 0 && x.isub(v)), {
        div: C.div,
        mod: x
      }) : v.length > this.length || this.cmp(v) < 0 ? {
        div: new o(0),
        mod: this
      } : v.length === 1 ? B === "div" ? {
        div: this.divn(v.words[0]),
        mod: null
      } : B === "mod" ? {
        div: null,
        mod: new o(this.modrn(v.words[0]))
      } : {
        div: this.divn(v.words[0]),
        mod: new o(this.modrn(v.words[0]))
      } : this._wordDiv(v, B);
    }, o.prototype.div = function(v) {
      return this.divmod(v, "div", !1).div;
    }, o.prototype.mod = function(v) {
      return this.divmod(v, "mod", !1).mod;
    }, o.prototype.umod = function(v) {
      return this.divmod(v, "mod", !0).mod;
    }, o.prototype.divRound = function(v) {
      var B = this.divmod(v);
      if (B.mod.isZero())
        return B.div;
      var P = B.div.negative !== 0 ? B.mod.isub(v) : B.mod, L = v.ushrn(1), x = v.andln(1), C = P.cmp(L);
      return C < 0 || x === 1 && C === 0 ? B.div : B.div.negative !== 0 ? B.div.isubn(1) : B.div.iaddn(1);
    }, o.prototype.modrn = function(v) {
      var B = v < 0;
      B && (v = -v), n(v <= 67108863);
      for (var P = (1 << 26) % v, L = 0, x = this.length - 1; x >= 0; x--)
        L = (P * L + (this.words[x] | 0)) % v;
      return B ? -L : L;
    }, o.prototype.modn = function(v) {
      return this.modrn(v);
    }, o.prototype.idivn = function(v) {
      var B = v < 0;
      B && (v = -v), n(v <= 67108863);
      for (var P = 0, L = this.length - 1; L >= 0; L--) {
        var x = (this.words[L] | 0) + P * 67108864;
        this.words[L] = x / v | 0, P = x % v;
      }
      return this._strip(), B ? this.ineg() : this;
    }, o.prototype.divn = function(v) {
      return this.clone().idivn(v);
    }, o.prototype.egcd = function(v) {
      n(v.negative === 0), n(!v.isZero());
      var B = this, P = v.clone();
      B.negative !== 0 ? B = B.umod(v) : B = B.clone();
      for (var L = new o(1), x = new o(0), C = new o(0), j = new o(1), k = 0; B.isEven() && P.isEven(); )
        B.iushrn(1), P.iushrn(1), ++k;
      for (var g = P.clone(), R = B.clone(); !B.isZero(); ) {
        for (var X = 0, re = 1; !(B.words[0] & re) && X < 26; ++X, re <<= 1)
          ;
        if (X > 0)
          for (B.iushrn(X); X-- > 0; )
            (L.isOdd() || x.isOdd()) && (L.iadd(g), x.isub(R)), L.iushrn(1), x.iushrn(1);
        for (var V = 0, $ = 1; !(P.words[0] & $) && V < 26; ++V, $ <<= 1)
          ;
        if (V > 0)
          for (P.iushrn(V); V-- > 0; )
            (C.isOdd() || j.isOdd()) && (C.iadd(g), j.isub(R)), C.iushrn(1), j.iushrn(1);
        B.cmp(P) >= 0 ? (B.isub(P), L.isub(C), x.isub(j)) : (P.isub(B), C.isub(L), j.isub(x));
      }
      return {
        a: C,
        b: j,
        gcd: P.iushln(k)
      };
    }, o.prototype._invmp = function(v) {
      n(v.negative === 0), n(!v.isZero());
      var B = this, P = v.clone();
      B.negative !== 0 ? B = B.umod(v) : B = B.clone();
      for (var L = new o(1), x = new o(0), C = P.clone(); B.cmpn(1) > 0 && P.cmpn(1) > 0; ) {
        for (var j = 0, k = 1; !(B.words[0] & k) && j < 26; ++j, k <<= 1)
          ;
        if (j > 0)
          for (B.iushrn(j); j-- > 0; )
            L.isOdd() && L.iadd(C), L.iushrn(1);
        for (var g = 0, R = 1; !(P.words[0] & R) && g < 26; ++g, R <<= 1)
          ;
        if (g > 0)
          for (P.iushrn(g); g-- > 0; )
            x.isOdd() && x.iadd(C), x.iushrn(1);
        B.cmp(P) >= 0 ? (B.isub(P), L.isub(x)) : (P.isub(B), x.isub(L));
      }
      var X;
      return B.cmpn(1) === 0 ? X = L : X = x, X.cmpn(0) < 0 && X.iadd(v), X;
    }, o.prototype.gcd = function(v) {
      if (this.isZero())
        return v.abs();
      if (v.isZero())
        return this.abs();
      var B = this.clone(), P = v.clone();
      B.negative = 0, P.negative = 0;
      for (var L = 0; B.isEven() && P.isEven(); L++)
        B.iushrn(1), P.iushrn(1);
      do {
        for (; B.isEven(); )
          B.iushrn(1);
        for (; P.isEven(); )
          P.iushrn(1);
        var x = B.cmp(P);
        if (x < 0) {
          var C = B;
          B = P, P = C;
        } else if (x === 0 || P.cmpn(1) === 0)
          break;
        B.isub(P);
      } while (!0);
      return P.iushln(L);
    }, o.prototype.invm = function(v) {
      return this.egcd(v).a.umod(v);
    }, o.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, o.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, o.prototype.andln = function(v) {
      return this.words[0] & v;
    }, o.prototype.bincn = function(v) {
      n(typeof v == "number");
      var B = v % 26, P = (v - B) / 26, L = 1 << B;
      if (this.length <= P)
        return this._expand(P + 1), this.words[P] |= L, this;
      for (var x = L, C = P; x !== 0 && C < this.length; C++) {
        var j = this.words[C] | 0;
        j += x, x = j >>> 26, j &= 67108863, this.words[C] = j;
      }
      return x !== 0 && (this.words[C] = x, this.length++), this;
    }, o.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, o.prototype.cmpn = function(v) {
      var B = v < 0;
      if (this.negative !== 0 && !B)
        return -1;
      if (this.negative === 0 && B)
        return 1;
      this._strip();
      var P;
      if (this.length > 1)
        P = 1;
      else {
        B && (v = -v), n(v <= 67108863, "Number is too big");
        var L = this.words[0] | 0;
        P = L === v ? 0 : L < v ? -1 : 1;
      }
      return this.negative !== 0 ? -P | 0 : P;
    }, o.prototype.cmp = function(v) {
      if (this.negative !== 0 && v.negative === 0)
        return -1;
      if (this.negative === 0 && v.negative !== 0)
        return 1;
      var B = this.ucmp(v);
      return this.negative !== 0 ? -B | 0 : B;
    }, o.prototype.ucmp = function(v) {
      if (this.length > v.length)
        return 1;
      if (this.length < v.length)
        return -1;
      for (var B = 0, P = this.length - 1; P >= 0; P--) {
        var L = this.words[P] | 0, x = v.words[P] | 0;
        if (L !== x) {
          L < x ? B = -1 : L > x && (B = 1);
          break;
        }
      }
      return B;
    }, o.prototype.gtn = function(v) {
      return this.cmpn(v) === 1;
    }, o.prototype.gt = function(v) {
      return this.cmp(v) === 1;
    }, o.prototype.gten = function(v) {
      return this.cmpn(v) >= 0;
    }, o.prototype.gte = function(v) {
      return this.cmp(v) >= 0;
    }, o.prototype.ltn = function(v) {
      return this.cmpn(v) === -1;
    }, o.prototype.lt = function(v) {
      return this.cmp(v) === -1;
    }, o.prototype.lten = function(v) {
      return this.cmpn(v) <= 0;
    }, o.prototype.lte = function(v) {
      return this.cmp(v) <= 0;
    }, o.prototype.eqn = function(v) {
      return this.cmpn(v) === 0;
    }, o.prototype.eq = function(v) {
      return this.cmp(v) === 0;
    }, o.red = function(v) {
      return new pe(v);
    }, o.prototype.toRed = function(v) {
      return n(!this.red, "Already a number in reduction context"), n(this.negative === 0, "red works only with positives"), v.convertTo(this)._forceRed(v);
    }, o.prototype.fromRed = function() {
      return n(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, o.prototype._forceRed = function(v) {
      return this.red = v, this;
    }, o.prototype.forceRed = function(v) {
      return n(!this.red, "Already a number in reduction context"), this._forceRed(v);
    }, o.prototype.redAdd = function(v) {
      return n(this.red, "redAdd works only with red numbers"), this.red.add(this, v);
    }, o.prototype.redIAdd = function(v) {
      return n(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, v);
    }, o.prototype.redSub = function(v) {
      return n(this.red, "redSub works only with red numbers"), this.red.sub(this, v);
    }, o.prototype.redISub = function(v) {
      return n(this.red, "redISub works only with red numbers"), this.red.isub(this, v);
    }, o.prototype.redShl = function(v) {
      return n(this.red, "redShl works only with red numbers"), this.red.shl(this, v);
    }, o.prototype.redMul = function(v) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, v), this.red.mul(this, v);
    }, o.prototype.redIMul = function(v) {
      return n(this.red, "redMul works only with red numbers"), this.red._verify2(this, v), this.red.imul(this, v);
    }, o.prototype.redSqr = function() {
      return n(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, o.prototype.redISqr = function() {
      return n(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, o.prototype.redSqrt = function() {
      return n(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, o.prototype.redInvm = function() {
      return n(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, o.prototype.redNeg = function() {
      return n(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, o.prototype.redPow = function(v) {
      return n(this.red && !v.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, v);
    };
    var z = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function J(F, v) {
      this.name = F, this.p = new o(v, 16), this.n = this.p.bitLength(), this.k = new o(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    J.prototype._tmp = function() {
      var v = new o(null);
      return v.words = new Array(Math.ceil(this.n / 13)), v;
    }, J.prototype.ireduce = function(v) {
      var B = v, P;
      do
        this.split(B, this.tmp), B = this.imulK(B), B = B.iadd(this.tmp), P = B.bitLength();
      while (P > this.n);
      var L = P < this.n ? -1 : B.ucmp(this.p);
      return L === 0 ? (B.words[0] = 0, B.length = 1) : L > 0 ? B.isub(this.p) : B.strip !== void 0 ? B.strip() : B._strip(), B;
    }, J.prototype.split = function(v, B) {
      v.iushrn(this.n, 0, B);
    }, J.prototype.imulK = function(v) {
      return v.imul(this.k);
    };
    function oe() {
      J.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    i(oe, J), oe.prototype.split = function(v, B) {
      for (var P = 4194303, L = Math.min(v.length, 9), x = 0; x < L; x++)
        B.words[x] = v.words[x];
      if (B.length = L, v.length <= 9) {
        v.words[0] = 0, v.length = 1;
        return;
      }
      var C = v.words[9];
      for (B.words[B.length++] = C & P, x = 10; x < v.length; x++) {
        var j = v.words[x] | 0;
        v.words[x - 10] = (j & P) << 4 | C >>> 22, C = j;
      }
      C >>>= 22, v.words[x - 10] = C, C === 0 && v.length > 10 ? v.length -= 10 : v.length -= 9;
    }, oe.prototype.imulK = function(v) {
      v.words[v.length] = 0, v.words[v.length + 1] = 0, v.length += 2;
      for (var B = 0, P = 0; P < v.length; P++) {
        var L = v.words[P] | 0;
        B += L * 977, v.words[P] = B & 67108863, B = L * 64 + (B / 67108864 | 0);
      }
      return v.words[v.length - 1] === 0 && (v.length--, v.words[v.length - 1] === 0 && v.length--), v;
    };
    function ee() {
      J.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    i(ee, J);
    function ae() {
      J.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    i(ae, J);
    function ye() {
      J.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    i(ye, J), ye.prototype.imulK = function(v) {
      for (var B = 0, P = 0; P < v.length; P++) {
        var L = (v.words[P] | 0) * 19 + B, x = L & 67108863;
        L >>>= 26, v.words[P] = x, B = L;
      }
      return B !== 0 && (v.words[v.length++] = B), v;
    }, o._prime = function(v) {
      if (z[v])
        return z[v];
      var B;
      if (v === "k256")
        B = new oe();
      else if (v === "p224")
        B = new ee();
      else if (v === "p192")
        B = new ae();
      else if (v === "p25519")
        B = new ye();
      else
        throw new Error("Unknown prime " + v);
      return z[v] = B, B;
    };
    function pe(F) {
      if (typeof F == "string") {
        var v = o._prime(F);
        this.m = v.p, this.prime = v;
      } else
        n(F.gtn(1), "modulus must be greater than 1"), this.m = F, this.prime = null;
    }
    pe.prototype._verify1 = function(v) {
      n(v.negative === 0, "red works only with positives"), n(v.red, "red works only with red numbers");
    }, pe.prototype._verify2 = function(v, B) {
      n((v.negative | B.negative) === 0, "red works only with positives"), n(
        v.red && v.red === B.red,
        "red works only with red numbers"
      );
    }, pe.prototype.imod = function(v) {
      return this.prime ? this.prime.ireduce(v)._forceRed(this) : (c(v, v.umod(this.m)._forceRed(this)), v);
    }, pe.prototype.neg = function(v) {
      return v.isZero() ? v.clone() : this.m.sub(v)._forceRed(this);
    }, pe.prototype.add = function(v, B) {
      this._verify2(v, B);
      var P = v.add(B);
      return P.cmp(this.m) >= 0 && P.isub(this.m), P._forceRed(this);
    }, pe.prototype.iadd = function(v, B) {
      this._verify2(v, B);
      var P = v.iadd(B);
      return P.cmp(this.m) >= 0 && P.isub(this.m), P;
    }, pe.prototype.sub = function(v, B) {
      this._verify2(v, B);
      var P = v.sub(B);
      return P.cmpn(0) < 0 && P.iadd(this.m), P._forceRed(this);
    }, pe.prototype.isub = function(v, B) {
      this._verify2(v, B);
      var P = v.isub(B);
      return P.cmpn(0) < 0 && P.iadd(this.m), P;
    }, pe.prototype.shl = function(v, B) {
      return this._verify1(v), this.imod(v.ushln(B));
    }, pe.prototype.imul = function(v, B) {
      return this._verify2(v, B), this.imod(v.imul(B));
    }, pe.prototype.mul = function(v, B) {
      return this._verify2(v, B), this.imod(v.mul(B));
    }, pe.prototype.isqr = function(v) {
      return this.imul(v, v.clone());
    }, pe.prototype.sqr = function(v) {
      return this.mul(v, v);
    }, pe.prototype.sqrt = function(v) {
      if (v.isZero())
        return v.clone();
      var B = this.m.andln(3);
      if (n(B % 2 === 1), B === 3) {
        var P = this.m.add(new o(1)).iushrn(2);
        return this.pow(v, P);
      }
      for (var L = this.m.subn(1), x = 0; !L.isZero() && L.andln(1) === 0; )
        x++, L.iushrn(1);
      n(!L.isZero());
      var C = new o(1).toRed(this), j = C.redNeg(), k = this.m.subn(1).iushrn(1), g = this.m.bitLength();
      for (g = new o(2 * g * g).toRed(this); this.pow(g, k).cmp(j) !== 0; )
        g.redIAdd(j);
      for (var R = this.pow(g, L), X = this.pow(v, L.addn(1).iushrn(1)), re = this.pow(v, L), V = x; re.cmp(C) !== 0; ) {
        for (var $ = re, W = 0; $.cmp(C) !== 0; W++)
          $ = $.redSqr();
        n(W < V);
        var Z = this.pow(R, new o(1).iushln(V - W - 1));
        X = X.redMul(Z), R = Z.redSqr(), re = re.redMul(R), V = W;
      }
      return X;
    }, pe.prototype.invm = function(v) {
      var B = v._invmp(this.m);
      return B.negative !== 0 ? (B.negative = 0, this.imod(B).redNeg()) : this.imod(B);
    }, pe.prototype.pow = function(v, B) {
      if (B.isZero())
        return new o(1).toRed(this);
      if (B.cmpn(1) === 0)
        return v.clone();
      var P = 4, L = new Array(1 << P);
      L[0] = new o(1).toRed(this), L[1] = v;
      for (var x = 2; x < L.length; x++)
        L[x] = this.mul(L[x - 1], v);
      var C = L[0], j = 0, k = 0, g = B.bitLength() % 26;
      for (g === 0 && (g = 26), x = B.length - 1; x >= 0; x--) {
        for (var R = B.words[x], X = g - 1; X >= 0; X--) {
          var re = R >> X & 1;
          if (C !== L[0] && (C = this.sqr(C)), re === 0 && j === 0) {
            k = 0;
            continue;
          }
          j <<= 1, j |= re, k++, !(k !== P && (x !== 0 || X !== 0)) && (C = this.mul(C, L[j]), k = 0, j = 0);
        }
        g = 26;
      }
      return C;
    }, pe.prototype.convertTo = function(v) {
      var B = v.umod(this.m);
      return B === v ? B.clone() : B;
    }, pe.prototype.convertFrom = function(v) {
      var B = v.clone();
      return B.red = null, B;
    }, o.mont = function(v) {
      return new te(v);
    };
    function te(F) {
      pe.call(this, F), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new o(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    i(te, pe), te.prototype.convertTo = function(v) {
      return this.imod(v.ushln(this.shift));
    }, te.prototype.convertFrom = function(v) {
      var B = this.imod(v.mul(this.rinv));
      return B.red = null, B;
    }, te.prototype.imul = function(v, B) {
      if (v.isZero() || B.isZero())
        return v.words[0] = 0, v.length = 1, v;
      var P = v.imul(B), L = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), x = P.isub(L).iushrn(this.shift), C = x;
      return x.cmp(this.m) >= 0 ? C = x.isub(this.m) : x.cmpn(0) < 0 && (C = x.iadd(this.m)), C._forceRed(this);
    }, te.prototype.mul = function(v, B) {
      if (v.isZero() || B.isZero())
        return new o(0)._forceRed(this);
      var P = v.mul(B), L = P.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), x = P.isub(L).iushrn(this.shift), C = x;
      return x.cmp(this.m) >= 0 ? C = x.isub(this.m) : x.cmpn(0) < 0 && (C = x.iadd(this.m)), C._forceRed(this);
    }, te.prototype.invm = function(v) {
      var B = this.imod(v._invmp(this.m).mul(this.r2));
      return B._forceRed(this);
    };
  })(t, yt);
})(kp);
var mr = kp.exports;
const Ni = /* @__PURE__ */ sn(mr);
var Yf = { exports: {} }, ab;
function Cp() {
  if (ab)
    return Yf.exports;
  ab = 1;
  var t;
  Yf.exports = function(i) {
    return t || (t = new e(null)), t.generate(i);
  };
  function e(n) {
    this.rand = n;
  }
  if (Yf.exports.Rand = e, e.prototype.generate = function(i) {
    return this._rand(i);
  }, e.prototype._rand = function(i) {
    if (this.rand.getBytes)
      return this.rand.getBytes(i);
    for (var o = new Uint8Array(i), a = 0; a < o.length; a++)
      o[a] = this.rand.getByte();
    return o;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? e.prototype._rand = function(i) {
      var o = new Uint8Array(i);
      return self.crypto.getRandomValues(o), o;
    } : self.msCrypto && self.msCrypto.getRandomValues ? e.prototype._rand = function(i) {
      var o = new Uint8Array(i);
      return self.msCrypto.getRandomValues(o), o;
    } : typeof window == "object" && (e.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var r = $p();
      if (typeof r.randomBytes != "function")
        throw new Error("Not supported");
      e.prototype._rand = function(i) {
        return r.randomBytes(i);
      };
    } catch {
    }
  return Yf.exports;
}
var hl, sb;
function E3() {
  if (sb)
    return hl;
  sb = 1;
  var t = mr, e = Cp();
  function r(n) {
    this.rand = n || new e.Rand();
  }
  return hl = r, r.create = function(i) {
    return new r(i);
  }, r.prototype._randbelow = function(i) {
    var o = i.bitLength(), a = Math.ceil(o / 8);
    do
      var s = new t(this.rand.generate(a));
    while (s.cmp(i) >= 0);
    return s;
  }, r.prototype._randrange = function(i, o) {
    var a = o.sub(i);
    return i.add(this._randbelow(a));
  }, r.prototype.test = function(i, o, a) {
    var s = i.bitLength(), f = t.mont(i), u = new t(1).toRed(f);
    o || (o = Math.max(1, s / 48 | 0));
    for (var c = i.subn(1), d = 0; !c.testn(d); d++)
      ;
    for (var l = i.shrn(d), h = c.toRed(f), y = !0; o > 0; o--) {
      var b = this._randrange(new t(2), c);
      a && a(b);
      var w = b.toRed(f).redPow(l);
      if (!(w.cmp(u) === 0 || w.cmp(h) === 0)) {
        for (var A = 1; A < d; A++) {
          if (w = w.redSqr(), w.cmp(u) === 0)
            return !1;
          if (w.cmp(h) === 0)
            break;
        }
        if (A === d)
          return !1;
      }
    }
    return y;
  }, r.prototype.getDivisor = function(i, o) {
    var a = i.bitLength(), s = t.mont(i), f = new t(1).toRed(s);
    o || (o = Math.max(1, a / 48 | 0));
    for (var u = i.subn(1), c = 0; !u.testn(c); c++)
      ;
    for (var d = i.shrn(c), l = u.toRed(s); o > 0; o--) {
      var h = this._randrange(new t(2), u), y = i.gcd(h);
      if (y.cmpn(1) !== 0)
        return y;
      var b = h.toRed(s).redPow(d);
      if (!(b.cmp(f) === 0 || b.cmp(l) === 0)) {
        for (var w = 1; w < c; w++) {
          if (b = b.redSqr(), b.cmp(f) === 0)
            return b.fromRed().subn(1).gcd(i);
          if (b.cmp(l) === 0)
            break;
        }
        if (w === c)
          return b = b.redSqr(), b.fromRed().subn(1).gcd(i);
      }
    }
    return !1;
  }, hl;
}
var pl, fb;
function S3() {
  if (fb)
    return pl;
  fb = 1;
  var t = es();
  pl = w, w.simpleSieve = y, w.fermatTest = b;
  var e = mr, r = new e(24), n = E3(), i = new n(), o = new e(1), a = new e(2), s = new e(5);
  new e(16), new e(8);
  var f = new e(10), u = new e(3);
  new e(7);
  var c = new e(11), d = new e(4);
  new e(12);
  var l = null;
  function h() {
    if (l !== null)
      return l;
    var A = 1048576, M = [];
    M[0] = 2;
    for (var N = 1, G = 3; G < A; G += 2) {
      for (var z = Math.ceil(Math.sqrt(G)), J = 0; J < N && M[J] <= z && G % M[J] !== 0; J++)
        ;
      N !== J && M[J] <= z || (M[N++] = G);
    }
    return l = M, M;
  }
  function y(A) {
    for (var M = h(), N = 0; N < M.length; N++)
      if (A.modn(M[N]) === 0)
        return A.cmpn(M[N]) === 0;
    return !0;
  }
  function b(A) {
    var M = e.mont(A);
    return a.toRed(M).redPow(A.subn(1)).fromRed().cmpn(1) === 0;
  }
  function w(A, M) {
    if (A < 16)
      return M === 2 || M === 5 ? new e([140, 123]) : new e([140, 39]);
    M = new e(M);
    for (var N, G; ; ) {
      for (N = new e(t(Math.ceil(A / 8))); N.bitLength() > A; )
        N.ishrn(1);
      if (N.isEven() && N.iadd(o), N.testn(1) || N.iadd(a), M.cmp(a)) {
        if (!M.cmp(s))
          for (; N.mod(f).cmp(u); )
            N.iadd(d);
      } else
        for (; N.mod(r).cmp(c); )
          N.iadd(d);
      if (G = N.shrn(1), y(G) && y(N) && b(G) && b(N) && i.test(G) && i.test(N))
        return N;
    }
  }
  return pl;
}
const B_ = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, M_ = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, R_ = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, T_ = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, O_ = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, k_ = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, C_ = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, P_ = {
  gen: "02",
  prime: "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"
}, N_ = {
  modp1: B_,
  modp2: M_,
  modp5: R_,
  modp14: T_,
  modp15: O_,
  modp16: k_,
  modp17: C_,
  modp18: P_
};
var yl, cb;
function U_() {
  if (cb)
    return yl;
  cb = 1;
  var t = mr, e = E3(), r = new e(), n = new t(24), i = new t(11), o = new t(10), a = new t(3), s = new t(7), f = S3(), u = es();
  yl = y;
  function c(w, A) {
    return A = A || "utf8", Ie.isBuffer(w) || (w = new Ie(w, A)), this._pub = new t(w), this;
  }
  function d(w, A) {
    return A = A || "utf8", Ie.isBuffer(w) || (w = new Ie(w, A)), this._priv = new t(w), this;
  }
  var l = {};
  function h(w, A) {
    var M = A.toString("hex"), N = [M, w.toString(16)].join("_");
    if (N in l)
      return l[N];
    var G = 0;
    if (w.isEven() || !f.simpleSieve || !f.fermatTest(w) || !r.test(w))
      return G += 1, M === "02" || M === "05" ? G += 8 : G += 4, l[N] = G, G;
    r.test(w.shrn(1)) || (G += 2);
    var z;
    switch (M) {
      case "02":
        w.mod(n).cmp(i) && (G += 8);
        break;
      case "05":
        z = w.mod(o), z.cmp(a) && z.cmp(s) && (G += 8);
        break;
      default:
        G += 4;
    }
    return l[N] = G, G;
  }
  function y(w, A, M) {
    this.setGenerator(A), this.__prime = new t(w), this._prime = t.mont(this.__prime), this._primeLen = w.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, M ? (this.setPublicKey = c, this.setPrivateKey = d) : this._primeCode = 8;
  }
  Object.defineProperty(y.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = h(this.__prime, this.__gen)), this._primeCode;
    }
  }), y.prototype.generateKeys = function() {
    return this._priv || (this._priv = new t(u(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, y.prototype.computeSecret = function(w) {
    w = new t(w), w = w.toRed(this._prime);
    var A = w.redPow(this._priv).fromRed(), M = new Ie(A.toArray()), N = this.getPrime();
    if (M.length < N.length) {
      var G = new Ie(N.length - M.length);
      G.fill(0), M = Ie.concat([G, M]);
    }
    return M;
  }, y.prototype.getPublicKey = function(A) {
    return b(this._pub, A);
  }, y.prototype.getPrivateKey = function(A) {
    return b(this._priv, A);
  }, y.prototype.getPrime = function(w) {
    return b(this.__prime, w);
  }, y.prototype.getGenerator = function(w) {
    return b(this._gen, w);
  }, y.prototype.setGenerator = function(w, A) {
    return A = A || "utf8", Ie.isBuffer(w) || (w = new Ie(w, A)), this.__gen = w, this._gen = new t(w), this;
  };
  function b(w, A) {
    var M = new Ie(w.toArray());
    return A ? M.toString(A) : M;
  }
  return yl;
}
var ub;
function F_() {
  if (ub)
    return ao;
  ub = 1;
  var t = S3(), e = N_, r = U_();
  function n(a) {
    var s = new Ie(e[a].prime, "hex"), f = new Ie(e[a].gen, "hex");
    return new r(s, f);
  }
  var i = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function o(a, s, f, u) {
    return Ie.isBuffer(s) || i[s] === void 0 ? o(a, "binary", s, f) : (s = s || "binary", u = u || "binary", f = f || new Ie([2]), Ie.isBuffer(f) || (f = new Ie(f, u)), typeof a == "number" ? new r(t(a, f), f, !0) : (Ie.isBuffer(a) || (a = new Ie(a, s)), new r(a, f, !0)));
  }
  return ao.DiffieHellmanGroup = ao.createDiffieHellmanGroup = ao.getDiffieHellman = n, ao.createDiffieHellman = ao.DiffieHellman = o, ao;
}
var vs = { exports: {} }, bl, db;
function Pp() {
  if (db)
    return bl;
  db = 1;
  var t = mr, e = es();
  function r(o) {
    var a = n(o), s = a.toRed(t.mont(o.modulus)).redPow(new t(o.publicExponent)).fromRed();
    return { blinder: s, unblinder: a.invm(o.modulus) };
  }
  function n(o) {
    var a = o.modulus.byteLength(), s;
    do
      s = new t(e(a));
    while (s.cmp(o.modulus) >= 0 || !s.umod(o.prime1) || !s.umod(o.prime2));
    return s;
  }
  function i(o, a) {
    var s = r(a), f = a.modulus.byteLength(), u = new t(o).mul(s.blinder).umod(a.modulus), c = u.toRed(t.mont(a.prime1)), d = u.toRed(t.mont(a.prime2)), l = a.coefficient, h = a.prime1, y = a.prime2, b = c.redPow(a.exponent1).fromRed(), w = d.redPow(a.exponent2).fromRed(), A = b.isub(w).imul(l).umod(h).imul(y);
    return w.iadd(A).imul(s.unblinder).umod(a.modulus).toArrayLike(Ie, "be", f);
  }
  return i.getr = n, bl = i, bl;
}
var gl = {};
const L_ = "elliptic", j_ = "6.5.4", D_ = "EC cryptography", $_ = "lib/elliptic.js", q_ = [
  "lib"
], z_ = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, K_ = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, W_ = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], H_ = "Fedor Indutny <fedor@indutny.com>", G_ = "MIT", V_ = {
  url: "https://github.com/indutny/elliptic/issues"
}, Y_ = "https://github.com/indutny/elliptic", J_ = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, X_ = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, Z_ = {
  name: L_,
  version: j_,
  description: D_,
  main: $_,
  files: q_,
  scripts: z_,
  repository: K_,
  keywords: W_,
  author: H_,
  license: G_,
  bugs: V_,
  homepage: Y_,
  devDependencies: J_,
  dependencies: X_
};
var vl = {}, ml = {}, lb;
function A3() {
  return lb || (lb = 1, function(t) {
    var e = t;
    function r(o, a) {
      if (Array.isArray(o))
        return o.slice();
      if (!o)
        return [];
      var s = [];
      if (typeof o != "string") {
        for (var f = 0; f < o.length; f++)
          s[f] = o[f] | 0;
        return s;
      }
      if (a === "hex") {
        o = o.replace(/[^a-z0-9]+/ig, ""), o.length % 2 !== 0 && (o = "0" + o);
        for (var f = 0; f < o.length; f += 2)
          s.push(parseInt(o[f] + o[f + 1], 16));
      } else
        for (var f = 0; f < o.length; f++) {
          var u = o.charCodeAt(f), c = u >> 8, d = u & 255;
          c ? s.push(c, d) : s.push(d);
        }
      return s;
    }
    e.toArray = r;
    function n(o) {
      return o.length === 1 ? "0" + o : o;
    }
    e.zero2 = n;
    function i(o) {
      for (var a = "", s = 0; s < o.length; s++)
        a += n(o[s].toString(16));
      return a;
    }
    e.toHex = i, e.encode = function(a, s) {
      return s === "hex" ? i(a) : a;
    };
  }(ml)), ml;
}
var hb;
function Vn() {
  return hb || (hb = 1, function(t) {
    var e = t, r = mr, n = On, i = A3();
    e.assert = n, e.toArray = i.toArray, e.zero2 = i.zero2, e.toHex = i.toHex, e.encode = i.encode;
    function o(c, d, l) {
      var h = new Array(Math.max(c.bitLength(), l) + 1);
      h.fill(0);
      for (var y = 1 << d + 1, b = c.clone(), w = 0; w < h.length; w++) {
        var A, M = b.andln(y - 1);
        b.isOdd() ? (M > (y >> 1) - 1 ? A = (y >> 1) - M : A = M, b.isubn(A)) : A = 0, h[w] = A, b.iushrn(1);
      }
      return h;
    }
    e.getNAF = o;
    function a(c, d) {
      var l = [
        [],
        []
      ];
      c = c.clone(), d = d.clone();
      for (var h = 0, y = 0, b; c.cmpn(-h) > 0 || d.cmpn(-y) > 0; ) {
        var w = c.andln(3) + h & 3, A = d.andln(3) + y & 3;
        w === 3 && (w = -1), A === 3 && (A = -1);
        var M;
        w & 1 ? (b = c.andln(7) + h & 7, (b === 3 || b === 5) && A === 2 ? M = -w : M = w) : M = 0, l[0].push(M);
        var N;
        A & 1 ? (b = d.andln(7) + y & 7, (b === 3 || b === 5) && w === 2 ? N = -A : N = A) : N = 0, l[1].push(N), 2 * h === M + 1 && (h = 1 - h), 2 * y === N + 1 && (y = 1 - y), c.iushrn(1), d.iushrn(1);
      }
      return l;
    }
    e.getJSF = a;
    function s(c, d, l) {
      var h = "_" + d;
      c.prototype[d] = function() {
        return this[h] !== void 0 ? this[h] : this[h] = l.call(this);
      };
    }
    e.cachedProperty = s;
    function f(c) {
      return typeof c == "string" ? e.toArray(c, "hex") : c;
    }
    e.parseBytes = f;
    function u(c) {
      return new r(c, "hex", "le");
    }
    e.intFromLE = u;
  }(vl)), vl;
}
var wl = {}, xl, pb;
function Ju() {
  if (pb)
    return xl;
  pb = 1;
  var t = mr, e = Vn(), r = e.getNAF, n = e.getJSF, i = e.assert;
  function o(s, f) {
    this.type = s, this.p = new t(f.p, 16), this.red = f.prime ? t.red(f.prime) : t.mont(this.p), this.zero = new t(0).toRed(this.red), this.one = new t(1).toRed(this.red), this.two = new t(2).toRed(this.red), this.n = f.n && new t(f.n, 16), this.g = f.g && this.pointFromJSON(f.g, f.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var u = this.n && this.p.div(this.n);
    !u || u.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  xl = o, o.prototype.point = function() {
    throw new Error("Not implemented");
  }, o.prototype.validate = function() {
    throw new Error("Not implemented");
  }, o.prototype._fixedNafMul = function(f, u) {
    i(f.precomputed);
    var c = f._getDoubles(), d = r(u, 1, this._bitLength), l = (1 << c.step + 1) - (c.step % 2 === 0 ? 2 : 1);
    l /= 3;
    var h = [], y, b;
    for (y = 0; y < d.length; y += c.step) {
      b = 0;
      for (var w = y + c.step - 1; w >= y; w--)
        b = (b << 1) + d[w];
      h.push(b);
    }
    for (var A = this.jpoint(null, null, null), M = this.jpoint(null, null, null), N = l; N > 0; N--) {
      for (y = 0; y < h.length; y++)
        b = h[y], b === N ? M = M.mixedAdd(c.points[y]) : b === -N && (M = M.mixedAdd(c.points[y].neg()));
      A = A.add(M);
    }
    return A.toP();
  }, o.prototype._wnafMul = function(f, u) {
    var c = 4, d = f._getNAFPoints(c);
    c = d.wnd;
    for (var l = d.points, h = r(u, c, this._bitLength), y = this.jpoint(null, null, null), b = h.length - 1; b >= 0; b--) {
      for (var w = 0; b >= 0 && h[b] === 0; b--)
        w++;
      if (b >= 0 && w++, y = y.dblp(w), b < 0)
        break;
      var A = h[b];
      i(A !== 0), f.type === "affine" ? A > 0 ? y = y.mixedAdd(l[A - 1 >> 1]) : y = y.mixedAdd(l[-A - 1 >> 1].neg()) : A > 0 ? y = y.add(l[A - 1 >> 1]) : y = y.add(l[-A - 1 >> 1].neg());
    }
    return f.type === "affine" ? y.toP() : y;
  }, o.prototype._wnafMulAdd = function(f, u, c, d, l) {
    var h = this._wnafT1, y = this._wnafT2, b = this._wnafT3, w = 0, A, M, N;
    for (A = 0; A < d; A++) {
      N = u[A];
      var G = N._getNAFPoints(f);
      h[A] = G.wnd, y[A] = G.points;
    }
    for (A = d - 1; A >= 1; A -= 2) {
      var z = A - 1, J = A;
      if (h[z] !== 1 || h[J] !== 1) {
        b[z] = r(c[z], h[z], this._bitLength), b[J] = r(c[J], h[J], this._bitLength), w = Math.max(b[z].length, w), w = Math.max(b[J].length, w);
        continue;
      }
      var oe = [
        u[z],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        u[J]
        /* 7 */
      ];
      u[z].y.cmp(u[J].y) === 0 ? (oe[1] = u[z].add(u[J]), oe[2] = u[z].toJ().mixedAdd(u[J].neg())) : u[z].y.cmp(u[J].y.redNeg()) === 0 ? (oe[1] = u[z].toJ().mixedAdd(u[J]), oe[2] = u[z].add(u[J].neg())) : (oe[1] = u[z].toJ().mixedAdd(u[J]), oe[2] = u[z].toJ().mixedAdd(u[J].neg()));
      var ee = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], ae = n(c[z], c[J]);
      for (w = Math.max(ae[0].length, w), b[z] = new Array(w), b[J] = new Array(w), M = 0; M < w; M++) {
        var ye = ae[0][M] | 0, pe = ae[1][M] | 0;
        b[z][M] = ee[(ye + 1) * 3 + (pe + 1)], b[J][M] = 0, y[z] = oe;
      }
    }
    var te = this.jpoint(null, null, null), F = this._wnafT4;
    for (A = w; A >= 0; A--) {
      for (var v = 0; A >= 0; ) {
        var B = !0;
        for (M = 0; M < d; M++)
          F[M] = b[M][A] | 0, F[M] !== 0 && (B = !1);
        if (!B)
          break;
        v++, A--;
      }
      if (A >= 0 && v++, te = te.dblp(v), A < 0)
        break;
      for (M = 0; M < d; M++) {
        var P = F[M];
        P !== 0 && (P > 0 ? N = y[M][P - 1 >> 1] : P < 0 && (N = y[M][-P - 1 >> 1].neg()), N.type === "affine" ? te = te.mixedAdd(N) : te = te.add(N));
      }
    }
    for (A = 0; A < d; A++)
      y[A] = null;
    return l ? te : te.toP();
  };
  function a(s, f) {
    this.curve = s, this.type = f, this.precomputed = null;
  }
  return o.BasePoint = a, a.prototype.eq = function() {
    throw new Error("Not implemented");
  }, a.prototype.validate = function() {
    return this.curve.validate(this);
  }, o.prototype.decodePoint = function(f, u) {
    f = e.toArray(f, u);
    var c = this.p.byteLength();
    if ((f[0] === 4 || f[0] === 6 || f[0] === 7) && f.length - 1 === 2 * c) {
      f[0] === 6 ? i(f[f.length - 1] % 2 === 0) : f[0] === 7 && i(f[f.length - 1] % 2 === 1);
      var d = this.point(
        f.slice(1, 1 + c),
        f.slice(1 + c, 1 + 2 * c)
      );
      return d;
    } else if ((f[0] === 2 || f[0] === 3) && f.length - 1 === c)
      return this.pointFromX(f.slice(1, 1 + c), f[0] === 3);
    throw new Error("Unknown point format");
  }, a.prototype.encodeCompressed = function(f) {
    return this.encode(f, !0);
  }, a.prototype._encode = function(f) {
    var u = this.curve.p.byteLength(), c = this.getX().toArray("be", u);
    return f ? [this.getY().isEven() ? 2 : 3].concat(c) : [4].concat(c, this.getY().toArray("be", u));
  }, a.prototype.encode = function(f, u) {
    return e.encode(this._encode(u), f);
  }, a.prototype.precompute = function(f) {
    if (this.precomputed)
      return this;
    var u = {
      doubles: null,
      naf: null,
      beta: null
    };
    return u.naf = this._getNAFPoints(8), u.doubles = this._getDoubles(4, f), u.beta = this._getBeta(), this.precomputed = u, this;
  }, a.prototype._hasDoubles = function(f) {
    if (!this.precomputed)
      return !1;
    var u = this.precomputed.doubles;
    return u ? u.points.length >= Math.ceil((f.bitLength() + 1) / u.step) : !1;
  }, a.prototype._getDoubles = function(f, u) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var c = [this], d = this, l = 0; l < u; l += f) {
      for (var h = 0; h < f; h++)
        d = d.dbl();
      c.push(d);
    }
    return {
      step: f,
      points: c
    };
  }, a.prototype._getNAFPoints = function(f) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var u = [this], c = (1 << f) - 1, d = c === 1 ? null : this.dbl(), l = 1; l < c; l++)
      u[l] = u[l - 1].add(d);
    return {
      wnd: f,
      points: u
    };
  }, a.prototype._getBeta = function() {
    return null;
  }, a.prototype.dblp = function(f) {
    for (var u = this, c = 0; c < f; c++)
      u = u.dbl();
    return u;
  }, xl;
}
var _l, yb;
function Q_() {
  if (yb)
    return _l;
  yb = 1;
  var t = Vn(), e = mr, r = Mt, n = Ju(), i = t.assert;
  function o(f) {
    n.call(this, "short", f), this.a = new e(f.a, 16).toRed(this.red), this.b = new e(f.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(f), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  r(o, n), _l = o, o.prototype._getEndomorphism = function(u) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var c, d;
      if (u.beta)
        c = new e(u.beta, 16).toRed(this.red);
      else {
        var l = this._getEndoRoots(this.p);
        c = l[0].cmp(l[1]) < 0 ? l[0] : l[1], c = c.toRed(this.red);
      }
      if (u.lambda)
        d = new e(u.lambda, 16);
      else {
        var h = this._getEndoRoots(this.n);
        this.g.mul(h[0]).x.cmp(this.g.x.redMul(c)) === 0 ? d = h[0] : (d = h[1], i(this.g.mul(d).x.cmp(this.g.x.redMul(c)) === 0));
      }
      var y;
      return u.basis ? y = u.basis.map(function(b) {
        return {
          a: new e(b.a, 16),
          b: new e(b.b, 16)
        };
      }) : y = this._getEndoBasis(d), {
        beta: c,
        lambda: d,
        basis: y
      };
    }
  }, o.prototype._getEndoRoots = function(u) {
    var c = u === this.p ? this.red : e.mont(u), d = new e(2).toRed(c).redInvm(), l = d.redNeg(), h = new e(3).toRed(c).redNeg().redSqrt().redMul(d), y = l.redAdd(h).fromRed(), b = l.redSub(h).fromRed();
    return [y, b];
  }, o.prototype._getEndoBasis = function(u) {
    for (var c = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), d = u, l = this.n.clone(), h = new e(1), y = new e(0), b = new e(0), w = new e(1), A, M, N, G, z, J, oe, ee = 0, ae, ye; d.cmpn(0) !== 0; ) {
      var pe = l.div(d);
      ae = l.sub(pe.mul(d)), ye = b.sub(pe.mul(h));
      var te = w.sub(pe.mul(y));
      if (!N && ae.cmp(c) < 0)
        A = oe.neg(), M = h, N = ae.neg(), G = ye;
      else if (N && ++ee === 2)
        break;
      oe = ae, l = d, d = ae, b = h, h = ye, w = y, y = te;
    }
    z = ae.neg(), J = ye;
    var F = N.sqr().add(G.sqr()), v = z.sqr().add(J.sqr());
    return v.cmp(F) >= 0 && (z = A, J = M), N.negative && (N = N.neg(), G = G.neg()), z.negative && (z = z.neg(), J = J.neg()), [
      { a: N, b: G },
      { a: z, b: J }
    ];
  }, o.prototype._endoSplit = function(u) {
    var c = this.endo.basis, d = c[0], l = c[1], h = l.b.mul(u).divRound(this.n), y = d.b.neg().mul(u).divRound(this.n), b = h.mul(d.a), w = y.mul(l.a), A = h.mul(d.b), M = y.mul(l.b), N = u.sub(b).sub(w), G = A.add(M).neg();
    return { k1: N, k2: G };
  }, o.prototype.pointFromX = function(u, c) {
    u = new e(u, 16), u.red || (u = u.toRed(this.red));
    var d = u.redSqr().redMul(u).redIAdd(u.redMul(this.a)).redIAdd(this.b), l = d.redSqrt();
    if (l.redSqr().redSub(d).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var h = l.fromRed().isOdd();
    return (c && !h || !c && h) && (l = l.redNeg()), this.point(u, l);
  }, o.prototype.validate = function(u) {
    if (u.inf)
      return !0;
    var c = u.x, d = u.y, l = this.a.redMul(c), h = c.redSqr().redMul(c).redIAdd(l).redIAdd(this.b);
    return d.redSqr().redISub(h).cmpn(0) === 0;
  }, o.prototype._endoWnafMulAdd = function(u, c, d) {
    for (var l = this._endoWnafT1, h = this._endoWnafT2, y = 0; y < u.length; y++) {
      var b = this._endoSplit(c[y]), w = u[y], A = w._getBeta();
      b.k1.negative && (b.k1.ineg(), w = w.neg(!0)), b.k2.negative && (b.k2.ineg(), A = A.neg(!0)), l[y * 2] = w, l[y * 2 + 1] = A, h[y * 2] = b.k1, h[y * 2 + 1] = b.k2;
    }
    for (var M = this._wnafMulAdd(1, l, h, y * 2, d), N = 0; N < y * 2; N++)
      l[N] = null, h[N] = null;
    return M;
  };
  function a(f, u, c, d) {
    n.BasePoint.call(this, f, "affine"), u === null && c === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new e(u, 16), this.y = new e(c, 16), d && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  r(a, n.BasePoint), o.prototype.point = function(u, c, d) {
    return new a(this, u, c, d);
  }, o.prototype.pointFromJSON = function(u, c) {
    return a.fromJSON(this, u, c);
  }, a.prototype._getBeta = function() {
    if (this.curve.endo) {
      var u = this.precomputed;
      if (u && u.beta)
        return u.beta;
      var c = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (u) {
        var d = this.curve, l = function(h) {
          return d.point(h.x.redMul(d.endo.beta), h.y);
        };
        u.beta = c, c.precomputed = {
          beta: null,
          naf: u.naf && {
            wnd: u.naf.wnd,
            points: u.naf.points.map(l)
          },
          doubles: u.doubles && {
            step: u.doubles.step,
            points: u.doubles.points.map(l)
          }
        };
      }
      return c;
    }
  }, a.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, a.fromJSON = function(u, c, d) {
    typeof c == "string" && (c = JSON.parse(c));
    var l = u.point(c[0], c[1], d);
    if (!c[2])
      return l;
    function h(b) {
      return u.point(b[0], b[1], d);
    }
    var y = c[2];
    return l.precomputed = {
      beta: null,
      doubles: y.doubles && {
        step: y.doubles.step,
        points: [l].concat(y.doubles.points.map(h))
      },
      naf: y.naf && {
        wnd: y.naf.wnd,
        points: [l].concat(y.naf.points.map(h))
      }
    }, l;
  }, a.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, a.prototype.isInfinity = function() {
    return this.inf;
  }, a.prototype.add = function(u) {
    if (this.inf)
      return u;
    if (u.inf)
      return this;
    if (this.eq(u))
      return this.dbl();
    if (this.neg().eq(u))
      return this.curve.point(null, null);
    if (this.x.cmp(u.x) === 0)
      return this.curve.point(null, null);
    var c = this.y.redSub(u.y);
    c.cmpn(0) !== 0 && (c = c.redMul(this.x.redSub(u.x).redInvm()));
    var d = c.redSqr().redISub(this.x).redISub(u.x), l = c.redMul(this.x.redSub(d)).redISub(this.y);
    return this.curve.point(d, l);
  }, a.prototype.dbl = function() {
    if (this.inf)
      return this;
    var u = this.y.redAdd(this.y);
    if (u.cmpn(0) === 0)
      return this.curve.point(null, null);
    var c = this.curve.a, d = this.x.redSqr(), l = u.redInvm(), h = d.redAdd(d).redIAdd(d).redIAdd(c).redMul(l), y = h.redSqr().redISub(this.x.redAdd(this.x)), b = h.redMul(this.x.redSub(y)).redISub(this.y);
    return this.curve.point(y, b);
  }, a.prototype.getX = function() {
    return this.x.fromRed();
  }, a.prototype.getY = function() {
    return this.y.fromRed();
  }, a.prototype.mul = function(u) {
    return u = new e(u, 16), this.isInfinity() ? this : this._hasDoubles(u) ? this.curve._fixedNafMul(this, u) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [u]) : this.curve._wnafMul(this, u);
  }, a.prototype.mulAdd = function(u, c, d) {
    var l = [this, c], h = [u, d];
    return this.curve.endo ? this.curve._endoWnafMulAdd(l, h) : this.curve._wnafMulAdd(1, l, h, 2);
  }, a.prototype.jmulAdd = function(u, c, d) {
    var l = [this, c], h = [u, d];
    return this.curve.endo ? this.curve._endoWnafMulAdd(l, h, !0) : this.curve._wnafMulAdd(1, l, h, 2, !0);
  }, a.prototype.eq = function(u) {
    return this === u || this.inf === u.inf && (this.inf || this.x.cmp(u.x) === 0 && this.y.cmp(u.y) === 0);
  }, a.prototype.neg = function(u) {
    if (this.inf)
      return this;
    var c = this.curve.point(this.x, this.y.redNeg());
    if (u && this.precomputed) {
      var d = this.precomputed, l = function(h) {
        return h.neg();
      };
      c.precomputed = {
        naf: d.naf && {
          wnd: d.naf.wnd,
          points: d.naf.points.map(l)
        },
        doubles: d.doubles && {
          step: d.doubles.step,
          points: d.doubles.points.map(l)
        }
      };
    }
    return c;
  }, a.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var u = this.curve.jpoint(this.x, this.y, this.curve.one);
    return u;
  };
  function s(f, u, c, d) {
    n.BasePoint.call(this, f, "jacobian"), u === null && c === null && d === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new e(0)) : (this.x = new e(u, 16), this.y = new e(c, 16), this.z = new e(d, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return r(s, n.BasePoint), o.prototype.jpoint = function(u, c, d) {
    return new s(this, u, c, d);
  }, s.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var u = this.z.redInvm(), c = u.redSqr(), d = this.x.redMul(c), l = this.y.redMul(c).redMul(u);
    return this.curve.point(d, l);
  }, s.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, s.prototype.add = function(u) {
    if (this.isInfinity())
      return u;
    if (u.isInfinity())
      return this;
    var c = u.z.redSqr(), d = this.z.redSqr(), l = this.x.redMul(c), h = u.x.redMul(d), y = this.y.redMul(c.redMul(u.z)), b = u.y.redMul(d.redMul(this.z)), w = l.redSub(h), A = y.redSub(b);
    if (w.cmpn(0) === 0)
      return A.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var M = w.redSqr(), N = M.redMul(w), G = l.redMul(M), z = A.redSqr().redIAdd(N).redISub(G).redISub(G), J = A.redMul(G.redISub(z)).redISub(y.redMul(N)), oe = this.z.redMul(u.z).redMul(w);
    return this.curve.jpoint(z, J, oe);
  }, s.prototype.mixedAdd = function(u) {
    if (this.isInfinity())
      return u.toJ();
    if (u.isInfinity())
      return this;
    var c = this.z.redSqr(), d = this.x, l = u.x.redMul(c), h = this.y, y = u.y.redMul(c).redMul(this.z), b = d.redSub(l), w = h.redSub(y);
    if (b.cmpn(0) === 0)
      return w.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var A = b.redSqr(), M = A.redMul(b), N = d.redMul(A), G = w.redSqr().redIAdd(M).redISub(N).redISub(N), z = w.redMul(N.redISub(G)).redISub(h.redMul(M)), J = this.z.redMul(b);
    return this.curve.jpoint(G, z, J);
  }, s.prototype.dblp = function(u) {
    if (u === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!u)
      return this.dbl();
    var c;
    if (this.curve.zeroA || this.curve.threeA) {
      var d = this;
      for (c = 0; c < u; c++)
        d = d.dbl();
      return d;
    }
    var l = this.curve.a, h = this.curve.tinv, y = this.x, b = this.y, w = this.z, A = w.redSqr().redSqr(), M = b.redAdd(b);
    for (c = 0; c < u; c++) {
      var N = y.redSqr(), G = M.redSqr(), z = G.redSqr(), J = N.redAdd(N).redIAdd(N).redIAdd(l.redMul(A)), oe = y.redMul(G), ee = J.redSqr().redISub(oe.redAdd(oe)), ae = oe.redISub(ee), ye = J.redMul(ae);
      ye = ye.redIAdd(ye).redISub(z);
      var pe = M.redMul(w);
      c + 1 < u && (A = A.redMul(z)), y = ee, w = pe, M = ye;
    }
    return this.curve.jpoint(y, M.redMul(h), w);
  }, s.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, s.prototype._zeroDbl = function() {
    var u, c, d;
    if (this.zOne) {
      var l = this.x.redSqr(), h = this.y.redSqr(), y = h.redSqr(), b = this.x.redAdd(h).redSqr().redISub(l).redISub(y);
      b = b.redIAdd(b);
      var w = l.redAdd(l).redIAdd(l), A = w.redSqr().redISub(b).redISub(b), M = y.redIAdd(y);
      M = M.redIAdd(M), M = M.redIAdd(M), u = A, c = w.redMul(b.redISub(A)).redISub(M), d = this.y.redAdd(this.y);
    } else {
      var N = this.x.redSqr(), G = this.y.redSqr(), z = G.redSqr(), J = this.x.redAdd(G).redSqr().redISub(N).redISub(z);
      J = J.redIAdd(J);
      var oe = N.redAdd(N).redIAdd(N), ee = oe.redSqr(), ae = z.redIAdd(z);
      ae = ae.redIAdd(ae), ae = ae.redIAdd(ae), u = ee.redISub(J).redISub(J), c = oe.redMul(J.redISub(u)).redISub(ae), d = this.y.redMul(this.z), d = d.redIAdd(d);
    }
    return this.curve.jpoint(u, c, d);
  }, s.prototype._threeDbl = function() {
    var u, c, d;
    if (this.zOne) {
      var l = this.x.redSqr(), h = this.y.redSqr(), y = h.redSqr(), b = this.x.redAdd(h).redSqr().redISub(l).redISub(y);
      b = b.redIAdd(b);
      var w = l.redAdd(l).redIAdd(l).redIAdd(this.curve.a), A = w.redSqr().redISub(b).redISub(b);
      u = A;
      var M = y.redIAdd(y);
      M = M.redIAdd(M), M = M.redIAdd(M), c = w.redMul(b.redISub(A)).redISub(M), d = this.y.redAdd(this.y);
    } else {
      var N = this.z.redSqr(), G = this.y.redSqr(), z = this.x.redMul(G), J = this.x.redSub(N).redMul(this.x.redAdd(N));
      J = J.redAdd(J).redIAdd(J);
      var oe = z.redIAdd(z);
      oe = oe.redIAdd(oe);
      var ee = oe.redAdd(oe);
      u = J.redSqr().redISub(ee), d = this.y.redAdd(this.z).redSqr().redISub(G).redISub(N);
      var ae = G.redSqr();
      ae = ae.redIAdd(ae), ae = ae.redIAdd(ae), ae = ae.redIAdd(ae), c = J.redMul(oe.redISub(u)).redISub(ae);
    }
    return this.curve.jpoint(u, c, d);
  }, s.prototype._dbl = function() {
    var u = this.curve.a, c = this.x, d = this.y, l = this.z, h = l.redSqr().redSqr(), y = c.redSqr(), b = d.redSqr(), w = y.redAdd(y).redIAdd(y).redIAdd(u.redMul(h)), A = c.redAdd(c);
    A = A.redIAdd(A);
    var M = A.redMul(b), N = w.redSqr().redISub(M.redAdd(M)), G = M.redISub(N), z = b.redSqr();
    z = z.redIAdd(z), z = z.redIAdd(z), z = z.redIAdd(z);
    var J = w.redMul(G).redISub(z), oe = d.redAdd(d).redMul(l);
    return this.curve.jpoint(N, J, oe);
  }, s.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var u = this.x.redSqr(), c = this.y.redSqr(), d = this.z.redSqr(), l = c.redSqr(), h = u.redAdd(u).redIAdd(u), y = h.redSqr(), b = this.x.redAdd(c).redSqr().redISub(u).redISub(l);
    b = b.redIAdd(b), b = b.redAdd(b).redIAdd(b), b = b.redISub(y);
    var w = b.redSqr(), A = l.redIAdd(l);
    A = A.redIAdd(A), A = A.redIAdd(A), A = A.redIAdd(A);
    var M = h.redIAdd(b).redSqr().redISub(y).redISub(w).redISub(A), N = c.redMul(M);
    N = N.redIAdd(N), N = N.redIAdd(N);
    var G = this.x.redMul(w).redISub(N);
    G = G.redIAdd(G), G = G.redIAdd(G);
    var z = this.y.redMul(M.redMul(A.redISub(M)).redISub(b.redMul(w)));
    z = z.redIAdd(z), z = z.redIAdd(z), z = z.redIAdd(z);
    var J = this.z.redAdd(b).redSqr().redISub(d).redISub(w);
    return this.curve.jpoint(G, z, J);
  }, s.prototype.mul = function(u, c) {
    return u = new e(u, c), this.curve._wnafMul(this, u);
  }, s.prototype.eq = function(u) {
    if (u.type === "affine")
      return this.eq(u.toJ());
    if (this === u)
      return !0;
    var c = this.z.redSqr(), d = u.z.redSqr();
    if (this.x.redMul(d).redISub(u.x.redMul(c)).cmpn(0) !== 0)
      return !1;
    var l = c.redMul(this.z), h = d.redMul(u.z);
    return this.y.redMul(h).redISub(u.y.redMul(l)).cmpn(0) === 0;
  }, s.prototype.eqXToP = function(u) {
    var c = this.z.redSqr(), d = u.toRed(this.curve.red).redMul(c);
    if (this.x.cmp(d) === 0)
      return !0;
    for (var l = u.clone(), h = this.curve.redN.redMul(c); ; ) {
      if (l.iadd(this.curve.n), l.cmp(this.curve.p) >= 0)
        return !1;
      if (d.redIAdd(h), this.x.cmp(d) === 0)
        return !0;
    }
  }, s.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, s.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, _l;
}
var El, bb;
function eE() {
  if (bb)
    return El;
  bb = 1;
  var t = mr, e = Mt, r = Ju(), n = Vn();
  function i(a) {
    r.call(this, "mont", a), this.a = new t(a.a, 16).toRed(this.red), this.b = new t(a.b, 16).toRed(this.red), this.i4 = new t(4).toRed(this.red).redInvm(), this.two = new t(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  e(i, r), El = i, i.prototype.validate = function(s) {
    var f = s.normalize().x, u = f.redSqr(), c = u.redMul(f).redAdd(u.redMul(this.a)).redAdd(f), d = c.redSqrt();
    return d.redSqr().cmp(c) === 0;
  };
  function o(a, s, f) {
    r.BasePoint.call(this, a, "projective"), s === null && f === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new t(s, 16), this.z = new t(f, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return e(o, r.BasePoint), i.prototype.decodePoint = function(s, f) {
    return this.point(n.toArray(s, f), 1);
  }, i.prototype.point = function(s, f) {
    return new o(this, s, f);
  }, i.prototype.pointFromJSON = function(s) {
    return o.fromJSON(this, s);
  }, o.prototype.precompute = function() {
  }, o.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, o.fromJSON = function(s, f) {
    return new o(s, f[0], f[1] || s.one);
  }, o.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, o.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, o.prototype.dbl = function() {
    var s = this.x.redAdd(this.z), f = s.redSqr(), u = this.x.redSub(this.z), c = u.redSqr(), d = f.redSub(c), l = f.redMul(c), h = d.redMul(c.redAdd(this.curve.a24.redMul(d)));
    return this.curve.point(l, h);
  }, o.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, o.prototype.diffAdd = function(s, f) {
    var u = this.x.redAdd(this.z), c = this.x.redSub(this.z), d = s.x.redAdd(s.z), l = s.x.redSub(s.z), h = l.redMul(u), y = d.redMul(c), b = f.z.redMul(h.redAdd(y).redSqr()), w = f.x.redMul(h.redISub(y).redSqr());
    return this.curve.point(b, w);
  }, o.prototype.mul = function(s) {
    for (var f = s.clone(), u = this, c = this.curve.point(null, null), d = this, l = []; f.cmpn(0) !== 0; f.iushrn(1))
      l.push(f.andln(1));
    for (var h = l.length - 1; h >= 0; h--)
      l[h] === 0 ? (u = u.diffAdd(c, d), c = c.dbl()) : (c = u.diffAdd(c, d), u = u.dbl());
    return c;
  }, o.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, o.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, o.prototype.eq = function(s) {
    return this.getX().cmp(s.getX()) === 0;
  }, o.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, o.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, El;
}
var Sl, gb;
function tE() {
  if (gb)
    return Sl;
  gb = 1;
  var t = Vn(), e = mr, r = Mt, n = Ju(), i = t.assert;
  function o(s) {
    this.twisted = (s.a | 0) !== 1, this.mOneA = this.twisted && (s.a | 0) === -1, this.extended = this.mOneA, n.call(this, "edwards", s), this.a = new e(s.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new e(s.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new e(s.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), i(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (s.c | 0) === 1;
  }
  r(o, n), Sl = o, o.prototype._mulA = function(f) {
    return this.mOneA ? f.redNeg() : this.a.redMul(f);
  }, o.prototype._mulC = function(f) {
    return this.oneC ? f : this.c.redMul(f);
  }, o.prototype.jpoint = function(f, u, c, d) {
    return this.point(f, u, c, d);
  }, o.prototype.pointFromX = function(f, u) {
    f = new e(f, 16), f.red || (f = f.toRed(this.red));
    var c = f.redSqr(), d = this.c2.redSub(this.a.redMul(c)), l = this.one.redSub(this.c2.redMul(this.d).redMul(c)), h = d.redMul(l.redInvm()), y = h.redSqrt();
    if (y.redSqr().redSub(h).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var b = y.fromRed().isOdd();
    return (u && !b || !u && b) && (y = y.redNeg()), this.point(f, y);
  }, o.prototype.pointFromY = function(f, u) {
    f = new e(f, 16), f.red || (f = f.toRed(this.red));
    var c = f.redSqr(), d = c.redSub(this.c2), l = c.redMul(this.d).redMul(this.c2).redSub(this.a), h = d.redMul(l.redInvm());
    if (h.cmp(this.zero) === 0) {
      if (u)
        throw new Error("invalid point");
      return this.point(this.zero, f);
    }
    var y = h.redSqrt();
    if (y.redSqr().redSub(h).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return y.fromRed().isOdd() !== u && (y = y.redNeg()), this.point(y, f);
  }, o.prototype.validate = function(f) {
    if (f.isInfinity())
      return !0;
    f.normalize();
    var u = f.x.redSqr(), c = f.y.redSqr(), d = u.redMul(this.a).redAdd(c), l = this.c2.redMul(this.one.redAdd(this.d.redMul(u).redMul(c)));
    return d.cmp(l) === 0;
  };
  function a(s, f, u, c, d) {
    n.BasePoint.call(this, s, "projective"), f === null && u === null && c === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new e(f, 16), this.y = new e(u, 16), this.z = c ? new e(c, 16) : this.curve.one, this.t = d && new e(d, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return r(a, n.BasePoint), o.prototype.pointFromJSON = function(f) {
    return a.fromJSON(this, f);
  }, o.prototype.point = function(f, u, c, d) {
    return new a(this, f, u, c, d);
  }, a.fromJSON = function(f, u) {
    return new a(f, u[0], u[1], u[2]);
  }, a.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, a.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, a.prototype._extDbl = function() {
    var f = this.x.redSqr(), u = this.y.redSqr(), c = this.z.redSqr();
    c = c.redIAdd(c);
    var d = this.curve._mulA(f), l = this.x.redAdd(this.y).redSqr().redISub(f).redISub(u), h = d.redAdd(u), y = h.redSub(c), b = d.redSub(u), w = l.redMul(y), A = h.redMul(b), M = l.redMul(b), N = y.redMul(h);
    return this.curve.point(w, A, N, M);
  }, a.prototype._projDbl = function() {
    var f = this.x.redAdd(this.y).redSqr(), u = this.x.redSqr(), c = this.y.redSqr(), d, l, h, y, b, w;
    if (this.curve.twisted) {
      y = this.curve._mulA(u);
      var A = y.redAdd(c);
      this.zOne ? (d = f.redSub(u).redSub(c).redMul(A.redSub(this.curve.two)), l = A.redMul(y.redSub(c)), h = A.redSqr().redSub(A).redSub(A)) : (b = this.z.redSqr(), w = A.redSub(b).redISub(b), d = f.redSub(u).redISub(c).redMul(w), l = A.redMul(y.redSub(c)), h = A.redMul(w));
    } else
      y = u.redAdd(c), b = this.curve._mulC(this.z).redSqr(), w = y.redSub(b).redSub(b), d = this.curve._mulC(f.redISub(y)).redMul(w), l = this.curve._mulC(y).redMul(u.redISub(c)), h = y.redMul(w);
    return this.curve.point(d, l, h);
  }, a.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, a.prototype._extAdd = function(f) {
    var u = this.y.redSub(this.x).redMul(f.y.redSub(f.x)), c = this.y.redAdd(this.x).redMul(f.y.redAdd(f.x)), d = this.t.redMul(this.curve.dd).redMul(f.t), l = this.z.redMul(f.z.redAdd(f.z)), h = c.redSub(u), y = l.redSub(d), b = l.redAdd(d), w = c.redAdd(u), A = h.redMul(y), M = b.redMul(w), N = h.redMul(w), G = y.redMul(b);
    return this.curve.point(A, M, G, N);
  }, a.prototype._projAdd = function(f) {
    var u = this.z.redMul(f.z), c = u.redSqr(), d = this.x.redMul(f.x), l = this.y.redMul(f.y), h = this.curve.d.redMul(d).redMul(l), y = c.redSub(h), b = c.redAdd(h), w = this.x.redAdd(this.y).redMul(f.x.redAdd(f.y)).redISub(d).redISub(l), A = u.redMul(y).redMul(w), M, N;
    return this.curve.twisted ? (M = u.redMul(b).redMul(l.redSub(this.curve._mulA(d))), N = y.redMul(b)) : (M = u.redMul(b).redMul(l.redSub(d)), N = this.curve._mulC(y).redMul(b)), this.curve.point(A, M, N);
  }, a.prototype.add = function(f) {
    return this.isInfinity() ? f : f.isInfinity() ? this : this.curve.extended ? this._extAdd(f) : this._projAdd(f);
  }, a.prototype.mul = function(f) {
    return this._hasDoubles(f) ? this.curve._fixedNafMul(this, f) : this.curve._wnafMul(this, f);
  }, a.prototype.mulAdd = function(f, u, c) {
    return this.curve._wnafMulAdd(1, [this, u], [f, c], 2, !1);
  }, a.prototype.jmulAdd = function(f, u, c) {
    return this.curve._wnafMulAdd(1, [this, u], [f, c], 2, !0);
  }, a.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var f = this.z.redInvm();
    return this.x = this.x.redMul(f), this.y = this.y.redMul(f), this.t && (this.t = this.t.redMul(f)), this.z = this.curve.one, this.zOne = !0, this;
  }, a.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, a.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, a.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, a.prototype.eq = function(f) {
    return this === f || this.getX().cmp(f.getX()) === 0 && this.getY().cmp(f.getY()) === 0;
  }, a.prototype.eqXToP = function(f) {
    var u = f.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(u) === 0)
      return !0;
    for (var c = f.clone(), d = this.curve.redN.redMul(this.z); ; ) {
      if (c.iadd(this.curve.n), c.cmp(this.curve.p) >= 0)
        return !1;
      if (u.redIAdd(d), this.x.cmp(u) === 0)
        return !0;
    }
  }, a.prototype.toP = a.prototype.normalize, a.prototype.mixedAdd = a.prototype.add, Sl;
}
var vb;
function I3() {
  return vb || (vb = 1, function(t) {
    var e = t;
    e.base = Ju(), e.short = Q_(), e.mont = eE(), e.edwards = tE();
  }(wl)), wl;
}
var Al = {}, Il = {}, ar = {}, mb;
function _i() {
  if (mb)
    return ar;
  mb = 1;
  var t = On, e = Mt;
  ar.inherits = e;
  function r(te, F) {
    return (te.charCodeAt(F) & 64512) !== 55296 || F < 0 || F + 1 >= te.length ? !1 : (te.charCodeAt(F + 1) & 64512) === 56320;
  }
  function n(te, F) {
    if (Array.isArray(te))
      return te.slice();
    if (!te)
      return [];
    var v = [];
    if (typeof te == "string")
      if (F) {
        if (F === "hex")
          for (te = te.replace(/[^a-z0-9]+/ig, ""), te.length % 2 !== 0 && (te = "0" + te), P = 0; P < te.length; P += 2)
            v.push(parseInt(te[P] + te[P + 1], 16));
      } else
        for (var B = 0, P = 0; P < te.length; P++) {
          var L = te.charCodeAt(P);
          L < 128 ? v[B++] = L : L < 2048 ? (v[B++] = L >> 6 | 192, v[B++] = L & 63 | 128) : r(te, P) ? (L = 65536 + ((L & 1023) << 10) + (te.charCodeAt(++P) & 1023), v[B++] = L >> 18 | 240, v[B++] = L >> 12 & 63 | 128, v[B++] = L >> 6 & 63 | 128, v[B++] = L & 63 | 128) : (v[B++] = L >> 12 | 224, v[B++] = L >> 6 & 63 | 128, v[B++] = L & 63 | 128);
        }
    else
      for (P = 0; P < te.length; P++)
        v[P] = te[P] | 0;
    return v;
  }
  ar.toArray = n;
  function i(te) {
    for (var F = "", v = 0; v < te.length; v++)
      F += s(te[v].toString(16));
    return F;
  }
  ar.toHex = i;
  function o(te) {
    var F = te >>> 24 | te >>> 8 & 65280 | te << 8 & 16711680 | (te & 255) << 24;
    return F >>> 0;
  }
  ar.htonl = o;
  function a(te, F) {
    for (var v = "", B = 0; B < te.length; B++) {
      var P = te[B];
      F === "little" && (P = o(P)), v += f(P.toString(16));
    }
    return v;
  }
  ar.toHex32 = a;
  function s(te) {
    return te.length === 1 ? "0" + te : te;
  }
  ar.zero2 = s;
  function f(te) {
    return te.length === 7 ? "0" + te : te.length === 6 ? "00" + te : te.length === 5 ? "000" + te : te.length === 4 ? "0000" + te : te.length === 3 ? "00000" + te : te.length === 2 ? "000000" + te : te.length === 1 ? "0000000" + te : te;
  }
  ar.zero8 = f;
  function u(te, F, v, B) {
    var P = v - F;
    t(P % 4 === 0);
    for (var L = new Array(P / 4), x = 0, C = F; x < L.length; x++, C += 4) {
      var j;
      B === "big" ? j = te[C] << 24 | te[C + 1] << 16 | te[C + 2] << 8 | te[C + 3] : j = te[C + 3] << 24 | te[C + 2] << 16 | te[C + 1] << 8 | te[C], L[x] = j >>> 0;
    }
    return L;
  }
  ar.join32 = u;
  function c(te, F) {
    for (var v = new Array(te.length * 4), B = 0, P = 0; B < te.length; B++, P += 4) {
      var L = te[B];
      F === "big" ? (v[P] = L >>> 24, v[P + 1] = L >>> 16 & 255, v[P + 2] = L >>> 8 & 255, v[P + 3] = L & 255) : (v[P + 3] = L >>> 24, v[P + 2] = L >>> 16 & 255, v[P + 1] = L >>> 8 & 255, v[P] = L & 255);
    }
    return v;
  }
  ar.split32 = c;
  function d(te, F) {
    return te >>> F | te << 32 - F;
  }
  ar.rotr32 = d;
  function l(te, F) {
    return te << F | te >>> 32 - F;
  }
  ar.rotl32 = l;
  function h(te, F) {
    return te + F >>> 0;
  }
  ar.sum32 = h;
  function y(te, F, v) {
    return te + F + v >>> 0;
  }
  ar.sum32_3 = y;
  function b(te, F, v, B) {
    return te + F + v + B >>> 0;
  }
  ar.sum32_4 = b;
  function w(te, F, v, B, P) {
    return te + F + v + B + P >>> 0;
  }
  ar.sum32_5 = w;
  function A(te, F, v, B) {
    var P = te[F], L = te[F + 1], x = B + L >>> 0, C = (x < B ? 1 : 0) + v + P;
    te[F] = C >>> 0, te[F + 1] = x;
  }
  ar.sum64 = A;
  function M(te, F, v, B) {
    var P = F + B >>> 0, L = (P < F ? 1 : 0) + te + v;
    return L >>> 0;
  }
  ar.sum64_hi = M;
  function N(te, F, v, B) {
    var P = F + B;
    return P >>> 0;
  }
  ar.sum64_lo = N;
  function G(te, F, v, B, P, L, x, C) {
    var j = 0, k = F;
    k = k + B >>> 0, j += k < F ? 1 : 0, k = k + L >>> 0, j += k < L ? 1 : 0, k = k + C >>> 0, j += k < C ? 1 : 0;
    var g = te + v + P + x + j;
    return g >>> 0;
  }
  ar.sum64_4_hi = G;
  function z(te, F, v, B, P, L, x, C) {
    var j = F + B + L + C;
    return j >>> 0;
  }
  ar.sum64_4_lo = z;
  function J(te, F, v, B, P, L, x, C, j, k) {
    var g = 0, R = F;
    R = R + B >>> 0, g += R < F ? 1 : 0, R = R + L >>> 0, g += R < L ? 1 : 0, R = R + C >>> 0, g += R < C ? 1 : 0, R = R + k >>> 0, g += R < k ? 1 : 0;
    var X = te + v + P + x + j + g;
    return X >>> 0;
  }
  ar.sum64_5_hi = J;
  function oe(te, F, v, B, P, L, x, C, j, k) {
    var g = F + B + L + C + k;
    return g >>> 0;
  }
  ar.sum64_5_lo = oe;
  function ee(te, F, v) {
    var B = F << 32 - v | te >>> v;
    return B >>> 0;
  }
  ar.rotr64_hi = ee;
  function ae(te, F, v) {
    var B = te << 32 - v | F >>> v;
    return B >>> 0;
  }
  ar.rotr64_lo = ae;
  function ye(te, F, v) {
    return te >>> v;
  }
  ar.shr64_hi = ye;
  function pe(te, F, v) {
    var B = te << 32 - v | F >>> v;
    return B >>> 0;
  }
  return ar.shr64_lo = pe, ar;
}
var Bl = {}, wb;
function Rf() {
  if (wb)
    return Bl;
  wb = 1;
  var t = _i(), e = On;
  function r() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  return Bl.BlockHash = r, r.prototype.update = function(i, o) {
    if (i = t.toArray(i, o), this.pending ? this.pending = this.pending.concat(i) : this.pending = i, this.pendingTotal += i.length, this.pending.length >= this._delta8) {
      i = this.pending;
      var a = i.length % this._delta8;
      this.pending = i.slice(i.length - a, i.length), this.pending.length === 0 && (this.pending = null), i = t.join32(i, 0, i.length - a, this.endian);
      for (var s = 0; s < i.length; s += this._delta32)
        this._update(i, s, s + this._delta32);
    }
    return this;
  }, r.prototype.digest = function(i) {
    return this.update(this._pad()), e(this.pending === null), this._digest(i);
  }, r.prototype._pad = function() {
    var i = this.pendingTotal, o = this._delta8, a = o - (i + this.padLength) % o, s = new Array(a + this.padLength);
    s[0] = 128;
    for (var f = 1; f < a; f++)
      s[f] = 0;
    if (i <<= 3, this.endian === "big") {
      for (var u = 8; u < this.padLength; u++)
        s[f++] = 0;
      s[f++] = 0, s[f++] = 0, s[f++] = 0, s[f++] = 0, s[f++] = i >>> 24 & 255, s[f++] = i >>> 16 & 255, s[f++] = i >>> 8 & 255, s[f++] = i & 255;
    } else
      for (s[f++] = i & 255, s[f++] = i >>> 8 & 255, s[f++] = i >>> 16 & 255, s[f++] = i >>> 24 & 255, s[f++] = 0, s[f++] = 0, s[f++] = 0, s[f++] = 0, u = 8; u < this.padLength; u++)
        s[f++] = 0;
    return s;
  }, Bl;
}
var so = {}, ui = {}, xb;
function B3() {
  if (xb)
    return ui;
  xb = 1;
  var t = _i(), e = t.rotr32;
  function r(c, d, l, h) {
    if (c === 0)
      return n(d, l, h);
    if (c === 1 || c === 3)
      return o(d, l, h);
    if (c === 2)
      return i(d, l, h);
  }
  ui.ft_1 = r;
  function n(c, d, l) {
    return c & d ^ ~c & l;
  }
  ui.ch32 = n;
  function i(c, d, l) {
    return c & d ^ c & l ^ d & l;
  }
  ui.maj32 = i;
  function o(c, d, l) {
    return c ^ d ^ l;
  }
  ui.p32 = o;
  function a(c) {
    return e(c, 2) ^ e(c, 13) ^ e(c, 22);
  }
  ui.s0_256 = a;
  function s(c) {
    return e(c, 6) ^ e(c, 11) ^ e(c, 25);
  }
  ui.s1_256 = s;
  function f(c) {
    return e(c, 7) ^ e(c, 18) ^ c >>> 3;
  }
  ui.g0_256 = f;
  function u(c) {
    return e(c, 17) ^ e(c, 19) ^ c >>> 10;
  }
  return ui.g1_256 = u, ui;
}
var Ml, _b;
function rE() {
  if (_b)
    return Ml;
  _b = 1;
  var t = _i(), e = Rf(), r = B3(), n = t.rotl32, i = t.sum32, o = t.sum32_5, a = r.ft_1, s = e.BlockHash, f = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
  ];
  function u() {
    if (!(this instanceof u))
      return new u();
    s.call(this), this.h = [
      1732584193,
      4023233417,
      2562383102,
      271733878,
      3285377520
    ], this.W = new Array(80);
  }
  return t.inherits(u, s), Ml = u, u.blockSize = 512, u.outSize = 160, u.hmacStrength = 80, u.padLength = 64, u.prototype._update = function(d, l) {
    for (var h = this.W, y = 0; y < 16; y++)
      h[y] = d[l + y];
    for (; y < h.length; y++)
      h[y] = n(h[y - 3] ^ h[y - 8] ^ h[y - 14] ^ h[y - 16], 1);
    var b = this.h[0], w = this.h[1], A = this.h[2], M = this.h[3], N = this.h[4];
    for (y = 0; y < h.length; y++) {
      var G = ~~(y / 20), z = o(n(b, 5), a(G, w, A, M), N, h[y], f[G]);
      N = M, M = A, A = n(w, 30), w = b, b = z;
    }
    this.h[0] = i(this.h[0], b), this.h[1] = i(this.h[1], w), this.h[2] = i(this.h[2], A), this.h[3] = i(this.h[3], M), this.h[4] = i(this.h[4], N);
  }, u.prototype._digest = function(d) {
    return d === "hex" ? t.toHex32(this.h, "big") : t.split32(this.h, "big");
  }, Ml;
}
var Rl, Eb;
function M3() {
  if (Eb)
    return Rl;
  Eb = 1;
  var t = _i(), e = Rf(), r = B3(), n = On, i = t.sum32, o = t.sum32_4, a = t.sum32_5, s = r.ch32, f = r.maj32, u = r.s0_256, c = r.s1_256, d = r.g0_256, l = r.g1_256, h = e.BlockHash, y = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ];
  function b() {
    if (!(this instanceof b))
      return new b();
    h.call(this), this.h = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ], this.k = y, this.W = new Array(64);
  }
  return t.inherits(b, h), Rl = b, b.blockSize = 512, b.outSize = 256, b.hmacStrength = 192, b.padLength = 64, b.prototype._update = function(A, M) {
    for (var N = this.W, G = 0; G < 16; G++)
      N[G] = A[M + G];
    for (; G < N.length; G++)
      N[G] = o(l(N[G - 2]), N[G - 7], d(N[G - 15]), N[G - 16]);
    var z = this.h[0], J = this.h[1], oe = this.h[2], ee = this.h[3], ae = this.h[4], ye = this.h[5], pe = this.h[6], te = this.h[7];
    for (n(this.k.length === N.length), G = 0; G < N.length; G++) {
      var F = a(te, c(ae), s(ae, ye, pe), this.k[G], N[G]), v = i(u(z), f(z, J, oe));
      te = pe, pe = ye, ye = ae, ae = i(ee, F), ee = oe, oe = J, J = z, z = i(F, v);
    }
    this.h[0] = i(this.h[0], z), this.h[1] = i(this.h[1], J), this.h[2] = i(this.h[2], oe), this.h[3] = i(this.h[3], ee), this.h[4] = i(this.h[4], ae), this.h[5] = i(this.h[5], ye), this.h[6] = i(this.h[6], pe), this.h[7] = i(this.h[7], te);
  }, b.prototype._digest = function(A) {
    return A === "hex" ? t.toHex32(this.h, "big") : t.split32(this.h, "big");
  }, Rl;
}
var Tl, Sb;
function nE() {
  if (Sb)
    return Tl;
  Sb = 1;
  var t = _i(), e = M3();
  function r() {
    if (!(this instanceof r))
      return new r();
    e.call(this), this.h = [
      3238371032,
      914150663,
      812702999,
      4144912697,
      4290775857,
      1750603025,
      1694076839,
      3204075428
    ];
  }
  return t.inherits(r, e), Tl = r, r.blockSize = 512, r.outSize = 224, r.hmacStrength = 192, r.padLength = 64, r.prototype._digest = function(i) {
    return i === "hex" ? t.toHex32(this.h.slice(0, 7), "big") : t.split32(this.h.slice(0, 7), "big");
  }, Tl;
}
var Ol, Ab;
function R3() {
  if (Ab)
    return Ol;
  Ab = 1;
  var t = _i(), e = Rf(), r = On, n = t.rotr64_hi, i = t.rotr64_lo, o = t.shr64_hi, a = t.shr64_lo, s = t.sum64, f = t.sum64_hi, u = t.sum64_lo, c = t.sum64_4_hi, d = t.sum64_4_lo, l = t.sum64_5_hi, h = t.sum64_5_lo, y = e.BlockHash, b = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ];
  function w() {
    if (!(this instanceof w))
      return new w();
    y.call(this), this.h = [
      1779033703,
      4089235720,
      3144134277,
      2227873595,
      1013904242,
      4271175723,
      2773480762,
      1595750129,
      1359893119,
      2917565137,
      2600822924,
      725511199,
      528734635,
      4215389547,
      1541459225,
      327033209
    ], this.k = b, this.W = new Array(160);
  }
  t.inherits(w, y), Ol = w, w.blockSize = 1024, w.outSize = 512, w.hmacStrength = 192, w.padLength = 128, w.prototype._prepareBlock = function(v, B) {
    for (var P = this.W, L = 0; L < 32; L++)
      P[L] = v[B + L];
    for (; L < P.length; L += 2) {
      var x = pe(P[L - 4], P[L - 3]), C = te(P[L - 4], P[L - 3]), j = P[L - 14], k = P[L - 13], g = ae(P[L - 30], P[L - 29]), R = ye(P[L - 30], P[L - 29]), X = P[L - 32], re = P[L - 31];
      P[L] = c(
        x,
        C,
        j,
        k,
        g,
        R,
        X,
        re
      ), P[L + 1] = d(
        x,
        C,
        j,
        k,
        g,
        R,
        X,
        re
      );
    }
  }, w.prototype._update = function(v, B) {
    this._prepareBlock(v, B);
    var P = this.W, L = this.h[0], x = this.h[1], C = this.h[2], j = this.h[3], k = this.h[4], g = this.h[5], R = this.h[6], X = this.h[7], re = this.h[8], V = this.h[9], $ = this.h[10], W = this.h[11], Z = this.h[12], fe = this.h[13], D = this.h[14], K = this.h[15];
    r(this.k.length === P.length);
    for (var he = 0; he < P.length; he += 2) {
      var be = D, Ce = K, je = oe(re, V), Ue = ee(re, V), Qe = A(re, V, $, W, Z), we = M(re, V, $, W, Z, fe), at = this.k[he], rt = this.k[he + 1], It = P[he], it = P[he + 1], se = l(
        be,
        Ce,
        je,
        Ue,
        Qe,
        we,
        at,
        rt,
        It,
        it
      ), ue = h(
        be,
        Ce,
        je,
        Ue,
        Qe,
        we,
        at,
        rt,
        It,
        it
      );
      be = z(L, x), Ce = J(L, x), je = N(L, x, C, j, k), Ue = G(L, x, C, j, k, g);
      var Ee = f(be, Ce, je, Ue), U = u(be, Ce, je, Ue);
      D = Z, K = fe, Z = $, fe = W, $ = re, W = V, re = f(R, X, se, ue), V = u(X, X, se, ue), R = k, X = g, k = C, g = j, C = L, j = x, L = f(se, ue, Ee, U), x = u(se, ue, Ee, U);
    }
    s(this.h, 0, L, x), s(this.h, 2, C, j), s(this.h, 4, k, g), s(this.h, 6, R, X), s(this.h, 8, re, V), s(this.h, 10, $, W), s(this.h, 12, Z, fe), s(this.h, 14, D, K);
  }, w.prototype._digest = function(v) {
    return v === "hex" ? t.toHex32(this.h, "big") : t.split32(this.h, "big");
  };
  function A(F, v, B, P, L) {
    var x = F & B ^ ~F & L;
    return x < 0 && (x += 4294967296), x;
  }
  function M(F, v, B, P, L, x) {
    var C = v & P ^ ~v & x;
    return C < 0 && (C += 4294967296), C;
  }
  function N(F, v, B, P, L) {
    var x = F & B ^ F & L ^ B & L;
    return x < 0 && (x += 4294967296), x;
  }
  function G(F, v, B, P, L, x) {
    var C = v & P ^ v & x ^ P & x;
    return C < 0 && (C += 4294967296), C;
  }
  function z(F, v) {
    var B = n(F, v, 28), P = n(v, F, 2), L = n(v, F, 7), x = B ^ P ^ L;
    return x < 0 && (x += 4294967296), x;
  }
  function J(F, v) {
    var B = i(F, v, 28), P = i(v, F, 2), L = i(v, F, 7), x = B ^ P ^ L;
    return x < 0 && (x += 4294967296), x;
  }
  function oe(F, v) {
    var B = n(F, v, 14), P = n(F, v, 18), L = n(v, F, 9), x = B ^ P ^ L;
    return x < 0 && (x += 4294967296), x;
  }
  function ee(F, v) {
    var B = i(F, v, 14), P = i(F, v, 18), L = i(v, F, 9), x = B ^ P ^ L;
    return x < 0 && (x += 4294967296), x;
  }
  function ae(F, v) {
    var B = n(F, v, 1), P = n(F, v, 8), L = o(F, v, 7), x = B ^ P ^ L;
    return x < 0 && (x += 4294967296), x;
  }
  function ye(F, v) {
    var B = i(F, v, 1), P = i(F, v, 8), L = a(F, v, 7), x = B ^ P ^ L;
    return x < 0 && (x += 4294967296), x;
  }
  function pe(F, v) {
    var B = n(F, v, 19), P = n(v, F, 29), L = o(F, v, 6), x = B ^ P ^ L;
    return x < 0 && (x += 4294967296), x;
  }
  function te(F, v) {
    var B = i(F, v, 19), P = i(v, F, 29), L = a(F, v, 6), x = B ^ P ^ L;
    return x < 0 && (x += 4294967296), x;
  }
  return Ol;
}
var kl, Ib;
function iE() {
  if (Ib)
    return kl;
  Ib = 1;
  var t = _i(), e = R3();
  function r() {
    if (!(this instanceof r))
      return new r();
    e.call(this), this.h = [
      3418070365,
      3238371032,
      1654270250,
      914150663,
      2438529370,
      812702999,
      355462360,
      4144912697,
      1731405415,
      4290775857,
      2394180231,
      1750603025,
      3675008525,
      1694076839,
      1203062813,
      3204075428
    ];
  }
  return t.inherits(r, e), kl = r, r.blockSize = 1024, r.outSize = 384, r.hmacStrength = 192, r.padLength = 128, r.prototype._digest = function(i) {
    return i === "hex" ? t.toHex32(this.h.slice(0, 12), "big") : t.split32(this.h.slice(0, 12), "big");
  }, kl;
}
var Bb;
function oE() {
  return Bb || (Bb = 1, so.sha1 = rE(), so.sha224 = nE(), so.sha256 = M3(), so.sha384 = iE(), so.sha512 = R3()), so;
}
var Cl = {}, Mb;
function aE() {
  if (Mb)
    return Cl;
  Mb = 1;
  var t = _i(), e = Rf(), r = t.rotl32, n = t.sum32, i = t.sum32_3, o = t.sum32_4, a = e.BlockHash;
  function s() {
    if (!(this instanceof s))
      return new s();
    a.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }
  t.inherits(s, a), Cl.ripemd160 = s, s.blockSize = 512, s.outSize = 160, s.hmacStrength = 192, s.padLength = 64, s.prototype._update = function(w, A) {
    for (var M = this.h[0], N = this.h[1], G = this.h[2], z = this.h[3], J = this.h[4], oe = M, ee = N, ae = G, ye = z, pe = J, te = 0; te < 80; te++) {
      var F = n(
        r(
          o(M, f(te, N, G, z), w[d[te] + A], u(te)),
          h[te]
        ),
        J
      );
      M = J, J = z, z = r(G, 10), G = N, N = F, F = n(
        r(
          o(oe, f(79 - te, ee, ae, ye), w[l[te] + A], c(te)),
          y[te]
        ),
        pe
      ), oe = pe, pe = ye, ye = r(ae, 10), ae = ee, ee = F;
    }
    F = i(this.h[1], G, ye), this.h[1] = i(this.h[2], z, pe), this.h[2] = i(this.h[3], J, oe), this.h[3] = i(this.h[4], M, ee), this.h[4] = i(this.h[0], N, ae), this.h[0] = F;
  }, s.prototype._digest = function(w) {
    return w === "hex" ? t.toHex32(this.h, "little") : t.split32(this.h, "little");
  };
  function f(b, w, A, M) {
    return b <= 15 ? w ^ A ^ M : b <= 31 ? w & A | ~w & M : b <= 47 ? (w | ~A) ^ M : b <= 63 ? w & M | A & ~M : w ^ (A | ~M);
  }
  function u(b) {
    return b <= 15 ? 0 : b <= 31 ? 1518500249 : b <= 47 ? 1859775393 : b <= 63 ? 2400959708 : 2840853838;
  }
  function c(b) {
    return b <= 15 ? 1352829926 : b <= 31 ? 1548603684 : b <= 47 ? 1836072691 : b <= 63 ? 2053994217 : 0;
  }
  var d = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], l = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], h = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], y = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ];
  return Cl;
}
var Pl, Rb;
function sE() {
  if (Rb)
    return Pl;
  Rb = 1;
  var t = _i(), e = On;
  function r(n, i, o) {
    if (!(this instanceof r))
      return new r(n, i, o);
    this.Hash = n, this.blockSize = n.blockSize / 8, this.outSize = n.outSize / 8, this.inner = null, this.outer = null, this._init(t.toArray(i, o));
  }
  return Pl = r, r.prototype._init = function(i) {
    i.length > this.blockSize && (i = new this.Hash().update(i).digest()), e(i.length <= this.blockSize);
    for (var o = i.length; o < this.blockSize; o++)
      i.push(0);
    for (o = 0; o < i.length; o++)
      i[o] ^= 54;
    for (this.inner = new this.Hash().update(i), o = 0; o < i.length; o++)
      i[o] ^= 106;
    this.outer = new this.Hash().update(i);
  }, r.prototype.update = function(i, o) {
    return this.inner.update(i, o), this;
  }, r.prototype.digest = function(i) {
    return this.outer.update(this.inner.digest()), this.outer.digest(i);
  }, Pl;
}
var Tb;
function Np() {
  return Tb || (Tb = 1, function(t) {
    var e = t;
    e.utils = _i(), e.common = Rf(), e.sha = oE(), e.ripemd = aE(), e.hmac = sE(), e.sha1 = e.sha.sha1, e.sha256 = e.sha.sha256, e.sha224 = e.sha.sha224, e.sha384 = e.sha.sha384, e.sha512 = e.sha.sha512, e.ripemd160 = e.ripemd.ripemd160;
  }(Il)), Il;
}
var Nl, Ob;
function fE() {
  return Ob || (Ob = 1, Nl = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), Nl;
}
var kb;
function Up() {
  return kb || (kb = 1, function(t) {
    var e = t, r = Np(), n = I3(), i = Vn(), o = i.assert;
    function a(u) {
      u.type === "short" ? this.curve = new n.short(u) : u.type === "edwards" ? this.curve = new n.edwards(u) : this.curve = new n.mont(u), this.g = this.curve.g, this.n = this.curve.n, this.hash = u.hash, o(this.g.validate(), "Invalid curve"), o(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    e.PresetCurve = a;
    function s(u, c) {
      Object.defineProperty(e, u, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var d = new a(c);
          return Object.defineProperty(e, u, {
            configurable: !0,
            enumerable: !0,
            value: d
          }), d;
        }
      });
    }
    s("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: r.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), s("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: r.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), s("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: r.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), s("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: r.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), s("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: r.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), s("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), s("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var f;
    try {
      f = fE();
    } catch {
      f = void 0;
    }
    s("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: r.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        f
      ]
    });
  }(Al)), Al;
}
var Ul, Cb;
function cE() {
  if (Cb)
    return Ul;
  Cb = 1;
  var t = Np(), e = A3(), r = On;
  function n(i) {
    if (!(this instanceof n))
      return new n(i);
    this.hash = i.hash, this.predResist = !!i.predResist, this.outLen = this.hash.outSize, this.minEntropy = i.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var o = e.toArray(i.entropy, i.entropyEnc || "hex"), a = e.toArray(i.nonce, i.nonceEnc || "hex"), s = e.toArray(i.pers, i.persEnc || "hex");
    r(
      o.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._init(o, a, s);
  }
  return Ul = n, n.prototype._init = function(o, a, s) {
    var f = o.concat(a).concat(s);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for (var u = 0; u < this.V.length; u++)
      this.K[u] = 0, this.V[u] = 1;
    this._update(f), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, n.prototype._hmac = function() {
    return new t.hmac(this.hash, this.K);
  }, n.prototype._update = function(o) {
    var a = this._hmac().update(this.V).update([0]);
    o && (a = a.update(o)), this.K = a.digest(), this.V = this._hmac().update(this.V).digest(), o && (this.K = this._hmac().update(this.V).update([1]).update(o).digest(), this.V = this._hmac().update(this.V).digest());
  }, n.prototype.reseed = function(o, a, s, f) {
    typeof a != "string" && (f = s, s = a, a = null), o = e.toArray(o, a), s = e.toArray(s, f), r(
      o.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._update(o.concat(s || [])), this._reseed = 1;
  }, n.prototype.generate = function(o, a, s, f) {
    if (this._reseed > this.reseedInterval)
      throw new Error("Reseed is required");
    typeof a != "string" && (f = s, s = a, a = null), s && (s = e.toArray(s, f || "hex"), this._update(s));
    for (var u = []; u.length < o; )
      this.V = this._hmac().update(this.V).digest(), u = u.concat(this.V);
    var c = u.slice(0, o);
    return this._update(s), this._reseed++, e.encode(c, a);
  }, Ul;
}
var Fl, Pb;
function uE() {
  if (Pb)
    return Fl;
  Pb = 1;
  var t = mr, e = Vn(), r = e.assert;
  function n(i, o) {
    this.ec = i, this.priv = null, this.pub = null, o.priv && this._importPrivate(o.priv, o.privEnc), o.pub && this._importPublic(o.pub, o.pubEnc);
  }
  return Fl = n, n.fromPublic = function(o, a, s) {
    return a instanceof n ? a : new n(o, {
      pub: a,
      pubEnc: s
    });
  }, n.fromPrivate = function(o, a, s) {
    return a instanceof n ? a : new n(o, {
      priv: a,
      privEnc: s
    });
  }, n.prototype.validate = function() {
    var o = this.getPublic();
    return o.isInfinity() ? { result: !1, reason: "Invalid public key" } : o.validate() ? o.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, n.prototype.getPublic = function(o, a) {
    return typeof o == "string" && (a = o, o = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), a ? this.pub.encode(a, o) : this.pub;
  }, n.prototype.getPrivate = function(o) {
    return o === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, n.prototype._importPrivate = function(o, a) {
    this.priv = new t(o, a || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, n.prototype._importPublic = function(o, a) {
    if (o.x || o.y) {
      this.ec.curve.type === "mont" ? r(o.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && r(o.x && o.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(o.x, o.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(o, a);
  }, n.prototype.derive = function(o) {
    return o.validate() || r(o.validate(), "public point not validated"), o.mul(this.priv).getX();
  }, n.prototype.sign = function(o, a, s) {
    return this.ec.sign(o, this, a, s);
  }, n.prototype.verify = function(o, a) {
    return this.ec.verify(o, a, this);
  }, n.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, Fl;
}
var Ll, Nb;
function dE() {
  if (Nb)
    return Ll;
  Nb = 1;
  var t = mr, e = Vn(), r = e.assert;
  function n(f, u) {
    if (f instanceof n)
      return f;
    this._importDER(f, u) || (r(f.r && f.s, "Signature without r or s"), this.r = new t(f.r, 16), this.s = new t(f.s, 16), f.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = f.recoveryParam);
  }
  Ll = n;
  function i() {
    this.place = 0;
  }
  function o(f, u) {
    var c = f[u.place++];
    if (!(c & 128))
      return c;
    var d = c & 15;
    if (d === 0 || d > 4)
      return !1;
    for (var l = 0, h = 0, y = u.place; h < d; h++, y++)
      l <<= 8, l |= f[y], l >>>= 0;
    return l <= 127 ? !1 : (u.place = y, l);
  }
  function a(f) {
    for (var u = 0, c = f.length - 1; !f[u] && !(f[u + 1] & 128) && u < c; )
      u++;
    return u === 0 ? f : f.slice(u);
  }
  n.prototype._importDER = function(u, c) {
    u = e.toArray(u, c);
    var d = new i();
    if (u[d.place++] !== 48)
      return !1;
    var l = o(u, d);
    if (l === !1 || l + d.place !== u.length || u[d.place++] !== 2)
      return !1;
    var h = o(u, d);
    if (h === !1)
      return !1;
    var y = u.slice(d.place, h + d.place);
    if (d.place += h, u[d.place++] !== 2)
      return !1;
    var b = o(u, d);
    if (b === !1 || u.length !== b + d.place)
      return !1;
    var w = u.slice(d.place, b + d.place);
    if (y[0] === 0)
      if (y[1] & 128)
        y = y.slice(1);
      else
        return !1;
    if (w[0] === 0)
      if (w[1] & 128)
        w = w.slice(1);
      else
        return !1;
    return this.r = new t(y), this.s = new t(w), this.recoveryParam = null, !0;
  };
  function s(f, u) {
    if (u < 128) {
      f.push(u);
      return;
    }
    var c = 1 + (Math.log(u) / Math.LN2 >>> 3);
    for (f.push(c | 128); --c; )
      f.push(u >>> (c << 3) & 255);
    f.push(u);
  }
  return n.prototype.toDER = function(u) {
    var c = this.r.toArray(), d = this.s.toArray();
    for (c[0] & 128 && (c = [0].concat(c)), d[0] & 128 && (d = [0].concat(d)), c = a(c), d = a(d); !d[0] && !(d[1] & 128); )
      d = d.slice(1);
    var l = [2];
    s(l, c.length), l = l.concat(c), l.push(2), s(l, d.length);
    var h = l.concat(d), y = [48];
    return s(y, h.length), y = y.concat(h), e.encode(y, u);
  }, Ll;
}
var jl, Ub;
function lE() {
  if (Ub)
    return jl;
  Ub = 1;
  var t = mr, e = cE(), r = Vn(), n = Up(), i = Cp(), o = r.assert, a = uE(), s = dE();
  function f(u) {
    if (!(this instanceof f))
      return new f(u);
    typeof u == "string" && (o(
      Object.prototype.hasOwnProperty.call(n, u),
      "Unknown curve " + u
    ), u = n[u]), u instanceof n.PresetCurve && (u = { curve: u }), this.curve = u.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = u.curve.g, this.g.precompute(u.curve.n.bitLength() + 1), this.hash = u.hash || u.curve.hash;
  }
  return jl = f, f.prototype.keyPair = function(c) {
    return new a(this, c);
  }, f.prototype.keyFromPrivate = function(c, d) {
    return a.fromPrivate(this, c, d);
  }, f.prototype.keyFromPublic = function(c, d) {
    return a.fromPublic(this, c, d);
  }, f.prototype.genKeyPair = function(c) {
    c || (c = {});
    for (var d = new e({
      hash: this.hash,
      pers: c.pers,
      persEnc: c.persEnc || "utf8",
      entropy: c.entropy || i(this.hash.hmacStrength),
      entropyEnc: c.entropy && c.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), l = this.n.byteLength(), h = this.n.sub(new t(2)); ; ) {
      var y = new t(d.generate(l));
      if (!(y.cmp(h) > 0))
        return y.iaddn(1), this.keyFromPrivate(y);
    }
  }, f.prototype._truncateToN = function(c, d) {
    var l = c.byteLength() * 8 - this.n.bitLength();
    return l > 0 && (c = c.ushrn(l)), !d && c.cmp(this.n) >= 0 ? c.sub(this.n) : c;
  }, f.prototype.sign = function(c, d, l, h) {
    typeof l == "object" && (h = l, l = null), h || (h = {}), d = this.keyFromPrivate(d, l), c = this._truncateToN(new t(c, 16));
    for (var y = this.n.byteLength(), b = d.getPrivate().toArray("be", y), w = c.toArray("be", y), A = new e({
      hash: this.hash,
      entropy: b,
      nonce: w,
      pers: h.pers,
      persEnc: h.persEnc || "utf8"
    }), M = this.n.sub(new t(1)), N = 0; ; N++) {
      var G = h.k ? h.k(N) : new t(A.generate(this.n.byteLength()));
      if (G = this._truncateToN(G, !0), !(G.cmpn(1) <= 0 || G.cmp(M) >= 0)) {
        var z = this.g.mul(G);
        if (!z.isInfinity()) {
          var J = z.getX(), oe = J.umod(this.n);
          if (oe.cmpn(0) !== 0) {
            var ee = G.invm(this.n).mul(oe.mul(d.getPrivate()).iadd(c));
            if (ee = ee.umod(this.n), ee.cmpn(0) !== 0) {
              var ae = (z.getY().isOdd() ? 1 : 0) | (J.cmp(oe) !== 0 ? 2 : 0);
              return h.canonical && ee.cmp(this.nh) > 0 && (ee = this.n.sub(ee), ae ^= 1), new s({ r: oe, s: ee, recoveryParam: ae });
            }
          }
        }
      }
    }
  }, f.prototype.verify = function(c, d, l, h) {
    c = this._truncateToN(new t(c, 16)), l = this.keyFromPublic(l, h), d = new s(d, "hex");
    var y = d.r, b = d.s;
    if (y.cmpn(1) < 0 || y.cmp(this.n) >= 0 || b.cmpn(1) < 0 || b.cmp(this.n) >= 0)
      return !1;
    var w = b.invm(this.n), A = w.mul(c).umod(this.n), M = w.mul(y).umod(this.n), N;
    return this.curve._maxwellTrick ? (N = this.g.jmulAdd(A, l.getPublic(), M), N.isInfinity() ? !1 : N.eqXToP(y)) : (N = this.g.mulAdd(A, l.getPublic(), M), N.isInfinity() ? !1 : N.getX().umod(this.n).cmp(y) === 0);
  }, f.prototype.recoverPubKey = function(u, c, d, l) {
    o((3 & d) === d, "The recovery param is more than two bits"), c = new s(c, l);
    var h = this.n, y = new t(u), b = c.r, w = c.s, A = d & 1, M = d >> 1;
    if (b.cmp(this.curve.p.umod(this.curve.n)) >= 0 && M)
      throw new Error("Unable to find sencond key candinate");
    M ? b = this.curve.pointFromX(b.add(this.curve.n), A) : b = this.curve.pointFromX(b, A);
    var N = c.r.invm(h), G = h.sub(y).mul(N).umod(h), z = w.mul(N).umod(h);
    return this.g.mulAdd(G, b, z);
  }, f.prototype.getKeyRecoveryParam = function(u, c, d, l) {
    if (c = new s(c, l), c.recoveryParam !== null)
      return c.recoveryParam;
    for (var h = 0; h < 4; h++) {
      var y;
      try {
        y = this.recoverPubKey(u, c, h);
      } catch {
        continue;
      }
      if (y.eq(d))
        return h;
    }
    throw new Error("Unable to find valid recovery factor");
  }, jl;
}
var Dl, Fb;
function hE() {
  if (Fb)
    return Dl;
  Fb = 1;
  var t = Vn(), e = t.assert, r = t.parseBytes, n = t.cachedProperty;
  function i(o, a) {
    this.eddsa = o, this._secret = r(a.secret), o.isPoint(a.pub) ? this._pub = a.pub : this._pubBytes = r(a.pub);
  }
  return i.fromPublic = function(a, s) {
    return s instanceof i ? s : new i(a, { pub: s });
  }, i.fromSecret = function(a, s) {
    return s instanceof i ? s : new i(a, { secret: s });
  }, i.prototype.secret = function() {
    return this._secret;
  }, n(i, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), n(i, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), n(i, "privBytes", function() {
    var a = this.eddsa, s = this.hash(), f = a.encodingLength - 1, u = s.slice(0, a.encodingLength);
    return u[0] &= 248, u[f] &= 127, u[f] |= 64, u;
  }), n(i, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), n(i, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), n(i, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), i.prototype.sign = function(a) {
    return e(this._secret, "KeyPair can only verify"), this.eddsa.sign(a, this);
  }, i.prototype.verify = function(a, s) {
    return this.eddsa.verify(a, s, this);
  }, i.prototype.getSecret = function(a) {
    return e(this._secret, "KeyPair is public only"), t.encode(this.secret(), a);
  }, i.prototype.getPublic = function(a) {
    return t.encode(this.pubBytes(), a);
  }, Dl = i, Dl;
}
var $l, Lb;
function pE() {
  if (Lb)
    return $l;
  Lb = 1;
  var t = mr, e = Vn(), r = e.assert, n = e.cachedProperty, i = e.parseBytes;
  function o(a, s) {
    this.eddsa = a, typeof s != "object" && (s = i(s)), Array.isArray(s) && (s = {
      R: s.slice(0, a.encodingLength),
      S: s.slice(a.encodingLength)
    }), r(s.R && s.S, "Signature without R or S"), a.isPoint(s.R) && (this._R = s.R), s.S instanceof t && (this._S = s.S), this._Rencoded = Array.isArray(s.R) ? s.R : s.Rencoded, this._Sencoded = Array.isArray(s.S) ? s.S : s.Sencoded;
  }
  return n(o, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), n(o, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), n(o, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), n(o, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), o.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, o.prototype.toHex = function() {
    return e.encode(this.toBytes(), "hex").toUpperCase();
  }, $l = o, $l;
}
var ql, jb;
function yE() {
  if (jb)
    return ql;
  jb = 1;
  var t = Np(), e = Up(), r = Vn(), n = r.assert, i = r.parseBytes, o = hE(), a = pE();
  function s(f) {
    if (n(f === "ed25519", "only tested with ed25519 so far"), !(this instanceof s))
      return new s(f);
    f = e[f].curve, this.curve = f, this.g = f.g, this.g.precompute(f.n.bitLength() + 1), this.pointClass = f.point().constructor, this.encodingLength = Math.ceil(f.n.bitLength() / 8), this.hash = t.sha512;
  }
  return ql = s, s.prototype.sign = function(u, c) {
    u = i(u);
    var d = this.keyFromSecret(c), l = this.hashInt(d.messagePrefix(), u), h = this.g.mul(l), y = this.encodePoint(h), b = this.hashInt(y, d.pubBytes(), u).mul(d.priv()), w = l.add(b).umod(this.curve.n);
    return this.makeSignature({ R: h, S: w, Rencoded: y });
  }, s.prototype.verify = function(u, c, d) {
    u = i(u), c = this.makeSignature(c);
    var l = this.keyFromPublic(d), h = this.hashInt(c.Rencoded(), l.pubBytes(), u), y = this.g.mul(c.S()), b = c.R().add(l.pub().mul(h));
    return b.eq(y);
  }, s.prototype.hashInt = function() {
    for (var u = this.hash(), c = 0; c < arguments.length; c++)
      u.update(arguments[c]);
    return r.intFromLE(u.digest()).umod(this.curve.n);
  }, s.prototype.keyFromPublic = function(u) {
    return o.fromPublic(this, u);
  }, s.prototype.keyFromSecret = function(u) {
    return o.fromSecret(this, u);
  }, s.prototype.makeSignature = function(u) {
    return u instanceof a ? u : new a(this, u);
  }, s.prototype.encodePoint = function(u) {
    var c = u.getY().toArray("le", this.encodingLength);
    return c[this.encodingLength - 1] |= u.getX().isOdd() ? 128 : 0, c;
  }, s.prototype.decodePoint = function(u) {
    u = r.parseBytes(u);
    var c = u.length - 1, d = u.slice(0, c).concat(u[c] & -129), l = (u[c] & 128) !== 0, h = r.intFromLE(d);
    return this.curve.pointFromY(h, l);
  }, s.prototype.encodeInt = function(u) {
    return u.toArray("le", this.encodingLength);
  }, s.prototype.decodeInt = function(u) {
    return r.intFromLE(u);
  }, s.prototype.isPoint = function(u) {
    return u instanceof this.pointClass;
  }, ql;
}
var Db;
function Xu() {
  return Db || (Db = 1, function(t) {
    var e = t;
    e.version = Z_.version, e.utils = Vn(), e.rand = Cp(), e.curve = I3(), e.curves = Up(), e.ec = lE(), e.eddsa = yE();
  }(gl)), gl;
}
var Un = {}, zl = {}, Kl = {}, Wl = {}, Hl, $b;
function Fp() {
  if ($b)
    return Hl;
  $b = 1;
  var t = mt, e = t.Buffer, r = {}, n;
  for (n in t)
    t.hasOwnProperty(n) && (n === "SlowBuffer" || n === "Buffer" || (r[n] = t[n]));
  var i = r.Buffer = {};
  for (n in e)
    e.hasOwnProperty(n) && (n === "allocUnsafe" || n === "allocUnsafeSlow" || (i[n] = e[n]));
  if (r.Buffer.prototype = e.prototype, (!i.from || i.from === Uint8Array.from) && (i.from = function(o, a, s) {
    if (typeof o == "number")
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof o);
    if (o && typeof o.length > "u")
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof o);
    return e(o, a, s);
  }), i.alloc || (i.alloc = function(o, a, s) {
    if (typeof o != "number")
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof o);
    if (o < 0 || o >= 2 * (1 << 30))
      throw new RangeError('The value "' + o + '" is invalid for option "size"');
    var f = e(o);
    return !a || a.length === 0 ? f.fill(0) : typeof s == "string" ? f.fill(a, s) : f.fill(a), f;
  }), !r.kStringMaxLength)
    try {
      r.kStringMaxLength = Ye.binding("buffer").kStringMaxLength;
    } catch {
    }
  return r.constants || (r.constants = {
    MAX_LENGTH: r.kMaxLength
  }, r.kStringMaxLength && (r.constants.MAX_STRING_LENGTH = r.kStringMaxLength)), Hl = r, Hl;
}
var Gl = {}, qb;
function Lp() {
  if (qb)
    return Gl;
  qb = 1;
  const t = Mt;
  function e(n) {
    this._reporterState = {
      obj: null,
      path: [],
      options: n || {},
      errors: []
    };
  }
  Gl.Reporter = e, e.prototype.isError = function(i) {
    return i instanceof r;
  }, e.prototype.save = function() {
    const i = this._reporterState;
    return { obj: i.obj, pathLen: i.path.length };
  }, e.prototype.restore = function(i) {
    const o = this._reporterState;
    o.obj = i.obj, o.path = o.path.slice(0, i.pathLen);
  }, e.prototype.enterKey = function(i) {
    return this._reporterState.path.push(i);
  }, e.prototype.exitKey = function(i) {
    const o = this._reporterState;
    o.path = o.path.slice(0, i - 1);
  }, e.prototype.leaveKey = function(i, o, a) {
    const s = this._reporterState;
    this.exitKey(i), s.obj !== null && (s.obj[o] = a);
  }, e.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, e.prototype.enterObject = function() {
    const i = this._reporterState, o = i.obj;
    return i.obj = {}, o;
  }, e.prototype.leaveObject = function(i) {
    const o = this._reporterState, a = o.obj;
    return o.obj = i, a;
  }, e.prototype.error = function(i) {
    let o;
    const a = this._reporterState, s = i instanceof r;
    if (s ? o = i : o = new r(a.path.map(function(f) {
      return "[" + JSON.stringify(f) + "]";
    }).join(""), i.message || i, i.stack), !a.options.partial)
      throw o;
    return s || a.errors.push(o), o;
  }, e.prototype.wrapResult = function(i) {
    const o = this._reporterState;
    return o.options.partial ? {
      result: this.isError(i) ? null : i,
      errors: o.errors
    } : i;
  };
  function r(n, i) {
    this.path = n, this.rethrow(i);
  }
  return t(r, Error), r.prototype.rethrow = function(i) {
    if (this.message = i + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, r), !this.stack)
      try {
        throw new Error(this.message);
      } catch (o) {
        this.stack = o.stack;
      }
    return this;
  }, Gl;
}
var Jf = {}, zb;
function $s() {
  if (zb)
    return Jf;
  zb = 1;
  const t = Mt, e = Lp().Reporter, r = Fp().Buffer;
  function n(o, a) {
    if (e.call(this, a), !r.isBuffer(o)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = o, this.offset = 0, this.length = o.length;
  }
  t(n, e), Jf.DecoderBuffer = n, n.isDecoderBuffer = function(a) {
    return a instanceof n ? !0 : typeof a == "object" && r.isBuffer(a.base) && a.constructor.name === "DecoderBuffer" && typeof a.offset == "number" && typeof a.length == "number" && typeof a.save == "function" && typeof a.restore == "function" && typeof a.isEmpty == "function" && typeof a.readUInt8 == "function" && typeof a.skip == "function" && typeof a.raw == "function";
  }, n.prototype.save = function() {
    return { offset: this.offset, reporter: e.prototype.save.call(this) };
  }, n.prototype.restore = function(a) {
    const s = new n(this.base);
    return s.offset = a.offset, s.length = this.offset, this.offset = a.offset, e.prototype.restore.call(this, a.reporter), s;
  }, n.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, n.prototype.readUInt8 = function(a) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(a || "DecoderBuffer overrun");
  }, n.prototype.skip = function(a, s) {
    if (!(this.offset + a <= this.length))
      return this.error(s || "DecoderBuffer overrun");
    const f = new n(this.base);
    return f._reporterState = this._reporterState, f.offset = this.offset, f.length = this.offset + a, this.offset += a, f;
  }, n.prototype.raw = function(a) {
    return this.base.slice(a ? a.offset : this.offset, this.length);
  };
  function i(o, a) {
    if (Array.isArray(o))
      this.length = 0, this.value = o.map(function(s) {
        return i.isEncoderBuffer(s) || (s = new i(s, a)), this.length += s.length, s;
      }, this);
    else if (typeof o == "number") {
      if (!(0 <= o && o <= 255))
        return a.error("non-byte EncoderBuffer value");
      this.value = o, this.length = 1;
    } else if (typeof o == "string")
      this.value = o, this.length = r.byteLength(o);
    else if (r.isBuffer(o))
      this.value = o, this.length = o.length;
    else
      return a.error("Unsupported type: " + typeof o);
  }
  return Jf.EncoderBuffer = i, i.isEncoderBuffer = function(a) {
    return a instanceof i ? !0 : typeof a == "object" && a.constructor.name === "EncoderBuffer" && typeof a.length == "number" && typeof a.join == "function";
  }, i.prototype.join = function(a, s) {
    return a || (a = r.alloc(this.length)), s || (s = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(f) {
      f.join(a, s), s += f.length;
    }) : (typeof this.value == "number" ? a[s] = this.value : typeof this.value == "string" ? a.write(this.value, s) : r.isBuffer(this.value) && this.value.copy(a, s), s += this.length)), a;
  }, Jf;
}
var Vl, Kb;
function jp() {
  if (Kb)
    return Vl;
  Kb = 1;
  const t = Lp().Reporter, e = $s().EncoderBuffer, r = $s().DecoderBuffer, n = On, i = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], o = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(i), a = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function s(u, c, d) {
    const l = {};
    this._baseState = l, l.name = d, l.enc = u, l.parent = c || null, l.children = null, l.tag = null, l.args = null, l.reverseArgs = null, l.choice = null, l.optional = !1, l.any = !1, l.obj = !1, l.use = null, l.useDecoder = null, l.key = null, l.default = null, l.explicit = null, l.implicit = null, l.contains = null, l.parent || (l.children = [], this._wrap());
  }
  Vl = s;
  const f = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return s.prototype.clone = function() {
    const c = this._baseState, d = {};
    f.forEach(function(h) {
      d[h] = c[h];
    });
    const l = new this.constructor(d.parent);
    return l._baseState = d, l;
  }, s.prototype._wrap = function() {
    const c = this._baseState;
    o.forEach(function(d) {
      this[d] = function() {
        const h = new this.constructor(this);
        return c.children.push(h), h[d].apply(h, arguments);
      };
    }, this);
  }, s.prototype._init = function(c) {
    const d = this._baseState;
    n(d.parent === null), c.call(this), d.children = d.children.filter(function(l) {
      return l._baseState.parent === this;
    }, this), n.equal(d.children.length, 1, "Root node can have only one child");
  }, s.prototype._useArgs = function(c) {
    const d = this._baseState, l = c.filter(function(h) {
      return h instanceof this.constructor;
    }, this);
    c = c.filter(function(h) {
      return !(h instanceof this.constructor);
    }, this), l.length !== 0 && (n(d.children === null), d.children = l, l.forEach(function(h) {
      h._baseState.parent = this;
    }, this)), c.length !== 0 && (n(d.args === null), d.args = c, d.reverseArgs = c.map(function(h) {
      if (typeof h != "object" || h.constructor !== Object)
        return h;
      const y = {};
      return Object.keys(h).forEach(function(b) {
        b == (b | 0) && (b |= 0);
        const w = h[b];
        y[w] = b;
      }), y;
    }));
  }, a.forEach(function(u) {
    s.prototype[u] = function() {
      const d = this._baseState;
      throw new Error(u + " not implemented for encoding: " + d.enc);
    };
  }), i.forEach(function(u) {
    s.prototype[u] = function() {
      const d = this._baseState, l = Array.prototype.slice.call(arguments);
      return n(d.tag === null), d.tag = u, this._useArgs(l), this;
    };
  }), s.prototype.use = function(c) {
    n(c);
    const d = this._baseState;
    return n(d.use === null), d.use = c, this;
  }, s.prototype.optional = function() {
    const c = this._baseState;
    return c.optional = !0, this;
  }, s.prototype.def = function(c) {
    const d = this._baseState;
    return n(d.default === null), d.default = c, d.optional = !0, this;
  }, s.prototype.explicit = function(c) {
    const d = this._baseState;
    return n(d.explicit === null && d.implicit === null), d.explicit = c, this;
  }, s.prototype.implicit = function(c) {
    const d = this._baseState;
    return n(d.explicit === null && d.implicit === null), d.implicit = c, this;
  }, s.prototype.obj = function() {
    const c = this._baseState, d = Array.prototype.slice.call(arguments);
    return c.obj = !0, d.length !== 0 && this._useArgs(d), this;
  }, s.prototype.key = function(c) {
    const d = this._baseState;
    return n(d.key === null), d.key = c, this;
  }, s.prototype.any = function() {
    const c = this._baseState;
    return c.any = !0, this;
  }, s.prototype.choice = function(c) {
    const d = this._baseState;
    return n(d.choice === null), d.choice = c, this._useArgs(Object.keys(c).map(function(l) {
      return c[l];
    })), this;
  }, s.prototype.contains = function(c) {
    const d = this._baseState;
    return n(d.use === null), d.contains = c, this;
  }, s.prototype._decode = function(c, d) {
    const l = this._baseState;
    if (l.parent === null)
      return c.wrapResult(l.children[0]._decode(c, d));
    let h = l.default, y = !0, b = null;
    if (l.key !== null && (b = c.enterKey(l.key)), l.optional) {
      let A = null;
      if (l.explicit !== null ? A = l.explicit : l.implicit !== null ? A = l.implicit : l.tag !== null && (A = l.tag), A === null && !l.any) {
        const M = c.save();
        try {
          l.choice === null ? this._decodeGeneric(l.tag, c, d) : this._decodeChoice(c, d), y = !0;
        } catch {
          y = !1;
        }
        c.restore(M);
      } else if (y = this._peekTag(c, A, l.any), c.isError(y))
        return y;
    }
    let w;
    if (l.obj && y && (w = c.enterObject()), y) {
      if (l.explicit !== null) {
        const M = this._decodeTag(c, l.explicit);
        if (c.isError(M))
          return M;
        c = M;
      }
      const A = c.offset;
      if (l.use === null && l.choice === null) {
        let M;
        l.any && (M = c.save());
        const N = this._decodeTag(
          c,
          l.implicit !== null ? l.implicit : l.tag,
          l.any
        );
        if (c.isError(N))
          return N;
        l.any ? h = c.raw(M) : c = N;
      }
      if (d && d.track && l.tag !== null && d.track(c.path(), A, c.length, "tagged"), d && d.track && l.tag !== null && d.track(c.path(), c.offset, c.length, "content"), l.any || (l.choice === null ? h = this._decodeGeneric(l.tag, c, d) : h = this._decodeChoice(c, d)), c.isError(h))
        return h;
      if (!l.any && l.choice === null && l.children !== null && l.children.forEach(function(N) {
        N._decode(c, d);
      }), l.contains && (l.tag === "octstr" || l.tag === "bitstr")) {
        const M = new r(h);
        h = this._getUse(l.contains, c._reporterState.obj)._decode(M, d);
      }
    }
    return l.obj && y && (h = c.leaveObject(w)), l.key !== null && (h !== null || y === !0) ? c.leaveKey(b, l.key, h) : b !== null && c.exitKey(b), h;
  }, s.prototype._decodeGeneric = function(c, d, l) {
    const h = this._baseState;
    return c === "seq" || c === "set" ? null : c === "seqof" || c === "setof" ? this._decodeList(d, c, h.args[0], l) : /str$/.test(c) ? this._decodeStr(d, c, l) : c === "objid" && h.args ? this._decodeObjid(d, h.args[0], h.args[1], l) : c === "objid" ? this._decodeObjid(d, null, null, l) : c === "gentime" || c === "utctime" ? this._decodeTime(d, c, l) : c === "null_" ? this._decodeNull(d, l) : c === "bool" ? this._decodeBool(d, l) : c === "objDesc" ? this._decodeStr(d, c, l) : c === "int" || c === "enum" ? this._decodeInt(d, h.args && h.args[0], l) : h.use !== null ? this._getUse(h.use, d._reporterState.obj)._decode(d, l) : d.error("unknown tag: " + c);
  }, s.prototype._getUse = function(c, d) {
    const l = this._baseState;
    return l.useDecoder = this._use(c, d), n(l.useDecoder._baseState.parent === null), l.useDecoder = l.useDecoder._baseState.children[0], l.implicit !== l.useDecoder._baseState.implicit && (l.useDecoder = l.useDecoder.clone(), l.useDecoder._baseState.implicit = l.implicit), l.useDecoder;
  }, s.prototype._decodeChoice = function(c, d) {
    const l = this._baseState;
    let h = null, y = !1;
    return Object.keys(l.choice).some(function(b) {
      const w = c.save(), A = l.choice[b];
      try {
        const M = A._decode(c, d);
        if (c.isError(M))
          return !1;
        h = { type: b, value: M }, y = !0;
      } catch {
        return c.restore(w), !1;
      }
      return !0;
    }, this), y ? h : c.error("Choice not matched");
  }, s.prototype._createEncoderBuffer = function(c) {
    return new e(c, this.reporter);
  }, s.prototype._encode = function(c, d, l) {
    const h = this._baseState;
    if (h.default !== null && h.default === c)
      return;
    const y = this._encodeValue(c, d, l);
    if (y !== void 0 && !this._skipDefault(y, d, l))
      return y;
  }, s.prototype._encodeValue = function(c, d, l) {
    const h = this._baseState;
    if (h.parent === null)
      return h.children[0]._encode(c, d || new t());
    let y = null;
    if (this.reporter = d, h.optional && c === void 0)
      if (h.default !== null)
        c = h.default;
      else
        return;
    let b = null, w = !1;
    if (h.any)
      y = this._createEncoderBuffer(c);
    else if (h.choice)
      y = this._encodeChoice(c, d);
    else if (h.contains)
      b = this._getUse(h.contains, l)._encode(c, d), w = !0;
    else if (h.children)
      b = h.children.map(function(A) {
        if (A._baseState.tag === "null_")
          return A._encode(null, d, c);
        if (A._baseState.key === null)
          return d.error("Child should have a key");
        const M = d.enterKey(A._baseState.key);
        if (typeof c != "object")
          return d.error("Child expected, but input is not object");
        const N = A._encode(c[A._baseState.key], d, c);
        return d.leaveKey(M), N;
      }, this).filter(function(A) {
        return A;
      }), b = this._createEncoderBuffer(b);
    else if (h.tag === "seqof" || h.tag === "setof") {
      if (!(h.args && h.args.length === 1))
        return d.error("Too many args for : " + h.tag);
      if (!Array.isArray(c))
        return d.error("seqof/setof, but data is not Array");
      const A = this.clone();
      A._baseState.implicit = null, b = this._createEncoderBuffer(c.map(function(M) {
        const N = this._baseState;
        return this._getUse(N.args[0], c)._encode(M, d);
      }, A));
    } else
      h.use !== null ? y = this._getUse(h.use, l)._encode(c, d) : (b = this._encodePrimitive(h.tag, c), w = !0);
    if (!h.any && h.choice === null) {
      const A = h.implicit !== null ? h.implicit : h.tag, M = h.implicit === null ? "universal" : "context";
      A === null ? h.use === null && d.error("Tag could be omitted only for .use()") : h.use === null && (y = this._encodeComposite(A, w, M, b));
    }
    return h.explicit !== null && (y = this._encodeComposite(h.explicit, !1, "context", y)), y;
  }, s.prototype._encodeChoice = function(c, d) {
    const l = this._baseState, h = l.choice[c.type];
    return h || n(
      !1,
      c.type + " not found in " + JSON.stringify(Object.keys(l.choice))
    ), h._encode(c.value, d);
  }, s.prototype._encodePrimitive = function(c, d) {
    const l = this._baseState;
    if (/str$/.test(c))
      return this._encodeStr(d, c);
    if (c === "objid" && l.args)
      return this._encodeObjid(d, l.reverseArgs[0], l.args[1]);
    if (c === "objid")
      return this._encodeObjid(d, null, null);
    if (c === "gentime" || c === "utctime")
      return this._encodeTime(d, c);
    if (c === "null_")
      return this._encodeNull();
    if (c === "int" || c === "enum")
      return this._encodeInt(d, l.args && l.reverseArgs[0]);
    if (c === "bool")
      return this._encodeBool(d);
    if (c === "objDesc")
      return this._encodeStr(d, c);
    throw new Error("Unsupported tag: " + c);
  }, s.prototype._isNumstr = function(c) {
    return /^[0-9 ]*$/.test(c);
  }, s.prototype._isPrintstr = function(c) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(c);
  }, Vl;
}
var Yl = {}, Wb;
function Dp() {
  return Wb || (Wb = 1, function(t) {
    function e(r) {
      const n = {};
      return Object.keys(r).forEach(function(i) {
        (i | 0) == i && (i = i | 0);
        const o = r[i];
        n[o] = i;
      }), n;
    }
    t.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, t.tagClassByName = e(t.tagClass), t.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, t.tagByName = e(t.tag);
  }(Yl)), Yl;
}
var Jl, Hb;
function T3() {
  if (Hb)
    return Jl;
  Hb = 1;
  const t = Mt, e = Fp().Buffer, r = jp(), n = Dp();
  function i(f) {
    this.enc = "der", this.name = f.name, this.entity = f, this.tree = new o(), this.tree._init(f.body);
  }
  Jl = i, i.prototype.encode = function(u, c) {
    return this.tree._encode(u, c).join();
  };
  function o(f) {
    r.call(this, "der", f);
  }
  t(o, r), o.prototype._encodeComposite = function(u, c, d, l) {
    const h = s(u, c, d, this.reporter);
    if (l.length < 128) {
      const w = e.alloc(2);
      return w[0] = h, w[1] = l.length, this._createEncoderBuffer([w, l]);
    }
    let y = 1;
    for (let w = l.length; w >= 256; w >>= 8)
      y++;
    const b = e.alloc(2 + y);
    b[0] = h, b[1] = 128 | y;
    for (let w = 1 + y, A = l.length; A > 0; w--, A >>= 8)
      b[w] = A & 255;
    return this._createEncoderBuffer([b, l]);
  }, o.prototype._encodeStr = function(u, c) {
    if (c === "bitstr")
      return this._createEncoderBuffer([u.unused | 0, u.data]);
    if (c === "bmpstr") {
      const d = e.alloc(u.length * 2);
      for (let l = 0; l < u.length; l++)
        d.writeUInt16BE(u.charCodeAt(l), l * 2);
      return this._createEncoderBuffer(d);
    } else
      return c === "numstr" ? this._isNumstr(u) ? this._createEncoderBuffer(u) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : c === "printstr" ? this._isPrintstr(u) ? this._createEncoderBuffer(u) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(c) ? this._createEncoderBuffer(u) : c === "objDesc" ? this._createEncoderBuffer(u) : this.reporter.error("Encoding of string type: " + c + " unsupported");
  }, o.prototype._encodeObjid = function(u, c, d) {
    if (typeof u == "string") {
      if (!c)
        return this.reporter.error("string objid given, but no values map found");
      if (!c.hasOwnProperty(u))
        return this.reporter.error("objid not found in values map");
      u = c[u].split(/[\s.]+/g);
      for (let b = 0; b < u.length; b++)
        u[b] |= 0;
    } else if (Array.isArray(u)) {
      u = u.slice();
      for (let b = 0; b < u.length; b++)
        u[b] |= 0;
    }
    if (!Array.isArray(u))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(u));
    if (!d) {
      if (u[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      u.splice(0, 2, u[0] * 40 + u[1]);
    }
    let l = 0;
    for (let b = 0; b < u.length; b++) {
      let w = u[b];
      for (l++; w >= 128; w >>= 7)
        l++;
    }
    const h = e.alloc(l);
    let y = h.length - 1;
    for (let b = u.length - 1; b >= 0; b--) {
      let w = u[b];
      for (h[y--] = w & 127; (w >>= 7) > 0; )
        h[y--] = 128 | w & 127;
    }
    return this._createEncoderBuffer(h);
  };
  function a(f) {
    return f < 10 ? "0" + f : f;
  }
  o.prototype._encodeTime = function(u, c) {
    let d;
    const l = new Date(u);
    return c === "gentime" ? d = [
      a(l.getUTCFullYear()),
      a(l.getUTCMonth() + 1),
      a(l.getUTCDate()),
      a(l.getUTCHours()),
      a(l.getUTCMinutes()),
      a(l.getUTCSeconds()),
      "Z"
    ].join("") : c === "utctime" ? d = [
      a(l.getUTCFullYear() % 100),
      a(l.getUTCMonth() + 1),
      a(l.getUTCDate()),
      a(l.getUTCHours()),
      a(l.getUTCMinutes()),
      a(l.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + c + " time is not supported yet"), this._encodeStr(d, "octstr");
  }, o.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, o.prototype._encodeInt = function(u, c) {
    if (typeof u == "string") {
      if (!c)
        return this.reporter.error("String int or enum given, but no values map");
      if (!c.hasOwnProperty(u))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(u));
      u = c[u];
    }
    if (typeof u != "number" && !e.isBuffer(u)) {
      const h = u.toArray();
      !u.sign && h[0] & 128 && h.unshift(0), u = e.from(h);
    }
    if (e.isBuffer(u)) {
      let h = u.length;
      u.length === 0 && h++;
      const y = e.alloc(h);
      return u.copy(y), u.length === 0 && (y[0] = 0), this._createEncoderBuffer(y);
    }
    if (u < 128)
      return this._createEncoderBuffer(u);
    if (u < 256)
      return this._createEncoderBuffer([0, u]);
    let d = 1;
    for (let h = u; h >= 256; h >>= 8)
      d++;
    const l = new Array(d);
    for (let h = l.length - 1; h >= 0; h--)
      l[h] = u & 255, u >>= 8;
    return l[0] & 128 && l.unshift(0), this._createEncoderBuffer(e.from(l));
  }, o.prototype._encodeBool = function(u) {
    return this._createEncoderBuffer(u ? 255 : 0);
  }, o.prototype._use = function(u, c) {
    return typeof u == "function" && (u = u(c)), u._getEncoder("der").tree;
  }, o.prototype._skipDefault = function(u, c, d) {
    const l = this._baseState;
    let h;
    if (l.default === null)
      return !1;
    const y = u.join();
    if (l.defaultBuffer === void 0 && (l.defaultBuffer = this._encodeValue(l.default, c, d).join()), y.length !== l.defaultBuffer.length)
      return !1;
    for (h = 0; h < y.length; h++)
      if (y[h] !== l.defaultBuffer[h])
        return !1;
    return !0;
  };
  function s(f, u, c, d) {
    let l;
    if (f === "seqof" ? f = "seq" : f === "setof" && (f = "set"), n.tagByName.hasOwnProperty(f))
      l = n.tagByName[f];
    else if (typeof f == "number" && (f | 0) === f)
      l = f;
    else
      return d.error("Unknown tag: " + f);
    return l >= 31 ? d.error("Multi-octet tag encoding unsupported") : (u || (l |= 32), l |= n.tagClassByName[c || "universal"] << 6, l);
  }
  return Jl;
}
var Xl, Gb;
function bE() {
  if (Gb)
    return Xl;
  Gb = 1;
  const t = Mt, e = T3();
  function r(n) {
    e.call(this, n), this.enc = "pem";
  }
  return t(r, e), Xl = r, r.prototype.encode = function(i, o) {
    const s = e.prototype.encode.call(this, i).toString("base64"), f = ["-----BEGIN " + o.label + "-----"];
    for (let u = 0; u < s.length; u += 64)
      f.push(s.slice(u, u + 64));
    return f.push("-----END " + o.label + "-----"), f.join(`
`);
  }, Xl;
}
var Vb;
function O3() {
  return Vb || (Vb = 1, function(t) {
    const e = t;
    e.der = T3(), e.pem = bE();
  }(Wl)), Wl;
}
var Zl = {}, Ql, Yb;
function k3() {
  if (Yb)
    return Ql;
  Yb = 1;
  const t = Mt, e = mr, r = $s().DecoderBuffer, n = jp(), i = Dp();
  function o(u) {
    this.enc = "der", this.name = u.name, this.entity = u, this.tree = new a(), this.tree._init(u.body);
  }
  Ql = o, o.prototype.decode = function(c, d) {
    return r.isDecoderBuffer(c) || (c = new r(c, d)), this.tree._decode(c, d);
  };
  function a(u) {
    n.call(this, "der", u);
  }
  t(a, n), a.prototype._peekTag = function(c, d, l) {
    if (c.isEmpty())
      return !1;
    const h = c.save(), y = s(c, 'Failed to peek tag: "' + d + '"');
    return c.isError(y) ? y : (c.restore(h), y.tag === d || y.tagStr === d || y.tagStr + "of" === d || l);
  }, a.prototype._decodeTag = function(c, d, l) {
    const h = s(
      c,
      'Failed to decode tag of "' + d + '"'
    );
    if (c.isError(h))
      return h;
    let y = f(
      c,
      h.primitive,
      'Failed to get length of "' + d + '"'
    );
    if (c.isError(y))
      return y;
    if (!l && h.tag !== d && h.tagStr !== d && h.tagStr + "of" !== d)
      return c.error('Failed to match tag: "' + d + '"');
    if (h.primitive || y !== null)
      return c.skip(y, 'Failed to match body of: "' + d + '"');
    const b = c.save(), w = this._skipUntilEnd(
      c,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return c.isError(w) ? w : (y = c.offset - b.offset, c.restore(b), c.skip(y, 'Failed to match body of: "' + d + '"'));
  }, a.prototype._skipUntilEnd = function(c, d) {
    for (; ; ) {
      const l = s(c, d);
      if (c.isError(l))
        return l;
      const h = f(c, l.primitive, d);
      if (c.isError(h))
        return h;
      let y;
      if (l.primitive || h !== null ? y = c.skip(h) : y = this._skipUntilEnd(c, d), c.isError(y))
        return y;
      if (l.tagStr === "end")
        break;
    }
  }, a.prototype._decodeList = function(c, d, l, h) {
    const y = [];
    for (; !c.isEmpty(); ) {
      const b = this._peekTag(c, "end");
      if (c.isError(b))
        return b;
      const w = l.decode(c, "der", h);
      if (c.isError(w) && b)
        break;
      y.push(w);
    }
    return y;
  }, a.prototype._decodeStr = function(c, d) {
    if (d === "bitstr") {
      const l = c.readUInt8();
      return c.isError(l) ? l : { unused: l, data: c.raw() };
    } else if (d === "bmpstr") {
      const l = c.raw();
      if (l.length % 2 === 1)
        return c.error("Decoding of string type: bmpstr length mismatch");
      let h = "";
      for (let y = 0; y < l.length / 2; y++)
        h += String.fromCharCode(l.readUInt16BE(y * 2));
      return h;
    } else if (d === "numstr") {
      const l = c.raw().toString("ascii");
      return this._isNumstr(l) ? l : c.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (d === "octstr")
        return c.raw();
      if (d === "objDesc")
        return c.raw();
      if (d === "printstr") {
        const l = c.raw().toString("ascii");
        return this._isPrintstr(l) ? l : c.error("Decoding of string type: printstr unsupported characters");
      } else
        return /str$/.test(d) ? c.raw().toString() : c.error("Decoding of string type: " + d + " unsupported");
    }
  }, a.prototype._decodeObjid = function(c, d, l) {
    let h;
    const y = [];
    let b = 0, w = 0;
    for (; !c.isEmpty(); )
      w = c.readUInt8(), b <<= 7, b |= w & 127, w & 128 || (y.push(b), b = 0);
    w & 128 && y.push(b);
    const A = y[0] / 40 | 0, M = y[0] % 40;
    if (l ? h = y : h = [A, M].concat(y.slice(1)), d) {
      let N = d[h.join(" ")];
      N === void 0 && (N = d[h.join(".")]), N !== void 0 && (h = N);
    }
    return h;
  }, a.prototype._decodeTime = function(c, d) {
    const l = c.raw().toString();
    let h, y, b, w, A, M;
    if (d === "gentime")
      h = l.slice(0, 4) | 0, y = l.slice(4, 6) | 0, b = l.slice(6, 8) | 0, w = l.slice(8, 10) | 0, A = l.slice(10, 12) | 0, M = l.slice(12, 14) | 0;
    else if (d === "utctime")
      h = l.slice(0, 2) | 0, y = l.slice(2, 4) | 0, b = l.slice(4, 6) | 0, w = l.slice(6, 8) | 0, A = l.slice(8, 10) | 0, M = l.slice(10, 12) | 0, h < 70 ? h = 2e3 + h : h = 1900 + h;
    else
      return c.error("Decoding " + d + " time is not supported yet");
    return Date.UTC(h, y - 1, b, w, A, M, 0);
  }, a.prototype._decodeNull = function() {
    return null;
  }, a.prototype._decodeBool = function(c) {
    const d = c.readUInt8();
    return c.isError(d) ? d : d !== 0;
  }, a.prototype._decodeInt = function(c, d) {
    const l = c.raw();
    let h = new e(l);
    return d && (h = d[h.toString(10)] || h), h;
  }, a.prototype._use = function(c, d) {
    return typeof c == "function" && (c = c(d)), c._getDecoder("der").tree;
  };
  function s(u, c) {
    let d = u.readUInt8(c);
    if (u.isError(d))
      return d;
    const l = i.tagClass[d >> 6], h = (d & 32) === 0;
    if ((d & 31) === 31) {
      let b = d;
      for (d = 0; (b & 128) === 128; ) {
        if (b = u.readUInt8(c), u.isError(b))
          return b;
        d <<= 7, d |= b & 127;
      }
    } else
      d &= 31;
    const y = i.tag[d];
    return {
      cls: l,
      primitive: h,
      tag: d,
      tagStr: y
    };
  }
  function f(u, c, d) {
    let l = u.readUInt8(d);
    if (u.isError(l))
      return l;
    if (!c && l === 128)
      return null;
    if (!(l & 128))
      return l;
    const h = l & 127;
    if (h > 4)
      return u.error("length octect is too long");
    l = 0;
    for (let y = 0; y < h; y++) {
      l <<= 8;
      const b = u.readUInt8(d);
      if (u.isError(b))
        return b;
      l |= b;
    }
    return l;
  }
  return Ql;
}
var eh, Jb;
function gE() {
  if (Jb)
    return eh;
  Jb = 1;
  const t = Mt, e = Fp().Buffer, r = k3();
  function n(i) {
    r.call(this, i), this.enc = "pem";
  }
  return t(n, r), eh = n, n.prototype.decode = function(o, a) {
    const s = o.toString().split(/[\r\n]+/g), f = a.label.toUpperCase(), u = /^-----(BEGIN|END) ([^-]+)-----$/;
    let c = -1, d = -1;
    for (let y = 0; y < s.length; y++) {
      const b = s[y].match(u);
      if (b !== null && b[2] === f)
        if (c === -1) {
          if (b[1] !== "BEGIN")
            break;
          c = y;
        } else {
          if (b[1] !== "END")
            break;
          d = y;
          break;
        }
    }
    if (c === -1 || d === -1)
      throw new Error("PEM section not found for: " + f);
    const l = s.slice(c + 1, d).join("");
    l.replace(/[^a-z0-9+/=]+/gi, "");
    const h = e.from(l, "base64");
    return r.prototype.decode.call(this, h, a);
  }, eh;
}
var Xb;
function C3() {
  return Xb || (Xb = 1, function(t) {
    const e = t;
    e.der = k3(), e.pem = gE();
  }(Zl)), Zl;
}
var Zb;
function vE() {
  return Zb || (Zb = 1, function(t) {
    const e = O3(), r = C3(), n = Mt, i = t;
    i.define = function(s, f) {
      return new o(s, f);
    };
    function o(a, s) {
      this.name = a, this.body = s, this.decoders = {}, this.encoders = {};
    }
    o.prototype._createNamed = function(s) {
      const f = this.name;
      function u(c) {
        this._initNamed(c, f);
      }
      return n(u, s), u.prototype._initNamed = function(d, l) {
        s.call(this, d, l);
      }, new u(this);
    }, o.prototype._getDecoder = function(s) {
      return s = s || "der", this.decoders.hasOwnProperty(s) || (this.decoders[s] = this._createNamed(r[s])), this.decoders[s];
    }, o.prototype.decode = function(s, f, u) {
      return this._getDecoder(f).decode(s, u);
    }, o.prototype._getEncoder = function(s) {
      return s = s || "der", this.encoders.hasOwnProperty(s) || (this.encoders[s] = this._createNamed(e[s])), this.encoders[s];
    }, o.prototype.encode = function(s, f, u) {
      return this._getEncoder(f).encode(s, u);
    };
  }(Kl)), Kl;
}
var th = {}, Qb;
function mE() {
  return Qb || (Qb = 1, function(t) {
    const e = t;
    e.Reporter = Lp().Reporter, e.DecoderBuffer = $s().DecoderBuffer, e.EncoderBuffer = $s().EncoderBuffer, e.Node = jp();
  }(th)), th;
}
var rh = {}, eg;
function wE() {
  return eg || (eg = 1, function(t) {
    const e = t;
    e._reverse = function(n) {
      const i = {};
      return Object.keys(n).forEach(function(o) {
        (o | 0) == o && (o = o | 0);
        const a = n[o];
        i[a] = o;
      }), i;
    }, e.der = Dp();
  }(rh)), rh;
}
var tg;
function P3() {
  return tg || (tg = 1, function(t) {
    const e = t;
    e.bignum = mr, e.define = vE().define, e.base = mE(), e.constants = wE(), e.decoders = C3(), e.encoders = O3();
  }(zl)), zl;
}
var nh, rg;
function xE() {
  if (rg)
    return nh;
  rg = 1;
  var t = P3(), e = t.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), r = t.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), n = t.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), i = t.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(n),
      this.key("subjectPublicKey").bitstr()
    );
  }), o = t.define("RelativeDistinguishedName", function() {
    this.setof(r);
  }), a = t.define("RDNSequence", function() {
    this.seqof(o);
  }), s = t.define("Name", function() {
    this.choice({
      rdnSequence: this.use(a)
    });
  }), f = t.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(e),
      this.key("notAfter").use(e)
    );
  }), u = t.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), c = t.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(n),
      this.key("issuer").use(s),
      this.key("validity").use(f),
      this.key("subject").use(s),
      this.key("subjectPublicKeyInfo").use(i),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(u).optional()
    );
  }), d = t.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(c),
      this.key("signatureAlgorithm").use(n),
      this.key("signatureValue").bitstr()
    );
  });
  return nh = d, nh;
}
var ng;
function _E() {
  if (ng)
    return Un;
  ng = 1;
  var t = P3();
  Un.certificate = xE();
  var e = t.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  Un.RSAPrivateKey = e;
  var r = t.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  Un.RSAPublicKey = r;
  var n = t.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(i),
      this.key("subjectPublicKey").bitstr()
    );
  });
  Un.PublicKey = n;
  var i = t.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), o = t.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(i),
      this.key("subjectPrivateKey").octstr()
    );
  });
  Un.PrivateKey = o;
  var a = t.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  Un.EncryptedPrivateKey = a;
  var s = t.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  Un.DSAPrivateKey = s, Un.DSAparam = t.define("DSAparam", function() {
    this.int();
  });
  var f = t.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(u),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  Un.ECPrivateKey = f;
  var u = t.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  });
  return Un.signature = t.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), Un;
}
const EE = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var ih, ig;
function SE() {
  if (ig)
    return ih;
  ig = 1;
  var t = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, e = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, r = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, n = Yu(), i = Op(), o = Et.Buffer;
  return ih = function(a, s) {
    var f = a.toString(), u = f.match(t), c;
    if (u) {
      var l = "aes" + u[1], h = o.from(u[2], "hex"), y = o.from(u[3].replace(/[\r\n]/g, ""), "base64"), b = n(s, h.slice(0, 8), parseInt(u[1], 10)).key, w = [], A = i.createDecipheriv(l, b, h);
      w.push(A.update(y)), w.push(A.final()), c = o.concat(w);
    } else {
      var d = f.match(r);
      c = o.from(d[2].replace(/[\r\n]/g, ""), "base64");
    }
    var M = f.match(e)[1];
    return {
      tag: M,
      data: c
    };
  }, ih;
}
var oh, og;
function Zu() {
  if (og)
    return oh;
  og = 1;
  var t = _E(), e = EE, r = SE(), n = Op(), i = y3(), o = Et.Buffer;
  oh = a;
  function a(f) {
    var u;
    typeof f == "object" && !o.isBuffer(f) && (u = f.passphrase, f = f.key), typeof f == "string" && (f = o.from(f));
    var c = r(f, u), d = c.tag, l = c.data, h, y;
    switch (d) {
      case "CERTIFICATE":
        y = t.certificate.decode(l, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (y || (y = t.PublicKey.decode(l, "der")), h = y.algorithm.algorithm.join("."), h) {
          case "1.2.840.113549.1.1.1":
            return t.RSAPublicKey.decode(y.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return y.subjectPrivateKey = y.subjectPublicKey, {
              type: "ec",
              data: y
            };
          case "1.2.840.10040.4.1":
            return y.algorithm.params.pub_key = t.DSAparam.decode(y.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: y.algorithm.params
            };
          default:
            throw new Error("unknown key id " + h);
        }
      case "ENCRYPTED PRIVATE KEY":
        l = t.EncryptedPrivateKey.decode(l, "der"), l = s(l, u);
      case "PRIVATE KEY":
        switch (y = t.PrivateKey.decode(l, "der"), h = y.algorithm.algorithm.join("."), h) {
          case "1.2.840.113549.1.1.1":
            return t.RSAPrivateKey.decode(y.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: y.algorithm.curve,
              privateKey: t.ECPrivateKey.decode(y.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return y.algorithm.params.priv_key = t.DSAparam.decode(y.subjectPrivateKey, "der"), {
              type: "dsa",
              params: y.algorithm.params
            };
          default:
            throw new Error("unknown key id " + h);
        }
      case "RSA PUBLIC KEY":
        return t.RSAPublicKey.decode(l, "der");
      case "RSA PRIVATE KEY":
        return t.RSAPrivateKey.decode(l, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: t.DSAPrivateKey.decode(l, "der")
        };
      case "EC PRIVATE KEY":
        return l = t.ECPrivateKey.decode(l, "der"), {
          curve: l.parameters.value,
          privateKey: l.privateKey
        };
      default:
        throw new Error("unknown key type " + d);
    }
  }
  a.signature = t.signature;
  function s(f, u) {
    var c = f.algorithm.decrypt.kde.kdeparams.salt, d = parseInt(f.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), l = e[f.algorithm.decrypt.cipher.algo.join(".")], h = f.algorithm.decrypt.cipher.iv, y = f.subjectPrivateKey, b = parseInt(l.split("-")[1], 10) / 8, w = i.pbkdf2Sync(u, c, d, b, "sha1"), A = n.createDecipheriv(l, w, h), M = [];
    return M.push(A.update(y)), M.push(A.final()), o.concat(M);
  }
  return oh;
}
const N3 = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var ag;
function AE() {
  if (ag)
    return vs.exports;
  ag = 1;
  var t = Et.Buffer, e = Gu, r = Pp(), n = Xu().ec, i = mr, o = Zu(), a = N3, s = 1;
  function f(A, M, N, G, z) {
    var J = o(M);
    if (J.curve) {
      if (G !== "ecdsa" && G !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return u(A, J);
    } else if (J.type === "dsa") {
      if (G !== "dsa")
        throw new Error("wrong private key type");
      return c(A, J, N);
    }
    if (G !== "rsa" && G !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (M.padding !== void 0 && M.padding !== s)
      throw new Error("illegal or unsupported padding mode");
    A = t.concat([z, A]);
    for (var oe = J.modulus.byteLength(), ee = [0, 1]; A.length + ee.length + 1 < oe; )
      ee.push(255);
    ee.push(0);
    for (var ae = -1; ++ae < A.length; )
      ee.push(A[ae]);
    var ye = r(ee, J);
    return ye;
  }
  function u(A, M) {
    var N = a[M.curve.join(".")];
    if (!N)
      throw new Error("unknown curve " + M.curve.join("."));
    var G = new n(N), z = G.keyFromPrivate(M.privateKey), J = z.sign(A);
    return t.from(J.toDER());
  }
  function c(A, M, N) {
    for (var G = M.params.priv_key, z = M.params.p, J = M.params.q, oe = M.params.g, ee = new i(0), ae, ye = h(A, J).mod(J), pe = !1, te = l(G, J, A, N); pe === !1; )
      ae = b(J, te, N), ee = w(oe, ae, z, J), pe = ae.invm(J).imul(ye.add(G.mul(ee))).mod(J), pe.cmpn(0) === 0 && (pe = !1, ee = new i(0));
    return d(ee, pe);
  }
  function d(A, M) {
    A = A.toArray(), M = M.toArray(), A[0] & 128 && (A = [0].concat(A)), M[0] & 128 && (M = [0].concat(M));
    var N = A.length + M.length + 4, G = [
      48,
      N,
      2,
      A.length
    ];
    return G = G.concat(A, [2, M.length], M), t.from(G);
  }
  function l(A, M, N, G) {
    if (A = t.from(A.toArray()), A.length < M.byteLength()) {
      var z = t.alloc(M.byteLength() - A.length);
      A = t.concat([z, A]);
    }
    var J = N.length, oe = y(N, M), ee = t.alloc(J);
    ee.fill(1);
    var ae = t.alloc(J);
    return ae = e(G, ae).update(ee).update(t.from([0])).update(A).update(oe).digest(), ee = e(G, ae).update(ee).digest(), ae = e(G, ae).update(ee).update(t.from([1])).update(A).update(oe).digest(), ee = e(G, ae).update(ee).digest(), { k: ae, v: ee };
  }
  function h(A, M) {
    var N = new i(A), G = (A.length << 3) - M.bitLength();
    return G > 0 && N.ishrn(G), N;
  }
  function y(A, M) {
    A = h(A, M), A = A.mod(M);
    var N = t.from(A.toArray());
    if (N.length < M.byteLength()) {
      var G = t.alloc(M.byteLength() - N.length);
      N = t.concat([G, N]);
    }
    return N;
  }
  function b(A, M, N) {
    var G, z;
    do {
      for (G = t.alloc(0); G.length * 8 < A.bitLength(); )
        M.v = e(N, M.k).update(M.v).digest(), G = t.concat([G, M.v]);
      z = h(G, A), M.k = e(N, M.k).update(M.v).update(t.from([0])).digest(), M.v = e(N, M.k).update(M.v).digest();
    } while (z.cmp(A) !== -1);
    return z;
  }
  function w(A, M, N, G) {
    return A.toRed(i.mont(N)).redPow(M).fromRed().mod(G);
  }
  return vs.exports = f, vs.exports.getKey = l, vs.exports.makeKey = b, vs.exports;
}
var ah, sg;
function IE() {
  if (sg)
    return ah;
  sg = 1;
  var t = Et.Buffer, e = mr, r = Xu().ec, n = Zu(), i = N3;
  function o(u, c, d, l, h) {
    var y = n(d);
    if (y.type === "ec") {
      if (l !== "ecdsa" && l !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return a(u, c, y);
    } else if (y.type === "dsa") {
      if (l !== "dsa")
        throw new Error("wrong public key type");
      return s(u, c, y);
    }
    if (l !== "rsa" && l !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    c = t.concat([h, c]);
    for (var b = y.modulus.byteLength(), w = [1], A = 0; c.length + w.length + 2 < b; )
      w.push(255), A += 1;
    w.push(0);
    for (var M = -1; ++M < c.length; )
      w.push(c[M]);
    w = t.from(w);
    var N = e.mont(y.modulus);
    u = new e(u).toRed(N), u = u.redPow(new e(y.publicExponent)), u = t.from(u.fromRed().toArray());
    var G = A < 8 ? 1 : 0;
    for (b = Math.min(u.length, w.length), u.length !== w.length && (G = 1), M = -1; ++M < b; )
      G |= u[M] ^ w[M];
    return G === 0;
  }
  function a(u, c, d) {
    var l = i[d.data.algorithm.curve.join(".")];
    if (!l)
      throw new Error("unknown curve " + d.data.algorithm.curve.join("."));
    var h = new r(l), y = d.data.subjectPrivateKey.data;
    return h.verify(c, u, y);
  }
  function s(u, c, d) {
    var l = d.data.p, h = d.data.q, y = d.data.g, b = d.data.pub_key, w = n.signature.decode(u, "der"), A = w.s, M = w.r;
    f(A, h), f(M, h);
    var N = e.mont(l), G = A.invm(h), z = y.toRed(N).redPow(new e(c).mul(G).mod(h)).fromRed().mul(b.toRed(N).redPow(M.mul(G).mod(h)).fromRed()).mod(l).mod(h);
    return z.cmp(M) === 0;
  }
  function f(u, c) {
    if (u.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (u.cmp(c) >= 0)
      throw new Error("invalid sig");
  }
  return ah = o, ah;
}
var sh, fg;
function BE() {
  if (fg)
    return sh;
  fg = 1;
  var t = Et.Buffer, e = Yo(), r = Hm, n = Mt, i = AE(), o = IE(), a = u3;
  Object.keys(a).forEach(function(d) {
    a[d].id = t.from(a[d].id, "hex"), a[d.toLowerCase()] = a[d];
  });
  function s(d) {
    r.Writable.call(this);
    var l = a[d];
    if (!l)
      throw new Error("Unknown message digest");
    this._hashType = l.hash, this._hash = e(l.hash), this._tag = l.id, this._signType = l.sign;
  }
  n(s, r.Writable), s.prototype._write = function(l, h, y) {
    this._hash.update(l), y();
  }, s.prototype.update = function(l, h) {
    return this._hash.update(typeof l == "string" ? t.from(l, h) : l), this;
  }, s.prototype.sign = function(l, h) {
    this.end();
    var y = this._hash.digest(), b = i(y, l, this._hashType, this._signType, this._tag);
    return h ? b.toString(h) : b;
  };
  function f(d) {
    r.Writable.call(this);
    var l = a[d];
    if (!l)
      throw new Error("Unknown message digest");
    this._hash = e(l.hash), this._tag = l.id, this._signType = l.sign;
  }
  n(f, r.Writable), f.prototype._write = function(l, h, y) {
    this._hash.update(l), y();
  }, f.prototype.update = function(l, h) {
    return this._hash.update(typeof l == "string" ? t.from(l, h) : l), this;
  }, f.prototype.verify = function(l, h, y) {
    var b = typeof h == "string" ? t.from(h, y) : h;
    this.end();
    var w = this._hash.digest();
    return o(b, w, l, this._signType, this._tag);
  };
  function u(d) {
    return new s(d);
  }
  function c(d) {
    return new f(d);
  }
  return sh = {
    Sign: u,
    Verify: c,
    createSign: u,
    createVerify: c
  }, sh;
}
var fh, cg;
function ME() {
  if (cg)
    return fh;
  cg = 1;
  var t = Xu(), e = mr;
  fh = function(a) {
    return new n(a);
  };
  var r = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  r.p224 = r.secp224r1, r.p256 = r.secp256r1 = r.prime256v1, r.p192 = r.secp192r1 = r.prime192v1, r.p384 = r.secp384r1, r.p521 = r.secp521r1;
  function n(o) {
    this.curveType = r[o], this.curveType || (this.curveType = {
      name: o
    }), this.curve = new t.ec(this.curveType.name), this.keys = void 0;
  }
  n.prototype.generateKeys = function(o, a) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(o, a);
  }, n.prototype.computeSecret = function(o, a, s) {
    a = a || "utf8", Ie.isBuffer(o) || (o = new Ie(o, a));
    var f = this.curve.keyFromPublic(o).getPublic(), u = f.mul(this.keys.getPrivate()).getX();
    return i(u, s, this.curveType.byteLength);
  }, n.prototype.getPublicKey = function(o, a) {
    var s = this.keys.getPublic(a === "compressed", !0);
    return a === "hybrid" && (s[s.length - 1] % 2 ? s[0] = 7 : s[0] = 6), i(s, o);
  }, n.prototype.getPrivateKey = function(o) {
    return i(this.keys.getPrivate(), o);
  }, n.prototype.setPublicKey = function(o, a) {
    return a = a || "utf8", Ie.isBuffer(o) || (o = new Ie(o, a)), this.keys._importPublic(o), this;
  }, n.prototype.setPrivateKey = function(o, a) {
    a = a || "utf8", Ie.isBuffer(o) || (o = new Ie(o, a));
    var s = new e(o);
    return s = s.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(s), this;
  };
  function i(o, a, s) {
    Array.isArray(o) || (o = o.toArray());
    var f = new Ie(o);
    if (s && f.length < s) {
      var u = new Ie(s - f.length);
      u.fill(0), f = Ie.concat([u, f]);
    }
    return a ? f.toString(a) : f;
  }
  return fh;
}
var ch = {}, uh, ug;
function U3() {
  if (ug)
    return uh;
  ug = 1;
  var t = Yo(), e = Et.Buffer;
  uh = function(n, i) {
    for (var o = e.alloc(0), a = 0, s; o.length < i; )
      s = r(a++), o = e.concat([o, t("sha1").update(n).update(s).digest()]);
    return o.slice(0, i);
  };
  function r(n) {
    var i = e.allocUnsafe(4);
    return i.writeUInt32BE(n, 0), i;
  }
  return uh;
}
var dh, dg;
function F3() {
  return dg || (dg = 1, dh = function(e, r) {
    for (var n = e.length, i = -1; ++i < n; )
      e[i] ^= r[i];
    return e;
  }), dh;
}
var lh, lg;
function L3() {
  if (lg)
    return lh;
  lg = 1;
  var t = mr, e = Et.Buffer;
  function r(n, i) {
    return e.from(n.toRed(t.mont(i.modulus)).redPow(new t(i.publicExponent)).fromRed().toArray());
  }
  return lh = r, lh;
}
var hh, hg;
function RE() {
  if (hg)
    return hh;
  hg = 1;
  var t = Zu(), e = es(), r = Yo(), n = U3(), i = F3(), o = mr, a = L3(), s = Pp(), f = Et.Buffer;
  hh = function(h, y, b) {
    var w;
    h.padding ? w = h.padding : b ? w = 1 : w = 4;
    var A = t(h), M;
    if (w === 4)
      M = u(A, y);
    else if (w === 1)
      M = c(A, y, b);
    else if (w === 3) {
      if (M = new o(y), M.cmp(A.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return b ? s(M, A) : a(M, A);
  };
  function u(l, h) {
    var y = l.modulus.byteLength(), b = h.length, w = r("sha1").update(f.alloc(0)).digest(), A = w.length, M = 2 * A;
    if (b > y - M - 2)
      throw new Error("message too long");
    var N = f.alloc(y - b - M - 2), G = y - A - 1, z = e(A), J = i(f.concat([w, N, f.alloc(1, 1), h], G), n(z, G)), oe = i(z, n(J, A));
    return new o(f.concat([f.alloc(1), oe, J], y));
  }
  function c(l, h, y) {
    var b = h.length, w = l.modulus.byteLength();
    if (b > w - 11)
      throw new Error("message too long");
    var A;
    return y ? A = f.alloc(w - b - 3, 255) : A = d(w - b - 3), new o(f.concat([f.from([0, y ? 1 : 2]), A, f.alloc(1), h], w));
  }
  function d(l) {
    for (var h = f.allocUnsafe(l), y = 0, b = e(l * 2), w = 0, A; y < l; )
      w === b.length && (b = e(l * 2), w = 0), A = b[w++], A && (h[y++] = A);
    return h;
  }
  return hh;
}
var ph, pg;
function TE() {
  if (pg)
    return ph;
  pg = 1;
  var t = Zu(), e = U3(), r = F3(), n = mr, i = Pp(), o = Yo(), a = L3(), s = Et.Buffer;
  ph = function(l, h, y) {
    var b;
    l.padding ? b = l.padding : y ? b = 1 : b = 4;
    var w = t(l), A = w.modulus.byteLength();
    if (h.length > A || new n(h).cmp(w.modulus) >= 0)
      throw new Error("decryption error");
    var M;
    y ? M = a(new n(h), w) : M = i(h, w);
    var N = s.alloc(A - M.length);
    if (M = s.concat([N, M], A), b === 4)
      return f(w, M);
    if (b === 1)
      return u(w, M, y);
    if (b === 3)
      return M;
    throw new Error("unknown padding");
  };
  function f(d, l) {
    var h = d.modulus.byteLength(), y = o("sha1").update(s.alloc(0)).digest(), b = y.length;
    if (l[0] !== 0)
      throw new Error("decryption error");
    var w = l.slice(1, b + 1), A = l.slice(b + 1), M = r(w, e(A, b)), N = r(A, e(M, h - b - 1));
    if (c(y, N.slice(0, b)))
      throw new Error("decryption error");
    for (var G = b; N[G] === 0; )
      G++;
    if (N[G++] !== 1)
      throw new Error("decryption error");
    return N.slice(G);
  }
  function u(d, l, h) {
    for (var y = l.slice(0, 2), b = 2, w = 0; l[b++] !== 0; )
      if (b >= l.length) {
        w++;
        break;
      }
    var A = l.slice(2, b - 1);
    if ((y.toString("hex") !== "0002" && !h || y.toString("hex") !== "0001" && h) && w++, A.length < 8 && w++, w)
      throw new Error("decryption error");
    return l.slice(b);
  }
  function c(d, l) {
    d = s.from(d), l = s.from(l);
    var h = 0, y = d.length;
    d.length !== l.length && (h++, y = Math.min(d.length, l.length));
    for (var b = -1; ++b < y; )
      h += d[b] ^ l[b];
    return h;
  }
  return ph;
}
var yg;
function OE() {
  return yg || (yg = 1, function(t) {
    t.publicEncrypt = RE(), t.privateDecrypt = TE(), t.privateEncrypt = function(r, n) {
      return t.publicEncrypt(r, n, !0);
    }, t.publicDecrypt = function(r, n) {
      return t.privateDecrypt(r, n, !0);
    };
  }(ch)), ch;
}
var aa = {}, bg;
function kE() {
  if (bg)
    return aa;
  bg = 1;
  function t() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var e = Et, r = es(), n = e.Buffer, i = e.kMaxLength, o = yt.crypto || yt.msCrypto, a = Math.pow(2, 32) - 1;
  function s(l, h) {
    if (typeof l != "number" || l !== l)
      throw new TypeError("offset must be a number");
    if (l > a || l < 0)
      throw new TypeError("offset must be a uint32");
    if (l > i || l > h)
      throw new RangeError("offset out of range");
  }
  function f(l, h, y) {
    if (typeof l != "number" || l !== l)
      throw new TypeError("size must be a number");
    if (l > a || l < 0)
      throw new TypeError("size must be a uint32");
    if (l + h > y || l > i)
      throw new RangeError("buffer too small");
  }
  o && o.getRandomValues || !Ye.browser ? (aa.randomFill = u, aa.randomFillSync = d) : (aa.randomFill = t, aa.randomFillSync = t);
  function u(l, h, y, b) {
    if (!n.isBuffer(l) && !(l instanceof yt.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof h == "function")
      b = h, h = 0, y = l.length;
    else if (typeof y == "function")
      b = y, y = l.length - h;
    else if (typeof b != "function")
      throw new TypeError('"cb" argument must be a function');
    return s(h, l.length), f(y, h, l.length), c(l, h, y, b);
  }
  function c(l, h, y, b) {
    if (Ye.browser) {
      var w = l.buffer, A = new Uint8Array(w, h, y);
      if (o.getRandomValues(A), b) {
        Ye.nextTick(function() {
          b(null, l);
        });
        return;
      }
      return l;
    }
    if (b) {
      r(y, function(N, G) {
        if (N)
          return b(N);
        G.copy(l, h), b(null, l);
      });
      return;
    }
    var M = r(y);
    return M.copy(l, h), l;
  }
  function d(l, h, y) {
    if (typeof h > "u" && (h = 0), !n.isBuffer(l) && !(l instanceof yt.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return s(h, l.length), y === void 0 && (y = l.length - h), f(y, h, l.length), c(l, h, y);
  }
  return aa;
}
var gg;
function $p() {
  if (gg)
    return At;
  gg = 1, At.randomBytes = At.rng = At.pseudoRandomBytes = At.prng = es(), At.createHash = At.Hash = Yo(), At.createHmac = At.Hmac = Gu;
  var t = s_(), e = Object.keys(t), r = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(e);
  At.getHashes = function() {
    return r;
  };
  var n = y3();
  At.pbkdf2 = n.pbkdf2, At.pbkdf2Sync = n.pbkdf2Sync;
  var i = I_();
  At.Cipher = i.Cipher, At.createCipher = i.createCipher, At.Cipheriv = i.Cipheriv, At.createCipheriv = i.createCipheriv, At.Decipher = i.Decipher, At.createDecipher = i.createDecipher, At.Decipheriv = i.Decipheriv, At.createDecipheriv = i.createDecipheriv, At.getCiphers = i.getCiphers, At.listCiphers = i.listCiphers;
  var o = F_();
  At.DiffieHellmanGroup = o.DiffieHellmanGroup, At.createDiffieHellmanGroup = o.createDiffieHellmanGroup, At.getDiffieHellman = o.getDiffieHellman, At.createDiffieHellman = o.createDiffieHellman, At.DiffieHellman = o.DiffieHellman;
  var a = BE();
  At.createSign = a.createSign, At.Sign = a.Sign, At.createVerify = a.createVerify, At.Verify = a.Verify, At.createECDH = ME();
  var s = OE();
  At.publicEncrypt = s.publicEncrypt, At.privateEncrypt = s.privateEncrypt, At.publicDecrypt = s.publicDecrypt, At.privateDecrypt = s.privateDecrypt;
  var f = kE();
  return At.randomFill = f.randomFill, At.randomFillSync = f.randomFillSync, At.createCredentials = function() {
    throw new Error([
      "sorry, createCredentials is not implemented yet",
      "we accept pull requests",
      "https://github.com/crypto-browserify/crypto-browserify"
    ].join(`
`));
  }, At.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, At;
}
(function(t) {
  (function(e) {
    var r = function(T) {
      var q, H = new Float64Array(16);
      if (T)
        for (q = 0; q < T.length; q++)
          H[q] = T[q];
      return H;
    }, n = function() {
      throw new Error("no PRNG");
    }, i = new Uint8Array(16), o = new Uint8Array(32);
    o[0] = 9;
    var a = r(), s = r([1]), f = r([56129, 1]), u = r([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), c = r([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), d = r([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), l = r([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), h = r([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function y(T, q, H, E) {
      T[q] = H >> 24 & 255, T[q + 1] = H >> 16 & 255, T[q + 2] = H >> 8 & 255, T[q + 3] = H & 255, T[q + 4] = E >> 24 & 255, T[q + 5] = E >> 16 & 255, T[q + 6] = E >> 8 & 255, T[q + 7] = E & 255;
    }
    function b(T, q, H, E, Y) {
      var le, de = 0;
      for (le = 0; le < Y; le++)
        de |= T[q + le] ^ H[E + le];
      return (1 & de - 1 >>> 8) - 1;
    }
    function w(T, q, H, E) {
      return b(T, q, H, E, 16);
    }
    function A(T, q, H, E) {
      return b(T, q, H, E, 32);
    }
    function M(T, q, H, E) {
      for (var Y = E[0] & 255 | (E[1] & 255) << 8 | (E[2] & 255) << 16 | (E[3] & 255) << 24, le = H[0] & 255 | (H[1] & 255) << 8 | (H[2] & 255) << 16 | (H[3] & 255) << 24, de = H[4] & 255 | (H[5] & 255) << 8 | (H[6] & 255) << 16 | (H[7] & 255) << 24, xe = H[8] & 255 | (H[9] & 255) << 8 | (H[10] & 255) << 16 | (H[11] & 255) << 24, Re = H[12] & 255 | (H[13] & 255) << 8 | (H[14] & 255) << 16 | (H[15] & 255) << 24, Fe = E[4] & 255 | (E[5] & 255) << 8 | (E[6] & 255) << 16 | (E[7] & 255) << 24, ke = q[0] & 255 | (q[1] & 255) << 8 | (q[2] & 255) << 16 | (q[3] & 255) << 24, Pt = q[4] & 255 | (q[5] & 255) << 8 | (q[6] & 255) << 16 | (q[7] & 255) << 24, ze = q[8] & 255 | (q[9] & 255) << 8 | (q[10] & 255) << 16 | (q[11] & 255) << 24, ct = q[12] & 255 | (q[13] & 255) << 8 | (q[14] & 255) << 16 | (q[15] & 255) << 24, dt = E[8] & 255 | (E[9] & 255) << 8 | (E[10] & 255) << 16 | (E[11] & 255) << 24, vt = H[16] & 255 | (H[17] & 255) << 8 | (H[18] & 255) << 16 | (H[19] & 255) << 24, gt = H[20] & 255 | (H[21] & 255) << 8 | (H[22] & 255) << 16 | (H[23] & 255) << 24, lt = H[24] & 255 | (H[25] & 255) << 8 | (H[26] & 255) << 16 | (H[27] & 255) << 24, pt = H[28] & 255 | (H[29] & 255) << 8 | (H[30] & 255) << 16 | (H[31] & 255) << 24, ht = E[12] & 255 | (E[13] & 255) << 8 | (E[14] & 255) << 16 | (E[15] & 255) << 24, We = Y, Xe = le, qe = de, He = xe, Ge = Re, De = Fe, ve = ke, me = Pt, Me = ze, Ae = ct, Be = dt, Oe = vt, st = gt, xt = lt, St = pt, _t = ht, ne, Tt = 0; Tt < 20; Tt += 2)
        ne = We + st | 0, Ge ^= ne << 7 | ne >>> 25, ne = Ge + We | 0, Me ^= ne << 9 | ne >>> 23, ne = Me + Ge | 0, st ^= ne << 13 | ne >>> 19, ne = st + Me | 0, We ^= ne << 18 | ne >>> 14, ne = De + Xe | 0, Ae ^= ne << 7 | ne >>> 25, ne = Ae + De | 0, xt ^= ne << 9 | ne >>> 23, ne = xt + Ae | 0, Xe ^= ne << 13 | ne >>> 19, ne = Xe + xt | 0, De ^= ne << 18 | ne >>> 14, ne = Be + ve | 0, St ^= ne << 7 | ne >>> 25, ne = St + Be | 0, qe ^= ne << 9 | ne >>> 23, ne = qe + St | 0, ve ^= ne << 13 | ne >>> 19, ne = ve + qe | 0, Be ^= ne << 18 | ne >>> 14, ne = _t + Oe | 0, He ^= ne << 7 | ne >>> 25, ne = He + _t | 0, me ^= ne << 9 | ne >>> 23, ne = me + He | 0, Oe ^= ne << 13 | ne >>> 19, ne = Oe + me | 0, _t ^= ne << 18 | ne >>> 14, ne = We + He | 0, Xe ^= ne << 7 | ne >>> 25, ne = Xe + We | 0, qe ^= ne << 9 | ne >>> 23, ne = qe + Xe | 0, He ^= ne << 13 | ne >>> 19, ne = He + qe | 0, We ^= ne << 18 | ne >>> 14, ne = De + Ge | 0, ve ^= ne << 7 | ne >>> 25, ne = ve + De | 0, me ^= ne << 9 | ne >>> 23, ne = me + ve | 0, Ge ^= ne << 13 | ne >>> 19, ne = Ge + me | 0, De ^= ne << 18 | ne >>> 14, ne = Be + Ae | 0, Oe ^= ne << 7 | ne >>> 25, ne = Oe + Be | 0, Me ^= ne << 9 | ne >>> 23, ne = Me + Oe | 0, Ae ^= ne << 13 | ne >>> 19, ne = Ae + Me | 0, Be ^= ne << 18 | ne >>> 14, ne = _t + St | 0, st ^= ne << 7 | ne >>> 25, ne = st + _t | 0, xt ^= ne << 9 | ne >>> 23, ne = xt + st | 0, St ^= ne << 13 | ne >>> 19, ne = St + xt | 0, _t ^= ne << 18 | ne >>> 14;
      We = We + Y | 0, Xe = Xe + le | 0, qe = qe + de | 0, He = He + xe | 0, Ge = Ge + Re | 0, De = De + Fe | 0, ve = ve + ke | 0, me = me + Pt | 0, Me = Me + ze | 0, Ae = Ae + ct | 0, Be = Be + dt | 0, Oe = Oe + vt | 0, st = st + gt | 0, xt = xt + lt | 0, St = St + pt | 0, _t = _t + ht | 0, T[0] = We >>> 0 & 255, T[1] = We >>> 8 & 255, T[2] = We >>> 16 & 255, T[3] = We >>> 24 & 255, T[4] = Xe >>> 0 & 255, T[5] = Xe >>> 8 & 255, T[6] = Xe >>> 16 & 255, T[7] = Xe >>> 24 & 255, T[8] = qe >>> 0 & 255, T[9] = qe >>> 8 & 255, T[10] = qe >>> 16 & 255, T[11] = qe >>> 24 & 255, T[12] = He >>> 0 & 255, T[13] = He >>> 8 & 255, T[14] = He >>> 16 & 255, T[15] = He >>> 24 & 255, T[16] = Ge >>> 0 & 255, T[17] = Ge >>> 8 & 255, T[18] = Ge >>> 16 & 255, T[19] = Ge >>> 24 & 255, T[20] = De >>> 0 & 255, T[21] = De >>> 8 & 255, T[22] = De >>> 16 & 255, T[23] = De >>> 24 & 255, T[24] = ve >>> 0 & 255, T[25] = ve >>> 8 & 255, T[26] = ve >>> 16 & 255, T[27] = ve >>> 24 & 255, T[28] = me >>> 0 & 255, T[29] = me >>> 8 & 255, T[30] = me >>> 16 & 255, T[31] = me >>> 24 & 255, T[32] = Me >>> 0 & 255, T[33] = Me >>> 8 & 255, T[34] = Me >>> 16 & 255, T[35] = Me >>> 24 & 255, T[36] = Ae >>> 0 & 255, T[37] = Ae >>> 8 & 255, T[38] = Ae >>> 16 & 255, T[39] = Ae >>> 24 & 255, T[40] = Be >>> 0 & 255, T[41] = Be >>> 8 & 255, T[42] = Be >>> 16 & 255, T[43] = Be >>> 24 & 255, T[44] = Oe >>> 0 & 255, T[45] = Oe >>> 8 & 255, T[46] = Oe >>> 16 & 255, T[47] = Oe >>> 24 & 255, T[48] = st >>> 0 & 255, T[49] = st >>> 8 & 255, T[50] = st >>> 16 & 255, T[51] = st >>> 24 & 255, T[52] = xt >>> 0 & 255, T[53] = xt >>> 8 & 255, T[54] = xt >>> 16 & 255, T[55] = xt >>> 24 & 255, T[56] = St >>> 0 & 255, T[57] = St >>> 8 & 255, T[58] = St >>> 16 & 255, T[59] = St >>> 24 & 255, T[60] = _t >>> 0 & 255, T[61] = _t >>> 8 & 255, T[62] = _t >>> 16 & 255, T[63] = _t >>> 24 & 255;
    }
    function N(T, q, H, E) {
      for (var Y = E[0] & 255 | (E[1] & 255) << 8 | (E[2] & 255) << 16 | (E[3] & 255) << 24, le = H[0] & 255 | (H[1] & 255) << 8 | (H[2] & 255) << 16 | (H[3] & 255) << 24, de = H[4] & 255 | (H[5] & 255) << 8 | (H[6] & 255) << 16 | (H[7] & 255) << 24, xe = H[8] & 255 | (H[9] & 255) << 8 | (H[10] & 255) << 16 | (H[11] & 255) << 24, Re = H[12] & 255 | (H[13] & 255) << 8 | (H[14] & 255) << 16 | (H[15] & 255) << 24, Fe = E[4] & 255 | (E[5] & 255) << 8 | (E[6] & 255) << 16 | (E[7] & 255) << 24, ke = q[0] & 255 | (q[1] & 255) << 8 | (q[2] & 255) << 16 | (q[3] & 255) << 24, Pt = q[4] & 255 | (q[5] & 255) << 8 | (q[6] & 255) << 16 | (q[7] & 255) << 24, ze = q[8] & 255 | (q[9] & 255) << 8 | (q[10] & 255) << 16 | (q[11] & 255) << 24, ct = q[12] & 255 | (q[13] & 255) << 8 | (q[14] & 255) << 16 | (q[15] & 255) << 24, dt = E[8] & 255 | (E[9] & 255) << 8 | (E[10] & 255) << 16 | (E[11] & 255) << 24, vt = H[16] & 255 | (H[17] & 255) << 8 | (H[18] & 255) << 16 | (H[19] & 255) << 24, gt = H[20] & 255 | (H[21] & 255) << 8 | (H[22] & 255) << 16 | (H[23] & 255) << 24, lt = H[24] & 255 | (H[25] & 255) << 8 | (H[26] & 255) << 16 | (H[27] & 255) << 24, pt = H[28] & 255 | (H[29] & 255) << 8 | (H[30] & 255) << 16 | (H[31] & 255) << 24, ht = E[12] & 255 | (E[13] & 255) << 8 | (E[14] & 255) << 16 | (E[15] & 255) << 24, We = Y, Xe = le, qe = de, He = xe, Ge = Re, De = Fe, ve = ke, me = Pt, Me = ze, Ae = ct, Be = dt, Oe = vt, st = gt, xt = lt, St = pt, _t = ht, ne, Tt = 0; Tt < 20; Tt += 2)
        ne = We + st | 0, Ge ^= ne << 7 | ne >>> 25, ne = Ge + We | 0, Me ^= ne << 9 | ne >>> 23, ne = Me + Ge | 0, st ^= ne << 13 | ne >>> 19, ne = st + Me | 0, We ^= ne << 18 | ne >>> 14, ne = De + Xe | 0, Ae ^= ne << 7 | ne >>> 25, ne = Ae + De | 0, xt ^= ne << 9 | ne >>> 23, ne = xt + Ae | 0, Xe ^= ne << 13 | ne >>> 19, ne = Xe + xt | 0, De ^= ne << 18 | ne >>> 14, ne = Be + ve | 0, St ^= ne << 7 | ne >>> 25, ne = St + Be | 0, qe ^= ne << 9 | ne >>> 23, ne = qe + St | 0, ve ^= ne << 13 | ne >>> 19, ne = ve + qe | 0, Be ^= ne << 18 | ne >>> 14, ne = _t + Oe | 0, He ^= ne << 7 | ne >>> 25, ne = He + _t | 0, me ^= ne << 9 | ne >>> 23, ne = me + He | 0, Oe ^= ne << 13 | ne >>> 19, ne = Oe + me | 0, _t ^= ne << 18 | ne >>> 14, ne = We + He | 0, Xe ^= ne << 7 | ne >>> 25, ne = Xe + We | 0, qe ^= ne << 9 | ne >>> 23, ne = qe + Xe | 0, He ^= ne << 13 | ne >>> 19, ne = He + qe | 0, We ^= ne << 18 | ne >>> 14, ne = De + Ge | 0, ve ^= ne << 7 | ne >>> 25, ne = ve + De | 0, me ^= ne << 9 | ne >>> 23, ne = me + ve | 0, Ge ^= ne << 13 | ne >>> 19, ne = Ge + me | 0, De ^= ne << 18 | ne >>> 14, ne = Be + Ae | 0, Oe ^= ne << 7 | ne >>> 25, ne = Oe + Be | 0, Me ^= ne << 9 | ne >>> 23, ne = Me + Oe | 0, Ae ^= ne << 13 | ne >>> 19, ne = Ae + Me | 0, Be ^= ne << 18 | ne >>> 14, ne = _t + St | 0, st ^= ne << 7 | ne >>> 25, ne = st + _t | 0, xt ^= ne << 9 | ne >>> 23, ne = xt + st | 0, St ^= ne << 13 | ne >>> 19, ne = St + xt | 0, _t ^= ne << 18 | ne >>> 14;
      T[0] = We >>> 0 & 255, T[1] = We >>> 8 & 255, T[2] = We >>> 16 & 255, T[3] = We >>> 24 & 255, T[4] = De >>> 0 & 255, T[5] = De >>> 8 & 255, T[6] = De >>> 16 & 255, T[7] = De >>> 24 & 255, T[8] = Be >>> 0 & 255, T[9] = Be >>> 8 & 255, T[10] = Be >>> 16 & 255, T[11] = Be >>> 24 & 255, T[12] = _t >>> 0 & 255, T[13] = _t >>> 8 & 255, T[14] = _t >>> 16 & 255, T[15] = _t >>> 24 & 255, T[16] = ve >>> 0 & 255, T[17] = ve >>> 8 & 255, T[18] = ve >>> 16 & 255, T[19] = ve >>> 24 & 255, T[20] = me >>> 0 & 255, T[21] = me >>> 8 & 255, T[22] = me >>> 16 & 255, T[23] = me >>> 24 & 255, T[24] = Me >>> 0 & 255, T[25] = Me >>> 8 & 255, T[26] = Me >>> 16 & 255, T[27] = Me >>> 24 & 255, T[28] = Ae >>> 0 & 255, T[29] = Ae >>> 8 & 255, T[30] = Ae >>> 16 & 255, T[31] = Ae >>> 24 & 255;
    }
    function G(T, q, H, E) {
      M(T, q, H, E);
    }
    function z(T, q, H, E) {
      N(T, q, H, E);
    }
    var J = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function oe(T, q, H, E, Y, le, de) {
      var xe = new Uint8Array(16), Re = new Uint8Array(64), Fe, ke;
      for (ke = 0; ke < 16; ke++)
        xe[ke] = 0;
      for (ke = 0; ke < 8; ke++)
        xe[ke] = le[ke];
      for (; Y >= 64; ) {
        for (G(Re, xe, de, J), ke = 0; ke < 64; ke++)
          T[q + ke] = H[E + ke] ^ Re[ke];
        for (Fe = 1, ke = 8; ke < 16; ke++)
          Fe = Fe + (xe[ke] & 255) | 0, xe[ke] = Fe & 255, Fe >>>= 8;
        Y -= 64, q += 64, E += 64;
      }
      if (Y > 0)
        for (G(Re, xe, de, J), ke = 0; ke < Y; ke++)
          T[q + ke] = H[E + ke] ^ Re[ke];
      return 0;
    }
    function ee(T, q, H, E, Y) {
      var le = new Uint8Array(16), de = new Uint8Array(64), xe, Re;
      for (Re = 0; Re < 16; Re++)
        le[Re] = 0;
      for (Re = 0; Re < 8; Re++)
        le[Re] = E[Re];
      for (; H >= 64; ) {
        for (G(de, le, Y, J), Re = 0; Re < 64; Re++)
          T[q + Re] = de[Re];
        for (xe = 1, Re = 8; Re < 16; Re++)
          xe = xe + (le[Re] & 255) | 0, le[Re] = xe & 255, xe >>>= 8;
        H -= 64, q += 64;
      }
      if (H > 0)
        for (G(de, le, Y, J), Re = 0; Re < H; Re++)
          T[q + Re] = de[Re];
      return 0;
    }
    function ae(T, q, H, E, Y) {
      var le = new Uint8Array(32);
      z(le, E, Y, J);
      for (var de = new Uint8Array(8), xe = 0; xe < 8; xe++)
        de[xe] = E[xe + 16];
      return ee(T, q, H, de, le);
    }
    function ye(T, q, H, E, Y, le, de) {
      var xe = new Uint8Array(32);
      z(xe, le, de, J);
      for (var Re = new Uint8Array(8), Fe = 0; Fe < 8; Fe++)
        Re[Fe] = le[Fe + 16];
      return oe(T, q, H, E, Y, Re, xe);
    }
    var pe = function(T) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var q, H, E, Y, le, de, xe, Re;
      q = T[0] & 255 | (T[1] & 255) << 8, this.r[0] = q & 8191, H = T[2] & 255 | (T[3] & 255) << 8, this.r[1] = (q >>> 13 | H << 3) & 8191, E = T[4] & 255 | (T[5] & 255) << 8, this.r[2] = (H >>> 10 | E << 6) & 7939, Y = T[6] & 255 | (T[7] & 255) << 8, this.r[3] = (E >>> 7 | Y << 9) & 8191, le = T[8] & 255 | (T[9] & 255) << 8, this.r[4] = (Y >>> 4 | le << 12) & 255, this.r[5] = le >>> 1 & 8190, de = T[10] & 255 | (T[11] & 255) << 8, this.r[6] = (le >>> 14 | de << 2) & 8191, xe = T[12] & 255 | (T[13] & 255) << 8, this.r[7] = (de >>> 11 | xe << 5) & 8065, Re = T[14] & 255 | (T[15] & 255) << 8, this.r[8] = (xe >>> 8 | Re << 8) & 8191, this.r[9] = Re >>> 5 & 127, this.pad[0] = T[16] & 255 | (T[17] & 255) << 8, this.pad[1] = T[18] & 255 | (T[19] & 255) << 8, this.pad[2] = T[20] & 255 | (T[21] & 255) << 8, this.pad[3] = T[22] & 255 | (T[23] & 255) << 8, this.pad[4] = T[24] & 255 | (T[25] & 255) << 8, this.pad[5] = T[26] & 255 | (T[27] & 255) << 8, this.pad[6] = T[28] & 255 | (T[29] & 255) << 8, this.pad[7] = T[30] & 255 | (T[31] & 255) << 8;
    };
    pe.prototype.blocks = function(T, q, H) {
      for (var E = this.fin ? 0 : 2048, Y, le, de, xe, Re, Fe, ke, Pt, ze, ct, dt, vt, gt, lt, pt, ht, We, Xe, qe, He = this.h[0], Ge = this.h[1], De = this.h[2], ve = this.h[3], me = this.h[4], Me = this.h[5], Ae = this.h[6], Be = this.h[7], Oe = this.h[8], st = this.h[9], xt = this.r[0], St = this.r[1], _t = this.r[2], ne = this.r[3], Tt = this.r[4], Ht = this.r[5], Gt = this.r[6], Bt = this.r[7], $t = this.r[8], qt = this.r[9]; H >= 16; )
        Y = T[q + 0] & 255 | (T[q + 1] & 255) << 8, He += Y & 8191, le = T[q + 2] & 255 | (T[q + 3] & 255) << 8, Ge += (Y >>> 13 | le << 3) & 8191, de = T[q + 4] & 255 | (T[q + 5] & 255) << 8, De += (le >>> 10 | de << 6) & 8191, xe = T[q + 6] & 255 | (T[q + 7] & 255) << 8, ve += (de >>> 7 | xe << 9) & 8191, Re = T[q + 8] & 255 | (T[q + 9] & 255) << 8, me += (xe >>> 4 | Re << 12) & 8191, Me += Re >>> 1 & 8191, Fe = T[q + 10] & 255 | (T[q + 11] & 255) << 8, Ae += (Re >>> 14 | Fe << 2) & 8191, ke = T[q + 12] & 255 | (T[q + 13] & 255) << 8, Be += (Fe >>> 11 | ke << 5) & 8191, Pt = T[q + 14] & 255 | (T[q + 15] & 255) << 8, Oe += (ke >>> 8 | Pt << 8) & 8191, st += Pt >>> 5 | E, ze = 0, ct = ze, ct += He * xt, ct += Ge * (5 * qt), ct += De * (5 * $t), ct += ve * (5 * Bt), ct += me * (5 * Gt), ze = ct >>> 13, ct &= 8191, ct += Me * (5 * Ht), ct += Ae * (5 * Tt), ct += Be * (5 * ne), ct += Oe * (5 * _t), ct += st * (5 * St), ze += ct >>> 13, ct &= 8191, dt = ze, dt += He * St, dt += Ge * xt, dt += De * (5 * qt), dt += ve * (5 * $t), dt += me * (5 * Bt), ze = dt >>> 13, dt &= 8191, dt += Me * (5 * Gt), dt += Ae * (5 * Ht), dt += Be * (5 * Tt), dt += Oe * (5 * ne), dt += st * (5 * _t), ze += dt >>> 13, dt &= 8191, vt = ze, vt += He * _t, vt += Ge * St, vt += De * xt, vt += ve * (5 * qt), vt += me * (5 * $t), ze = vt >>> 13, vt &= 8191, vt += Me * (5 * Bt), vt += Ae * (5 * Gt), vt += Be * (5 * Ht), vt += Oe * (5 * Tt), vt += st * (5 * ne), ze += vt >>> 13, vt &= 8191, gt = ze, gt += He * ne, gt += Ge * _t, gt += De * St, gt += ve * xt, gt += me * (5 * qt), ze = gt >>> 13, gt &= 8191, gt += Me * (5 * $t), gt += Ae * (5 * Bt), gt += Be * (5 * Gt), gt += Oe * (5 * Ht), gt += st * (5 * Tt), ze += gt >>> 13, gt &= 8191, lt = ze, lt += He * Tt, lt += Ge * ne, lt += De * _t, lt += ve * St, lt += me * xt, ze = lt >>> 13, lt &= 8191, lt += Me * (5 * qt), lt += Ae * (5 * $t), lt += Be * (5 * Bt), lt += Oe * (5 * Gt), lt += st * (5 * Ht), ze += lt >>> 13, lt &= 8191, pt = ze, pt += He * Ht, pt += Ge * Tt, pt += De * ne, pt += ve * _t, pt += me * St, ze = pt >>> 13, pt &= 8191, pt += Me * xt, pt += Ae * (5 * qt), pt += Be * (5 * $t), pt += Oe * (5 * Bt), pt += st * (5 * Gt), ze += pt >>> 13, pt &= 8191, ht = ze, ht += He * Gt, ht += Ge * Ht, ht += De * Tt, ht += ve * ne, ht += me * _t, ze = ht >>> 13, ht &= 8191, ht += Me * St, ht += Ae * xt, ht += Be * (5 * qt), ht += Oe * (5 * $t), ht += st * (5 * Bt), ze += ht >>> 13, ht &= 8191, We = ze, We += He * Bt, We += Ge * Gt, We += De * Ht, We += ve * Tt, We += me * ne, ze = We >>> 13, We &= 8191, We += Me * _t, We += Ae * St, We += Be * xt, We += Oe * (5 * qt), We += st * (5 * $t), ze += We >>> 13, We &= 8191, Xe = ze, Xe += He * $t, Xe += Ge * Bt, Xe += De * Gt, Xe += ve * Ht, Xe += me * Tt, ze = Xe >>> 13, Xe &= 8191, Xe += Me * ne, Xe += Ae * _t, Xe += Be * St, Xe += Oe * xt, Xe += st * (5 * qt), ze += Xe >>> 13, Xe &= 8191, qe = ze, qe += He * qt, qe += Ge * $t, qe += De * Bt, qe += ve * Gt, qe += me * Ht, ze = qe >>> 13, qe &= 8191, qe += Me * Tt, qe += Ae * ne, qe += Be * _t, qe += Oe * St, qe += st * xt, ze += qe >>> 13, qe &= 8191, ze = (ze << 2) + ze | 0, ze = ze + ct | 0, ct = ze & 8191, ze = ze >>> 13, dt += ze, He = ct, Ge = dt, De = vt, ve = gt, me = lt, Me = pt, Ae = ht, Be = We, Oe = Xe, st = qe, q += 16, H -= 16;
      this.h[0] = He, this.h[1] = Ge, this.h[2] = De, this.h[3] = ve, this.h[4] = me, this.h[5] = Me, this.h[6] = Ae, this.h[7] = Be, this.h[8] = Oe, this.h[9] = st;
    }, pe.prototype.finish = function(T, q) {
      var H = new Uint16Array(10), E, Y, le, de;
      if (this.leftover) {
        for (de = this.leftover, this.buffer[de++] = 1; de < 16; de++)
          this.buffer[de] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (E = this.h[1] >>> 13, this.h[1] &= 8191, de = 2; de < 10; de++)
        this.h[de] += E, E = this.h[de] >>> 13, this.h[de] &= 8191;
      for (this.h[0] += E * 5, E = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += E, E = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += E, H[0] = this.h[0] + 5, E = H[0] >>> 13, H[0] &= 8191, de = 1; de < 10; de++)
        H[de] = this.h[de] + E, E = H[de] >>> 13, H[de] &= 8191;
      for (H[9] -= 8192, Y = (E ^ 1) - 1, de = 0; de < 10; de++)
        H[de] &= Y;
      for (Y = ~Y, de = 0; de < 10; de++)
        this.h[de] = this.h[de] & Y | H[de];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, le = this.h[0] + this.pad[0], this.h[0] = le & 65535, de = 1; de < 8; de++)
        le = (this.h[de] + this.pad[de] | 0) + (le >>> 16) | 0, this.h[de] = le & 65535;
      T[q + 0] = this.h[0] >>> 0 & 255, T[q + 1] = this.h[0] >>> 8 & 255, T[q + 2] = this.h[1] >>> 0 & 255, T[q + 3] = this.h[1] >>> 8 & 255, T[q + 4] = this.h[2] >>> 0 & 255, T[q + 5] = this.h[2] >>> 8 & 255, T[q + 6] = this.h[3] >>> 0 & 255, T[q + 7] = this.h[3] >>> 8 & 255, T[q + 8] = this.h[4] >>> 0 & 255, T[q + 9] = this.h[4] >>> 8 & 255, T[q + 10] = this.h[5] >>> 0 & 255, T[q + 11] = this.h[5] >>> 8 & 255, T[q + 12] = this.h[6] >>> 0 & 255, T[q + 13] = this.h[6] >>> 8 & 255, T[q + 14] = this.h[7] >>> 0 & 255, T[q + 15] = this.h[7] >>> 8 & 255;
    }, pe.prototype.update = function(T, q, H) {
      var E, Y;
      if (this.leftover) {
        for (Y = 16 - this.leftover, Y > H && (Y = H), E = 0; E < Y; E++)
          this.buffer[this.leftover + E] = T[q + E];
        if (H -= Y, q += Y, this.leftover += Y, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (H >= 16 && (Y = H - H % 16, this.blocks(T, q, Y), q += Y, H -= Y), H) {
        for (E = 0; E < H; E++)
          this.buffer[this.leftover + E] = T[q + E];
        this.leftover += H;
      }
    };
    function te(T, q, H, E, Y, le) {
      var de = new pe(le);
      return de.update(H, E, Y), de.finish(T, q), 0;
    }
    function F(T, q, H, E, Y, le) {
      var de = new Uint8Array(16);
      return te(de, 0, H, E, Y, le), w(T, q, de, 0);
    }
    function v(T, q, H, E, Y) {
      var le;
      if (H < 32)
        return -1;
      for (ye(T, 0, q, 0, H, E, Y), te(T, 16, T, 32, H - 32, T), le = 0; le < 16; le++)
        T[le] = 0;
      return 0;
    }
    function B(T, q, H, E, Y) {
      var le, de = new Uint8Array(32);
      if (H < 32 || (ae(de, 0, 32, E, Y), F(q, 16, q, 32, H - 32, de) !== 0))
        return -1;
      for (ye(T, 0, q, 0, H, E, Y), le = 0; le < 32; le++)
        T[le] = 0;
      return 0;
    }
    function P(T, q) {
      var H;
      for (H = 0; H < 16; H++)
        T[H] = q[H] | 0;
    }
    function L(T) {
      var q, H, E = 1;
      for (q = 0; q < 16; q++)
        H = T[q] + E + 65535, E = Math.floor(H / 65536), T[q] = H - E * 65536;
      T[0] += E - 1 + 37 * (E - 1);
    }
    function x(T, q, H) {
      for (var E, Y = ~(H - 1), le = 0; le < 16; le++)
        E = Y & (T[le] ^ q[le]), T[le] ^= E, q[le] ^= E;
    }
    function C(T, q) {
      var H, E, Y, le = r(), de = r();
      for (H = 0; H < 16; H++)
        de[H] = q[H];
      for (L(de), L(de), L(de), E = 0; E < 2; E++) {
        for (le[0] = de[0] - 65517, H = 1; H < 15; H++)
          le[H] = de[H] - 65535 - (le[H - 1] >> 16 & 1), le[H - 1] &= 65535;
        le[15] = de[15] - 32767 - (le[14] >> 16 & 1), Y = le[15] >> 16 & 1, le[14] &= 65535, x(de, le, 1 - Y);
      }
      for (H = 0; H < 16; H++)
        T[2 * H] = de[H] & 255, T[2 * H + 1] = de[H] >> 8;
    }
    function j(T, q) {
      var H = new Uint8Array(32), E = new Uint8Array(32);
      return C(H, T), C(E, q), A(H, 0, E, 0);
    }
    function k(T) {
      var q = new Uint8Array(32);
      return C(q, T), q[0] & 1;
    }
    function g(T, q) {
      var H;
      for (H = 0; H < 16; H++)
        T[H] = q[2 * H] + (q[2 * H + 1] << 8);
      T[15] &= 32767;
    }
    function R(T, q, H) {
      for (var E = 0; E < 16; E++)
        T[E] = q[E] + H[E];
    }
    function X(T, q, H) {
      for (var E = 0; E < 16; E++)
        T[E] = q[E] - H[E];
    }
    function re(T, q, H) {
      var E, Y, le = 0, de = 0, xe = 0, Re = 0, Fe = 0, ke = 0, Pt = 0, ze = 0, ct = 0, dt = 0, vt = 0, gt = 0, lt = 0, pt = 0, ht = 0, We = 0, Xe = 0, qe = 0, He = 0, Ge = 0, De = 0, ve = 0, me = 0, Me = 0, Ae = 0, Be = 0, Oe = 0, st = 0, xt = 0, St = 0, _t = 0, ne = H[0], Tt = H[1], Ht = H[2], Gt = H[3], Bt = H[4], $t = H[5], qt = H[6], Sr = H[7], nr = H[8], wr = H[9], xr = H[10], _r = H[11], Rr = H[12], Hr = H[13], Gr = H[14], Vr = H[15];
      E = q[0], le += E * ne, de += E * Tt, xe += E * Ht, Re += E * Gt, Fe += E * Bt, ke += E * $t, Pt += E * qt, ze += E * Sr, ct += E * nr, dt += E * wr, vt += E * xr, gt += E * _r, lt += E * Rr, pt += E * Hr, ht += E * Gr, We += E * Vr, E = q[1], de += E * ne, xe += E * Tt, Re += E * Ht, Fe += E * Gt, ke += E * Bt, Pt += E * $t, ze += E * qt, ct += E * Sr, dt += E * nr, vt += E * wr, gt += E * xr, lt += E * _r, pt += E * Rr, ht += E * Hr, We += E * Gr, Xe += E * Vr, E = q[2], xe += E * ne, Re += E * Tt, Fe += E * Ht, ke += E * Gt, Pt += E * Bt, ze += E * $t, ct += E * qt, dt += E * Sr, vt += E * nr, gt += E * wr, lt += E * xr, pt += E * _r, ht += E * Rr, We += E * Hr, Xe += E * Gr, qe += E * Vr, E = q[3], Re += E * ne, Fe += E * Tt, ke += E * Ht, Pt += E * Gt, ze += E * Bt, ct += E * $t, dt += E * qt, vt += E * Sr, gt += E * nr, lt += E * wr, pt += E * xr, ht += E * _r, We += E * Rr, Xe += E * Hr, qe += E * Gr, He += E * Vr, E = q[4], Fe += E * ne, ke += E * Tt, Pt += E * Ht, ze += E * Gt, ct += E * Bt, dt += E * $t, vt += E * qt, gt += E * Sr, lt += E * nr, pt += E * wr, ht += E * xr, We += E * _r, Xe += E * Rr, qe += E * Hr, He += E * Gr, Ge += E * Vr, E = q[5], ke += E * ne, Pt += E * Tt, ze += E * Ht, ct += E * Gt, dt += E * Bt, vt += E * $t, gt += E * qt, lt += E * Sr, pt += E * nr, ht += E * wr, We += E * xr, Xe += E * _r, qe += E * Rr, He += E * Hr, Ge += E * Gr, De += E * Vr, E = q[6], Pt += E * ne, ze += E * Tt, ct += E * Ht, dt += E * Gt, vt += E * Bt, gt += E * $t, lt += E * qt, pt += E * Sr, ht += E * nr, We += E * wr, Xe += E * xr, qe += E * _r, He += E * Rr, Ge += E * Hr, De += E * Gr, ve += E * Vr, E = q[7], ze += E * ne, ct += E * Tt, dt += E * Ht, vt += E * Gt, gt += E * Bt, lt += E * $t, pt += E * qt, ht += E * Sr, We += E * nr, Xe += E * wr, qe += E * xr, He += E * _r, Ge += E * Rr, De += E * Hr, ve += E * Gr, me += E * Vr, E = q[8], ct += E * ne, dt += E * Tt, vt += E * Ht, gt += E * Gt, lt += E * Bt, pt += E * $t, ht += E * qt, We += E * Sr, Xe += E * nr, qe += E * wr, He += E * xr, Ge += E * _r, De += E * Rr, ve += E * Hr, me += E * Gr, Me += E * Vr, E = q[9], dt += E * ne, vt += E * Tt, gt += E * Ht, lt += E * Gt, pt += E * Bt, ht += E * $t, We += E * qt, Xe += E * Sr, qe += E * nr, He += E * wr, Ge += E * xr, De += E * _r, ve += E * Rr, me += E * Hr, Me += E * Gr, Ae += E * Vr, E = q[10], vt += E * ne, gt += E * Tt, lt += E * Ht, pt += E * Gt, ht += E * Bt, We += E * $t, Xe += E * qt, qe += E * Sr, He += E * nr, Ge += E * wr, De += E * xr, ve += E * _r, me += E * Rr, Me += E * Hr, Ae += E * Gr, Be += E * Vr, E = q[11], gt += E * ne, lt += E * Tt, pt += E * Ht, ht += E * Gt, We += E * Bt, Xe += E * $t, qe += E * qt, He += E * Sr, Ge += E * nr, De += E * wr, ve += E * xr, me += E * _r, Me += E * Rr, Ae += E * Hr, Be += E * Gr, Oe += E * Vr, E = q[12], lt += E * ne, pt += E * Tt, ht += E * Ht, We += E * Gt, Xe += E * Bt, qe += E * $t, He += E * qt, Ge += E * Sr, De += E * nr, ve += E * wr, me += E * xr, Me += E * _r, Ae += E * Rr, Be += E * Hr, Oe += E * Gr, st += E * Vr, E = q[13], pt += E * ne, ht += E * Tt, We += E * Ht, Xe += E * Gt, qe += E * Bt, He += E * $t, Ge += E * qt, De += E * Sr, ve += E * nr, me += E * wr, Me += E * xr, Ae += E * _r, Be += E * Rr, Oe += E * Hr, st += E * Gr, xt += E * Vr, E = q[14], ht += E * ne, We += E * Tt, Xe += E * Ht, qe += E * Gt, He += E * Bt, Ge += E * $t, De += E * qt, ve += E * Sr, me += E * nr, Me += E * wr, Ae += E * xr, Be += E * _r, Oe += E * Rr, st += E * Hr, xt += E * Gr, St += E * Vr, E = q[15], We += E * ne, Xe += E * Tt, qe += E * Ht, He += E * Gt, Ge += E * Bt, De += E * $t, ve += E * qt, me += E * Sr, Me += E * nr, Ae += E * wr, Be += E * xr, Oe += E * _r, st += E * Rr, xt += E * Hr, St += E * Gr, _t += E * Vr, le += 38 * Xe, de += 38 * qe, xe += 38 * He, Re += 38 * Ge, Fe += 38 * De, ke += 38 * ve, Pt += 38 * me, ze += 38 * Me, ct += 38 * Ae, dt += 38 * Be, vt += 38 * Oe, gt += 38 * st, lt += 38 * xt, pt += 38 * St, ht += 38 * _t, Y = 1, E = le + Y + 65535, Y = Math.floor(E / 65536), le = E - Y * 65536, E = de + Y + 65535, Y = Math.floor(E / 65536), de = E - Y * 65536, E = xe + Y + 65535, Y = Math.floor(E / 65536), xe = E - Y * 65536, E = Re + Y + 65535, Y = Math.floor(E / 65536), Re = E - Y * 65536, E = Fe + Y + 65535, Y = Math.floor(E / 65536), Fe = E - Y * 65536, E = ke + Y + 65535, Y = Math.floor(E / 65536), ke = E - Y * 65536, E = Pt + Y + 65535, Y = Math.floor(E / 65536), Pt = E - Y * 65536, E = ze + Y + 65535, Y = Math.floor(E / 65536), ze = E - Y * 65536, E = ct + Y + 65535, Y = Math.floor(E / 65536), ct = E - Y * 65536, E = dt + Y + 65535, Y = Math.floor(E / 65536), dt = E - Y * 65536, E = vt + Y + 65535, Y = Math.floor(E / 65536), vt = E - Y * 65536, E = gt + Y + 65535, Y = Math.floor(E / 65536), gt = E - Y * 65536, E = lt + Y + 65535, Y = Math.floor(E / 65536), lt = E - Y * 65536, E = pt + Y + 65535, Y = Math.floor(E / 65536), pt = E - Y * 65536, E = ht + Y + 65535, Y = Math.floor(E / 65536), ht = E - Y * 65536, E = We + Y + 65535, Y = Math.floor(E / 65536), We = E - Y * 65536, le += Y - 1 + 37 * (Y - 1), Y = 1, E = le + Y + 65535, Y = Math.floor(E / 65536), le = E - Y * 65536, E = de + Y + 65535, Y = Math.floor(E / 65536), de = E - Y * 65536, E = xe + Y + 65535, Y = Math.floor(E / 65536), xe = E - Y * 65536, E = Re + Y + 65535, Y = Math.floor(E / 65536), Re = E - Y * 65536, E = Fe + Y + 65535, Y = Math.floor(E / 65536), Fe = E - Y * 65536, E = ke + Y + 65535, Y = Math.floor(E / 65536), ke = E - Y * 65536, E = Pt + Y + 65535, Y = Math.floor(E / 65536), Pt = E - Y * 65536, E = ze + Y + 65535, Y = Math.floor(E / 65536), ze = E - Y * 65536, E = ct + Y + 65535, Y = Math.floor(E / 65536), ct = E - Y * 65536, E = dt + Y + 65535, Y = Math.floor(E / 65536), dt = E - Y * 65536, E = vt + Y + 65535, Y = Math.floor(E / 65536), vt = E - Y * 65536, E = gt + Y + 65535, Y = Math.floor(E / 65536), gt = E - Y * 65536, E = lt + Y + 65535, Y = Math.floor(E / 65536), lt = E - Y * 65536, E = pt + Y + 65535, Y = Math.floor(E / 65536), pt = E - Y * 65536, E = ht + Y + 65535, Y = Math.floor(E / 65536), ht = E - Y * 65536, E = We + Y + 65535, Y = Math.floor(E / 65536), We = E - Y * 65536, le += Y - 1 + 37 * (Y - 1), T[0] = le, T[1] = de, T[2] = xe, T[3] = Re, T[4] = Fe, T[5] = ke, T[6] = Pt, T[7] = ze, T[8] = ct, T[9] = dt, T[10] = vt, T[11] = gt, T[12] = lt, T[13] = pt, T[14] = ht, T[15] = We;
    }
    function V(T, q) {
      re(T, q, q);
    }
    function $(T, q) {
      var H = r(), E;
      for (E = 0; E < 16; E++)
        H[E] = q[E];
      for (E = 253; E >= 0; E--)
        V(H, H), E !== 2 && E !== 4 && re(H, H, q);
      for (E = 0; E < 16; E++)
        T[E] = H[E];
    }
    function W(T, q) {
      var H = r(), E;
      for (E = 0; E < 16; E++)
        H[E] = q[E];
      for (E = 250; E >= 0; E--)
        V(H, H), E !== 1 && re(H, H, q);
      for (E = 0; E < 16; E++)
        T[E] = H[E];
    }
    function Z(T, q, H) {
      var E = new Uint8Array(32), Y = new Float64Array(80), le, de, xe = r(), Re = r(), Fe = r(), ke = r(), Pt = r(), ze = r();
      for (de = 0; de < 31; de++)
        E[de] = q[de];
      for (E[31] = q[31] & 127 | 64, E[0] &= 248, g(Y, H), de = 0; de < 16; de++)
        Re[de] = Y[de], ke[de] = xe[de] = Fe[de] = 0;
      for (xe[0] = ke[0] = 1, de = 254; de >= 0; --de)
        le = E[de >>> 3] >>> (de & 7) & 1, x(xe, Re, le), x(Fe, ke, le), R(Pt, xe, Fe), X(xe, xe, Fe), R(Fe, Re, ke), X(Re, Re, ke), V(ke, Pt), V(ze, xe), re(xe, Fe, xe), re(Fe, Re, Pt), R(Pt, xe, Fe), X(xe, xe, Fe), V(Re, xe), X(Fe, ke, ze), re(xe, Fe, f), R(xe, xe, ke), re(Fe, Fe, xe), re(xe, ke, ze), re(ke, Re, Y), V(Re, Pt), x(xe, Re, le), x(Fe, ke, le);
      for (de = 0; de < 16; de++)
        Y[de + 16] = xe[de], Y[de + 32] = Fe[de], Y[de + 48] = Re[de], Y[de + 64] = ke[de];
      var ct = Y.subarray(32), dt = Y.subarray(16);
      return $(ct, ct), re(dt, dt, ct), C(T, dt), 0;
    }
    function fe(T, q) {
      return Z(T, q, o);
    }
    function D(T, q) {
      return n(q, 32), fe(T, q);
    }
    function K(T, q, H) {
      var E = new Uint8Array(32);
      return Z(E, H, q), z(T, i, E, J);
    }
    var he = v, be = B;
    function Ce(T, q, H, E, Y, le) {
      var de = new Uint8Array(32);
      return K(de, Y, le), he(T, q, H, E, de);
    }
    function je(T, q, H, E, Y, le) {
      var de = new Uint8Array(32);
      return K(de, Y, le), be(T, q, H, E, de);
    }
    var Ue = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function Qe(T, q, H, E) {
      for (var Y = new Int32Array(16), le = new Int32Array(16), de, xe, Re, Fe, ke, Pt, ze, ct, dt, vt, gt, lt, pt, ht, We, Xe, qe, He, Ge, De, ve, me, Me, Ae, Be, Oe, st = T[0], xt = T[1], St = T[2], _t = T[3], ne = T[4], Tt = T[5], Ht = T[6], Gt = T[7], Bt = q[0], $t = q[1], qt = q[2], Sr = q[3], nr = q[4], wr = q[5], xr = q[6], _r = q[7], Rr = 0; E >= 128; ) {
        for (Ge = 0; Ge < 16; Ge++)
          De = 8 * Ge + Rr, Y[Ge] = H[De + 0] << 24 | H[De + 1] << 16 | H[De + 2] << 8 | H[De + 3], le[Ge] = H[De + 4] << 24 | H[De + 5] << 16 | H[De + 6] << 8 | H[De + 7];
        for (Ge = 0; Ge < 80; Ge++)
          if (de = st, xe = xt, Re = St, Fe = _t, ke = ne, Pt = Tt, ze = Ht, ct = Gt, dt = Bt, vt = $t, gt = qt, lt = Sr, pt = nr, ht = wr, We = xr, Xe = _r, ve = Gt, me = _r, Me = me & 65535, Ae = me >>> 16, Be = ve & 65535, Oe = ve >>> 16, ve = (ne >>> 14 | nr << 18) ^ (ne >>> 18 | nr << 14) ^ (nr >>> 9 | ne << 23), me = (nr >>> 14 | ne << 18) ^ (nr >>> 18 | ne << 14) ^ (ne >>> 9 | nr << 23), Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, ve = ne & Tt ^ ~ne & Ht, me = nr & wr ^ ~nr & xr, Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, ve = Ue[Ge * 2], me = Ue[Ge * 2 + 1], Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, ve = Y[Ge % 16], me = le[Ge % 16], Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, Ae += Me >>> 16, Be += Ae >>> 16, Oe += Be >>> 16, qe = Be & 65535 | Oe << 16, He = Me & 65535 | Ae << 16, ve = qe, me = He, Me = me & 65535, Ae = me >>> 16, Be = ve & 65535, Oe = ve >>> 16, ve = (st >>> 28 | Bt << 4) ^ (Bt >>> 2 | st << 30) ^ (Bt >>> 7 | st << 25), me = (Bt >>> 28 | st << 4) ^ (st >>> 2 | Bt << 30) ^ (st >>> 7 | Bt << 25), Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, ve = st & xt ^ st & St ^ xt & St, me = Bt & $t ^ Bt & qt ^ $t & qt, Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, Ae += Me >>> 16, Be += Ae >>> 16, Oe += Be >>> 16, ct = Be & 65535 | Oe << 16, Xe = Me & 65535 | Ae << 16, ve = Fe, me = lt, Me = me & 65535, Ae = me >>> 16, Be = ve & 65535, Oe = ve >>> 16, ve = qe, me = He, Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, Ae += Me >>> 16, Be += Ae >>> 16, Oe += Be >>> 16, Fe = Be & 65535 | Oe << 16, lt = Me & 65535 | Ae << 16, xt = de, St = xe, _t = Re, ne = Fe, Tt = ke, Ht = Pt, Gt = ze, st = ct, $t = dt, qt = vt, Sr = gt, nr = lt, wr = pt, xr = ht, _r = We, Bt = Xe, Ge % 16 === 15)
            for (De = 0; De < 16; De++)
              ve = Y[De], me = le[De], Me = me & 65535, Ae = me >>> 16, Be = ve & 65535, Oe = ve >>> 16, ve = Y[(De + 9) % 16], me = le[(De + 9) % 16], Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, qe = Y[(De + 1) % 16], He = le[(De + 1) % 16], ve = (qe >>> 1 | He << 31) ^ (qe >>> 8 | He << 24) ^ qe >>> 7, me = (He >>> 1 | qe << 31) ^ (He >>> 8 | qe << 24) ^ (He >>> 7 | qe << 25), Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, qe = Y[(De + 14) % 16], He = le[(De + 14) % 16], ve = (qe >>> 19 | He << 13) ^ (He >>> 29 | qe << 3) ^ qe >>> 6, me = (He >>> 19 | qe << 13) ^ (qe >>> 29 | He << 3) ^ (He >>> 6 | qe << 26), Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, Ae += Me >>> 16, Be += Ae >>> 16, Oe += Be >>> 16, Y[De] = Be & 65535 | Oe << 16, le[De] = Me & 65535 | Ae << 16;
        ve = st, me = Bt, Me = me & 65535, Ae = me >>> 16, Be = ve & 65535, Oe = ve >>> 16, ve = T[0], me = q[0], Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, Ae += Me >>> 16, Be += Ae >>> 16, Oe += Be >>> 16, T[0] = st = Be & 65535 | Oe << 16, q[0] = Bt = Me & 65535 | Ae << 16, ve = xt, me = $t, Me = me & 65535, Ae = me >>> 16, Be = ve & 65535, Oe = ve >>> 16, ve = T[1], me = q[1], Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, Ae += Me >>> 16, Be += Ae >>> 16, Oe += Be >>> 16, T[1] = xt = Be & 65535 | Oe << 16, q[1] = $t = Me & 65535 | Ae << 16, ve = St, me = qt, Me = me & 65535, Ae = me >>> 16, Be = ve & 65535, Oe = ve >>> 16, ve = T[2], me = q[2], Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, Ae += Me >>> 16, Be += Ae >>> 16, Oe += Be >>> 16, T[2] = St = Be & 65535 | Oe << 16, q[2] = qt = Me & 65535 | Ae << 16, ve = _t, me = Sr, Me = me & 65535, Ae = me >>> 16, Be = ve & 65535, Oe = ve >>> 16, ve = T[3], me = q[3], Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, Ae += Me >>> 16, Be += Ae >>> 16, Oe += Be >>> 16, T[3] = _t = Be & 65535 | Oe << 16, q[3] = Sr = Me & 65535 | Ae << 16, ve = ne, me = nr, Me = me & 65535, Ae = me >>> 16, Be = ve & 65535, Oe = ve >>> 16, ve = T[4], me = q[4], Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, Ae += Me >>> 16, Be += Ae >>> 16, Oe += Be >>> 16, T[4] = ne = Be & 65535 | Oe << 16, q[4] = nr = Me & 65535 | Ae << 16, ve = Tt, me = wr, Me = me & 65535, Ae = me >>> 16, Be = ve & 65535, Oe = ve >>> 16, ve = T[5], me = q[5], Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, Ae += Me >>> 16, Be += Ae >>> 16, Oe += Be >>> 16, T[5] = Tt = Be & 65535 | Oe << 16, q[5] = wr = Me & 65535 | Ae << 16, ve = Ht, me = xr, Me = me & 65535, Ae = me >>> 16, Be = ve & 65535, Oe = ve >>> 16, ve = T[6], me = q[6], Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, Ae += Me >>> 16, Be += Ae >>> 16, Oe += Be >>> 16, T[6] = Ht = Be & 65535 | Oe << 16, q[6] = xr = Me & 65535 | Ae << 16, ve = Gt, me = _r, Me = me & 65535, Ae = me >>> 16, Be = ve & 65535, Oe = ve >>> 16, ve = T[7], me = q[7], Me += me & 65535, Ae += me >>> 16, Be += ve & 65535, Oe += ve >>> 16, Ae += Me >>> 16, Be += Ae >>> 16, Oe += Be >>> 16, T[7] = Gt = Be & 65535 | Oe << 16, q[7] = _r = Me & 65535 | Ae << 16, Rr += 128, E -= 128;
      }
      return E;
    }
    function we(T, q, H) {
      var E = new Int32Array(8), Y = new Int32Array(8), le = new Uint8Array(256), de, xe = H;
      for (E[0] = 1779033703, E[1] = 3144134277, E[2] = 1013904242, E[3] = 2773480762, E[4] = 1359893119, E[5] = 2600822924, E[6] = 528734635, E[7] = 1541459225, Y[0] = 4089235720, Y[1] = 2227873595, Y[2] = 4271175723, Y[3] = 1595750129, Y[4] = 2917565137, Y[5] = 725511199, Y[6] = 4215389547, Y[7] = 327033209, Qe(E, Y, q, H), H %= 128, de = 0; de < H; de++)
        le[de] = q[xe - H + de];
      for (le[H] = 128, H = 256 - 128 * (H < 112 ? 1 : 0), le[H - 9] = 0, y(le, H - 8, xe / 536870912 | 0, xe << 3), Qe(E, Y, le, H), de = 0; de < 8; de++)
        y(T, 8 * de, E[de], Y[de]);
      return 0;
    }
    function at(T, q) {
      var H = r(), E = r(), Y = r(), le = r(), de = r(), xe = r(), Re = r(), Fe = r(), ke = r();
      X(H, T[1], T[0]), X(ke, q[1], q[0]), re(H, H, ke), R(E, T[0], T[1]), R(ke, q[0], q[1]), re(E, E, ke), re(Y, T[3], q[3]), re(Y, Y, c), re(le, T[2], q[2]), R(le, le, le), X(de, E, H), X(xe, le, Y), R(Re, le, Y), R(Fe, E, H), re(T[0], de, xe), re(T[1], Fe, Re), re(T[2], Re, xe), re(T[3], de, Fe);
    }
    function rt(T, q, H) {
      var E;
      for (E = 0; E < 4; E++)
        x(T[E], q[E], H);
    }
    function It(T, q) {
      var H = r(), E = r(), Y = r();
      $(Y, q[2]), re(H, q[0], Y), re(E, q[1], Y), C(T, E), T[31] ^= k(H) << 7;
    }
    function it(T, q, H) {
      var E, Y;
      for (P(T[0], a), P(T[1], s), P(T[2], s), P(T[3], a), Y = 255; Y >= 0; --Y)
        E = H[Y / 8 | 0] >> (Y & 7) & 1, rt(T, q, E), at(q, T), at(T, T), rt(T, q, E);
    }
    function se(T, q) {
      var H = [r(), r(), r(), r()];
      P(H[0], d), P(H[1], l), P(H[2], s), re(H[3], d, l), it(T, H, q);
    }
    function ue(T, q, H) {
      var E = new Uint8Array(64), Y = [r(), r(), r(), r()], le;
      for (H || n(q, 32), we(E, q, 32), E[0] &= 248, E[31] &= 127, E[31] |= 64, se(Y, E), It(T, Y), le = 0; le < 32; le++)
        q[le + 32] = T[le];
      return 0;
    }
    var Ee = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function U(T, q) {
      var H, E, Y, le;
      for (E = 63; E >= 32; --E) {
        for (H = 0, Y = E - 32, le = E - 12; Y < le; ++Y)
          q[Y] += H - 16 * q[E] * Ee[Y - (E - 32)], H = Math.floor((q[Y] + 128) / 256), q[Y] -= H * 256;
        q[Y] += H, q[E] = 0;
      }
      for (H = 0, Y = 0; Y < 32; Y++)
        q[Y] += H - (q[31] >> 4) * Ee[Y], H = q[Y] >> 8, q[Y] &= 255;
      for (Y = 0; Y < 32; Y++)
        q[Y] -= H * Ee[Y];
      for (E = 0; E < 32; E++)
        q[E + 1] += q[E] >> 8, T[E] = q[E] & 255;
    }
    function S(T) {
      var q = new Float64Array(64), H;
      for (H = 0; H < 64; H++)
        q[H] = T[H];
      for (H = 0; H < 64; H++)
        T[H] = 0;
      U(T, q);
    }
    function I(T, q, H, E) {
      var Y = new Uint8Array(64), le = new Uint8Array(64), de = new Uint8Array(64), xe, Re, Fe = new Float64Array(64), ke = [r(), r(), r(), r()];
      we(Y, E, 32), Y[0] &= 248, Y[31] &= 127, Y[31] |= 64;
      var Pt = H + 64;
      for (xe = 0; xe < H; xe++)
        T[64 + xe] = q[xe];
      for (xe = 0; xe < 32; xe++)
        T[32 + xe] = Y[32 + xe];
      for (we(de, T.subarray(32), H + 32), S(de), se(ke, de), It(T, ke), xe = 32; xe < 64; xe++)
        T[xe] = E[xe];
      for (we(le, T, H + 64), S(le), xe = 0; xe < 64; xe++)
        Fe[xe] = 0;
      for (xe = 0; xe < 32; xe++)
        Fe[xe] = de[xe];
      for (xe = 0; xe < 32; xe++)
        for (Re = 0; Re < 32; Re++)
          Fe[xe + Re] += le[xe] * Y[Re];
      return U(T.subarray(32), Fe), Pt;
    }
    function _(T, q) {
      var H = r(), E = r(), Y = r(), le = r(), de = r(), xe = r(), Re = r();
      return P(T[2], s), g(T[1], q), V(Y, T[1]), re(le, Y, u), X(Y, Y, T[2]), R(le, T[2], le), V(de, le), V(xe, de), re(Re, xe, de), re(H, Re, Y), re(H, H, le), W(H, H), re(H, H, Y), re(H, H, le), re(H, H, le), re(T[0], H, le), V(E, T[0]), re(E, E, le), j(E, Y) && re(T[0], T[0], h), V(E, T[0]), re(E, E, le), j(E, Y) ? -1 : (k(T[0]) === q[31] >> 7 && X(T[0], a, T[0]), re(T[3], T[0], T[1]), 0);
    }
    function p(T, q, H, E) {
      var Y, le = new Uint8Array(32), de = new Uint8Array(64), xe = [r(), r(), r(), r()], Re = [r(), r(), r(), r()];
      if (H < 64 || _(Re, E))
        return -1;
      for (Y = 0; Y < H; Y++)
        T[Y] = q[Y];
      for (Y = 0; Y < 32; Y++)
        T[Y + 32] = E[Y];
      if (we(de, T, H), S(de), it(xe, Re, de), se(Re, q.subarray(32)), at(xe, Re), It(le, xe), H -= 64, A(q, 0, le, 0)) {
        for (Y = 0; Y < H; Y++)
          T[Y] = 0;
        return -1;
      }
      for (Y = 0; Y < H; Y++)
        T[Y] = q[Y + 64];
      return H;
    }
    var m = 32, O = 24, Q = 32, ie = 16, ce = 32, Ne = 32, Te = 32, Je = 32, Dt = 32, nt = O, ur = Q, Mi = ie, Lt = 64, Wt = 32, pn = 64, tr = 32, rr = 64;
    e.lowlevel = {
      crypto_core_hsalsa20: z,
      crypto_stream_xor: ye,
      crypto_stream: ae,
      crypto_stream_salsa20_xor: oe,
      crypto_stream_salsa20: ee,
      crypto_onetimeauth: te,
      crypto_onetimeauth_verify: F,
      crypto_verify_16: w,
      crypto_verify_32: A,
      crypto_secretbox: v,
      crypto_secretbox_open: B,
      crypto_scalarmult: Z,
      crypto_scalarmult_base: fe,
      crypto_box_beforenm: K,
      crypto_box_afternm: he,
      crypto_box: Ce,
      crypto_box_open: je,
      crypto_box_keypair: D,
      crypto_hash: we,
      crypto_sign: I,
      crypto_sign_keypair: ue,
      crypto_sign_open: p,
      crypto_secretbox_KEYBYTES: m,
      crypto_secretbox_NONCEBYTES: O,
      crypto_secretbox_ZEROBYTES: Q,
      crypto_secretbox_BOXZEROBYTES: ie,
      crypto_scalarmult_BYTES: ce,
      crypto_scalarmult_SCALARBYTES: Ne,
      crypto_box_PUBLICKEYBYTES: Te,
      crypto_box_SECRETKEYBYTES: Je,
      crypto_box_BEFORENMBYTES: Dt,
      crypto_box_NONCEBYTES: nt,
      crypto_box_ZEROBYTES: ur,
      crypto_box_BOXZEROBYTES: Mi,
      crypto_sign_BYTES: Lt,
      crypto_sign_PUBLICKEYBYTES: Wt,
      crypto_sign_SECRETKEYBYTES: pn,
      crypto_sign_SEEDBYTES: tr,
      crypto_hash_BYTES: rr,
      gf: r,
      D: u,
      L: Ee,
      pack25519: C,
      unpack25519: g,
      M: re,
      A: R,
      S: V,
      Z: X,
      pow2523: W,
      add: at,
      set25519: P,
      modL: U,
      scalarmult: it,
      scalarbase: se
    };
    function fi(T, q) {
      if (T.length !== m)
        throw new Error("bad key size");
      if (q.length !== O)
        throw new Error("bad nonce size");
    }
    function dr(T, q) {
      if (T.length !== Te)
        throw new Error("bad public key size");
      if (q.length !== Je)
        throw new Error("bad secret key size");
    }
    function Rt() {
      for (var T = 0; T < arguments.length; T++)
        if (!(arguments[T] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function ci(T) {
      for (var q = 0; q < T.length; q++)
        T[q] = 0;
    }
    e.randomBytes = function(T) {
      var q = new Uint8Array(T);
      return n(q, T), q;
    }, e.secretbox = function(T, q, H) {
      Rt(T, q, H), fi(H, q);
      for (var E = new Uint8Array(Q + T.length), Y = new Uint8Array(E.length), le = 0; le < T.length; le++)
        E[le + Q] = T[le];
      return v(Y, E, E.length, q, H), Y.subarray(ie);
    }, e.secretbox.open = function(T, q, H) {
      Rt(T, q, H), fi(H, q);
      for (var E = new Uint8Array(ie + T.length), Y = new Uint8Array(E.length), le = 0; le < T.length; le++)
        E[le + ie] = T[le];
      return E.length < 32 || B(Y, E, E.length, q, H) !== 0 ? null : Y.subarray(Q);
    }, e.secretbox.keyLength = m, e.secretbox.nonceLength = O, e.secretbox.overheadLength = ie, e.scalarMult = function(T, q) {
      if (Rt(T, q), T.length !== Ne)
        throw new Error("bad n size");
      if (q.length !== ce)
        throw new Error("bad p size");
      var H = new Uint8Array(ce);
      return Z(H, T, q), H;
    }, e.scalarMult.base = function(T) {
      if (Rt(T), T.length !== Ne)
        throw new Error("bad n size");
      var q = new Uint8Array(ce);
      return fe(q, T), q;
    }, e.scalarMult.scalarLength = Ne, e.scalarMult.groupElementLength = ce, e.box = function(T, q, H, E) {
      var Y = e.box.before(H, E);
      return e.secretbox(T, q, Y);
    }, e.box.before = function(T, q) {
      Rt(T, q), dr(T, q);
      var H = new Uint8Array(Dt);
      return K(H, T, q), H;
    }, e.box.after = e.secretbox, e.box.open = function(T, q, H, E) {
      var Y = e.box.before(H, E);
      return e.secretbox.open(T, q, Y);
    }, e.box.open.after = e.secretbox.open, e.box.keyPair = function() {
      var T = new Uint8Array(Te), q = new Uint8Array(Je);
      return D(T, q), { publicKey: T, secretKey: q };
    }, e.box.keyPair.fromSecretKey = function(T) {
      if (Rt(T), T.length !== Je)
        throw new Error("bad secret key size");
      var q = new Uint8Array(Te);
      return fe(q, T), { publicKey: q, secretKey: new Uint8Array(T) };
    }, e.box.publicKeyLength = Te, e.box.secretKeyLength = Je, e.box.sharedKeyLength = Dt, e.box.nonceLength = nt, e.box.overheadLength = e.secretbox.overheadLength, e.sign = function(T, q) {
      if (Rt(T, q), q.length !== pn)
        throw new Error("bad secret key size");
      var H = new Uint8Array(Lt + T.length);
      return I(H, T, T.length, q), H;
    }, e.sign.open = function(T, q) {
      if (Rt(T, q), q.length !== Wt)
        throw new Error("bad public key size");
      var H = new Uint8Array(T.length), E = p(H, T, T.length, q);
      if (E < 0)
        return null;
      for (var Y = new Uint8Array(E), le = 0; le < Y.length; le++)
        Y[le] = H[le];
      return Y;
    }, e.sign.detached = function(T, q) {
      for (var H = e.sign(T, q), E = new Uint8Array(Lt), Y = 0; Y < E.length; Y++)
        E[Y] = H[Y];
      return E;
    }, e.sign.detached.verify = function(T, q, H) {
      if (Rt(T, q, H), q.length !== Lt)
        throw new Error("bad signature size");
      if (H.length !== Wt)
        throw new Error("bad public key size");
      var E = new Uint8Array(Lt + T.length), Y = new Uint8Array(Lt + T.length), le;
      for (le = 0; le < Lt; le++)
        E[le] = q[le];
      for (le = 0; le < T.length; le++)
        E[le + Lt] = T[le];
      return p(Y, E, E.length, H) >= 0;
    }, e.sign.keyPair = function() {
      var T = new Uint8Array(Wt), q = new Uint8Array(pn);
      return ue(T, q), { publicKey: T, secretKey: q };
    }, e.sign.keyPair.fromSecretKey = function(T) {
      if (Rt(T), T.length !== pn)
        throw new Error("bad secret key size");
      for (var q = new Uint8Array(Wt), H = 0; H < q.length; H++)
        q[H] = T[32 + H];
      return { publicKey: q, secretKey: new Uint8Array(T) };
    }, e.sign.keyPair.fromSeed = function(T) {
      if (Rt(T), T.length !== tr)
        throw new Error("bad seed size");
      for (var q = new Uint8Array(Wt), H = new Uint8Array(pn), E = 0; E < 32; E++)
        H[E] = T[E];
      return ue(q, H, !0), { publicKey: q, secretKey: H };
    }, e.sign.publicKeyLength = Wt, e.sign.secretKeyLength = pn, e.sign.seedLength = tr, e.sign.signatureLength = Lt, e.hash = function(T) {
      Rt(T);
      var q = new Uint8Array(rr);
      return we(q, T, T.length), q;
    }, e.hash.hashLength = rr, e.verify = function(T, q) {
      return Rt(T, q), T.length === 0 || q.length === 0 || T.length !== q.length ? !1 : b(T, 0, q, 0, T.length) === 0;
    }, e.setPRNG = function(T) {
      n = T;
    }, function() {
      var T = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (T && T.getRandomValues) {
        var q = 65536;
        e.setPRNG(function(H, E) {
          var Y, le = new Uint8Array(E);
          for (Y = 0; Y < E; Y += q)
            T.getRandomValues(le.subarray(Y, Y + Math.min(E - Y, q)));
          for (Y = 0; Y < E; Y++)
            H[Y] = le[Y];
          ci(le);
        });
      } else
        typeof F8 < "u" && (T = $p(), T && T.randomBytes && e.setPRNG(function(H, E) {
          var Y, le = T.randomBytes(E);
          for (Y = 0; Y < E; Y++)
            H[Y] = le[Y];
          ci(le);
        }));
    }();
  })(t.exports ? t.exports : self.nacl = self.nacl || {});
})(Mm);
var CE = Mm.exports;
const eo = /* @__PURE__ */ sn(CE);
var Xf = Et.Buffer;
function PE(t) {
  if (t.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var e = new Uint8Array(256), r = 0; r < e.length; r++)
    e[r] = 255;
  for (var n = 0; n < t.length; n++) {
    var i = t.charAt(n), o = i.charCodeAt(0);
    if (e[o] !== 255)
      throw new TypeError(i + " is ambiguous");
    e[o] = n;
  }
  var a = t.length, s = t.charAt(0), f = Math.log(a) / Math.log(256), u = Math.log(256) / Math.log(a);
  function c(h) {
    if ((Array.isArray(h) || h instanceof Uint8Array) && (h = Xf.from(h)), !Xf.isBuffer(h))
      throw new TypeError("Expected Buffer");
    if (h.length === 0)
      return "";
    for (var y = 0, b = 0, w = 0, A = h.length; w !== A && h[w] === 0; )
      w++, y++;
    for (var M = (A - w) * u + 1 >>> 0, N = new Uint8Array(M); w !== A; ) {
      for (var G = h[w], z = 0, J = M - 1; (G !== 0 || z < b) && J !== -1; J--, z++)
        G += 256 * N[J] >>> 0, N[J] = G % a >>> 0, G = G / a >>> 0;
      if (G !== 0)
        throw new Error("Non-zero carry");
      b = z, w++;
    }
    for (var oe = M - b; oe !== M && N[oe] === 0; )
      oe++;
    for (var ee = s.repeat(y); oe < M; ++oe)
      ee += t.charAt(N[oe]);
    return ee;
  }
  function d(h) {
    if (typeof h != "string")
      throw new TypeError("Expected String");
    if (h.length === 0)
      return Xf.alloc(0);
    for (var y = 0, b = 0, w = 0; h[y] === s; )
      b++, y++;
    for (var A = (h.length - y) * f + 1 >>> 0, M = new Uint8Array(A); h[y]; ) {
      var N = e[h.charCodeAt(y)];
      if (N === 255)
        return;
      for (var G = 0, z = A - 1; (N !== 0 || G < w) && z !== -1; z--, G++)
        N += a * M[z] >>> 0, M[z] = N % 256 >>> 0, N = N / 256 >>> 0;
      if (N !== 0)
        throw new Error("Non-zero carry");
      w = G, y++;
    }
    for (var J = A - w; J !== A && M[J] === 0; )
      J++;
    var oe = Xf.allocUnsafe(b + (A - J));
    oe.fill(0, 0, b);
    for (var ee = b; J !== A; )
      oe[ee++] = M[J++];
    return oe;
  }
  function l(h) {
    var y = d(h);
    if (y)
      return y;
    throw new Error("Non-base" + a + " character");
  }
  return {
    encode: c,
    decodeUnsafe: d,
    decode: l
  };
}
var NE = PE, UE = NE, FE = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", qp = UE(FE);
const fr = /* @__PURE__ */ sn(qp);
var zr = {};
function Oi(t, e, r) {
  return e <= t && t <= r;
}
function Qu(t) {
  if (t === void 0)
    return {};
  if (t === Object(t))
    return t;
  throw TypeError("Could not convert argument to dictionary");
}
function LE(t) {
  for (var e = String(t), r = e.length, n = 0, i = []; n < r; ) {
    var o = e.charCodeAt(n);
    if (o < 55296 || o > 57343)
      i.push(o);
    else if (56320 <= o && o <= 57343)
      i.push(65533);
    else if (55296 <= o && o <= 56319)
      if (n === r - 1)
        i.push(65533);
      else {
        var a = t.charCodeAt(n + 1);
        if (56320 <= a && a <= 57343) {
          var s = o & 1023, f = a & 1023;
          i.push(65536 + (s << 10) + f), n += 1;
        } else
          i.push(65533);
      }
    n += 1;
  }
  return i;
}
function jE(t) {
  for (var e = "", r = 0; r < t.length; ++r) {
    var n = t[r];
    n <= 65535 ? e += String.fromCharCode(n) : (n -= 65536, e += String.fromCharCode(
      (n >> 10) + 55296,
      (n & 1023) + 56320
    ));
  }
  return e;
}
var Cc = -1;
function zp(t) {
  this.tokens = [].slice.call(t);
}
zp.prototype = {
  /**
   * @return {boolean} True if end-of-stream has been hit.
   */
  endOfStream: function() {
    return !this.tokens.length;
  },
  /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */
  read: function() {
    return this.tokens.length ? this.tokens.shift() : Cc;
  },
  /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */
  prepend: function(t) {
    if (Array.isArray(t))
      for (var e = (
        /**@type {!Array.<number>}*/
        t
      ); e.length; )
        this.tokens.unshift(e.pop());
    else
      this.tokens.unshift(t);
  },
  /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */
  push: function(t) {
    if (Array.isArray(t))
      for (var e = (
        /**@type {!Array.<number>}*/
        t
      ); e.length; )
        this.tokens.push(e.shift());
    else
      this.tokens.push(t);
  }
};
var $a = -1;
function yh(t, e) {
  if (t)
    throw TypeError("Decoder error");
  return e || 65533;
}
var Pc = "utf-8";
function Nc(t, e) {
  if (!(this instanceof Nc))
    return new Nc(t, e);
  if (t = t !== void 0 ? String(t).toLowerCase() : Pc, t !== Pc)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  e = Qu(e), this._streaming = !1, this._BOMseen = !1, this._decoder = null, this._fatal = !!e.fatal, this._ignoreBOM = !!e.ignoreBOM, Object.defineProperty(this, "encoding", { value: "utf-8" }), Object.defineProperty(this, "fatal", { value: this._fatal }), Object.defineProperty(this, "ignoreBOM", { value: this._ignoreBOM });
}
Nc.prototype = {
  /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */
  decode: function(e, r) {
    var n;
    typeof e == "object" && e instanceof ArrayBuffer ? n = new Uint8Array(e) : typeof e == "object" && "buffer" in e && e.buffer instanceof ArrayBuffer ? n = new Uint8Array(
      e.buffer,
      e.byteOffset,
      e.byteLength
    ) : n = new Uint8Array(0), r = Qu(r), this._streaming || (this._decoder = new DE({ fatal: this._fatal }), this._BOMseen = !1), this._streaming = !!r.stream;
    for (var i = new zp(n), o = [], a; !i.endOfStream() && (a = this._decoder.handler(i, i.read()), a !== $a); )
      a !== null && (Array.isArray(a) ? o.push.apply(
        o,
        /**@type {!Array.<number>}*/
        a
      ) : o.push(a));
    if (!this._streaming) {
      do {
        if (a = this._decoder.handler(i, i.read()), a === $a)
          break;
        a !== null && (Array.isArray(a) ? o.push.apply(
          o,
          /**@type {!Array.<number>}*/
          a
        ) : o.push(a));
      } while (!i.endOfStream());
      this._decoder = null;
    }
    return o.length && ["utf-8"].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen && (o[0] === 65279 ? (this._BOMseen = !0, o.shift()) : this._BOMseen = !0), jE(o);
  }
};
function Uc(t, e) {
  if (!(this instanceof Uc))
    return new Uc(t, e);
  if (t = t !== void 0 ? String(t).toLowerCase() : Pc, t !== Pc)
    throw new Error("Encoding not supported. Only utf-8 is supported");
  e = Qu(e), this._streaming = !1, this._encoder = null, this._options = { fatal: !!e.fatal }, Object.defineProperty(this, "encoding", { value: "utf-8" });
}
Uc.prototype = {
  /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */
  encode: function(e, r) {
    e = e ? String(e) : "", r = Qu(r), this._streaming || (this._encoder = new $E(this._options)), this._streaming = !!r.stream;
    for (var n = [], i = new zp(LE(e)), o; !i.endOfStream() && (o = this._encoder.handler(i, i.read()), o !== $a); )
      Array.isArray(o) ? n.push.apply(
        n,
        /**@type {!Array.<number>}*/
        o
      ) : n.push(o);
    if (!this._streaming) {
      for (; o = this._encoder.handler(i, i.read()), o !== $a; )
        Array.isArray(o) ? n.push.apply(
          n,
          /**@type {!Array.<number>}*/
          o
        ) : n.push(o);
      this._encoder = null;
    }
    return new Uint8Array(n);
  }
};
function DE(t) {
  var e = t.fatal, r = 0, n = 0, i = 0, o = 128, a = 191;
  this.handler = function(s, f) {
    if (f === Cc && i !== 0)
      return i = 0, yh(e);
    if (f === Cc)
      return $a;
    if (i === 0) {
      if (Oi(f, 0, 127))
        return f;
      if (Oi(f, 194, 223))
        i = 1, r = f - 192;
      else if (Oi(f, 224, 239))
        f === 224 && (o = 160), f === 237 && (a = 159), i = 2, r = f - 224;
      else if (Oi(f, 240, 244))
        f === 240 && (o = 144), f === 244 && (a = 143), i = 3, r = f - 240;
      else
        return yh(e);
      return r = r << 6 * i, null;
    }
    if (!Oi(f, o, a))
      return r = i = n = 0, o = 128, a = 191, s.prepend(f), yh(e);
    if (o = 128, a = 191, n += 1, r += f - 128 << 6 * (i - n), n !== i)
      return null;
    var u = r;
    return r = i = n = 0, u;
  };
}
function $E(t) {
  t.fatal, this.handler = function(e, r) {
    if (r === Cc)
      return $a;
    if (Oi(r, 0, 127))
      return r;
    var n, i;
    Oi(r, 128, 2047) ? (n = 1, i = 192) : Oi(r, 2048, 65535) ? (n = 2, i = 224) : Oi(r, 65536, 1114111) && (n = 3, i = 240);
    for (var o = [(r >> 6 * n) + i]; n > 0; ) {
      var a = r >> 6 * (n - 1);
      o.push(128 | a & 63), n -= 1;
    }
    return o;
  };
}
const qE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TextDecoder: Nc,
  TextEncoder: Uc
}, Symbol.toStringTag, { value: "Module" })), zE = /* @__PURE__ */ _f(qE);
var KE = yt && yt.__createBinding || (Object.create ? function(t, e, r, n) {
  n === void 0 && (n = r), Object.defineProperty(t, n, { enumerable: !0, get: function() {
    return e[r];
  } });
} : function(t, e, r, n) {
  n === void 0 && (n = r), t[n] = e[r];
}), WE = yt && yt.__setModuleDefault || (Object.create ? function(t, e) {
  Object.defineProperty(t, "default", { enumerable: !0, value: e });
} : function(t, e) {
  t.default = e;
}), Ei = yt && yt.__decorate || function(t, e, r, n) {
  var i = arguments.length, o = i < 3 ? e : n === null ? n = Object.getOwnPropertyDescriptor(e, r) : n, a;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(t, e, r, n);
  else
    for (var s = t.length - 1; s >= 0; s--)
      (a = t[s]) && (o = (i < 3 ? a(o) : i > 3 ? a(e, r, o) : a(e, r)) || o);
  return i > 3 && o && Object.defineProperty(e, r, o), o;
}, HE = yt && yt.__importStar || function(t) {
  if (t && t.__esModule)
    return t;
  var e = {};
  if (t != null)
    for (var r in t)
      r !== "default" && Object.hasOwnProperty.call(t, r) && KE(e, t, r);
  return WE(e, t), e;
}, j3 = yt && yt.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(zr, "__esModule", { value: !0 });
var Kp = zr.deserializeUnchecked = G3 = zr.deserialize = H3 = zr.serialize = z3 = zr.BinaryReader = q3 = zr.BinaryWriter = zr.BorshError = zr.baseDecode = zr.baseEncode = void 0;
const Gi = j3(mr), D3 = j3(qp), GE = HE(zE), VE = typeof TextDecoder != "function" ? GE.TextDecoder : TextDecoder, YE = new VE("utf-8", { fatal: !0 });
function JE(t) {
  return typeof t == "string" && (t = Ie.from(t, "utf8")), D3.default.encode(Ie.from(t));
}
zr.baseEncode = JE;
function XE(t) {
  return Ie.from(D3.default.decode(t));
}
zr.baseDecode = XE;
const bh = 1024;
class dn extends Error {
  constructor(e) {
    super(e), this.fieldPath = [], this.originalMessage = e;
  }
  addToFieldPath(e) {
    this.fieldPath.splice(0, 0, e), this.message = this.originalMessage + ": " + this.fieldPath.join(".");
  }
}
zr.BorshError = dn;
class $3 {
  constructor() {
    this.buf = Ie.alloc(bh), this.length = 0;
  }
  maybeResize() {
    this.buf.length < 16 + this.length && (this.buf = Ie.concat([this.buf, Ie.alloc(bh)]));
  }
  writeU8(e) {
    this.maybeResize(), this.buf.writeUInt8(e, this.length), this.length += 1;
  }
  writeU16(e) {
    this.maybeResize(), this.buf.writeUInt16LE(e, this.length), this.length += 2;
  }
  writeU32(e) {
    this.maybeResize(), this.buf.writeUInt32LE(e, this.length), this.length += 4;
  }
  writeU64(e) {
    this.maybeResize(), this.writeBuffer(Ie.from(new Gi.default(e).toArray("le", 8)));
  }
  writeU128(e) {
    this.maybeResize(), this.writeBuffer(Ie.from(new Gi.default(e).toArray("le", 16)));
  }
  writeU256(e) {
    this.maybeResize(), this.writeBuffer(Ie.from(new Gi.default(e).toArray("le", 32)));
  }
  writeU512(e) {
    this.maybeResize(), this.writeBuffer(Ie.from(new Gi.default(e).toArray("le", 64)));
  }
  writeBuffer(e) {
    this.buf = Ie.concat([
      Ie.from(this.buf.subarray(0, this.length)),
      e,
      Ie.alloc(bh)
    ]), this.length += e.length;
  }
  writeString(e) {
    this.maybeResize();
    const r = Ie.from(e, "utf8");
    this.writeU32(r.length), this.writeBuffer(r);
  }
  writeFixedArray(e) {
    this.writeBuffer(Ie.from(e));
  }
  writeArray(e, r) {
    this.maybeResize(), this.writeU32(e.length);
    for (const n of e)
      this.maybeResize(), r(n);
  }
  toArray() {
    return this.buf.subarray(0, this.length);
  }
}
var q3 = zr.BinaryWriter = $3;
function Si(t, e, r) {
  const n = r.value;
  r.value = function(...i) {
    try {
      return n.apply(this, i);
    } catch (o) {
      if (o instanceof RangeError) {
        const a = o.code;
        if (["ERR_BUFFER_OUT_OF_BOUNDS", "ERR_OUT_OF_RANGE"].indexOf(a) >= 0)
          throw new dn("Reached the end of buffer when deserializing");
      }
      throw o;
    }
  };
}
class kn {
  constructor(e) {
    this.buf = e, this.offset = 0;
  }
  readU8() {
    const e = this.buf.readUInt8(this.offset);
    return this.offset += 1, e;
  }
  readU16() {
    const e = this.buf.readUInt16LE(this.offset);
    return this.offset += 2, e;
  }
  readU32() {
    const e = this.buf.readUInt32LE(this.offset);
    return this.offset += 4, e;
  }
  readU64() {
    const e = this.readBuffer(8);
    return new Gi.default(e, "le");
  }
  readU128() {
    const e = this.readBuffer(16);
    return new Gi.default(e, "le");
  }
  readU256() {
    const e = this.readBuffer(32);
    return new Gi.default(e, "le");
  }
  readU512() {
    const e = this.readBuffer(64);
    return new Gi.default(e, "le");
  }
  readBuffer(e) {
    if (this.offset + e > this.buf.length)
      throw new dn(`Expected buffer length ${e} isn't within bounds`);
    const r = this.buf.slice(this.offset, this.offset + e);
    return this.offset += e, r;
  }
  readString() {
    const e = this.readU32(), r = this.readBuffer(e);
    try {
      return YE.decode(r);
    } catch (n) {
      throw new dn(`Error decoding UTF-8 string: ${n}`);
    }
  }
  readFixedArray(e) {
    return new Uint8Array(this.readBuffer(e));
  }
  readArray(e) {
    const r = this.readU32(), n = Array();
    for (let i = 0; i < r; ++i)
      n.push(e());
    return n;
  }
}
Ei([
  Si
], kn.prototype, "readU8", null);
Ei([
  Si
], kn.prototype, "readU16", null);
Ei([
  Si
], kn.prototype, "readU32", null);
Ei([
  Si
], kn.prototype, "readU64", null);
Ei([
  Si
], kn.prototype, "readU128", null);
Ei([
  Si
], kn.prototype, "readU256", null);
Ei([
  Si
], kn.prototype, "readU512", null);
Ei([
  Si
], kn.prototype, "readString", null);
Ei([
  Si
], kn.prototype, "readFixedArray", null);
Ei([
  Si
], kn.prototype, "readArray", null);
var z3 = zr.BinaryReader = kn;
function K3(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
function lo(t, e, r, n, i) {
  try {
    if (typeof n == "string")
      i[`write${K3(n)}`](r);
    else if (n instanceof Array)
      if (typeof n[0] == "number") {
        if (r.length !== n[0])
          throw new dn(`Expecting byte array of length ${n[0]}, but got ${r.length} bytes`);
        i.writeFixedArray(r);
      } else if (n.length === 2 && typeof n[1] == "number") {
        if (r.length !== n[1])
          throw new dn(`Expecting byte array of length ${n[1]}, but got ${r.length} bytes`);
        for (let o = 0; o < n[1]; o++)
          lo(t, null, r[o], n[0], i);
      } else
        i.writeArray(r, (o) => {
          lo(t, e, o, n[0], i);
        });
    else if (n.kind !== void 0)
      switch (n.kind) {
        case "option": {
          r == null ? i.writeU8(0) : (i.writeU8(1), lo(t, e, r, n.type, i));
          break;
        }
        case "map": {
          i.writeU32(r.size), r.forEach((o, a) => {
            lo(t, e, a, n.key, i), lo(t, e, o, n.value, i);
          });
          break;
        }
        default:
          throw new dn(`FieldType ${n} unrecognized`);
      }
    else
      W3(t, r, i);
  } catch (o) {
    throw o instanceof dn && o.addToFieldPath(e), o;
  }
}
function W3(t, e, r) {
  if (typeof e.borshSerialize == "function") {
    e.borshSerialize(r);
    return;
  }
  const n = t.get(e.constructor);
  if (!n)
    throw new dn(`Class ${e.constructor.name} is missing in schema`);
  if (n.kind === "struct")
    n.fields.map(([i, o]) => {
      lo(t, i, e[i], o, r);
    });
  else if (n.kind === "enum") {
    const i = e[n.field];
    for (let o = 0; o < n.values.length; ++o) {
      const [a, s] = n.values[o];
      if (a === i) {
        r.writeU8(o), lo(t, a, e[a], s, r);
        break;
      }
    }
  } else
    throw new dn(`Unexpected schema kind: ${n.kind} for ${e.constructor.name}`);
}
function ZE(t, e, r = $3) {
  const n = new r();
  return W3(t, e, n), n.toArray();
}
var H3 = zr.serialize = ZE;
function ho(t, e, r, n) {
  try {
    if (typeof r == "string")
      return n[`read${K3(r)}`]();
    if (r instanceof Array) {
      if (typeof r[0] == "number")
        return n.readFixedArray(r[0]);
      if (typeof r[1] == "number") {
        const i = [];
        for (let o = 0; o < r[1]; o++)
          i.push(ho(t, null, r[0], n));
        return i;
      } else
        return n.readArray(() => ho(t, e, r[0], n));
    }
    if (r.kind === "option")
      return n.readU8() ? ho(t, e, r.type, n) : void 0;
    if (r.kind === "map") {
      let i = /* @__PURE__ */ new Map();
      const o = n.readU32();
      for (let a = 0; a < o; a++) {
        const s = ho(t, e, r.key, n), f = ho(t, e, r.value, n);
        i.set(s, f);
      }
      return i;
    }
    return Wp(t, r, n);
  } catch (i) {
    throw i instanceof dn && i.addToFieldPath(e), i;
  }
}
function Wp(t, e, r) {
  if (typeof e.borshDeserialize == "function")
    return e.borshDeserialize(r);
  const n = t.get(e);
  if (!n)
    throw new dn(`Class ${e.name} is missing in schema`);
  if (n.kind === "struct") {
    const i = {};
    for (const [o, a] of t.get(e).fields)
      i[o] = ho(t, o, a, r);
    return new e(i);
  }
  if (n.kind === "enum") {
    const i = r.readU8();
    if (i >= n.values.length)
      throw new dn(`Enum index: ${i} is out of range`);
    const [o, a] = n.values[i], s = ho(t, o, a, r);
    return new e({ [o]: s });
  }
  throw new dn(`Unexpected schema kind: ${n.kind} for ${e.constructor.name}`);
}
function QE(t, e, r, n = kn) {
  const i = new n(r), o = Wp(t, e, i);
  if (i.offset < r.length)
    throw new dn(`Unexpected ${r.length - i.offset} bytes after deserialized data`);
  return o;
}
var G3 = zr.deserialize = QE;
function eS(t, e, r, n = kn) {
  const i = new n(r);
  return Wp(t, e, i);
}
Kp = zr.deserializeUnchecked = eS;
var ge = {};
Object.defineProperty(ge, "__esModule", { value: !0 });
ge.s16 = ge.s8 = ge.nu64be = ge.u48be = ge.u40be = ge.u32be = ge.u24be = ge.u16be = $r = ge.nu64 = ge.u48 = ge.u40 = ft = ge.u32 = ge.u24 = qn = ge.u16 = Xt = ge.u8 = Ro = ge.offset = ge.greedy = ge.Constant = ge.UTF8 = ge.CString = ge.Blob = ge.Boolean = ge.BitField = ge.BitStructure = ge.VariantLayout = ge.Union = ge.UnionLayoutDiscriminator = ge.UnionDiscriminator = ge.Structure = ge.Sequence = ge.DoubleBE = ge.Double = ge.FloatBE = ge.Float = ge.NearInt64BE = ge.NearInt64 = ge.NearUInt64BE = ge.NearUInt64 = ge.IntBE = ge.Int = ge.UIntBE = ge.UInt = ge.OffsetLayout = ge.GreedyCount = ge.ExternalLayout = ge.bindConstructorLayout = ge.nameWithProperty = ge.Layout = ge.uint8ArrayToBuffer = ge.checkUint8Array = void 0;
ge.constant = ge.utf8 = ge.cstr = yr = ge.blob = ge.unionLayoutDiscriminator = ge.union = ln = ge.seq = ge.bits = et = ge.struct = ge.f64be = ge.f64 = ge.f32be = ge.f32 = ge.ns64be = ge.s48be = ge.s40be = ge.s32be = ge.s24be = ge.s16be = Bn = ge.ns64 = ge.s48 = ge.s40 = ge.s32 = ge.s24 = void 0;
const Hp = mt;
function rs(t) {
  if (!(t instanceof Uint8Array))
    throw new TypeError("b must be a Uint8Array");
}
ge.checkUint8Array = rs;
function Yt(t) {
  return rs(t), Hp.Buffer.from(t.buffer, t.byteOffset, t.length);
}
ge.uint8ArrayToBuffer = Yt;
let or = class {
  constructor(e, r) {
    if (!Number.isInteger(e))
      throw new TypeError("span must be an integer");
    this.span = e, this.property = r;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   *
   * See {@link bindConstructorLayout}.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Uint8Array} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(e, r) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(e) {
    const r = Object.create(this.constructor.prototype);
    return Object.assign(r, this), r.property = e, r;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(e) {
  }
};
ge.Layout = or;
function Gp(t, e) {
  return e.property ? t + "[" + e.property + "]" : t;
}
ge.nameWithProperty = Gp;
function tS(t, e) {
  if (typeof t != "function")
    throw new TypeError("Class must be constructor");
  if (Object.prototype.hasOwnProperty.call(t, "layout_"))
    throw new Error("Class is already bound to a layout");
  if (!(e && e instanceof or))
    throw new TypeError("layout must be a Layout");
  if (Object.prototype.hasOwnProperty.call(e, "boundConstructor_"))
    throw new Error("layout is already bound to a constructor");
  t.layout_ = e, e.boundConstructor_ = t, e.makeDestinationObject = () => new t(), Object.defineProperty(t.prototype, "encode", {
    value(r, n) {
      return e.encode(this, r, n);
    },
    writable: !0
  }), Object.defineProperty(t, "decode", {
    value(r, n) {
      return e.decode(r, n);
    },
    writable: !0
  });
}
ge.bindConstructorLayout = tS;
let gn = class extends or {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
};
ge.ExternalLayout = gn;
class V3 extends gn {
  constructor(e = 1, r) {
    if (!Number.isInteger(e) || 0 >= e)
      throw new TypeError("elementSpan must be a (positive) integer");
    super(-1, r), this.elementSpan = e;
  }
  /** @override */
  isCount() {
    return !0;
  }
  /** @override */
  decode(e, r = 0) {
    rs(e);
    const n = e.length - r;
    return Math.floor(n / this.elementSpan);
  }
  /** @override */
  encode(e, r, n) {
    return 0;
  }
}
ge.GreedyCount = V3;
let Vp = class extends gn {
  constructor(e, r = 0, n) {
    if (!(e instanceof or))
      throw new TypeError("layout must be a Layout");
    if (!Number.isInteger(r))
      throw new TypeError("offset must be integer or undefined");
    super(e.span, n || e.property), this.layout = e, this.offset = r;
  }
  /** @override */
  isCount() {
    return this.layout instanceof Kn || this.layout instanceof ni;
  }
  /** @override */
  decode(e, r = 0) {
    return this.layout.decode(e, r + this.offset);
  }
  /** @override */
  encode(e, r, n = 0) {
    return this.layout.encode(e, r, n + this.offset);
  }
};
ge.OffsetLayout = Vp;
let Kn = class extends or {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r = 0) {
    return Yt(e).readUIntLE(r, this.span);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Yt(r).writeUIntLE(e, n, this.span), this.span;
  }
};
ge.UInt = Kn;
let ni = class extends or {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r = 0) {
    return Yt(e).readUIntBE(r, this.span);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Yt(r).writeUIntBE(e, n, this.span), this.span;
  }
};
ge.UIntBE = ni;
class Jo extends or {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r = 0) {
    return Yt(e).readIntLE(r, this.span);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Yt(r).writeIntLE(e, n, this.span), this.span;
  }
}
ge.Int = Jo;
class ns extends or {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r = 0) {
    return Yt(e).readIntBE(r, this.span);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Yt(r).writeIntBE(e, n, this.span), this.span;
  }
}
ge.IntBE = ns;
const T0 = Math.pow(2, 32);
function ed(t) {
  const e = Math.floor(t / T0), r = t - e * T0;
  return { hi32: e, lo32: r };
}
function td(t, e) {
  return t * T0 + e;
}
let Y3 = class extends or {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r = 0) {
    const n = Yt(e), i = n.readUInt32LE(r), o = n.readUInt32LE(r + 4);
    return td(o, i);
  }
  /** @override */
  encode(e, r, n = 0) {
    const i = ed(e), o = Yt(r);
    return o.writeUInt32LE(i.lo32, n), o.writeUInt32LE(i.hi32, n + 4), 8;
  }
};
ge.NearUInt64 = Y3;
class J3 extends or {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r = 0) {
    const n = Yt(e), i = n.readUInt32BE(r), o = n.readUInt32BE(r + 4);
    return td(i, o);
  }
  /** @override */
  encode(e, r, n = 0) {
    const i = ed(e), o = Yt(r);
    return o.writeUInt32BE(i.hi32, n), o.writeUInt32BE(i.lo32, n + 4), 8;
  }
}
ge.NearUInt64BE = J3;
let X3 = class extends or {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r = 0) {
    const n = Yt(e), i = n.readUInt32LE(r), o = n.readInt32LE(r + 4);
    return td(o, i);
  }
  /** @override */
  encode(e, r, n = 0) {
    const i = ed(e), o = Yt(r);
    return o.writeUInt32LE(i.lo32, n), o.writeInt32LE(i.hi32, n + 4), 8;
  }
};
ge.NearInt64 = X3;
class Z3 extends or {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r = 0) {
    const n = Yt(e), i = n.readInt32BE(r), o = n.readUInt32BE(r + 4);
    return td(i, o);
  }
  /** @override */
  encode(e, r, n = 0) {
    const i = ed(e), o = Yt(r);
    return o.writeInt32BE(i.hi32, n), o.writeUInt32BE(i.lo32, n + 4), 8;
  }
}
ge.NearInt64BE = Z3;
class Q3 extends or {
  constructor(e) {
    super(4, e);
  }
  /** @override */
  decode(e, r = 0) {
    return Yt(e).readFloatLE(r);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Yt(r).writeFloatLE(e, n), 4;
  }
}
ge.Float = Q3;
class e6 extends or {
  constructor(e) {
    super(4, e);
  }
  /** @override */
  decode(e, r = 0) {
    return Yt(e).readFloatBE(r);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Yt(r).writeFloatBE(e, n), 4;
  }
}
ge.FloatBE = e6;
class t6 extends or {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r = 0) {
    return Yt(e).readDoubleLE(r);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Yt(r).writeDoubleLE(e, n), 8;
  }
}
ge.Double = t6;
class r6 extends or {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r = 0) {
    return Yt(e).readDoubleBE(r);
  }
  /** @override */
  encode(e, r, n = 0) {
    return Yt(r).writeDoubleBE(e, n), 8;
  }
}
ge.DoubleBE = r6;
let n6 = class extends or {
  constructor(e, r, n) {
    if (!(e instanceof or))
      throw new TypeError("elementLayout must be a Layout");
    if (!(r instanceof gn && r.isCount() || Number.isInteger(r) && 0 <= r))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let i = -1;
    !(r instanceof gn) && 0 < e.span && (i = r * e.span), super(i, n), this.elementLayout = e, this.count = r;
  }
  /** @override */
  getSpan(e, r = 0) {
    if (0 <= this.span)
      return this.span;
    let n = 0, i = this.count;
    if (i instanceof gn && (i = i.decode(e, r)), 0 < this.elementLayout.span)
      n = i * this.elementLayout.span;
    else {
      let o = 0;
      for (; o < i; )
        n += this.elementLayout.getSpan(e, r + n), ++o;
    }
    return n;
  }
  /** @override */
  decode(e, r = 0) {
    const n = [];
    let i = 0, o = this.count;
    for (o instanceof gn && (o = o.decode(e, r)); i < o; )
      n.push(this.elementLayout.decode(e, r)), r += this.elementLayout.getSpan(e, r), i += 1;
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, r, n = 0) {
    const i = this.elementLayout, o = e.reduce((a, s) => a + i.encode(s, r, n + a), 0);
    return this.count instanceof gn && this.count.encode(e.length, r, n), o;
  }
};
ge.Sequence = n6;
let i6 = class extends or {
  constructor(e, r, n) {
    if (!(Array.isArray(e) && e.reduce((o, a) => o && a instanceof or, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof r == "boolean" && n === void 0 && (n = r, r = void 0);
    for (const o of e)
      if (0 > o.span && o.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let i = -1;
    try {
      i = e.reduce((o, a) => o + a.getSpan(), 0);
    } catch {
    }
    super(i, r), this.fields = e, this.decodePrefixes = !!n;
  }
  /** @override */
  getSpan(e, r = 0) {
    if (0 <= this.span)
      return this.span;
    let n = 0;
    try {
      n = this.fields.reduce((i, o) => {
        const a = o.getSpan(e, r);
        return r += a, i + a;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return n;
  }
  /** @override */
  decode(e, r = 0) {
    rs(e);
    const n = this.makeDestinationObject();
    for (const i of this.fields)
      if (i.property !== void 0 && (n[i.property] = i.decode(e, r)), r += i.getSpan(e, r), this.decodePrefixes && e.length === r)
        break;
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(e, r, n = 0) {
    const i = n;
    let o = 0, a = 0;
    for (const s of this.fields) {
      let f = s.span;
      if (a = 0 < f ? f : 0, s.property !== void 0) {
        const u = e[s.property];
        u !== void 0 && (a = s.encode(u, r, n), 0 > f && (f = s.getSpan(r, n)));
      }
      o = n, n += f;
    }
    return o + a - i;
  }
  /** @override */
  fromArray(e) {
    const r = this.makeDestinationObject();
    for (const n of this.fields)
      n.property !== void 0 && 0 < e.length && (r[n.property] = e.shift());
    return r;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const r of this.fields)
      if (r.property === e)
        return r;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    let r = 0;
    for (const n of this.fields) {
      if (n.property === e)
        return r;
      0 > n.span ? r = -1 : 0 <= r && (r += n.span);
    }
  }
};
ge.Structure = i6;
let Yp = class {
  constructor(e) {
    this.property = e;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode(e, r) {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode(e, r, n) {
    throw new Error("UnionDiscriminator is abstract");
  }
};
ge.UnionDiscriminator = Yp;
let Fc = class extends Yp {
  constructor(e, r) {
    if (!(e instanceof gn && e.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(r || e.property || "variant"), this.layout = e;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(e, r) {
    return this.layout.decode(e, r);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(e, r, n) {
    return this.layout.encode(e, r, n);
  }
};
ge.UnionLayoutDiscriminator = Fc;
let Jp = class extends or {
  constructor(e, r, n) {
    let i;
    if (e instanceof Kn || e instanceof ni)
      i = new Fc(new Vp(e));
    else if (e instanceof gn && e.isCount())
      i = new Fc(e);
    else if (e instanceof Yp)
      i = e;
    else
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (r === void 0 && (r = null), !(r === null || r instanceof or))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (r !== null) {
      if (0 > r.span)
        throw new Error("defaultLayout must have constant span");
      r.property === void 0 && (r = r.replicate("content"));
    }
    let o = -1;
    r && (o = r.span, 0 <= o && (e instanceof Kn || e instanceof ni) && (o += i.layout.span)), super(o, n), this.discriminator = i, this.usesPrefixDiscriminator = e instanceof Kn || e instanceof ni, this.defaultLayout = r, this.registry = {};
    let a = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(s) {
      return a(s);
    }, this.configGetSourceVariant = function(s) {
      a = s.bind(this);
    };
  }
  /** @override */
  getSpan(e, r = 0) {
    if (0 <= this.span)
      return this.span;
    const n = this.getVariant(e, r);
    if (!n)
      throw new Error("unable to determine span for unrecognized variant");
    return n.getSpan(e, r);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisfied rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(e) {
    if (Object.prototype.hasOwnProperty.call(e, this.discriminator.property)) {
      if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(e, this.defaultLayout.property))
        return;
      const r = this.registry[e[this.discriminator.property]];
      if (r && (!r.layout || r.property && Object.prototype.hasOwnProperty.call(e, r.property)))
        return r;
    } else
      for (const r in this.registry) {
        const n = this.registry[r];
        if (n.property && Object.prototype.hasOwnProperty.call(e, n.property))
          return n;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(e, r = 0) {
    let n;
    const i = this.discriminator, o = i.decode(e, r), a = this.registry[o];
    if (a === void 0) {
      const s = this.defaultLayout;
      let f = 0;
      this.usesPrefixDiscriminator && (f = i.layout.span), n = this.makeDestinationObject(), n[i.property] = o, n[s.property] = s.decode(e, r + f);
    } else
      n = a.decode(e, r);
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(e, r, n = 0) {
    const i = this.getSourceVariant(e);
    if (i === void 0) {
      const o = this.discriminator, a = this.defaultLayout;
      let s = 0;
      return this.usesPrefixDiscriminator && (s = o.layout.span), o.encode(e[o.property], r, n), s + a.encode(e[a.property], r, n + s);
    }
    return i.encode(e, r, n);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(e, r, n) {
    const i = new o6(this, e, r, n);
    return this.registry[e] = i, i;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Uint8Array)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Uint8Array}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(e, r = 0) {
    let n;
    return e instanceof Uint8Array ? n = this.discriminator.decode(e, r) : n = e, this.registry[n];
  }
};
ge.Union = Jp;
let o6 = class extends or {
  constructor(e, r, n, i) {
    if (!(e instanceof Jp))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(r) || 0 > r)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof n == "string" && i === void 0 && (i = n, n = null), n) {
      if (!(n instanceof or))
        throw new TypeError("layout must be a Layout");
      if (e.defaultLayout !== null && 0 <= n.span && n.span > e.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof i != "string")
        throw new TypeError("variant must have a String property");
    }
    let o = e.span;
    0 > e.span && (o = n ? n.span : 0, 0 <= o && e.usesPrefixDiscriminator && (o += e.discriminator.layout.span)), super(o, i), this.union = e, this.variant = r, this.layout = n || null;
  }
  /** @override */
  getSpan(e, r = 0) {
    if (0 <= this.span)
      return this.span;
    let n = 0;
    this.union.usesPrefixDiscriminator && (n = this.union.discriminator.layout.span);
    let i = 0;
    return this.layout && (i = this.layout.getSpan(e, r + n)), n + i;
  }
  /** @override */
  decode(e, r = 0) {
    const n = this.makeDestinationObject();
    if (this !== this.union.getVariant(e, r))
      throw new Error("variant mismatch");
    let i = 0;
    return this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout ? n[this.property] = this.layout.decode(e, r + i) : this.property ? n[this.property] = !0 : this.union.usesPrefixDiscriminator && (n[this.union.discriminator.property] = this.variant), n;
  }
  /** @override */
  encode(e, r, n = 0) {
    let i = 0;
    if (this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout && !Object.prototype.hasOwnProperty.call(e, this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, r, n);
    let o = i;
    if (this.layout && (this.layout.encode(e[this.property], r, n + i), o += this.layout.getSpan(r, n + i), 0 <= this.union.span && o > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return o;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(e) {
    if (this.layout)
      return this.layout.fromArray(e);
  }
};
ge.VariantLayout = o6;
function ya(t) {
  return 0 > t && (t += 4294967296), t;
}
class Xp extends or {
  constructor(e, r, n) {
    if (!(e instanceof Kn || e instanceof ni))
      throw new TypeError("word must be a UInt or UIntBE layout");
    if (typeof r == "string" && n === void 0 && (n = r, r = !1), 4 < e.span)
      throw new RangeError("word cannot exceed 32 bits");
    super(e.span, n), this.word = e, this.msb = !!r, this.fields = [];
    let i = 0;
    this._packedSetValue = function(o) {
      return i = ya(o), this;
    }, this._packedGetValue = function() {
      return i;
    };
  }
  /** @override */
  decode(e, r = 0) {
    const n = this.makeDestinationObject(), i = this.word.decode(e, r);
    this._packedSetValue(i);
    for (const o of this.fields)
      o.property !== void 0 && (n[o.property] = o.decode(e));
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the packed
   * value is left unmodified.  Unused bits are also left unmodified. */
  encode(e, r, n = 0) {
    const i = this.word.decode(r, n);
    this._packedSetValue(i);
    for (const o of this.fields)
      if (o.property !== void 0) {
        const a = e[o.property];
        a !== void 0 && o.encode(a);
      }
    return this.word.encode(this._packedGetValue(), r, n);
  }
  /** Register a new bitfield with a containing bit structure.  The
   * resulting bitfield is returned.
   *
   * @param {Number} bits - initializer for {@link BitField#bits|bits}.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {BitField} */
  addField(e, r) {
    const n = new Zp(this, e, r);
    return this.fields.push(n), n;
  }
  /** As with {@link BitStructure#addField|addField} for single-bit
   * fields with `boolean` value representation.
   *
   * @param {string} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {Boolean} */
  // `Boolean` conflicts with the native primitive type
  // eslint-disable-next-line @typescript-eslint/ban-types
  addBoolean(e) {
    const r = new a6(this, e);
    return this.fields.push(r), r;
  }
  /**
   * Get access to the bit field for a given property.
   *
   * @param {String} property - the bit field of interest.
   *
   * @return {BitField} - the field associated with `property`, or
   * undefined if there is no such property.
   */
  fieldFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const r of this.fields)
      if (r.property === e)
        return r;
  }
}
ge.BitStructure = Xp;
class Zp {
  constructor(e, r, n) {
    if (!(e instanceof Xp))
      throw new TypeError("container must be a BitStructure");
    if (!Number.isInteger(r) || 0 >= r)
      throw new TypeError("bits must be positive integer");
    const i = 8 * e.span, o = e.fields.reduce((a, s) => a + s.bits, 0);
    if (r + o > i)
      throw new Error("bits too long for span remainder (" + (i - o) + " of " + i + " remain)");
    this.container = e, this.bits = r, this.valueMask = (1 << r) - 1, r === 32 && (this.valueMask = 4294967295), this.start = o, this.container.msb && (this.start = i - o - r), this.wordMask = ya(this.valueMask << this.start), this.property = n;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field. */
  decode(e, r) {
    const n = this.container._packedGetValue();
    return ya(n & this.wordMask) >>> this.start;
  }
  /** Store a value into the corresponding subsequence of the containing
   * bit field.
   *
   * **NOTE** This is not a specialization of {@link
   * Layout#encode|Layout.encode} and there is no return value. */
  encode(e) {
    if (typeof e != "number" || !Number.isInteger(e) || e !== ya(e & this.valueMask))
      throw new TypeError(Gp("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
    const r = this.container._packedGetValue(), n = ya(e << this.start);
    this.container._packedSetValue(ya(r & ~this.wordMask) | n);
  }
}
ge.BitField = Zp;
let a6 = class extends Zp {
  constructor(e, r) {
    super(e, 1, r);
  }
  /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
   *
   * @returns {boolean} */
  decode(e, r) {
    return !!super.decode(e, r);
  }
  /** @override */
  encode(e) {
    typeof e == "boolean" && (e = +e), super.encode(e);
  }
};
ge.Boolean = a6;
let s6 = class extends or {
  constructor(e, r) {
    if (!(e instanceof gn && e.isCount() || Number.isInteger(e) && 0 <= e))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let n = -1;
    e instanceof gn || (n = e), super(n, r), this.length = e;
  }
  /** @override */
  getSpan(e, r) {
    let n = this.span;
    return 0 > n && (n = this.length.decode(e, r)), n;
  }
  /** @override */
  decode(e, r = 0) {
    let n = this.span;
    return 0 > n && (n = this.length.decode(e, r)), Yt(e).slice(r, r + n);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, r, n) {
    let i = this.length;
    if (this.length instanceof gn && (i = e.length), !(e instanceof Uint8Array && i === e.length))
      throw new TypeError(Gp("Blob.encode", this) + " requires (length " + i + ") Uint8Array as src");
    if (n + i > r.length)
      throw new RangeError("encoding overruns Uint8Array");
    const o = Yt(e);
    return Yt(r).write(o.toString("hex"), n, i, "hex"), this.length instanceof gn && this.length.encode(i, r, n), i;
  }
};
ge.Blob = s6;
class f6 extends or {
  constructor(e) {
    super(-1, e);
  }
  /** @override */
  getSpan(e, r = 0) {
    rs(e);
    let n = r;
    for (; n < e.length && e[n] !== 0; )
      n += 1;
    return 1 + n - r;
  }
  /** @override */
  decode(e, r = 0) {
    const n = this.getSpan(e, r);
    return Yt(e).slice(r, r + n - 1).toString("utf-8");
  }
  /** @override */
  encode(e, r, n = 0) {
    typeof e != "string" && (e = String(e));
    const i = Hp.Buffer.from(e, "utf8"), o = i.length;
    if (n + o > r.length)
      throw new RangeError("encoding overruns Buffer");
    const a = Yt(r);
    return i.copy(a, n), a[n + o] = 0, o + 1;
  }
}
ge.CString = f6;
class c6 extends or {
  constructor(e, r) {
    if (typeof e == "string" && r === void 0 && (r = e, e = void 0), e === void 0)
      e = -1;
    else if (!Number.isInteger(e))
      throw new TypeError("maxSpan must be an integer");
    super(-1, r), this.maxSpan = e;
  }
  /** @override */
  getSpan(e, r = 0) {
    return rs(e), e.length - r;
  }
  /** @override */
  decode(e, r = 0) {
    const n = this.getSpan(e, r);
    if (0 <= this.maxSpan && this.maxSpan < n)
      throw new RangeError("text length exceeds maxSpan");
    return Yt(e).slice(r, r + n).toString("utf-8");
  }
  /** @override */
  encode(e, r, n = 0) {
    typeof e != "string" && (e = String(e));
    const i = Hp.Buffer.from(e, "utf8"), o = i.length;
    if (0 <= this.maxSpan && this.maxSpan < o)
      throw new RangeError("text length exceeds maxSpan");
    if (n + o > r.length)
      throw new RangeError("encoding overruns Buffer");
    return i.copy(Yt(r), n), o;
  }
}
ge.UTF8 = c6;
class u6 extends or {
  constructor(e, r) {
    super(0, r), this.value = e;
  }
  /** @override */
  decode(e, r) {
    return this.value;
  }
  /** @override */
  encode(e, r, n) {
    return 0;
  }
}
ge.Constant = u6;
ge.greedy = (t, e) => new V3(t, e);
var Ro = ge.offset = (t, e, r) => new Vp(t, e, r), Xt = ge.u8 = (t) => new Kn(1, t), qn = ge.u16 = (t) => new Kn(2, t);
ge.u24 = (t) => new Kn(3, t);
var ft = ge.u32 = (t) => new Kn(4, t);
ge.u40 = (t) => new Kn(5, t);
ge.u48 = (t) => new Kn(6, t);
var $r = ge.nu64 = (t) => new Y3(t);
ge.u16be = (t) => new ni(2, t);
ge.u24be = (t) => new ni(3, t);
ge.u32be = (t) => new ni(4, t);
ge.u40be = (t) => new ni(5, t);
ge.u48be = (t) => new ni(6, t);
ge.nu64be = (t) => new J3(t);
ge.s8 = (t) => new Jo(1, t);
ge.s16 = (t) => new Jo(2, t);
ge.s24 = (t) => new Jo(3, t);
ge.s32 = (t) => new Jo(4, t);
ge.s40 = (t) => new Jo(5, t);
ge.s48 = (t) => new Jo(6, t);
var Bn = ge.ns64 = (t) => new X3(t);
ge.s16be = (t) => new ns(2, t);
ge.s24be = (t) => new ns(3, t);
ge.s32be = (t) => new ns(4, t);
ge.s40be = (t) => new ns(5, t);
ge.s48be = (t) => new ns(6, t);
ge.ns64be = (t) => new Z3(t);
ge.f32 = (t) => new Q3(t);
ge.f32be = (t) => new e6(t);
ge.f64 = (t) => new t6(t);
ge.f64be = (t) => new r6(t);
var et = ge.struct = (t, e, r) => new i6(t, e, r);
ge.bits = (t, e, r) => new Xp(t, e, r);
var ln = ge.seq = (t, e, r) => new n6(t, e, r);
ge.union = (t, e, r) => new Jp(t, e, r);
ge.unionLayoutDiscriminator = (t, e) => new Fc(t, e);
var yr = ge.blob = (t, e) => new s6(t, e);
ge.cstr = (t) => new f6(t);
ge.utf8 = (t, e) => new c6(t, e);
ge.constant = (t, e) => new u6(t, e);
var Zf = {}, gh, vg;
function rS() {
  if (vg)
    return gh;
  vg = 1;
  var t, e, r = {
    '"': '"',
    "\\": "\\",
    "/": "/",
    b: "\b",
    f: "\f",
    n: `
`,
    r: "\r",
    t: "	"
  }, n;
  function i(h) {
    throw {
      name: "SyntaxError",
      message: h,
      at: t,
      text: n
    };
  }
  function o(h) {
    return h && h !== e && i("Expected '" + h + "' instead of '" + e + "'"), e = n.charAt(t), t += 1, e;
  }
  function a() {
    var h, y = "";
    for (e === "-" && (y = "-", o("-")); e >= "0" && e <= "9"; )
      y += e, o();
    if (e === ".")
      for (y += "."; o() && e >= "0" && e <= "9"; )
        y += e;
    if (e === "e" || e === "E")
      for (y += e, o(), (e === "-" || e === "+") && (y += e, o()); e >= "0" && e <= "9"; )
        y += e, o();
    return h = Number(y), isFinite(h) || i("Bad number"), h;
  }
  function s() {
    var h, y, b = "", w;
    if (e === '"')
      for (; o(); ) {
        if (e === '"')
          return o(), b;
        if (e === "\\")
          if (o(), e === "u") {
            for (w = 0, y = 0; y < 4 && (h = parseInt(o(), 16), !!isFinite(h)); y += 1)
              w = w * 16 + h;
            b += String.fromCharCode(w);
          } else if (typeof r[e] == "string")
            b += r[e];
          else
            break;
        else
          b += e;
      }
    i("Bad string");
  }
  function f() {
    for (; e && e <= " "; )
      o();
  }
  function u() {
    switch (e) {
      case "t":
        return o("t"), o("r"), o("u"), o("e"), !0;
      case "f":
        return o("f"), o("a"), o("l"), o("s"), o("e"), !1;
      case "n":
        return o("n"), o("u"), o("l"), o("l"), null;
      default:
        i("Unexpected '" + e + "'");
    }
  }
  function c() {
    var h = [];
    if (e === "[") {
      if (o("["), f(), e === "]")
        return o("]"), h;
      for (; e; ) {
        if (h.push(l()), f(), e === "]")
          return o("]"), h;
        o(","), f();
      }
    }
    i("Bad array");
  }
  function d() {
    var h, y = {};
    if (e === "{") {
      if (o("{"), f(), e === "}")
        return o("}"), y;
      for (; e; ) {
        if (h = s(), f(), o(":"), Object.prototype.hasOwnProperty.call(y, h) && i('Duplicate key "' + h + '"'), y[h] = l(), f(), e === "}")
          return o("}"), y;
        o(","), f();
      }
    }
    i("Bad object");
  }
  function l() {
    switch (f(), e) {
      case "{":
        return d();
      case "[":
        return c();
      case '"':
        return s();
      case "-":
        return a();
      default:
        return e >= "0" && e <= "9" ? a() : u();
    }
  }
  return gh = function(h, y) {
    var b;
    return n = h, t = 0, e = " ", b = l(), f(), e && i("Syntax error"), typeof y == "function" ? function w(A, M) {
      var N, G, z = A[M];
      if (z && typeof z == "object")
        for (N in l)
          Object.prototype.hasOwnProperty.call(z, N) && (G = w(z, N), typeof G > "u" ? delete z[N] : z[N] = G);
      return y.call(A, M, z);
    }({ "": b }, "") : b;
  }, gh;
}
var vh, mg;
function nS() {
  if (mg)
    return vh;
  mg = 1;
  var t = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, e, r, n = {
    // table of character substitutions
    "\b": "\\b",
    "	": "\\t",
    "\n": "\\n",
    "\f": "\\f",
    "\r": "\\r",
    '"': '\\"',
    "\\": "\\\\"
  }, i;
  function o(s) {
    return t.lastIndex = 0, t.test(s) ? '"' + s.replace(t, function(f) {
      var u = n[f];
      return typeof u == "string" ? u : "\\u" + ("0000" + f.charCodeAt(0).toString(16)).slice(-4);
    }) + '"' : '"' + s + '"';
  }
  function a(s, f) {
    var u, c, d, l, h = e, y, b = f[s];
    switch (b && typeof b == "object" && typeof b.toJSON == "function" && (b = b.toJSON(s)), typeof i == "function" && (b = i.call(f, s, b)), typeof b) {
      case "string":
        return o(b);
      case "number":
        return isFinite(b) ? String(b) : "null";
      case "boolean":
      case "null":
        return String(b);
      case "object":
        if (!b)
          return "null";
        if (e += r, y = [], Object.prototype.toString.apply(b) === "[object Array]") {
          for (l = b.length, u = 0; u < l; u += 1)
            y[u] = a(u, b) || "null";
          return d = y.length === 0 ? "[]" : e ? `[
` + e + y.join(`,
` + e) + `
` + h + "]" : "[" + y.join(",") + "]", e = h, d;
        }
        if (i && typeof i == "object")
          for (l = i.length, u = 0; u < l; u += 1)
            c = i[u], typeof c == "string" && (d = a(c, b), d && y.push(o(c) + (e ? ": " : ":") + d));
        else
          for (c in b)
            Object.prototype.hasOwnProperty.call(b, c) && (d = a(c, b), d && y.push(o(c) + (e ? ": " : ":") + d));
        return d = y.length === 0 ? "{}" : e ? `{
` + e + y.join(`,
` + e) + `
` + h + "}" : "{" + y.join(",") + "}", e = h, d;
    }
  }
  return vh = function(s, f, u) {
    var c;
    if (e = "", r = "", typeof u == "number")
      for (c = 0; c < u; c += 1)
        r += " ";
    else
      typeof u == "string" && (r = u);
    if (i = f, f && typeof f != "function" && (typeof f != "object" || typeof f.length != "number"))
      throw new Error("JSON.stringify");
    return a("", { "": s });
  }, vh;
}
var wg;
function iS() {
  return wg || (wg = 1, Zf.parse = rS(), Zf.stringify = nS()), Zf;
}
typeof JSON < "u" || iS();
class oS extends TypeError {
  constructor(e, r) {
    let n;
    const {
      message: i,
      ...o
    } = e, {
      path: a
    } = e, s = a.length === 0 ? i : "At path: " + a.join(".") + " -- " + i;
    super(s), Object.assign(this, o), this.name = this.constructor.name, this.failures = () => {
      var f;
      return (f = n) != null ? f : n = [e, ...r()];
    };
  }
}
function aS(t) {
  return Ji(t) && typeof t[Symbol.iterator] == "function";
}
function Ji(t) {
  return typeof t == "object" && t != null;
}
function ii(t) {
  return typeof t == "string" ? JSON.stringify(t) : "" + t;
}
function sS(t) {
  const {
    done: e,
    value: r
  } = t.next();
  return e ? void 0 : r;
}
function fS(t, e, r, n) {
  if (t === !0)
    return;
  t === !1 ? t = {} : typeof t == "string" && (t = {
    message: t
  });
  const {
    path: i,
    branch: o
  } = e, {
    type: a
  } = r, {
    refinement: s,
    message: f = "Expected a value of type `" + a + "`" + (s ? " with refinement `" + s + "`" : "") + ", but received: `" + ii(n) + "`"
  } = t;
  return {
    value: n,
    type: a,
    refinement: s,
    key: i[i.length - 1],
    path: i,
    branch: o,
    ...t,
    message: f
  };
}
function* xg(t, e, r, n) {
  aS(t) || (t = [t]);
  for (const i of t) {
    const o = fS(i, e, r, n);
    o && (yield o);
  }
}
function* Qp(t, e, r = {}) {
  const {
    path: n = [],
    branch: i = [t],
    coerce: o = !1,
    mask: a = !1
  } = r, s = {
    path: n,
    branch: i
  };
  if (o && (t = e.coercer(t, s), a && e.type !== "type" && Ji(e.schema) && Ji(t) && !Array.isArray(t)))
    for (const u in t)
      e.schema[u] === void 0 && delete t[u];
  let f = !0;
  for (const u of e.validator(t, s))
    f = !1, yield [u, void 0];
  for (let [u, c, d] of e.entries(t, s)) {
    const l = Qp(c, d, {
      path: u === void 0 ? n : [...n, u],
      branch: u === void 0 ? i : [...i, c],
      coerce: o,
      mask: a
    });
    for (const h of l)
      h[0] ? (f = !1, yield [h[0], void 0]) : o && (c = h[1], u === void 0 ? t = c : t instanceof Map ? t.set(u, c) : t instanceof Set ? t.add(c) : Ji(t) && (t[u] = c));
  }
  if (f)
    for (const u of e.refiner(t, s))
      f = !1, yield [u, void 0];
  f && (yield [void 0, t]);
}
let Ai = class {
  constructor(e) {
    const {
      type: r,
      schema: n,
      validator: i,
      refiner: o,
      coercer: a = (f) => f,
      entries: s = function* () {
      }
    } = e;
    this.type = r, this.schema = n, this.entries = s, this.coercer = a, i ? this.validator = (f, u) => {
      const c = i(f, u);
      return xg(c, u, this, f);
    } : this.validator = () => [], o ? this.refiner = (f, u) => {
      const c = o(f, u);
      return xg(c, u, this, f);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(e) {
    return cS(e, this);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(e) {
    return qs(e, this);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(e) {
    return d6(e, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(e) {
    return uS(e, this);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(e, r = {}) {
    return Tf(e, this, r);
  }
};
function cS(t, e) {
  const r = Tf(t, e);
  if (r[0])
    throw r[0];
}
function qs(t, e) {
  const r = Tf(t, e, {
    coerce: !0
  });
  if (r[0])
    throw r[0];
  return r[1];
}
function uS(t, e) {
  const r = Tf(t, e, {
    coerce: !0,
    mask: !0
  });
  if (r[0])
    throw r[0];
  return r[1];
}
function d6(t, e) {
  return !Tf(t, e)[0];
}
function Tf(t, e, r = {}) {
  const n = Qp(t, e, r), i = sS(n);
  return i[0] ? [new oS(i[0], function* () {
    for (const a of n)
      a[0] && (yield a[0]);
  }), void 0] : [void 0, i[1]];
}
function Xo(t, e) {
  return new Ai({
    type: t,
    schema: null,
    validator: e
  });
}
function dS() {
  return Xo("any", () => !0);
}
function ot(t) {
  return new Ai({
    type: "array",
    schema: t,
    *entries(e) {
      if (t && Array.isArray(e))
        for (const [r, n] of e.entries())
          yield [r, n, t];
    },
    coercer(e) {
      return Array.isArray(e) ? e.slice() : e;
    },
    validator(e) {
      return Array.isArray(e) || "Expected an array value, but received: " + ii(e);
    }
  });
}
function Fi() {
  return Xo("boolean", (t) => typeof t == "boolean");
}
function e1(t) {
  return Xo("instance", (e) => e instanceof t || "Expected a `" + t.name + "` instance, but received: " + ii(e));
}
function vr(t) {
  const e = ii(t), r = typeof t;
  return new Ai({
    type: "literal",
    schema: r === "string" || r === "number" || r === "boolean" ? t : null,
    validator(n) {
      return n === t || "Expected the literal `" + e + "`, but received: " + ii(n);
    }
  });
}
function lS() {
  return Xo("never", () => !1);
}
function bt(t) {
  return new Ai({
    ...t,
    validator: (e, r) => e === null || t.validator(e, r),
    refiner: (e, r) => e === null || t.refiner(e, r)
  });
}
function _e() {
  return Xo("number", (t) => typeof t == "number" && !isNaN(t) || "Expected a number, but received: " + ii(t));
}
function Ot(t) {
  return new Ai({
    ...t,
    validator: (e, r) => e === void 0 || t.validator(e, r),
    refiner: (e, r) => e === void 0 || t.refiner(e, r)
  });
}
function l6(t, e) {
  return new Ai({
    type: "record",
    schema: null,
    *entries(r) {
      if (Ji(r))
        for (const n in r) {
          const i = r[n];
          yield [n, n, t], yield [n, i, e];
        }
    },
    validator(r) {
      return Ji(r) || "Expected an object, but received: " + ii(r);
    }
  });
}
function Ke() {
  return Xo("string", (t) => typeof t == "string" || "Expected a string, but received: " + ii(t));
}
function t1(t) {
  const e = lS();
  return new Ai({
    type: "tuple",
    schema: null,
    *entries(r) {
      if (Array.isArray(r)) {
        const n = Math.max(t.length, r.length);
        for (let i = 0; i < n; i++)
          yield [i, r[i], t[i] || e];
      }
    },
    validator(r) {
      return Array.isArray(r) || "Expected an array, but received: " + ii(r);
    }
  });
}
function Pe(t) {
  const e = Object.keys(t);
  return new Ai({
    type: "type",
    schema: t,
    *entries(r) {
      if (Ji(r))
        for (const n of e)
          yield [n, r[n], t[n]];
    },
    validator(r) {
      return Ji(r) || "Expected an object, but received: " + ii(r);
    }
  });
}
function wn(t) {
  const e = t.map((r) => r.type).join(" | ");
  return new Ai({
    type: "union",
    schema: null,
    validator(r, n) {
      const i = [];
      for (const o of t) {
        const [...a] = Qp(r, o, n), [s] = a;
        if (s[0])
          for (const [f] of a)
            f && i.push(f);
        else
          return [];
      }
      return ["Expected the value to satisfy a union of `" + e + "`, but received: " + ii(r), ...i];
    }
  });
}
function Of() {
  return Xo("unknown", () => !0);
}
function kf(t, e, r) {
  return new Ai({
    ...t,
    coercer: (n, i) => d6(n, e) ? t.coercer(r(n, i), i) : t.coercer(n, i)
  });
}
var r1 = {}, n1 = {};
const h6 = /* @__PURE__ */ _f(Q4);
Object.defineProperty(n1, "__esModule", {
  value: !0
});
n1.default = yS;
var hS = h6;
class pS extends hS.EventEmitter {
  /** Instantiate a WebSocket class
   * @constructor
   * @param {String} address - url to a websocket server
   * @param {(Object)} options - websocket options
   * @param {(String|Array)} protocols - a list of protocols
   * @return {WebSocketBrowserImpl} - returns a WebSocket instance
   */
  constructor(e, r, n) {
    super(), this.socket = new window.WebSocket(e, n), this.socket.onopen = () => this.emit("open"), this.socket.onmessage = (i) => this.emit("message", i.data), this.socket.onerror = (i) => this.emit("error", i), this.socket.onclose = (i) => {
      this.emit("close", i.code, i.reason);
    };
  }
  /**
   * Sends data through a websocket connection
   * @method
   * @param {(String|Object)} data - data to be sent via websocket
   * @param {Object} optionsOrCallback - ws options
   * @param {Function} callback - a callback called once the data is sent
   * @return {Undefined}
   */
  send(e, r, n) {
    const i = n || r;
    try {
      this.socket.send(e), i();
    } catch (o) {
      i(o);
    }
  }
  /**
   * Closes an underlying socket
   * @method
   * @param {Number} code - status code explaining why the connection is being closed
   * @param {String} reason - a description why the connection is closing
   * @return {Undefined}
   * @throws {Error}
   */
  close(e, r) {
    this.socket.close(e, r);
  }
  addEventListener(e, r, n) {
    this.socket.addEventListener(e, r, n);
  }
}
function yS(t, e) {
  return new pS(t, e);
}
var rd = {};
Object.defineProperty(rd, "__esModule", {
  value: !0
});
rd.default = void 0;
var bS = h6;
class gS extends bS.EventEmitter {
  /**
   * Instantiate a Client class.
   * @constructor
   * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
   * @param {String} address - url to a websocket server
   * @param {Object} options - ws options object with reconnect parameters
   * @param {Function} generate_request_id - custom generation request Id
   * @return {CommonClient}
   */
  constructor(e, r = "ws://localhost:8080", {
    autoconnect: n = !0,
    reconnect: i = !0,
    reconnect_interval: o = 1e3,
    max_reconnects: a = 5,
    ...s
  } = {}, f) {
    super(), this.webSocketFactory = e, this.queue = /* @__PURE__ */ new Map(), this.rpc_id = 0, this.address = r, this.autoconnect = n, this.ready = !1, this.reconnect = i, this.reconnect_interval = o, this.max_reconnects = a, this.rest_options = s, this.current_reconnects = 0, this.generate_request_id = f || (() => ++this.rpc_id), this.autoconnect && this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
   * Connects to a defined server if not connected already.
   * @method
   * @return {Undefined}
   */
  connect() {
    this.socket || this._connect(this.address, {
      autoconnect: this.autoconnect,
      reconnect: this.reconnect,
      reconnect_interval: this.reconnect_interval,
      max_reconnects: this.max_reconnects,
      ...this.rest_options
    });
  }
  /**
   * Calls a registered RPC method on server.
   * @method
   * @param {String} method - RPC method name
   * @param {Object|Array} params - optional method parameters
   * @param {Number} timeout - RPC reply timeout value
   * @param {Object} ws_opts - options passed to ws
   * @return {Promise}
   */
  call(e, r, n, i) {
    return !i && typeof n == "object" && (i = n, n = null), new Promise((o, a) => {
      if (!this.ready)
        return a(new Error("socket not ready"));
      const s = this.generate_request_id(e, r), f = {
        jsonrpc: "2.0",
        method: e,
        params: r || null,
        id: s
      };
      this.socket.send(JSON.stringify(f), i, (u) => {
        if (u)
          return a(u);
        this.queue.set(s, {
          promise: [o, a]
        }), n && (this.queue.get(s).timeout = setTimeout(() => {
          this.queue.delete(s), a(new Error("reply timeout"));
        }, n));
      });
    });
  }
  /**
   * Logins with the other side of the connection.
   * @method
   * @param {Object} params - Login credentials object
   * @return {Promise}
   */
  async login(e) {
    const r = await this.call("rpc.login", e);
    if (!r)
      throw new Error("authentication failed");
    return r;
  }
  /**
   * Fetches a list of client's methods registered on server.
   * @method
   * @return {Array}
   */
  async listMethods() {
    return await this.call("__listMethods");
  }
  /**
   * Sends a JSON-RPC 2.0 notification to server.
   * @method
   * @param {String} method - RPC method name
   * @param {Object} params - optional method parameters
   * @return {Promise}
   */
  notify(e, r) {
    return new Promise((n, i) => {
      if (!this.ready)
        return i(new Error("socket not ready"));
      const o = {
        jsonrpc: "2.0",
        method: e,
        params: r || null
      };
      this.socket.send(JSON.stringify(o), (a) => {
        if (a)
          return i(a);
        n();
      });
    });
  }
  /**
   * Subscribes for a defined event.
   * @method
   * @param {String|Array} event - event name
   * @return {Undefined}
   * @throws {Error}
   */
  async subscribe(e) {
    typeof e == "string" && (e = [e]);
    const r = await this.call("rpc.on", e);
    if (typeof e == "string" && r[e] !== "ok")
      throw new Error("Failed subscribing to an event '" + e + "' with: " + r[e]);
    return r;
  }
  /**
   * Unsubscribes from a defined event.
   * @method
   * @param {String|Array} event - event name
   * @return {Undefined}
   * @throws {Error}
   */
  async unsubscribe(e) {
    typeof e == "string" && (e = [e]);
    const r = await this.call("rpc.off", e);
    if (typeof e == "string" && r[e] !== "ok")
      throw new Error("Failed unsubscribing from an event with: " + r);
    return r;
  }
  /**
   * Closes a WebSocket connection gracefully.
   * @method
   * @param {Number} code - socket close code
   * @param {String} data - optional data to be sent before closing
   * @return {Undefined}
   */
  close(e, r) {
    this.socket.close(e || 1e3, r);
  }
  /**
   * Connection/Message handler.
   * @method
   * @private
   * @param {String} address - WebSocket API address
   * @param {Object} options - ws options object
   * @return {Undefined}
   */
  _connect(e, r) {
    this.socket = this.webSocketFactory(e, r), this.socket.addEventListener("open", () => {
      this.ready = !0, this.emit("open"), this.current_reconnects = 0;
    }), this.socket.addEventListener("message", ({
      data: n
    }) => {
      n instanceof ArrayBuffer && (n = Ie.from(n).toString());
      try {
        n = JSON.parse(n);
      } catch {
        return;
      }
      if (n.notification && this.listeners(n.notification).length) {
        if (!Object.keys(n.params).length)
          return this.emit(n.notification);
        const i = [n.notification];
        if (n.params.constructor === Object)
          i.push(n.params);
        else
          for (let o = 0; o < n.params.length; o++)
            i.push(n.params[o]);
        return Promise.resolve().then(() => {
          this.emit.apply(this, i);
        });
      }
      if (!this.queue.has(n.id))
        return n.method && n.params ? Promise.resolve().then(() => {
          this.emit(n.method, n.params);
        }) : void 0;
      "error" in n == "result" in n && this.queue.get(n.id).promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.')), this.queue.get(n.id).timeout && clearTimeout(this.queue.get(n.id).timeout), n.error ? this.queue.get(n.id).promise[1](n.error) : this.queue.get(n.id).promise[0](n.result), this.queue.delete(n.id);
    }), this.socket.addEventListener("error", (n) => this.emit("error", n)), this.socket.addEventListener("close", ({
      code: n,
      reason: i
    }) => {
      this.ready && setTimeout(() => this.emit("close", n, i), 0), this.ready = !1, this.socket = void 0, n !== 1e3 && (this.current_reconnects++, this.reconnect && (this.max_reconnects > this.current_reconnects || this.max_reconnects === 0) && setTimeout(() => this._connect(e, r), this.reconnect_interval));
    });
  }
}
rd.default = gS;
Object.defineProperty(r1, "__esModule", {
  value: !0
});
r1.Client = void 0;
var vS = p6(n1), mS = p6(rd);
function p6(t) {
  return t && t.__esModule ? t : { default: t };
}
class wS extends mS.default {
  constructor(e = "ws://localhost:8080", {
    autoconnect: r = !0,
    reconnect: n = !0,
    reconnect_interval: i = 1e3,
    max_reconnects: o = 5
  } = {}, a) {
    super(vS.default, e, {
      autoconnect: r,
      reconnect: n,
      reconnect_interval: i,
      max_reconnects: o
    }, a);
  }
}
r1.Client = wS;
var Qf, xS = new Uint8Array(16);
function y6() {
  if (!Qf && (Qf = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Qf))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Qf(xS);
}
const _S = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function nd(t) {
  return typeof t == "string" && _S.test(t);
}
var Dr = [];
for (var mh = 0; mh < 256; ++mh)
  Dr.push((mh + 256).toString(16).substr(1));
function id(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Dr[t[e + 0]] + Dr[t[e + 1]] + Dr[t[e + 2]] + Dr[t[e + 3]] + "-" + Dr[t[e + 4]] + Dr[t[e + 5]] + "-" + Dr[t[e + 6]] + Dr[t[e + 7]] + "-" + Dr[t[e + 8]] + Dr[t[e + 9]] + "-" + Dr[t[e + 10]] + Dr[t[e + 11]] + Dr[t[e + 12]] + Dr[t[e + 13]] + Dr[t[e + 14]] + Dr[t[e + 15]]).toLowerCase();
  if (!nd(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
var _g, wh, xh = 0, _h = 0;
function ES(t, e, r) {
  var n = e && r || 0, i = e || new Array(16);
  t = t || {};
  var o = t.node || _g, a = t.clockseq !== void 0 ? t.clockseq : wh;
  if (o == null || a == null) {
    var s = t.random || (t.rng || y6)();
    o == null && (o = _g = [s[0] | 1, s[1], s[2], s[3], s[4], s[5]]), a == null && (a = wh = (s[6] << 8 | s[7]) & 16383);
  }
  var f = t.msecs !== void 0 ? t.msecs : Date.now(), u = t.nsecs !== void 0 ? t.nsecs : _h + 1, c = f - xh + (u - _h) / 1e4;
  if (c < 0 && t.clockseq === void 0 && (a = a + 1 & 16383), (c < 0 || f > xh) && t.nsecs === void 0 && (u = 0), u >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  xh = f, _h = u, wh = a, f += 122192928e5;
  var d = ((f & 268435455) * 1e4 + u) % 4294967296;
  i[n++] = d >>> 24 & 255, i[n++] = d >>> 16 & 255, i[n++] = d >>> 8 & 255, i[n++] = d & 255;
  var l = f / 4294967296 * 1e4 & 268435455;
  i[n++] = l >>> 8 & 255, i[n++] = l & 255, i[n++] = l >>> 24 & 15 | 16, i[n++] = l >>> 16 & 255, i[n++] = a >>> 8 | 128, i[n++] = a & 255;
  for (var h = 0; h < 6; ++h)
    i[n + h] = o[h];
  return e || id(i);
}
function b6(t) {
  if (!nd(t))
    throw TypeError("Invalid UUID");
  var e, r = new Uint8Array(16);
  return r[0] = (e = parseInt(t.slice(0, 8), 16)) >>> 24, r[1] = e >>> 16 & 255, r[2] = e >>> 8 & 255, r[3] = e & 255, r[4] = (e = parseInt(t.slice(9, 13), 16)) >>> 8, r[5] = e & 255, r[6] = (e = parseInt(t.slice(14, 18), 16)) >>> 8, r[7] = e & 255, r[8] = (e = parseInt(t.slice(19, 23), 16)) >>> 8, r[9] = e & 255, r[10] = (e = parseInt(t.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = e / 4294967296 & 255, r[12] = e >>> 24 & 255, r[13] = e >>> 16 & 255, r[14] = e >>> 8 & 255, r[15] = e & 255, r;
}
function SS(t) {
  t = unescape(encodeURIComponent(t));
  for (var e = [], r = 0; r < t.length; ++r)
    e.push(t.charCodeAt(r));
  return e;
}
var AS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", IS = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function g6(t, e, r) {
  function n(i, o, a, s) {
    if (typeof i == "string" && (i = SS(i)), typeof o == "string" && (o = b6(o)), o.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var f = new Uint8Array(16 + i.length);
    if (f.set(o), f.set(i, o.length), f = r(f), f[6] = f[6] & 15 | e, f[8] = f[8] & 63 | 128, a) {
      s = s || 0;
      for (var u = 0; u < 16; ++u)
        a[s + u] = f[u];
      return a;
    }
    return id(f);
  }
  try {
    n.name = t;
  } catch {
  }
  return n.DNS = AS, n.URL = IS, n;
}
function BS(t) {
  if (typeof t == "string") {
    var e = unescape(encodeURIComponent(t));
    t = new Uint8Array(e.length);
    for (var r = 0; r < e.length; ++r)
      t[r] = e.charCodeAt(r);
  }
  return MS(RS(TS(t), t.length * 8));
}
function MS(t) {
  for (var e = [], r = t.length * 32, n = "0123456789abcdef", i = 0; i < r; i += 8) {
    var o = t[i >> 5] >>> i % 32 & 255, a = parseInt(n.charAt(o >>> 4 & 15) + n.charAt(o & 15), 16);
    e.push(a);
  }
  return e;
}
function v6(t) {
  return (t + 64 >>> 9 << 4) + 14 + 1;
}
function RS(t, e) {
  t[e >> 5] |= 128 << e % 32, t[v6(e) - 1] = e;
  for (var r = 1732584193, n = -271733879, i = -1732584194, o = 271733878, a = 0; a < t.length; a += 16) {
    var s = r, f = n, u = i, c = o;
    r = en(r, n, i, o, t[a], 7, -680876936), o = en(o, r, n, i, t[a + 1], 12, -389564586), i = en(i, o, r, n, t[a + 2], 17, 606105819), n = en(n, i, o, r, t[a + 3], 22, -1044525330), r = en(r, n, i, o, t[a + 4], 7, -176418897), o = en(o, r, n, i, t[a + 5], 12, 1200080426), i = en(i, o, r, n, t[a + 6], 17, -1473231341), n = en(n, i, o, r, t[a + 7], 22, -45705983), r = en(r, n, i, o, t[a + 8], 7, 1770035416), o = en(o, r, n, i, t[a + 9], 12, -1958414417), i = en(i, o, r, n, t[a + 10], 17, -42063), n = en(n, i, o, r, t[a + 11], 22, -1990404162), r = en(r, n, i, o, t[a + 12], 7, 1804603682), o = en(o, r, n, i, t[a + 13], 12, -40341101), i = en(i, o, r, n, t[a + 14], 17, -1502002290), n = en(n, i, o, r, t[a + 15], 22, 1236535329), r = tn(r, n, i, o, t[a + 1], 5, -165796510), o = tn(o, r, n, i, t[a + 6], 9, -1069501632), i = tn(i, o, r, n, t[a + 11], 14, 643717713), n = tn(n, i, o, r, t[a], 20, -373897302), r = tn(r, n, i, o, t[a + 5], 5, -701558691), o = tn(o, r, n, i, t[a + 10], 9, 38016083), i = tn(i, o, r, n, t[a + 15], 14, -660478335), n = tn(n, i, o, r, t[a + 4], 20, -405537848), r = tn(r, n, i, o, t[a + 9], 5, 568446438), o = tn(o, r, n, i, t[a + 14], 9, -1019803690), i = tn(i, o, r, n, t[a + 3], 14, -187363961), n = tn(n, i, o, r, t[a + 8], 20, 1163531501), r = tn(r, n, i, o, t[a + 13], 5, -1444681467), o = tn(o, r, n, i, t[a + 2], 9, -51403784), i = tn(i, o, r, n, t[a + 7], 14, 1735328473), n = tn(n, i, o, r, t[a + 12], 20, -1926607734), r = rn(r, n, i, o, t[a + 5], 4, -378558), o = rn(o, r, n, i, t[a + 8], 11, -2022574463), i = rn(i, o, r, n, t[a + 11], 16, 1839030562), n = rn(n, i, o, r, t[a + 14], 23, -35309556), r = rn(r, n, i, o, t[a + 1], 4, -1530992060), o = rn(o, r, n, i, t[a + 4], 11, 1272893353), i = rn(i, o, r, n, t[a + 7], 16, -155497632), n = rn(n, i, o, r, t[a + 10], 23, -1094730640), r = rn(r, n, i, o, t[a + 13], 4, 681279174), o = rn(o, r, n, i, t[a], 11, -358537222), i = rn(i, o, r, n, t[a + 3], 16, -722521979), n = rn(n, i, o, r, t[a + 6], 23, 76029189), r = rn(r, n, i, o, t[a + 9], 4, -640364487), o = rn(o, r, n, i, t[a + 12], 11, -421815835), i = rn(i, o, r, n, t[a + 15], 16, 530742520), n = rn(n, i, o, r, t[a + 2], 23, -995338651), r = nn(r, n, i, o, t[a], 6, -198630844), o = nn(o, r, n, i, t[a + 7], 10, 1126891415), i = nn(i, o, r, n, t[a + 14], 15, -1416354905), n = nn(n, i, o, r, t[a + 5], 21, -57434055), r = nn(r, n, i, o, t[a + 12], 6, 1700485571), o = nn(o, r, n, i, t[a + 3], 10, -1894986606), i = nn(i, o, r, n, t[a + 10], 15, -1051523), n = nn(n, i, o, r, t[a + 1], 21, -2054922799), r = nn(r, n, i, o, t[a + 8], 6, 1873313359), o = nn(o, r, n, i, t[a + 15], 10, -30611744), i = nn(i, o, r, n, t[a + 6], 15, -1560198380), n = nn(n, i, o, r, t[a + 13], 21, 1309151649), r = nn(r, n, i, o, t[a + 4], 6, -145523070), o = nn(o, r, n, i, t[a + 11], 10, -1120210379), i = nn(i, o, r, n, t[a + 2], 15, 718787259), n = nn(n, i, o, r, t[a + 9], 21, -343485551), r = Vi(r, s), n = Vi(n, f), i = Vi(i, u), o = Vi(o, c);
  }
  return [r, n, i, o];
}
function TS(t) {
  if (t.length === 0)
    return [];
  for (var e = t.length * 8, r = new Uint32Array(v6(e)), n = 0; n < e; n += 8)
    r[n >> 5] |= (t[n / 8] & 255) << n % 32;
  return r;
}
function Vi(t, e) {
  var r = (t & 65535) + (e & 65535), n = (t >> 16) + (e >> 16) + (r >> 16);
  return n << 16 | r & 65535;
}
function OS(t, e) {
  return t << e | t >>> 32 - e;
}
function od(t, e, r, n, i, o) {
  return Vi(OS(Vi(Vi(e, t), Vi(n, o)), i), r);
}
function en(t, e, r, n, i, o, a) {
  return od(e & r | ~e & n, t, e, i, o, a);
}
function tn(t, e, r, n, i, o, a) {
  return od(e & n | r & ~n, t, e, i, o, a);
}
function rn(t, e, r, n, i, o, a) {
  return od(e ^ r ^ n, t, e, i, o, a);
}
function nn(t, e, r, n, i, o, a) {
  return od(r ^ (e | ~n), t, e, i, o, a);
}
var kS = g6("v3", 48, BS);
const CS = kS;
function PS(t, e, r) {
  t = t || {};
  var n = t.random || (t.rng || y6)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, e) {
    r = r || 0;
    for (var i = 0; i < 16; ++i)
      e[r + i] = n[i];
    return e;
  }
  return id(n);
}
function NS(t, e, r, n) {
  switch (t) {
    case 0:
      return e & r ^ ~e & n;
    case 1:
      return e ^ r ^ n;
    case 2:
      return e & r ^ e & n ^ r & n;
    case 3:
      return e ^ r ^ n;
  }
}
function Eh(t, e) {
  return t << e | t >>> 32 - e;
}
function US(t) {
  var e = [1518500249, 1859775393, 2400959708, 3395469782], r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof t == "string") {
    var n = unescape(encodeURIComponent(t));
    t = [];
    for (var i = 0; i < n.length; ++i)
      t.push(n.charCodeAt(i));
  } else
    Array.isArray(t) || (t = Array.prototype.slice.call(t));
  t.push(128);
  for (var o = t.length / 4 + 2, a = Math.ceil(o / 16), s = new Array(a), f = 0; f < a; ++f) {
    for (var u = new Uint32Array(16), c = 0; c < 16; ++c)
      u[c] = t[f * 64 + c * 4] << 24 | t[f * 64 + c * 4 + 1] << 16 | t[f * 64 + c * 4 + 2] << 8 | t[f * 64 + c * 4 + 3];
    s[f] = u;
  }
  s[a - 1][14] = (t.length - 1) * 8 / Math.pow(2, 32), s[a - 1][14] = Math.floor(s[a - 1][14]), s[a - 1][15] = (t.length - 1) * 8 & 4294967295;
  for (var d = 0; d < a; ++d) {
    for (var l = new Uint32Array(80), h = 0; h < 16; ++h)
      l[h] = s[d][h];
    for (var y = 16; y < 80; ++y)
      l[y] = Eh(l[y - 3] ^ l[y - 8] ^ l[y - 14] ^ l[y - 16], 1);
    for (var b = r[0], w = r[1], A = r[2], M = r[3], N = r[4], G = 0; G < 80; ++G) {
      var z = Math.floor(G / 20), J = Eh(b, 5) + NS(z, w, A, M) + N + e[z] + l[G] >>> 0;
      N = M, M = A, A = Eh(w, 30) >>> 0, w = b, b = J;
    }
    r[0] = r[0] + b >>> 0, r[1] = r[1] + w >>> 0, r[2] = r[2] + A >>> 0, r[3] = r[3] + M >>> 0, r[4] = r[4] + N >>> 0;
  }
  return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, r[0] & 255, r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, r[1] & 255, r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, r[2] & 255, r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, r[3] & 255, r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, r[4] & 255];
}
var FS = g6("v5", 80, US);
const LS = FS, jS = "00000000-0000-0000-0000-000000000000";
function DS(t) {
  if (!nd(t))
    throw TypeError("Invalid UUID");
  return parseInt(t.substr(14, 1), 16);
}
const $S = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NIL: jS,
  parse: b6,
  stringify: id,
  v1: ES,
  v3: CS,
  v4: PS,
  v5: LS,
  validate: nd,
  version: DS
}, Symbol.toStringTag, { value: "Module" })), m6 = /* @__PURE__ */ _f($S), qS = m6.v4, zS = function(t, e, r, n) {
  if (typeof t != "string")
    throw new TypeError(t + " must be a string");
  n = n || {};
  const i = typeof n.version == "number" ? n.version : 2;
  if (i !== 1 && i !== 2)
    throw new TypeError(i + " must be 1 or 2");
  const o = {
    method: t
  };
  if (i === 2 && (o.jsonrpc = "2.0"), e) {
    if (typeof e != "object" && !Array.isArray(e))
      throw new TypeError(e + " must be an object, array or omitted");
    o.params = e;
  }
  if (typeof r > "u") {
    const a = typeof n.generator == "function" ? n.generator : function() {
      return qS();
    };
    o.id = a(o, n);
  } else
    i === 2 && r === null ? n.notificationIdNull && (o.id = null) : o.id = r;
  return o;
};
var KS = zS;
const WS = m6.v4, HS = KS, Lc = function(t, e) {
  if (!(this instanceof Lc))
    return new Lc(t, e);
  e || (e = {}), this.options = {
    reviver: typeof e.reviver < "u" ? e.reviver : null,
    replacer: typeof e.replacer < "u" ? e.replacer : null,
    generator: typeof e.generator < "u" ? e.generator : function() {
      return WS();
    },
    version: typeof e.version < "u" ? e.version : 2,
    notificationIdNull: typeof e.notificationIdNull == "boolean" ? e.notificationIdNull : !1
  }, this.callServer = t;
};
Lc.prototype.request = function(t, e, r, n) {
  const i = this;
  let o = null;
  const a = Array.isArray(t) && typeof e == "function";
  if (this.options.version === 1 && a)
    throw new TypeError("JSON-RPC 1.0 does not support batching");
  if (a || !a && t && typeof t == "object" && typeof e == "function")
    n = e, o = t;
  else {
    typeof r == "function" && (n = r, r = void 0);
    const u = typeof n == "function";
    try {
      o = HS(t, e, r, {
        generator: this.options.generator,
        version: this.options.version,
        notificationIdNull: this.options.notificationIdNull
      });
    } catch (c) {
      if (u)
        return n(c);
      throw c;
    }
    if (!u)
      return o;
  }
  let f;
  try {
    f = JSON.stringify(o, this.options.replacer);
  } catch (u) {
    return n(u);
  }
  return this.callServer(f, function(u, c) {
    i._parseResponse(u, c, n);
  }), o;
};
Lc.prototype._parseResponse = function(t, e, r) {
  if (t) {
    r(t);
    return;
  }
  if (!e)
    return r();
  let n;
  try {
    n = JSON.parse(e, this.options.reviver);
  } catch (i) {
    return r(i);
  }
  if (r.length === 3)
    if (Array.isArray(n)) {
      const i = function(a) {
        return typeof a.error < "u";
      }, o = function(a) {
        return !i(a);
      };
      return r(null, n.filter(i), n.filter(o));
    } else
      return r(null, n.error, n.result);
  r(null, n);
};
(function() {
  var t = typeof window == "object" ? window : {}, e = !t.JS_SHA3_NO_NODE_JS && typeof Ye == "object" && Ye.versions && Ye.versions.node;
  e && (t = yt);
  var r = !t.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", n = "0123456789abcdef".split(""), i = [31, 7936, 2031616, 520093696], o = [4, 1024, 262144, 67108864], a = [1, 256, 65536, 16777216], s = [6, 1536, 393216, 100663296], f = [0, 8, 16, 24], u = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
  ], c = [224, 256, 384, 512], d = [128, 256], l = ["hex", "buffer", "arrayBuffer", "array"], h = {
    128: 168,
    256: 136
  };
  (t.JS_SHA3_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(x) {
    return Object.prototype.toString.call(x) === "[object Array]";
  });
  for (var y = function(x, C, j) {
    return function(k) {
      return new B(x, C, x).update(k)[j]();
    };
  }, b = function(x, C, j) {
    return function(k, g) {
      return new B(x, C, g).update(k)[j]();
    };
  }, w = function(x, C, j) {
    return function(k, g, R, X) {
      return ee["cshake" + x].update(k, g, R, X)[j]();
    };
  }, A = function(x, C, j) {
    return function(k, g, R, X) {
      return ee["kmac" + x].update(k, g, R, X)[j]();
    };
  }, M = function(x, C, j, k) {
    for (var g = 0; g < l.length; ++g) {
      var R = l[g];
      x[R] = C(j, k, R);
    }
    return x;
  }, N = function(x, C) {
    var j = y(x, C, "hex");
    return j.create = function() {
      return new B(x, C, x);
    }, j.update = function(k) {
      return j.create().update(k);
    }, M(j, y, x, C);
  }, G = function(x, C) {
    var j = b(x, C, "hex");
    return j.create = function(k) {
      return new B(x, C, k);
    }, j.update = function(k, g) {
      return j.create(g).update(k);
    }, M(j, b, x, C);
  }, z = function(x, C) {
    var j = h[x], k = w(x, C, "hex");
    return k.create = function(g, R, X) {
      return !R && !X ? ee["shake" + x].create(g) : new B(x, C, g).bytepad([R, X], j);
    }, k.update = function(g, R, X, re) {
      return k.create(R, X, re).update(g);
    }, M(k, w, x, C);
  }, J = function(x, C) {
    var j = h[x], k = A(x, C, "hex");
    return k.create = function(g, R, X) {
      return new P(x, C, R).bytepad(["KMAC", X], j).bytepad([g], j);
    }, k.update = function(g, R, X, re) {
      return k.create(g, X, re).update(R);
    }, M(k, A, x, C);
  }, oe = [
    { name: "keccak", padding: a, bits: c, createMethod: N },
    { name: "sha3", padding: s, bits: c, createMethod: N },
    { name: "shake", padding: i, bits: d, createMethod: G },
    { name: "cshake", padding: o, bits: d, createMethod: z },
    { name: "kmac", padding: o, bits: d, createMethod: J }
  ], ee = {}, ae = 0; ae < oe.length; ++ae)
    for (var ye = oe[ae], pe = ye.bits, te = 0; te < pe.length; ++te) {
      var F = ye.name + "_" + pe[te];
      if (ee[F] = ye.createMethod(pe[te], ye.padding), ye.name !== "sha3") {
        var v = ye.name + pe[te];
        ee[v] = ee[F];
      }
    }
  function B(x, C, j) {
    this.blocks = [], this.s = [], this.padding = C, this.outputBits = j, this.reset = !0, this.block = 0, this.start = 0, this.blockCount = 1600 - (x << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = j >> 5, this.extraBytes = (j & 31) >> 3;
    for (var k = 0; k < 50; ++k)
      this.s[k] = 0;
  }
  B.prototype.update = function(x) {
    var C = typeof x != "string";
    C && x.constructor === t.ArrayBuffer && (x = new Uint8Array(x));
    var j = x.length;
    if (C && (typeof j != "number" || !Array.isArray(x) && !(r && ArrayBuffer.isView(x))))
      throw "input is invalid type";
    for (var k = this.blocks, g = this.byteCount, R = this.blockCount, X = 0, re = this.s, V, $; X < j; ) {
      if (this.reset)
        for (this.reset = !1, k[0] = this.block, V = 1; V < R + 1; ++V)
          k[V] = 0;
      if (C)
        for (V = this.start; X < j && V < g; ++X)
          k[V >> 2] |= x[X] << f[V++ & 3];
      else
        for (V = this.start; X < j && V < g; ++X)
          $ = x.charCodeAt(X), $ < 128 ? k[V >> 2] |= $ << f[V++ & 3] : $ < 2048 ? (k[V >> 2] |= (192 | $ >> 6) << f[V++ & 3], k[V >> 2] |= (128 | $ & 63) << f[V++ & 3]) : $ < 55296 || $ >= 57344 ? (k[V >> 2] |= (224 | $ >> 12) << f[V++ & 3], k[V >> 2] |= (128 | $ >> 6 & 63) << f[V++ & 3], k[V >> 2] |= (128 | $ & 63) << f[V++ & 3]) : ($ = 65536 + (($ & 1023) << 10 | x.charCodeAt(++X) & 1023), k[V >> 2] |= (240 | $ >> 18) << f[V++ & 3], k[V >> 2] |= (128 | $ >> 12 & 63) << f[V++ & 3], k[V >> 2] |= (128 | $ >> 6 & 63) << f[V++ & 3], k[V >> 2] |= (128 | $ & 63) << f[V++ & 3]);
      if (this.lastByteIndex = V, V >= g) {
        for (this.start = V - g, this.block = k[R], V = 0; V < R; ++V)
          re[V] ^= k[V];
        L(re), this.reset = !0;
      } else
        this.start = V;
    }
    return this;
  }, B.prototype.encode = function(x, C) {
    var j = x & 255, k = 1, g = [j];
    for (x = x >> 8, j = x & 255; j > 0; )
      g.unshift(j), x = x >> 8, j = x & 255, ++k;
    return C ? g.push(k) : g.unshift(k), this.update(g), g.length;
  }, B.prototype.encodeString = function(x) {
    x = x || "";
    var C = typeof x != "string";
    C && x.constructor === t.ArrayBuffer && (x = new Uint8Array(x));
    var j = x.length;
    if (C && (typeof j != "number" || !Array.isArray(x) && !(r && ArrayBuffer.isView(x))))
      throw "input is invalid type";
    var k = 0;
    if (C)
      k = j;
    else
      for (var g = 0; g < x.length; ++g) {
        var R = x.charCodeAt(g);
        R < 128 ? k += 1 : R < 2048 ? k += 2 : R < 55296 || R >= 57344 ? k += 3 : (R = 65536 + ((R & 1023) << 10 | x.charCodeAt(++g) & 1023), k += 4);
      }
    return k += this.encode(k * 8), this.update(x), k;
  }, B.prototype.bytepad = function(x, C) {
    for (var j = this.encode(C), k = 0; k < x.length; ++k)
      j += this.encodeString(x[k]);
    var g = C - j % C, R = [];
    return R.length = g, this.update(R), this;
  }, B.prototype.finalize = function() {
    var x = this.blocks, C = this.lastByteIndex, j = this.blockCount, k = this.s;
    if (x[C >> 2] |= this.padding[C & 3], this.lastByteIndex === this.byteCount)
      for (x[0] = x[j], C = 1; C < j + 1; ++C)
        x[C] = 0;
    for (x[j - 1] |= 2147483648, C = 0; C < j; ++C)
      k[C] ^= x[C];
    L(k);
  }, B.prototype.toString = B.prototype.hex = function() {
    this.finalize();
    for (var x = this.blockCount, C = this.s, j = this.outputBlocks, k = this.extraBytes, g = 0, R = 0, X = "", re; R < j; ) {
      for (g = 0; g < x && R < j; ++g, ++R)
        re = C[g], X += n[re >> 4 & 15] + n[re & 15] + n[re >> 12 & 15] + n[re >> 8 & 15] + n[re >> 20 & 15] + n[re >> 16 & 15] + n[re >> 28 & 15] + n[re >> 24 & 15];
      R % x === 0 && (L(C), g = 0);
    }
    return k && (re = C[g], k > 0 && (X += n[re >> 4 & 15] + n[re & 15]), k > 1 && (X += n[re >> 12 & 15] + n[re >> 8 & 15]), k > 2 && (X += n[re >> 20 & 15] + n[re >> 16 & 15])), X;
  }, B.prototype.arrayBuffer = function() {
    this.finalize();
    var x = this.blockCount, C = this.s, j = this.outputBlocks, k = this.extraBytes, g = 0, R = 0, X = this.outputBits >> 3, re;
    k ? re = new ArrayBuffer(j + 1 << 2) : re = new ArrayBuffer(X);
    for (var V = new Uint32Array(re); R < j; ) {
      for (g = 0; g < x && R < j; ++g, ++R)
        V[R] = C[g];
      R % x === 0 && L(C);
    }
    return k && (V[g] = C[g], re = re.slice(0, X)), re;
  }, B.prototype.buffer = B.prototype.arrayBuffer, B.prototype.digest = B.prototype.array = function() {
    this.finalize();
    for (var x = this.blockCount, C = this.s, j = this.outputBlocks, k = this.extraBytes, g = 0, R = 0, X = [], re, V; R < j; ) {
      for (g = 0; g < x && R < j; ++g, ++R)
        re = R << 2, V = C[g], X[re] = V & 255, X[re + 1] = V >> 8 & 255, X[re + 2] = V >> 16 & 255, X[re + 3] = V >> 24 & 255;
      R % x === 0 && L(C);
    }
    return k && (re = R << 2, V = C[g], k > 0 && (X[re] = V & 255), k > 1 && (X[re + 1] = V >> 8 & 255), k > 2 && (X[re + 2] = V >> 16 & 255)), X;
  };
  function P(x, C, j) {
    B.call(this, x, C, j);
  }
  P.prototype = new B(), P.prototype.finalize = function() {
    return this.encode(this.outputBits, !0), B.prototype.finalize.call(this);
  };
  var L = function(x) {
    var C, j, k, g, R, X, re, V, $, W, Z, fe, D, K, he, be, Ce, je, Ue, Qe, we, at, rt, It, it, se, ue, Ee, U, S, I, _, p, m, O, Q, ie, ce, Ne, Te, Je, Dt, nt, ur, Mi, Lt, Wt, pn, tr, rr, fi, dr, Rt, ci, T, q, H, E, Y, le, de, xe, Re;
    for (k = 0; k < 48; k += 2)
      g = x[0] ^ x[10] ^ x[20] ^ x[30] ^ x[40], R = x[1] ^ x[11] ^ x[21] ^ x[31] ^ x[41], X = x[2] ^ x[12] ^ x[22] ^ x[32] ^ x[42], re = x[3] ^ x[13] ^ x[23] ^ x[33] ^ x[43], V = x[4] ^ x[14] ^ x[24] ^ x[34] ^ x[44], $ = x[5] ^ x[15] ^ x[25] ^ x[35] ^ x[45], W = x[6] ^ x[16] ^ x[26] ^ x[36] ^ x[46], Z = x[7] ^ x[17] ^ x[27] ^ x[37] ^ x[47], fe = x[8] ^ x[18] ^ x[28] ^ x[38] ^ x[48], D = x[9] ^ x[19] ^ x[29] ^ x[39] ^ x[49], C = fe ^ (X << 1 | re >>> 31), j = D ^ (re << 1 | X >>> 31), x[0] ^= C, x[1] ^= j, x[10] ^= C, x[11] ^= j, x[20] ^= C, x[21] ^= j, x[30] ^= C, x[31] ^= j, x[40] ^= C, x[41] ^= j, C = g ^ (V << 1 | $ >>> 31), j = R ^ ($ << 1 | V >>> 31), x[2] ^= C, x[3] ^= j, x[12] ^= C, x[13] ^= j, x[22] ^= C, x[23] ^= j, x[32] ^= C, x[33] ^= j, x[42] ^= C, x[43] ^= j, C = X ^ (W << 1 | Z >>> 31), j = re ^ (Z << 1 | W >>> 31), x[4] ^= C, x[5] ^= j, x[14] ^= C, x[15] ^= j, x[24] ^= C, x[25] ^= j, x[34] ^= C, x[35] ^= j, x[44] ^= C, x[45] ^= j, C = V ^ (fe << 1 | D >>> 31), j = $ ^ (D << 1 | fe >>> 31), x[6] ^= C, x[7] ^= j, x[16] ^= C, x[17] ^= j, x[26] ^= C, x[27] ^= j, x[36] ^= C, x[37] ^= j, x[46] ^= C, x[47] ^= j, C = W ^ (g << 1 | R >>> 31), j = Z ^ (R << 1 | g >>> 31), x[8] ^= C, x[9] ^= j, x[18] ^= C, x[19] ^= j, x[28] ^= C, x[29] ^= j, x[38] ^= C, x[39] ^= j, x[48] ^= C, x[49] ^= j, K = x[0], he = x[1], Lt = x[11] << 4 | x[10] >>> 28, Wt = x[10] << 4 | x[11] >>> 28, Ee = x[20] << 3 | x[21] >>> 29, U = x[21] << 3 | x[20] >>> 29, le = x[31] << 9 | x[30] >>> 23, de = x[30] << 9 | x[31] >>> 23, Dt = x[40] << 18 | x[41] >>> 14, nt = x[41] << 18 | x[40] >>> 14, m = x[2] << 1 | x[3] >>> 31, O = x[3] << 1 | x[2] >>> 31, be = x[13] << 12 | x[12] >>> 20, Ce = x[12] << 12 | x[13] >>> 20, pn = x[22] << 10 | x[23] >>> 22, tr = x[23] << 10 | x[22] >>> 22, S = x[33] << 13 | x[32] >>> 19, I = x[32] << 13 | x[33] >>> 19, xe = x[42] << 2 | x[43] >>> 30, Re = x[43] << 2 | x[42] >>> 30, ci = x[5] << 30 | x[4] >>> 2, T = x[4] << 30 | x[5] >>> 2, Q = x[14] << 6 | x[15] >>> 26, ie = x[15] << 6 | x[14] >>> 26, je = x[25] << 11 | x[24] >>> 21, Ue = x[24] << 11 | x[25] >>> 21, rr = x[34] << 15 | x[35] >>> 17, fi = x[35] << 15 | x[34] >>> 17, _ = x[45] << 29 | x[44] >>> 3, p = x[44] << 29 | x[45] >>> 3, It = x[6] << 28 | x[7] >>> 4, it = x[7] << 28 | x[6] >>> 4, q = x[17] << 23 | x[16] >>> 9, H = x[16] << 23 | x[17] >>> 9, ce = x[26] << 25 | x[27] >>> 7, Ne = x[27] << 25 | x[26] >>> 7, Qe = x[36] << 21 | x[37] >>> 11, we = x[37] << 21 | x[36] >>> 11, dr = x[47] << 24 | x[46] >>> 8, Rt = x[46] << 24 | x[47] >>> 8, ur = x[8] << 27 | x[9] >>> 5, Mi = x[9] << 27 | x[8] >>> 5, se = x[18] << 20 | x[19] >>> 12, ue = x[19] << 20 | x[18] >>> 12, E = x[29] << 7 | x[28] >>> 25, Y = x[28] << 7 | x[29] >>> 25, Te = x[38] << 8 | x[39] >>> 24, Je = x[39] << 8 | x[38] >>> 24, at = x[48] << 14 | x[49] >>> 18, rt = x[49] << 14 | x[48] >>> 18, x[0] = K ^ ~be & je, x[1] = he ^ ~Ce & Ue, x[10] = It ^ ~se & Ee, x[11] = it ^ ~ue & U, x[20] = m ^ ~Q & ce, x[21] = O ^ ~ie & Ne, x[30] = ur ^ ~Lt & pn, x[31] = Mi ^ ~Wt & tr, x[40] = ci ^ ~q & E, x[41] = T ^ ~H & Y, x[2] = be ^ ~je & Qe, x[3] = Ce ^ ~Ue & we, x[12] = se ^ ~Ee & S, x[13] = ue ^ ~U & I, x[22] = Q ^ ~ce & Te, x[23] = ie ^ ~Ne & Je, x[32] = Lt ^ ~pn & rr, x[33] = Wt ^ ~tr & fi, x[42] = q ^ ~E & le, x[43] = H ^ ~Y & de, x[4] = je ^ ~Qe & at, x[5] = Ue ^ ~we & rt, x[14] = Ee ^ ~S & _, x[15] = U ^ ~I & p, x[24] = ce ^ ~Te & Dt, x[25] = Ne ^ ~Je & nt, x[34] = pn ^ ~rr & dr, x[35] = tr ^ ~fi & Rt, x[44] = E ^ ~le & xe, x[45] = Y ^ ~de & Re, x[6] = Qe ^ ~at & K, x[7] = we ^ ~rt & he, x[16] = S ^ ~_ & It, x[17] = I ^ ~p & it, x[26] = Te ^ ~Dt & m, x[27] = Je ^ ~nt & O, x[36] = rr ^ ~dr & ur, x[37] = fi ^ ~Rt & Mi, x[46] = le ^ ~xe & ci, x[47] = de ^ ~Re & T, x[8] = at ^ ~K & be, x[9] = rt ^ ~he & Ce, x[18] = _ ^ ~It & se, x[19] = p ^ ~it & ue, x[28] = Dt ^ ~m & Q, x[29] = nt ^ ~O & ie, x[38] = dr ^ ~ur & Lt, x[39] = Rt ^ ~Mi & Wt, x[48] = xe ^ ~ci & q, x[49] = Re ^ ~T & H, x[0] ^= u[k], x[1] ^= u[k + 1];
  };
})();
const w6 = (t, e) => eo.sign.detached(t, e);
function GS(t, e, r) {
  return eo.sign.detached.verify(e, t, r);
}
let kt = eo.lowlevel;
function Eg(t) {
  var e = [kt.gf(), kt.gf(), kt.gf(), kt.gf()], r = kt.gf(), n = kt.gf(), i = kt.gf(), o = kt.gf(), a = kt.gf(), s = kt.gf(), f = kt.gf();
  return kt.set25519(e[2], VS), kt.unpack25519(e[1], t), kt.S(i, e[1]), kt.M(o, i, kt.D), kt.Z(i, i, e[2]), kt.A(o, e[2], o), kt.S(a, o), kt.S(s, a), kt.M(f, s, a), kt.M(r, f, i), kt.M(r, r, o), kt.pow2523(r, r), kt.M(r, r, i), kt.M(r, r, o), kt.M(r, r, o), kt.M(e[0], r, o), kt.S(n, e[0]), kt.M(n, n, o), Sg(n, i) && kt.M(e[0], e[0], YS), kt.S(n, e[0]), kt.M(n, n, o), !Sg(n, i);
}
let VS = kt.gf([1]), YS = kt.gf([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
function Sg(t, e) {
  var r = new Uint8Array(32), n = new Uint8Array(32);
  return kt.pack25519(r, t), kt.pack25519(n, e), kt.crypto_verify_32(r, 0, n, 0);
}
const i1 = (t) => mt.Buffer.isBuffer(t) ? t : t instanceof Uint8Array ? mt.Buffer.from(t.buffer, t.byteOffset, t.byteLength) : mt.Buffer.from(t);
class JS {
  constructor(e) {
    Object.assign(this, e);
  }
  encode() {
    return mt.Buffer.from(H3(bc, this));
  }
  static decode(e) {
    return G3(bc, this, e);
  }
  static decodeUnchecked(e) {
    return Kp(bc, this, e);
  }
}
const bc = /* @__PURE__ */ new Map(), XS = 32, Pi = 32;
function ZS(t) {
  return t._bn !== void 0;
}
let Ag = 1, wt = class ba extends JS {
  /** @internal */
  /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */
  constructor(e) {
    if (super({}), this._bn = void 0, ZS(e))
      this._bn = e._bn;
    else {
      if (typeof e == "string") {
        const r = fr.decode(e);
        if (r.length != Pi)
          throw new Error("Invalid public key input");
        this._bn = new Ni(r);
      } else
        this._bn = new Ni(e);
      if (this._bn.byteLength() > 32)
        throw new Error("Invalid public key input");
    }
  }
  /**
   * Returns a unique PublicKey for tests and benchmarks using acounter
   */
  static unique() {
    const e = new ba(Ag);
    return Ag += 1, new ba(e.toBuffer());
  }
  /**
   * Default public key value. (All zeros)
   */
  /**
   * Checks if two publicKeys are equal
   */
  equals(e) {
    return this._bn.eq(e._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return fr.encode(this.toBytes());
  }
  toJSON() {
    return this.toBase58();
  }
  /**
   * Return the byte array representation of the public key
   */
  toBytes() {
    return this.toBuffer();
  }
  /**
   * Return the Buffer representation of the public key
   */
  toBuffer() {
    const e = this._bn.toArrayLike(mt.Buffer);
    if (e.length === Pi)
      return e;
    const r = mt.Buffer.alloc(32);
    return e.copy(r, 32 - e.length), r;
  }
  /**
   * Return the base-58 representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */
  /* eslint-disable require-await */
  static async createWithSeed(e, r, n) {
    const i = mt.Buffer.concat([e.toBuffer(), mt.Buffer.from(r), n.toBuffer()]), o = new Uint8Array(new js.sha256().update(i).digest());
    return new ba(o);
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  /* eslint-disable require-await */
  static createProgramAddressSync(e, r) {
    let n = mt.Buffer.alloc(0);
    e.forEach(function(o) {
      if (o.length > XS)
        throw new TypeError("Max seed length exceeded");
      n = mt.Buffer.concat([n, i1(o)]);
    }), n = mt.Buffer.concat([n, r.toBuffer(), mt.Buffer.from("ProgramDerivedAddress")]);
    const i = new Uint8Array(new js.sha256().update(n).digest());
    if (Eg(i))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new ba(i);
  }
  /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   */
  /* eslint-disable require-await */
  static async createProgramAddress(e, r) {
    return this.createProgramAddressSync(e, r);
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */
  static findProgramAddressSync(e, r) {
    let n = 255, i;
    for (; n != 0; ) {
      try {
        const o = e.concat(mt.Buffer.from([n]));
        i = this.createProgramAddressSync(o, r);
      } catch (o) {
        if (o instanceof TypeError)
          throw o;
        n--;
        continue;
      }
      return [i, n];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   */
  static async findProgramAddress(e, r) {
    return this.findProgramAddressSync(e, r);
  }
  /**
   * Check that a pubkey is on the ed25519 curve.
   */
  static isOnCurve(e) {
    const r = new ba(e);
    return Eg(r.toBytes());
  }
};
wt.default = new wt("11111111111111111111111111111111");
bc.set(wt, {
  kind: "struct",
  fields: [["_bn", "u256"]]
});
new wt("BPFLoader1111111111111111111111111111111111");
const Ma = 1232, o1 = 127, zs = 64;
class jc {
  constructor(e, r) {
    this.staticAccountKeys = void 0, this.accountKeysFromLookups = void 0, this.staticAccountKeys = e, this.accountKeysFromLookups = r;
  }
  keySegments() {
    const e = [this.staticAccountKeys];
    return this.accountKeysFromLookups && (e.push(this.accountKeysFromLookups.writable), e.push(this.accountKeysFromLookups.readonly)), e;
  }
  get(e) {
    for (const r of this.keySegments()) {
      if (e < r.length)
        return r[e];
      e -= r.length;
    }
  }
  get length() {
    return this.keySegments().flat().length;
  }
  compileInstructions(e) {
    if (this.length > 255)
      throw new Error("Account index overflow encountered during compilation");
    const n = /* @__PURE__ */ new Map();
    this.keySegments().flat().forEach((o, a) => {
      n.set(o.toBase58(), a);
    });
    const i = (o) => {
      const a = n.get(o.toBase58());
      if (a === void 0)
        throw new Error("Encountered an unknown instruction account key during compilation");
      return a;
    };
    return e.map((o) => ({
      programIdIndex: i(o.programId),
      accountKeyIndexes: o.keys.map((a) => i(a.pubkey)),
      data: o.data
    }));
  }
}
const Ft = (t = "publicKey") => yr(32, t), QS = (t = "signature") => yr(64, t), wa = (t = "string") => {
  const e = et([ft("length"), ft("lengthPadding"), yr(Ro(ft(), -8), "chars")], t), r = e.decode.bind(e), n = e.encode.bind(e), i = e;
  return i.decode = (o, a) => r(o, a).chars.toString(), i.encode = (o, a, s) => {
    const f = {
      chars: mt.Buffer.from(o, "utf8")
    };
    return n(f, a, s);
  }, i.alloc = (o) => ft().span + ft().span + mt.Buffer.from(o, "utf8").length, i;
}, e7 = (t = "authorized") => et([Ft("staker"), Ft("withdrawer")], t), t7 = (t = "lockup") => et([Bn("unixTimestamp"), Bn("epoch"), Ft("custodian")], t), r7 = (t = "voteInit") => et([Ft("nodePubkey"), Ft("authorizedVoter"), Ft("authorizedWithdrawer"), Xt("commission")], t), n7 = (t = "voteAuthorizeWithSeedArgs") => et([ft("voteAuthorizationType"), Ft("currentAuthorityDerivedKeyOwnerPubkey"), wa("currentAuthorityDerivedKeySeed"), Ft("newAuthorized")], t);
function Mn(t) {
  let e = 0, r = 0;
  for (; ; ) {
    let n = t.shift();
    if (e |= (n & 127) << r * 7, r += 1, !(n & 128))
      break;
  }
  return e;
}
function Rn(t, e) {
  let r = e;
  for (; ; ) {
    let n = r & 127;
    if (r >>= 7, r == 0) {
      t.push(n);
      break;
    } else
      n |= 128, t.push(n);
  }
}
function Or(t, e) {
  if (!t)
    throw new Error(e || "Assertion failed");
}
class ad {
  constructor(e, r) {
    this.payer = void 0, this.keyMetaMap = void 0, this.payer = e, this.keyMetaMap = r;
  }
  static compile(e, r) {
    const n = /* @__PURE__ */ new Map(), i = (a) => {
      const s = a.toBase58();
      let f = n.get(s);
      return f === void 0 && (f = {
        isSigner: !1,
        isWritable: !1,
        isInvoked: !1
      }, n.set(s, f)), f;
    }, o = i(r);
    o.isSigner = !0, o.isWritable = !0;
    for (const a of e) {
      i(a.programId).isInvoked = !0;
      for (const s of a.keys) {
        const f = i(s.pubkey);
        f.isSigner || (f.isSigner = s.isSigner), f.isWritable || (f.isWritable = s.isWritable);
      }
    }
    return new ad(r, n);
  }
  getMessageComponents() {
    const e = [...this.keyMetaMap.entries()];
    Or(e.length < 256, "Max static account keys length exceeded");
    const r = e.filter(([, f]) => f.isSigner && f.isWritable), n = e.filter(([, f]) => f.isSigner && !f.isWritable), i = e.filter(([, f]) => !f.isSigner && f.isWritable), o = e.filter(([, f]) => !f.isSigner && !f.isWritable), a = {
      numRequiredSignatures: r.length + n.length,
      numReadonlySignedAccounts: n.length,
      numReadonlyUnsignedAccounts: o.length
    };
    {
      Or(r.length > 0, "Expected at least one writable signer key");
      const [f] = r[0];
      Or(f === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
    }
    const s = [...r.map(([f]) => new wt(f)), ...n.map(([f]) => new wt(f)), ...i.map(([f]) => new wt(f)), ...o.map(([f]) => new wt(f))];
    return [a, s];
  }
  extractTableLookup(e) {
    const [r, n] = this.drainKeysFoundInLookupTable(e.state.addresses, (a) => !a.isSigner && !a.isInvoked && a.isWritable), [i, o] = this.drainKeysFoundInLookupTable(e.state.addresses, (a) => !a.isSigner && !a.isInvoked && !a.isWritable);
    if (!(r.length === 0 && i.length === 0))
      return [{
        accountKey: e.key,
        writableIndexes: r,
        readonlyIndexes: i
      }, {
        writable: n,
        readonly: o
      }];
  }
  /** @internal */
  drainKeysFoundInLookupTable(e, r) {
    const n = new Array(), i = new Array();
    for (const [o, a] of this.keyMetaMap.entries())
      if (r(a)) {
        const s = new wt(o), f = e.findIndex((u) => u.equals(s));
        f >= 0 && (Or(f < 256, "Max lookup table index exceeded"), n.push(f), i.push(s), this.keyMetaMap.delete(o));
      }
    return [n, i];
  }
}
let O0 = class k0 {
  constructor(e) {
    this.header = void 0, this.accountKeys = void 0, this.recentBlockhash = void 0, this.instructions = void 0, this.indexToProgramIds = /* @__PURE__ */ new Map(), this.header = e.header, this.accountKeys = e.accountKeys.map((r) => new wt(r)), this.recentBlockhash = e.recentBlockhash, this.instructions = e.instructions, this.instructions.forEach((r) => this.indexToProgramIds.set(r.programIdIndex, this.accountKeys[r.programIdIndex]));
  }
  get version() {
    return "legacy";
  }
  get staticAccountKeys() {
    return this.accountKeys;
  }
  get compiledInstructions() {
    return this.instructions.map((e) => ({
      programIdIndex: e.programIdIndex,
      accountKeyIndexes: e.accounts,
      data: fr.decode(e.data)
    }));
  }
  get addressTableLookups() {
    return [];
  }
  getAccountKeys() {
    return new jc(this.staticAccountKeys);
  }
  static compile(e) {
    const r = ad.compile(e.instructions, e.payerKey), [n, i] = r.getMessageComponents(), a = new jc(i).compileInstructions(e.instructions).map((s) => ({
      programIdIndex: s.programIdIndex,
      accounts: s.accountKeyIndexes,
      data: fr.encode(s.data)
    }));
    return new k0({
      header: n,
      accountKeys: i,
      recentBlockhash: e.recentBlockhash,
      instructions: a
    });
  }
  isAccountSigner(e) {
    return e < this.header.numRequiredSignatures;
  }
  isAccountWritable(e) {
    const r = this.header.numRequiredSignatures;
    if (e >= this.header.numRequiredSignatures) {
      const n = e - r, o = this.accountKeys.length - r - this.header.numReadonlyUnsignedAccounts;
      return n < o;
    } else {
      const n = r - this.header.numReadonlySignedAccounts;
      return e < n;
    }
  }
  isProgramId(e) {
    return this.indexToProgramIds.has(e);
  }
  programIds() {
    return [...this.indexToProgramIds.values()];
  }
  nonProgramIds() {
    return this.accountKeys.filter((e, r) => !this.isProgramId(r));
  }
  serialize() {
    const e = this.accountKeys.length;
    let r = [];
    Rn(r, e);
    const n = this.instructions.map((d) => {
      const {
        accounts: l,
        programIdIndex: h
      } = d, y = Array.from(fr.decode(d.data));
      let b = [];
      Rn(b, l.length);
      let w = [];
      return Rn(w, y.length), {
        programIdIndex: h,
        keyIndicesCount: mt.Buffer.from(b),
        keyIndices: l,
        dataLength: mt.Buffer.from(w),
        data: y
      };
    });
    let i = [];
    Rn(i, n.length);
    let o = mt.Buffer.alloc(Ma);
    mt.Buffer.from(i).copy(o);
    let a = i.length;
    n.forEach((d) => {
      const h = et([Xt("programIdIndex"), yr(d.keyIndicesCount.length, "keyIndicesCount"), ln(Xt("keyIndex"), d.keyIndices.length, "keyIndices"), yr(d.dataLength.length, "dataLength"), ln(Xt("userdatum"), d.data.length, "data")]).encode(d, o, a);
      a += h;
    }), o = o.slice(0, a);
    const s = et([yr(1, "numRequiredSignatures"), yr(1, "numReadonlySignedAccounts"), yr(1, "numReadonlyUnsignedAccounts"), yr(r.length, "keyCount"), ln(Ft("key"), e, "keys"), Ft("recentBlockhash")]), f = {
      numRequiredSignatures: mt.Buffer.from([this.header.numRequiredSignatures]),
      numReadonlySignedAccounts: mt.Buffer.from([this.header.numReadonlySignedAccounts]),
      numReadonlyUnsignedAccounts: mt.Buffer.from([this.header.numReadonlyUnsignedAccounts]),
      keyCount: mt.Buffer.from(r),
      keys: this.accountKeys.map((d) => i1(d.toBytes())),
      recentBlockhash: fr.decode(this.recentBlockhash)
    };
    let u = mt.Buffer.alloc(2048);
    const c = s.encode(f, u);
    return o.copy(u, c), u.slice(0, c + o.length);
  }
  /**
   * Decode a compiled message into a Message object.
   */
  static from(e) {
    let r = [...e];
    const n = r.shift();
    if (n !== (n & o1))
      throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
    const i = r.shift(), o = r.shift(), a = Mn(r);
    let s = [];
    for (let l = 0; l < a; l++) {
      const h = r.slice(0, Pi);
      r = r.slice(Pi), s.push(new wt(mt.Buffer.from(h)));
    }
    const f = r.slice(0, Pi);
    r = r.slice(Pi);
    const u = Mn(r);
    let c = [];
    for (let l = 0; l < u; l++) {
      const h = r.shift(), y = Mn(r), b = r.slice(0, y);
      r = r.slice(y);
      const w = Mn(r), A = r.slice(0, w), M = fr.encode(mt.Buffer.from(A));
      r = r.slice(w), c.push({
        programIdIndex: h,
        accounts: b,
        data: M
      });
    }
    const d = {
      header: {
        numRequiredSignatures: n,
        numReadonlySignedAccounts: i,
        numReadonlyUnsignedAccounts: o
      },
      recentBlockhash: fr.encode(mt.Buffer.from(f)),
      accountKeys: s,
      instructions: c
    };
    return new k0(d);
  }
};
class Dc {
  constructor(e) {
    this.header = void 0, this.staticAccountKeys = void 0, this.recentBlockhash = void 0, this.compiledInstructions = void 0, this.addressTableLookups = void 0, this.header = e.header, this.staticAccountKeys = e.staticAccountKeys, this.recentBlockhash = e.recentBlockhash, this.compiledInstructions = e.compiledInstructions, this.addressTableLookups = e.addressTableLookups;
  }
  get version() {
    return 0;
  }
  get numAccountKeysFromLookups() {
    let e = 0;
    for (const r of this.addressTableLookups)
      e += r.readonlyIndexes.length + r.writableIndexes.length;
    return e;
  }
  getAccountKeys(e) {
    let r;
    if (e && "accountKeysFromLookups" in e && e.accountKeysFromLookups) {
      if (this.numAccountKeysFromLookups != e.accountKeysFromLookups.writable.length + e.accountKeysFromLookups.readonly.length)
        throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
      r = e.accountKeysFromLookups;
    } else if (e && "addressLookupTableAccounts" in e && e.addressLookupTableAccounts)
      r = this.resolveAddressTableLookups(e.addressLookupTableAccounts);
    else if (this.addressTableLookups.length > 0)
      throw new Error("Failed to get account keys because address table lookups were not resolved");
    return new jc(this.staticAccountKeys, r);
  }
  isAccountSigner(e) {
    return e < this.header.numRequiredSignatures;
  }
  isAccountWritable(e) {
    const r = this.header.numRequiredSignatures, n = this.staticAccountKeys.length;
    if (e >= n) {
      const i = e - n, o = this.addressTableLookups.reduce((a, s) => a + s.writableIndexes.length, 0);
      return i < o;
    } else if (e >= this.header.numRequiredSignatures) {
      const i = e - r, a = n - r - this.header.numReadonlyUnsignedAccounts;
      return i < a;
    } else {
      const i = r - this.header.numReadonlySignedAccounts;
      return e < i;
    }
  }
  resolveAddressTableLookups(e) {
    const r = {
      writable: [],
      readonly: []
    };
    for (const n of this.addressTableLookups) {
      const i = e.find((o) => o.key.equals(n.accountKey));
      if (!i)
        throw new Error(`Failed to find address lookup table account for table key ${n.accountKey.toBase58()}`);
      for (const o of n.writableIndexes)
        if (o < i.state.addresses.length)
          r.writable.push(i.state.addresses[o]);
        else
          throw new Error(`Failed to find address for index ${o} in address lookup table ${n.accountKey.toBase58()}`);
      for (const o of n.readonlyIndexes)
        if (o < i.state.addresses.length)
          r.readonly.push(i.state.addresses[o]);
        else
          throw new Error(`Failed to find address for index ${o} in address lookup table ${n.accountKey.toBase58()}`);
    }
    return r;
  }
  static compile(e) {
    const r = ad.compile(e.instructions, e.payerKey), n = new Array(), i = {
      writable: new Array(),
      readonly: new Array()
    }, o = e.addressLookupTableAccounts || [];
    for (const c of o) {
      const d = r.extractTableLookup(c);
      if (d !== void 0) {
        const [l, {
          writable: h,
          readonly: y
        }] = d;
        n.push(l), i.writable.push(...h), i.readonly.push(...y);
      }
    }
    const [a, s] = r.getMessageComponents(), u = new jc(s, i).compileInstructions(e.instructions);
    return new Dc({
      header: a,
      staticAccountKeys: s,
      recentBlockhash: e.recentBlockhash,
      compiledInstructions: u,
      addressTableLookups: n
    });
  }
  serialize() {
    const e = Array();
    Rn(e, this.staticAccountKeys.length);
    const r = this.serializeInstructions(), n = Array();
    Rn(n, this.compiledInstructions.length);
    const i = this.serializeAddressTableLookups(), o = Array();
    Rn(o, this.addressTableLookups.length);
    const a = et([Xt("prefix"), et([Xt("numRequiredSignatures"), Xt("numReadonlySignedAccounts"), Xt("numReadonlyUnsignedAccounts")], "header"), yr(e.length, "staticAccountKeysLength"), ln(Ft(), this.staticAccountKeys.length, "staticAccountKeys"), Ft("recentBlockhash"), yr(n.length, "instructionsLength"), yr(r.length, "serializedInstructions"), yr(o.length, "addressTableLookupsLength"), yr(i.length, "serializedAddressTableLookups")]), s = new Uint8Array(Ma), u = a.encode({
      prefix: 128,
      header: this.header,
      staticAccountKeysLength: new Uint8Array(e),
      staticAccountKeys: this.staticAccountKeys.map((c) => c.toBytes()),
      recentBlockhash: fr.decode(this.recentBlockhash),
      instructionsLength: new Uint8Array(n),
      serializedInstructions: r,
      addressTableLookupsLength: new Uint8Array(o),
      serializedAddressTableLookups: i
    }, s);
    return s.slice(0, u);
  }
  serializeInstructions() {
    let e = 0;
    const r = new Uint8Array(Ma);
    for (const n of this.compiledInstructions) {
      const i = Array();
      Rn(i, n.accountKeyIndexes.length);
      const o = Array();
      Rn(o, n.data.length);
      const a = et([Xt("programIdIndex"), yr(i.length, "encodedAccountKeyIndexesLength"), ln(Xt(), n.accountKeyIndexes.length, "accountKeyIndexes"), yr(o.length, "encodedDataLength"), yr(n.data.length, "data")]);
      e += a.encode({
        programIdIndex: n.programIdIndex,
        encodedAccountKeyIndexesLength: new Uint8Array(i),
        accountKeyIndexes: n.accountKeyIndexes,
        encodedDataLength: new Uint8Array(o),
        data: n.data
      }, r, e);
    }
    return r.slice(0, e);
  }
  serializeAddressTableLookups() {
    let e = 0;
    const r = new Uint8Array(Ma);
    for (const n of this.addressTableLookups) {
      const i = Array();
      Rn(i, n.writableIndexes.length);
      const o = Array();
      Rn(o, n.readonlyIndexes.length);
      const a = et([Ft("accountKey"), yr(i.length, "encodedWritableIndexesLength"), ln(Xt(), n.writableIndexes.length, "writableIndexes"), yr(o.length, "encodedReadonlyIndexesLength"), ln(Xt(), n.readonlyIndexes.length, "readonlyIndexes")]);
      e += a.encode({
        accountKey: n.accountKey.toBytes(),
        encodedWritableIndexesLength: new Uint8Array(i),
        writableIndexes: n.writableIndexes,
        encodedReadonlyIndexesLength: new Uint8Array(o),
        readonlyIndexes: n.readonlyIndexes
      }, r, e);
    }
    return r.slice(0, e);
  }
  static deserialize(e) {
    let r = [...e];
    const n = r.shift(), i = n & o1;
    Or(n !== i, "Expected versioned message but received legacy message");
    const o = i;
    Or(o === 0, `Expected versioned message with version 0 but found version ${o}`);
    const a = {
      numRequiredSignatures: r.shift(),
      numReadonlySignedAccounts: r.shift(),
      numReadonlyUnsignedAccounts: r.shift()
    }, s = [], f = Mn(r);
    for (let y = 0; y < f; y++)
      s.push(new wt(r.splice(0, Pi)));
    const u = fr.encode(r.splice(0, Pi)), c = Mn(r), d = [];
    for (let y = 0; y < c; y++) {
      const b = r.shift(), w = Mn(r), A = r.splice(0, w), M = Mn(r), N = new Uint8Array(r.splice(0, M));
      d.push({
        programIdIndex: b,
        accountKeyIndexes: A,
        data: N
      });
    }
    const l = Mn(r), h = [];
    for (let y = 0; y < l; y++) {
      const b = new wt(r.splice(0, Pi)), w = Mn(r), A = r.splice(0, w), M = Mn(r), N = r.splice(0, M);
      h.push({
        accountKey: b,
        writableIndexes: A,
        readonlyIndexes: N
      });
    }
    return new Dc({
      header: a,
      staticAccountKeys: s,
      recentBlockhash: u,
      compiledInstructions: d,
      addressTableLookups: h
    });
  }
}
const x6 = {
  deserializeMessageVersion(t) {
    const e = t[0], r = e & o1;
    return r === e ? "legacy" : r;
  },
  deserialize: (t) => {
    const e = x6.deserializeMessageVersion(t);
    if (e === "legacy")
      return O0.from(t);
    if (e === 0)
      return Dc.deserialize(t);
    throw new Error(`Transaction message version ${e} deserialization is not supported`);
  }
};
let Ig;
(function(t) {
  t[t.BLOCKHEIGHT_EXCEEDED = 0] = "BLOCKHEIGHT_EXCEEDED", t[t.PROCESSED = 1] = "PROCESSED", t[t.TIMED_OUT = 2] = "TIMED_OUT";
})(Ig || (Ig = {}));
const i7 = mt.Buffer.alloc(zs).fill(0);
let Bg = class {
  /**
   * Public keys to include in this transaction
   * Boolean represents whether this pubkey needs to sign the transaction
   */
  /**
   * Program Id to execute
   */
  /**
   * Program input
   */
  constructor(e) {
    this.keys = void 0, this.programId = void 0, this.data = mt.Buffer.alloc(0), this.programId = e.programId, this.keys = e.keys, e.data && (this.data = e.data);
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      keys: this.keys.map(({
        pubkey: e,
        isSigner: r,
        isWritable: n
      }) => ({
        pubkey: e.toJSON(),
        isSigner: r,
        isWritable: n
      })),
      programId: this.programId.toJSON(),
      data: [...this.data]
    };
  }
}, o7 = class C0 {
  /**
   * Signatures for the transaction.  Typically created by invoking the
   * `sign()` method
   */
  /**
   * The first (payer) Transaction signature
   */
  get signature() {
    return this.signatures.length > 0 ? this.signatures[0].signature : null;
  }
  /**
   * The transaction fee payer
   */
  /**
   * Construct an empty Transaction
   */
  constructor(e) {
    if (this.signatures = [], this.feePayer = void 0, this.instructions = [], this.recentBlockhash = void 0, this.lastValidBlockHeight = void 0, this.nonceInfo = void 0, this._message = void 0, this._json = void 0, !!e)
      if (e.feePayer && (this.feePayer = e.feePayer), e.signatures && (this.signatures = e.signatures), Object.prototype.hasOwnProperty.call(e, "lastValidBlockHeight")) {
        const {
          blockhash: r,
          lastValidBlockHeight: n
        } = e;
        this.recentBlockhash = r, this.lastValidBlockHeight = n;
      } else {
        const {
          recentBlockhash: r,
          nonceInfo: n
        } = e;
        n && (this.nonceInfo = n), this.recentBlockhash = r;
      }
  }
  /**
   * @internal
   */
  toJSON() {
    return {
      recentBlockhash: this.recentBlockhash || null,
      feePayer: this.feePayer ? this.feePayer.toJSON() : null,
      nonceInfo: this.nonceInfo ? {
        nonce: this.nonceInfo.nonce,
        nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
      } : null,
      instructions: this.instructions.map((e) => e.toJSON()),
      signers: this.signatures.map(({
        publicKey: e
      }) => e.toJSON())
    };
  }
  /**
   * Add one or more instructions to this Transaction
   */
  add(...e) {
    if (e.length === 0)
      throw new Error("No instructions");
    return e.forEach((r) => {
      "instructions" in r ? this.instructions = this.instructions.concat(r.instructions) : "data" in r && "programId" in r && "keys" in r ? this.instructions.push(r) : this.instructions.push(new Bg(r));
    }), this;
  }
  /**
   * Compile transaction data
   */
  compileMessage() {
    if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json))
      return this._message;
    let e, r;
    if (this.nonceInfo ? (e = this.nonceInfo.nonce, this.instructions[0] != this.nonceInfo.nonceInstruction ? r = [this.nonceInfo.nonceInstruction, ...this.instructions] : r = this.instructions) : (e = this.recentBlockhash, r = this.instructions), !e)
      throw new Error("Transaction recentBlockhash required");
    r.length < 1 && console.warn("No instructions provided");
    let n;
    if (this.feePayer)
      n = this.feePayer;
    else if (this.signatures.length > 0 && this.signatures[0].publicKey)
      n = this.signatures[0].publicKey;
    else
      throw new Error("Transaction fee payer required");
    for (let b = 0; b < r.length; b++)
      if (r[b].programId === void 0)
        throw new Error(`Transaction instruction index ${b} has undefined program id`);
    const i = [], o = [];
    r.forEach((b) => {
      b.keys.forEach((A) => {
        o.push({
          ...A
        });
      });
      const w = b.programId.toString();
      i.includes(w) || i.push(w);
    }), i.forEach((b) => {
      o.push({
        pubkey: new wt(b),
        isSigner: !1,
        isWritable: !1
      });
    });
    const a = [];
    o.forEach((b) => {
      const w = b.pubkey.toString(), A = a.findIndex((M) => M.pubkey.toString() === w);
      A > -1 ? (a[A].isWritable = a[A].isWritable || b.isWritable, a[A].isSigner = a[A].isSigner || b.isSigner) : a.push(b);
    }), a.sort(function(b, w) {
      return b.isSigner !== w.isSigner ? b.isSigner ? -1 : 1 : b.isWritable !== w.isWritable ? b.isWritable ? -1 : 1 : b.pubkey.toBase58().localeCompare(w.pubkey.toBase58());
    });
    const s = a.findIndex((b) => b.pubkey.equals(n));
    if (s > -1) {
      const [b] = a.splice(s, 1);
      b.isSigner = !0, b.isWritable = !0, a.unshift(b);
    } else
      a.unshift({
        pubkey: n,
        isSigner: !0,
        isWritable: !0
      });
    for (const b of this.signatures) {
      const w = a.findIndex((A) => A.pubkey.equals(b.publicKey));
      if (w > -1)
        a[w].isSigner || (a[w].isSigner = !0, console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release."));
      else
        throw new Error(`unknown signer: ${b.publicKey.toString()}`);
    }
    let f = 0, u = 0, c = 0;
    const d = [], l = [];
    a.forEach(({
      pubkey: b,
      isSigner: w,
      isWritable: A
    }) => {
      w ? (d.push(b.toString()), f += 1, A || (u += 1)) : (l.push(b.toString()), A || (c += 1));
    });
    const h = d.concat(l), y = r.map((b) => {
      const {
        data: w,
        programId: A
      } = b;
      return {
        programIdIndex: h.indexOf(A.toString()),
        accounts: b.keys.map((M) => h.indexOf(M.pubkey.toString())),
        data: fr.encode(w)
      };
    });
    return y.forEach((b) => {
      Or(b.programIdIndex >= 0), b.accounts.forEach((w) => Or(w >= 0));
    }), new O0({
      header: {
        numRequiredSignatures: f,
        numReadonlySignedAccounts: u,
        numReadonlyUnsignedAccounts: c
      },
      accountKeys: h,
      recentBlockhash: e,
      instructions: y
    });
  }
  /**
   * @internal
   */
  _compile() {
    const e = this.compileMessage(), r = e.accountKeys.slice(0, e.header.numRequiredSignatures);
    return this.signatures.length === r.length && this.signatures.every((i, o) => r[o].equals(i.publicKey)) || (this.signatures = r.map((n) => ({
      signature: null,
      publicKey: n
    }))), e;
  }
  /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */
  serializeMessage() {
    return this._compile().serialize();
  }
  /**
   * Get the estimated fee associated with a transaction
   */
  async getEstimatedFee(e) {
    return (await e.getFeeForMessage(this.compileMessage())).value;
  }
  /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */
  setSigners(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set();
    this.signatures = e.filter((n) => {
      const i = n.toString();
      return r.has(i) ? !1 : (r.add(i), !0);
    }).map((n) => ({
      signature: null,
      publicKey: n
    }));
  }
  /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   */
  sign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set(), n = [];
    for (const o of e) {
      const a = o.publicKey.toString();
      r.has(a) || (r.add(a), n.push(o));
    }
    this.signatures = n.map((o) => ({
      signature: null,
      publicKey: o.publicKey
    }));
    const i = this._compile();
    this._partialSign(i, ...n);
  }
  /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   */
  partialSign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set(), n = [];
    for (const o of e) {
      const a = o.publicKey.toString();
      r.has(a) || (r.add(a), n.push(o));
    }
    const i = this._compile();
    this._partialSign(i, ...n);
  }
  /**
   * @internal
   */
  _partialSign(e, ...r) {
    const n = e.serialize();
    r.forEach((i) => {
      const o = w6(n, i.secretKey);
      this._addSignature(i.publicKey, i1(o));
    });
  }
  /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   */
  addSignature(e, r) {
    this._compile(), this._addSignature(e, r);
  }
  /**
   * @internal
   */
  _addSignature(e, r) {
    Or(r.length === 64);
    const n = this.signatures.findIndex((i) => e.equals(i.publicKey));
    if (n < 0)
      throw new Error(`unknown signer: ${e.toString()}`);
    this.signatures[n].signature = mt.Buffer.from(r);
  }
  /**
   * Verify signatures of a complete, signed Transaction
   */
  verifySignatures() {
    return this._verifySignatures(this.serializeMessage(), !0);
  }
  /**
   * @internal
   */
  _verifySignatures(e, r) {
    for (const {
      signature: n,
      publicKey: i
    } of this.signatures)
      if (n === null) {
        if (r)
          return !1;
      } else if (!GS(n, e, i.toBuffer()))
        return !1;
    return !0;
  }
  /**
   * Serialize the Transaction in the wire format.
   */
  serialize(e) {
    const {
      requireAllSignatures: r,
      verifySignatures: n
    } = Object.assign({
      requireAllSignatures: !0,
      verifySignatures: !0
    }, e), i = this.serializeMessage();
    if (n && !this._verifySignatures(i, r))
      throw new Error("Signature verification failed");
    return this._serialize(i);
  }
  /**
   * @internal
   */
  _serialize(e) {
    const {
      signatures: r
    } = this, n = [];
    Rn(n, r.length);
    const i = n.length + r.length * 64 + e.length, o = mt.Buffer.alloc(i);
    return Or(r.length < 256), mt.Buffer.from(n).copy(o, 0), r.forEach(({
      signature: a
    }, s) => {
      a !== null && (Or(a.length === 64, "signature has invalid length"), mt.Buffer.from(a).copy(o, n.length + s * 64));
    }), e.copy(o, n.length + r.length * 64), Or(o.length <= Ma, `Transaction too large: ${o.length} > ${Ma}`), o;
  }
  /**
   * Deprecated method
   * @internal
   */
  get keys() {
    return Or(this.instructions.length === 1), this.instructions[0].keys.map((e) => e.pubkey);
  }
  /**
   * Deprecated method
   * @internal
   */
  get programId() {
    return Or(this.instructions.length === 1), this.instructions[0].programId;
  }
  /**
   * Deprecated method
   * @internal
   */
  get data() {
    return Or(this.instructions.length === 1), this.instructions[0].data;
  }
  /**
   * Parse a wire transaction into a Transaction object.
   */
  static from(e) {
    let r = [...e];
    const n = Mn(r);
    let i = [];
    for (let o = 0; o < n; o++) {
      const a = r.slice(0, zs);
      r = r.slice(zs), i.push(fr.encode(mt.Buffer.from(a)));
    }
    return C0.populate(O0.from(r), i);
  }
  /**
   * Populate Transaction object from message and signatures
   */
  static populate(e, r = []) {
    const n = new C0();
    return n.recentBlockhash = e.recentBlockhash, e.header.numRequiredSignatures > 0 && (n.feePayer = e.accountKeys[0]), r.forEach((i, o) => {
      const a = {
        signature: i == fr.encode(i7) ? null : fr.decode(i),
        publicKey: e.accountKeys[o]
      };
      n.signatures.push(a);
    }), e.instructions.forEach((i) => {
      const o = i.accounts.map((a) => {
        const s = e.accountKeys[a];
        return {
          pubkey: s,
          isSigner: n.signatures.some((f) => f.publicKey.toString() === s.toString()) || e.isAccountSigner(a),
          isWritable: e.isAccountWritable(a)
        };
      });
      n.instructions.push(new Bg({
        keys: o,
        programId: e.accountKeys[i.programIdIndex],
        data: fr.decode(i.data)
      }));
    }), n._message = e, n._json = n.toJSON(), n;
  }
};
class $c {
  get version() {
    return this.message.version;
  }
  constructor(e, r) {
    if (this.signatures = void 0, this.message = void 0, r !== void 0)
      Or(r.length === e.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures"), this.signatures = r;
    else {
      const n = [];
      for (let i = 0; i < e.header.numRequiredSignatures; i++)
        n.push(new Uint8Array(zs));
      this.signatures = n;
    }
    this.message = e;
  }
  serialize() {
    const e = this.message.serialize(), r = Array();
    Rn(r, this.signatures.length);
    const n = et([yr(r.length, "encodedSignaturesLength"), ln(QS(), this.signatures.length, "signatures"), yr(e.length, "serializedMessage")]), i = new Uint8Array(2048), o = n.encode({
      encodedSignaturesLength: new Uint8Array(r),
      signatures: this.signatures,
      serializedMessage: e
    }, i);
    return i.slice(0, o);
  }
  static deserialize(e) {
    let r = [...e];
    const n = [], i = Mn(r);
    for (let a = 0; a < i; a++)
      n.push(new Uint8Array(r.splice(0, zs)));
    const o = x6.deserialize(new Uint8Array(r));
    return new $c(o, n);
  }
  sign(e) {
    const r = this.message.serialize(), n = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
    for (const i of e) {
      const o = n.findIndex((a) => a.equals(i.publicKey));
      Or(o >= 0, `Cannot sign with non signer key ${i.publicKey.toBase58()}`), this.signatures[o] = w6(r, i.secretKey);
    }
  }
  addSignature(e, r) {
    Or(r.byteLength === 64, "Signature must be 64 bytes long");
    const i = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures).findIndex((o) => o.equals(e));
    Or(i >= 0, `Can not add signature; \`${e.toBase58()}\` is not required to sign this transaction`), this.signatures[i] = r;
  }
}
new wt("SysvarC1ock11111111111111111111111111111111");
new wt("SysvarEpochSchedu1e111111111111111111111111");
new wt("Sysvar1nstructions1111111111111111111111111");
new wt("SysvarRecentB1ockHashes11111111111111111111");
new wt("SysvarRent111111111111111111111111111111111");
new wt("SysvarRewards111111111111111111111111111111");
new wt("SysvarS1otHashes111111111111111111111111111");
new wt("SysvarS1otHistory11111111111111111111111111");
new wt("SysvarStakeHistory1111111111111111111111111");
const a7 = $r("lamportsPerSignature"), s7 = et([ft("version"), ft("state"), Ft("authorizedPubkey"), Ft("nonce"), et([a7], "feeCalculator")]);
s7.span;
var Cf = {};
Object.defineProperty(Cf, "__esModule", { value: !0 });
function f7(t) {
  {
    const e = Ie.from(t);
    e.reverse();
    const r = e.toString("hex");
    return r.length === 0 ? BigInt(0) : BigInt(`0x${r}`);
  }
}
var c7 = Cf.toBigIntLE = f7;
function u7(t) {
  {
    const e = t.toString("hex");
    return e.length === 0 ? BigInt(0) : BigInt(`0x${e}`);
  }
}
Cf.toBigIntBE = u7;
function d7(t, e) {
  {
    const r = t.toString(16), n = Ie.from(r.padStart(e * 2, "0").slice(0, e * 2), "hex");
    return n.reverse(), n;
  }
}
var l7 = Cf.toBufferLE = d7;
function h7(t, e) {
  {
    const r = t.toString(16);
    return Ie.from(r.padStart(e * 2, "0").slice(0, e * 2), "hex");
  }
}
Cf.toBufferBE = h7;
const p7 = (t) => {
  const e = t.decode.bind(t), r = t.encode.bind(t);
  return {
    decode: e,
    encode: r
  };
}, y7 = (t) => (e) => {
  const r = yr(t, e), {
    encode: n,
    decode: i
  } = p7(r), o = r;
  return o.decode = (a, s) => {
    const f = i(a, s);
    return c7(mt.Buffer.from(f));
  }, o.encode = (a, s, f) => {
    const u = l7(a, t);
    return n(u, s, f);
  }, o;
}, qa = y7(8);
Object.freeze({
  Create: {
    index: 0,
    layout: et([ft("instruction"), Bn("lamports"), Bn("space"), Ft("programId")])
  },
  Assign: {
    index: 1,
    layout: et([ft("instruction"), Ft("programId")])
  },
  Transfer: {
    index: 2,
    layout: et([ft("instruction"), qa("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: et([ft("instruction"), Ft("base"), wa("seed"), Bn("lamports"), Bn("space"), Ft("programId")])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: et([ft("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: et([ft("instruction"), Bn("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: et([ft("instruction"), Ft("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: et([ft("instruction"), Ft("authorized")])
  },
  Allocate: {
    index: 8,
    layout: et([ft("instruction"), Bn("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: et([ft("instruction"), Ft("base"), wa("seed"), Bn("space"), Ft("programId")])
  },
  AssignWithSeed: {
    index: 10,
    layout: et([ft("instruction"), Ft("base"), wa("seed"), Ft("programId")])
  },
  TransferWithSeed: {
    index: 11,
    layout: et([ft("instruction"), qa("lamports"), wa("seed"), Ft("programId")])
  },
  UpgradeNonceAccount: {
    index: 12,
    layout: et([ft("instruction")])
  }
});
new wt("11111111111111111111111111111111");
new wt("BPFLoader2111111111111111111111111111111111");
et([
  ft("typeIndex"),
  qa("deactivationSlot"),
  $r("lastExtendedSlot"),
  Xt("lastExtendedStartIndex"),
  Xt(),
  // option
  ln(Ft(), Ro(Xt(), -1), "authority")
]);
const Pr = kf(e1(wt), Ke(), (t) => new wt(t)), _6 = t1([Ke(), vr("base64")]), a1 = kf(e1(mt.Buffer), _6, (t) => mt.Buffer.from(t[0], "base64"));
function E6(t) {
  return wn([Pe({
    jsonrpc: vr("2.0"),
    id: Ke(),
    result: t
  }), Pe({
    jsonrpc: vr("2.0"),
    id: Ke(),
    error: Pe({
      code: Of(),
      message: Ke(),
      data: Ot(dS())
    })
  })]);
}
const b7 = E6(Of());
function Nr(t) {
  return kf(E6(t), b7, (e) => "error" in e ? e : {
    ...e,
    result: qs(e.result, t)
  });
}
function ai(t) {
  return Nr(Pe({
    context: Pe({
      slot: _e()
    }),
    value: t
  }));
}
function sd(t) {
  return Pe({
    context: Pe({
      slot: _e()
    }),
    value: t
  });
}
const g7 = Pe({
  foundation: _e(),
  foundationTerm: _e(),
  initial: _e(),
  taper: _e(),
  terminal: _e()
});
Nr(ot(bt(Pe({
  epoch: _e(),
  effectiveSlot: _e(),
  amount: _e(),
  postBalance: _e()
}))));
const v7 = Pe({
  epoch: _e(),
  slotIndex: _e(),
  slotsInEpoch: _e(),
  absoluteSlot: _e(),
  blockHeight: Ot(_e()),
  transactionCount: Ot(_e())
}), m7 = Pe({
  slotsPerEpoch: _e(),
  leaderScheduleSlotOffset: _e(),
  warmup: Fi(),
  firstNormalEpoch: _e(),
  firstNormalSlot: _e()
}), w7 = l6(Ke(), ot(_e())), Zo = bt(wn([Pe({}), Ke()])), x7 = Pe({
  err: Zo
}), _7 = vr("receivedSignature");
Pe({
  "solana-core": Ke(),
  "feature-set": Ot(_e())
});
ai(Pe({
  err: bt(wn([Pe({}), Ke()])),
  logs: bt(ot(Ke())),
  accounts: Ot(bt(ot(bt(Pe({
    executable: Fi(),
    owner: Ke(),
    lamports: _e(),
    data: ot(Ke()),
    rentEpoch: Ot(_e())
  }))))),
  unitsConsumed: Ot(_e()),
  returnData: Ot(bt(Pe({
    programId: Ke(),
    data: t1([Ke(), vr("base64")])
  })))
}));
ai(Pe({
  byIdentity: l6(Ke(), ot(_e())),
  range: Pe({
    firstSlot: _e(),
    lastSlot: _e()
  })
}));
Nr(g7);
Nr(v7);
Nr(m7);
Nr(w7);
Nr(_e());
ai(Pe({
  total: _e(),
  circulating: _e(),
  nonCirculating: _e(),
  nonCirculatingAccounts: ot(Pr)
}));
const E7 = Pe({
  amount: Ke(),
  uiAmount: bt(_e()),
  decimals: _e(),
  uiAmountString: Ot(Ke())
});
ai(ot(Pe({
  address: Pr,
  amount: Ke(),
  uiAmount: bt(_e()),
  decimals: _e(),
  uiAmountString: Ot(Ke())
})));
ai(ot(Pe({
  pubkey: Pr,
  account: Pe({
    executable: Fi(),
    owner: Pr,
    lamports: _e(),
    data: a1,
    rentEpoch: _e()
  })
})));
const P0 = Pe({
  program: Ke(),
  parsed: Of(),
  space: _e()
});
ai(ot(Pe({
  pubkey: Pr,
  account: Pe({
    executable: Fi(),
    owner: Pr,
    lamports: _e(),
    data: P0,
    rentEpoch: _e()
  })
})));
ai(ot(Pe({
  lamports: _e(),
  address: Pr
})));
const s1 = Pe({
  executable: Fi(),
  owner: Pr,
  lamports: _e(),
  data: a1,
  rentEpoch: _e()
});
Pe({
  pubkey: Pr,
  account: s1
});
const S7 = kf(wn([e1(mt.Buffer), P0]), wn([_6, P0]), (t) => Array.isArray(t) ? qs(t, a1) : t), A7 = Pe({
  executable: Fi(),
  owner: Pr,
  lamports: _e(),
  data: S7,
  rentEpoch: _e()
});
Pe({
  pubkey: Pr,
  account: A7
});
Pe({
  state: wn([vr("active"), vr("inactive"), vr("activating"), vr("deactivating")]),
  active: _e(),
  inactive: _e()
});
Nr(ot(Pe({
  signature: Ke(),
  slot: _e(),
  err: Zo,
  memo: bt(Ke()),
  blockTime: Ot(bt(_e()))
})));
Nr(ot(Pe({
  signature: Ke(),
  slot: _e(),
  err: Zo,
  memo: bt(Ke()),
  blockTime: Ot(bt(_e()))
})));
Pe({
  subscription: _e(),
  result: sd(s1)
});
const I7 = Pe({
  pubkey: Pr,
  account: s1
});
Pe({
  subscription: _e(),
  result: sd(I7)
});
const B7 = Pe({
  parent: _e(),
  slot: _e(),
  root: _e()
});
Pe({
  subscription: _e(),
  result: B7
});
const M7 = wn([Pe({
  type: wn([vr("firstShredReceived"), vr("completed"), vr("optimisticConfirmation"), vr("root")]),
  slot: _e(),
  timestamp: _e()
}), Pe({
  type: vr("createdBank"),
  parent: _e(),
  slot: _e(),
  timestamp: _e()
}), Pe({
  type: vr("frozen"),
  slot: _e(),
  timestamp: _e(),
  stats: Pe({
    numTransactionEntries: _e(),
    numSuccessfulTransactions: _e(),
    numFailedTransactions: _e(),
    maxTransactionsPerEntry: _e()
  })
}), Pe({
  type: vr("dead"),
  slot: _e(),
  timestamp: _e(),
  err: Ke()
})]);
Pe({
  subscription: _e(),
  result: M7
});
Pe({
  subscription: _e(),
  result: sd(wn([x7, _7]))
});
Pe({
  subscription: _e(),
  result: _e()
});
Pe({
  pubkey: Ke(),
  gossip: bt(Ke()),
  tpu: bt(Ke()),
  rpc: bt(Ke()),
  version: bt(Ke())
});
const Mg = Pe({
  votePubkey: Ke(),
  nodePubkey: Ke(),
  activatedStake: _e(),
  epochVoteAccount: Fi(),
  epochCredits: ot(t1([_e(), _e(), _e()])),
  commission: _e(),
  lastVote: _e(),
  rootSlot: bt(_e())
});
Nr(Pe({
  current: ot(Mg),
  delinquent: ot(Mg)
}));
const R7 = wn([vr("processed"), vr("confirmed"), vr("finalized")]), T7 = Pe({
  slot: _e(),
  confirmations: bt(_e()),
  err: Zo,
  confirmationStatus: Ot(R7)
});
ai(ot(bt(T7)));
Nr(_e());
const S6 = Pe({
  accountKey: Pr,
  writableIndexes: ot(_e()),
  readonlyIndexes: ot(_e())
}), f1 = Pe({
  signatures: ot(Ke()),
  message: Pe({
    accountKeys: ot(Ke()),
    header: Pe({
      numRequiredSignatures: _e(),
      numReadonlySignedAccounts: _e(),
      numReadonlyUnsignedAccounts: _e()
    }),
    instructions: ot(Pe({
      accounts: ot(_e()),
      data: Ke(),
      programIdIndex: _e()
    })),
    recentBlockhash: Ke(),
    addressTableLookups: Ot(ot(S6))
  })
}), A6 = Pe({
  parsed: Of(),
  program: Ke(),
  programId: Pr
}), I6 = Pe({
  accounts: ot(Pr),
  data: Ke(),
  programId: Pr
}), O7 = wn([I6, A6]), k7 = wn([Pe({
  parsed: Of(),
  program: Ke(),
  programId: Ke()
}), Pe({
  accounts: ot(Ke()),
  data: Ke(),
  programId: Ke()
})]), B6 = kf(O7, k7, (t) => "accounts" in t ? qs(t, I6) : qs(t, A6)), C7 = Pe({
  signatures: ot(Ke()),
  message: Pe({
    accountKeys: ot(Pe({
      pubkey: Pr,
      signer: Fi(),
      writable: Fi(),
      source: Ot(wn([vr("transaction"), vr("lookupTable")]))
    })),
    instructions: ot(B6),
    recentBlockhash: Ke(),
    addressTableLookups: Ot(bt(ot(S6)))
  })
}), qc = Pe({
  accountIndex: _e(),
  mint: Ke(),
  owner: Ot(Ke()),
  uiTokenAmount: E7
}), M6 = Pe({
  writable: ot(Pr),
  readonly: ot(Pr)
}), c1 = Pe({
  err: Zo,
  fee: _e(),
  innerInstructions: Ot(bt(ot(Pe({
    index: _e(),
    instructions: ot(Pe({
      accounts: ot(_e()),
      data: Ke(),
      programIdIndex: _e()
    }))
  })))),
  preBalances: ot(_e()),
  postBalances: ot(_e()),
  logMessages: Ot(bt(ot(Ke()))),
  preTokenBalances: Ot(bt(ot(qc))),
  postTokenBalances: Ot(bt(ot(qc))),
  loadedAddresses: Ot(M6),
  computeUnitsConsumed: Ot(_e())
}), P7 = Pe({
  err: Zo,
  fee: _e(),
  innerInstructions: Ot(bt(ot(Pe({
    index: _e(),
    instructions: ot(B6)
  })))),
  preBalances: ot(_e()),
  postBalances: ot(_e()),
  logMessages: Ot(bt(ot(Ke()))),
  preTokenBalances: Ot(bt(ot(qc))),
  postTokenBalances: Ot(bt(ot(qc))),
  loadedAddresses: Ot(M6),
  computeUnitsConsumed: Ot(_e())
}), u1 = wn([vr(0), vr("legacy")]);
Nr(bt(Pe({
  blockhash: Ke(),
  previousBlockhash: Ke(),
  parentSlot: _e(),
  transactions: ot(Pe({
    transaction: f1,
    meta: bt(c1),
    version: Ot(u1)
  })),
  rewards: Ot(ot(Pe({
    pubkey: Ke(),
    lamports: _e(),
    postBalance: bt(_e()),
    rewardType: bt(Ke())
  }))),
  blockTime: bt(_e()),
  blockHeight: bt(_e())
})));
Nr(bt(Pe({
  blockhash: Ke(),
  previousBlockhash: Ke(),
  parentSlot: _e(),
  transactions: ot(Pe({
    transaction: f1,
    meta: bt(c1)
  })),
  rewards: Ot(ot(Pe({
    pubkey: Ke(),
    lamports: _e(),
    postBalance: bt(_e()),
    rewardType: bt(Ke())
  }))),
  blockTime: bt(_e())
})));
Nr(bt(Pe({
  blockhash: Ke(),
  previousBlockhash: Ke(),
  parentSlot: _e(),
  signatures: ot(Ke()),
  blockTime: bt(_e())
})));
Nr(bt(Pe({
  slot: _e(),
  meta: c1,
  blockTime: Ot(bt(_e())),
  transaction: f1,
  version: Ot(u1)
})));
Nr(bt(Pe({
  slot: _e(),
  transaction: C7,
  meta: bt(P7),
  blockTime: Ot(bt(_e())),
  version: Ot(u1)
})));
ai(Pe({
  blockhash: Ke(),
  feeCalculator: Pe({
    lamportsPerSignature: _e()
  })
}));
ai(Pe({
  blockhash: Ke(),
  lastValidBlockHeight: _e()
}));
const N7 = Pe({
  slot: _e(),
  numTransactions: _e(),
  numSlots: _e(),
  samplePeriodSecs: _e()
});
Nr(ot(N7));
ai(bt(Pe({
  feeCalculator: Pe({
    lamportsPerSignature: _e()
  })
})));
Nr(Ke());
Nr(Ke());
const U7 = Pe({
  err: Zo,
  logs: ot(Ke()),
  signature: Ke()
});
Pe({
  result: sd(U7),
  subscription: _e()
});
Object.freeze({
  CreateLookupTable: {
    index: 0,
    layout: et([ft("instruction"), qa("recentSlot"), Xt("bumpSeed")])
  },
  FreezeLookupTable: {
    index: 1,
    layout: et([ft("instruction")])
  },
  ExtendLookupTable: {
    index: 2,
    layout: et([ft("instruction"), qa(), ln(Ft(), Ro(ft(), -8), "addresses")])
  },
  DeactivateLookupTable: {
    index: 3,
    layout: et([ft("instruction")])
  },
  CloseLookupTable: {
    index: 4,
    layout: et([ft("instruction")])
  }
});
new wt("AddressLookupTab1e1111111111111111111111111");
Object.freeze({
  RequestUnits: {
    index: 0,
    layout: et([Xt("instruction"), ft("units"), ft("additionalFee")])
  },
  RequestHeapFrame: {
    index: 1,
    layout: et([Xt("instruction"), ft("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: et([Xt("instruction"), ft("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: et([Xt("instruction"), qa("microLamports")])
  }
});
new wt("ComputeBudget111111111111111111111111111111");
et([Xt("numSignatures"), Xt("padding"), qn("signatureOffset"), qn("signatureInstructionIndex"), qn("publicKeyOffset"), qn("publicKeyInstructionIndex"), qn("messageDataOffset"), qn("messageDataSize"), qn("messageInstructionIndex")]);
new wt("Ed25519SigVerify111111111111111111111111111");
var F7 = {}, L7 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: F7
});
/*! noble-secp256k1 - MIT License (c) 2019 Paul Miller (paulmillr.com) */
const er = BigInt(0), gr = BigInt(1), Yi = BigInt(2), ks = BigInt(3), j7 = BigInt(8), Br = Object.freeze({
  a: er,
  b: BigInt(7),
  P: BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"),
  n: BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"),
  h: gr,
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee")
});
function Rg(t) {
  const { a: e, b: r } = Br, n = Ze(t * t), i = Ze(n * t);
  return Ze(i + e * t + r);
}
const ec = Br.a === er;
class D7 extends Error {
  constructor(e) {
    super(e);
  }
}
class ir {
  constructor(e, r, n) {
    this.x = e, this.y = r, this.z = n;
  }
  static fromAffine(e) {
    if (!(e instanceof kr))
      throw new TypeError("JacobianPoint#fromAffine: expected Point");
    return new ir(e.x, e.y, gr);
  }
  static toAffineBatch(e) {
    const r = W7(e.map((n) => n.z));
    return e.map((n, i) => n.toAffine(r[i]));
  }
  static normalizeZ(e) {
    return ir.toAffineBatch(e).map(ir.fromAffine);
  }
  equals(e) {
    if (!(e instanceof ir))
      throw new TypeError("JacobianPoint expected");
    const { x: r, y: n, z: i } = this, { x: o, y: a, z: s } = e, f = Ze(i * i), u = Ze(s * s), c = Ze(r * u), d = Ze(o * f), l = Ze(Ze(n * s) * u), h = Ze(Ze(a * i) * f);
    return c === d && l === h;
  }
  negate() {
    return new ir(this.x, Ze(-this.y), this.z);
  }
  double() {
    const { x: e, y: r, z: n } = this, i = Ze(e * e), o = Ze(r * r), a = Ze(o * o), s = e + o, f = Ze(Yi * (Ze(s * s) - i - a)), u = Ze(ks * i), c = Ze(u * u), d = Ze(c - Yi * f), l = Ze(u * (f - d) - j7 * a), h = Ze(Yi * r * n);
    return new ir(d, l, h);
  }
  add(e) {
    if (!(e instanceof ir))
      throw new TypeError("JacobianPoint expected");
    const { x: r, y: n, z: i } = this, { x: o, y: a, z: s } = e;
    if (o === er || a === er)
      return this;
    if (r === er || n === er)
      return e;
    const f = Ze(i * i), u = Ze(s * s), c = Ze(r * u), d = Ze(o * f), l = Ze(Ze(n * s) * u), h = Ze(Ze(a * i) * f), y = Ze(d - c), b = Ze(h - l);
    if (y === er)
      return b === er ? this.double() : ir.ZERO;
    const w = Ze(y * y), A = Ze(y * w), M = Ze(c * w), N = Ze(b * b - A - Yi * M), G = Ze(b * (M - N) - l * A), z = Ze(i * s * y);
    return new ir(N, G, z);
  }
  subtract(e) {
    return this.add(e.negate());
  }
  multiplyUnsafe(e) {
    const r = ir.ZERO;
    if (typeof e == "bigint" && e === er)
      return r;
    let n = Cg(e);
    if (n === gr)
      return this;
    if (!ec) {
      let d = r, l = this;
      for (; n > er; )
        n & gr && (d = d.add(l)), l = l.double(), n >>= gr;
      return d;
    }
    let { k1neg: i, k1: o, k2neg: a, k2: s } = Ng(n), f = r, u = r, c = this;
    for (; o > er || s > er; )
      o & gr && (f = f.add(c)), s & gr && (u = u.add(c)), c = c.double(), o >>= gr, s >>= gr;
    return i && (f = f.negate()), a && (u = u.negate()), u = new ir(Ze(u.x * Br.beta), u.y, u.z), f.add(u);
  }
  precomputeWindow(e) {
    const r = ec ? 128 / e + 1 : 256 / e + 1, n = [];
    let i = this, o = i;
    for (let a = 0; a < r; a++) {
      o = i, n.push(o);
      for (let s = 1; s < 2 ** (e - 1); s++)
        o = o.add(i), n.push(o);
      i = o.double();
    }
    return n;
  }
  wNAF(e, r) {
    !r && this.equals(ir.BASE) && (r = kr.BASE);
    const n = r && r._WINDOW_SIZE || 1;
    if (256 % n)
      throw new Error("Point#wNAF: Invalid precomputation window, must be power of 2");
    let i = r && N0.get(r);
    i || (i = this.precomputeWindow(n), r && n !== 1 && (i = ir.normalizeZ(i), N0.set(r, i)));
    let o = ir.ZERO, a = ir.ZERO;
    const s = 1 + (ec ? 128 / n : 256 / n), f = 2 ** (n - 1), u = BigInt(2 ** n - 1), c = 2 ** n, d = BigInt(n);
    for (let l = 0; l < s; l++) {
      const h = l * f;
      let y = Number(e & u);
      if (e >>= d, y > f && (y -= c, e += gr), y === 0) {
        let b = i[h];
        l % 2 && (b = b.negate()), a = a.add(b);
      } else {
        let b = i[h + Math.abs(y) - 1];
        y < 0 && (b = b.negate()), o = o.add(b);
      }
    }
    return { p: o, f: a };
  }
  multiply(e, r) {
    let n = Cg(e), i, o;
    if (ec) {
      const { k1neg: a, k1: s, k2neg: f, k2: u } = Ng(n);
      let { p: c, f: d } = this.wNAF(s, r), { p: l, f: h } = this.wNAF(u, r);
      a && (c = c.negate()), f && (l = l.negate()), l = new ir(Ze(l.x * Br.beta), l.y, l.z), i = c.add(l), o = d.add(h);
    } else {
      const { p: a, f: s } = this.wNAF(n, r);
      i = a, o = s;
    }
    return ir.normalizeZ([i, o])[0];
  }
  toAffine(e = fd(this.z)) {
    const { x: r, y: n, z: i } = this, o = e, a = Ze(o * o), s = Ze(a * o), f = Ze(r * a), u = Ze(n * s);
    if (Ze(i * o) !== gr)
      throw new Error("invZ was invalid");
    return new kr(f, u);
  }
}
ir.BASE = new ir(Br.Gx, Br.Gy, gr);
ir.ZERO = new ir(er, gr, er);
const N0 = /* @__PURE__ */ new WeakMap();
class kr {
  constructor(e, r) {
    this.x = e, this.y = r;
  }
  _setWindowSize(e) {
    this._WINDOW_SIZE = e, N0.delete(this);
  }
  hasEvenY() {
    return this.y % Yi === er;
  }
  static fromCompressedHex(e) {
    const r = e.length === 32, n = ko(r ? e : e.subarray(1));
    if (!Ah(n))
      throw new Error("Point is not on curve");
    const i = Rg(n);
    let o = K7(i);
    const a = (o & gr) === gr;
    r ? a && (o = Ze(-o)) : (e[0] & 1) === 1 !== a && (o = Ze(-o));
    const s = new kr(n, o);
    return s.assertValidity(), s;
  }
  static fromUncompressedHex(e) {
    const r = ko(e.subarray(1, 33)), n = ko(e.subarray(33, 65)), i = new kr(r, n);
    return i.assertValidity(), i;
  }
  static fromHex(e) {
    const r = U0(e), n = r.length, i = r[0];
    if (n === 32 || n === 33 && (i === 2 || i === 3))
      return this.fromCompressedHex(r);
    if (n === 65 && i === 4)
      return this.fromUncompressedHex(r);
    throw new Error(`Point.fromHex: received invalid point. Expected 32-33 compressed bytes or 65 uncompressed bytes, not ${n}`);
  }
  static fromPrivateKey(e) {
    return kr.BASE.multiply(F0(e));
  }
  static fromSignature(e, r, n) {
    e = U0(e);
    const i = G7(e), { r: o, s: a } = V7(r);
    if (n !== 0 && n !== 1)
      throw new Error("Cannot recover signature: invalid recovery bit");
    const s = n & 1 ? "03" : "02", f = kr.fromHex(s + Ra(o)), { n: u } = Br, c = fd(o, u), d = Ze(-i * c, u), l = Ze(a * c, u), h = kr.BASE.multiplyAndAddUnsafe(f, d, l);
    if (!h)
      throw new Error("Cannot recover signature: point at infinify");
    return h.assertValidity(), h;
  }
  toRawBytes(e = !1) {
    return Oo(this.toHex(e));
  }
  toHex(e = !1) {
    const r = Ra(this.x);
    return e ? `${this.hasEvenY() ? "02" : "03"}${r}` : `04${r}${Ra(this.y)}`;
  }
  toHexX() {
    return this.toHex(!0).slice(2);
  }
  toRawX() {
    return this.toRawBytes(!0).slice(1);
  }
  assertValidity() {
    const e = "Point is not on elliptic curve", { x: r, y: n } = this;
    if (!Ah(r) || !Ah(n))
      throw new Error(e);
    const i = Ze(n * n), o = Rg(r);
    if (Ze(i - o) !== er)
      throw new Error(e);
  }
  equals(e) {
    return this.x === e.x && this.y === e.y;
  }
  negate() {
    return new kr(this.x, Ze(-this.y));
  }
  double() {
    return ir.fromAffine(this).double().toAffine();
  }
  add(e) {
    return ir.fromAffine(this).add(ir.fromAffine(e)).toAffine();
  }
  subtract(e) {
    return this.add(e.negate());
  }
  multiply(e) {
    return ir.fromAffine(this).multiply(e, this).toAffine();
  }
  multiplyAndAddUnsafe(e, r, n) {
    const i = ir.fromAffine(this), o = r === er || r === gr || this !== kr.BASE ? i.multiplyUnsafe(r) : i.multiply(r), a = ir.fromAffine(e).multiplyUnsafe(n), s = o.add(a);
    return s.equals(ir.ZERO) ? void 0 : s.toAffine();
  }
}
kr.BASE = new kr(Br.Gx, Br.Gy);
kr.ZERO = new kr(er, er);
function Tg(t) {
  return Number.parseInt(t[0], 16) >= 8 ? "00" + t : t;
}
function Og(t) {
  if (t.length < 2 || t[0] !== 2)
    throw new Error(`Invalid signature integer tag: ${za(t)}`);
  const e = t[1], r = t.subarray(2, e + 2);
  if (!e || r.length !== e)
    throw new Error("Invalid signature integer: wrong length");
  if (r[0] === 0 && r[1] <= 127)
    throw new Error("Invalid signature integer: trailing length");
  return { data: ko(r), left: t.subarray(e + 2) };
}
function $7(t) {
  if (t.length < 2 || t[0] != 48)
    throw new Error(`Invalid signature tag: ${za(t)}`);
  if (t[1] !== t.length - 2)
    throw new Error("Invalid signature: incorrect length");
  const { data: e, left: r } = Og(t.subarray(2)), { data: n, left: i } = Og(r);
  if (i.length)
    throw new Error(`Invalid signature: left bytes after parsing: ${za(i)}`);
  return { r: e, s: n };
}
class To {
  constructor(e, r) {
    this.r = e, this.s = r, this.assertValidity();
  }
  static fromCompact(e) {
    const r = e instanceof Uint8Array, n = "Signature.fromCompact";
    if (typeof e != "string" && !r)
      throw new TypeError(`${n}: Expected string or Uint8Array`);
    const i = r ? za(e) : e;
    if (i.length !== 128)
      throw new Error(`${n}: Expected 64-byte hex`);
    return new To(zc(i.slice(0, 64)), zc(i.slice(64, 128)));
  }
  static fromDER(e) {
    const r = e instanceof Uint8Array;
    if (typeof e != "string" && !r)
      throw new TypeError("Signature.fromDER: Expected string or Uint8Array");
    const { r: n, s: i } = $7(r ? e : Oo(e));
    return new To(n, i);
  }
  static fromHex(e) {
    return this.fromDER(e);
  }
  assertValidity() {
    const { r: e, s: r } = this;
    if (!Kc(e))
      throw new Error("Invalid Signature: r must be 0 < r < n");
    if (!Kc(r))
      throw new Error("Invalid Signature: s must be 0 < s < n");
  }
  hasHighS() {
    const e = Br.n >> gr;
    return this.s > e;
  }
  normalizeS() {
    return this.hasHighS() ? new To(this.r, Br.n - this.s) : this;
  }
  toDERRawBytes(e = !1) {
    return Oo(this.toDERHex(e));
  }
  toDERHex(e = !1) {
    const r = Tg(ws(this.s));
    if (e)
      return r;
    const n = Tg(ws(this.r)), i = ws(n.length / 2), o = ws(r.length / 2);
    return `30${ws(n.length / 2 + r.length / 2 + 4)}02${i}${n}02${o}${r}`;
  }
  toRawBytes() {
    return this.toDERRawBytes();
  }
  toHex() {
    return this.toDERHex();
  }
  toCompactRawBytes() {
    return Oo(this.toCompactHex());
  }
  toCompactHex() {
    return Ra(this.r) + Ra(this.s);
  }
}
function ms(...t) {
  if (!t.every((n) => n instanceof Uint8Array))
    throw new Error("Uint8Array list expected");
  if (t.length === 1)
    return t[0];
  const e = t.reduce((n, i) => n + i.length, 0), r = new Uint8Array(e);
  for (let n = 0, i = 0; n < t.length; n++) {
    const o = t[n];
    r.set(o, i), i += o.length;
  }
  return r;
}
const q7 = Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function za(t) {
  if (!(t instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  let e = "";
  for (let r = 0; r < t.length; r++)
    e += q7[t[r]];
  return e;
}
const z7 = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
function Ra(t) {
  if (typeof t != "bigint")
    throw new Error("Expected bigint");
  if (!(er <= t && t < z7))
    throw new Error("Expected number < 2^256");
  return t.toString(16).padStart(64, "0");
}
function kg(t) {
  const e = Oo(Ra(t));
  if (e.length !== 32)
    throw new Error("Error: expected 32 bytes");
  return e;
}
function ws(t) {
  const e = t.toString(16);
  return e.length & 1 ? `0${e}` : e;
}
function zc(t) {
  if (typeof t != "string")
    throw new TypeError("hexToNumber: expected string, got " + typeof t);
  return BigInt(`0x${t}`);
}
function Oo(t) {
  if (typeof t != "string")
    throw new TypeError("hexToBytes: expected string, got " + typeof t);
  if (t.length % 2)
    throw new Error("hexToBytes: received invalid unpadded hex" + t.length);
  const e = new Uint8Array(t.length / 2);
  for (let r = 0; r < e.length; r++) {
    const n = r * 2, i = t.slice(n, n + 2), o = Number.parseInt(i, 16);
    if (Number.isNaN(o) || o < 0)
      throw new Error("Invalid byte sequence");
    e[r] = o;
  }
  return e;
}
function ko(t) {
  return zc(za(t));
}
function U0(t) {
  return t instanceof Uint8Array ? Uint8Array.from(t) : Oo(t);
}
function Cg(t) {
  if (typeof t == "number" && Number.isSafeInteger(t) && t > 0)
    return BigInt(t);
  if (typeof t == "bigint" && Kc(t))
    return t;
  throw new TypeError("Expected valid private scalar: 0 < scalar < curve.n");
}
function Ze(t, e = Br.P) {
  const r = t % e;
  return r >= er ? r : e + r;
}
function Fn(t, e) {
  const { P: r } = Br;
  let n = t;
  for (; e-- > er; )
    n *= n, n %= r;
  return n;
}
function K7(t) {
  const { P: e } = Br, r = BigInt(6), n = BigInt(11), i = BigInt(22), o = BigInt(23), a = BigInt(44), s = BigInt(88), f = t * t * t % e, u = f * f * t % e, c = Fn(u, ks) * u % e, d = Fn(c, ks) * u % e, l = Fn(d, Yi) * f % e, h = Fn(l, n) * l % e, y = Fn(h, i) * h % e, b = Fn(y, a) * y % e, w = Fn(b, s) * b % e, A = Fn(w, a) * y % e, M = Fn(A, ks) * u % e, N = Fn(M, o) * h % e, G = Fn(N, r) * f % e;
  return Fn(G, Yi);
}
function fd(t, e = Br.P) {
  if (t === er || e <= er)
    throw new Error(`invert: expected positive integers, got n=${t} mod=${e}`);
  let r = Ze(t, e), n = e, i = er, o = gr;
  for (; r !== er; ) {
    const s = n / r, f = n % r, u = i - o * s;
    n = r, r = f, i = o, o = u;
  }
  if (n !== gr)
    throw new Error("invert: does not exist");
  return Ze(i, e);
}
function W7(t, e = Br.P) {
  const r = new Array(t.length), n = t.reduce((o, a, s) => a === er ? o : (r[s] = o, Ze(o * a, e)), gr), i = fd(n, e);
  return t.reduceRight((o, a, s) => a === er ? o : (r[s] = Ze(o * r[s], e), Ze(o * a, e)), i), r;
}
const Pg = (t, e) => (t + e / Yi) / e, H7 = {
  a1: BigInt("0x3086d221a7d46bcde86c90e49284eb15"),
  b1: -gr * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"),
  a2: BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"),
  b2: BigInt("0x3086d221a7d46bcde86c90e49284eb15"),
  POW_2_128: BigInt("0x100000000000000000000000000000000")
};
function Ng(t) {
  const { n: e } = Br, { a1: r, b1: n, a2: i, b2: o, POW_2_128: a } = H7, s = Pg(o * t, e), f = Pg(-n * t, e);
  let u = Ze(t - s * r - f * i, e), c = Ze(-s * n - f * o, e);
  const d = u > a, l = c > a;
  if (d && (u = e - u), l && (c = e - c), u > a || c > a)
    throw new Error("splitScalarEndo: Endomorphism failed, k=" + t);
  return { k1neg: d, k1: u, k2neg: l, k2: c };
}
function G7(t) {
  const { n: e } = Br, n = t.length * 8 - 256;
  let i = ko(t);
  return n > 0 && (i = i >> BigInt(n)), i >= e && (i -= e), i;
}
let Ta, Sh;
function Kc(t) {
  return er < t && t < Br.n;
}
function Ah(t) {
  return er < t && t < Br.P;
}
function F0(t) {
  let e;
  if (typeof t == "bigint")
    e = t;
  else if (typeof t == "number" && Number.isSafeInteger(t) && t > 0)
    e = BigInt(t);
  else if (typeof t == "string") {
    if (t.length !== 64)
      throw new Error("Expected 32 bytes of private key");
    e = zc(t);
  } else if (t instanceof Uint8Array) {
    if (t.length !== 32)
      throw new Error("Expected 32 bytes of private key");
    e = ko(t);
  } else
    throw new TypeError("Expected valid private key");
  if (!Kc(e))
    throw new Error("Expected private key: 0 < key < n");
  return e;
}
function V7(t) {
  if (t instanceof To)
    return t.assertValidity(), t;
  try {
    return To.fromDER(t);
  } catch {
    return To.fromCompact(t);
  }
}
kr.BASE._setWindowSize(8);
const An = {
  node: L7,
  web: typeof self == "object" && "crypto" in self ? self.crypto : void 0
}, tc = {}, mo = {
  bytesToHex: za,
  hexToBytes: Oo,
  concatBytes: ms,
  mod: Ze,
  invert: fd,
  isValidPrivateKey(t) {
    try {
      return F0(t), !0;
    } catch {
      return !1;
    }
  },
  _bigintTo32Bytes: kg,
  _normalizePrivateKey: F0,
  hashToPrivateKey: (t) => {
    if (t = U0(t), t.length < 40 || t.length > 1024)
      throw new Error("Expected 40-1024 bytes of private key as per FIPS 186");
    const e = Ze(ko(t), Br.n - gr) + gr;
    return kg(e);
  },
  randomBytes: (t = 32) => {
    if (An.web)
      return An.web.getRandomValues(new Uint8Array(t));
    if (An.node) {
      const { randomBytes: e } = An.node;
      return Uint8Array.from(e(t));
    } else
      throw new Error("The environment doesn't have randomBytes function");
  },
  randomPrivateKey: () => mo.hashToPrivateKey(mo.randomBytes(40)),
  sha256: async (...t) => {
    if (An.web) {
      const e = await An.web.subtle.digest("SHA-256", ms(...t));
      return new Uint8Array(e);
    } else if (An.node) {
      const { createHash: e } = An.node, r = e("sha256");
      return t.forEach((n) => r.update(n)), Uint8Array.from(r.digest());
    } else
      throw new Error("The environment doesn't have sha256 function");
  },
  hmacSha256: async (t, ...e) => {
    if (An.web) {
      const r = await An.web.subtle.importKey("raw", t, { name: "HMAC", hash: { name: "SHA-256" } }, !1, ["sign"]), n = ms(...e), i = await An.web.subtle.sign("HMAC", r, n);
      return new Uint8Array(i);
    } else if (An.node) {
      const { createHmac: r } = An.node, n = r("sha256", t);
      return e.forEach((i) => n.update(i)), Uint8Array.from(n.digest());
    } else
      throw new Error("The environment doesn't have hmac-sha256 function");
  },
  sha256Sync: void 0,
  hmacSha256Sync: void 0,
  taggedHash: async (t, ...e) => {
    let r = tc[t];
    if (r === void 0) {
      const n = await mo.sha256(Uint8Array.from(t, (i) => i.charCodeAt(0)));
      r = ms(n, n), tc[t] = r;
    }
    return mo.sha256(r, ...e);
  },
  taggedHashSync: (t, ...e) => {
    if (typeof Ta != "function")
      throw new D7("sha256Sync is undefined, you need to set it");
    let r = tc[t];
    if (r === void 0) {
      const n = Ta(Uint8Array.from(t, (i) => i.charCodeAt(0)));
      r = ms(n, n), tc[t] = r;
    }
    return Ta(r, ...e);
  },
  precompute(t = 8, e = kr.BASE) {
    const r = e === kr.BASE ? e : new kr(e.x, e.y);
    return r._setWindowSize(t), r.multiply(ks), r;
  }
};
Object.defineProperties(mo, {
  sha256Sync: {
    configurable: !1,
    get() {
      return Ta;
    },
    set(t) {
      Ta || (Ta = t);
    }
  },
  hmacSha256Sync: {
    configurable: !1,
    get() {
      return Sh;
    },
    set(t) {
      Sh || (Sh = t);
    }
  }
});
mo.hmacSha256Sync = (t, ...e) => {
  const r = Yx("sha256", t);
  return e.forEach((n) => r.update(n)), new Uint8Array(r.digest());
};
mo.isValidPrivateKey;
et([Xt("numSignatures"), qn("signatureOffset"), Xt("signatureInstructionIndex"), qn("ethAddressOffset"), Xt("ethAddressInstructionIndex"), qn("messageDataOffset"), qn("messageDataSize"), Xt("messageInstructionIndex"), yr(20, "ethAddress"), yr(64, "signature"), Xt("recoveryId")]);
new wt("KeccakSecp256k11111111111111111111111111111");
new wt("StakeConfig11111111111111111111111111111111");
class Ug {
  /** Unix timestamp of lockup expiration */
  /** Epoch of lockup expiration */
  /** Lockup custodian authority */
  /**
   * Create a new Lockup object
   */
  constructor(e, r, n) {
    this.unixTimestamp = void 0, this.epoch = void 0, this.custodian = void 0, this.unixTimestamp = e, this.epoch = r, this.custodian = n;
  }
  /**
   * Default, inactive Lockup value
   */
}
Ug.default = new Ug(0, 0, wt.default);
Object.freeze({
  Initialize: {
    index: 0,
    layout: et([ft("instruction"), e7(), t7()])
  },
  Authorize: {
    index: 1,
    layout: et([ft("instruction"), Ft("newAuthorized"), ft("stakeAuthorizationType")])
  },
  Delegate: {
    index: 2,
    layout: et([ft("instruction")])
  },
  Split: {
    index: 3,
    layout: et([ft("instruction"), Bn("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: et([ft("instruction"), Bn("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: et([ft("instruction")])
  },
  Merge: {
    index: 7,
    layout: et([ft("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: et([ft("instruction"), Ft("newAuthorized"), ft("stakeAuthorizationType"), wa("authoritySeed"), Ft("authorityOwner")])
  }
});
new wt("Stake11111111111111111111111111111111111111");
Object.freeze({
  InitializeAccount: {
    index: 0,
    layout: et([ft("instruction"), r7()])
  },
  Authorize: {
    index: 1,
    layout: et([ft("instruction"), Ft("newAuthorized"), ft("voteAuthorizationType")])
  },
  Withdraw: {
    index: 3,
    layout: et([ft("instruction"), Bn("lamports")])
  },
  AuthorizeWithSeed: {
    index: 10,
    layout: et([ft("instruction"), n7()])
  }
});
new wt("Vote111111111111111111111111111111111111111");
new wt("Va1idator1nfo111111111111111111111111111111");
Pe({
  name: Ke(),
  website: Ot(Ke()),
  details: Ot(Ke()),
  keybaseUsername: Ot(Ke())
});
new wt("Vote111111111111111111111111111111111111111");
et([
  Ft("nodePubkey"),
  Ft("authorizedWithdrawer"),
  Xt("commission"),
  $r(),
  // votes.length
  ln(et([$r("slot"), ft("confirmationCount")]), Ro(ft(), -8), "votes"),
  Xt("rootSlotValid"),
  $r("rootSlot"),
  $r(),
  // authorizedVoters.length
  ln(et([$r("epoch"), Ft("authorizedVoter")]), Ro(ft(), -8), "authorizedVoters"),
  et([ln(et([Ft("authorizedPubkey"), $r("epochOfLastAuthorizedSwitch"), $r("targetEpoch")]), 32, "buf"), $r("idx"), Xt("isEmpty")], "priorVoters"),
  $r(),
  // epochCredits.length
  ln(et([$r("epoch"), $r("credits"), $r("prevCredits")]), Ro(ft(), -8), "epochCredits"),
  et([$r("slot"), $r("timestamp")], "lastTimestamp")
]);
let Co;
if (typeof Error.captureStackTrace < "u")
  Co = Error.captureStackTrace.bind(Error);
else
  try {
    const t = (i) => {
      try {
        throw new Error(i);
      } catch (o) {
        return o;
      }
    }, e = (i) => i.stack || i.stacktrace, r = e(t("Marker"));
    if (!r)
      throw new Error("No Error.prototype.stack");
    const n = /Marker/.test(r.split(`
`)[0]);
    Co = function(i) {
      const o = e(t());
      if (o === void 0)
        return;
      const a = o.trim().split(`
`).slice(n ? 4 : 3);
      let s;
      Object.defineProperties(i, {
        stack: {
          configurable: !0,
          get: function() {
            return s !== void 0 || (s = [
              `${i.name || "Error"}: ${i.message || ""}`,
              ...a
            ].join(`
`)), s;
          }
        }
      });
    };
  } catch {
    Co = function(e) {
      let r;
      Object.defineProperties(e, {
        stack: {
          configurable: !0,
          get: function() {
            return r !== void 0 || (r = `${e.name || "Error"}: ${e.message || ""}`), r;
          }
        }
      });
    };
  }
class Y7 extends Error {
  constructor() {
    super("The Provider does not support the requested method.");
    Le(this, "code");
    this.name = "UnsupportedMethodError", this.code = 4200, Co(this, this.constructor);
  }
}
class J7 extends Error {
  constructor() {
    super("The Provider is disconnected from all chains.");
    Le(this, "code");
    this.name = "DisconnectedError", this.code = 4900, Co(this, this.constructor);
  }
}
class X7 extends Error {
  constructor(r) {
    super("Missing or invalid parameters.");
    Le(this, "code");
    this.name = "InvalidInputError", this.code = -32e3, r && (this.message = r), Co(this, this.constructor);
  }
}
class Z7 extends Error {
  constructor() {
    super("The requested method is not recognized by the wallet.");
    Le(this, "code");
    this.name = "MethodNotFoundError", this.code = -32601, Co(this, this.constructor);
  }
}
function Q7(t) {
  return new wt(t);
}
function e9(t) {
  return Ie.from(t).toString("base64");
}
function t9(t) {
  if (t.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var e = new Uint8Array(256), r = 0; r < e.length; r++)
    e[r] = 255;
  for (var n = 0; n < t.length; n++) {
    var i = t.charAt(n), o = i.charCodeAt(0);
    if (e[o] !== 255)
      throw new TypeError(i + " is ambiguous");
    e[o] = n;
  }
  var a = t.length, s = t.charAt(0), f = Math.log(a) / Math.log(256), u = Math.log(256) / Math.log(a);
  function c(h) {
    if (h instanceof Uint8Array || (ArrayBuffer.isView(h) ? h = new Uint8Array(h.buffer, h.byteOffset, h.byteLength) : Array.isArray(h) && (h = Uint8Array.from(h))), !(h instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (h.length === 0)
      return "";
    for (var y = 0, b = 0, w = 0, A = h.length; w !== A && h[w] === 0; )
      w++, y++;
    for (var M = (A - w) * u + 1 >>> 0, N = new Uint8Array(M); w !== A; ) {
      for (var G = h[w], z = 0, J = M - 1; (G !== 0 || z < b) && J !== -1; J--, z++)
        G += 256 * N[J] >>> 0, N[J] = G % a >>> 0, G = G / a >>> 0;
      if (G !== 0)
        throw new Error("Non-zero carry");
      b = z, w++;
    }
    for (var oe = M - b; oe !== M && N[oe] === 0; )
      oe++;
    for (var ee = s.repeat(y); oe < M; ++oe)
      ee += t.charAt(N[oe]);
    return ee;
  }
  function d(h) {
    if (typeof h != "string")
      throw new TypeError("Expected String");
    if (h.length === 0)
      return new Uint8Array();
    for (var y = 0, b = 0, w = 0; h[y] === s; )
      b++, y++;
    for (var A = (h.length - y) * f + 1 >>> 0, M = new Uint8Array(A); h[y]; ) {
      var N = e[h.charCodeAt(y)];
      if (N === 255)
        return;
      for (var G = 0, z = A - 1; (N !== 0 || G < w) && z !== -1; z--, G++)
        N += a * M[z] >>> 0, M[z] = N % 256 >>> 0, N = N / 256 >>> 0;
      if (N !== 0)
        throw new Error("Non-zero carry");
      w = G, y++;
    }
    for (var J = A - w; J !== A && M[J] === 0; )
      J++;
    for (var oe = new Uint8Array(b + (A - J)), ee = b; J !== A; )
      oe[ee++] = M[J++];
    return oe;
  }
  function l(h) {
    var y = d(h);
    if (y)
      return y;
    throw new Error("Non-base" + a + " character");
  }
  return {
    encode: c,
    decodeUnsafe: d,
    decode: l
  };
}
var r9 = t9;
const n9 = r9, i9 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var o9 = n9(i9);
eo.sign.signatureLength;
function a9(t) {
  return o9.decode(t);
}
function s9(t) {
  return Ie.from(t, "base64");
}
const f9 = (t) => $e(typeof t == "function", `expected Function, got ${typeof t}`), c9 = (t, e) => (f9(e), t == null ? /* @__PURE__ */ Object.create(null) : Object.fromEntries(Object.entries(t).map(([r, n]) => [r, e(n, r)]))), u9 = (t, e) => {
  if (typeof e == "string") {
    const n = e;
    if (n in {})
      throw new Error("prototype key");
    e = (i) => i[n];
  }
  $e(typeof e == "function", "expected key string or keying function");
  const r = (n) => {
    const i = e(n);
    if (typeof i == "string" && i in {})
      throw new Error("prototype key");
    return i;
  };
  return Object.fromEntries(t.map((n) => [r(n), n]));
};
var po = {}, is = {}, Ii = {}, jr = {}, Wr = {}, R6 = typeof yt == "object" && yt && yt.Object === Object && yt, d9 = typeof self == "object" && self && self.Object === Object && self, T6 = R6 || d9 || Function("return this")(), Ks = T6.Symbol, O6 = Object.prototype, l9 = O6.hasOwnProperty, h9 = O6.toString, xs = Ks ? Ks.toStringTag : void 0;
function p9(t) {
  var e = l9.call(t, xs), r = t[xs];
  try {
    t[xs] = void 0;
    var n = !0;
  } catch {
  }
  var i = h9.call(t);
  return n && (e ? t[xs] = r : delete t[xs]), i;
}
var y9 = Object.prototype, b9 = y9.toString;
function g9(t) {
  return b9.call(t);
}
var v9 = "[object Null]", m9 = "[object Undefined]", Fg = Ks ? Ks.toStringTag : void 0;
function w9(t) {
  return t == null ? t === void 0 ? m9 : v9 : Fg && Fg in Object(t) ? p9(t) : g9(t);
}
Wr.Symbol = Ks;
Wr.baseGetTag = w9;
Wr.freeGlobal = R6;
Wr.root = T6;
const d1 = Wr;
function l1(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
var x9 = "[object AsyncFunction]", _9 = "[object Function]", E9 = "[object GeneratorFunction]", S9 = "[object Proxy]";
function k6(t) {
  if (!l1(t))
    return !1;
  var e = d1.baseGetTag(t);
  return e == _9 || e == E9 || e == x9 || e == S9;
}
var Ih = d1.root["__core-js_shared__"], Lg = function() {
  var t = /[^.]+$/.exec(Ih && Ih.keys && Ih.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function A9(t) {
  return !!Lg && Lg in t;
}
var I9 = Function.prototype, B9 = I9.toString;
function C6(t) {
  if (t != null) {
    try {
      return B9.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var M9 = /[\\^$.*+?()[\]{}|]/g, R9 = /^\[object .+?Constructor\]$/, T9 = Function.prototype, O9 = Object.prototype, k9 = T9.toString, C9 = O9.hasOwnProperty, P9 = RegExp("^" + k9.call(C9).replace(M9, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function N9(t) {
  if (!l1(t) || A9(t))
    return !1;
  var e = k6(t) ? P9 : R9;
  return e.test(C6(t));
}
function U9(t, e) {
  return t == null ? void 0 : t[e];
}
function P6(t, e) {
  var r = U9(t, e);
  return N9(r) ? r : void 0;
}
var F9 = P6(d1.root, "Map");
jr.Map = F9;
jr.getNative = P6;
jr.isFunction = k6;
jr.isObject = l1;
jr.toSource = C6;
const N6 = jr;
function U6(t, e) {
  return t === e || t !== t && e !== e;
}
var Ws = N6.getNative(Object, "create");
function L9() {
  this.__data__ = Ws ? Ws(null) : {}, this.size = 0;
}
function j9(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var D9 = "__lodash_hash_undefined__", $9 = Object.prototype, q9 = $9.hasOwnProperty;
function z9(t) {
  var e = this.__data__;
  if (Ws) {
    var r = e[t];
    return r === D9 ? void 0 : r;
  }
  return q9.call(e, t) ? e[t] : void 0;
}
var K9 = Object.prototype, W9 = K9.hasOwnProperty;
function H9(t) {
  var e = this.__data__;
  return Ws ? e[t] !== void 0 : W9.call(e, t);
}
var G9 = "__lodash_hash_undefined__";
function V9(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = Ws && e === void 0 ? G9 : e, this;
}
function Do(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
Do.prototype.clear = L9;
Do.prototype.delete = j9;
Do.prototype.get = z9;
Do.prototype.has = H9;
Do.prototype.set = V9;
function Y9() {
  this.__data__ = [], this.size = 0;
}
function cd(t, e) {
  for (var r = t.length; r--; )
    if (U6(t[r][0], e))
      return r;
  return -1;
}
var J9 = Array.prototype, X9 = J9.splice;
function Z9(t) {
  var e = this.__data__, r = cd(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : X9.call(e, r, 1), --this.size, !0;
}
function Q9(t) {
  var e = this.__data__, r = cd(e, t);
  return r < 0 ? void 0 : e[r][1];
}
function eA(t) {
  return cd(this.__data__, t) > -1;
}
function tA(t, e) {
  var r = this.__data__, n = cd(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
function Qo(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
Qo.prototype.clear = Y9;
Qo.prototype.delete = Z9;
Qo.prototype.get = Q9;
Qo.prototype.has = eA;
Qo.prototype.set = tA;
function rA() {
  this.size = 0, this.__data__ = { hash: new Do(), map: new (N6.Map || Qo)(), string: new Do() };
}
function nA(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function ud(t, e) {
  var r = t.__data__;
  return nA(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
function iA(t) {
  var e = ud(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function oA(t) {
  return ud(this, t).get(t);
}
function aA(t) {
  return ud(this, t).has(t);
}
function sA(t, e) {
  var r = ud(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
function os(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
os.prototype.clear = rA;
os.prototype.delete = iA;
os.prototype.get = oA;
os.prototype.has = aA;
os.prototype.set = sA;
Ii.ListCache = Qo;
Ii.MapCache = os;
Ii.eq = U6;
const fA = Ii;
var cA = "__lodash_hash_undefined__";
function uA(t) {
  return this.__data__.set(t, cA), this;
}
function dA(t) {
  return this.__data__.has(t);
}
function Wc(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new fA.MapCache(); ++e < r; )
    this.add(t[e]);
}
Wc.prototype.add = Wc.prototype.push = uA;
Wc.prototype.has = dA;
function lA(t, e) {
  return t.has(e);
}
function hA(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = n;
  }), r;
}
is.SetCache = Wc;
is.cacheHas = lA;
is.setToArray = hA;
var Pf = {};
function F6(t, e, r, n) {
  for (var i = t.length, o = r + -1; ++o < i; )
    if (e(t[o], o, t))
      return o;
  return -1;
}
function pA(t) {
  return t !== t;
}
function yA(t, e, r) {
  for (var n = r - 1, i = t.length; ++n < i; )
    if (t[n] === e)
      return n;
  return -1;
}
function bA(t, e, r) {
  return e === e ? yA(t, e, r) : F6(t, pA, r);
}
function gA(t, e) {
  var r = t == null ? 0 : t.length;
  return !!r && bA(t, e, 0) > -1;
}
Pf.arrayIncludes = gA;
Pf.baseFindIndex = F6;
var xn = {}, vA = Array.isArray, _n = vA;
const L6 = Ii;
var mA = "Expected a function";
function h1(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(mA);
  var r = function() {
    var n = arguments, i = e ? e.apply(this, n) : n[0], o = r.cache;
    if (o.has(i))
      return o.get(i);
    var a = t.apply(this, n);
    return r.cache = o.set(i, a) || o, a;
  };
  return r.cache = new (h1.Cache || L6.MapCache)(), r;
}
h1.Cache = L6.MapCache;
var p1 = h1, Di = {};
function wA(t) {
  return t != null && typeof t == "object";
}
Di.isObjectLike = wA;
const y1 = _n, xA = p1, L0 = Wr, _A = Di;
var EA = "[object Symbol]";
function dd(t) {
  return typeof t == "symbol" || _A.isObjectLike(t) && L0.baseGetTag(t) == EA;
}
function j6(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, i = Array(n); ++r < n; )
    i[r] = e(t[r], r, t);
  return i;
}
var SA = 1 / 0, jg = L0.Symbol ? L0.Symbol.prototype : void 0, Dg = jg ? jg.toString : void 0;
function D6(t) {
  if (typeof t == "string")
    return t;
  if (y1(t))
    return j6(t, D6) + "";
  if (dd(t))
    return Dg ? Dg.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -SA ? "-0" : e;
}
var AA = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, IA = /^\w*$/;
function $6(t, e) {
  if (y1(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || dd(t) ? !0 : IA.test(t) || !AA.test(t) || e != null && t in Object(e);
}
var BA = 500;
function MA(t) {
  var e = xA(t, function(n) {
    return r.size === BA && r.clear(), n;
  }), r = e.cache;
  return e;
}
var RA = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, TA = /\\(\\)?/g, OA = MA(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(RA, function(r, n, i, o) {
    e.push(i ? o.replace(TA, "$1") : n || r);
  }), e;
});
function kA(t) {
  return t == null ? "" : D6(t);
}
function CA(t, e) {
  return y1(t) ? t : $6(t, e) ? [t] : OA(kA(t));
}
var PA = 1 / 0;
function NA(t) {
  if (typeof t == "string" || dd(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -PA ? "-0" : e;
}
xn.arrayMap = j6;
xn.castPath = CA;
xn.isKey = $6;
xn.isSymbol = dd;
xn.toKey = NA;
var Hc = { exports: {} }, io = {};
const UA = Wr, q6 = Di;
var FA = 9007199254740991;
function LA(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= FA;
}
var jA = "[object Arguments]";
function $g(t) {
  return q6.isObjectLike(t) && UA.baseGetTag(t) == jA;
}
var z6 = Object.prototype, DA = z6.hasOwnProperty, $A = z6.propertyIsEnumerable, qA = $g(/* @__PURE__ */ function() {
  return arguments;
}()) ? $g : function(t) {
  return q6.isObjectLike(t) && DA.call(t, "callee") && !$A.call(t, "callee");
};
io.isArguments = qA;
io.isLength = LA;
Hc.exports;
(function(t, e) {
  const r = jr, n = io, i = Wr, o = Di;
  function a(be) {
    return be != null && n.isLength(be.length) && !r.isFunction(be);
  }
  var s = Object.prototype;
  function f(be) {
    var Ce = be && be.constructor, je = typeof Ce == "function" && Ce.prototype || s;
    return be === je;
  }
  function u() {
    return !1;
  }
  var c = e && !e.nodeType && e, d = c && !0 && t && !t.nodeType && t, l = d && d.exports === c, h = l ? i.root.Buffer : void 0, y = h ? h.isBuffer : void 0, b = y || u, w = "[object Arguments]", A = "[object Array]", M = "[object Boolean]", N = "[object Date]", G = "[object Error]", z = "[object Function]", J = "[object Map]", oe = "[object Number]", ee = "[object Object]", ae = "[object RegExp]", ye = "[object Set]", pe = "[object String]", te = "[object WeakMap]", F = "[object ArrayBuffer]", v = "[object DataView]", B = "[object Float32Array]", P = "[object Float64Array]", L = "[object Int8Array]", x = "[object Int16Array]", C = "[object Int32Array]", j = "[object Uint8Array]", k = "[object Uint8ClampedArray]", g = "[object Uint16Array]", R = "[object Uint32Array]", X = {};
  X[B] = X[P] = X[L] = X[x] = X[C] = X[j] = X[k] = X[g] = X[R] = !0, X[w] = X[A] = X[F] = X[M] = X[v] = X[N] = X[G] = X[z] = X[J] = X[oe] = X[ee] = X[ae] = X[ye] = X[pe] = X[te] = !1;
  function re(be) {
    return o.isObjectLike(be) && n.isLength(be.length) && !!X[i.baseGetTag(be)];
  }
  function V(be) {
    return function(Ce) {
      return be(Ce);
    };
  }
  var $ = e && !e.nodeType && e, W = $ && !0 && t && !t.nodeType && t, Z = W && W.exports === $, fe = Z && i.freeGlobal.process, D = function() {
    try {
      var be = W && W.require && W.require("util").types;
      return be || fe && fe.binding && fe.binding("util");
    } catch {
    }
  }(), K = D && D.isTypedArray, he = K ? V(K) : re;
  e.baseUnary = V, e.isArrayLike = a, e.isBuffer = b, e.isPrototype = f, e.isTypedArray = he, e.nodeUtil = D;
})(Hc, Hc.exports);
var En = Hc.exports, Nf = {}, ld = {};
function zA(t, e) {
  for (var r = -1, n = e.length, i = t.length; ++r < n; )
    t[i + r] = e[r];
  return t;
}
ld.arrayPush = zA;
const KA = ld, qg = Wr, WA = io, HA = _n;
var zg = qg.Symbol ? qg.Symbol.isConcatSpreadable : void 0;
function GA(t) {
  return HA(t) || WA.isArguments(t) || !!(zg && t && t[zg]);
}
function VA(t, e, r, n, i) {
  var o = -1, a = t.length;
  for (r || (r = GA), i || (i = []); ++o < a; ) {
    var s = t[o];
    r(s) ? KA.arrayPush(i, s) : n || (i[i.length] = s);
  }
  return i;
}
Nf.baseFlatten = VA;
var ea = {}, $i = {}, Uf = {}, YA = 9007199254740991, JA = /^(?:0|[1-9]\d*)$/;
function XA(t, e) {
  var r = typeof t;
  return e = e ?? YA, !!e && (r == "number" || r != "symbol" && JA.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
Uf.isIndex = XA;
const ZA = io, QA = _n, Kg = En, eI = Uf, Gc = Ii, tI = jr, rI = Wr;
function nI(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var iI = Object.prototype, oI = iI.hasOwnProperty;
function aI(t, e) {
  var r = QA(t), n = !r && ZA.isArguments(t), i = !r && !n && Kg.isBuffer(t), o = !r && !n && !i && Kg.isTypedArray(t), a = r || n || i || o, s = a ? nI(t.length, String) : [], f = s.length;
  for (var u in t)
    (e || oI.call(t, u)) && !(a && (u == "length" || i && (u == "offset" || u == "parent") || o && (u == "buffer" || u == "byteLength" || u == "byteOffset") || eI.isIndex(u, f))) && s.push(u);
  return s;
}
function sI() {
  this.__data__ = new Gc.ListCache(), this.size = 0;
}
function fI(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
function cI(t) {
  return this.__data__.get(t);
}
function uI(t) {
  return this.__data__.has(t);
}
var dI = 200;
function lI(t, e) {
  var r = this.__data__;
  if (r instanceof Gc.ListCache) {
    var n = r.__data__;
    if (!tI.Map || n.length < dI - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new Gc.MapCache(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
function as(t) {
  var e = this.__data__ = new Gc.ListCache(t);
  this.size = e.size;
}
as.prototype.clear = sI;
as.prototype.delete = fI;
as.prototype.get = cI;
as.prototype.has = uI;
as.prototype.set = lI;
var hI = rI.root.Uint8Array;
$i.Stack = as;
$i.Uint8Array = hI;
$i.arrayLikeKeys = aI;
var b1 = {}, si = {}, Ff = {}, g1 = {};
function pI(t, e) {
  return function(r) {
    return t(e(r));
  };
}
g1.overArg = pI;
var v1 = {};
const yI = jr, bI = Wr;
var gI = yI.getNative(bI.root, "Set");
v1.Set = gI;
(function(t) {
  const e = En, r = g1, n = jr, i = Wr, o = v1;
  var a = n.getNative(i.root, "WeakMap"), s = r.overArg(Object.keys, Object), f = Object.prototype, u = f.hasOwnProperty;
  function c(ee) {
    if (!e.isPrototype(ee))
      return s(ee);
    var ae = [];
    for (var ye in Object(ee))
      u.call(ee, ye) && ye != "constructor" && ae.push(ye);
    return ae;
  }
  var d = n.getNative(i.root, "DataView"), l = n.getNative(i.root, "Promise"), h = "[object Map]", y = "[object Object]", b = "[object Promise]", w = "[object Set]", A = "[object WeakMap]", M = "[object DataView]", N = n.toSource(d), G = n.toSource(n.Map), z = n.toSource(l), J = n.toSource(o.Set), oe = n.toSource(a);
  t.getTag = i.baseGetTag, (d && t.getTag(new d(new ArrayBuffer(1))) != M || n.Map && t.getTag(new n.Map()) != h || l && t.getTag(l.resolve()) != b || o.Set && t.getTag(new o.Set()) != w || a && t.getTag(new a()) != A) && (t.getTag = function(ee) {
    var ae = i.baseGetTag(ee), ye = ae == y ? ee.constructor : void 0, pe = ye ? n.toSource(ye) : "";
    if (pe)
      switch (pe) {
        case N:
          return M;
        case G:
          return h;
        case z:
          return b;
        case J:
          return w;
        case oe:
          return A;
      }
    return ae;
  }), t.baseKeys = c;
})(Ff);
const vI = ld, mI = _n, wI = $i, xI = Ff, _I = En;
function K6(t) {
  return _I.isArrayLike(t) ? wI.arrayLikeKeys(t) : xI.baseKeys(t);
}
function W6(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, i = 0, o = []; ++r < n; ) {
    var a = t[r];
    e(a, r, t) && (o[i++] = a);
  }
  return o;
}
function H6() {
  return [];
}
var EI = Object.prototype, SI = EI.propertyIsEnumerable, Wg = Object.getOwnPropertySymbols, G6 = Wg ? function(t) {
  return t == null ? [] : (t = Object(t), W6(Wg(t), function(e) {
    return SI.call(t, e);
  }));
} : H6;
function V6(t, e, r) {
  var n = e(t);
  return mI(t) ? n : vI.arrayPush(n, r(t));
}
function AI(t) {
  return V6(t, K6, G6);
}
si.arrayFilter = W6;
si.baseGetAllKeys = V6;
si.getAllKeys = AI;
si.getSymbols = G6;
si.keys = K6;
si.stubArray = H6;
const Cs = $i, j0 = is, Hg = Wr, II = Ii, Gg = si, Vg = Ff, Yg = _n, Bh = En, Jg = Di;
function BI(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
var MI = 1, RI = 2;
function Y6(t, e, r, n, i, o) {
  var a = r & MI, s = t.length, f = e.length;
  if (s != f && !(a && f > s))
    return !1;
  var u = o.get(t), c = o.get(e);
  if (u && c)
    return u == e && c == t;
  var d = -1, l = !0, h = r & RI ? new j0.SetCache() : void 0;
  for (o.set(t, e), o.set(e, t); ++d < s; ) {
    var y = t[d], b = e[d];
    if (n)
      var w = a ? n(b, y, d, e, t, o) : n(y, b, d, t, e, o);
    if (w !== void 0) {
      if (w)
        continue;
      l = !1;
      break;
    }
    if (h) {
      if (!BI(e, function(A, M) {
        if (!j0.cacheHas(h, M) && (y === A || i(y, A, r, n, o)))
          return h.push(M);
      })) {
        l = !1;
        break;
      }
    } else if (!(y === b || i(y, b, r, n, o))) {
      l = !1;
      break;
    }
  }
  return o.delete(t), o.delete(e), l;
}
function TI(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n, i) {
    r[++e] = [i, n];
  }), r;
}
var OI = 1, kI = 2, CI = "[object Boolean]", PI = "[object Date]", NI = "[object Error]", UI = "[object Map]", FI = "[object Number]", LI = "[object RegExp]", jI = "[object Set]", DI = "[object String]", $I = "[object Symbol]", qI = "[object ArrayBuffer]", zI = "[object DataView]", Xg = Hg.Symbol ? Hg.Symbol.prototype : void 0, Mh = Xg ? Xg.valueOf : void 0;
function KI(t, e, r, n, i, o, a) {
  switch (r) {
    case zI:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case qI:
      return !(t.byteLength != e.byteLength || !o(new Cs.Uint8Array(t), new Cs.Uint8Array(e)));
    case CI:
    case PI:
    case FI:
      return II.eq(+t, +e);
    case NI:
      return t.name == e.name && t.message == e.message;
    case LI:
    case DI:
      return t == e + "";
    case UI:
      var s = TI;
    case jI:
      var f = n & OI;
      if (s || (s = j0.setToArray), t.size != e.size && !f)
        return !1;
      var u = a.get(t);
      if (u)
        return u == e;
      n |= kI, a.set(t, e);
      var c = Y6(s(t), s(e), n, i, o, a);
      return a.delete(t), c;
    case $I:
      if (Mh)
        return Mh.call(t) == Mh.call(e);
  }
  return !1;
}
var WI = 1, HI = Object.prototype, GI = HI.hasOwnProperty;
function VI(t, e, r, n, i, o) {
  var a = r & WI, s = Gg.getAllKeys(t), f = s.length, u = Gg.getAllKeys(e), c = u.length;
  if (f != c && !a)
    return !1;
  for (var d = f; d--; ) {
    var l = s[d];
    if (!(a ? l in e : GI.call(e, l)))
      return !1;
  }
  var h = o.get(t), y = o.get(e);
  if (h && y)
    return h == e && y == t;
  var b = !0;
  o.set(t, e), o.set(e, t);
  for (var w = a; ++d < f; ) {
    l = s[d];
    var A = t[l], M = e[l];
    if (n)
      var N = a ? n(M, A, l, e, t, o) : n(A, M, l, t, e, o);
    if (!(N === void 0 ? A === M || i(A, M, r, n, o) : N)) {
      b = !1;
      break;
    }
    w || (w = l == "constructor");
  }
  if (b && !w) {
    var G = t.constructor, z = e.constructor;
    G != z && "constructor" in t && "constructor" in e && !(typeof G == "function" && G instanceof G && typeof z == "function" && z instanceof z) && (b = !1);
  }
  return o.delete(t), o.delete(e), b;
}
var YI = 1, Zg = "[object Arguments]", Qg = "[object Array]", rc = "[object Object]", JI = Object.prototype, ev = JI.hasOwnProperty;
function XI(t, e, r, n, i, o) {
  var a = Yg(t), s = Yg(e), f = a ? Qg : Vg.getTag(t), u = s ? Qg : Vg.getTag(e);
  f = f == Zg ? rc : f, u = u == Zg ? rc : u;
  var c = f == rc, d = u == rc, l = f == u;
  if (l && Bh.isBuffer(t)) {
    if (!Bh.isBuffer(e))
      return !1;
    a = !0, c = !1;
  }
  if (l && !c)
    return o || (o = new Cs.Stack()), a || Bh.isTypedArray(t) ? Y6(t, e, r, n, i, o) : KI(t, e, f, r, n, i, o);
  if (!(r & YI)) {
    var h = c && ev.call(t, "__wrapped__"), y = d && ev.call(e, "__wrapped__");
    if (h || y) {
      var b = h ? t.value() : t, w = y ? e.value() : e;
      return o || (o = new Cs.Stack()), i(b, w, r, n, o);
    }
  }
  return l ? (o || (o = new Cs.Stack()), VI(t, e, r, n, i, o)) : !1;
}
function J6(t, e, r, n, i) {
  return t === e ? !0 : t == null || e == null || !Jg.isObjectLike(t) && !Jg.isObjectLike(e) ? t !== t && e !== e : XI(t, e, r, n, J6, i);
}
b1.baseIsEqual = J6;
var ss = {};
const tv = xn;
function ZI(t, e) {
  e = tv.castPath(e, t);
  for (var r = 0, n = e.length; t != null && r < n; )
    t = t[tv.toKey(e[r++])];
  return r && r == n ? t : void 0;
}
ss.baseGet = ZI;
const QI = ss;
function eB(t, e, r) {
  var n = t == null ? void 0 : QI.baseGet(t, e);
  return n === void 0 ? r : n;
}
var X6 = eB, m1 = {};
const rv = xn, nv = io, tB = _n, rB = Uf;
function nB(t, e) {
  return t != null && e in Object(t);
}
function iB(t, e, r) {
  e = rv.castPath(e, t);
  for (var n = -1, i = e.length, o = !1; ++n < i; ) {
    var a = rv.toKey(e[n]);
    if (!(o = t != null && r(t, a)))
      break;
    t = t[a];
  }
  return o || ++n != i ? o : (i = t == null ? 0 : t.length, !!i && nv.isLength(i) && rB.isIndex(a, i) && (tB(t) || nv.isArguments(t)));
}
function oB(t, e) {
  return t != null && iB(t, e, nB);
}
m1.hasIn = oB;
var Lf = {};
function aB(t) {
  return t;
}
Lf.identity = aB;
const sB = $i, Z6 = b1, fB = jr, cB = si, uB = X6, dB = m1, Vc = xn, lB = Lf, hB = _n, pB = ss;
var yB = 1, bB = 2;
function gB(t, e, r, n) {
  var i = r.length, o = i;
  if (t == null)
    return !o;
  for (t = Object(t); i--; ) {
    var a = r[i];
    if (a[2] ? a[1] !== t[a[0]] : !(a[0] in t))
      return !1;
  }
  for (; ++i < o; ) {
    a = r[i];
    var s = a[0], f = t[s], u = a[1];
    if (a[2]) {
      if (f === void 0 && !(s in t))
        return !1;
    } else {
      var c = new sB.Stack(), d;
      if (!(d === void 0 ? Z6.baseIsEqual(u, f, yB | bB, n, c) : d))
        return !1;
    }
  }
  return !0;
}
function Q6(t) {
  return t === t && !fB.isObject(t);
}
function vB(t) {
  for (var e = cB.keys(t), r = e.length; r--; ) {
    var n = e[r], i = t[n];
    e[r] = [n, i, Q6(i)];
  }
  return e;
}
function ew(t, e) {
  return function(r) {
    return r == null ? !1 : r[t] === e && (e !== void 0 || t in Object(r));
  };
}
function mB(t) {
  var e = vB(t);
  return e.length == 1 && e[0][2] ? ew(e[0][0], e[0][1]) : function(r) {
    return r === t || gB(r, t, e);
  };
}
var wB = 1, xB = 2;
function _B(t, e) {
  return Vc.isKey(t) && Q6(e) ? ew(Vc.toKey(t), e) : function(r) {
    var n = uB(r, t);
    return n === void 0 && n === e ? dB.hasIn(r, t) : Z6.baseIsEqual(e, n, wB | xB);
  };
}
function EB(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
function SB(t) {
  return function(e) {
    return pB.baseGet(e, t);
  };
}
function AB(t) {
  return Vc.isKey(t) ? EB(Vc.toKey(t)) : SB(t);
}
function IB(t) {
  return typeof t == "function" ? t : t == null ? lB.identity : typeof t == "object" ? hB(t) ? _B(t[0], t[1]) : mB(t) : AB(t);
}
ea.baseIteratee = IB;
var jf = {}, hd = {}, w1 = {};
const BB = jr;
var MB = function() {
  try {
    var t = BB.getNative(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}();
w1.defineProperty = MB;
const iv = w1, RB = Lf;
function TB(t, e, r) {
  switch (r.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, r[0]);
    case 2:
      return t.call(e, r[0], r[1]);
    case 3:
      return t.call(e, r[0], r[1], r[2]);
  }
  return t.apply(e, r);
}
var OB = 800, kB = 16, CB = Date.now;
function PB(t) {
  var e = 0, r = 0;
  return function() {
    var n = CB(), i = kB - (n - r);
    if (r = n, i > 0) {
      if (++e >= OB)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
function NB(t) {
  return function() {
    return t;
  };
}
var UB = iv.defineProperty ? function(t, e) {
  return iv.defineProperty(t, "toString", { configurable: !0, enumerable: !1, value: NB(e), writable: !0 });
} : RB.identity, FB = PB(UB), ov = Math.max;
function LB(t, e, r) {
  return e = ov(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var n = arguments, i = -1, o = ov(n.length - e, 0), a = Array(o); ++i < o; )
      a[i] = n[e + i];
    i = -1;
    for (var s = Array(e + 1); ++i < e; )
      s[i] = n[i];
    return s[e] = r(a), TB(t, this, s);
  };
}
hd.overRest = LB;
hd.setToString = FB;
const jB = Lf, av = hd;
function DB(t, e) {
  return av.setToString(av.overRest(t, e, jB.identity), t + "");
}
jf.baseRest = DB;
var pd = {};
const $B = En, qB = Di;
function zB(t) {
  return qB.isObjectLike(t) && $B.isArrayLike(t);
}
pd.isArrayLikeObject = zB;
var yd = {};
function KB(t) {
  var e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
yd.last = KB;
const sv = is, WB = Pf, HB = xn, GB = En, VB = Nf, YB = ea, JB = jf, Rh = pd, XB = yd;
var ZB = 200;
function QB(t, e, r, n) {
  var i = -1, o = WB.arrayIncludes, a = !0, s = t.length, f = [], u = e.length;
  if (!s)
    return f;
  r && (e = HB.arrayMap(e, GB.baseUnary(r))), e.length >= ZB && (o = sv.cacheHas, a = !1, e = new sv.SetCache(e));
  e:
    for (; ++i < s; ) {
      var c = t[i], d = r == null ? c : r(c);
      if (c = c !== 0 ? c : 0, a && d === d) {
        for (var l = u; l--; )
          if (e[l] === d)
            continue e;
        f.push(c);
      } else
        o(e, d, n) || f.push(c);
    }
  return f;
}
var eM = JB.baseRest(function(t, e) {
  var r = XB.last(e);
  return Rh.isArrayLikeObject(r) && (r = void 0), Rh.isArrayLikeObject(t) ? QB(t, VB.baseFlatten(e, 1, Rh.isArrayLikeObject, !0), YB.baseIteratee(r)) : [];
}), tM = eM, bd = {}, x1 = {}, _1 = {};
function rM(t) {
  return function(e, r, n) {
    for (var i = -1, o = Object(e), a = n(e), s = a.length; s--; ) {
      var f = a[++i];
      if (r(o[f], f, o) === !1)
        break;
    }
    return e;
  };
}
var nM = rM();
_1.baseFor = nM;
const iM = _1, oM = si;
function aM(t, e) {
  return t && iM.baseFor(t, e, oM.keys);
}
x1.baseForOwn = aM;
const sM = x1, fM = En;
function cM(t, e) {
  return function(r, n) {
    if (r == null)
      return r;
    if (!fM.isArrayLike(r))
      return t(r, n);
    for (var i = r.length, o = -1, a = Object(r); ++o < i && n(a[o], o, a) !== !1; )
      ;
    return r;
  };
}
var uM = cM(sM.baseForOwn);
bd.baseEach = uM;
var fs = {};
const fv = w1;
function dM(t, e, r) {
  e == "__proto__" && fv.defineProperty ? fv.defineProperty(t, e, { configurable: !0, enumerable: !0, value: r, writable: !0 }) : t[e] = r;
}
fs.baseAssignValue = dM;
const lM = fs, hM = bd, pM = ea, yM = _n;
function bM(t, e, r, n) {
  for (var i = -1, o = t == null ? 0 : t.length; ++i < o; ) {
    var a = t[i];
    e(n, a, r(a), t);
  }
  return n;
}
function gM(t, e, r, n) {
  return hM.baseEach(t, function(i, o, a) {
    e(n, i, r(i), a);
  }), n;
}
function vM(t, e) {
  return function(r, n) {
    var i = yM(r) ? bM : gM, o = {};
    return i(r, t, pM.baseIteratee(n), o);
  };
}
var mM = Object.prototype, wM = mM.hasOwnProperty, xM = vM(function(t, e, r) {
  wM.call(t, r) ? t[r].push(e) : lM.baseAssignValue(t, r, [e]);
}), _M = xM;
const cv = Ff, EM = io, SM = _n, nc = En;
var AM = "[object Map]", IM = "[object Set]", BM = Object.prototype, MM = BM.hasOwnProperty;
function RM(t) {
  if (t == null)
    return !0;
  if (nc.isArrayLike(t) && (SM(t) || typeof t == "string" || typeof t.splice == "function" || nc.isBuffer(t) || nc.isTypedArray(t) || EM.isArguments(t)))
    return !t.length;
  var e = cv.getTag(t);
  if (e == AM || e == IM)
    return !t.size;
  if (nc.isPrototype(t))
    return !cv.baseKeys(t).length;
  for (var r in t)
    if (MM.call(t, r))
      return !1;
  return !0;
}
var TM = RM;
const OM = b1;
function kM(t, e) {
  return OM.baseIsEqual(t, e);
}
var CM = kM;
function PM(t) {
  return t == null;
}
var NM = PM, cs = {};
const UM = Wr, FM = g1, LM = Di;
var tw = FM.overArg(Object.getPrototypeOf, Object), jM = "[object Object]", DM = Function.prototype, $M = Object.prototype, rw = DM.toString, qM = $M.hasOwnProperty, zM = rw.call(Object);
function KM(t) {
  if (!LM.isObjectLike(t) || UM.baseGetTag(t) != jM)
    return !1;
  var e = tw(t);
  if (e === null)
    return !0;
  var r = qM.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && rw.call(r) == zM;
}
cs.getPrototype = tw;
cs.isPlainObject = KM;
const WM = Wr, HM = _n, GM = Di;
var VM = "[object String]";
function YM(t) {
  return typeof t == "string" || !HM(t) && GM.isObjectLike(t) && WM.baseGetTag(t) == VM;
}
var JM = YM, E1 = {}, S1 = {};
const XM = Ii, ZM = En, QM = Uf, eR = jr;
function tR(t, e, r) {
  if (!eR.isObject(r))
    return !1;
  var n = typeof e;
  return (n == "number" ? ZM.isArrayLike(r) && QM.isIndex(e, r.length) : n == "string" && e in r) ? XM.eq(r[e], t) : !1;
}
S1.isIterateeCall = tR;
const rR = Nf, Ps = xn, nR = ss, iR = ea, oR = bd, nw = En, aR = Lf, sR = _n, fR = jf, uv = S1;
function iw(t, e) {
  var r = -1, n = nw.isArrayLike(t) ? Array(t.length) : [];
  return oR.baseEach(t, function(i, o, a) {
    n[++r] = e(i, o, a);
  }), n;
}
function cR(t, e) {
  var r = t.length;
  for (t.sort(e); r--; )
    t[r] = t[r].value;
  return t;
}
function uR(t, e) {
  if (t !== e) {
    var r = t !== void 0, n = t === null, i = t === t, o = Ps.isSymbol(t), a = e !== void 0, s = e === null, f = e === e, u = Ps.isSymbol(e);
    if (!s && !u && !o && t > e || o && a && f && !s && !u || n && a && f || !r && f || !i)
      return 1;
    if (!n && !o && !u && t < e || u && r && i && !n && !o || s && r && i || !a && i || !f)
      return -1;
  }
  return 0;
}
function dR(t, e, r) {
  for (var n = -1, i = t.criteria, o = e.criteria, a = i.length, s = r.length; ++n < a; ) {
    var f = uR(i[n], o[n]);
    if (f) {
      if (n >= s)
        return f;
      var u = r[n];
      return f * (u == "desc" ? -1 : 1);
    }
  }
  return t.index - e.index;
}
function lR(t, e, r) {
  e.length ? e = Ps.arrayMap(e, function(o) {
    return sR(o) ? function(a) {
      return nR.baseGet(a, o.length === 1 ? o[0] : o);
    } : o;
  }) : e = [aR.identity];
  var n = -1;
  e = Ps.arrayMap(e, nw.baseUnary(iR.baseIteratee));
  var i = iw(t, function(o, a, s) {
    var f = Ps.arrayMap(e, function(u) {
      return u(o);
    });
    return { criteria: f, index: ++n, value: o };
  });
  return cR(i, function(o, a) {
    return dR(o, a, r);
  });
}
var hR = fR.baseRest(function(t, e) {
  if (t == null)
    return [];
  var r = e.length;
  return r > 1 && uv.isIterateeCall(t, e[0], e[1]) ? e = [] : r > 2 && uv.isIterateeCall(e[0], e[1], e[2]) && (e = [e[0]]), lR(t, rR.baseFlatten(e), []);
});
E1.baseMap = iw;
E1.sortBy = hR;
const pR = fs, yR = x1, bR = ea;
function gR(t, e) {
  var r = {};
  return e = bR.baseIteratee(e), yR.baseForOwn(t, function(n, i, o) {
    pR.baseAssignValue(r, i, e(n, i, o));
  }), r;
}
var vR = gR, gd = {}, Yc = { exports: {} }, vd = {};
const mR = fs, wR = Ii;
var xR = Object.prototype, _R = xR.hasOwnProperty;
function ER(t, e, r) {
  var n = t[e];
  (!(_R.call(t, e) && wR.eq(n, r)) || r === void 0 && !(e in t)) && mR.baseAssignValue(t, e, r);
}
vd.assignValue = ER;
Yc.exports;
(function(t, e) {
  const r = vd, n = fs, i = $i, o = jr, a = En, s = Wr, f = cs;
  var u = Object.create, c = /* @__PURE__ */ function() {
    function pe() {
    }
    return function(te) {
      if (!o.isObject(te))
        return {};
      if (u)
        return u(te);
      pe.prototype = te;
      var F = new pe();
      return pe.prototype = void 0, F;
    };
  }();
  function d(pe, te) {
    var F = -1, v = pe.length;
    for (te || (te = Array(v)); ++F < v; )
      te[F] = pe[F];
    return te;
  }
  function l(pe, te, F, v) {
    var B = !F;
    F || (F = {});
    for (var P = -1, L = te.length; ++P < L; ) {
      var x = te[P], C = void 0;
      C === void 0 && (C = pe[x]), B ? n.baseAssignValue(F, x, C) : r.assignValue(F, x, C);
    }
    return F;
  }
  function h(pe) {
    var te = [];
    if (pe != null)
      for (var F in Object(pe))
        te.push(F);
    return te;
  }
  var y = Object.prototype, b = y.hasOwnProperty;
  function w(pe) {
    if (!o.isObject(pe))
      return h(pe);
    var te = a.isPrototype(pe), F = [];
    for (var v in pe)
      v == "constructor" && (te || !b.call(pe, v)) || F.push(v);
    return F;
  }
  function A(pe) {
    return a.isArrayLike(pe) ? i.arrayLikeKeys(pe, !0) : w(pe);
  }
  var M = e && !e.nodeType && e, N = M && !0 && t && !t.nodeType && t, G = N && N.exports === M, z = G ? s.root.Buffer : void 0, J = z ? z.allocUnsafe : void 0;
  function oe(pe, te) {
    if (te)
      return pe.slice();
    var F = pe.length, v = J ? J(F) : new pe.constructor(F);
    return pe.copy(v), v;
  }
  function ee(pe) {
    var te = new pe.constructor(pe.byteLength);
    return new i.Uint8Array(te).set(new i.Uint8Array(pe)), te;
  }
  function ae(pe, te) {
    var F = te ? ee(pe.buffer) : pe.buffer;
    return new pe.constructor(F, pe.byteOffset, pe.length);
  }
  function ye(pe) {
    return typeof pe.constructor == "function" && !a.isPrototype(pe) ? c(f.getPrototype(pe)) : {};
  }
  e.cloneArrayBuffer = ee, e.cloneBuffer = oe, e.cloneTypedArray = ae, e.copyArray = d, e.copyObject = l, e.initCloneObject = ye, e.keysIn = A;
})(Yc, Yc.exports);
var ow = Yc.exports;
const SR = jf, AR = S1, IR = $i, BR = fs, MR = Ii, RR = _1, wo = ow, dv = io, lv = _n, TR = pd, hv = En, D0 = jr, OR = cs;
function kR(t) {
  return SR.baseRest(function(e, r) {
    var n = -1, i = r.length, o = i > 1 ? r[i - 1] : void 0, a = i > 2 ? r[2] : void 0;
    for (o = t.length > 3 && typeof o == "function" ? (i--, o) : void 0, a && AR.isIterateeCall(r[0], r[1], a) && (o = i < 3 ? void 0 : o, i = 1), e = Object(e); ++n < i; ) {
      var s = r[n];
      s && t(e, s, n, o);
    }
    return e;
  });
}
function $0(t, e, r) {
  (r !== void 0 && !MR.eq(t[e], r) || r === void 0 && !(e in t)) && BR.baseAssignValue(t, e, r);
}
function q0(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
function CR(t) {
  return wo.copyObject(t, wo.keysIn(t));
}
function PR(t, e, r, n, i, o, a) {
  var s = q0(t, r), f = q0(e, r), u = a.get(f);
  if (u) {
    $0(t, r, u);
    return;
  }
  var c = o ? o(s, f, r + "", t, e, a) : void 0, d = c === void 0;
  if (d) {
    var l = lv(f), h = !l && hv.isBuffer(f), y = !l && !h && hv.isTypedArray(f);
    c = f, l || h || y ? lv(s) ? c = s : TR.isArrayLikeObject(s) ? c = wo.copyArray(s) : h ? (d = !1, c = wo.cloneBuffer(f, !0)) : y ? (d = !1, c = wo.cloneTypedArray(f, !0)) : c = [] : OR.isPlainObject(f) || dv.isArguments(f) ? (c = s, dv.isArguments(s) ? c = CR(s) : (!D0.isObject(s) || D0.isFunction(s)) && (c = wo.initCloneObject(f))) : d = !1;
  }
  d && (a.set(f, c), i(c, f, n, o, a), a.delete(f)), $0(t, r, c);
}
function aw(t, e, r, n, i) {
  t !== e && RR.baseFor(e, function(o, a) {
    if (i || (i = new IR.Stack()), D0.isObject(o))
      PR(t, e, a, r, aw, n, i);
    else {
      var s = n ? n(q0(t, a), o, a + "", t, e, i) : void 0;
      s === void 0 && (s = o), $0(t, a, s);
    }
  }, wo.keysIn);
}
gd.baseMerge = aw;
gd.createAssigner = kR;
const pv = gd;
var NR = pv.createAssigner(function(t, e, r) {
  pv.baseMerge(t, e, r);
}), UR = NR;
const yv = gd;
var FR = yv.createAssigner(function(t, e, r, n) {
  yv.baseMerge(t, e, r, n);
}), LR = FR, A1 = {}, I1 = {};
const jR = Nf, bv = hd;
function DR(t) {
  var e = t == null ? 0 : t.length;
  return e ? jR.baseFlatten(t) : [];
}
function $R(t) {
  return bv.setToString(bv.overRest(t, void 0, DR), t + "");
}
I1.flatRest = $R;
const Jc = xn, qR = $i, zR = vd, mn = ow, $o = si, KR = ld, sw = cs, B1 = Ff, gv = Wr, WR = _n, qo = En, fw = Di, HR = jr, GR = yd, VR = ss, YR = I1;
function JR(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n && e(t[r], r, t) !== !1; )
    ;
  return t;
}
function XR(t, e, r) {
  var n = -1, i = t.length;
  e < 0 && (e = -e > i ? 0 : i + e), r = r > i ? i : r, r < 0 && (r += i), i = e > r ? 0 : r - e >>> 0, e >>>= 0;
  for (var o = Array(i); ++n < i; )
    o[n] = t[n + e];
  return o;
}
function ZR(t, e) {
  return t && mn.copyObject(e, $o.keys(e), t);
}
function QR(t, e) {
  return t && mn.copyObject(e, mn.keysIn(e), t);
}
function eT(t, e) {
  return mn.copyObject(t, $o.getSymbols(t), e);
}
var tT = Object.getOwnPropertySymbols, cw = tT ? function(t) {
  for (var e = []; t; )
    KR.arrayPush(e, $o.getSymbols(t)), t = sw.getPrototype(t);
  return e;
} : $o.stubArray;
function rT(t, e) {
  return mn.copyObject(t, cw(t), e);
}
function M1(t) {
  return $o.baseGetAllKeys(t, mn.keysIn, cw);
}
var nT = Object.prototype, iT = nT.hasOwnProperty;
function oT(t) {
  var e = t.length, r = new t.constructor(e);
  return e && typeof t[0] == "string" && iT.call(t, "index") && (r.index = t.index, r.input = t.input), r;
}
function aT(t, e) {
  var r = e ? mn.cloneArrayBuffer(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.byteLength);
}
var sT = /\w*$/;
function fT(t) {
  var e = new t.constructor(t.source, sT.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var vv = gv.Symbol ? gv.Symbol.prototype : void 0, mv = vv ? vv.valueOf : void 0;
function cT(t) {
  return mv ? Object(mv.call(t)) : {};
}
var uT = "[object Boolean]", dT = "[object Date]", lT = "[object Map]", hT = "[object Number]", pT = "[object RegExp]", yT = "[object Set]", bT = "[object String]", gT = "[object Symbol]", vT = "[object ArrayBuffer]", mT = "[object DataView]", wT = "[object Float32Array]", xT = "[object Float64Array]", _T = "[object Int8Array]", ET = "[object Int16Array]", ST = "[object Int32Array]", AT = "[object Uint8Array]", IT = "[object Uint8ClampedArray]", BT = "[object Uint16Array]", MT = "[object Uint32Array]";
function RT(t, e, r) {
  var n = t.constructor;
  switch (e) {
    case vT:
      return mn.cloneArrayBuffer(t);
    case uT:
    case dT:
      return new n(+t);
    case mT:
      return aT(t, r);
    case wT:
    case xT:
    case _T:
    case ET:
    case ST:
    case AT:
    case IT:
    case BT:
    case MT:
      return mn.cloneTypedArray(t, r);
    case lT:
      return new n();
    case hT:
    case bT:
      return new n(t);
    case pT:
      return fT(t);
    case yT:
      return new n();
    case gT:
      return cT(t);
  }
}
var TT = "[object Map]";
function OT(t) {
  return fw.isObjectLike(t) && B1.getTag(t) == TT;
}
var wv = qo.nodeUtil && qo.nodeUtil.isMap, kT = wv ? qo.baseUnary(wv) : OT, CT = "[object Set]";
function PT(t) {
  return fw.isObjectLike(t) && B1.getTag(t) == CT;
}
var xv = qo.nodeUtil && qo.nodeUtil.isSet, NT = xv ? qo.baseUnary(xv) : PT, UT = 1, FT = 2, LT = 4, uw = "[object Arguments]", jT = "[object Array]", DT = "[object Boolean]", $T = "[object Date]", qT = "[object Error]", dw = "[object Function]", zT = "[object GeneratorFunction]", KT = "[object Map]", WT = "[object Number]", lw = "[object Object]", HT = "[object RegExp]", GT = "[object Set]", VT = "[object String]", YT = "[object Symbol]", JT = "[object WeakMap]", XT = "[object ArrayBuffer]", ZT = "[object DataView]", QT = "[object Float32Array]", eO = "[object Float64Array]", tO = "[object Int8Array]", rO = "[object Int16Array]", nO = "[object Int32Array]", iO = "[object Uint8Array]", oO = "[object Uint8ClampedArray]", aO = "[object Uint16Array]", sO = "[object Uint32Array]", hr = {};
hr[uw] = hr[jT] = hr[XT] = hr[ZT] = hr[DT] = hr[$T] = hr[QT] = hr[eO] = hr[tO] = hr[rO] = hr[nO] = hr[KT] = hr[WT] = hr[lw] = hr[HT] = hr[GT] = hr[VT] = hr[YT] = hr[iO] = hr[oO] = hr[aO] = hr[sO] = !0;
hr[qT] = hr[dw] = hr[JT] = !1;
function gc(t, e, r, n, i, o) {
  var a, s = e & UT, f = e & FT, u = e & LT;
  if (r && (a = i ? r(t, n, i, o) : r(t)), a !== void 0)
    return a;
  if (!HR.isObject(t))
    return t;
  var c = WR(t);
  if (c) {
    if (a = oT(t), !s)
      return mn.copyArray(t, a);
  } else {
    var d = B1.getTag(t), l = d == dw || d == zT;
    if (qo.isBuffer(t))
      return mn.cloneBuffer(t, s);
    if (d == lw || d == uw || l && !i) {
      if (a = f || l ? {} : mn.initCloneObject(t), !s)
        return f ? rT(t, QR(a, t)) : eT(t, ZR(a, t));
    } else {
      if (!hr[d])
        return i ? t : {};
      a = RT(t, d, s);
    }
  }
  o || (o = new qR.Stack());
  var h = o.get(t);
  if (h)
    return h;
  o.set(t, a), NT(t) ? t.forEach(function(w) {
    a.add(gc(w, e, r, w, t, o));
  }) : kT(t) && t.forEach(function(w, A) {
    a.set(A, gc(w, e, r, A, t, o));
  });
  var y = u ? f ? M1 : $o.getAllKeys : f ? mn.keysIn : $o.keys, b = c ? void 0 : y(t);
  return JR(b || t, function(w, A) {
    b && (A = w, w = t[A]), zR.assignValue(a, A, gc(w, e, r, A, t, o));
  }), a;
}
function fO(t, e) {
  return e.length < 2 ? t : VR.baseGet(t, XR(e, 0, -1));
}
function cO(t, e) {
  return e = Jc.castPath(e, t), t = fO(t, e), t == null || delete t[Jc.toKey(GR.last(e))];
}
function uO(t) {
  return sw.isPlainObject(t) ? void 0 : t;
}
var dO = 1, lO = 2, hO = 4, pO = YR.flatRest(function(t, e) {
  var r = {};
  if (t == null)
    return r;
  var n = !1;
  e = Jc.arrayMap(e, function(o) {
    return o = Jc.castPath(o, t), n || (n = o.length > 1), o;
  }), mn.copyObject(t, M1(t), r), n && (r = gc(r, dO | lO | hO, uO));
  for (var i = e.length; i--; )
    cO(r, e[i]);
  return r;
});
A1.getAllKeysIn = M1;
A1.omit = pO;
var R1 = {}, T1 = {};
const yO = vd, _v = xn, bO = Uf, Ev = jr;
function gO(t, e, r, n) {
  if (!Ev.isObject(t))
    return t;
  e = _v.castPath(e, t);
  for (var i = -1, o = e.length, a = o - 1, s = t; s != null && ++i < o; ) {
    var f = _v.toKey(e[i]), u = r;
    if (f === "__proto__" || f === "constructor" || f === "prototype")
      return t;
    if (i != a) {
      var c = s[f];
      u = void 0, u === void 0 && (u = Ev.isObject(c) ? c : bO.isIndex(e[i + 1]) ? [] : {});
    }
    yO.assignValue(s, f, u), s = s[f];
  }
  return t;
}
T1.baseSet = gO;
const vO = ss, mO = T1, wO = xn, xO = m1, _O = I1;
function hw(t, e, r) {
  for (var n = -1, i = e.length, o = {}; ++n < i; ) {
    var a = e[n], s = vO.baseGet(t, a);
    r(s, a) && mO.baseSet(o, wO.castPath(a, t), s);
  }
  return o;
}
function EO(t, e) {
  return hw(t, e, function(r, n) {
    return xO.hasIn(t, n);
  });
}
var SO = _O.flatRest(function(t, e) {
  return t == null ? {} : EO(t, e);
});
R1.basePickBy = hw;
R1.pick = SO;
const AO = T1;
function IO(t, e, r) {
  return t == null ? t : AO.baseSet(t, e, r);
}
var BO = IO, md = {};
const vc = is, MO = Pf, Th = v1;
function RO() {
}
var TO = 1 / 0, OO = Th.Set && 1 / vc.setToArray(new Th.Set([, -0]))[1] == TO ? function(t) {
  return new Th.Set(t);
} : RO, kO = 200;
function CO(t, e, r) {
  var n = -1, i = MO.arrayIncludes, o = t.length, a = !0, s = [], f = s;
  if (o >= kO) {
    var u = e ? null : OO(t);
    if (u)
      return vc.setToArray(u);
    a = !1, i = vc.cacheHas, f = new vc.SetCache();
  } else
    f = e ? [] : s;
  e:
    for (; ++n < o; ) {
      var c = t[n], d = e ? e(c) : c;
      if (c = c !== 0 ? c : 0, a && d === d) {
        for (var l = f.length; l--; )
          if (f[l] === d)
            continue e;
        e && f.push(d), s.push(c);
      } else
        i(f, d, r) || (f !== s && f.push(d), s.push(c));
    }
  return s;
}
md.baseUniq = CO;
const PO = md;
function NO(t) {
  return t && t.length ? PO.baseUniq(t) : [];
}
var UO = NO;
const FO = ea, LO = md;
function jO(t, e) {
  return t && t.length ? LO.baseUniq(t, FO.baseIteratee(e)) : [];
}
var DO = jO;
(function(t) {
  Object.defineProperties(t, { __esModule: { value: !0 }, [Symbol.toStringTag]: { value: "Module" } });
  const e = tM, r = si, n = bd, i = ea, o = _n, a = En, s = Pf, f = jr, u = xn, c = X6, d = _M, l = TM, h = CM, y = NM, b = cs, w = JM, A = E1, M = vR, N = p1, G = UR, z = LR, J = A1, oe = R1, ee = BO, ae = Nf, ye = jf, pe = md, te = pd, F = yd, v = UO, B = DO;
  var P = /\s/;
  function L(p) {
    for (var m = p.length; m-- && P.test(p.charAt(m)); )
      ;
    return m;
  }
  var x = /^\s+/;
  function C(p) {
    return p && p.slice(0, L(p) + 1).replace(x, "");
  }
  var j = NaN, k = /^[-+]0x[0-9a-f]+$/i, g = /^0b[01]+$/i, R = /^0o[0-7]+$/i, X = parseInt;
  function re(p) {
    if (typeof p == "number")
      return p;
    if (u.isSymbol(p))
      return j;
    if (f.isObject(p)) {
      var m = typeof p.valueOf == "function" ? p.valueOf() : p;
      p = f.isObject(m) ? m + "" : m;
    }
    if (typeof p != "string")
      return p === 0 ? p : +p;
    p = C(p);
    var O = g.test(p);
    return O || R.test(p) ? X(p.slice(2), O ? 2 : 8) : k.test(p) ? j : +p;
  }
  var V = 1 / 0, $ = 17976931348623157e292;
  function W(p) {
    if (!p)
      return p === 0 ? p : 0;
    if (p = re(p), p === V || p === -V) {
      var m = p < 0 ? -1 : 1;
      return m * $;
    }
    return p === p ? p : 0;
  }
  function Z(p) {
    var m = W(p), O = m % 1;
    return m === m ? O ? m - O : m : 0;
  }
  function fe(p, m, O, Q) {
    var ie = -1, ce = p == null ? 0 : p.length;
    for (Q && ce && (O = p[++ie]); ++ie < ce; )
      O = m(O, p[ie], ie, p);
    return O;
  }
  function D(p, m) {
    var O = [];
    return n.baseEach(p, function(Q, ie, ce) {
      m(Q, ie, ce) && O.push(Q);
    }), O;
  }
  function K(p, m) {
    var O = o(p) ? r.arrayFilter : D;
    return O(p, i.baseIteratee(m));
  }
  function he(p) {
    return function(m, O, Q) {
      var ie = Object(m);
      if (!a.isArrayLike(m)) {
        var ce = i.baseIteratee(O);
        m = r.keys(m), O = function(Te) {
          return ce(ie[Te], Te, ie);
        };
      }
      var Ne = p(m, O, Q);
      return Ne > -1 ? ie[ce ? m[Ne] : Ne] : void 0;
    };
  }
  var be = Math.max;
  function Ce(p, m, O) {
    var Q = p == null ? 0 : p.length;
    if (!Q)
      return -1;
    var ie = O == null ? 0 : Z(O);
    return ie < 0 && (ie = be(Q + ie, 0)), s.baseFindIndex(p, i.baseIteratee(m), ie);
  }
  var je = he(Ce);
  function Ue(p, m) {
    var O = o(p) ? u.arrayMap : A.baseMap;
    return O(p, i.baseIteratee(m));
  }
  function Qe(p, m) {
    return u.arrayMap(m, function(O) {
      return p[O];
    });
  }
  function we(p) {
    return p == null ? [] : Qe(p, r.keys(p));
  }
  function at(p, m) {
    if (p == null)
      return {};
    var O = u.arrayMap(J.getAllKeysIn(p), function(Q) {
      return [Q];
    });
    return m = i.baseIteratee(m), oe.basePickBy(p, O, function(Q, ie) {
      return m(Q, ie[0]);
    });
  }
  var rt = Math.floor, It = Math.random;
  function it(p, m) {
    return p + rt(It() * (m - p + 1));
  }
  function se(p, m, O, Q, ie) {
    return ie(p, function(ce, Ne, Te) {
      O = Q ? (Q = !1, ce) : m(O, ce, Ne, Te);
    }), O;
  }
  function ue(p, m, O) {
    var Q = o(p) ? fe : se, ie = arguments.length < 3;
    return Q(p, i.baseIteratee(m), O, ie, n.baseEach);
  }
  function Ee(p) {
    var m = p.length;
    return m ? p[it(0, m - 1)] : void 0;
  }
  function U(p) {
    return Ee(we(p));
  }
  function S(p) {
    var m = o(p) ? Ee : U;
    return m(p);
  }
  var I = ye.baseRest(function(p) {
    var m = F.last(p);
    return te.isArrayLikeObject(m) && (m = void 0), pe.baseUniq(ae.baseFlatten(p, 1, te.isArrayLikeObject, !0), i.baseIteratee(m));
  });
  const _ = { differenceBy: e, filter: K, find: je, get: c, groupBy: d, isArray: o, isEmpty: l, isEqual: h, isNil: y, isObject: f.isObject, isPlainObject: b.isPlainObject, isString: w, map: Ue, mapValues: M, memoize: N, merge: G, mergeWith: z, omit: J.omit, pick: oe.pick, pickBy: at, reduce: ue, sample: S, set: ee, sortBy: A.sortBy, unionBy: I, uniq: v, uniqBy: B };
  t.differenceBy = e, t.isArray = o, t.isObject = f.isObject, t.get = c, t.groupBy = d, t.isEmpty = l, t.isEqual = h, t.isNil = y, t.isPlainObject = b.isPlainObject, t.isString = w, t.sortBy = A.sortBy, t.mapValues = M, t.memoize = N, t.merge = G, t.mergeWith = z, t.omit = J.omit, t.pick = oe.pick, t.set = ee, t.uniq = v, t.uniqBy = B, t.default = _, t.filter = K, t.find = je, t.map = Ue, t.pickBy = at, t.reduce = ue, t.sample = S, t.unionBy = I;
})(po);
const tt = /* @__PURE__ */ sn(po), _s = Symbol("bigint-wrapper"), cn = (t) => t instanceof pr ? t.unwrap() : t, Es = BigInt(0);
var sf, z0;
const un = class un {
  constructor(e, r) {
    Ve(this, sf);
    Le(this, "__value__");
    if (e !== _s)
      throw new Error("use wrap() instead");
    this.__value__ = r;
  }
  static wrap(e, r = 10) {
    if (typeof e == "bigint")
      return new un(_s, e);
    if (typeof e == "number")
      return new un(_s, BigInt(e));
    if (typeof e != "string")
      throw new Error(`Unsupported type: ${typeof e}`);
    switch (r) {
      case 10:
        return new un(_s, BigInt(e));
      case 16:
        return new un(_s, BigInt("0x" + e));
      default:
        throw new Error(`Unsupported base: ${r}`);
    }
  }
  static isUnderlyingInstance(e) {
    return typeof e == "bigint";
  }
  unwrap() {
    return this.__value__;
  }
  add(e) {
    return un.wrap(this.__value__ + cn(e));
  }
  mutateAdd(e) {
    return this.__value__ += cn(e), this;
  }
  sub(e) {
    return un.wrap(this.__value__ - cn(e));
  }
  mutateSub(e) {
    return this.__value__ -= cn(e), this;
  }
  mul(e) {
    return un.wrap(this.__value__ * cn(e));
  }
  mutateMul(e) {
    return this.__value__ *= cn(e), this;
  }
  div(e) {
    return un.wrap(this.__value__ / cn(e));
  }
  mutateDiv(e) {
    return this.__value__ /= cn(e), this;
  }
  mod(e) {
    return un.wrap(this.__value__ % cn(e));
  }
  pow(e) {
    return un.wrap(this.__value__ ** cn(e));
  }
  negate() {
    return un.wrap(-this.__value__);
  }
  mutateNegate() {
    return this.__value__ = -this.__value__, this;
  }
  abs() {
    return this.__value__ < Es ? un.wrap(-this.__value__) : this;
  }
  mutateAbs() {
    return this.__value__ < Es && (this.__value__ = -this.__value__), this;
  }
  gte(e) {
    return this.__value__ >= cn(e);
  }
  gt(e) {
    return this.__value__ > cn(e);
  }
  lte(e) {
    return this.__value__ <= cn(e);
  }
  lt(e) {
    return this.__value__ < cn(e);
  }
  eq(e) {
    return this.__value__ === cn(e);
  }
  isZero() {
    return this.__value__ === Es;
  }
  isNegative() {
    return this.__value__ < Es;
  }
  isPositive() {
    return this.__value__ > Es;
  }
  toString(e) {
    return $e(typeof e == "number", 'expected number "base"'), this.__value__.toString(e);
  }
  toNumber() {
    return Number(this.__value__);
  }
  toBaseBufferLE(e = fn(this, sf, z0).call(this)) {
    const r = this.__value__.toString(16), n = Ie.from(r.padStart(e * 2, "0").slice(0, e * 2), "hex");
    return n.reverse(), n;
  }
  toBaseBufferBE(e = fn(this, sf, z0).call(this)) {
    const r = this.__value__.toString(16);
    return Ie.from(r.padStart(e * 2, "0").slice(0, e * 2), "hex");
  }
  isBigIntWrapper() {
    return !0;
  }
};
sf = new WeakSet(), z0 = function() {
  const e = this.__value__.toString(2).length;
  return Math.ceil(e / 8);
}, Le(un, "wrapperName", "native-bigint");
let pr = un;
function zo(t) {
  return t == null || typeof t != "object" ? !1 : "_number" in t && "unit" in t && "unitType" in t && "baseUnit" in t;
}
const $O = ["parse", "equals", "toJSON"], qO = ["units", "baseUnit", "defaultUnit", "ZERO"];
function Xc(t) {
  return t == null || typeof t != "object" ? !1 : qO.every((e) => e in t) && $O.every((e) => typeof t[e] == "function");
}
function zO(t, e, r, n = {}) {
  if (!Xc(t) || !Xc(e))
    throw new Error("Must pass in an instance of UnitType for ut1 and ut2.");
  const { unit1: i, unit2: o } = { unit1: t.defaultUnit, unit2: e.defaultUnit, ...n };
  if (!t[i])
    throw new Error(`unit1 (${i}) is not from ut1`);
  if (!e[o])
    throw new Error(`unit2 (${o}) is not from ut2`);
  return function(s) {
    const f = s.unitType;
    if (f.equals(t)) {
      const u = e.baseUnit(s._number).mul(e[o].multiplier).mul(r);
      return u._number = u._number.div(t[i].multiplier), u.to(o);
    }
    if (f.equals(e)) {
      let u = t.baseUnit(s._number).mul(t[i].multiplier);
      try {
        u = u.div(r);
      } catch (c) {
        if (String(c.message) !== "Invalid division by 0")
          throw c;
        u = t.baseUnit(0);
      }
      return u._number = u._number.div(e[o].multiplier), u.to(i);
    }
    throw new Error("Conversion error");
  };
}
const KO = Ye.env.NODE_ENV === "development" || Ye.env.NODE_ENV === "test", yo = (t) => {
  try {
    console.warn("***************************************************************"), console.warn(t), console.warn("***************************************************************"), console.trace();
  } catch {
  }
}, zi = (t, e, r) => {
  if (!t.unitType.equals(e.unitType)) {
    const n = `number-unit.${r} on different NumberUnit types (${t}, ${e}) is not correct and will be removed soon.`;
    if (KO)
      throw new Error(n);
    yo(`DEPRECATION WARNING: ${n}`);
  }
};
function pw(t) {
  return t !== null && typeof t == "object" && t.constructor.wordSize === 26 && Array.isArray(t.words);
}
function WO(t, e) {
  var n;
  if ((n = t.isBigIntWrapper) != null && n.call(t))
    return t;
  if (pw(t) && e > 0)
    throw new Error(
      `You are creating a NU providing a BN.js number ${t} with a power of ${e}. Please use base units, string or decimal numbers!`
    );
  if (typeof t == "bigint" && e > 0 && yo(
    `You are creating a NU providing a bigint number ${t} with a power of ${e}. Please use base unit, string or decimal numbers!`
  ), pr.isUnderlyingInstance(t)) {
    const i = pr.wrap(t);
    return e ? i.mutateMul(pr.wrap(10).pow(pr.wrap(e))) : i;
  }
  const r = K0(t, e, { numberOnly: !0 });
  return pr.wrap(r);
}
function K0(t, e, { numberOnly: r = !1 } = {}) {
  if (typeof t == "number") {
    if (t === Number.POSITIVE_INFINITY || t === Number.NEGATIVE_INFINITY)
      throw new Error("Infinity is not supported");
    t = t.toString();
  } else if (typeof t == "string")
    t = t.toLowerCase();
  else if (pw(t))
    t = t.toString();
  else if (typeof t == "bigint")
    t = t.toString();
  else
    throw new TypeError(`Invalid number type '${typeof t}'`);
  if (t.length > 2 && t[0] === "0" && t[1] === "x") {
    if (t = t.slice(2), !/^[\d.a-f]*$/.test(t))
      throw new Error(`Invalid hex number: 0x${t}`);
    t = pr.wrap(t, 16).toString(10);
  }
  const n = t[0] === "-";
  n && (t = t.slice(1));
  const i = n ? "-" : "";
  t[0] === "+" && !n && (t = t.slice(1));
  const o = t.indexOf("e");
  if (o !== -1) {
    if (e += Number.parseInt(t.slice(o + 1), 10), Number.isNaN(e))
      throw new TypeError(`Invalid exponential in number: ${t}`);
    t = t.slice(0, o);
  }
  if (!/^\d*\.?\d*$/.test(t))
    throw new Error(`Not allowed symbol in number: ${t}`);
  switch (t.indexOf(".")) {
    case -1: {
      t += ".0";
      break;
    }
    case 0: {
      t = "0" + t;
      break;
    }
    case t.length - 1: {
      t += "0";
      break;
    }
  }
  if (e === 0) {
    const d = t.indexOf("."), l = i + t.slice(0, d);
    if (r)
      return l;
    const h = t.slice(d + 1);
    return { number: l, fraction: i + h, fractionLength: h.length };
  }
  e > 0 ? t = t.padEnd(t.length + e, "0") : t = t.padStart(t.length - e, "0");
  const s = t.indexOf(".");
  t = t.slice(0, s) + t.slice(s + 1);
  const f = i + t.slice(0, s + e);
  if (r)
    return f;
  let u = t.slice(s + e), c = u.length - 1;
  for (; u[c] === "0" && c > 0; )
    c -= 1;
  return c !== u.length - 1 && (u = u.slice(0, c + 1)), { number: f, fraction: i + u, fractionLength: u.length };
}
const Oh = pr.wrap(10), Jt = class Jt {
  constructor(e, r) {
    // prop types
    Le(this, "_number");
    Le(this, "unit");
    Le(this, "unitType");
    Le(this, "baseUnit");
    Le(this, "defaultUnit");
    Le(this, "unitName");
    this.unit = r, this.unitType = r.unitType, this.baseUnit = r.unitType.baseUnit, this.defaultUnit = r.unitType.defaultUnit, this.unitName = this.unit.unitName, this._number = WO(e, r.power), Object.defineProperty(this, "_numberStringMap", {
      enumerable: !1,
      value: /* @__PURE__ */ new Map(),
      writable: !0
    });
  }
  static create(e, r) {
    return new Jt(e, r);
  }
  abs() {
    return new Jt(this._number.abs(), this.unit);
  }
  add(e) {
    return e = this._coerceToNumberUnit(e), zi(this, e, "add"), e.isZero ? this : this.isZero ? new Jt(e._number, this.unit) : new Jt(this._number.add(e._number), this.unit);
  }
  clampLowerZero() {
    const e = new Jt(0, this.unit);
    return this.gte(e) ? this : e;
  }
  clone() {
    return new Jt(this._number, this.unit);
  }
  equals(e) {
    return zi(this, e, "equals"), this._number.eq(e._number);
  }
  gt(e) {
    return zi(this, e, "gt"), this._number.gt(e._number);
  }
  gte(e) {
    return zi(this, e, "gte"), this._number.gte(e._number);
  }
  /*
  inspect() {
    return `<NumberUnit: ${this.toString()} >`
  }
  */
  lt(e) {
    return zi(this, e, "lt"), this._number.lt(e._number);
  }
  lte(e) {
    return zi(this, e, "lte"), this._number.lte(e._number);
  }
  mul(e) {
    var a;
    if (Jt.isNumberUnit(e))
      throw new TypeError("NumberUnit.mul does not support NumberUnit as argument.");
    if (pr.isUnderlyingInstance(e) && (e = pr.wrap(e)), (a = e.isBigIntWrapper) != null && a.call(e))
      return new Jt(this._number.mul(e), this.unit);
    const { number: r, fraction: n, fractionLength: i } = K0(e, 0), o = r !== "0" && r !== "-0" ? this._number.mul(pr.wrap(r)) : pr.wrap(0);
    if (n !== "0" && n !== "-0") {
      const s = pr.wrap(n).mutateMul(this._number).div(Oh.pow(pr.wrap(i)));
      o.mutateAdd(s);
    }
    return new Jt(o, this.unit);
  }
  div(e) {
    if (Jt.isNumberUnit(e))
      throw new TypeError("NumberUnit.div does not support NumberUnit as argument.");
    if (pr.isUnderlyingInstance(e))
      return new Jt(this._number.div(e), this.unit);
    const { number: r, fraction: n, fractionLength: i } = K0(e, 0), o = Oh.pow(pr.wrap(i)), a = pr.wrap(r).mutateMul(o).mutateAdd(pr.wrap(n));
    if (a.isZero())
      throw new Error("Invalid division by 0");
    const s = this._number.mul(o).div(a);
    return new Jt(s, this.unit);
  }
  floor() {
    if (this.unit.power === 0)
      return this;
    const e = this._toNumberString(), [r] = e.split(".");
    return new Jt(r, this.unit);
  }
  round() {
    if (this.unit.power === 0)
      return this;
    const e = this._toNumberString(), [r, n] = e.split(".");
    let i = new Jt(r, this.unit);
    return n && Math.round(Number.parseFloat(`0.${n}`)) > 0 && (i = i.add(new Jt(1, this.unit))), i;
  }
  ceil() {
    if (this.unit.power === 0)
      return this;
    const e = this._toNumberString(), [r, n] = e.split(".");
    let i = new Jt(r, this.unit);
    return n && Math.ceil(Number.parseFloat(`0.${n}`)) > 0 && (i = i.add(new Jt(1, this.unit))), i;
  }
  // @deprecated
  toFixed(e, r) {
    const n = pr.wrap(10).pow(pr.wrap(e));
    let i = new Jt(this._number.mul(n), this.unit);
    switch (r) {
      case "floor":
        i = i.floor();
        break;
      case "ceil":
        i = i.ceil();
        break;
      default:
        i = i.round();
    }
    return i = new Jt(i._number.div(n), this.unit), i;
  }
  negate() {
    return new Jt(this._number.negate(), this.unit);
  }
  sub(e) {
    return e = this._coerceToNumberUnit(e), zi(this, e, "sub"), e.isZero ? this : this.isZero ? new Jt(e._number.negate(), this.unit) : new Jt(this._number.sub(e._number), this.unit);
  }
  // always returns NumberUnit in base unit for consistency and ease of operation
  // this.unit will be deprecated/removed, at which point the above will be irrelevant
  // when casting to a UnitType with lower power we truncate the remaining decimals (not round)
  cast(e) {
    if (!Xc(e))
      throw new Error("unitType needs to be a UnitType instance");
    if (this.unitType.equals(e))
      return this.toBase();
    const r = e.baseUnit;
    let n = this._number;
    const i = this.unitType.defaultUnit.power, o = e.defaultUnit.power;
    if (n.isZero() || i === o)
      return new Jt(n, r);
    const a = Oh.pow(pr.wrap(Math.abs(o - i), 10));
    return i < o ? n = n.mul(a) : i > o && (n = n.div(a)), new Jt(n, r);
  }
  // @deprecated
  toBase() {
    return this.unit.power === 0 ? this : new Jt(this._number, this.baseUnit);
  }
  // @deprecated
  toDefault() {
    return this.defaultUnit === this.unit ? this : this.to(this.defaultUnit);
  }
  // @deprecated
  to(e, r) {
    if (e === this.unit)
      return this;
    if (typeof e == "string" && (e = this.unitType.units[e]), this.unit.unitType.equals(e.unitType))
      return new Jt(this._number, e);
    if (!r)
      throw new Error("Incompatible unit types. Must specify a conversion.");
    if (typeof r == "function")
      return r(this);
    if (!this.unitType.equals(r.from.unitType))
      throw new Error("Conversion unit from is of different type.");
    const n = Number.parseFloat(r.toValue) / Number.parseFloat(r.fromValue);
    return zO(
      r.from.unitType,
      r.to.unitType,
      n,
      { unit1: r.fromUnit, unit2: r.toUnit }
    )(this);
  }
  // this is only here to prevent JSON stringify circular error
  // you should probably use toString() in conjunction with parse()
  // a corresponding fromJSON probably won't ever be implemented
  toJSON() {
    return {
      value: this._toNumberString(),
      unit: this.unitName,
      unitType: this.unitType.toString(),
      type: "NumberUnit"
    };
  }
  toNumber(e) {
    return Number.parseFloat(this._toNumberString(e));
  }
  toDefaultNumber() {
    return this.toNumber(this.defaultUnit);
  }
  toBaseNumber() {
    return this.toNumber(this.baseUnit);
  }
  toBaseBufferLE(e) {
    return this._number.toBaseBufferLE(e);
  }
  toBaseBufferBE(e) {
    return this._number.toBaseBufferBE(e);
  }
  toNumberString(e) {
    return yo(
      "DEPRECATION WARNING: number-unit.toNumberString usage will be removed soon. Use number-unit.toString({unit: false}) instead"
    ), this._toNumberString(e);
  }
  _toNumberString(e = this.unit) {
    const r = "WARNING: number-unit was cloned improperly and is no longer a NumberUnit instance", n = e.toString();
    if (this._numberStringMap && this._numberStringMap.get(n))
      return this._numberStringMap.get(n);
    this._numberStringMap || yo(r);
    let i;
    e === this.unit ? i = this : i = this.to(e);
    let o = i._number.toString(10);
    if (i.unit.power === 0)
      return this._numberStringMap ? this._numberStringMap.set(n, o) : yo(r), o;
    const a = o[0] === "-";
    a && (o = o.slice(1)), o.length < i.unit.power + 1 && (o = o.padStart(i.unit.power + 1, "0")), o = o.slice(0, -i.unit.power) + "." + o.slice(-i.unit.power);
    const s = o.indexOf(".");
    if (s !== -1) {
      let f = o.length - 1;
      for (; o[f] === "0" && f > s; )
        f -= 1;
      f !== o.length - 1 && (o[f] === "." && f--, o = o.slice(0, f + 1));
    }
    return a && (o = "-" + o), this._numberStringMap ? this._numberStringMap.set(n, o) : yo(r), o;
  }
  // TODO: `format` is undocumented, consider if passing `this._number` is correct. Probably should just pass `this`
  toString({ unit: e = !0, format: r, unitInstance: n = this.unit } = {}) {
    return n && (n = this.unitType.units[n.toString()]), r ? r(this._toNumberString(n), n) : this._toNumberString(n) + (e ? " " + n.unitName : "");
  }
  toDefaultString({ unit: e = !1 } = {}) {
    return this.toString({ unitInstance: this.defaultUnit, unit: e });
  }
  toBaseString({ unit: e = !1 } = {}) {
    return this.toString({ unitInstance: this.baseUnit, unit: e });
  }
  // @deprecated
  valueOf() {
    return this.toDefaultNumber();
  }
  // NOTE: for debugging, should probably use Chrome Formatter:
  // https://docs.google.com/document/d/1FTascZXT9cxfetuPRT2eXPQKXui4nWFivUnS_335T3U/preview
  get value() {
    return this.toString();
  }
  get isNegative() {
    return this._number.isNegative();
  }
  get isPositive() {
    return this._number.isPositive();
  }
  get isZero() {
    return this._number.isZero();
  }
  // convert 'number' / 'string' to NumberUnit
  _coerceToNumberUnit(e) {
    return Jt.isNumberUnit(e) ? e : (yo(
      "DEPRECATION WARNING: number-unit.add/sub usage with int or string param will be removed soon"
    ), new Jt(e, this.unit));
  }
};
// so you don't have to do instanceof and get bit by different included versions
Le(Jt, "isNumberUnit", zo);
let Ka = Jt;
function HO(t, e, r) {
  if (r < 0)
    throw new Error("power cannot be less than 0");
  const n = function(i) {
    if (Number.isNaN(i))
      throw new Error("Value NaN not supported for number unit conversion.");
    return zo(i) ? (zi(i, n, "create"), i.to(n)) : Ka.create(i, n);
  };
  return n.unitName = e, n.power = r, n.multiplier = pr.wrap(10, 10).pow(pr.wrap(r, 10)), n.unitType = t, n.toJSON = function() {
    return {
      unitName: n.unitName,
      power: n.power
    };
  }, n[Symbol.toStringTag] = () => String(n), n.toString = function() {
    return n.unitName;
  }, n;
}
const { isEmpty: GO, mapValues: VO, memoize: YO } = tt, Sv = Symbol("UnitType"), Av = (t) => t;
var ff;
const Us = class Us {
  constructor(e, r) {
    // [unitName] // would like this to be "Unit", but TypeScript errors pop up; Flow can't handle this
    Le(this, "units");
    Le(this, "baseUnit");
    Le(this, "defaultUnit");
    Ve(this, ff, void 0);
    $e(r === Sv, "please use UnitType.create()"), this.units = {}, Object.keys(e).forEach((i) => {
      this.units[i] = HO(this, i, e[i]), this[i] = this.units[i];
    });
    const n = Object.keys(this.units).filter((i) => this.units[i].power === 0);
    if (n.length === 0)
      throw new Error("Must specify at least one unit with a power of 0.");
    this.baseUnit = this.units[n[0]], this.defaultUnit = Object.values(this.units).reduce((i, o) => Math.trunc(i.power) > o.power ? i : o, {}), Nt(this, ff, this.defaultUnit(0));
  }
  static equals(e, r) {
    return $e(e instanceof Us, "argument must be a UnitType"), e === r || e.equals(r);
  }
  /*
  // custom inspect with util.inspect.custom ?
  [Symbol.toStringTag]() {
    return Object.values(this.units)
      .map((u) => `(${u.unitName}: ${u.power})`)
      .join(',')
  }
  */
  equals(e) {
    return $e(Xc(e), "argument must be a UnitType"), this === e || this.toString() === e.toString();
  }
  parse(e) {
    const [r, n] = e.split(" ");
    if (this.units[n] === void 0)
      throw new Error(`Unit "${n}" not found from parsing "${e}"`);
    return this.units[n](r);
  }
  toString() {
    return String(this.defaultUnit);
  }
  toJSON() {
    return VO(this.units, (e) => e.power);
  }
  get ZERO() {
    return Se(this, ff);
  }
};
ff = new WeakMap(), Le(Us, "create", YO(
  (e) => ($e(!GO(e), "definitions must have at least one item"), new Us(Av(e), Sv)),
  (e) => JSON.stringify(Av(e))
));
let xi = Us;
const di = (t, e, r) => {
  t[e] === void 0 && r !== void 0 && (t[e] = r);
}, JO = ({ assets: t, asset: e }) => {
  if (Object.defineProperties(e, {
    baseAsset: {
      get() {
        return t[e.baseAssetName || e.name];
      },
      enumerable: !0
    },
    feeAsset: {
      get() {
        return t[e.feeAssetName || e.baseAssetName || e.name];
      },
      enumerable: !0
    }
  }), e.isCombined) {
    const r = e.combinedAssetNames.filter((n) => t[n]);
    Object.defineProperties(e, {
      combinedAssetNames: {
        get() {
          return r;
        },
        enumerable: !0
      }
    }), Object.defineProperties(e, {
      combinedAssets: {
        get() {
          return r.map((n) => t[n]);
        },
        enumerable: !0
      }
    });
  }
  e.isBuiltIn = !e.isCustomToken, e.isCustomToken && XO(e, e.baseAsset);
};
function XO(t, e) {
  const { units: r, properName: n, properTicker: i, ticker: o, color: a } = t;
  di(t, "currency", xi.create(r)), di(t, "displayName", n), di(t, "displayTicker", i || o), di(t, "primaryColor", a || "#FFFFFF"), di(t, "chainBadgeColors", e.chainBadgeColors), di(t, "displayNetworkName", e.displayNetworkName || e.displayName), di(
    t,
    "displayNetworkTicker",
    e.displayNetworkTicker || e.displayTicker
  ), di(t, "blockExplorer", e.blockExplorer), di(t, "gradientCoords", { x1: "0%", y1: "0%", x2: "100%", y2: "100%" }), di(t, "gradientColors", ["#EAEAEA", "#FFF"]);
  const { displayName: s, displayTicker: f } = t;
  return t.properName = s, t.properTicker = f, t;
}
const ZO = (t) => Object.values(t).sort(
  (e, r) => +(r.baseAssetName === r.name) - +(e.baseAssetName === e.name)
);
function QO(t) {
  const e = c9(t, (r) => ({ ...r }));
  return ZO(e).forEach((r) => JO({ assets: e, asset: r })), e;
}
const ek = [
  {
    name: "7dhb_solana_c9e04412",
    displayName: "Lido Staked SOL",
    decimals: 9,
    ticker: "7DHBsolanaC9E04412",
    displayTicker: "stSOL",
    mintAddress: "7dHbWXmci3dT8UFYWYZweBLXgycu7Y3iL6trKn1Y7ARj",
    info: {
      description: "When someone stakes their SOL with Lido, they instantly receive stSOL tokens in return. The stSOL tokens increase in value over time and can be used in other DeFi products while the SOL is staked.",
      telegram: "https://t.me/lidofinance",
      reddit: "https://reddit.com/r/lidofinance",
      twitter: "https://twitter.com/lidofinance",
      website: "https://www.lido.fi"
    },
    primaryColor: "#00A3FF",
    gradientColors: ["#00A3FF", "#3ADCFF"],
    gradientCoords: { x1: "29.931%", y1: "11.994%", x2: "10.494%", y2: "28.187%" }
  },
  {
    name: "7i5k_solana_c9e04412",
    displayName: "STEPN",
    decimals: 9,
    ticker: "7I5KsolanaC9E04412",
    displayTicker: "GMT",
    mintAddress: "7i5KKsX2weiTkry7jA4ZwSuXGhs5eJBEjY8vVxR4pfRx",
    primaryColor: "#E6BC7B",
    gradientColors: ["#FFE5C0", "#E6BC7B"],
    gradientCoords: { x1: "3%", y1: "8.5%", x2: "41.043%", y2: "26.738%" }
  },
  {
    name: "8hgy_solana_43b58185",
    displayName: "COPE",
    decimals: 6,
    ticker: "8HGYsolana43B58185",
    displayTicker: "COPE",
    mintAddress: "8HGyAAB1yoM1ttS7pXjHMa3dukTFGQggnFFH3hJZgzQh",
    info: {
      description: "Cope ranks and indexes online call makers (such as trader influencers on social media), and filters out the ones who make low quality calls. This creates a powerful leaderboard that can be used to follow the top call makers.",
      twitter: "https://twitter.com/unlimitedcope",
      website: "https://www.unlimitedcope.com"
    },
    primaryColor: "#77B0DD",
    gradientColors: ["#44b6BB", "#77B0DD"],
    gradientCoords: { x1: "19.031%", y1: "-66.682%", x2: "123.324%", y2: "91.487%" }
  },
  {
    name: "audius_solana",
    displayName: "Audius",
    decimals: 8,
    ticker: "AUDIOSOL",
    displayTicker: "AUDIO",
    mintAddress: "9LzCMqDgTKYz9Drzqnpgee3SGa89up3a247ypMj2xrqM",
    primaryColor: "#ED43FF",
    gradientColors: ["#EAEAEA", "#FFF"],
    gradientCoords: { x1: "19.031%", y1: "-66.682%", x2: "123.324%", y2: "91.487%" }
  },
  {
    name: "aury_solana_c9e04412",
    displayName: "Aurory",
    decimals: 9,
    ticker: "AURYsolanaC9E04412",
    displayTicker: "AURY",
    mintAddress: "AURYydfxJib1ZkTir1Jn1J9ECYUtjb6rKQVmtYaixWPP",
    info: {
      description: "Aurory is a Solana-based role-playing game that rewards players with NFTs and tokens. Its universe has a blend of Japanese, retro, and futuristic styles, including hand-drawn art.",
      twitter: "https://twitter.com/auroryproject",
      website: "https://aurory.io/",
      telegram: "https://t.me/aurory_project"
    },
    primaryColor: "#B53BE1",
    gradientColors: ["#8312AC", "#B53BE1"],
    gradientCoords: { x1: "22.6%", y1: "7.867%", x2: "22.426%", y2: "30.81%" }
  },
  {
    name: "eche_solana_c5cba5c4",
    displayName: "Bonfida",
    decimals: 6,
    ticker: "ECHEsolanaC5CBA5C4",
    displayTicker: "FIDA",
    mintAddress: "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
    info: {
      description: "FIDA is a Solana-based governance token that offers multiple services such as a graphical user interface for the Serum DEX and Solana data analytics.",
      website: "https://bonfida.org/#/",
      telegram: "https://t.me/bonfidatg"
    },
    primaryColor: "#6868FC",
    gradientColors: ["#A0A0FF", "#6868FC"],
    gradientCoords: { x1: "-4.68%", y1: "1.381%", x2: "48.573%", y2: "30.414%" }
  },
  {
    name: "7atg_solana_3506aeb0",
    displayName: "Catwifhat",
    decimals: 2,
    ticker: "7ATGsolana3506AEB0",
    displayTicker: "CWIF",
    mintAddress: "7atgF8KQo4wJrD5ATGX7t1V2zVvykPJbFfNeVf1icFv1",
    info: {
      description: "Catwifhat is a deflationary memecoin on the Solana network.",
      website: "https://www.catwifhatsolana.com/"
    },
    primaryColor: "#DBDBDB",
    gradientColors: ["#FFFFFF", "#DBDBDB"],
    gradientCoords: { x1: "-4.68%", y1: "1.381%", x2: "48.573%", y2: "30.414%" }
  },
  {
    name: "dezx_solana_3b523050",
    displayName: "Bonk",
    decimals: 5,
    ticker: "DEZXsolana3B523050",
    displayTicker: "BONK",
    mintAddress: "DezXAZ8z7PnrnRJjz3wXBoRgixCa6xjnB7YaB1pPB263",
    info: {
      description: "BONK is a memecoin that gave users airdrops of BONK on the Solana network.",
      website: "https://www.bonkcoin.com/"
    },
    primaryColor: "#6868FC",
    gradientColors: ["#A0A0FF", "#6868FC"],
    gradientCoords: { x1: "-4.68%", y1: "1.381%", x2: "48.573%", y2: "30.414%" }
  },
  {
    name: "gene_solana_c9e04412",
    displayName: "Genopets",
    decimals: 9,
    ticker: "GENEsolanaC9E04412",
    displayTicker: "GENE",
    mintAddress: "GENEtH5amGSi8kHAtQoezp1XEXwZJ8vcuePYnXdKrMYz",
    info: {
      description: "Genopets is a game that rewards users for being active while raising their in-game Genopet. The GENE token offers staking, NFT-creation, exclusive features, and governance of the Genopets platform.",
      reddit: "https://reddit.com/r/genopets",
      twitter: "https://twitter.com/genopets",
      website: "https://www.genopets.me/"
    },
    primaryColor: "#00FFC8",
    gradientColors: ["#00AE89", "#00FFC8"],
    gradientCoords: { x1: "19.031%", y1: "-66.682%", x2: "123.324%", y2: "91.487%" }
  },
  {
    name: "jupy_solana_ed7ebe51",
    displayName: "Jupiter",
    decimals: 6,
    ticker: "JUPYsolanaED7EBE51",
    displayTicker: "JUP",
    mintAddress: "JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN",
    info: {
      description: "JUP is the governance token of the Jupiter platform, originally split 50% to the community and 50% to the Jupiter ecosystem team.  Holders are expecting to vote on token mints and initiatives within the Jupiter platform.",
      twitter: "https://twitter.com/JupiterExchange",
      website: "https://jup.ag/"
    },
    primaryColor: "#00FFC8",
    gradientColors: ["#98C158", "#C7F284"],
    gradientCoords: { x1: "19.031%", y1: "-66.682%", x2: "123.324%", y2: "91.487%" }
  },
  {
    name: "kinx_solana_bf1442d2",
    displayName: "KIN",
    decimals: 5,
    ticker: "KINXsolanaBF1442D2",
    displayTicker: "KIN",
    mintAddress: "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
    info: {
      description: "Kin is used as money in consumer apps and services in the spaces of gaming, finance, communication, and more. By implementing Kin, apps can offer their users the ability to earn, pay, or transfer cryptocurrency.",
      telegram: "https://t.me/TheKinChannel",
      reddit: "https://reddit.com/r/KinFoundation",
      twitter: "https://twitter.com/kin_ecosystem",
      website: "https://kin.org"
    },
    primaryColor: "#946DFC",
    gradientColors: ["#EAEAEA", "#FFF"],
    gradientCoords: { x1: "19.031%", y1: "-66.682%", x2: "123.324%", y2: "91.487%" }
  },
  {
    name: "mang_solana_c5cba5c4",
    displayName: "Mango",
    decimals: 6,
    ticker: "MANGsolanaC5CBA5C4",
    displayTicker: "MNGO",
    mintAddress: "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
    info: {
      description: "MNGO is a governance token for Mango, a DAO offering margin trading, lending, and perpetual futures. Powered by Solana, Mango’s transactions are nearly instant, with fees close to zero. ",
      twitter: "https://twitter.com/mangomarkets",
      website: "https://mango.markets/"
    },
    primaryColor: "#EEB91B",
    gradientColors: ["#E54033", "#EEB91B"],
    gradientCoords: { x1: "61.5%", y1: "7.3%", x2: "47.7%", y2: "-6.5%" }
  },
  {
    name: "mean_solana_c5cba5c4",
    displayName: "Meanfi",
    decimals: 6,
    ticker: "MEANsolanaC5CBA5C4",
    displayTicker: "MEAN",
    mintAddress: "MEANeD3XDdUmNMsRGjASkSWdC8prLYsoRJ61pPeHctD",
    info: {
      description: "MeanFi is a self-custody, trustless bank that connects traditional finance and DeFi. It can save users time and money with services such as money streaming, dollar cost averaging, and searches that find the best prices for Solana-based exchanges.",
      twitter: "https://twitter.com/meanfinance",
      website: "https://meanfi.com/"
    },
    primaryColor: "#FF4F4F",
    gradientColors: ["#B7011C", "#FF4F4F"],
    gradientCoords: { x1: "10.5%", y1: "3.5%", x2: "38.5%", y2: "53.5%" }
  },
  {
    name: "msol_solana_c9e04412",
    displayName: "Marinade Staked SOL",
    decimals: 9,
    ticker: "MSOLsolanaC9E04412",
    displayTicker: "mSOL",
    mintAddress: "mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So",
    info: {
      description: "Marinade Staked SOL is a token users receive for staking their SOL with Marinade, the first liquid staking protocol built on Solana. While earning staking rewards with Marinade, users can earn even more by using their mSOL for borrowing, lending, and other DeFi use cases.",
      twitter: "https://twitter.com/MarinadeFinance",
      website: "https://marinade.finance/"
    },
    primaryColor: "#C8ECE1",
    gradientColors: ["#308DBA", "#C8ECE1"],
    gradientCoords: { x1: "-3.5%", y1: "3.5%", x2: "48.05%", y2: "30.724%" }
  },
  {
    name: "orca_solana",
    displayName: "Orca",
    decimals: 6,
    ticker: "ORCASOL",
    displayTicker: "ORCA",
    mintAddress: "orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
    info: {
      description: "Orca is an AMM on Solana where users can exchange assets with low fees and get rewarded for providing liquidity to trading pools.",
      reddit: "https://www.reddit.com/r/orca_so",
      twitter: "https://twitter.com/orca_so",
      website: "https://orca.so",
      telegram: "https://t.me/orca_so"
    },
    primaryColor: "#5969DB",
    gradientColors: ["#1D257A", "#5969DB"],
    gradientCoords: { x1: "44.5%", y1: "40%", x2: "-4.548%", y2: "4.017%" }
  },
  {
    name: "poli_solana_0cc3745c",
    displayName: "Star Atlas DAO",
    decimals: 8,
    ticker: "POLIsolana0CC3745C",
    displayTicker: "POLIS",
    mintAddress: "poLisWXnNRwC6oBu1vHiuKQzFjGL4XDSu4g9qjz9qVk",
    info: {
      description: "Star Atlas DAO (POLIS) is the governance token for Star Atlas, an expansive, breathtaking gaming metaverse. POLIS holders can participate in decisions that affect how Star Atlas is operated.",
      reddit: "https://reddit.com/r/staratlas",
      twitter: "https://twitter.com/staratlas",
      website: "https://staratlas.com"
    },
    primaryColor: "#32FFFF",
    gradientColors: ["#32FFFF", "#EDFEFF"],
    gradientCoords: { x1: "19.031%", y1: "-66.682%", x2: "123.324%", y2: "91.487%" }
  },
  {
    name: "2b1k_solana_f3924eb0",
    displayName: "PayPal USD",
    decimals: 6,
    ticker: "2B1KsolanaF3924EB0",
    displayTicker: "PYUSD",
    mintAddress: "2b1kV6DkPAnxd5ixfnxCpjxmKwqjjaYmCZfHsFu24GXo",
    info: {
      description: "A stablecoin pegged to the US Dollar, issued by PayPal.",
      website: "https://www.paypal.com/pyusd"
    },
    primaryColor: "#0071F3",
    gradientColors: ["#0071F3", "#338EF8"],
    gradientCoords: { x1: "0%", y1: "0%", x2: "100%", y2: "100%" }
  },
  {
    name: "raydium",
    displayName: "Raydium",
    decimals: 6,
    ticker: "RAY",
    mintAddress: "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
    info: {
      description: "Raydium, an AMM (Automated Market Market), powers DeFi on the Solana blockchain, providing on-chain liquidity for the Serum Decentralized Exchange. This means lightning fast token swaps and a whole lot more!",
      twitter: "https://twitter.com/RaydiumProtocol",
      website: "https://raydium.io/",
      telegram: "https://t.me/raydiumprotocol"
    },
    primaryColor: "#3772FF",
    gradientColors: ["#3772FF", "#C200FB"],
    gradientCoords: { x1: "99.911%", y1: "25.033%", x2: "-6.116%", y2: "61.756%" }
  },
  {
    name: "rndr_solana_4b3ba195",
    displayName: "Render",
    decimals: 8,
    ticker: "RNDRsolana4B3BA195",
    displayTicker: "RENDER",
    mintAddress: "rndrizKT3MK1iimdxRdWabcF7Zg7AR5T4nud4EkHBof",
    info: {
      description: "Render is a token that creators can pay to node operators to get GPU rendering power for their work on images, animation, and special effects. This saves creators money as it’s cheaper than in-house rendering, and it allows node operators to earn RNDR with their idle GPUs.",
      reddit: "https://www.reddit.com/r/RenderToken/",
      twitter: "https://twitter.com/rendertoken",
      website: "https://rendertoken.com/",
      telegram: "https://t.me/RenderTokenOfficial"
    },
    primaryColor: "#FF5A5A",
    gradientColors: ["#E62249", "#FF5A5A"],
    gradientCoords: { x1: "38%", y1: "37.5%", x2: "0.537%", y2: "6.714%" }
  },
  {
    name: "serum",
    displayName: "Serum",
    decimals: 6,
    ticker: "SRM",
    mintAddress: "SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt",
    info: {
      description: "SRM tokens power Serum, a centralized exchange software system built on the Solana blockchain. It allows for trading of cryptocurrencies and has the advantage of a cross-chain support, meaning that it enables a trustless exchange of crypto between various blockchains.",
      reddit: "https://www.reddit.com/r/ProjectSerum/",
      twitter: "https://twitter.com/ProjectSerum",
      website: "https://projectserum.com/"
    },
    primaryColor: "#71E0EC",
    gradientColors: ["#71E0EC", "#05AAC5"],
    gradientCoords: { x1: "0%", y1: "-.006%", x2: "99.694%", y2: "99.694%" }
  },
  {
    name: "smoothlovepotion_solana",
    displayName: "Smooth Love Potion",
    decimals: 8,
    ticker: "SLPSOL",
    displayTicker: "SLP",
    mintAddress: "4hpngEp1v3CXpeKB81Gw4sv7YvwUVRKvY3SGag9ND8Q4",
    primaryColor: "#77BAA1",
    gradientColors: ["#EAEAEA", "#FFF"],
    gradientCoords: { x1: "19.031%", y1: "-66.682%", x2: "123.324%", y2: "91.487%" }
  },
  {
    name: "staratlas_solana",
    displayName: "Star Atlas",
    decimals: 8,
    ticker: "ATLASSOL",
    displayTicker: "ATLAS",
    mintAddress: "ATLASXmbPQxBUYbxPsV97usA3fPQYEqzQBUHgiFCUsXx",
    info: {
      description: "Star Atlas is a massive multiplayer online game in a breathtaking metaverse run on Solana. Players can travel in space, build space stations, form alliances, and battle for virtual assets.",
      reddit: "https://reddit.com/r/staratlas",
      twitter: "https://twitter.com/staratlas",
      website: "https://staratlas.com",
      telegram: "https://t.me/staratlasgame"
    },
    primaryColor: "#32FFFF",
    gradientColors: ["#32FFFF", "#EDFEFF"],
    gradientCoords: { x1: "44.5%", y1: "40%", x2: "-4.548%", y2: "4.017%" }
  },
  {
    name: "tetherusd_solana",
    displayName: "Tether USD",
    decimals: 6,
    ticker: "USDTSOL",
    displayTicker: "USDT",
    mintAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    primaryColor: "#53AE94",
    gradientColors: ["#EAEAEA", "#FFF"],
    gradientCoords: { x1: "19.031%", y1: "-66.682%", x2: "123.324%", y2: "91.487%" }
  },
  {
    name: "thegraph_solana",
    displayName: "The Graph",
    decimals: 8,
    ticker: "GRTSOL",
    displayTicker: "GRT",
    mintAddress: "HGsLG4PnZ28L8A4R5nPqKgZd86zUUdmfnkTRnuFJ5dAX",
    primaryColor: "#33A0FF",
    gradientColors: ["#EAEAEA", "#FFF"],
    gradientCoords: { x1: "19.031%", y1: "-66.682%", x2: "123.324%", y2: "91.487%" }
  },
  {
    name: "tulip_solana",
    displayName: "Tulip Protocol",
    decimals: 6,
    ticker: "TULIPSOL",
    displayTicker: "TULIP",
    mintAddress: "TuLipcqtGVXP9XR62wM8WWCm6a9vhLs7T1uoWBk6FDs",
    info: {
      description: "Tulip is the first Solana-powered platform to offer decentralized yield aggregation and auto-compounding vault strategies.",
      twitter: "https://twitter.com/tulipprotocol",
      website: "https://tulip.garden",
      telegram: "https://t.me/tulipprotocol"
    },
    primaryColor: "#1C88B4",
    gradientColors: ["#2BD9B9", "#D141E9"],
    gradientCoords: { x1: "44.5%", y1: "40%", x2: "-4.548%", y2: "4.017%" }
  },
  {
    name: "usdcoin_solana",
    displayName: "USD Coin",
    decimals: 6,
    ticker: "USDCSOL",
    displayTicker: "USDC",
    mintAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    primaryColor: "#3E90E8",
    gradientColors: ["#EAEAEA", "#FFF"],
    gradientCoords: { x1: "19.031%", y1: "-66.682%", x2: "123.324%", y2: "91.487%" }
  }
];
function tk(t) {
  return t.units || {
    base: 0,
    [t.ticker]: t.decimals
  };
}
const W0 = "solana", H0 = "Solana", rk = "SOL", G0 = "SOL", yw = G0, bw = H0, gw = W0, nk = "#14F195", ik = ["#14F195", "#9BFFD7"], ok = { x1: "12.519%", y1: "28.482%", x2: "27.289%", y2: "11.831%" }, ak = ["#0CF3A8", "#D823FE"], vw = {
  Lamports: 0,
  SOL: 9
}, sk = xi.create(vw), fk = "SOLANA_LIKE", mw = {
  addressUrl: (t) => `https://solscan.io/account/${encodeURIComponent(t)}`,
  txUrl: (t) => `https://solscan.io/tx/${encodeURIComponent(t)}`
}, ck = {
  description: "Solana is a high-performance blockchain, taking on one of tech's biggest challenges: scaling blockchain for global adoption.",
  reddit: "https://www.reddit.com/r/solana/",
  twitter: "https://twitter.com/solana",
  website: "https://solana.com/",
  telegram: "https://t.me/solana"
}, uk = {
  assetType: fk,
  baseAssetName: gw,
  blockExplorer: mw,
  chainBadgeColors: ak,
  currency: sk,
  displayName: H0,
  displayNetworkName: bw,
  displayNetworkTicker: yw,
  displayTicker: G0,
  gradientColors: ik,
  gradientCoords: ok,
  info: ck,
  name: W0,
  primaryColor: nk,
  properName: H0,
  // deprecated
  properTicker: G0,
  // deprecated
  ticker: rk,
  toString: () => W0,
  units: vw
}, dk = ek.map((t) => {
  const e = tk(t);
  return {
    ...t,
    // name,
    // displayName,
    // decimals,
    // ticker,
    // info,
    // primaryColor,
    // gradientColors
    // gradientCoords
    assetType: "SOLANA_TOKEN",
    baseAssetName: gw,
    blockExplorer: mw,
    chainBadgeColors: t.chainBadgeColors || t.gradientColors,
    currency: xi.create(e),
    displayNetworkName: bw,
    displayNetworkTicker: yw,
    displayTicker: t.displayTicker || t.ticker,
    mintAddress: t.mintAddress,
    info: t.info || {},
    properName: t.displayName,
    // deprecated
    properTicker: t.displayTicker || t.ticker,
    // deprecated
    toString: () => t.name,
    units: e
  };
}), lk = [uk, ...dk];
var ww = {}, V0 = function() {
  return V0 = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, V0.apply(this, arguments);
}, Iv = function(t, e, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, Ns = function(t, e, r) {
  if (r === void 0 && (r = !1), !t || !e || typeof t != "object" || typeof e != "object")
    return t;
  var n = V0({}, t);
  for (var i in e)
    e.hasOwnProperty(i) && (e[i] instanceof Array && t[i] instanceof Array ? n[i] = r ? Iv(Iv([], t[i], !0), e[i], !0) : e[i] : typeof e[i] == "object" && typeof t[i] == "object" ? n[i] = Ns(t[i], e[i], r) : n[i] = e[i]);
  return n;
};
const Bv = globalThis || void 0 || self;
var hk = function(t, e, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, vn = {
  // Default options
  defaults: {},
  // Error type
  errorType: null,
  // Polyfills
  polyfills: {
    fetch: null,
    FormData: null,
    URLSearchParams: null,
    performance: null,
    PerformanceObserver: null,
    AbortController: null
  },
  polyfill: function(t, e) {
    for (var r = e === void 0 ? {} : e, n = r.doThrow, i = n === void 0 ? !0 : n, o = r.instance, a = o === void 0 ? !1 : o, s = [], f = 2; f < arguments.length; f++)
      s[f - 2] = arguments[f];
    var u = this.polyfills[t] || (typeof self < "u" ? self[t] : null) || (typeof Bv < "u" ? Bv[t] : null);
    if (i && !u)
      throw new Error(t + " is not defined");
    return a && u ? new (u.bind.apply(u, hk([void 0], s, !1)))() : u;
  }
}, xw = function(t, e, r, n) {
  if (!t.getEntriesByName)
    return !1;
  var i = t.getEntriesByName(e);
  return i && i.length > 0 ? (r(i.reverse()[0]), n.clearMeasures && n.clearMeasures(e), ti.callbacks.delete(e), ti.callbacks.size < 1 && (ti.observer.disconnect(), n.clearResourceTimings && n.clearResourceTimings()), !0) : !1;
}, pk = function(t, e) {
  return !ti.observer && t && e && (ti.observer = new e(function(r) {
    ti.callbacks.forEach(function(n, i) {
      xw(r, i, n, t);
    });
  }), t.clearResourceTimings && t.clearResourceTimings()), ti.observer;
}, ti = {
  callbacks: /* @__PURE__ */ new Map(),
  observer: null,
  observe: function(t, e) {
    if (!(!t || !e)) {
      var r = vn.polyfill("performance", { doThrow: !1 }), n = vn.polyfill("PerformanceObserver", { doThrow: !1 });
      pk(r, n) && (xw(r, t, e, r) || (ti.callbacks.size < 1 && ti.observer.observe({ entryTypes: ["resource", "measure"] }), ti.callbacks.set(t, e)));
    }
  }
}, yk = function(t) {
  return function(e) {
    return t.length === 0 ? e : t.length === 1 ? t[0](e) : t.reduceRight(function(r, n, i) {
      return i === t.length - 2 ? n(r(e)) : n(r);
    });
  };
}, kh = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      this.error = e;
    }
    return t;
  }()
), bk = function(t) {
  var e = t._url, r = t._catchers, n = t._resolvers, i = t._middlewares, o = t._options, a = new Map(r), s = Ns(vn.defaults, o), f = vn.polyfill("AbortController", { doThrow: !1, instance: !0 });
  !s.signal && f && (s.signal = f.signal);
  var u = {
    ref: null,
    clear: function() {
      u.ref && (clearTimeout(u.ref), u.ref = null);
    }
  }, c = yk(i)(vn.polyfill("fetch"))(e, s), d = c.catch(function(b) {
    throw new kh(b);
  }).then(function(b) {
    if (u.clear(), !b.ok) {
      if (b.type === "opaque") {
        var w = new Error("Opaque response");
        throw w.status = b.status, w.response = b, w;
      }
      return b[vn.errorType || "text"]().then(function(A) {
        var M = new Error(A);
        throw M[vn.errorType || "text"] = A, M.status = b.status, M.response = b, M;
      });
    }
    return b;
  }), l = function(b) {
    return b.catch(function(w) {
      u.clear();
      var A = w instanceof kh ? w.error : w;
      if (w instanceof kh && a.has("__fromFetch"))
        return a.get("__fromFetch")(A, t);
      if (a.has(A.status))
        return a.get(A.status)(A, t);
      if (a.has(A.name))
        return a.get(A.name)(A, t);
      throw A;
    });
  }, h = function(b) {
    return function(w) {
      return /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ l(b ? d.then(function(A) {
        return A && A[b]();
      }).then(function(A) {
        return w ? w(A) : A;
      }) : d.then(function(A) {
        return w ? w(A) : A;
      }));
    };
  }, y = {
    /**
     * Retrieves the raw result as a promise.
     */
    res: h(null),
    /**
     * Retrieves the result as a parsed JSON object.
     */
    json: h("json"),
    /**
     * Retrieves the result as a Blob object.
     */
    blob: h("blob"),
    /**
     * Retrieves the result as a FormData object.
     */
    formData: h("formData"),
    /**
     * Retrieves the result as an ArrayBuffer object.
     */
    arrayBuffer: h("arrayBuffer"),
    /**
     * Retrieves the result as a string.
     */
    text: h("text"),
    /**
     * Performs a callback on the API performance timings of the request.
     *
     * Warning: Still experimental on browsers and node.js
     */
    perfs: function(b) {
      return c.then(function(w) {
        return ti.observe(w.url, b);
      }).catch(function() {
      }), y;
    },
    /**
     * Aborts the request after a fixed time.
     *
     * @param time Time in milliseconds
     * @param controller A custom controller
     */
    setTimeout: function(b, w) {
      return w === void 0 && (w = f), u.clear(), u.ref = setTimeout(function() {
        return w.abort();
      }, b), y;
    },
    /**
     * Returns the automatically generated AbortController alongside the current wretch response as a pair.
     */
    controller: function() {
      return [f, y];
    },
    /**
     * Catches an http response with a specific error code or name and performs a callback.
     */
    error: function(b, w) {
      return a.set(b, w), y;
    },
    /**
     * Catches a bad request (http code 400) and performs a callback.
     */
    badRequest: function(b) {
      return y.error(400, b);
    },
    /**
     * Catches an unauthorized request (http code 401) and performs a callback.
     */
    unauthorized: function(b) {
      return y.error(401, b);
    },
    /**
     * Catches a forbidden request (http code 403) and performs a callback.
     */
    forbidden: function(b) {
      return y.error(403, b);
    },
    /**
     * Catches a "not found" request (http code 404) and performs a callback.
     */
    notFound: function(b) {
      return y.error(404, b);
    },
    /**
     * Catches a timeout (http code 408) and performs a callback.
     */
    timeout: function(b) {
      return y.error(408, b);
    },
    /**
     * Catches an internal server error (http code 500) and performs a callback.
     */
    internalError: function(b) {
      return y.error(500, b);
    },
    /**
     * Catches errors thrown when calling the fetch function and performs a callback.
     */
    fetchError: function(b) {
      return y.error("__fromFetch", b);
    },
    /**
     * Catches an AbortError and performs a callback.
     */
    onAbort: function(b) {
      return y.error("AbortError", b);
    }
  };
  return n.reduce(function(b, w) {
    return w(b, t);
  }, y);
}, Xn = function() {
  return Xn = Object.assign || function(t) {
    for (var e, r = 1, n = arguments.length; r < n; r++) {
      e = arguments[r];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, Xn.apply(this, arguments);
}, Zn = function(t, e, r) {
  if (r || arguments.length === 2)
    for (var n = 0, i = e.length, o; n < i; n++)
      (o || !(n in e)) && (o || (o = Array.prototype.slice.call(e, 0, n)), o[n] = e[n]);
  return t.concat(o || Array.prototype.slice.call(e));
}, gk = "application/json", _w = "Content-Type";
function Mv(t) {
  var e;
  return t === void 0 && (t = {}), (e = Object.entries(t).find(function(r) {
    var n = r[0];
    return n.toLowerCase() === _w.toLowerCase();
  })) === null || e === void 0 ? void 0 : e[1];
}
function Rv(t) {
  return /^application\/.*json.*/.test(t);
}
var O1 = (
  /** @class */
  function() {
    function t(e, r, n, i, o, a) {
      n === void 0 && (n = /* @__PURE__ */ new Map()), i === void 0 && (i = []), o === void 0 && (o = []), a === void 0 && (a = []), this._url = e, this._options = r, this._catchers = n, this._resolvers = i, this._middlewares = o, this._deferredChain = a;
    }
    return t.factory = function(e, r) {
      return e === void 0 && (e = ""), r === void 0 && (r = {}), new t(e, r);
    }, t.prototype.selfFactory = function(e) {
      var r = e === void 0 ? {} : e, n = r.url, i = n === void 0 ? this._url : n, o = r.options, a = o === void 0 ? this._options : o, s = r.catchers, f = s === void 0 ? this._catchers : s, u = r.resolvers, c = u === void 0 ? this._resolvers : u, d = r.middlewares, l = d === void 0 ? this._middlewares : d, h = r.deferredChain, y = h === void 0 ? this._deferredChain : h;
      return new t(i, Xn({}, a), new Map(f), Zn([], c, !0), Zn([], l, !0), Zn([], y, !0));
    }, t.prototype.defaults = function(e, r) {
      return r === void 0 && (r = !1), vn.defaults = r ? Ns(vn.defaults, e) : e, this;
    }, t.prototype.errorType = function(e) {
      return vn.errorType = e, this;
    }, t.prototype.polyfills = function(e) {
      return vn.polyfills = Xn(Xn({}, vn.polyfills), e), this;
    }, t.prototype.url = function(e, r) {
      if (r === void 0 && (r = !1), r)
        return this.selfFactory({ url: e });
      var n = this._url.split("?");
      return this.selfFactory({
        url: n.length > 1 ? n[0] + e + "?" + n[1] : this._url + e
      });
    }, t.prototype.options = function(e, r) {
      return r === void 0 && (r = !0), this.selfFactory({ options: r ? Ns(this._options, e) : e });
    }, t.prototype.query = function(e, r) {
      return r === void 0 && (r = !1), this.selfFactory({ url: vk(this._url, e, r) });
    }, t.prototype.headers = function(e) {
      return this.selfFactory({ options: Ns(this._options, { headers: e || {} }) });
    }, t.prototype.accept = function(e) {
      return this.headers({ Accept: e });
    }, t.prototype.content = function(e) {
      var r;
      return this.headers((r = {}, r[_w] = e, r));
    }, t.prototype.auth = function(e) {
      return this.headers({ Authorization: e });
    }, t.prototype.catcher = function(e, r) {
      var n = new Map(this._catchers);
      return n.set(e, r), this.selfFactory({ catchers: n });
    }, t.prototype.signal = function(e) {
      return this.selfFactory({ options: Xn(Xn({}, this._options), { signal: e.signal }) });
    }, t.prototype.resolve = function(e, r) {
      return r === void 0 && (r = !1), this.selfFactory({ resolvers: r ? [e] : Zn(Zn([], this._resolvers, !0), [e], !1) });
    }, t.prototype.defer = function(e, r) {
      return r === void 0 && (r = !1), this.selfFactory({
        deferredChain: r ? [e] : Zn(Zn([], this._deferredChain, !0), [e], !1)
      });
    }, t.prototype.middlewares = function(e, r) {
      return r === void 0 && (r = !1), this.selfFactory({
        middlewares: r ? e : Zn(Zn([], this._middlewares, !0), e, !0)
      });
    }, t.prototype.method = function(e, r, n) {
      r === void 0 && (r = {}), n === void 0 && (n = null);
      var i = this.options(Xn(Xn({}, r), { method: e })), o = Mv(i._options.headers), a = typeof n == "object" && (!i._options.headers || !o || Rv(o));
      return i = n ? a ? i.json(n, o) : i.body(n) : i, bk(i._deferredChain.reduce(function(s, f) {
        return f(s, s._url, s._options);
      }, i));
    }, t.prototype.get = function(e) {
      return this.method("GET", e);
    }, t.prototype.delete = function(e) {
      return this.method("DELETE", e);
    }, t.prototype.put = function(e, r) {
      return this.method("PUT", r, e);
    }, t.prototype.post = function(e, r) {
      return this.method("POST", r, e);
    }, t.prototype.patch = function(e, r) {
      return this.method("PATCH", r, e);
    }, t.prototype.head = function(e) {
      return this.method("HEAD", e);
    }, t.prototype.opts = function(e) {
      return this.method("OPTIONS", e);
    }, t.prototype.replay = function(e) {
      return this.method(this._options.method, e);
    }, t.prototype.body = function(e) {
      return this.selfFactory({ options: Xn(Xn({}, this._options), { body: e }) });
    }, t.prototype.json = function(e, r) {
      var n = Mv(this._options.headers);
      return this.content(r || Rv(n) && n || gk).body(JSON.stringify(e));
    }, t.prototype.formData = function(e, r) {
      return r === void 0 && (r = !1), this.body(Ew(e, r));
    }, t.prototype.formUrl = function(e) {
      return this.body(typeof e == "string" ? e : mk(e)).content("application/x-www-form-urlencoded");
    }, t;
  }()
), vk = function(t, e, r) {
  var n;
  if (typeof e == "string")
    n = e;
  else {
    var i = vn.polyfill("URLSearchParams", { instance: !0 });
    for (var o in e)
      if (e[o] instanceof Array)
        for (var a = 0, s = e[o]; a < s.length; a++) {
          var f = s[a];
          i.append(o, f);
        }
      else
        i.append(o, e[o]);
    n = i.toString();
  }
  var u = t.split("?");
  return n ? r || u.length < 2 ? u[0] + "?" + n : t + "&" + n : r ? u[0] : t;
};
function Ew(t, e, r, n) {
  return e === void 0 && (e = !1), r === void 0 && (r = vn.polyfill("FormData", { instance: !0 })), n === void 0 && (n = []), Object.entries(t).forEach(function(i) {
    var o = i[0], a = i[1], s = n.reduce(function(d, l) {
      return d ? "".concat(d, "[").concat(l, "]") : l;
    }, null);
    if (s = s ? "".concat(s, "[").concat(o, "]") : o, a instanceof Array)
      for (var f = 0, u = a; f < u.length; f++) {
        var c = u[f];
        r.append(s + "[]", c);
      }
    else
      e && typeof a == "object" && (!(e instanceof Array) || !e.includes(o)) ? a !== null && Ew(a, e, r, Zn(Zn([], n, !0), [o], !1)) : r.append(s, a);
  }), r;
}
function Tv(t, e) {
  return encodeURIComponent(t) + "=" + encodeURIComponent(typeof e == "object" ? JSON.stringify(e) : "" + e);
}
function mk(t) {
  return Object.keys(t).map(function(e) {
    var r = t[e];
    return r instanceof Array ? r.map(function(n) {
      return Tv(e, n);
    }).join("&") : Tv(e, r);
  }).join("&");
}
var k1 = O1.factory;
k1.default = O1.factory;
const wk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Wretcher: O1,
  default: k1
}, Symbol.toStringTag, { value: "Module" })), xk = /* @__PURE__ */ _f(wk);
Object.defineProperty(ww, "__esModule", {
  value: !0
});
var Ov = ww.default = Ak, _k = Ek(xk);
function Ek(t) {
  return t && t.__esModule ? t : { default: t };
}
function kv(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Cv(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? kv(Object(r), !0).forEach(function(n) {
      Sk(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : kv(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Sk(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function Ak(t, e = {}) {
  return (0, _k.default)(t).middlewares([(r) => async (n, i) => {
    const o = JSON.stringify(Cv({
      jsonrpc: "2.0",
      id: 1,
      params: []
    }, JSON.parse(i.body)));
    return r(n, Cv({}, i, {
      body: o
    }));
  }]).resolve(async (r) => {
    const {
      result: n,
      error: i
    } = await r.json();
    if (i)
      throw new Error(JSON.stringify(i));
    return n;
  });
}
var Sw = {}, C1 = { exports: {} };
const Ik = (t, e) => Math.floor(Math.random() * (e - t + 1) + t), Pv = () => {
  const t = new Error("Delay aborted");
  return t.name = "AbortError", t;
}, Zc = ({ clearTimeout: t, setTimeout: e, willResolve: r }) => (n, { value: i, signal: o } = {}) => {
  if (o && o.aborted)
    return Promise.reject(Pv());
  let a, s, f;
  const u = t || clearTimeout, c = () => {
    u(a), f(Pv());
  }, d = () => {
    o && o.removeEventListener("abort", c);
  }, l = new Promise((h, y) => {
    s = () => {
      d(), r ? h(i) : y(i);
    }, f = y, a = (e || setTimeout)(s, n);
  });
  return o && o.addEventListener("abort", c, { once: !0 }), l.clear = () => {
    u(a), a = null, s();
  }, l;
}, Wa = Zc({ willResolve: !0 });
Wa.reject = Zc({ willResolve: !1 });
Wa.range = (t, e, r) => Wa(Ik(t, e), r);
Wa.createWithTimers = ({ clearTimeout: t, setTimeout: e }) => {
  const r = Zc({ clearTimeout: t, setTimeout: e, willResolve: !0 });
  return r.reject = Zc({ clearTimeout: t, setTimeout: e, willResolve: !1 }), r;
};
C1.exports = Wa;
C1.exports.default = Wa;
var Bk = C1.exports, Ha = 1e3, Ga = Ha * 60, Va = Ga * 60, Ko = Va * 24, Mk = Ko * 7, Rk = Ko * 365.25, Aw = function(t, e) {
  e = e || {};
  var r = typeof t;
  if (r === "string" && t.length > 0)
    return Tk(t);
  if (r === "number" && isFinite(t))
    return e.long ? kk(t) : Ok(t);
  throw new Error(
    "val is not a non-empty string or a valid number. val=" + JSON.stringify(t)
  );
};
function Tk(t) {
  if (t = String(t), !(t.length > 100)) {
    var e = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
      t
    );
    if (e) {
      var r = parseFloat(e[1]), n = (e[2] || "ms").toLowerCase();
      switch (n) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return r * Rk;
        case "weeks":
        case "week":
        case "w":
          return r * Mk;
        case "days":
        case "day":
        case "d":
          return r * Ko;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return r * Va;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return r * Ga;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return r * Ha;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return r;
        default:
          return;
      }
    }
  }
}
function Ok(t) {
  var e = Math.abs(t);
  return e >= Ko ? Math.round(t / Ko) + "d" : e >= Va ? Math.round(t / Va) + "h" : e >= Ga ? Math.round(t / Ga) + "m" : e >= Ha ? Math.round(t / Ha) + "s" : t + "ms";
}
function kk(t) {
  var e = Math.abs(t);
  return e >= Ko ? ic(t, e, Ko, "day") : e >= Va ? ic(t, e, Va, "hour") : e >= Ga ? ic(t, e, Ga, "minute") : e >= Ha ? ic(t, e, Ha, "second") : t + " ms";
}
function ic(t, e, r, n) {
  var i = e >= r * 1.5;
  return Math.round(t / r) + " " + n + (i ? "s" : "");
}
const ta = /* @__PURE__ */ sn(Aw);
Object.defineProperty(Sw, "__esModule", {
  value: !0
});
var Ck = Sw.retry = Uk, Pk = Iw(Bk), Nv = Iw(Aw);
function Iw(t) {
  return t && t.__esModule ? t : { default: t };
}
function Nk(t) {
  return t instanceof Error ? Object.assign({
    name: t.name,
    message: t.message,
    stack: t.stack
  }, t) : t;
}
function Uk(t, {
  delayTimesMs: e = [(0, Nv.default)("10s")]
}) {
  return async function(...r) {
    const n = e.map((a) => typeof a == "number" ? a : (0, Nv.default)(a)), i = [];
    let o = 0;
    for (; ; )
      try {
        return await t(...r);
      } catch (a) {
        const s = a || new Error("Null error");
        if (s.finalError || o === n.length)
          throw s.errorChain = i, s;
        i.push(Nk(s)), await (0, Pk.default)(n[o]), o++;
      }
  };
}
var Fk = Yo();
const Uv = /* @__PURE__ */ sn(Fk), Ct = eo.lowlevel, Lk = 32;
class Zt {
  /**
   * Create a new PublicKey object
   */
  constructor(e) {
    Le(this, "_bn");
    if (typeof e == "string") {
      const r = fr.decode(e);
      if (r.length !== 32)
        throw new Error("Invalid public key input");
      this._bn = new Ni(r);
    } else
      this._bn = new Ni(e);
    if (this._bn.byteLength() > 32)
      throw new Error("Invalid public key input");
  }
  /**
   * Checks if two publicKeys are equal
   */
  equals(e) {
    return this._bn.eq(e._bn);
  }
  /**
   * Return the base-58 representation of the public key
   */
  toBase58() {
    return fr.encode(this.toBuffer());
  }
  /**
   * Return the byte array representation of the public key in big endian
   */
  toBytes() {
    const e = this.toBuffer();
    return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  }
  /**
   * Return the Buffer representation of the public key
   */
  toBuffer() {
    const e = this._bn.toArrayLike(Ie);
    if (e.length === 32)
      return e;
    const r = Ie.alloc(32);
    return e.copy(r, 32 - e.length), r;
  }
  /**
   * Returns a string representation of the public key
   */
  toString() {
    return this.toBase58();
  }
  /**
   * Returns a JSON representation of the public key
   */
  toJSON() {
    return this.toBase58();
  }
  /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   * HACK: transformed in sync function
   */
  static findProgramAddress(e, r) {
    let n = 255, i;
    for (; n !== 0; ) {
      try {
        const o = [...e, Ie.from([n])];
        i = this.createProgramAddress(o, r);
      } catch {
        n--;
        continue;
      }
      return [i, n];
    }
    throw new Error("Unable to find a viable program address nonce");
  }
  /**
   * Derive a public key from another key, a seed, and a program ID.
   * HACK: transformed in sync function
   */
  static createWithSeed(e, r, n) {
    const i = Ie.concat([
      e.toBuffer(),
      Ie.from(r),
      n.toBuffer()
    ]), o = Uv("sha256").update(i).digest("hex");
    return new Zt(Ie.from(o, "hex"));
  }
  /**
   * Derive a program address from seeds and a program ID.
   */
  static createProgramAddress(e, r) {
    let n = Ie.alloc(0);
    e.forEach(function(a) {
      if (a.length > Lk)
        throw new Error("Max seed length exceeded");
      n = Ie.concat([n, Ie.from(a)]);
    }), n = Ie.concat([n, r.toBuffer(), Ie.from("ProgramDerivedAddress")]);
    const i = Uv("sha256").update(n).digest("hex"), o = new Ni(i, 16).toArray(null, 32);
    if (jk(o))
      throw new Error("Invalid seeds, address must fall off the curve");
    return new Zt(o);
  }
}
function jk(t) {
  const e = [Ct.gf(), Ct.gf(), Ct.gf(), Ct.gf()], r = Ct.gf(), n = Ct.gf(), i = Ct.gf(), o = Ct.gf(), a = Ct.gf(), s = Ct.gf(), f = Ct.gf();
  return Ct.set25519(e[2], Dk), Ct.unpack25519(e[1], t), Ct.S(i, e[1]), Ct.M(o, i, Ct.D), Ct.Z(i, i, e[2]), Ct.A(o, e[2], o), Ct.S(a, o), Ct.S(s, a), Ct.M(f, s, a), Ct.M(r, f, i), Ct.M(r, r, o), Ct.pow2523(r, r), Ct.M(r, r, i), Ct.M(r, r, o), Ct.M(r, r, o), Ct.M(e[0], r, o), Ct.S(n, e[0]), Ct.M(n, n, o), Fv(n, i) && Ct.M(e[0], e[0], $k), Ct.S(n, e[0]), Ct.M(n, n, o), Fv(n, i) ? 0 : 1;
}
const Dk = Ct.gf([1]), $k = Ct.gf([
  41136,
  18958,
  6951,
  50414,
  58488,
  44335,
  6150,
  12099,
  55207,
  15867,
  153,
  11085,
  57099,
  20417,
  9344,
  11139
]);
function Fv(t, e) {
  var r = new Uint8Array(32), n = new Uint8Array(32);
  return Ct.pack25519(r, t), Ct.pack25519(n, e), Ct.crypto_verify_32(r, 0, n, 0);
}
var Ch = { exports: {} }, Ph = {}, Ya = {}, Bw = {}, P1 = function() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var e = {}, r = Symbol("test"), n = Object(r);
  if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
    return !1;
  var i = 42;
  e[r] = i;
  for (r in e)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
    return !1;
  var o = Object.getOwnPropertySymbols(e);
  if (o.length !== 1 || o[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var a = Object.getOwnPropertyDescriptor(e, r);
    if (a.value !== i || a.enumerable !== !0)
      return !1;
  }
  return !0;
}, qk = P1, N1 = function() {
  return qk() && !!Symbol.toStringTag;
}, zk = Error, Kk = EvalError, Wk = RangeError, Hk = ReferenceError, Mw = SyntaxError, wd = TypeError, Gk = URIError, Lv = typeof Symbol < "u" && Symbol, Vk = P1, Yk = function() {
  return typeof Lv != "function" || typeof Symbol != "function" || typeof Lv("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : Vk();
}, Nh = {
  __proto__: null,
  foo: {}
}, Jk = Object, Xk = function() {
  return { __proto__: Nh }.foo === Nh.foo && !(Nh instanceof Jk);
}, Zk = "Function.prototype.bind called on incompatible ", Qk = Object.prototype.toString, eC = Math.max, tC = "[object Function]", jv = function(e, r) {
  for (var n = [], i = 0; i < e.length; i += 1)
    n[i] = e[i];
  for (var o = 0; o < r.length; o += 1)
    n[o + e.length] = r[o];
  return n;
}, rC = function(e, r) {
  for (var n = [], i = r || 0, o = 0; i < e.length; i += 1, o += 1)
    n[o] = e[i];
  return n;
}, nC = function(t, e) {
  for (var r = "", n = 0; n < t.length; n += 1)
    r += t[n], n + 1 < t.length && (r += e);
  return r;
}, iC = function(e) {
  var r = this;
  if (typeof r != "function" || Qk.apply(r) !== tC)
    throw new TypeError(Zk + r);
  for (var n = rC(arguments, 1), i, o = function() {
    if (this instanceof i) {
      var c = r.apply(
        this,
        jv(n, arguments)
      );
      return Object(c) === c ? c : this;
    }
    return r.apply(
      e,
      jv(n, arguments)
    );
  }, a = eC(0, r.length - n.length), s = [], f = 0; f < a; f++)
    s[f] = "$" + f;
  if (i = Function("binder", "return function (" + nC(s, ",") + "){ return binder.apply(this,arguments); }")(o), r.prototype) {
    var u = function() {
    };
    u.prototype = r.prototype, i.prototype = new u(), u.prototype = null;
  }
  return i;
}, oC = iC, U1 = Function.prototype.bind || oC, aC = Function.prototype.call, sC = Object.prototype.hasOwnProperty, fC = U1, cC = fC.call(aC, sC), Ut, uC = zk, dC = Kk, lC = Wk, hC = Hk, Ja = Mw, Oa = wd, pC = Gk, Rw = Function, Uh = function(t) {
  try {
    return Rw('"use strict"; return (' + t + ").constructor;")();
  } catch {
  }
}, Po = Object.getOwnPropertyDescriptor;
if (Po)
  try {
    Po({}, "");
  } catch {
    Po = null;
  }
var Fh = function() {
  throw new Oa();
}, yC = Po ? function() {
  try {
    return arguments.callee, Fh;
  } catch {
    try {
      return Po(arguments, "callee").get;
    } catch {
      return Fh;
    }
  }
}() : Fh, sa = Yk(), bC = Xk(), Fr = Object.getPrototypeOf || (bC ? function(t) {
  return t.__proto__;
} : null), ga = {}, gC = typeof Uint8Array > "u" || !Fr ? Ut : Fr(Uint8Array), No = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? Ut : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? Ut : ArrayBuffer,
  "%ArrayIteratorPrototype%": sa && Fr ? Fr([][Symbol.iterator]()) : Ut,
  "%AsyncFromSyncIteratorPrototype%": Ut,
  "%AsyncFunction%": ga,
  "%AsyncGenerator%": ga,
  "%AsyncGeneratorFunction%": ga,
  "%AsyncIteratorPrototype%": ga,
  "%Atomics%": typeof Atomics > "u" ? Ut : Atomics,
  "%BigInt%": typeof BigInt > "u" ? Ut : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? Ut : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? Ut : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? Ut : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": uC,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": dC,
  "%Float32Array%": typeof Float32Array > "u" ? Ut : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? Ut : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? Ut : FinalizationRegistry,
  "%Function%": Rw,
  "%GeneratorFunction%": ga,
  "%Int8Array%": typeof Int8Array > "u" ? Ut : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? Ut : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? Ut : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": sa && Fr ? Fr(Fr([][Symbol.iterator]())) : Ut,
  "%JSON%": typeof JSON == "object" ? JSON : Ut,
  "%Map%": typeof Map > "u" ? Ut : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !sa || !Fr ? Ut : Fr((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? Ut : Promise,
  "%Proxy%": typeof Proxy > "u" ? Ut : Proxy,
  "%RangeError%": lC,
  "%ReferenceError%": hC,
  "%Reflect%": typeof Reflect > "u" ? Ut : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? Ut : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !sa || !Fr ? Ut : Fr((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? Ut : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": sa && Fr ? Fr(""[Symbol.iterator]()) : Ut,
  "%Symbol%": sa ? Symbol : Ut,
  "%SyntaxError%": Ja,
  "%ThrowTypeError%": yC,
  "%TypedArray%": gC,
  "%TypeError%": Oa,
  "%Uint8Array%": typeof Uint8Array > "u" ? Ut : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? Ut : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? Ut : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? Ut : Uint32Array,
  "%URIError%": pC,
  "%WeakMap%": typeof WeakMap > "u" ? Ut : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? Ut : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? Ut : WeakSet
};
if (Fr)
  try {
    null.error;
  } catch (t) {
    var vC = Fr(Fr(t));
    No["%Error.prototype%"] = vC;
  }
var mC = function t(e) {
  var r;
  if (e === "%AsyncFunction%")
    r = Uh("async function () {}");
  else if (e === "%GeneratorFunction%")
    r = Uh("function* () {}");
  else if (e === "%AsyncGeneratorFunction%")
    r = Uh("async function* () {}");
  else if (e === "%AsyncGenerator%") {
    var n = t("%AsyncGeneratorFunction%");
    n && (r = n.prototype);
  } else if (e === "%AsyncIteratorPrototype%") {
    var i = t("%AsyncGenerator%");
    i && Fr && (r = Fr(i.prototype));
  }
  return No[e] = r, r;
}, Dv = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, Df = U1, Qc = cC, wC = Df.call(Function.call, Array.prototype.concat), xC = Df.call(Function.apply, Array.prototype.splice), $v = Df.call(Function.call, String.prototype.replace), eu = Df.call(Function.call, String.prototype.slice), _C = Df.call(Function.call, RegExp.prototype.exec), EC = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, SC = /\\(\\)?/g, AC = function(e) {
  var r = eu(e, 0, 1), n = eu(e, -1);
  if (r === "%" && n !== "%")
    throw new Ja("invalid intrinsic syntax, expected closing `%`");
  if (n === "%" && r !== "%")
    throw new Ja("invalid intrinsic syntax, expected opening `%`");
  var i = [];
  return $v(e, EC, function(o, a, s, f) {
    i[i.length] = s ? $v(f, SC, "$1") : a || o;
  }), i;
}, IC = function(e, r) {
  var n = e, i;
  if (Qc(Dv, n) && (i = Dv[n], n = "%" + i[0] + "%"), Qc(No, n)) {
    var o = No[n];
    if (o === ga && (o = mC(n)), typeof o > "u" && !r)
      throw new Oa("intrinsic " + e + " exists, but is not available. Please file an issue!");
    return {
      alias: i,
      name: n,
      value: o
    };
  }
  throw new Ja("intrinsic " + e + " does not exist!");
}, $f = function(e, r) {
  if (typeof e != "string" || e.length === 0)
    throw new Oa("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof r != "boolean")
    throw new Oa('"allowMissing" argument must be a boolean');
  if (_C(/^%?[^%]*%?$/, e) === null)
    throw new Ja("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var n = AC(e), i = n.length > 0 ? n[0] : "", o = IC("%" + i + "%", r), a = o.name, s = o.value, f = !1, u = o.alias;
  u && (i = u[0], xC(n, wC([0, 1], u)));
  for (var c = 1, d = !0; c < n.length; c += 1) {
    var l = n[c], h = eu(l, 0, 1), y = eu(l, -1);
    if ((h === '"' || h === "'" || h === "`" || y === '"' || y === "'" || y === "`") && h !== y)
      throw new Ja("property names with quotes must have matching quotes");
    if ((l === "constructor" || !d) && (f = !0), i += "." + l, a = "%" + i + "%", Qc(No, a))
      s = No[a];
    else if (s != null) {
      if (!(l in s)) {
        if (!r)
          throw new Oa("base intrinsic for " + e + " exists, but the property is not available.");
        return;
      }
      if (Po && c + 1 >= n.length) {
        var b = Po(s, l);
        d = !!b, d && "get" in b && !("originalValue" in b.get) ? s = b.get : s = s[l];
      } else
        d = Qc(s, l), s = s[l];
      d && !f && (No[a] = s);
    }
  }
  return s;
}, Tw = { exports: {} }, Lh, qv;
function F1() {
  if (qv)
    return Lh;
  qv = 1;
  var t = $f, e = t("%Object.defineProperty%", !0) || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return Lh = e, Lh;
}
var BC = $f, mc = BC("%Object.getOwnPropertyDescriptor%", !0);
if (mc)
  try {
    mc([], "length");
  } catch {
    mc = null;
  }
var L1 = mc, zv = F1(), MC = Mw, fa = wd, Kv = L1, Ow = function(e, r, n) {
  if (!e || typeof e != "object" && typeof e != "function")
    throw new fa("`obj` must be an object or a function`");
  if (typeof r != "string" && typeof r != "symbol")
    throw new fa("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new fa("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new fa("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new fa("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new fa("`loose`, if provided, must be a boolean");
  var i = arguments.length > 3 ? arguments[3] : null, o = arguments.length > 4 ? arguments[4] : null, a = arguments.length > 5 ? arguments[5] : null, s = arguments.length > 6 ? arguments[6] : !1, f = !!Kv && Kv(e, r);
  if (zv)
    zv(e, r, {
      configurable: a === null && f ? f.configurable : !a,
      enumerable: i === null && f ? f.enumerable : !i,
      value: n,
      writable: o === null && f ? f.writable : !o
    });
  else if (s || !i && !o && !a)
    e[r] = n;
  else
    throw new MC("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, Y0 = F1(), kw = function() {
  return !!Y0;
};
kw.hasArrayLengthDefineBug = function() {
  if (!Y0)
    return null;
  try {
    return Y0([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var Cw = kw, RC = $f, Wv = Ow, TC = Cw(), Hv = L1, Gv = wd, OC = RC("%Math.floor%"), kC = function(e, r) {
  if (typeof e != "function")
    throw new Gv("`fn` is not a function");
  if (typeof r != "number" || r < 0 || r > 4294967295 || OC(r) !== r)
    throw new Gv("`length` must be a positive 32-bit integer");
  var n = arguments.length > 2 && !!arguments[2], i = !0, o = !0;
  if ("length" in e && Hv) {
    var a = Hv(e, "length");
    a && !a.configurable && (i = !1), a && !a.writable && (o = !1);
  }
  return (i || o || !n) && (TC ? Wv(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    r,
    !0,
    !0
  ) : Wv(
    /** @type {Parameters<define>[0]} */
    e,
    "length",
    r
  )), e;
};
(function(t) {
  var e = U1, r = $f, n = kC, i = wd, o = r("%Function.prototype.apply%"), a = r("%Function.prototype.call%"), s = r("%Reflect.apply%", !0) || e.call(a, o), f = F1(), u = r("%Math.max%");
  t.exports = function(l) {
    if (typeof l != "function")
      throw new i("a function is required");
    var h = s(e, a, arguments);
    return n(
      h,
      1 + u(0, l.length - (arguments.length - 1)),
      !0
    );
  };
  var c = function() {
    return s(e, o, arguments);
  };
  f ? f(t.exports, "apply", { value: c }) : t.exports.apply = c;
})(Tw);
var xd = Tw.exports, Pw = $f, Nw = xd, CC = Nw(Pw("String.prototype.indexOf")), _d = function(e, r) {
  var n = Pw(e, !!r);
  return typeof n == "function" && CC(e, ".prototype.") > -1 ? Nw(n) : n;
}, PC = N1(), NC = _d, J0 = NC("Object.prototype.toString"), Ed = function(e) {
  return PC && e && typeof e == "object" && Symbol.toStringTag in e ? !1 : J0(e) === "[object Arguments]";
}, Uw = function(e) {
  return Ed(e) ? !0 : e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && J0(e) !== "[object Array]" && J0(e.callee) === "[object Function]";
}, UC = function() {
  return Ed(arguments);
}();
Ed.isLegacyArguments = Uw;
var FC = UC ? Ed : Uw, LC = Object.prototype.toString, jC = Function.prototype.toString, DC = /^\s*(?:function)?\*/, Fw = N1(), jh = Object.getPrototypeOf, $C = function() {
  if (!Fw)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, Dh, qC = function(e) {
  if (typeof e != "function")
    return !1;
  if (DC.test(jC.call(e)))
    return !0;
  if (!Fw) {
    var r = LC.call(e);
    return r === "[object GeneratorFunction]";
  }
  if (!jh)
    return !1;
  if (typeof Dh > "u") {
    var n = $C();
    Dh = n ? jh(n) : !1;
  }
  return jh(e) === Dh;
}, Lw = Function.prototype.toString, xa = typeof Reflect == "object" && Reflect !== null && Reflect.apply, X0, wc;
if (typeof xa == "function" && typeof Object.defineProperty == "function")
  try {
    X0 = Object.defineProperty({}, "length", {
      get: function() {
        throw wc;
      }
    }), wc = {}, xa(function() {
      throw 42;
    }, null, X0);
  } catch (t) {
    t !== wc && (xa = null);
  }
else
  xa = null;
var zC = /^\s*class\b/, Z0 = function(e) {
  try {
    var r = Lw.call(e);
    return zC.test(r);
  } catch {
    return !1;
  }
}, $h = function(e) {
  try {
    return Z0(e) ? !1 : (Lw.call(e), !0);
  } catch {
    return !1;
  }
}, xc = Object.prototype.toString, KC = "[object Object]", WC = "[object Function]", HC = "[object GeneratorFunction]", GC = "[object HTMLAllCollection]", VC = "[object HTML document.all class]", YC = "[object HTMLCollection]", JC = typeof Symbol == "function" && !!Symbol.toStringTag, XC = !(0 in [,]), Q0 = function() {
  return !1;
};
if (typeof document == "object") {
  var ZC = document.all;
  xc.call(ZC) === xc.call(document.all) && (Q0 = function(e) {
    if ((XC || !e) && (typeof e > "u" || typeof e == "object"))
      try {
        var r = xc.call(e);
        return (r === GC || r === VC || r === YC || r === KC) && e("") == null;
      } catch {
      }
    return !1;
  });
}
var QC = xa ? function(e) {
  if (Q0(e))
    return !0;
  if (!e || typeof e != "function" && typeof e != "object")
    return !1;
  try {
    xa(e, null, X0);
  } catch (r) {
    if (r !== wc)
      return !1;
  }
  return !Z0(e) && $h(e);
} : function(e) {
  if (Q0(e))
    return !0;
  if (!e || typeof e != "function" && typeof e != "object")
    return !1;
  if (JC)
    return $h(e);
  if (Z0(e))
    return !1;
  var r = xc.call(e);
  return r !== WC && r !== HC && !/^\[object HTML/.test(r) ? !1 : $h(e);
}, eP = QC, tP = Object.prototype.toString, jw = Object.prototype.hasOwnProperty, rP = function(e, r, n) {
  for (var i = 0, o = e.length; i < o; i++)
    jw.call(e, i) && (n == null ? r(e[i], i, e) : r.call(n, e[i], i, e));
}, nP = function(e, r, n) {
  for (var i = 0, o = e.length; i < o; i++)
    n == null ? r(e.charAt(i), i, e) : r.call(n, e.charAt(i), i, e);
}, iP = function(e, r, n) {
  for (var i in e)
    jw.call(e, i) && (n == null ? r(e[i], i, e) : r.call(n, e[i], i, e));
}, oP = function(e, r, n) {
  if (!eP(r))
    throw new TypeError("iterator must be a function");
  var i;
  arguments.length >= 3 && (i = n), tP.call(e) === "[object Array]" ? rP(e, r, i) : typeof e == "string" ? nP(e, r, i) : iP(e, r, i);
}, aP = oP, sP = [
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array"
], qh = sP, fP = typeof globalThis > "u" ? yt : globalThis, cP = function() {
  for (var e = [], r = 0; r < qh.length; r++)
    typeof fP[qh[r]] == "function" && (e[e.length] = qh[r]);
  return e;
}, tu = aP, uP = cP, Vv = xd, j1 = _d, _c = L1, dP = j1("Object.prototype.toString"), Dw = N1(), Yv = typeof globalThis > "u" ? yt : globalThis, ep = uP(), D1 = j1("String.prototype.slice"), zh = Object.getPrototypeOf, lP = j1("Array.prototype.indexOf", !0) || function(e, r) {
  for (var n = 0; n < e.length; n += 1)
    if (e[n] === r)
      return n;
  return -1;
}, ru = { __proto__: null };
Dw && _c && zh ? tu(ep, function(t) {
  var e = new Yv[t]();
  if (Symbol.toStringTag in e) {
    var r = zh(e), n = _c(r, Symbol.toStringTag);
    if (!n) {
      var i = zh(r);
      n = _c(i, Symbol.toStringTag);
    }
    ru["$" + t] = Vv(n.get);
  }
}) : tu(ep, function(t) {
  var e = new Yv[t](), r = e.slice || e.set;
  r && (ru["$" + t] = Vv(r));
});
var hP = function(e) {
  var r = !1;
  return tu(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    ru,
    /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function(n, i) {
      if (!r)
        try {
          "$" + n(e) === i && (r = D1(i, 1));
        } catch {
        }
    }
  ), r;
}, pP = function(e) {
  var r = !1;
  return tu(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    ru,
    /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
    function(n, i) {
      if (!r)
        try {
          n(e), r = D1(i, 1);
        } catch {
        }
    }
  ), r;
}, $w = function(e) {
  if (!e || typeof e != "object")
    return !1;
  if (!Dw) {
    var r = D1(dP(e), 8, -1);
    return lP(ep, r) > -1 ? r : r !== "Object" ? !1 : pP(e);
  }
  return _c ? hP(e) : null;
}, yP = $w, bP = function(e) {
  return !!yP(e);
};
(function(t) {
  var e = FC, r = qC, n = $w, i = bP;
  function o(we) {
    return we.call.bind(we);
  }
  var a = typeof BigInt < "u", s = typeof Symbol < "u", f = o(Object.prototype.toString), u = o(Number.prototype.valueOf), c = o(String.prototype.valueOf), d = o(Boolean.prototype.valueOf);
  if (a)
    var l = o(BigInt.prototype.valueOf);
  if (s)
    var h = o(Symbol.prototype.valueOf);
  function y(we, at) {
    if (typeof we != "object")
      return !1;
    try {
      return at(we), !0;
    } catch {
      return !1;
    }
  }
  t.isArgumentsObject = e, t.isGeneratorFunction = r, t.isTypedArray = i;
  function b(we) {
    return typeof Promise < "u" && we instanceof Promise || we !== null && typeof we == "object" && typeof we.then == "function" && typeof we.catch == "function";
  }
  t.isPromise = b;
  function w(we) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(we) : i(we) || R(we);
  }
  t.isArrayBufferView = w;
  function A(we) {
    return n(we) === "Uint8Array";
  }
  t.isUint8Array = A;
  function M(we) {
    return n(we) === "Uint8ClampedArray";
  }
  t.isUint8ClampedArray = M;
  function N(we) {
    return n(we) === "Uint16Array";
  }
  t.isUint16Array = N;
  function G(we) {
    return n(we) === "Uint32Array";
  }
  t.isUint32Array = G;
  function z(we) {
    return n(we) === "Int8Array";
  }
  t.isInt8Array = z;
  function J(we) {
    return n(we) === "Int16Array";
  }
  t.isInt16Array = J;
  function oe(we) {
    return n(we) === "Int32Array";
  }
  t.isInt32Array = oe;
  function ee(we) {
    return n(we) === "Float32Array";
  }
  t.isFloat32Array = ee;
  function ae(we) {
    return n(we) === "Float64Array";
  }
  t.isFloat64Array = ae;
  function ye(we) {
    return n(we) === "BigInt64Array";
  }
  t.isBigInt64Array = ye;
  function pe(we) {
    return n(we) === "BigUint64Array";
  }
  t.isBigUint64Array = pe;
  function te(we) {
    return f(we) === "[object Map]";
  }
  te.working = typeof Map < "u" && te(/* @__PURE__ */ new Map());
  function F(we) {
    return typeof Map > "u" ? !1 : te.working ? te(we) : we instanceof Map;
  }
  t.isMap = F;
  function v(we) {
    return f(we) === "[object Set]";
  }
  v.working = typeof Set < "u" && v(/* @__PURE__ */ new Set());
  function B(we) {
    return typeof Set > "u" ? !1 : v.working ? v(we) : we instanceof Set;
  }
  t.isSet = B;
  function P(we) {
    return f(we) === "[object WeakMap]";
  }
  P.working = typeof WeakMap < "u" && P(/* @__PURE__ */ new WeakMap());
  function L(we) {
    return typeof WeakMap > "u" ? !1 : P.working ? P(we) : we instanceof WeakMap;
  }
  t.isWeakMap = L;
  function x(we) {
    return f(we) === "[object WeakSet]";
  }
  x.working = typeof WeakSet < "u" && x(/* @__PURE__ */ new WeakSet());
  function C(we) {
    return x(we);
  }
  t.isWeakSet = C;
  function j(we) {
    return f(we) === "[object ArrayBuffer]";
  }
  j.working = typeof ArrayBuffer < "u" && j(new ArrayBuffer());
  function k(we) {
    return typeof ArrayBuffer > "u" ? !1 : j.working ? j(we) : we instanceof ArrayBuffer;
  }
  t.isArrayBuffer = k;
  function g(we) {
    return f(we) === "[object DataView]";
  }
  g.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && g(new DataView(new ArrayBuffer(1), 0, 1));
  function R(we) {
    return typeof DataView > "u" ? !1 : g.working ? g(we) : we instanceof DataView;
  }
  t.isDataView = R;
  var X = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function re(we) {
    return f(we) === "[object SharedArrayBuffer]";
  }
  function V(we) {
    return typeof X > "u" ? !1 : (typeof re.working > "u" && (re.working = re(new X())), re.working ? re(we) : we instanceof X);
  }
  t.isSharedArrayBuffer = V;
  function $(we) {
    return f(we) === "[object AsyncFunction]";
  }
  t.isAsyncFunction = $;
  function W(we) {
    return f(we) === "[object Map Iterator]";
  }
  t.isMapIterator = W;
  function Z(we) {
    return f(we) === "[object Set Iterator]";
  }
  t.isSetIterator = Z;
  function fe(we) {
    return f(we) === "[object Generator]";
  }
  t.isGeneratorObject = fe;
  function D(we) {
    return f(we) === "[object WebAssembly.Module]";
  }
  t.isWebAssemblyCompiledModule = D;
  function K(we) {
    return y(we, u);
  }
  t.isNumberObject = K;
  function he(we) {
    return y(we, c);
  }
  t.isStringObject = he;
  function be(we) {
    return y(we, d);
  }
  t.isBooleanObject = be;
  function Ce(we) {
    return a && y(we, l);
  }
  t.isBigIntObject = Ce;
  function je(we) {
    return s && y(we, h);
  }
  t.isSymbolObject = je;
  function Ue(we) {
    return K(we) || he(we) || be(we) || Ce(we) || je(we);
  }
  t.isBoxedPrimitive = Ue;
  function Qe(we) {
    return typeof Uint8Array < "u" && (k(we) || V(we));
  }
  t.isAnyArrayBuffer = Qe, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(we) {
    Object.defineProperty(t, we, {
      enumerable: !1,
      value: function() {
        throw new Error(we + " is not supported in userland");
      }
    });
  });
})(Bw);
var gP = function(e) {
  return e && typeof e == "object" && typeof e.copy == "function" && typeof e.fill == "function" && typeof e.readUInt8 == "function";
};
(function(t) {
  var e = Object.getOwnPropertyDescriptors || function(R) {
    for (var X = Object.keys(R), re = {}, V = 0; V < X.length; V++)
      re[X[V]] = Object.getOwnPropertyDescriptor(R, X[V]);
    return re;
  }, r = /%[sdj%]/g;
  t.format = function(g) {
    if (!z(g)) {
      for (var R = [], X = 0; X < arguments.length; X++)
        R.push(a(arguments[X]));
      return R.join(" ");
    }
    for (var X = 1, re = arguments, V = re.length, $ = String(g).replace(r, function(Z) {
      if (Z === "%%")
        return "%";
      if (X >= V)
        return Z;
      switch (Z) {
        case "%s":
          return String(re[X++]);
        case "%d":
          return Number(re[X++]);
        case "%j":
          try {
            return JSON.stringify(re[X++]);
          } catch {
            return "[Circular]";
          }
        default:
          return Z;
      }
    }), W = re[X]; X < V; W = re[++X])
      M(W) || !ae(W) ? $ += " " + W : $ += " " + a(W);
    return $;
  }, t.deprecate = function(g, R) {
    if (typeof Ye < "u" && Ye.noDeprecation === !0)
      return g;
    if (typeof Ye > "u")
      return function() {
        return t.deprecate(g, R).apply(this, arguments);
      };
    var X = !1;
    function re() {
      if (!X) {
        if (Ye.throwDeprecation)
          throw new Error(R);
        Ye.traceDeprecation ? console.trace(R) : console.error(R), X = !0;
      }
      return g.apply(this, arguments);
    }
    return re;
  };
  var n = {}, i = /^$/;
  if (Ye.env.NODE_DEBUG) {
    var o = Ye.env.NODE_DEBUG;
    o = o.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), i = new RegExp("^" + o + "$", "i");
  }
  t.debuglog = function(g) {
    if (g = g.toUpperCase(), !n[g])
      if (i.test(g)) {
        var R = Ye.pid;
        n[g] = function() {
          var X = t.format.apply(t, arguments);
          console.error("%s %d: %s", g, R, X);
        };
      } else
        n[g] = function() {
        };
    return n[g];
  };
  function a(g, R) {
    var X = {
      seen: [],
      stylize: f
    };
    return arguments.length >= 3 && (X.depth = arguments[2]), arguments.length >= 4 && (X.colors = arguments[3]), A(R) ? X.showHidden = R : R && t._extend(X, R), oe(X.showHidden) && (X.showHidden = !1), oe(X.depth) && (X.depth = 2), oe(X.colors) && (X.colors = !1), oe(X.customInspect) && (X.customInspect = !0), X.colors && (X.stylize = s), c(X, g, X.depth);
  }
  t.inspect = a, a.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, a.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function s(g, R) {
    var X = a.styles[R];
    return X ? "\x1B[" + a.colors[X][0] + "m" + g + "\x1B[" + a.colors[X][1] + "m" : g;
  }
  function f(g, R) {
    return g;
  }
  function u(g) {
    var R = {};
    return g.forEach(function(X, re) {
      R[X] = !0;
    }), R;
  }
  function c(g, R, X) {
    if (g.customInspect && R && te(R.inspect) && // Filter out the util module, it's inspect function is special
    R.inspect !== t.inspect && // Also filter out any prototype objects using the circular check.
    !(R.constructor && R.constructor.prototype === R)) {
      var re = R.inspect(X, g);
      return z(re) || (re = c(g, re, X)), re;
    }
    var V = d(g, R);
    if (V)
      return V;
    var $ = Object.keys(R), W = u($);
    if (g.showHidden && ($ = Object.getOwnPropertyNames(R)), pe(R) && ($.indexOf("message") >= 0 || $.indexOf("description") >= 0))
      return l(R);
    if ($.length === 0) {
      if (te(R)) {
        var Z = R.name ? ": " + R.name : "";
        return g.stylize("[Function" + Z + "]", "special");
      }
      if (ee(R))
        return g.stylize(RegExp.prototype.toString.call(R), "regexp");
      if (ye(R))
        return g.stylize(Date.prototype.toString.call(R), "date");
      if (pe(R))
        return l(R);
    }
    var fe = "", D = !1, K = ["{", "}"];
    if (w(R) && (D = !0, K = ["[", "]"]), te(R)) {
      var he = R.name ? ": " + R.name : "";
      fe = " [Function" + he + "]";
    }
    if (ee(R) && (fe = " " + RegExp.prototype.toString.call(R)), ye(R) && (fe = " " + Date.prototype.toUTCString.call(R)), pe(R) && (fe = " " + l(R)), $.length === 0 && (!D || R.length == 0))
      return K[0] + fe + K[1];
    if (X < 0)
      return ee(R) ? g.stylize(RegExp.prototype.toString.call(R), "regexp") : g.stylize("[Object]", "special");
    g.seen.push(R);
    var be;
    return D ? be = h(g, R, X, W, $) : be = $.map(function(Ce) {
      return y(g, R, X, W, Ce, D);
    }), g.seen.pop(), b(be, fe, K);
  }
  function d(g, R) {
    if (oe(R))
      return g.stylize("undefined", "undefined");
    if (z(R)) {
      var X = "'" + JSON.stringify(R).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return g.stylize(X, "string");
    }
    if (G(R))
      return g.stylize("" + R, "number");
    if (A(R))
      return g.stylize("" + R, "boolean");
    if (M(R))
      return g.stylize("null", "null");
  }
  function l(g) {
    return "[" + Error.prototype.toString.call(g) + "]";
  }
  function h(g, R, X, re, V) {
    for (var $ = [], W = 0, Z = R.length; W < Z; ++W)
      x(R, String(W)) ? $.push(y(
        g,
        R,
        X,
        re,
        String(W),
        !0
      )) : $.push("");
    return V.forEach(function(fe) {
      fe.match(/^\d+$/) || $.push(y(
        g,
        R,
        X,
        re,
        fe,
        !0
      ));
    }), $;
  }
  function y(g, R, X, re, V, $) {
    var W, Z, fe;
    if (fe = Object.getOwnPropertyDescriptor(R, V) || { value: R[V] }, fe.get ? fe.set ? Z = g.stylize("[Getter/Setter]", "special") : Z = g.stylize("[Getter]", "special") : fe.set && (Z = g.stylize("[Setter]", "special")), x(re, V) || (W = "[" + V + "]"), Z || (g.seen.indexOf(fe.value) < 0 ? (M(X) ? Z = c(g, fe.value, null) : Z = c(g, fe.value, X - 1), Z.indexOf(`
`) > -1 && ($ ? Z = Z.split(`
`).map(function(D) {
      return "  " + D;
    }).join(`
`).slice(2) : Z = `
` + Z.split(`
`).map(function(D) {
      return "   " + D;
    }).join(`
`))) : Z = g.stylize("[Circular]", "special")), oe(W)) {
      if ($ && V.match(/^\d+$/))
        return Z;
      W = JSON.stringify("" + V), W.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (W = W.slice(1, -1), W = g.stylize(W, "name")) : (W = W.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), W = g.stylize(W, "string"));
    }
    return W + ": " + Z;
  }
  function b(g, R, X) {
    var re = g.reduce(function(V, $) {
      return $.indexOf(`
`) >= 0, V + $.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return re > 60 ? X[0] + (R === "" ? "" : R + `
 `) + " " + g.join(`,
  `) + " " + X[1] : X[0] + R + " " + g.join(", ") + " " + X[1];
  }
  t.types = Bw;
  function w(g) {
    return Array.isArray(g);
  }
  t.isArray = w;
  function A(g) {
    return typeof g == "boolean";
  }
  t.isBoolean = A;
  function M(g) {
    return g === null;
  }
  t.isNull = M;
  function N(g) {
    return g == null;
  }
  t.isNullOrUndefined = N;
  function G(g) {
    return typeof g == "number";
  }
  t.isNumber = G;
  function z(g) {
    return typeof g == "string";
  }
  t.isString = z;
  function J(g) {
    return typeof g == "symbol";
  }
  t.isSymbol = J;
  function oe(g) {
    return g === void 0;
  }
  t.isUndefined = oe;
  function ee(g) {
    return ae(g) && v(g) === "[object RegExp]";
  }
  t.isRegExp = ee, t.types.isRegExp = ee;
  function ae(g) {
    return typeof g == "object" && g !== null;
  }
  t.isObject = ae;
  function ye(g) {
    return ae(g) && v(g) === "[object Date]";
  }
  t.isDate = ye, t.types.isDate = ye;
  function pe(g) {
    return ae(g) && (v(g) === "[object Error]" || g instanceof Error);
  }
  t.isError = pe, t.types.isNativeError = pe;
  function te(g) {
    return typeof g == "function";
  }
  t.isFunction = te;
  function F(g) {
    return g === null || typeof g == "boolean" || typeof g == "number" || typeof g == "string" || typeof g == "symbol" || // ES6 symbol
    typeof g > "u";
  }
  t.isPrimitive = F, t.isBuffer = gP;
  function v(g) {
    return Object.prototype.toString.call(g);
  }
  function B(g) {
    return g < 10 ? "0" + g.toString(10) : g.toString(10);
  }
  var P = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function L() {
    var g = /* @__PURE__ */ new Date(), R = [
      B(g.getHours()),
      B(g.getMinutes()),
      B(g.getSeconds())
    ].join(":");
    return [g.getDate(), P[g.getMonth()], R].join(" ");
  }
  t.log = function() {
    console.log("%s - %s", L(), t.format.apply(t, arguments));
  }, t.inherits = Mt, t._extend = function(g, R) {
    if (!R || !ae(R))
      return g;
    for (var X = Object.keys(R), re = X.length; re--; )
      g[X[re]] = R[X[re]];
    return g;
  };
  function x(g, R) {
    return Object.prototype.hasOwnProperty.call(g, R);
  }
  var C = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  t.promisify = function(R) {
    if (typeof R != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (C && R[C]) {
      var X = R[C];
      if (typeof X != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(X, C, {
        value: X,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), X;
    }
    function X() {
      for (var re, V, $ = new Promise(function(fe, D) {
        re = fe, V = D;
      }), W = [], Z = 0; Z < arguments.length; Z++)
        W.push(arguments[Z]);
      W.push(function(fe, D) {
        fe ? V(fe) : re(D);
      });
      try {
        R.apply(this, W);
      } catch (fe) {
        V(fe);
      }
      return $;
    }
    return Object.setPrototypeOf(X, Object.getPrototypeOf(R)), C && Object.defineProperty(X, C, {
      value: X,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      X,
      e(R)
    );
  }, t.promisify.custom = C;
  function j(g, R) {
    if (!g) {
      var X = new Error("Promise was rejected with a falsy value");
      X.reason = g, g = X;
    }
    return R(g);
  }
  function k(g) {
    if (typeof g != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function R() {
      for (var X = [], re = 0; re < arguments.length; re++)
        X.push(arguments[re]);
      var V = X.pop();
      if (typeof V != "function")
        throw new TypeError("The last argument must be of type Function");
      var $ = this, W = function() {
        return V.apply($, arguments);
      };
      g.apply(this, X).then(
        function(Z) {
          Ye.nextTick(W.bind(null, null, Z));
        },
        function(Z) {
          Ye.nextTick(j.bind(null, Z, W));
        }
      );
    }
    return Object.setPrototypeOf(R, Object.getPrototypeOf(g)), Object.defineProperties(
      R,
      e(g)
    ), R;
  }
  t.callbackify = k;
})(Ya);
var Jv;
function qw() {
  if (Jv)
    return Ph;
  Jv = 1;
  function t(z) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(J) {
      return typeof J;
    } : function(J) {
      return J && typeof Symbol == "function" && J.constructor === Symbol && J !== Symbol.prototype ? "symbol" : typeof J;
    }, t(z);
  }
  function e(z, J) {
    for (var oe = 0; oe < J.length; oe++) {
      var ee = J[oe];
      ee.enumerable = ee.enumerable || !1, ee.configurable = !0, "value" in ee && (ee.writable = !0), Object.defineProperty(z, n(ee.key), ee);
    }
  }
  function r(z, J, oe) {
    return J && e(z.prototype, J), oe && e(z, oe), Object.defineProperty(z, "prototype", { writable: !1 }), z;
  }
  function n(z) {
    var J = i(z, "string");
    return t(J) === "symbol" ? J : String(J);
  }
  function i(z, J) {
    if (t(z) !== "object" || z === null)
      return z;
    var oe = z[Symbol.toPrimitive];
    if (oe !== void 0) {
      var ee = oe.call(z, J || "default");
      if (t(ee) !== "object")
        return ee;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (J === "string" ? String : Number)(z);
  }
  function o(z, J) {
    if (!(z instanceof J))
      throw new TypeError("Cannot call a class as a function");
  }
  function a(z, J) {
    if (typeof J != "function" && J !== null)
      throw new TypeError("Super expression must either be null or a function");
    z.prototype = Object.create(J && J.prototype, { constructor: { value: z, writable: !0, configurable: !0 } }), Object.defineProperty(z, "prototype", { writable: !1 }), J && s(z, J);
  }
  function s(z, J) {
    return s = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(ee, ae) {
      return ee.__proto__ = ae, ee;
    }, s(z, J);
  }
  function f(z) {
    var J = d();
    return function() {
      var ee = l(z), ae;
      if (J) {
        var ye = l(this).constructor;
        ae = Reflect.construct(ee, arguments, ye);
      } else
        ae = ee.apply(this, arguments);
      return u(this, ae);
    };
  }
  function u(z, J) {
    if (J && (t(J) === "object" || typeof J == "function"))
      return J;
    if (J !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return c(z);
  }
  function c(z) {
    if (z === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return z;
  }
  function d() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function l(z) {
    return l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(oe) {
      return oe.__proto__ || Object.getPrototypeOf(oe);
    }, l(z);
  }
  var h = {}, y, b;
  function w(z, J, oe) {
    oe || (oe = Error);
    function ee(ye, pe, te) {
      return typeof J == "string" ? J : J(ye, pe, te);
    }
    var ae = /* @__PURE__ */ function(ye) {
      a(te, ye);
      var pe = f(te);
      function te(F, v, B) {
        var P;
        return o(this, te), P = pe.call(this, ee(F, v, B)), P.code = z, P;
      }
      return r(te);
    }(oe);
    h[z] = ae;
  }
  function A(z, J) {
    if (Array.isArray(z)) {
      var oe = z.length;
      return z = z.map(function(ee) {
        return String(ee);
      }), oe > 2 ? "one of ".concat(J, " ").concat(z.slice(0, oe - 1).join(", "), ", or ") + z[oe - 1] : oe === 2 ? "one of ".concat(J, " ").concat(z[0], " or ").concat(z[1]) : "of ".concat(J, " ").concat(z[0]);
    } else
      return "of ".concat(J, " ").concat(String(z));
  }
  function M(z, J, oe) {
    return z.substr(!oe || oe < 0 ? 0 : +oe, J.length) === J;
  }
  function N(z, J, oe) {
    return (oe === void 0 || oe > z.length) && (oe = z.length), z.substring(oe - J.length, oe) === J;
  }
  function G(z, J, oe) {
    return typeof oe != "number" && (oe = 0), oe + J.length > z.length ? !1 : z.indexOf(J, oe) !== -1;
  }
  return w("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), w("ERR_INVALID_ARG_TYPE", function(z, J, oe) {
    y === void 0 && (y = nu()), y(typeof z == "string", "'name' must be a string");
    var ee;
    typeof J == "string" && M(J, "not ") ? (ee = "must not be", J = J.replace(/^not /, "")) : ee = "must be";
    var ae;
    if (N(z, " argument"))
      ae = "The ".concat(z, " ").concat(ee, " ").concat(A(J, "type"));
    else {
      var ye = G(z, ".") ? "property" : "argument";
      ae = 'The "'.concat(z, '" ').concat(ye, " ").concat(ee, " ").concat(A(J, "type"));
    }
    return ae += ". Received type ".concat(t(oe)), ae;
  }, TypeError), w("ERR_INVALID_ARG_VALUE", function(z, J) {
    var oe = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
    b === void 0 && (b = Ya);
    var ee = b.inspect(J);
    return ee.length > 128 && (ee = "".concat(ee.slice(0, 128), "...")), "The argument '".concat(z, "' ").concat(oe, ". Received ").concat(ee);
  }, TypeError), w("ERR_INVALID_RETURN_VALUE", function(z, J, oe) {
    var ee;
    return oe && oe.constructor && oe.constructor.name ? ee = "instance of ".concat(oe.constructor.name) : ee = "type ".concat(t(oe)), "Expected ".concat(z, ' to be returned from the "').concat(J, '"') + " function but got ".concat(ee, ".");
  }, TypeError), w("ERR_MISSING_ARGS", function() {
    for (var z = arguments.length, J = new Array(z), oe = 0; oe < z; oe++)
      J[oe] = arguments[oe];
    y === void 0 && (y = nu()), y(J.length > 0, "At least one arg needs to be specified");
    var ee = "The ", ae = J.length;
    switch (J = J.map(function(ye) {
      return '"'.concat(ye, '"');
    }), ae) {
      case 1:
        ee += "".concat(J[0], " argument");
        break;
      case 2:
        ee += "".concat(J[0], " and ").concat(J[1], " arguments");
        break;
      default:
        ee += J.slice(0, ae - 1).join(", "), ee += ", and ".concat(J[ae - 1], " arguments");
        break;
    }
    return "".concat(ee, " must be specified");
  }, TypeError), Ph.codes = h, Ph;
}
var Kh, Xv;
function vP() {
  if (Xv)
    return Kh;
  Xv = 1;
  function t(C, j) {
    var k = Object.keys(C);
    if (Object.getOwnPropertySymbols) {
      var g = Object.getOwnPropertySymbols(C);
      j && (g = g.filter(function(R) {
        return Object.getOwnPropertyDescriptor(C, R).enumerable;
      })), k.push.apply(k, g);
    }
    return k;
  }
  function e(C) {
    for (var j = 1; j < arguments.length; j++) {
      var k = arguments[j] != null ? arguments[j] : {};
      j % 2 ? t(Object(k), !0).forEach(function(g) {
        r(C, g, k[g]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(C, Object.getOwnPropertyDescriptors(k)) : t(Object(k)).forEach(function(g) {
        Object.defineProperty(C, g, Object.getOwnPropertyDescriptor(k, g));
      });
    }
    return C;
  }
  function r(C, j, k) {
    return j = a(j), j in C ? Object.defineProperty(C, j, { value: k, enumerable: !0, configurable: !0, writable: !0 }) : C[j] = k, C;
  }
  function n(C, j) {
    if (!(C instanceof j))
      throw new TypeError("Cannot call a class as a function");
  }
  function i(C, j) {
    for (var k = 0; k < j.length; k++) {
      var g = j[k];
      g.enumerable = g.enumerable || !1, g.configurable = !0, "value" in g && (g.writable = !0), Object.defineProperty(C, a(g.key), g);
    }
  }
  function o(C, j, k) {
    return j && i(C.prototype, j), k && i(C, k), Object.defineProperty(C, "prototype", { writable: !1 }), C;
  }
  function a(C) {
    var j = s(C, "string");
    return M(j) === "symbol" ? j : String(j);
  }
  function s(C, j) {
    if (M(C) !== "object" || C === null)
      return C;
    var k = C[Symbol.toPrimitive];
    if (k !== void 0) {
      var g = k.call(C, j || "default");
      if (M(g) !== "object")
        return g;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (j === "string" ? String : Number)(C);
  }
  function f(C, j) {
    if (typeof j != "function" && j !== null)
      throw new TypeError("Super expression must either be null or a function");
    C.prototype = Object.create(j && j.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), Object.defineProperty(C, "prototype", { writable: !1 }), j && w(C, j);
  }
  function u(C) {
    var j = y();
    return function() {
      var g = A(C), R;
      if (j) {
        var X = A(this).constructor;
        R = Reflect.construct(g, arguments, X);
      } else
        R = g.apply(this, arguments);
      return c(this, R);
    };
  }
  function c(C, j) {
    if (j && (M(j) === "object" || typeof j == "function"))
      return j;
    if (j !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return d(C);
  }
  function d(C) {
    if (C === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return C;
  }
  function l(C) {
    var j = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return l = function(g) {
      if (g === null || !b(g))
        return g;
      if (typeof g != "function")
        throw new TypeError("Super expression must either be null or a function");
      if (typeof j < "u") {
        if (j.has(g))
          return j.get(g);
        j.set(g, R);
      }
      function R() {
        return h(g, arguments, A(this).constructor);
      }
      return R.prototype = Object.create(g.prototype, { constructor: { value: R, enumerable: !1, writable: !0, configurable: !0 } }), w(R, g);
    }, l(C);
  }
  function h(C, j, k) {
    return y() ? h = Reflect.construct.bind() : h = function(R, X, re) {
      var V = [null];
      V.push.apply(V, X);
      var $ = Function.bind.apply(R, V), W = new $();
      return re && w(W, re.prototype), W;
    }, h.apply(null, arguments);
  }
  function y() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function b(C) {
    return Function.toString.call(C).indexOf("[native code]") !== -1;
  }
  function w(C, j) {
    return w = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(g, R) {
      return g.__proto__ = R, g;
    }, w(C, j);
  }
  function A(C) {
    return A = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(k) {
      return k.__proto__ || Object.getPrototypeOf(k);
    }, A(C);
  }
  function M(C) {
    "@babel/helpers - typeof";
    return M = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(j) {
      return typeof j;
    } : function(j) {
      return j && typeof Symbol == "function" && j.constructor === Symbol && j !== Symbol.prototype ? "symbol" : typeof j;
    }, M(C);
  }
  var N = Ya, G = N.inspect, z = qw(), J = z.codes.ERR_INVALID_ARG_TYPE;
  function oe(C, j, k) {
    return (k === void 0 || k > C.length) && (k = C.length), C.substring(k - j.length, k) === j;
  }
  function ee(C, j) {
    if (j = Math.floor(j), C.length == 0 || j == 0)
      return "";
    var k = C.length * j;
    for (j = Math.floor(Math.log(j) / Math.log(2)); j; )
      C += C, j--;
    return C += C.substring(0, k - C.length), C;
  }
  var ae = "", ye = "", pe = "", te = "", F = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
  }, v = 10;
  function B(C) {
    var j = Object.keys(C), k = Object.create(Object.getPrototypeOf(C));
    return j.forEach(function(g) {
      k[g] = C[g];
    }), Object.defineProperty(k, "message", {
      value: C.message
    }), k;
  }
  function P(C) {
    return G(C, {
      compact: !1,
      customInspect: !1,
      depth: 1e3,
      maxArrayLength: 1 / 0,
      // Assert compares only enumerable properties (with a few exceptions).
      showHidden: !1,
      // Having a long line as error is better than wrapping the line for
      // comparison for now.
      // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
      // have meta information about the inspected properties (i.e., know where
      // in what line the property starts and ends).
      breakLength: 1 / 0,
      // Assert does not detect proxies currently.
      showProxy: !1,
      sorted: !0,
      // Inspect getters as we also check them when comparing entries.
      getters: !0
    });
  }
  function L(C, j, k) {
    var g = "", R = "", X = 0, re = "", V = !1, $ = P(C), W = $.split(`
`), Z = P(j).split(`
`), fe = 0, D = "";
    if (k === "strictEqual" && M(C) === "object" && M(j) === "object" && C !== null && j !== null && (k = "strictEqualObject"), W.length === 1 && Z.length === 1 && W[0] !== Z[0]) {
      var K = W[0].length + Z[0].length;
      if (K <= v) {
        if ((M(C) !== "object" || C === null) && (M(j) !== "object" || j === null) && (C !== 0 || j !== 0))
          return "".concat(F[k], `

`) + "".concat(W[0], " !== ").concat(Z[0], `
`);
      } else if (k !== "strictEqualObject") {
        var he = Ye.stderr && Ye.stderr.isTTY ? Ye.stderr.columns : 80;
        if (K < he) {
          for (; W[0][fe] === Z[0][fe]; )
            fe++;
          fe > 2 && (D = `
  `.concat(ee(" ", fe), "^"), fe = 0);
        }
      }
    }
    for (var be = W[W.length - 1], Ce = Z[Z.length - 1]; be === Ce && (fe++ < 2 ? re = `
  `.concat(be).concat(re) : g = be, W.pop(), Z.pop(), !(W.length === 0 || Z.length === 0)); )
      be = W[W.length - 1], Ce = Z[Z.length - 1];
    var je = Math.max(W.length, Z.length);
    if (je === 0) {
      var Ue = $.split(`
`);
      if (Ue.length > 30)
        for (Ue[26] = "".concat(ae, "...").concat(te); Ue.length > 27; )
          Ue.pop();
      return "".concat(F.notIdentical, `

`).concat(Ue.join(`
`), `
`);
    }
    fe > 3 && (re = `
`.concat(ae, "...").concat(te).concat(re), V = !0), g !== "" && (re = `
  `.concat(g).concat(re), g = "");
    var Qe = 0, we = F[k] + `
`.concat(ye, "+ actual").concat(te, " ").concat(pe, "- expected").concat(te), at = " ".concat(ae, "...").concat(te, " Lines skipped");
    for (fe = 0; fe < je; fe++) {
      var rt = fe - X;
      if (W.length < fe + 1)
        rt > 1 && fe > 2 && (rt > 4 ? (R += `
`.concat(ae, "...").concat(te), V = !0) : rt > 3 && (R += `
  `.concat(Z[fe - 2]), Qe++), R += `
  `.concat(Z[fe - 1]), Qe++), X = fe, g += `
`.concat(pe, "-").concat(te, " ").concat(Z[fe]), Qe++;
      else if (Z.length < fe + 1)
        rt > 1 && fe > 2 && (rt > 4 ? (R += `
`.concat(ae, "...").concat(te), V = !0) : rt > 3 && (R += `
  `.concat(W[fe - 2]), Qe++), R += `
  `.concat(W[fe - 1]), Qe++), X = fe, R += `
`.concat(ye, "+").concat(te, " ").concat(W[fe]), Qe++;
      else {
        var It = Z[fe], it = W[fe], se = it !== It && (!oe(it, ",") || it.slice(0, -1) !== It);
        se && oe(It, ",") && It.slice(0, -1) === it && (se = !1, it += ","), se ? (rt > 1 && fe > 2 && (rt > 4 ? (R += `
`.concat(ae, "...").concat(te), V = !0) : rt > 3 && (R += `
  `.concat(W[fe - 2]), Qe++), R += `
  `.concat(W[fe - 1]), Qe++), X = fe, R += `
`.concat(ye, "+").concat(te, " ").concat(it), g += `
`.concat(pe, "-").concat(te, " ").concat(It), Qe += 2) : (R += g, g = "", (rt === 1 || fe === 0) && (R += `
  `.concat(it), Qe++));
      }
      if (Qe > 20 && fe < je - 2)
        return "".concat(we).concat(at, `
`).concat(R, `
`).concat(ae, "...").concat(te).concat(g, `
`) + "".concat(ae, "...").concat(te);
    }
    return "".concat(we).concat(V ? at : "", `
`).concat(R).concat(g).concat(re).concat(D);
  }
  var x = /* @__PURE__ */ function(C, j) {
    f(g, C);
    var k = u(g);
    function g(R) {
      var X;
      if (n(this, g), M(R) !== "object" || R === null)
        throw new J("options", "Object", R);
      var re = R.message, V = R.operator, $ = R.stackStartFn, W = R.actual, Z = R.expected, fe = Error.stackTraceLimit;
      if (Error.stackTraceLimit = 0, re != null)
        X = k.call(this, String(re));
      else if (Ye.stderr && Ye.stderr.isTTY && (Ye.stderr && Ye.stderr.getColorDepth && Ye.stderr.getColorDepth() !== 1 ? (ae = "\x1B[34m", ye = "\x1B[32m", te = "\x1B[39m", pe = "\x1B[31m") : (ae = "", ye = "", te = "", pe = "")), M(W) === "object" && W !== null && M(Z) === "object" && Z !== null && "stack" in W && W instanceof Error && "stack" in Z && Z instanceof Error && (W = B(W), Z = B(Z)), V === "deepStrictEqual" || V === "strictEqual")
        X = k.call(this, L(W, Z, V));
      else if (V === "notDeepStrictEqual" || V === "notStrictEqual") {
        var D = F[V], K = P(W).split(`
`);
        if (V === "notStrictEqual" && M(W) === "object" && W !== null && (D = F.notStrictEqualObject), K.length > 30)
          for (K[26] = "".concat(ae, "...").concat(te); K.length > 27; )
            K.pop();
        K.length === 1 ? X = k.call(this, "".concat(D, " ").concat(K[0])) : X = k.call(this, "".concat(D, `

`).concat(K.join(`
`), `
`));
      } else {
        var he = P(W), be = "", Ce = F[V];
        V === "notDeepEqual" || V === "notEqual" ? (he = "".concat(F[V], `

`).concat(he), he.length > 1024 && (he = "".concat(he.slice(0, 1021), "..."))) : (be = "".concat(P(Z)), he.length > 512 && (he = "".concat(he.slice(0, 509), "...")), be.length > 512 && (be = "".concat(be.slice(0, 509), "...")), V === "deepEqual" || V === "equal" ? he = "".concat(Ce, `

`).concat(he, `

should equal

`) : be = " ".concat(V, " ").concat(be)), X = k.call(this, "".concat(he).concat(be));
      }
      return Error.stackTraceLimit = fe, X.generatedMessage = !re, Object.defineProperty(d(X), "name", {
        value: "AssertionError [ERR_ASSERTION]",
        enumerable: !1,
        writable: !0,
        configurable: !0
      }), X.code = "ERR_ASSERTION", X.actual = W, X.expected = Z, X.operator = V, Error.captureStackTrace && Error.captureStackTrace(d(X), $), X.stack, X.name = "AssertionError", c(X);
    }
    return o(g, [{
      key: "toString",
      value: function() {
        return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
      }
    }, {
      key: j,
      value: function(X, re) {
        return G(this, e(e({}, re), {}, {
          customInspect: !1,
          depth: 0
        }));
      }
    }]), g;
  }(/* @__PURE__ */ l(Error), G.custom);
  return Kh = x, Kh;
}
var Zv = Object.prototype.toString, zw = function(e) {
  var r = Zv.call(e), n = r === "[object Arguments]";
  return n || (n = r !== "[object Array]" && e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && Zv.call(e.callee) === "[object Function]"), n;
}, Wh, Qv;
function mP() {
  if (Qv)
    return Wh;
  Qv = 1;
  var t;
  if (!Object.keys) {
    var e = Object.prototype.hasOwnProperty, r = Object.prototype.toString, n = zw, i = Object.prototype.propertyIsEnumerable, o = !i.call({ toString: null }, "toString"), a = i.call(function() {
    }, "prototype"), s = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], f = function(l) {
      var h = l.constructor;
      return h && h.prototype === l;
    }, u = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, c = function() {
      if (typeof window > "u")
        return !1;
      for (var l in window)
        try {
          if (!u["$" + l] && e.call(window, l) && window[l] !== null && typeof window[l] == "object")
            try {
              f(window[l]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), d = function(l) {
      if (typeof window > "u" || !c)
        return f(l);
      try {
        return f(l);
      } catch {
        return !1;
      }
    };
    t = function(h) {
      var y = h !== null && typeof h == "object", b = r.call(h) === "[object Function]", w = n(h), A = y && r.call(h) === "[object String]", M = [];
      if (!y && !b && !w)
        throw new TypeError("Object.keys called on a non-object");
      var N = a && b;
      if (A && h.length > 0 && !e.call(h, 0))
        for (var G = 0; G < h.length; ++G)
          M.push(String(G));
      if (w && h.length > 0)
        for (var z = 0; z < h.length; ++z)
          M.push(String(z));
      else
        for (var J in h)
          !(N && J === "prototype") && e.call(h, J) && M.push(String(J));
      if (o)
        for (var oe = d(h), ee = 0; ee < s.length; ++ee)
          !(oe && s[ee] === "constructor") && e.call(h, s[ee]) && M.push(s[ee]);
      return M;
    };
  }
  return Wh = t, Wh;
}
var wP = Array.prototype.slice, xP = zw, e2 = Object.keys, Ec = e2 ? function(e) {
  return e2(e);
} : mP(), t2 = Object.keys;
Ec.shim = function() {
  if (Object.keys) {
    var e = function() {
      var r = Object.keys(arguments);
      return r && r.length === arguments.length;
    }(1, 2);
    e || (Object.keys = function(n) {
      return xP(n) ? t2(wP.call(n)) : t2(n);
    });
  } else
    Object.keys = Ec;
  return Object.keys || Ec;
};
var Kw = Ec, _P = Kw, Ww = P1(), Hw = _d, r2 = Object, EP = Hw("Array.prototype.push"), n2 = Hw("Object.prototype.propertyIsEnumerable"), SP = Ww ? Object.getOwnPropertySymbols : null, AP = function(e, r) {
  if (e == null)
    throw new TypeError("target must be an object");
  var n = r2(e);
  if (arguments.length === 1)
    return n;
  for (var i = 1; i < arguments.length; ++i) {
    var o = r2(arguments[i]), a = _P(o), s = Ww && (Object.getOwnPropertySymbols || SP);
    if (s)
      for (var f = s(o), u = 0; u < f.length; ++u) {
        var c = f[u];
        n2(o, c) && EP(a, c);
      }
    for (var d = 0; d < a.length; ++d) {
      var l = a[d];
      if (n2(o, l)) {
        var h = o[l];
        n[l] = h;
      }
    }
  }
  return n;
}, Hh = AP, IP = function() {
  if (!Object.assign)
    return !1;
  for (var t = "abcdefghijklmnopqrst", e = t.split(""), r = {}, n = 0; n < e.length; ++n)
    r[e[n]] = e[n];
  var i = Object.assign({}, r), o = "";
  for (var a in i)
    o += a;
  return t !== o;
}, BP = function() {
  if (!Object.assign || !Object.preventExtensions)
    return !1;
  var t = Object.preventExtensions({ 1: 2 });
  try {
    Object.assign(t, "xy");
  } catch {
    return t[1] === "y";
  }
  return !1;
}, MP = function() {
  return !Object.assign || IP() || BP() ? Hh : Object.assign;
}, i2 = function(t) {
  return t !== t;
}, Gw = function(e, r) {
  return e === 0 && r === 0 ? 1 / e === 1 / r : !!(e === r || i2(e) && i2(r));
}, RP = Gw, $1 = function() {
  return typeof Object.is == "function" ? Object.is : RP;
}, Gh, o2;
function Sd() {
  if (o2)
    return Gh;
  o2 = 1;
  var t = Kw, e = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", r = Object.prototype.toString, n = Array.prototype.concat, i = Ow, o = function(u) {
    return typeof u == "function" && r.call(u) === "[object Function]";
  }, a = Cw(), s = function(u, c, d, l) {
    if (c in u) {
      if (l === !0) {
        if (u[c] === d)
          return;
      } else if (!o(l) || !l())
        return;
    }
    a ? i(u, c, d, !0) : i(u, c, d);
  }, f = function(u, c) {
    var d = arguments.length > 2 ? arguments[2] : {}, l = t(c);
    e && (l = n.call(l, Object.getOwnPropertySymbols(c)));
    for (var h = 0; h < l.length; h += 1)
      s(u, l[h], c[l[h]], d[l[h]]);
  };
  return f.supportsDescriptors = !!a, Gh = f, Gh;
}
var Vh, a2;
function TP() {
  if (a2)
    return Vh;
  a2 = 1;
  var t = $1, e = Sd();
  return Vh = function() {
    var n = t();
    return e(Object, { is: n }, {
      is: function() {
        return Object.is !== n;
      }
    }), n;
  }, Vh;
}
var Yh, s2;
function OP() {
  if (s2)
    return Yh;
  s2 = 1;
  var t = Sd(), e = xd, r = Gw, n = $1, i = TP(), o = e(n(), Object);
  return t(o, {
    getPolyfill: n,
    implementation: r,
    shim: i
  }), Yh = o, Yh;
}
var Jh, f2;
function Vw() {
  return f2 || (f2 = 1, Jh = function(e) {
    return e !== e;
  }), Jh;
}
var Xh, c2;
function Yw() {
  if (c2)
    return Xh;
  c2 = 1;
  var t = Vw();
  return Xh = function() {
    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : t;
  }, Xh;
}
var Zh, u2;
function kP() {
  if (u2)
    return Zh;
  u2 = 1;
  var t = Sd(), e = Yw();
  return Zh = function() {
    var n = e();
    return t(Number, { isNaN: n }, {
      isNaN: function() {
        return Number.isNaN !== n;
      }
    }), n;
  }, Zh;
}
var Qh, d2;
function CP() {
  if (d2)
    return Qh;
  d2 = 1;
  var t = xd, e = Sd(), r = Vw(), n = Yw(), i = kP(), o = t(n(), Number);
  return e(o, {
    getPolyfill: n,
    implementation: r,
    shim: i
  }), Qh = o, Qh;
}
var e0, l2;
function PP() {
  if (l2)
    return e0;
  l2 = 1;
  function t(se, ue) {
    return o(se) || i(se, ue) || r(se, ue) || e();
  }
  function e() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(se, ue) {
    if (se) {
      if (typeof se == "string")
        return n(se, ue);
      var Ee = Object.prototype.toString.call(se).slice(8, -1);
      if (Ee === "Object" && se.constructor && (Ee = se.constructor.name), Ee === "Map" || Ee === "Set")
        return Array.from(se);
      if (Ee === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ee))
        return n(se, ue);
    }
  }
  function n(se, ue) {
    (ue == null || ue > se.length) && (ue = se.length);
    for (var Ee = 0, U = new Array(ue); Ee < ue; Ee++)
      U[Ee] = se[Ee];
    return U;
  }
  function i(se, ue) {
    var Ee = se == null ? null : typeof Symbol < "u" && se[Symbol.iterator] || se["@@iterator"];
    if (Ee != null) {
      var U, S, I, _, p = [], m = !0, O = !1;
      try {
        if (I = (Ee = Ee.call(se)).next, ue === 0) {
          if (Object(Ee) !== Ee)
            return;
          m = !1;
        } else
          for (; !(m = (U = I.call(Ee)).done) && (p.push(U.value), p.length !== ue); m = !0)
            ;
      } catch (Q) {
        O = !0, S = Q;
      } finally {
        try {
          if (!m && Ee.return != null && (_ = Ee.return(), Object(_) !== _))
            return;
        } finally {
          if (O)
            throw S;
        }
      }
      return p;
    }
  }
  function o(se) {
    if (Array.isArray(se))
      return se;
  }
  function a(se) {
    "@babel/helpers - typeof";
    return a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ue) {
      return typeof ue;
    } : function(ue) {
      return ue && typeof Symbol == "function" && ue.constructor === Symbol && ue !== Symbol.prototype ? "symbol" : typeof ue;
    }, a(se);
  }
  var s = /a/g.flags !== void 0, f = function(ue) {
    var Ee = [];
    return ue.forEach(function(U) {
      return Ee.push(U);
    }), Ee;
  }, u = function(ue) {
    var Ee = [];
    return ue.forEach(function(U, S) {
      return Ee.push([S, U]);
    }), Ee;
  }, c = Object.is ? Object.is : OP(), d = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
  }, l = Number.isNaN ? Number.isNaN : CP();
  function h(se) {
    return se.call.bind(se);
  }
  var y = h(Object.prototype.hasOwnProperty), b = h(Object.prototype.propertyIsEnumerable), w = h(Object.prototype.toString), A = Ya.types, M = A.isAnyArrayBuffer, N = A.isArrayBufferView, G = A.isDate, z = A.isMap, J = A.isRegExp, oe = A.isSet, ee = A.isNativeError, ae = A.isBoxedPrimitive, ye = A.isNumberObject, pe = A.isStringObject, te = A.isBooleanObject, F = A.isBigIntObject, v = A.isSymbolObject, B = A.isFloat32Array, P = A.isFloat64Array;
  function L(se) {
    if (se.length === 0 || se.length > 10)
      return !0;
    for (var ue = 0; ue < se.length; ue++) {
      var Ee = se.charCodeAt(ue);
      if (Ee < 48 || Ee > 57)
        return !0;
    }
    return se.length === 10 && se >= Math.pow(2, 32);
  }
  function x(se) {
    return Object.keys(se).filter(L).concat(d(se).filter(Object.prototype.propertyIsEnumerable.bind(se)));
  }
  /*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
   * @license  MIT
   */
  function C(se, ue) {
    if (se === ue)
      return 0;
    for (var Ee = se.length, U = ue.length, S = 0, I = Math.min(Ee, U); S < I; ++S)
      if (se[S] !== ue[S]) {
        Ee = se[S], U = ue[S];
        break;
      }
    return Ee < U ? -1 : U < Ee ? 1 : 0;
  }
  var j = !0, k = !1, g = 0, R = 1, X = 2, re = 3;
  function V(se, ue) {
    return s ? se.source === ue.source && se.flags === ue.flags : RegExp.prototype.toString.call(se) === RegExp.prototype.toString.call(ue);
  }
  function $(se, ue) {
    if (se.byteLength !== ue.byteLength)
      return !1;
    for (var Ee = 0; Ee < se.byteLength; Ee++)
      if (se[Ee] !== ue[Ee])
        return !1;
    return !0;
  }
  function W(se, ue) {
    return se.byteLength !== ue.byteLength ? !1 : C(new Uint8Array(se.buffer, se.byteOffset, se.byteLength), new Uint8Array(ue.buffer, ue.byteOffset, ue.byteLength)) === 0;
  }
  function Z(se, ue) {
    return se.byteLength === ue.byteLength && C(new Uint8Array(se), new Uint8Array(ue)) === 0;
  }
  function fe(se, ue) {
    return ye(se) ? ye(ue) && c(Number.prototype.valueOf.call(se), Number.prototype.valueOf.call(ue)) : pe(se) ? pe(ue) && String.prototype.valueOf.call(se) === String.prototype.valueOf.call(ue) : te(se) ? te(ue) && Boolean.prototype.valueOf.call(se) === Boolean.prototype.valueOf.call(ue) : F(se) ? F(ue) && BigInt.prototype.valueOf.call(se) === BigInt.prototype.valueOf.call(ue) : v(ue) && Symbol.prototype.valueOf.call(se) === Symbol.prototype.valueOf.call(ue);
  }
  function D(se, ue, Ee, U) {
    if (se === ue)
      return se !== 0 ? !0 : Ee ? c(se, ue) : !0;
    if (Ee) {
      if (a(se) !== "object")
        return typeof se == "number" && l(se) && l(ue);
      if (a(ue) !== "object" || se === null || ue === null || Object.getPrototypeOf(se) !== Object.getPrototypeOf(ue))
        return !1;
    } else {
      if (se === null || a(se) !== "object")
        return ue === null || a(ue) !== "object" ? se == ue : !1;
      if (ue === null || a(ue) !== "object")
        return !1;
    }
    var S = w(se), I = w(ue);
    if (S !== I)
      return !1;
    if (Array.isArray(se)) {
      if (se.length !== ue.length)
        return !1;
      var _ = x(se), p = x(ue);
      return _.length !== p.length ? !1 : he(se, ue, Ee, U, R, _);
    }
    if (S === "[object Object]" && (!z(se) && z(ue) || !oe(se) && oe(ue)))
      return !1;
    if (G(se)) {
      if (!G(ue) || Date.prototype.getTime.call(se) !== Date.prototype.getTime.call(ue))
        return !1;
    } else if (J(se)) {
      if (!J(ue) || !V(se, ue))
        return !1;
    } else if (ee(se) || se instanceof Error) {
      if (se.message !== ue.message || se.name !== ue.name)
        return !1;
    } else if (N(se)) {
      if (!Ee && (B(se) || P(se))) {
        if (!$(se, ue))
          return !1;
      } else if (!W(se, ue))
        return !1;
      var m = x(se), O = x(ue);
      return m.length !== O.length ? !1 : he(se, ue, Ee, U, g, m);
    } else {
      if (oe(se))
        return !oe(ue) || se.size !== ue.size ? !1 : he(se, ue, Ee, U, X);
      if (z(se))
        return !z(ue) || se.size !== ue.size ? !1 : he(se, ue, Ee, U, re);
      if (M(se)) {
        if (!Z(se, ue))
          return !1;
      } else if (ae(se) && !fe(se, ue))
        return !1;
    }
    return he(se, ue, Ee, U, g);
  }
  function K(se, ue) {
    return ue.filter(function(Ee) {
      return b(se, Ee);
    });
  }
  function he(se, ue, Ee, U, S, I) {
    if (arguments.length === 5) {
      I = Object.keys(se);
      var _ = Object.keys(ue);
      if (I.length !== _.length)
        return !1;
    }
    for (var p = 0; p < I.length; p++)
      if (!y(ue, I[p]))
        return !1;
    if (Ee && arguments.length === 5) {
      var m = d(se);
      if (m.length !== 0) {
        var O = 0;
        for (p = 0; p < m.length; p++) {
          var Q = m[p];
          if (b(se, Q)) {
            if (!b(ue, Q))
              return !1;
            I.push(Q), O++;
          } else if (b(ue, Q))
            return !1;
        }
        var ie = d(ue);
        if (m.length !== ie.length && K(ue, ie).length !== O)
          return !1;
      } else {
        var ce = d(ue);
        if (ce.length !== 0 && K(ue, ce).length !== 0)
          return !1;
      }
    }
    if (I.length === 0 && (S === g || S === R && se.length === 0 || se.size === 0))
      return !0;
    if (U === void 0)
      U = {
        val1: /* @__PURE__ */ new Map(),
        val2: /* @__PURE__ */ new Map(),
        position: 0
      };
    else {
      var Ne = U.val1.get(se);
      if (Ne !== void 0) {
        var Te = U.val2.get(ue);
        if (Te !== void 0)
          return Ne === Te;
      }
      U.position++;
    }
    U.val1.set(se, U.position), U.val2.set(ue, U.position);
    var Je = rt(se, ue, Ee, I, U, S);
    return U.val1.delete(se), U.val2.delete(ue), Je;
  }
  function be(se, ue, Ee, U) {
    for (var S = f(se), I = 0; I < S.length; I++) {
      var _ = S[I];
      if (D(ue, _, Ee, U))
        return se.delete(_), !0;
    }
    return !1;
  }
  function Ce(se) {
    switch (a(se)) {
      case "undefined":
        return null;
      case "object":
        return;
      case "symbol":
        return !1;
      case "string":
        se = +se;
      case "number":
        if (l(se))
          return !1;
    }
    return !0;
  }
  function je(se, ue, Ee) {
    var U = Ce(Ee);
    return U ?? (ue.has(U) && !se.has(U));
  }
  function Ue(se, ue, Ee, U, S) {
    var I = Ce(Ee);
    if (I != null)
      return I;
    var _ = ue.get(I);
    return _ === void 0 && !ue.has(I) || !D(U, _, !1, S) ? !1 : !se.has(I) && D(U, _, !1, S);
  }
  function Qe(se, ue, Ee, U) {
    for (var S = null, I = f(se), _ = 0; _ < I.length; _++) {
      var p = I[_];
      if (a(p) === "object" && p !== null)
        S === null && (S = /* @__PURE__ */ new Set()), S.add(p);
      else if (!ue.has(p)) {
        if (Ee || !je(se, ue, p))
          return !1;
        S === null && (S = /* @__PURE__ */ new Set()), S.add(p);
      }
    }
    if (S !== null) {
      for (var m = f(ue), O = 0; O < m.length; O++) {
        var Q = m[O];
        if (a(Q) === "object" && Q !== null) {
          if (!be(S, Q, Ee, U))
            return !1;
        } else if (!Ee && !se.has(Q) && !be(S, Q, Ee, U))
          return !1;
      }
      return S.size === 0;
    }
    return !0;
  }
  function we(se, ue, Ee, U, S, I) {
    for (var _ = f(se), p = 0; p < _.length; p++) {
      var m = _[p];
      if (D(Ee, m, S, I) && D(U, ue.get(m), S, I))
        return se.delete(m), !0;
    }
    return !1;
  }
  function at(se, ue, Ee, U) {
    for (var S = null, I = u(se), _ = 0; _ < I.length; _++) {
      var p = t(I[_], 2), m = p[0], O = p[1];
      if (a(m) === "object" && m !== null)
        S === null && (S = /* @__PURE__ */ new Set()), S.add(m);
      else {
        var Q = ue.get(m);
        if (Q === void 0 && !ue.has(m) || !D(O, Q, Ee, U)) {
          if (Ee || !Ue(se, ue, m, O, U))
            return !1;
          S === null && (S = /* @__PURE__ */ new Set()), S.add(m);
        }
      }
    }
    if (S !== null) {
      for (var ie = u(ue), ce = 0; ce < ie.length; ce++) {
        var Ne = t(ie[ce], 2), Te = Ne[0], Je = Ne[1];
        if (a(Te) === "object" && Te !== null) {
          if (!we(S, se, Te, Je, Ee, U))
            return !1;
        } else if (!Ee && (!se.has(Te) || !D(se.get(Te), Je, !1, U)) && !we(S, se, Te, Je, !1, U))
          return !1;
      }
      return S.size === 0;
    }
    return !0;
  }
  function rt(se, ue, Ee, U, S, I) {
    var _ = 0;
    if (I === X) {
      if (!Qe(se, ue, Ee, S))
        return !1;
    } else if (I === re) {
      if (!at(se, ue, Ee, S))
        return !1;
    } else if (I === R)
      for (; _ < se.length; _++)
        if (y(se, _)) {
          if (!y(ue, _) || !D(se[_], ue[_], Ee, S))
            return !1;
        } else {
          if (y(ue, _))
            return !1;
          for (var p = Object.keys(se); _ < p.length; _++) {
            var m = p[_];
            if (!y(ue, m) || !D(se[m], ue[m], Ee, S))
              return !1;
          }
          return p.length === Object.keys(ue).length;
        }
    for (_ = 0; _ < U.length; _++) {
      var O = U[_];
      if (!D(se[O], ue[O], Ee, S))
        return !1;
    }
    return !0;
  }
  function It(se, ue) {
    return D(se, ue, k);
  }
  function it(se, ue) {
    return D(se, ue, j);
  }
  return e0 = {
    isDeepEqual: It,
    isDeepStrictEqual: it
  }, e0;
}
var h2;
function nu() {
  if (h2)
    return Ch.exports;
  h2 = 1;
  function t($) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(W) {
      return typeof W;
    } : function(W) {
      return W && typeof Symbol == "function" && W.constructor === Symbol && W !== Symbol.prototype ? "symbol" : typeof W;
    }, t($);
  }
  function e($, W) {
    for (var Z = 0; Z < W.length; Z++) {
      var fe = W[Z];
      fe.enumerable = fe.enumerable || !1, fe.configurable = !0, "value" in fe && (fe.writable = !0), Object.defineProperty($, n(fe.key), fe);
    }
  }
  function r($, W, Z) {
    return W && e($.prototype, W), Z && e($, Z), Object.defineProperty($, "prototype", { writable: !1 }), $;
  }
  function n($) {
    var W = i($, "string");
    return t(W) === "symbol" ? W : String(W);
  }
  function i($, W) {
    if (t($) !== "object" || $ === null)
      return $;
    var Z = $[Symbol.toPrimitive];
    if (Z !== void 0) {
      var fe = Z.call($, W || "default");
      if (t(fe) !== "object")
        return fe;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (W === "string" ? String : Number)($);
  }
  function o($, W) {
    if (!($ instanceof W))
      throw new TypeError("Cannot call a class as a function");
  }
  var a = qw(), s = a.codes, f = s.ERR_AMBIGUOUS_ARGUMENT, u = s.ERR_INVALID_ARG_TYPE, c = s.ERR_INVALID_ARG_VALUE, d = s.ERR_INVALID_RETURN_VALUE, l = s.ERR_MISSING_ARGS, h = vP(), y = Ya, b = y.inspect, w = Ya.types, A = w.isPromise, M = w.isRegExp, N = MP(), G = $1(), z = _d("RegExp.prototype.test"), J, oe;
  function ee() {
    var $ = PP();
    J = $.isDeepEqual, oe = $.isDeepStrictEqual;
  }
  var ae = !1, ye = Ch.exports = B, pe = {};
  function te($) {
    throw $.message instanceof Error ? $.message : new h($);
  }
  function F($, W, Z, fe, D) {
    var K = arguments.length, he;
    if (K === 0)
      he = "Failed";
    else if (K === 1)
      Z = $, $ = void 0;
    else {
      if (ae === !1) {
        ae = !0;
        var be = Ye.emitWarning ? Ye.emitWarning : console.warn.bind(console);
        be("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
      }
      K === 2 && (fe = "!=");
    }
    if (Z instanceof Error)
      throw Z;
    var Ce = {
      actual: $,
      expected: W,
      operator: fe === void 0 ? "fail" : fe,
      stackStartFn: D || F
    };
    Z !== void 0 && (Ce.message = Z);
    var je = new h(Ce);
    throw he && (je.message = he, je.generatedMessage = !0), je;
  }
  ye.fail = F, ye.AssertionError = h;
  function v($, W, Z, fe) {
    if (!Z) {
      var D = !1;
      if (W === 0)
        D = !0, fe = "No value argument passed to `assert.ok()`";
      else if (fe instanceof Error)
        throw fe;
      var K = new h({
        actual: Z,
        expected: !0,
        message: fe,
        operator: "==",
        stackStartFn: $
      });
      throw K.generatedMessage = D, K;
    }
  }
  function B() {
    for (var $ = arguments.length, W = new Array($), Z = 0; Z < $; Z++)
      W[Z] = arguments[Z];
    v.apply(void 0, [B, W.length].concat(W));
  }
  ye.ok = B, ye.equal = function $(W, Z, fe) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    W != Z && te({
      actual: W,
      expected: Z,
      message: fe,
      operator: "==",
      stackStartFn: $
    });
  }, ye.notEqual = function $(W, Z, fe) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    W == Z && te({
      actual: W,
      expected: Z,
      message: fe,
      operator: "!=",
      stackStartFn: $
    });
  }, ye.deepEqual = function $(W, Z, fe) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    J === void 0 && ee(), J(W, Z) || te({
      actual: W,
      expected: Z,
      message: fe,
      operator: "deepEqual",
      stackStartFn: $
    });
  }, ye.notDeepEqual = function $(W, Z, fe) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    J === void 0 && ee(), J(W, Z) && te({
      actual: W,
      expected: Z,
      message: fe,
      operator: "notDeepEqual",
      stackStartFn: $
    });
  }, ye.deepStrictEqual = function $(W, Z, fe) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    J === void 0 && ee(), oe(W, Z) || te({
      actual: W,
      expected: Z,
      message: fe,
      operator: "deepStrictEqual",
      stackStartFn: $
    });
  }, ye.notDeepStrictEqual = P;
  function P($, W, Z) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    J === void 0 && ee(), oe($, W) && te({
      actual: $,
      expected: W,
      message: Z,
      operator: "notDeepStrictEqual",
      stackStartFn: P
    });
  }
  ye.strictEqual = function $(W, Z, fe) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    G(W, Z) || te({
      actual: W,
      expected: Z,
      message: fe,
      operator: "strictEqual",
      stackStartFn: $
    });
  }, ye.notStrictEqual = function $(W, Z, fe) {
    if (arguments.length < 2)
      throw new l("actual", "expected");
    G(W, Z) && te({
      actual: W,
      expected: Z,
      message: fe,
      operator: "notStrictEqual",
      stackStartFn: $
    });
  };
  var L = /* @__PURE__ */ r(function $(W, Z, fe) {
    var D = this;
    o(this, $), Z.forEach(function(K) {
      K in W && (fe !== void 0 && typeof fe[K] == "string" && M(W[K]) && z(W[K], fe[K]) ? D[K] = fe[K] : D[K] = W[K]);
    });
  });
  function x($, W, Z, fe, D, K) {
    if (!(Z in $) || !oe($[Z], W[Z])) {
      if (!fe) {
        var he = new L($, D), be = new L(W, D, $), Ce = new h({
          actual: he,
          expected: be,
          operator: "deepStrictEqual",
          stackStartFn: K
        });
        throw Ce.actual = $, Ce.expected = W, Ce.operator = K.name, Ce;
      }
      te({
        actual: $,
        expected: W,
        message: fe,
        operator: K.name,
        stackStartFn: K
      });
    }
  }
  function C($, W, Z, fe) {
    if (typeof W != "function") {
      if (M(W))
        return z(W, $);
      if (arguments.length === 2)
        throw new u("expected", ["Function", "RegExp"], W);
      if (t($) !== "object" || $ === null) {
        var D = new h({
          actual: $,
          expected: W,
          message: Z,
          operator: "deepStrictEqual",
          stackStartFn: fe
        });
        throw D.operator = fe.name, D;
      }
      var K = Object.keys(W);
      if (W instanceof Error)
        K.push("name", "message");
      else if (K.length === 0)
        throw new c("error", W, "may not be an empty object");
      return J === void 0 && ee(), K.forEach(function(he) {
        typeof $[he] == "string" && M(W[he]) && z(W[he], $[he]) || x($, W, he, Z, K, fe);
      }), !0;
    }
    return W.prototype !== void 0 && $ instanceof W ? !0 : Error.isPrototypeOf(W) ? !1 : W.call({}, $) === !0;
  }
  function j($) {
    if (typeof $ != "function")
      throw new u("fn", "Function", $);
    try {
      $();
    } catch (W) {
      return W;
    }
    return pe;
  }
  function k($) {
    return A($) || $ !== null && t($) === "object" && typeof $.then == "function" && typeof $.catch == "function";
  }
  function g($) {
    return Promise.resolve().then(function() {
      var W;
      if (typeof $ == "function") {
        if (W = $(), !k(W))
          throw new d("instance of Promise", "promiseFn", W);
      } else if (k($))
        W = $;
      else
        throw new u("promiseFn", ["Function", "Promise"], $);
      return Promise.resolve().then(function() {
        return W;
      }).then(function() {
        return pe;
      }).catch(function(Z) {
        return Z;
      });
    });
  }
  function R($, W, Z, fe) {
    if (typeof Z == "string") {
      if (arguments.length === 4)
        throw new u("error", ["Object", "Error", "Function", "RegExp"], Z);
      if (t(W) === "object" && W !== null) {
        if (W.message === Z)
          throw new f("error/message", 'The error message "'.concat(W.message, '" is identical to the message.'));
      } else if (W === Z)
        throw new f("error/message", 'The error "'.concat(W, '" is identical to the message.'));
      fe = Z, Z = void 0;
    } else if (Z != null && t(Z) !== "object" && typeof Z != "function")
      throw new u("error", ["Object", "Error", "Function", "RegExp"], Z);
    if (W === pe) {
      var D = "";
      Z && Z.name && (D += " (".concat(Z.name, ")")), D += fe ? ": ".concat(fe) : ".";
      var K = $.name === "rejects" ? "rejection" : "exception";
      te({
        actual: void 0,
        expected: Z,
        operator: $.name,
        message: "Missing expected ".concat(K).concat(D),
        stackStartFn: $
      });
    }
    if (Z && !C(W, Z, fe, $))
      throw W;
  }
  function X($, W, Z, fe) {
    if (W !== pe) {
      if (typeof Z == "string" && (fe = Z, Z = void 0), !Z || C(W, Z)) {
        var D = fe ? ": ".concat(fe) : ".", K = $.name === "doesNotReject" ? "rejection" : "exception";
        te({
          actual: W,
          expected: Z,
          operator: $.name,
          message: "Got unwanted ".concat(K).concat(D, `
`) + 'Actual message: "'.concat(W && W.message, '"'),
          stackStartFn: $
        });
      }
      throw W;
    }
  }
  ye.throws = function $(W) {
    for (var Z = arguments.length, fe = new Array(Z > 1 ? Z - 1 : 0), D = 1; D < Z; D++)
      fe[D - 1] = arguments[D];
    R.apply(void 0, [$, j(W)].concat(fe));
  }, ye.rejects = function $(W) {
    for (var Z = arguments.length, fe = new Array(Z > 1 ? Z - 1 : 0), D = 1; D < Z; D++)
      fe[D - 1] = arguments[D];
    return g(W).then(function(K) {
      return R.apply(void 0, [$, K].concat(fe));
    });
  }, ye.doesNotThrow = function $(W) {
    for (var Z = arguments.length, fe = new Array(Z > 1 ? Z - 1 : 0), D = 1; D < Z; D++)
      fe[D - 1] = arguments[D];
    X.apply(void 0, [$, j(W)].concat(fe));
  }, ye.doesNotReject = function $(W) {
    for (var Z = arguments.length, fe = new Array(Z > 1 ? Z - 1 : 0), D = 1; D < Z; D++)
      fe[D - 1] = arguments[D];
    return g(W).then(function(K) {
      return X.apply(void 0, [$, K].concat(fe));
    });
  }, ye.ifError = function $(W) {
    if (W != null) {
      var Z = "ifError got unwanted exception: ";
      t(W) === "object" && typeof W.message == "string" ? W.message.length === 0 && W.constructor ? Z += W.constructor.name : Z += W.message : Z += b(W);
      var fe = new h({
        actual: W,
        expected: null,
        operator: "ifError",
        message: Z,
        stackStartFn: $
      }), D = W.stack;
      if (typeof D == "string") {
        var K = D.split(`
`);
        K.shift();
        for (var he = fe.stack.split(`
`), be = 0; be < K.length; be++) {
          var Ce = he.indexOf(K[be]);
          if (Ce !== -1) {
            he = he.slice(0, Ce);
            break;
          }
        }
        fe.stack = "".concat(he.join(`
`), `
`).concat(K.join(`
`));
      }
      throw fe;
    }
  };
  function re($, W, Z, fe, D) {
    if (!M(W))
      throw new u("regexp", "RegExp", W);
    var K = D === "match";
    if (typeof $ != "string" || z(W, $) !== K) {
      if (Z instanceof Error)
        throw Z;
      var he = !Z;
      Z = Z || (typeof $ != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(t($), " (").concat(b($), ")") : (K ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(b(W), `. Input:

`).concat(b($), `
`));
      var be = new h({
        actual: $,
        expected: W,
        message: Z,
        operator: D,
        stackStartFn: fe
      });
      throw be.generatedMessage = he, be;
    }
  }
  ye.match = function $(W, Z, fe) {
    re(W, Z, fe, $, "match");
  }, ye.doesNotMatch = function $(W, Z, fe) {
    re(W, Z, fe, $, "doesNotMatch");
  };
  function V() {
    for (var $ = arguments.length, W = new Array($), Z = 0; Z < $; Z++)
      W[Z] = arguments[Z];
    v.apply(void 0, [V, W.length].concat(W));
  }
  return ye.strict = N(V, ye, {
    equal: ye.strictEqual,
    deepEqual: ye.deepStrictEqual,
    notEqual: ye.notStrictEqual,
    notDeepEqual: ye.notDeepStrictEqual
  }), ye.strict.strict = ye.strict, Ch.exports;
}
const NP = nu();
class hn {
  constructor(e, r) {
    if (!Number.isInteger(e))
      throw new TypeError("span must be an integer");
    this.span = e, this.property = r;
  }
  /** Function to create an Object into which decoded properties will
   * be written.
   *
   * Used only for layouts that {@link Layout#decode|decode} to Object
   * instances, which means:
   * * {@link Structure}
   * * {@link Union}
   * * {@link VariantLayout}
   * * {@link BitStructure}
   *
   * If left undefined the JavaScript representation of these layouts
   * will be Object instances.
   */
  makeDestinationObject() {
    return {};
  }
  /**
   * Decode from a Buffer into an JavaScript value.
   *
   * @param {Buffer} b - the buffer from which encoded data is read.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {(Number|Array|Object)} - the value of the decoded data.
   *
   * @abstract
   */
  decode(e, r) {
    throw new Error("Layout is abstract");
  }
  /**
   * Encode a JavaScript value into a Buffer.
   *
   * @param {(Number|Array|Object)} src - the value to be encoded into
   * the buffer.  The type accepted depends on the (sub-)type of {@link
   * Layout}.
   *
   * @param {Buffer} b - the buffer into which encoded data will be
   * written.
   *
   * @param {Number} [offset] - the offset at which the encoded data
   * starts.  If absent a zero offset is inferred.
   *
   * @returns {Number} - the number of bytes encoded, including the
   * space skipped for internal padding, but excluding data such as
   * {@link Sequence#count|lengths} when stored {@link
   * ExternalLayout|externally}.  This is the adjustment to `offset`
   * producing the offset where data for the next layout would be
   * written.
   *
   * @abstract
   */
  encode(e, r, n) {
    throw new Error("Layout is abstract");
  }
  /**
   * Calculate the span of a specific instance of a layout.
   *
   * @param {Buffer} b - the buffer that contains an encoded instance.
   *
   * @param {Number} [offset] - the offset at which the encoded instance
   * starts.  If absent a zero offset is inferred.
   *
   * @return {Number} - the number of bytes covered by the layout
   * instance.  If this method is not overridden in a subclass the
   * definition-time constant {@link Layout#span|span} will be
   * returned.
   *
   * @throws {RangeError} - if the length of the value cannot be
   * determined.
   */
  getSpan(e, r) {
    if (0 > this.span)
      throw new RangeError("indeterminate span");
    return this.span;
  }
  /**
   * Replicate the layout using a new property.
   *
   * This function must be used to get a structurally-equivalent layout
   * with a different name since all {@link Layout} instances are
   * immutable.
   *
   * **NOTE** This is a shallow copy.  All fields except {@link
   * Layout#property|property} are strictly equal to the origin layout.
   *
   * @param {String} property - the value for {@link
   * Layout#property|property} in the replica.
   *
   * @returns {Layout} - the copy with {@link Layout#property|property}
   * set to `property`.
   */
  replicate(e) {
    const r = Object.create(this.constructor.prototype);
    return Object.assign(r, this), r.property = e, r;
  }
  /**
   * Create an object from layout properties and an array of values.
   *
   * **NOTE** This function returns `undefined` if invoked on a layout
   * that does not return its value as an Object.  Objects are
   * returned for things that are a {@link Structure}, which includes
   * {@link VariantLayout|variant layouts} if they are structures, and
   * excludes {@link Union}s.  If you want this feature for a union
   * you must use {@link Union.getVariant|getVariant} to select the
   * desired layout.
   *
   * @param {Array} values - an array of values that correspond to the
   * default order for properties.  As with {@link Layout#decode|decode}
   * layout elements that have no property name are skipped when
   * iterating over the array values.  Only the top-level properties are
   * assigned; arguments are not assigned to properties of contained
   * layouts.  Any unused values are ignored.
   *
   * @return {(Object|undefined)}
   */
  fromArray(e) {
  }
}
function UP(t, e) {
  return e.property ? t + "[" + e.property + "]" : t;
}
class zn extends hn {
  /**
   * Return `true` iff the external layout decodes to an unsigned
   * integer layout.
   *
   * In that case it can be used as the source of {@link
   * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
   * or as {@link UnionLayoutDiscriminator#layout|external union
   * discriminators}.
   *
   * @abstract
   */
  isCount() {
    throw new Error("ExternalLayout is abstract");
  }
}
class Jw extends zn {
  constructor(e, r, n) {
    if (!(e instanceof hn))
      throw new TypeError("layout must be a Layout");
    if (r === void 0)
      r = 0;
    else if (!Number.isInteger(r))
      throw new TypeError("offset must be integer or undefined");
    super(e.span, n || e.property), this.layout = e, this.offset = r;
  }
  /** @override */
  isCount() {
    return this.layout instanceof Ad || this.layout instanceof Xw;
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), this.layout.decode(e, r + this.offset);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), this.layout.encode(e, r, n + this.offset);
  }
}
class Ad extends hn {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), e.readUIntLE(r, this.span);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), r.writeUIntLE(e, n, this.span), this.span;
  }
}
class Xw extends hn {
  constructor(e, r) {
    if (super(e, r), 6 < this.span)
      throw new RangeError("span must not exceed 6 bytes");
  }
  /** @override */
  decode(e, r) {
    return r === void 0 && (r = 0), e.readUIntBE(r, this.span);
  }
  /** @override */
  encode(e, r, n) {
    return n === void 0 && (n = 0), r.writeUIntBE(e, n, this.span), this.span;
  }
}
const tp = Math.pow(2, 32);
function Zw(t) {
  const e = Math.floor(t / tp), r = t - e * tp;
  return { hi32: e, lo32: r };
}
function Qw(t, e) {
  return t * tp + e;
}
class FP extends hn {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = e.readUInt32LE(r), i = e.readUInt32LE(r + 4);
    return Qw(i, n);
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = Zw(e);
    return r.writeUInt32LE(i.lo32, n), r.writeUInt32LE(i.hi32, n + 4), 8;
  }
}
class LP extends hn {
  constructor(e) {
    super(8, e);
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = e.readUInt32LE(r), i = e.readInt32LE(r + 4);
    return Qw(i, n);
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = Zw(e);
    return r.writeUInt32LE(i.lo32, n), r.writeInt32LE(i.hi32, n + 4), 8;
  }
}
class jP extends hn {
  constructor(e, r, n) {
    if (!(e instanceof hn))
      throw new TypeError("elementLayout must be a Layout");
    if (!(r instanceof zn && r.isCount() || Number.isInteger(r) && 0 <= r))
      throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
    let i = -1;
    !(r instanceof zn) && 0 < e.span && (i = r * e.span), super(i, n), this.elementLayout = e, this.count = r;
  }
  /** @override */
  getSpan(e, r) {
    if (0 <= this.span)
      return this.span;
    r === void 0 && (r = 0);
    let n = 0, i = this.count;
    if (i instanceof zn && (i = i.decode(e, r)), 0 < this.elementLayout.span)
      n = i * this.elementLayout.span;
    else {
      let o = 0;
      for (; o < i; )
        n += this.elementLayout.getSpan(e, r + n), ++o;
    }
    return n;
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = [];
    let i = 0, o = this.count;
    for (o instanceof zn && (o = o.decode(e, r)); i < o; )
      n.push(this.elementLayout.decode(e, r)), r += this.elementLayout.getSpan(e, r), i += 1;
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Sequence}.
   *
   * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
   * the unused space in the buffer is left unchanged.  If `src` is
   * longer than {@link Sequence#count|count} the unneeded elements are
   * ignored.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = this.elementLayout, o = e.reduce((a, s) => a + i.encode(s, r, n + a), 0);
    return this.count instanceof zn && this.count.encode(e.length, r, n), o;
  }
}
class DP extends hn {
  constructor(e, r, n) {
    if (!(Array.isArray(e) && e.reduce((o, a) => o && a instanceof hn, !0)))
      throw new TypeError("fields must be array of Layout instances");
    typeof r == "boolean" && n === void 0 && (n = r, r = void 0);
    for (const o of e)
      if (0 > o.span && o.property === void 0)
        throw new Error("fields cannot contain unnamed variable-length layout");
    let i = -1;
    try {
      i = e.reduce((o, a) => o + a.getSpan(), 0);
    } catch {
    }
    super(i, r), this.fields = e, this.decodePrefixes = !!n;
  }
  /** @override */
  getSpan(e, r) {
    if (0 <= this.span)
      return this.span;
    r === void 0 && (r = 0);
    let n = 0;
    try {
      n = this.fields.reduce((i, o) => {
        const a = o.getSpan(e, r);
        return r += a, i + a;
      }, 0);
    } catch {
      throw new RangeError("indeterminate span");
    }
    return n;
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    const n = this.makeDestinationObject();
    for (const i of this.fields)
      if (i.property !== void 0 && (n[i.property] = i.decode(e, r)), r += i.getSpan(e, r), this.decodePrefixes && e.length === r)
        break;
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Structure}.
   *
   * If `src` is missing a property for a member with a defined {@link
   * Layout#property|property} the corresponding region of the buffer is
   * left unmodified. */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = n;
    let o = 0, a = 0;
    for (const s of this.fields) {
      let f = s.span;
      if (a = 0 < f ? f : 0, s.property === void 0)
        NP(0 < f);
      else {
        const u = e[s.property];
        u !== void 0 && (a = s.encode(u, r, n), 0 > f && (f = s.getSpan(r, n)));
      }
      o = n, n += f;
    }
    return o + a - i;
  }
  /** @override */
  fromArray(e) {
    const r = this.makeDestinationObject();
    for (const n of this.fields)
      n.property !== void 0 && 0 < e.length && (r[n.property] = e.shift());
    return r;
  }
  /**
   * Get access to the layout of a given property.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Layout} - the layout associated with `property`, or
   * undefined if there is no such property.
   */
  layoutFor(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    for (const r of this.fields)
      if (r.property === e)
        return r;
  }
  /**
   * Get the offset of a structure member.
   *
   * @param {String} property - the structure member of interest.
   *
   * @return {Number} - the offset in bytes to the start of `property`
   * within the structure, or undefined if `property` is not a field
   * within the structure.  If the property is a member but follows a
   * variable-length structure member a negative number will be
   * returned.
   */
  offsetOf(e) {
    if (typeof e != "string")
      throw new TypeError("property must be string");
    let r = 0;
    for (const n of this.fields) {
      if (n.property === e)
        return r;
      0 > n.span ? r = -1 : 0 <= r && (r += n.span);
    }
  }
}
class e4 {
  constructor(e) {
    this.property = e;
  }
  /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
   *
   * The implementation of this method need not reference the buffer if
   * variant information is available through other means. */
  decode() {
    throw new Error("UnionDiscriminator is abstract");
  }
  /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
   *
   * The implementation of this method need not store the value if
   * variant information is maintained through other means. */
  encode() {
    throw new Error("UnionDiscriminator is abstract");
  }
}
class p2 extends e4 {
  constructor(e, r) {
    if (!(e instanceof zn && e.isCount()))
      throw new TypeError("layout must be an unsigned integer ExternalLayout");
    super(r || e.property || "variant"), this.layout = e;
  }
  /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  decode(e, r) {
    return this.layout.decode(e, r);
  }
  /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */
  encode(e, r, n) {
    return this.layout.encode(e, r, n);
  }
}
class t4 extends hn {
  constructor(e, r, n) {
    const i = e instanceof Ad || e instanceof Xw;
    if (i)
      e = new p2(new Jw(e));
    else if (e instanceof zn && e.isCount())
      e = new p2(e);
    else if (!(e instanceof e4))
      throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
    if (r === void 0 && (r = null), !(r === null || r instanceof hn))
      throw new TypeError("defaultLayout must be null or a Layout");
    if (r !== null) {
      if (0 > r.span)
        throw new Error("defaultLayout must have constant span");
      r.property === void 0 && (r = r.replicate("content"));
    }
    let o = -1;
    r && (o = r.span, 0 <= o && i && (o += e.layout.span)), super(o, n), this.discriminator = e, this.usesPrefixDiscriminator = i, this.defaultLayout = r, this.registry = {};
    let a = this.defaultGetSourceVariant.bind(this);
    this.getSourceVariant = function(s) {
      return a(s);
    }, this.configGetSourceVariant = function(s) {
      a = s.bind(this);
    };
  }
  /** @override */
  getSpan(e, r) {
    if (0 <= this.span)
      return this.span;
    r === void 0 && (r = 0);
    const n = this.getVariant(e, r);
    if (!n)
      throw new Error("unable to determine span for unrecognized variant");
    return n.getSpan(e, r);
  }
  /**
   * Method to infer a registered Union variant compatible with `src`.
   *
   * The first satisified rule in the following sequence defines the
   * return value:
   * * If `src` has properties matching the Union discriminator and
   *   the default layout, `undefined` is returned regardless of the
   *   value of the discriminator property (this ensures the default
   *   layout will be used);
   * * If `src` has a property matching the Union discriminator, the
   *   value of the discriminator identifies a registered variant, and
   *   either (a) the variant has no layout, or (b) `src` has the
   *   variant's property, then the variant is returned (because the
   *   source satisfies the constraints of the variant it identifies);
   * * If `src` does not have a property matching the Union
   *   discriminator, but does have a property matching a registered
   *   variant, then the variant is returned (because the source
   *   matches a variant without an explicit conflict);
   * * An error is thrown (because we either can't identify a variant,
   *   or we were explicitly told the variant but can't satisfy it).
   *
   * @param {Object} src - an object presumed to be compatible with
   * the content of the Union.
   *
   * @return {(undefined|VariantLayout)} - as described above.
   *
   * @throws {Error} - if `src` cannot be associated with a default or
   * registered variant.
   */
  defaultGetSourceVariant(e) {
    if (e.hasOwnProperty(this.discriminator.property)) {
      if (this.defaultLayout && e.hasOwnProperty(this.defaultLayout.property))
        return;
      const r = this.registry[e[this.discriminator.property]];
      if (r && (!r.layout || e.hasOwnProperty(r.property)))
        return r;
    } else
      for (const r in this.registry) {
        const n = this.registry[r];
        if (e.hasOwnProperty(n.property))
          return n;
      }
    throw new Error("unable to infer src variant");
  }
  /** Implement {@link Layout#decode|decode} for {@link Union}.
   *
   * If the variant is {@link Union#addVariant|registered} the return
   * value is an instance of that variant, with no explicit
   * discriminator.  Otherwise the {@link Union#defaultLayout|default
   * layout} is used to decode the content. */
  decode(e, r) {
    r === void 0 && (r = 0);
    let n;
    const i = this.discriminator, o = i.decode(e, r);
    let a = this.registry[o];
    if (a === void 0) {
      let s = 0;
      a = this.defaultLayout, this.usesPrefixDiscriminator && (s = i.layout.span), n = this.makeDestinationObject(), n[i.property] = o, n[a.property] = this.defaultLayout.decode(e, r + s);
    } else
      n = a.decode(e, r);
    return n;
  }
  /** Implement {@link Layout#encode|encode} for {@link Union}.
   *
   * This API assumes the `src` object is consistent with the union's
   * {@link Union#defaultLayout|default layout}.  To encode variants
   * use the appropriate variant-specific {@link VariantLayout#encode}
   * method. */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    const i = this.getSourceVariant(e);
    if (i === void 0) {
      const o = this.discriminator, a = this.defaultLayout;
      let s = 0;
      return this.usesPrefixDiscriminator && (s = o.layout.span), o.encode(e[o.property], r, n), s + a.encode(
        e[a.property],
        r,
        n + s
      );
    }
    return i.encode(e, r, n);
  }
  /** Register a new variant structure within a union.  The newly
   * created variant is returned.
   *
   * @param {Number} variant - initializer for {@link
   * VariantLayout#variant|variant}.
   *
   * @param {Layout} layout - initializer for {@link
   * VariantLayout#layout|layout}.
   *
   * @param {String} property - initializer for {@link
   * Layout#property|property}.
   *
   * @return {VariantLayout} */
  addVariant(e, r, n) {
    const i = new $P(this, e, r, n);
    return this.registry[e] = i, i;
  }
  /**
   * Get the layout associated with a registered variant.
   *
   * If `vb` does not produce a registered variant the function returns
   * `undefined`.
   *
   * @param {(Number|Buffer)} vb - either the variant number, or a
   * buffer from which the discriminator is to be read.
   *
   * @param {Number} offset - offset into `vb` for the start of the
   * union.  Used only when `vb` is an instance of {Buffer}.
   *
   * @return {({VariantLayout}|undefined)}
   */
  getVariant(e, r) {
    let n = e;
    return e instanceof Ie && (r === void 0 && (r = 0), n = this.discriminator.decode(e, r)), this.registry[n];
  }
}
class $P extends hn {
  constructor(e, r, n, i) {
    if (!(e instanceof t4))
      throw new TypeError("union must be a Union");
    if (!Number.isInteger(r) || 0 > r)
      throw new TypeError("variant must be a (non-negative) integer");
    if (typeof n == "string" && i === void 0 && (i = n, n = null), n) {
      if (!(n instanceof hn))
        throw new TypeError("layout must be a Layout");
      if (e.defaultLayout !== null && 0 <= n.span && n.span > e.defaultLayout.span)
        throw new Error("variant span exceeds span of containing union");
      if (typeof i != "string")
        throw new TypeError("variant must have a String property");
    }
    let o = e.span;
    0 > e.span && (o = n ? n.span : 0, 0 <= o && e.usesPrefixDiscriminator && (o += e.discriminator.layout.span)), super(o, i), this.union = e, this.variant = r, this.layout = n || null;
  }
  /** @override */
  getSpan(e, r) {
    if (0 <= this.span)
      return this.span;
    r === void 0 && (r = 0);
    let n = 0;
    return this.union.usesPrefixDiscriminator && (n = this.union.discriminator.layout.span), n + this.layout.getSpan(e, r + n);
  }
  /** @override */
  decode(e, r) {
    const n = this.makeDestinationObject();
    if (r === void 0 && (r = 0), this !== this.union.getVariant(e, r))
      throw new Error("variant mismatch");
    let i = 0;
    return this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout ? n[this.property] = this.layout.decode(e, r + i) : this.property ? n[this.property] = !0 : this.union.usesPrefixDiscriminator && (n[this.union.discriminator.property] = this.variant), n;
  }
  /** @override */
  encode(e, r, n) {
    n === void 0 && (n = 0);
    let i = 0;
    if (this.union.usesPrefixDiscriminator && (i = this.union.discriminator.layout.span), this.layout && !e.hasOwnProperty(this.property))
      throw new TypeError("variant lacks property " + this.property);
    this.union.discriminator.encode(this.variant, r, n);
    let o = i;
    if (this.layout && (this.layout.encode(e[this.property], r, n + i), o += this.layout.getSpan(r, n + i), 0 <= this.union.span && o > this.union.span))
      throw new Error("encoded variant overruns containing union");
    return o;
  }
  /** Delegate {@link Layout#fromArray|fromArray} to {@link
   * VariantLayout#layout|layout}. */
  fromArray(e) {
    if (this.layout)
      return this.layout.fromArray(e);
  }
}
class r4 extends hn {
  constructor(e, r) {
    if (!(e instanceof zn && e.isCount() || Number.isInteger(e) && 0 <= e))
      throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
    let n = -1;
    e instanceof zn || (n = e), super(n, r), this.length = e;
  }
  /** @override */
  getSpan(e, r) {
    let n = this.span;
    return 0 > n && (n = this.length.decode(e, r)), n;
  }
  /** @override */
  decode(e, r) {
    r === void 0 && (r = 0);
    let n = this.span;
    return 0 > n && (n = this.length.decode(e, r)), e.slice(r, r + n);
  }
  /** Implement {@link Layout#encode|encode} for {@link Blob}.
   *
   * **NOTE** If {@link Layout#count|count} is an instance of {@link
   * ExternalLayout} then the length of `src` will be encoded as the
   * count after `src` is encoded. */
  encode(e, r, n) {
    let i = this.length;
    if (this.length instanceof zn && (i = e.length), !(e instanceof Ie && i === e.length))
      throw new TypeError(UP("Blob.encode", this) + " requires (length " + i + ") Buffer as src");
    if (n + i > r.length)
      throw new RangeError("encoding overruns Buffer");
    return r.write(e.toString("hex"), n, i, "hex"), this.length instanceof zn && this.length.encode(i, r, n), i;
  }
}
var qP = r4, zP = (t, e, r) => new Jw(t, e, r), sr = (t) => new Ad(1, t), Kt = (t) => new Ad(4, t), us = (t) => new FP(t), In = (t) => new LP(t), ut = (t, e, r) => new DP(t, e, r), t0 = (t, e, r) => new jP(t, e, r), n4 = (t, e, r) => new t4(t, e, r), Tn = (t, e) => new r4(t, e);
const Ir = (t = "publicKey") => Tn(32, t), KP = (t = "uint64") => Tn(8, t), Sc = (t = "string") => {
  const e = ut(
    [
      Kt("length"),
      Kt("lengthPadding"),
      Tn(zP(Kt(), -8), "chars")
    ],
    t
  ), r = e.decode.bind(e), n = e.encode.bind(e);
  return e.decode = (i, o) => r(i, o).chars.toString("utf8"), e.encode = (i, o, a) => {
    const s = {
      chars: Ie.from(i, "utf8")
    };
    return n(s, o, a);
  }, e.alloc = (i) => Kt().span + Kt().span + Ie.from(i, "utf8").length, e;
}, WP = (t = "authorized") => ut([Ir("staker"), Ir("withdrawer")], t), HP = (t = "lockup") => ut(
  [In("unixTimestamp"), In("epoch"), Ir("custodian")],
  t
), y2 = (t) => {
  const e = Tn(8, t), r = e.decode.bind(e), n = e.encode.bind(e);
  return e.decode = (i, o = 0) => new Ni(r(i, o), 10, "le"), e.encode = (i, o, a = 0) => n(i.toArrayLike(Ie, "le", 8), o, a), e;
};
function GP(t, e) {
  let r = 0;
  return t.layout.fields.forEach((n) => {
    n.span >= 0 ? r += n.span : typeof n.alloc == "function" && (r += n.alloc(e[n.property]));
  }), r;
}
function Tr(t, e) {
  const r = t.layout.span >= 0 ? t.layout.span : GP(t, e), n = Ie.alloc(r), i = Object.assign({ instruction: t.index }, e);
  return t.layout.encode(i, n), n;
}
const Hs = 1232, i4 = "Reached end of buffer unexpectedly";
function oc(t) {
  if (t.length === 0)
    throw new Error(i4);
  return t.shift();
}
function Rs(t, ...e) {
  const [r] = e;
  if (e.length === 2 ? r + (e[1] ?? 0) > t.length : r >= t.length)
    throw new Error(i4);
  return t.splice(...e);
}
function Ts(t) {
  let e = 0, r = 0;
  for (; ; ) {
    const n = t.shift();
    if (e |= (n & 127) << r * 7, r += 1, !(n & 128))
      break;
  }
  return e;
}
function Os(t, e) {
  let r = e;
  for (; ; ) {
    let n = r & 127;
    if (r >>= 7, r === 0) {
      t.push(n);
      break;
    } else
      n |= 128, t.push(n);
  }
}
const b2 = 32, VP = 127;
class iu {
  constructor(e) {
    Le(this, "header");
    Le(this, "accountKeys");
    Le(this, "recentBlockhash");
    Le(this, "instructions");
    this.header = e.header, this.accountKeys = e.accountKeys.map((r) => new Zt(r)), this.recentBlockhash = e.recentBlockhash, this.instructions = e.instructions;
  }
  isAccountSigner(e) {
    return e < this.header.numRequiredSignatures;
  }
  isAccountWritable(e) {
    return e < this.header.numRequiredSignatures - this.header.numReadonlySignedAccounts || e >= this.header.numRequiredSignatures && e < this.accountKeys.length - this.header.numReadonlyUnsignedAccounts;
  }
  findSignerIndex(e) {
    const r = this.accountKeys.findIndex((n) => n.equals(e));
    if (r < 0)
      throw new Error(`unknown signer: ${e.toString()}`);
    return r;
  }
  serialize() {
    const e = this.accountKeys.length, r = [];
    Os(r, e);
    const n = this.instructions.map((d) => {
      const { accounts: l, programIdIndex: h } = d, y = fr.decode(d.data), b = [];
      Os(b, l.length);
      const w = [];
      return Os(w, y.length), {
        programIdIndex: h,
        keyIndicesCount: Ie.from(b),
        keyIndices: Ie.from(l),
        dataLength: Ie.from(w),
        data: y
      };
    }), i = [];
    Os(i, n.length);
    let o = Ie.alloc(Hs);
    Ie.from(i).copy(o);
    let a = i.length;
    n.forEach((d) => {
      const h = ut([
        sr("programIdIndex"),
        Tn(d.keyIndicesCount.length, "keyIndicesCount"),
        t0(sr("keyIndex"), d.keyIndices.length, "keyIndices"),
        Tn(d.dataLength.length, "dataLength"),
        t0(sr("userdatum"), d.data.length, "data")
      ]).encode(
        d,
        o,
        a
      );
      a += h;
    }), o = o.slice(0, a);
    const s = ut([
      Tn(1, "numRequiredSignatures"),
      Tn(1, "numReadonlySignedAccounts"),
      Tn(1, "numReadonlyUnsignedAccounts"),
      Tn(r.length, "keyCount"),
      t0(Ir("key"), e, "keys"),
      Ir("recentBlockhash")
    ]), f = {
      numRequiredSignatures: Ie.from([this.header.numRequiredSignatures]),
      numReadonlySignedAccounts: Ie.from([this.header.numReadonlySignedAccounts]),
      numReadonlyUnsignedAccounts: Ie.from([this.header.numReadonlyUnsignedAccounts]),
      keyCount: Ie.from(r),
      keys: this.accountKeys.map((d) => d.toBuffer()),
      recentBlockhash: fr.decode(this.recentBlockhash)
    }, u = Ie.alloc(2048), c = s.encode(f, u);
    return o.copy(u, c), u.slice(0, c + o.length);
  }
  /**
   * Decode a compiled message into a Message object.
   */
  static from(e) {
    const r = [...e], n = oc(r);
    if (n !== (n & VP))
      throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
    const i = oc(r), o = oc(r), a = Ts(r), s = [];
    for (let l = 0; l < a; l++) {
      const h = Rs(r, 0, b2);
      s.push(Ie.from(h));
    }
    const f = Rs(r, 0, b2), u = Ts(r), c = [];
    for (let l = 0; l < u; l++) {
      const h = oc(r), y = Ts(r), b = Rs(r, 0, y), w = Ts(r), A = Rs(r, 0, w), M = fr.encode(Ie.from(A));
      c.push({
        programIdIndex: h,
        accounts: b,
        data: M
      });
    }
    const d = {
      header: {
        numRequiredSignatures: n,
        numReadonlySignedAccounts: i,
        numReadonlyUnsignedAccounts: o
      },
      recentBlockhash: fr.encode(Ie.from(f)),
      accountKeys: s,
      instructions: c
    };
    return new iu(d);
  }
}
const YP = us("lamportsPerSignature"), JP = ut([
  Kt("version"),
  Kt("state"),
  Ir("authorizedPubkey"),
  Ir("nonce"),
  ut([YP], "feeCalculator")
]), g2 = JP.span, r0 = new Zt("SysvarC1ock11111111111111111111111111111111"), n0 = new Zt(
  "SysvarRecentB1ockHashes11111111111111111111"
), ka = new Zt("SysvarRent111111111111111111111111111111111");
new Zt("SysvarRewards111111111111111111111111111111");
const v2 = new Zt(
  "SysvarStakeHistory1111111111111111111111111"
), XP = Ie.alloc(64).fill(0), ZP = 64;
class br {
  constructor(e) {
    /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */
    Le(this, "keys", []);
    /**
     * Program Id to execute
     */
    Le(this, "programId");
    /**
     * Program input
     */
    Le(this, "data", Ie.alloc(0));
    e && Object.assign(this, e);
  }
}
class ki {
  /**
   * Construct an empty Transaction
   */
  constructor(e) {
    /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */
    Le(this, "signatures", []);
    /**
     * The transaction fee payer
     */
    Le(this, "feePayer");
    /**
     * The instructions to atomically execute
     */
    Le(this, "instructions", []);
    /**
     * A recent transaction id.  Must be populated by the caller
     */
    Le(this, "recentBlockhash");
    /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */
    Le(this, "nonceInfo");
    e && Object.assign(this, e);
  }
  /**
   * The first (payer) Transaction signature
   */
  get signature() {
    return this.signatures.length > 0 ? this.signatures[0].signature : null;
  }
  /**
   * The transaction fee payer (first signer)
   */
  getFeePayer() {
    return this.signatures.length > 0 ? this.signatures[0].publicKey : null;
  }
  /**
   * Add one or more instructions to this Transaction
   */
  add(...e) {
    if (e.length === 0)
      throw new Error("No instructions");
    return e.forEach((r) => {
      "instructions" in r ? this.instructions = [...this.instructions, ...r.instructions] : "data" in r && "programId" in r && "keys" in r ? this.instructions.push(r) : this.instructions.push(new br(r));
    }), this;
  }
  /**
   * Compile transaction data
   */
  compileMessage() {
    const { nonceInfo: e } = this;
    e && this.instructions[0] !== e.nonceInstruction && (this.recentBlockhash = e.nonce, this.instructions.unshift(e.nonceInstruction));
    const { recentBlockhash: r } = this;
    if (!r)
      throw new Error("Transaction recentBlockhash required");
    if (this.instructions.length === 0)
      throw new Error("No instructions provided");
    let n;
    if (this.feePayer)
      n = this.feePayer;
    else if (this.signatures.length > 0 && this.signatures[0].publicKey)
      n = this.signatures[0].publicKey;
    else
      throw new Error("Transaction fee payer required");
    const i = [], o = [];
    this.instructions.forEach((b) => {
      b.keys.forEach((A) => {
        o.push({ ...A });
      });
      const w = b.programId.toString();
      i.includes(w) || i.push(w);
    }), i.forEach((b) => {
      o.push({
        pubkey: new Zt(b),
        isSigner: !1,
        isWritable: !1
      });
    }), o.sort(function(b, w) {
      if (b.isSigner !== w.isSigner)
        return b.isSigner ? -1 : 1;
      if (b.isWritable !== w.isWritable)
        return b.isWritable ? -1 : 1;
      const A = b.pubkey.toBase58().toLowerCase(), M = w.pubkey.toBase58().toLowerCase();
      return A < M ? -1 : A > M ? 1 : 0;
    });
    const a = [];
    o.forEach((b) => {
      const w = b.pubkey.toString(), A = a.findIndex((M) => M.pubkey.toString() === w);
      A > -1 ? a[A].isWritable = a[A].isWritable || b.isWritable : a.push(b);
    });
    const s = a.findIndex((b) => b.pubkey.equals(n));
    if (s > -1) {
      const [b] = a.splice(s, 1);
      b.isSigner = !0, b.isWritable = !0, a.unshift(b);
    } else
      a.unshift({
        pubkey: n,
        isSigner: !0,
        isWritable: !0
      });
    this.signatures.forEach((b, w) => {
      const A = w === 0, M = a.findIndex((N) => N.pubkey.equals(b.publicKey));
      if (M > -1)
        if (A) {
          const [N] = a.splice(M, 1);
          N.isSigner = !0, N.isWritable = !0, a.unshift(N);
        } else
          a[M].isSigner = !0;
      else if (A)
        a.unshift({
          pubkey: b.publicKey,
          isSigner: !0,
          isWritable: !0
        });
      else
        throw new Error(`unknown signer: ${b.publicKey.toString()}`);
    });
    let f = 0, u = 0, c = 0;
    const d = [], l = [];
    a.forEach(({ pubkey: b, isSigner: w, isWritable: A }) => {
      w ? (d.push(b.toString()), f += 1, A || (u += 1)) : (l.push(b.toString()), A || (c += 1));
    });
    const h = [...d, ...l], y = this.instructions.map((b) => {
      const { data: w, programId: A } = b;
      return {
        programIdIndex: h.indexOf(A.toString()),
        accounts: b.keys.map((M) => h.indexOf(M.pubkey.toString())),
        data: fr.encode(w)
      };
    });
    return y.forEach((b) => {
      $e(b.programIdIndex >= 0), b.accounts.forEach((w) => $e(w >= 0));
    }), new iu({
      header: {
        numRequiredSignatures: f,
        numReadonlySignedAccounts: u,
        numReadonlyUnsignedAccounts: c
      },
      accountKeys: h,
      recentBlockhash: r,
      instructions: y
    });
  }
  /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */
  serializeMessage() {
    return this.compileMessage().serialize();
  }
  /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   */
  setSigners(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set();
    this.signatures = e.filter((n) => {
      const i = n.toString();
      return r.has(i) ? !1 : (r.add(i), !0);
    }).map((n) => ({ signature: null, publicKey: n }));
  }
  /**
   * Sign the Transaction with the specified accounts. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used when testing for Transaction confirmation. The first signer
   * will be used as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   */
  sign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = /* @__PURE__ */ new Set();
    return this.signatures = e.filter((n) => {
      const i = n.publicKey.toString();
      return r.has(i) ? !1 : (r.add(i), !0);
    }).map((n) => ({
      signature: null,
      publicKey: n.publicKey
    })), this.partialSign(...e);
  }
  /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to a public key that was previously provided to `setSigners`.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   */
  partialSign(...e) {
    if (e.length === 0)
      throw new Error("No signers");
    const r = this.compileMessage();
    this.signatures.sort(function(i, o) {
      const a = r.findSignerIndex(i.publicKey), s = r.findSignerIndex(o.publicKey);
      return a < s ? -1 : 1;
    });
    const n = r.serialize();
    e.forEach((i) => {
      const o = eo.sign.detached(n, i.secretKey);
      this.addSignature(i.publicKey, o);
    });
  }
  /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to a public key that was previously provided to `setSigners`.
   */
  addSignature(e, r) {
    $e(r.length === 64);
    const n = this.signatures.findIndex((i) => e.equals(i.publicKey));
    if (n < 0)
      throw new Error(`unknown signer: ${e.toString()}`);
    this.signatures[n].signature = Ie.from(r);
  }
  /**
   * Verify signatures of a complete, signed Transaction
   */
  verifySignatures() {
    return this._verifySignatures(this.serializeMessage(), !0);
  }
  /**
   * @private
   */
  _verifySignatures(e, r) {
    for (const { signature: n, publicKey: i } of this.signatures)
      if (n === null) {
        if (r)
          return !1;
      } else if (!eo.sign.detached.verify(e, n, i.toBuffer()))
        return !1;
    return !0;
  }
  /**
   * Serialize the Transaction in the wire format.
   */
  serialize(e) {
    const { requireAllSignatures: r, verifySignatures: n } = Object.assign(
      { requireAllSignatures: !0, verifySignatures: !0 },
      e
    ), i = this.serializeMessage();
    if (n && !this._verifySignatures(i, r))
      throw new Error("Signature verification failed");
    return this._serialize(i);
  }
  /**
   * @private
   */
  _serialize(e) {
    const { signatures: r } = this, n = [];
    Os(n, r.length);
    const i = n.length + r.length * 64 + e.length, o = Ie.alloc(i);
    return $e(r.length < 256), Ie.from(n).copy(o, 0), r.forEach(({ signature: a }, s) => {
      a !== null && ($e(a.length === 64, "signature has invalid length"), Ie.from(a).copy(o, n.length + s * 64));
    }), e.copy(o, n.length + r.length * 64), $e(
      o.length <= Hs,
      `Transaction too large: ${o.length} > ${Hs}`
    ), o;
  }
  /**
   * Deprecated method
   * @private
   */
  get keys() {
    return $e(this.instructions.length === 1), this.instructions[0].keys.map((e) => e.pubkey);
  }
  /**
   * Deprecated method
   * @private
   */
  get programId() {
    return $e(this.instructions.length === 1), this.instructions[0].programId;
  }
  /**
   * Deprecated method
   * @private
   */
  get data() {
    return $e(this.instructions.length === 1), this.instructions[0].data;
  }
  /**
   * Parse a wire transaction into a Transaction object.
   */
  static from(e) {
    const r = [...e], n = Ts(r), i = [];
    for (let o = 0; o < n; o++) {
      const a = Rs(r, 0, ZP);
      i.push(fr.encode(Ie.from(a)));
    }
    return ki.populate(iu.from(r), i);
  }
  /**
   * Populate Transaction object from message and signatures
   */
  static populate(e, r) {
    const n = new ki();
    return n.recentBlockhash = e.recentBlockhash, r.forEach((i, o) => {
      const a = {
        signature: i === fr.encode(XP) ? null : fr.decode(i),
        publicKey: e.accountKeys[o]
      };
      n.signatures.push(a);
    }), e.instructions.forEach((i) => {
      const o = i.accounts.map((a) => {
        const s = e.accountKeys[a];
        return {
          pubkey: s,
          isSigner: n.signatures.some(
            (f) => f.publicKey.toString() === s.toString()
          ),
          isWritable: e.isAccountWritable(a)
        };
      });
      n.instructions.push(
        new br({
          keys: o,
          programId: e.accountKeys[i.programIdIndex],
          data: fr.decode(i.data)
        })
      );
    }), n;
  }
}
const Yn = Object.freeze({
  Create: {
    index: 0,
    layout: ut([
      Kt("instruction"),
      In("lamports"),
      In("space"),
      Ir("programId")
    ])
  },
  Assign: {
    index: 1,
    layout: ut([Kt("instruction"), Ir("programId")])
  },
  Transfer: {
    index: 2,
    layout: ut([Kt("instruction"), In("lamports")])
  },
  CreateWithSeed: {
    index: 3,
    layout: ut([
      Kt("instruction"),
      Ir("base"),
      Sc("seed"),
      In("lamports"),
      In("space"),
      Ir("programId")
    ])
  },
  AdvanceNonceAccount: {
    index: 4,
    layout: ut([Kt("instruction")])
  },
  WithdrawNonceAccount: {
    index: 5,
    layout: ut([Kt("instruction"), In("lamports")])
  },
  InitializeNonceAccount: {
    index: 6,
    layout: ut([Kt("instruction"), Ir("authorized")])
  },
  AuthorizeNonceAccount: {
    index: 7,
    layout: ut([Kt("instruction"), Ir("authorized")])
  },
  Allocate: {
    index: 8,
    layout: ut([Kt("instruction"), In("space")])
  },
  AllocateWithSeed: {
    index: 9,
    layout: ut([
      Kt("instruction"),
      Ir("base"),
      Sc("seed"),
      In("space"),
      Ir("programId")
    ])
  },
  AssignWithSeed: {
    index: 10,
    layout: ut([
      Kt("instruction"),
      Ir("base"),
      Sc("seed"),
      Ir("programId")
    ])
  }
}), Xa = {
  /**
   * Public key that identifies the System program
   */
  get programId() {
    return new Zt("11111111111111111111111111111111");
  },
  /**
   * Generate a transaction instruction that creates a new account
   */
  createAccount(t) {
    const e = Yn.Create, r = Tr(e, {
      lamports: t.lamports,
      space: t.space,
      programId: t.programId.toBuffer()
    });
    return new br({
      keys: [
        { pubkey: t.fromPubkey, isSigner: !0, isWritable: !0 },
        { pubkey: t.newAccountPubkey, isSigner: !0, isWritable: !0 }
      ],
      programId: this.programId,
      data: r
    });
  },
  /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */
  transfer(t) {
    const e = Yn.Transfer, r = Tr(e, { lamports: t.lamports });
    return new br({
      keys: [
        { pubkey: t.fromPubkey, isSigner: !0, isWritable: !0 },
        { pubkey: t.toPubkey, isSigner: !1, isWritable: !0 }
      ],
      programId: this.programId,
      data: r
    });
  },
  /**
   * Generate a transaction instruction that assigns an account to a program
   */
  assign(t) {
    let e;
    if (t.basePubkey) {
      const r = Yn.AssignWithSeed;
      e = Tr(r, {
        base: t.basePubkey.toBuffer(),
        seed: t.seed,
        programId: t.programId.toBuffer()
      });
    } else {
      const r = Yn.Assign;
      e = Tr(r, { programId: t.programId.toBuffer() });
    }
    return new br({
      keys: [{ pubkey: t.accountPubkey, isSigner: !0, isWritable: !0 }],
      programId: this.programId,
      data: e
    });
  },
  /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */
  createAccountWithSeed(t) {
    const e = Yn.CreateWithSeed, r = Tr(e, {
      base: t.basePubkey.toBuffer(),
      seed: t.seed,
      lamports: t.lamports,
      space: t.space,
      programId: t.programId.toBuffer()
    });
    return new br({
      keys: [
        { pubkey: t.fromPubkey, isSigner: !0, isWritable: !0 },
        { pubkey: t.newAccountPubkey, isSigner: !1, isWritable: !0 }
      ],
      programId: this.programId,
      data: r
    });
  },
  /**
   * Generate a transaction that creates a new Nonce account
   */
  createNonceAccount(t) {
    const e = new ki();
    t.basePubkey && t.seed ? e.add(
      Xa.createAccountWithSeed({
        fromPubkey: t.fromPubkey,
        newAccountPubkey: t.noncePubkey,
        basePubkey: t.basePubkey,
        seed: t.seed,
        lamports: t.lamports,
        space: g2,
        programId: this.programId
      })
    ) : e.add(
      Xa.createAccount({
        fromPubkey: t.fromPubkey,
        newAccountPubkey: t.noncePubkey,
        lamports: t.lamports,
        space: g2,
        programId: this.programId
      })
    );
    const r = {
      noncePubkey: t.noncePubkey,
      authorizedPubkey: t.authorizedPubkey
    };
    return e.add(this.nonceInitialize(r)), e;
  },
  /**
   * Generate an instruction to initialize a Nonce account
   */
  nonceInitialize(t) {
    const e = Yn.InitializeNonceAccount, r = Tr(e, {
      authorized: t.authorizedPubkey.toBuffer()
    }), n = {
      keys: [
        { pubkey: t.noncePubkey, isSigner: !1, isWritable: !0 },
        {
          pubkey: n0,
          isSigner: !1,
          isWritable: !1
        },
        { pubkey: ka, isSigner: !1, isWritable: !1 }
      ],
      programId: this.programId,
      data: r
    };
    return new br(n);
  },
  /**
   * Generate an instruction to advance the nonce in a Nonce account
   */
  nonceAdvance(t) {
    const e = Yn.AdvanceNonceAccount, r = Tr(e), n = {
      keys: [
        { pubkey: t.noncePubkey, isSigner: !1, isWritable: !0 },
        {
          pubkey: n0,
          isSigner: !1,
          isWritable: !1
        },
        { pubkey: t.authorizedPubkey, isSigner: !0, isWritable: !1 }
      ],
      programId: this.programId,
      data: r
    };
    return new br(n);
  },
  /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */
  nonceWithdraw(t) {
    const e = Yn.WithdrawNonceAccount, r = Tr(e, { lamports: t.lamports });
    return new br({
      keys: [
        { pubkey: t.noncePubkey, isSigner: !1, isWritable: !0 },
        { pubkey: t.toPubkey, isSigner: !1, isWritable: !0 },
        {
          pubkey: n0,
          isSigner: !1,
          isWritable: !1
        },
        {
          pubkey: ka,
          isSigner: !1,
          isWritable: !1
        },
        { pubkey: t.authorizedPubkey, isSigner: !0, isWritable: !1 }
      ],
      programId: this.programId,
      data: r
    });
  },
  /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */
  nonceAuthorize(t) {
    const e = Yn.AuthorizeNonceAccount, r = Tr(e, {
      authorized: t.newAuthorizedPubkey.toBuffer()
    });
    return new br({
      keys: [
        { pubkey: t.noncePubkey, isSigner: !1, isWritable: !0 },
        { pubkey: t.authorizedPubkey, isSigner: !0, isWritable: !1 }
      ],
      programId: this.programId,
      data: r
    });
  },
  /**
   * Generate a transaction instruction that allocates space in an account without funding
   */
  allocate(t) {
    let e;
    if (t.basePubkey) {
      const r = Yn.AllocateWithSeed;
      e = Tr(r, {
        base: t.basePubkey.toBuffer(),
        seed: t.seed,
        space: t.space,
        programId: t.programId.toBuffer()
      });
    } else {
      const r = Yn.Allocate;
      e = Tr(r, {
        space: t.space
      });
    }
    return new br({
      keys: [{ pubkey: t.accountPubkey, isSigner: !0, isWritable: !0 }],
      programId: this.programId,
      data: e
    });
  }
}, ac = Object.freeze({
  RequestUnits: {
    index: 0,
    layout: ut([
      sr("instruction"),
      Kt("units"),
      Kt("additionalFee")
    ])
  },
  RequestHeapFrame: {
    index: 1,
    layout: ut([sr("instruction"), Kt("bytes")])
  },
  SetComputeUnitLimit: {
    index: 2,
    layout: ut([sr("instruction"), Kt("units")])
  },
  SetComputeUnitPrice: {
    index: 3,
    layout: ut([
      sr("instruction"),
      In("microLamports")
    ])
  }
});
class QP {
  /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */
  static requestUnits(e) {
    const r = ac.RequestUnits, n = Tr(r, e);
    return new br({
      keys: [],
      programId: this.programId,
      data: n
    });
  }
  static requestHeapFrame(e) {
    const r = ac.RequestHeapFrame, n = Tr(r, e);
    return new br({
      keys: [],
      programId: this.programId,
      data: n
    });
  }
  static setComputeUnitLimit(e) {
    const r = ac.SetComputeUnitLimit, n = Tr(r, e);
    return new br({
      keys: [],
      programId: this.programId,
      data: n
    });
  }
  static setComputeUnitPrice(e) {
    const r = ac.SetComputeUnitPrice, n = Tr(r, {
      microLamports: Number(e.microLamports)
      // replaced from BigInt
    });
    return new br({
      keys: [],
      programId: this.programId,
      data: n
    });
  }
}
/**
 * Public key that identifies the Compute Budget program
 */
Le(QP, "programId", new Zt("ComputeBudget111111111111111111111111111111"));
const eN = new Zt("StakeConfig11111111111111111111111111111111"), sc = Object.freeze({
  Initialize: {
    index: 0,
    layout: ut([
      Kt("instruction"),
      WP(),
      HP()
    ])
  },
  Authorize: {
    index: 1,
    layout: ut([
      Kt("instruction"),
      Ir("newAuthorized"),
      Kt("stakeAuthorizationType")
    ])
  },
  Delegate: {
    index: 2,
    layout: ut([Kt("instruction")])
  },
  Split: {
    index: 3,
    layout: ut([Kt("instruction"), In("lamports")])
  },
  Withdraw: {
    index: 4,
    layout: ut([Kt("instruction"), In("lamports")])
  },
  Deactivate: {
    index: 5,
    layout: ut([Kt("instruction")])
  },
  AuthorizeWithSeed: {
    index: 8,
    layout: ut([
      Kt("instruction"),
      Ir("newAuthorized"),
      Kt("stakeAuthorizationType"),
      Sc("authoritySeed"),
      Ir("authorityOwner")
    ])
  }
}), tN = {
  /**
   * Public key that identifies the Stake program
   */
  get programId() {
    return new Zt("Stake11111111111111111111111111111111111111");
  },
  /**
   * Max space of a Stake account
   *
   * This is generated from the solana-stake-program StakeState struct as
   * `std::mem::size_of::<StakeState>()`:
   * https://docs.rs/solana-stake-program/1.4.4/solana_stake_program/stake_state/enum.StakeState.html
   */
  get space() {
    return 200;
  },
  /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */
  initialize(t) {
    const { stakePubkey: e, authorized: r, lockup: n } = t, i = sc.Initialize, o = Tr(i, {
      authorized: {
        staker: r.staker.toBuffer(),
        withdrawer: r.withdrawer.toBuffer()
      },
      lockup: {
        unixTimestamp: n.unixTimestamp,
        epoch: n.epoch,
        custodian: n.custodian.toBuffer()
      }
    }), a = {
      keys: [
        { pubkey: e, isSigner: !1, isWritable: !0 },
        { pubkey: ka, isSigner: !1, isWritable: !1 }
      ],
      programId: this.programId,
      data: o
    };
    return new br(a);
  },
  /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */
  createAccountWithSeed(t) {
    const e = new ki();
    e.add(
      Xa.createAccountWithSeed({
        fromPubkey: t.fromPubkey,
        newAccountPubkey: t.stakePubkey,
        basePubkey: t.basePubkey,
        seed: t.seed,
        lamports: t.lamports,
        space: this.space,
        programId: this.programId
      })
    );
    const { stakePubkey: r, authorized: n, lockup: i } = t;
    return e.add(this.initialize({ stakePubkey: r, authorized: n, lockup: i }));
  },
  /**
   * Generate a Transaction that creates a new Stake account
   */
  createAccount(t) {
    const e = new ki();
    e.add(
      Xa.createAccount({
        fromPubkey: t.fromPubkey,
        newAccountPubkey: t.stakePubkey,
        lamports: t.lamports,
        space: this.space,
        programId: this.programId
      })
    );
    const { stakePubkey: r, authorized: n, lockup: i } = t;
    return e.add(this.initialize({ stakePubkey: r, authorized: n, lockup: i }));
  },
  /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */
  delegate(t) {
    const { stakePubkey: e, authorizedPubkey: r, votePubkey: n } = t, i = sc.Delegate, o = Tr(i);
    return new ki().add({
      keys: [
        { pubkey: e, isSigner: !1, isWritable: !0 },
        { pubkey: n, isSigner: !1, isWritable: !1 },
        { pubkey: r0, isSigner: !1, isWritable: !1 },
        {
          pubkey: v2,
          isSigner: !1,
          isWritable: !1
        },
        { pubkey: eN, isSigner: !1, isWritable: !1 },
        { pubkey: r, isSigner: !0, isWritable: !1 }
      ],
      programId: this.programId,
      data: o
    });
  },
  /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */
  withdraw(t) {
    const { stakePubkey: e, authorizedPubkey: r, toPubkey: n, lamports: i } = t, o = sc.Withdraw, a = Tr(o, { lamports: i });
    return new ki().add({
      keys: [
        { pubkey: e, isSigner: !1, isWritable: !0 },
        { pubkey: n, isSigner: !1, isWritable: !0 },
        { pubkey: r0, isSigner: !1, isWritable: !1 },
        {
          pubkey: v2,
          isSigner: !1,
          isWritable: !1
        },
        { pubkey: r, isSigner: !0, isWritable: !1 }
      ],
      programId: this.programId,
      data: a
    });
  },
  /**
   * Generate a Transaction that deactivates Stake tokens.
   */
  deactivate(t) {
    const { stakePubkey: e, authorizedPubkey: r } = t, n = sc.Deactivate, i = Tr(n);
    return new ki().add({
      keys: [
        { pubkey: e, isSigner: !1, isWritable: !0 },
        { pubkey: r0, isSigner: !1, isWritable: !1 },
        { pubkey: r, isSigner: !0, isWritable: !1 }
      ],
      programId: this.programId,
      data: i
    });
  }
};
new Zt(
  "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
);
const rN = Xa.programId, nN = tN.programId, i0 = new Zt("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"), fc = new Zt("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
new Zt("MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr");
new Zt(
  "MEisE1HzehtrDpAAT8PnLHjpSSkRYakotTuJRPjTpo8"
);
const m2 = new Zt(
  "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"
);
new Zt(
  "Sysvar1nstructions1111111111111111111111111"
);
const iN = 1e9, oN = Math.log10(iN);
z3.prototype.readPubkeyAsString = function() {
  const t = this.readFixedArray(32);
  return fr.encode(t);
};
q3.prototype.writePubkeyAsString = function(t) {
  this.writeFixedArray(fr.decode(t));
};
class w2 {
  constructor(e) {
    this.name = e.name, this.symbol = e.symbol, this.uri = e.uri, this.sellerFeeBasisPoints = e.sellerFeeBasisPoints, this.creators = e.creators;
  }
}
class x2 {
  constructor(e) {
    this.address = e.address, this.verified = e.verified, this.share = e.share;
  }
}
class o4 {
  constructor(e) {
    this.key = "", this.updateAuthority = e.updateAuthority, this.mint = e.mint, this.data = e.data, this.primarySaleHappened = e.primarySaleHappened, this.isMutable = e.isMutable, this.editionNonce = e.editionNonce || null;
  }
}
const aN = /* @__PURE__ */ new Map([
  [
    w2,
    {
      kind: "struct",
      fields: [
        ["name", "string"],
        ["symbol", "string"],
        ["uri", "string"],
        ["sellerFeeBasisPoints", "u16"],
        ["creators", { kind: "option", type: [x2] }]
      ]
    }
  ],
  [
    x2,
    {
      kind: "struct",
      fields: [
        ["address", "pubkeyAsString"],
        ["verified", "u8"],
        ["share", "u8"]
      ]
    }
  ],
  [
    o4,
    {
      kind: "struct",
      fields: [
        ["key", "u8"],
        ["updateAuthority", "pubkeyAsString"],
        ["mint", "pubkeyAsString"],
        ["data", w2],
        ["primarySaleHappened", "u8"],
        // bool
        ["isMutable", "u8"],
        // bool
        ["editionNonce", { kind: "option", type: "u8" }]
      ]
    }
  ]
]);
function sN(t) {
  return Zt.findProgramAddress(
    [
      Ie.from("metadata"),
      m2.toBuffer(),
      new Zt(t).toBuffer()
    ],
    m2
  )[0].toBase58();
}
function fN(t) {
  const e = Kp(aN, o4, t), r = new RegExp("\0", "g");
  return e.data.name = e.data.name.replace(r, ""), e.data.uri = e.data.uri.replace(r, ""), e.data.symbol = e.data.symbol.replace(r, ""), e.data;
}
new Zt(
  "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
);
new Zt("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
class Xi extends Ni {
  /**
   * Convert to Buffer representation
   */
  toBuffer() {
    const e = super.toArray().reverse(), r = Ie.from(e);
    if (r.length === 8)
      return r;
    $e(r.length < 8, "u64 too large");
    const n = Ie.alloc(8);
    return r.copy(n), n;
  }
  /**
   * Construct a u64 from Buffer representation
   */
  static fromBuffer(e) {
    return $e(e.length === 8, `Invalid buffer length: ${e.length}`), new Xi(
      [...e].reverse().map((r) => `00${r.toString(16)}`.slice(-2)).join(""),
      16
    );
  }
}
const ca = (t = "publicKey") => Tn(32, t), Ss = (t = "uint64") => Tn(8, t), _2 = (t) => Ie.from(t.toBuffer()), cN = {
  /**
   * Construct an Approve instruction
   *
   * @param programId SPL Token program account
   * @param account Public key of the account
   * @param delegate Account authorized to perform a transfer of tokens from the source account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `owner` is a multiSig
   * @param amount Maximum number of tokens the delegate may transfer
   */
  createApproveInstruction(t, e, r, n, i, o) {
    const a = ut([sr("instruction"), Ss("amount")]), s = Ie.alloc(a.span);
    a.encode(
      {
        instruction: 4,
        // Approve instruction
        amount: new Xi(o).toBuffer()
      },
      s
    );
    const f = [
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !0
      },
      {
        pubkey: r,
        isSigner: !1,
        isWritable: !1
      }
    ];
    return i.length === 0 ? f.push({
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }) : (f.push({
      pubkey: n,
      isSigner: !1,
      isWritable: !1
    }), i.forEach(
      (u) => f.push({
        pubkey: u.publicKey,
        isSigner: !0,
        isWritable: !1
      })
    )), new br({
      keys: f,
      programId: t,
      data: s
    });
  },
  /**
   * Construct the AssociatedTokenProgram instruction to create the associated
   * token account
   *
   * @param associatedProgramId SPL Associated Token program account
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param associatedAccount New associated account
   * @param owner Owner of the new account
   * @param payer Payer of fees
   */
  createAssociatedTokenAccountInstruction(t, e, r, n, i, o) {
    const a = Ie.alloc(0), s = [
      {
        pubkey: o,
        isSigner: !0,
        isWritable: !0
      },
      {
        pubkey: n,
        isSigner: !1,
        isWritable: !0
      },
      {
        pubkey: i,
        isSigner: !1,
        isWritable: !1
      },
      {
        pubkey: r,
        isSigner: !1,
        isWritable: !1
      },
      {
        pubkey: Xa.programId,
        isSigner: !1,
        isWritable: !1
      },
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !1
      },
      {
        pubkey: ka,
        isSigner: !1,
        isWritable: !1
      }
    ];
    return new br({
      keys: s,
      programId: t,
      data: a
    });
  },
  /**
   * Construct a Close instruction
   *
   * @param programId SPL Token program account
   * @param account Account to close
   * @param dest Account to receive the remaining balance of the closed account
   * @param authority Account Close authority
   * @param multiSigners Signing accounts if `owner` is a multiSig
   */
  createCloseAccountInstruction(t, e, r, n, i) {
    const o = ut([sr("instruction")]), a = Ie.alloc(o.span);
    o.encode(
      {
        instruction: 9
        // CloseAccount instruction
      },
      a
    );
    const s = [
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !0
      },
      {
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      }
    ];
    return i.length === 0 ? s.push({
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }) : (s.push({
      pubkey: n,
      isSigner: !1,
      isWritable: !1
    }), i.forEach(
      (f) => s.push({
        pubkey: f.publicKey,
        isSigner: !0,
        isWritable: !1
      })
    )), new br({
      keys: s,
      programId: t,
      data: a
    });
  },
  /**
   * Construct an InitializeAccount instruction
   *
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param account New account
   * @param owner Owner of the new account
   */
  createInitAccountInstruction(t, e, r, n) {
    const i = ut([sr("instruction")]), o = Ie.alloc(i.span);
    i.encode(
      {
        instruction: 1
        // InitializeAccount instruction
      },
      o
    );
    const a = [
      {
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      },
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !1
      },
      {
        pubkey: n,
        isSigner: !1,
        isWritable: !1
      },
      {
        pubkey: ka,
        isSigner: !1,
        isWritable: !1
      }
    ];
    return new br({
      keys: a,
      programId: t,
      data: o
    });
  },
  /**
   * Construct an InitializeMint instruction
   *
   * @param programId SPL Token program account
   * @param mint Token mint account
   * @param decimals Number of decimals in token account amounts
   * @param mintAuthority Minting authority
   * @param freezeAuthority Optional authority that can freeze token accounts
   */
  createInitMintInstruction(t, e, r, n, i) {
    const o = ut([
      sr("instruction"),
      sr("decimals"),
      ca("mintAuthority"),
      sr("option"),
      ca("freezeAuthority")
    ]);
    let a = Ie.alloc(1024);
    const s = o.encode(
      {
        instruction: 0,
        // InitializeMint instruction
        decimals: r,
        mintAuthority: _2(n),
        option: i === null ? 0 : 1,
        freezeAuthority: _2(i || new Zt(0))
      },
      a
    );
    a = a.slice(0, s);
    const f = [
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !0
      },
      {
        pubkey: ka,
        isSigner: !1,
        isWritable: !1
      }
    ];
    return new br({
      keys: f,
      programId: t,
      data: a
    });
  },
  /**
   * Construct a MintTo instruction
   *
   * @param programId SPL Token program account
   * @param mint Public key of the mint
   * @param dest Public key of the account to mint to
   * @param authority The mint authority
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Amount to mint
   */
  createMintToInstruction(t, e, r, n, i, o) {
    const a = ut([sr("instruction"), Ss("amount")]), s = Ie.alloc(a.span);
    a.encode(
      {
        instruction: 7,
        // MintTo instruction
        amount: new Xi(o).toBuffer()
      },
      s
    );
    const f = [
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !0
      },
      {
        pubkey: r,
        isSigner: !1,
        isWritable: !0
      }
    ];
    return i.length === 0 ? f.push({
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }) : (f.push({
      pubkey: n,
      isSigner: !1,
      isWritable: !1
    }), i.forEach(
      (u) => f.push({
        pubkey: u.publicKey,
        isSigner: !0,
        isWritable: !1
      })
    )), new br({
      keys: f,
      programId: t,
      data: s
    });
  },
  /**
   * Construct a SyncNative instruction
   *
   * @param programId SPL Token program account
   * @param nativeAccount Account to sync lamports from
   */
  createSyncNativeInstruction(t, e) {
    const r = ut([sr("instruction")]), n = Ie.alloc(r.span);
    r.encode(
      {
        instruction: 17
        // SyncNative instruction
      },
      n
    );
    const i = [
      {
        pubkey: e,
        isSigner: !1,
        isWritable: !0
      }
    ];
    return new br({
      keys: i,
      programId: t,
      data: n
    });
  },
  /**
   * Construct a Transfer instruction
   *
   * @param programId SPL Token program account
   * @param source Source account
   * @param destination Destination account
   * @param owner Owner of the source account
   * @param multiSigners Signing accounts if `authority` is a multiSig
   * @param amount Number of tokens to transfer
   */
  createTransferInstruction(t, e, r, n, i, o) {
    const a = ut([
      sr("instruction"),
      KP("amount")
    ]), s = Ie.alloc(a.span);
    a.encode(
      {
        instruction: 3,
        // Transfer instruction
        amount: new Xi(o).toBuffer()
      },
      s
    );
    const f = [
      { pubkey: e, isSigner: !1, isWritable: !0 },
      { pubkey: r, isSigner: !1, isWritable: !0 }
    ];
    return i.length === 0 ? f.push({
      pubkey: n,
      isSigner: !0,
      isWritable: !1
    }) : (f.push({ pubkey: n, isSigner: !1, isWritable: !1 }), i.forEach(
      (u) => f.push({
        pubkey: u.publicKey,
        isSigner: !0,
        isWritable: !1
      })
    )), new br({
      keys: f,
      programId: t,
      data: s
    });
  },
  decode(t) {
    return ut([
      ca("mint"),
      ca("owner"),
      Ss("amount"),
      Kt("delegateOption"),
      ca("delegate"),
      sr("state"),
      Kt("isNativeOption"),
      Ss("isNative"),
      Ss("delegatedAmount"),
      Kt("closeAuthorityOption"),
      ca("closeAuthority")
    ]).decode(t);
  }
};
new Zt("auth9SigNpDKz4sJJ1DfCTuZrZNSAgh9sFD3rboVmgg");
const E2 = (t = "uint64") => Tn(8, t);
new Zt("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
ut([
  sr("instruction"),
  sr("transferFeeInstruction"),
  E2("amount"),
  sr("decimals"),
  E2("fee")
]);
ut([y2("takerAmount"), sr("escrowBump")]), ut([]), ut([y2("expectedTakerAmount"), Ir("expectedMint")]);
new Zt("2NZukH2TXpcuZP4htiuT8CFxcaQSWzkkR6kepSWnZ24Q");
function S2(t, e) {
  return new Xi(t).sub(new Xi(e));
}
function uN(t) {
  let e = t.indexToProgramIds;
  const r = {
    encoding: "base64",
    commitment: "confirmed"
  }, n = /* @__PURE__ */ new Set();
  if (t.staticAccountKeys)
    t.staticAccountKeys.forEach(
      (i) => n.add(i.toString())
    );
  else if (t.accountKeys)
    e || (e = /* @__PURE__ */ new Map(), t.instructions.forEach(
      (i) => e.set(
        i.programIdIndex,
        t.accountKeys[i.programIdIndex]
      )
    )), t.accountKeys.filter((i, o) => !e.has(o)).forEach((i) => n.add(i.toString()));
  else {
    const i = new Set(
      t.instructions.map((o) => o.programId.toString())
    );
    t.instructions.forEach((o) => {
      o.keys.forEach((a) => {
        i.has(a.pubkey.toString()) || n.add(a.pubkey.toString());
      });
    });
  }
  return r.accounts = {
    encoding: "base64",
    addresses: [...n]
  }, {
    config: r,
    accountAddresses: [...n]
  };
}
const dN = (t) => t === "11111111111111111111111111111111";
function lN(t, e, r) {
  const n = [], i = [];
  if (t.length !== e.length)
    throw new Error("Simulation returning wrong account length");
  return t.forEach((o, a) => {
    try {
      const s = e[a];
      if (dN(o.owner.toString())) {
        s.toString() === r.toString() && n.push({
          amount: o.lamports,
          address: r
        });
        return;
      }
      const f = Ie.from(o.data[0], "base64"), u = cN.decode(f), c = new Zt(u.owner).toString(), d = Xi.fromBuffer(u.amount);
      c === r.toString() && i.push({
        amount: d,
        mint: new Zt(u.mint).toString(),
        owner: c,
        address: s.toString()
      });
    } catch (s) {
      console.warn(s);
    }
  }), {
    solAccounts: n,
    tokenAccounts: i
  };
}
class hN extends qP {
  constructor(e) {
    super(32, e);
  }
  decode(e, r) {
    return new wt(super.decode(e, r));
  }
  encode(e, r, n) {
    return super.encode(e.toBuffer(), r, n);
  }
}
function rp(t) {
  return new hN(t);
}
new wt("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
new wt("So11111111111111111111111111111111111111112");
new wt("MSRMcoVyrFxnSgo5uXwone5SKcGhT1KEJMFEkMEWf9L");
new wt("SRMuApVNdxXokk5GT7XD5cUUgXMBCoAz2LHeuAoKWRt");
const Bi = n4(sr("instruction"));
Bi.addVariant(
  0,
  ut([
    sr("decimals"),
    rp("mintAuthority"),
    sr("freezeAuthorityOption"),
    rp("freezeAuthority")
  ]),
  "initializeMint"
);
Bi.addVariant(1, ut([]), "initializeAccount");
Bi.addVariant(3, ut([us("amount")]), "transfer");
Bi.addVariant(4, ut([us("amount")]), "approve");
Bi.addVariant(5, ut([]), "revoke");
Bi.addVariant(
  6,
  ut([
    sr("authorityType"),
    sr("newAuthorityOption"),
    rp("newAuthority")
  ]),
  "setAuthority"
);
Bi.addVariant(7, ut([us("amount")]), "mintTo");
Bi.addVariant(8, ut([us("amount")]), "burn");
Bi.addVariant(9, ut([]), "closeAccount");
Math.max(...Object.values(Bi.registry).map((t) => t.span));
const pN = n4(sr("instruction"));
pN.addVariant(
  12,
  ut([us("amount"), sr("decimals")]),
  "transferChecked"
);
function yN(t, e) {
  let r = e;
  for (; ; ) {
    let n = r & 127;
    if (r >>= 7, r === 0) {
      t.push(n);
      break;
    }
    n |= 128, t.push(n);
  }
}
const A2 = 255, o0 = eo.sign.signatureLength;
function bN(t, e) {
  const r = [];
  yN(r, e.length);
  const n = r.length + e.length * o0, i = t.length + n;
  if (e.length > A2)
    throw new Error(`Too many signatures: ${e.length} > ${A2}`);
  if (i > Hs)
    throw new Error(`Transaction too large: ${i} > ${Hs}`);
  const o = Ie.alloc(i);
  return Ie.from(r).copy(o), e.forEach((a, s) => {
    if (a !== null) {
      if (a.length !== o0)
        throw new Error("Invalid signature length");
      Ie.from(a).copy(o, r.length + s * o0);
    }
  }), t.copy(o, n), o;
}
function Kr() {
  this._events = this._events || {}, this._maxListeners = this._maxListeners || void 0;
}
Kr.EventEmitter = Kr;
Kr.prototype._events = void 0;
Kr.prototype._maxListeners = void 0;
Kr.defaultMaxListeners = 10;
Kr.prototype.setMaxListeners = function(t) {
  if (!gN(t) || t < 0 || isNaN(t))
    throw TypeError("n must be a positive number");
  return this._maxListeners = t, this;
};
Kr.prototype.emit = function(t) {
  var e, r, n, i, o, a;
  if (this._events || (this._events = {}), t === "error" && (!this._events.error || Gs(this._events.error) && !this._events.error.length)) {
    if (e = arguments[1], e instanceof Error)
      throw e;
    var s = new Error('Uncaught, unspecified "error" event. (' + e + ")");
    throw s.context = e, s;
  }
  if (r = this._events[t], a4(r))
    return !1;
  if (Li(r))
    switch (arguments.length) {
      case 1:
        r.call(this);
        break;
      case 2:
        r.call(this, arguments[1]);
        break;
      case 3:
        r.call(this, arguments[1], arguments[2]);
        break;
      default:
        i = Array.prototype.slice.call(arguments, 1), r.apply(this, i);
    }
  else if (Gs(r))
    for (i = Array.prototype.slice.call(arguments, 1), a = r.slice(), n = a.length, o = 0; o < n; o++)
      a[o].apply(this, i);
  return !0;
};
Kr.prototype.addListener = function(t, e) {
  var r;
  if (!Li(e))
    throw TypeError("listener must be a function");
  return this._events || (this._events = {}), this._events.newListener && this.emit(
    "newListener",
    t,
    Li(e.listener) ? e.listener : e
  ), this._events[t] ? Gs(this._events[t]) ? this._events[t].push(e) : this._events[t] = [this._events[t], e] : this._events[t] = e, Gs(this._events[t]) && !this._events[t].warned && (a4(this._maxListeners) ? r = Kr.defaultMaxListeners : r = this._maxListeners, r && r > 0 && this._events[t].length > r && (this._events[t].warned = !0, console.error(
    "(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",
    this._events[t].length
  ), typeof console.trace == "function" && console.trace())), this;
};
Kr.prototype.on = Kr.prototype.addListener;
Kr.prototype.once = function(t, e) {
  if (!Li(e))
    throw TypeError("listener must be a function");
  var r = !1;
  function n() {
    this.removeListener(t, n), r || (r = !0, e.apply(this, arguments));
  }
  return n.listener = e, this.on(t, n), this;
};
Kr.prototype.removeListener = function(t, e) {
  var r, n, i, o;
  if (!Li(e))
    throw TypeError("listener must be a function");
  if (!this._events || !this._events[t])
    return this;
  if (r = this._events[t], i = r.length, n = -1, r === e || Li(r.listener) && r.listener === e)
    delete this._events[t], this._events.removeListener && this.emit("removeListener", t, e);
  else if (Gs(r)) {
    for (o = i; o-- > 0; )
      if (r[o] === e || r[o].listener && r[o].listener === e) {
        n = o;
        break;
      }
    if (n < 0)
      return this;
    r.length === 1 ? (r.length = 0, delete this._events[t]) : r.splice(n, 1), this._events.removeListener && this.emit("removeListener", t, e);
  }
  return this;
};
Kr.prototype.removeAllListeners = function(t) {
  var e, r;
  if (!this._events)
    return this;
  if (!this._events.removeListener)
    return arguments.length === 0 ? this._events = {} : this._events[t] && delete this._events[t], this;
  if (arguments.length === 0) {
    for (e in this._events)
      e !== "removeListener" && this.removeAllListeners(e);
    return this.removeAllListeners("removeListener"), this._events = {}, this;
  }
  if (r = this._events[t], Li(r))
    this.removeListener(t, r);
  else if (r)
    for (; r.length; )
      this.removeListener(t, r[r.length - 1]);
  return delete this._events[t], this;
};
Kr.prototype.listeners = function(t) {
  var e;
  return !this._events || !this._events[t] ? e = [] : Li(this._events[t]) ? e = [this._events[t]] : e = this._events[t].slice(), e;
};
Kr.prototype.listenerCount = function(t) {
  if (this._events) {
    var e = this._events[t];
    if (Li(e))
      return 1;
    if (e)
      return e.length;
  }
  return 0;
};
Kr.listenerCount = function(t, e) {
  return t.listenerCount(e);
};
function Li(t) {
  return typeof t == "function";
}
function gN(t) {
  return typeof t == "number";
}
function Gs(t) {
  return typeof t == "object" && t !== null;
}
function a4(t) {
  return t === void 0;
}
var a0, I2;
function vN() {
  return I2 || (I2 = 1, a0 = function(t) {
    t.prototype[Symbol.iterator] = function* () {
      for (let e = this.head; e; e = e.next)
        yield e.value;
    };
  }), a0;
}
Qt.Node = Wo;
Qt.create = Qt;
function Qt(t) {
  var e = this;
  if (e instanceof Qt || (e = new Qt()), e.tail = null, e.head = null, e.length = 0, t && typeof t.forEach == "function")
    t.forEach(function(i) {
      e.push(i);
    });
  else if (arguments.length > 0)
    for (var r = 0, n = arguments.length; r < n; r++)
      e.push(arguments[r]);
  return e;
}
Qt.prototype.removeNode = function(t) {
  if (t.list !== this)
    throw new Error("removing node which does not belong to this list");
  var e = t.next, r = t.prev;
  return e && (e.prev = r), r && (r.next = e), t === this.head && (this.head = e), t === this.tail && (this.tail = r), t.list.length--, t.next = null, t.prev = null, t.list = null, e;
};
Qt.prototype.unshiftNode = function(t) {
  if (t !== this.head) {
    t.list && t.list.removeNode(t);
    var e = this.head;
    t.list = this, t.next = e, e && (e.prev = t), this.head = t, this.tail || (this.tail = t), this.length++;
  }
};
Qt.prototype.pushNode = function(t) {
  if (t !== this.tail) {
    t.list && t.list.removeNode(t);
    var e = this.tail;
    t.list = this, t.prev = e, e && (e.next = t), this.tail = t, this.head || (this.head = t), this.length++;
  }
};
Qt.prototype.push = function() {
  for (var t = 0, e = arguments.length; t < e; t++)
    wN(this, arguments[t]);
  return this.length;
};
Qt.prototype.unshift = function() {
  for (var t = 0, e = arguments.length; t < e; t++)
    xN(this, arguments[t]);
  return this.length;
};
Qt.prototype.pop = function() {
  if (this.tail) {
    var t = this.tail.value;
    return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, t;
  }
};
Qt.prototype.shift = function() {
  if (this.head) {
    var t = this.head.value;
    return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, t;
  }
};
Qt.prototype.forEach = function(t, e) {
  e = e || this;
  for (var r = this.head, n = 0; r !== null; n++)
    t.call(e, r.value, n, this), r = r.next;
};
Qt.prototype.forEachReverse = function(t, e) {
  e = e || this;
  for (var r = this.tail, n = this.length - 1; r !== null; n--)
    t.call(e, r.value, n, this), r = r.prev;
};
Qt.prototype.get = function(t) {
  for (var e = 0, r = this.head; r !== null && e < t; e++)
    r = r.next;
  if (e === t && r !== null)
    return r.value;
};
Qt.prototype.getReverse = function(t) {
  for (var e = 0, r = this.tail; r !== null && e < t; e++)
    r = r.prev;
  if (e === t && r !== null)
    return r.value;
};
Qt.prototype.map = function(t, e) {
  e = e || this;
  for (var r = new Qt(), n = this.head; n !== null; )
    r.push(t.call(e, n.value, this)), n = n.next;
  return r;
};
Qt.prototype.mapReverse = function(t, e) {
  e = e || this;
  for (var r = new Qt(), n = this.tail; n !== null; )
    r.push(t.call(e, n.value, this)), n = n.prev;
  return r;
};
Qt.prototype.reduce = function(t, e) {
  var r, n = this.head;
  if (arguments.length > 1)
    r = e;
  else if (this.head)
    n = this.head.next, r = this.head.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var i = 0; n !== null; i++)
    r = t(r, n.value, i), n = n.next;
  return r;
};
Qt.prototype.reduceReverse = function(t, e) {
  var r, n = this.tail;
  if (arguments.length > 1)
    r = e;
  else if (this.tail)
    n = this.tail.prev, r = this.tail.value;
  else
    throw new TypeError("Reduce of empty list with no initial value");
  for (var i = this.length - 1; n !== null; i--)
    r = t(r, n.value, i), n = n.prev;
  return r;
};
Qt.prototype.toArray = function() {
  for (var t = new Array(this.length), e = 0, r = this.head; r !== null; e++)
    t[e] = r.value, r = r.next;
  return t;
};
Qt.prototype.toArrayReverse = function() {
  for (var t = new Array(this.length), e = 0, r = this.tail; r !== null; e++)
    t[e] = r.value, r = r.prev;
  return t;
};
Qt.prototype.slice = function(t, e) {
  e = e || this.length, e < 0 && (e += this.length), t = t || 0, t < 0 && (t += this.length);
  var r = new Qt();
  if (e < t || e < 0)
    return r;
  t < 0 && (t = 0), e > this.length && (e = this.length);
  for (var n = 0, i = this.head; i !== null && n < t; n++)
    i = i.next;
  for (; i !== null && n < e; n++, i = i.next)
    r.push(i.value);
  return r;
};
Qt.prototype.sliceReverse = function(t, e) {
  e = e || this.length, e < 0 && (e += this.length), t = t || 0, t < 0 && (t += this.length);
  var r = new Qt();
  if (e < t || e < 0)
    return r;
  t < 0 && (t = 0), e > this.length && (e = this.length);
  for (var n = this.length, i = this.tail; i !== null && n > e; n--)
    i = i.prev;
  for (; i !== null && n > t; n--, i = i.prev)
    r.push(i.value);
  return r;
};
Qt.prototype.splice = function(t, e, ...r) {
  t > this.length && (t = this.length - 1), t < 0 && (t = this.length + t);
  for (var n = 0, i = this.head; i !== null && n < t; n++)
    i = i.next;
  for (var o = [], n = 0; i && n < e; n++)
    o.push(i.value), i = this.removeNode(i);
  i === null && (i = this.tail), i !== this.head && i !== this.tail && (i = i.prev);
  for (var n = 0; n < r.length; n++)
    i = mN(this, i, r[n]);
  return o;
};
Qt.prototype.reverse = function() {
  for (var t = this.head, e = this.tail, r = t; r !== null; r = r.prev) {
    var n = r.prev;
    r.prev = r.next, r.next = n;
  }
  return this.head = e, this.tail = t, this;
};
function mN(t, e, r) {
  var n = e === t.head ? new Wo(r, null, e, t) : new Wo(r, e, e.next, t);
  return n.next === null && (t.tail = n), n.prev === null && (t.head = n), t.length++, n;
}
function wN(t, e) {
  t.tail = new Wo(e, t.tail, null, t), t.head || (t.head = t.tail), t.length++;
}
function xN(t, e) {
  t.head = new Wo(e, null, t.head, t), t.tail || (t.tail = t.head), t.length++;
}
function Wo(t, e, r, n) {
  if (!(this instanceof Wo))
    return new Wo(t, e, r, n);
  this.list = n, this.value = t, e ? (e.next = this, this.prev = e) : this.prev = null, r ? (r.prev = this, this.next = r) : this.next = null;
}
try {
  vN()(Qt);
} catch {
}
const ou = 2147483648;
var Hn = function(t) {
  if (!Array.isArray(t))
    throw new Error("Input must be an Array");
  if (t.length === 0)
    throw new Error("Path must contain at least one level");
  for (var e = 0; e < t.length; e++)
    if (typeof t[e] != "number")
      throw new Error("Path element is not a number");
  this.path = t;
};
Hn.validatePathArray = function(t) {
  try {
    return Hn.fromPathArray(t), !0;
  } catch {
    return !1;
  }
};
Hn.validateString = function(t, e) {
  try {
    return Hn.fromString(t, e), !0;
  } catch {
    return !1;
  }
};
Hn.fromPathArray = function(t) {
  return new Hn(t);
};
Hn.fromString = function(t, e) {
  if (/^m\//i.test(t))
    t = t.slice(2);
  else if (e)
    throw new Error("Root element is required");
  for (var r = t.split("/"), n = new Array(r.length), i = 0; i < r.length; i++) {
    var o = /(\d+)([hH\']?)/.exec(r[i]);
    if (o === null)
      throw new Error("Invalid input");
    if (n[i] = parseInt(o[1], 10), n[i] >= ou)
      throw new Error("Invalid child index");
    if (o[2] === "h" || o[2] === "H" || o[2] === "'")
      n[i] += ou;
    else if (o[2].length != 0)
      throw new Error("Invalid modifier");
  }
  return new Hn(n);
};
Hn.prototype.toPathArray = function() {
  return this.path;
};
Hn.prototype.toString = function(t, e) {
  for (var r = new Array(this.path.length), n = 0; n < this.path.length; n++) {
    var i = this.path[n];
    i & ou ? r[n] = (i & ~ou) + (e ? "h" : "'") : r[n] = i;
  }
  return (t ? "" : "m/") + r.join("/");
};
Hn.prototype.inspect = function() {
  return "BIPPath <" + this.toString() + ">";
};
var _N = Hn;
const EN = /* @__PURE__ */ sn(_N);
var s0 = qp, SN = Et.Buffer, AN = function(t) {
  function e(o) {
    var a = t(o);
    return s0.encode(SN.concat([
      o,
      a
    ], o.length + 4));
  }
  function r(o) {
    var a = o.slice(0, -4), s = o.slice(-4), f = t(a);
    if (!(s[0] ^ f[0] | s[1] ^ f[1] | s[2] ^ f[2] | s[3] ^ f[3]))
      return a;
  }
  function n(o) {
    var a = s0.decodeUnsafe(o);
    if (a)
      return r(a);
  }
  function i(o) {
    var a = s0.decode(o), s = r(a);
    if (!s)
      throw new Error("Invalid checksum");
    return s;
  }
  return {
    encode: e,
    decode: i,
    decodeUnsafe: n
  };
}, B2 = Yo(), IN = AN;
function BN(t) {
  var e = B2("sha256").update(t).digest();
  return B2("sha256").update(e).digest();
}
var MN = IN(BN);
const Vt = {
  IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
  TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
  TWEAK_MUL: "The tweak was out of range or equal to zero",
  CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
  SECKEY_INVALID: "Private Key is invalid",
  PUBKEY_PARSE: "Public Key could not be parsed",
  PUBKEY_SERIALIZE: "Public Key serialization error",
  PUBKEY_COMBINE: "The sum of the public keys is not valid",
  SIG_PARSE: "Signature could not be parsed",
  SIGN: "The nonce generation function failed, or the private key was invalid",
  RECOVER: "Public key could not be recover",
  ECDH: "Scalar was invalid (zero or overflow)"
};
function $n(t, e) {
  if (!t)
    throw new Error(e);
}
function zt(t, e, r) {
  if ($n(e instanceof Uint8Array, `Expected ${t} to be an Uint8Array`), r !== void 0)
    if (Array.isArray(r)) {
      const n = r.join(", "), i = `Expected ${t} to be an Uint8Array with length [${n}]`;
      $n(r.includes(e.length), i);
    } else {
      const n = `Expected ${t} to be an Uint8Array with length ${r}`;
      $n(e.length === r, n);
    }
}
function fo(t) {
  $n(va(t) === "Boolean", "Expected compressed to be a Boolean");
}
function Jn(t = (r) => new Uint8Array(r), e) {
  return typeof t == "function" && (t = t(e)), zt("output", t, e), t;
}
function va(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
var RN = (t) => ({
  contextRandomize(e) {
    switch ($n(
      e === null || e instanceof Uint8Array,
      "Expected seed to be an Uint8Array or null"
    ), e !== null && zt("seed", e, 32), t.contextRandomize(e)) {
      case 1:
        throw new Error(Vt.CONTEXT_RANDOMIZE_UNKNOW);
    }
  },
  privateKeyVerify(e) {
    return zt("private key", e, 32), t.privateKeyVerify(e) === 0;
  },
  privateKeyNegate(e) {
    switch (zt("private key", e, 32), t.privateKeyNegate(e)) {
      case 0:
        return e;
      case 1:
        throw new Error(Vt.IMPOSSIBLE_CASE);
    }
  },
  privateKeyTweakAdd(e, r) {
    switch (zt("private key", e, 32), zt("tweak", r, 32), t.privateKeyTweakAdd(e, r)) {
      case 0:
        return e;
      case 1:
        throw new Error(Vt.TWEAK_ADD);
    }
  },
  privateKeyTweakMul(e, r) {
    switch (zt("private key", e, 32), zt("tweak", r, 32), t.privateKeyTweakMul(e, r)) {
      case 0:
        return e;
      case 1:
        throw new Error(Vt.TWEAK_MUL);
    }
  },
  publicKeyVerify(e) {
    return zt("public key", e, [33, 65]), t.publicKeyVerify(e) === 0;
  },
  publicKeyCreate(e, r = !0, n) {
    switch (zt("private key", e, 32), fo(r), n = Jn(n, r ? 33 : 65), t.publicKeyCreate(n, e)) {
      case 0:
        return n;
      case 1:
        throw new Error(Vt.SECKEY_INVALID);
      case 2:
        throw new Error(Vt.PUBKEY_SERIALIZE);
    }
  },
  publicKeyConvert(e, r = !0, n) {
    switch (zt("public key", e, [33, 65]), fo(r), n = Jn(n, r ? 33 : 65), t.publicKeyConvert(n, e)) {
      case 0:
        return n;
      case 1:
        throw new Error(Vt.PUBKEY_PARSE);
      case 2:
        throw new Error(Vt.PUBKEY_SERIALIZE);
    }
  },
  publicKeyNegate(e, r = !0, n) {
    switch (zt("public key", e, [33, 65]), fo(r), n = Jn(n, r ? 33 : 65), t.publicKeyNegate(n, e)) {
      case 0:
        return n;
      case 1:
        throw new Error(Vt.PUBKEY_PARSE);
      case 2:
        throw new Error(Vt.IMPOSSIBLE_CASE);
      case 3:
        throw new Error(Vt.PUBKEY_SERIALIZE);
    }
  },
  publicKeyCombine(e, r = !0, n) {
    $n(Array.isArray(e), "Expected public keys to be an Array"), $n(e.length > 0, "Expected public keys array will have more than zero items");
    for (const i of e)
      zt("public key", i, [33, 65]);
    switch (fo(r), n = Jn(n, r ? 33 : 65), t.publicKeyCombine(n, e)) {
      case 0:
        return n;
      case 1:
        throw new Error(Vt.PUBKEY_PARSE);
      case 2:
        throw new Error(Vt.PUBKEY_COMBINE);
      case 3:
        throw new Error(Vt.PUBKEY_SERIALIZE);
    }
  },
  publicKeyTweakAdd(e, r, n = !0, i) {
    switch (zt("public key", e, [33, 65]), zt("tweak", r, 32), fo(n), i = Jn(i, n ? 33 : 65), t.publicKeyTweakAdd(i, e, r)) {
      case 0:
        return i;
      case 1:
        throw new Error(Vt.PUBKEY_PARSE);
      case 2:
        throw new Error(Vt.TWEAK_ADD);
    }
  },
  publicKeyTweakMul(e, r, n = !0, i) {
    switch (zt("public key", e, [33, 65]), zt("tweak", r, 32), fo(n), i = Jn(i, n ? 33 : 65), t.publicKeyTweakMul(i, e, r)) {
      case 0:
        return i;
      case 1:
        throw new Error(Vt.PUBKEY_PARSE);
      case 2:
        throw new Error(Vt.TWEAK_MUL);
    }
  },
  signatureNormalize(e) {
    switch (zt("signature", e, 64), t.signatureNormalize(e)) {
      case 0:
        return e;
      case 1:
        throw new Error(Vt.SIG_PARSE);
    }
  },
  signatureExport(e, r) {
    zt("signature", e, 64), r = Jn(r, 72);
    const n = { output: r, outputlen: 72 };
    switch (t.signatureExport(n, e)) {
      case 0:
        return r.slice(0, n.outputlen);
      case 1:
        throw new Error(Vt.SIG_PARSE);
      case 2:
        throw new Error(Vt.IMPOSSIBLE_CASE);
    }
  },
  signatureImport(e, r) {
    switch (zt("signature", e), r = Jn(r, 64), t.signatureImport(r, e)) {
      case 0:
        return r;
      case 1:
        throw new Error(Vt.SIG_PARSE);
      case 2:
        throw new Error(Vt.IMPOSSIBLE_CASE);
    }
  },
  ecdsaSign(e, r, n = {}, i) {
    zt("message", e, 32), zt("private key", r, 32), $n(va(n) === "Object", "Expected options to be an Object"), n.data !== void 0 && zt("options.data", n.data), n.noncefn !== void 0 && $n(va(n.noncefn) === "Function", "Expected options.noncefn to be a Function"), i = Jn(i, 64);
    const o = { signature: i, recid: null };
    switch (t.ecdsaSign(o, e, r, n.data, n.noncefn)) {
      case 0:
        return o;
      case 1:
        throw new Error(Vt.SIGN);
      case 2:
        throw new Error(Vt.IMPOSSIBLE_CASE);
    }
  },
  ecdsaVerify(e, r, n) {
    switch (zt("signature", e, 64), zt("message", r, 32), zt("public key", n, [33, 65]), t.ecdsaVerify(e, r, n)) {
      case 0:
        return !0;
      case 3:
        return !1;
      case 1:
        throw new Error(Vt.SIG_PARSE);
      case 2:
        throw new Error(Vt.PUBKEY_PARSE);
    }
  },
  ecdsaRecover(e, r, n, i = !0, o) {
    switch (zt("signature", e, 64), $n(
      va(r) === "Number" && r >= 0 && r <= 3,
      "Expected recovery id to be a Number within interval [0, 3]"
    ), zt("message", n, 32), fo(i), o = Jn(o, i ? 33 : 65), t.ecdsaRecover(o, e, r, n)) {
      case 0:
        return o;
      case 1:
        throw new Error(Vt.SIG_PARSE);
      case 2:
        throw new Error(Vt.RECOVER);
      case 3:
        throw new Error(Vt.IMPOSSIBLE_CASE);
    }
  },
  ecdh(e, r, n = {}, i) {
    switch (zt("public key", e, [33, 65]), zt("private key", r, 32), $n(va(n) === "Object", "Expected options to be an Object"), n.data !== void 0 && zt("options.data", n.data), n.hashfn !== void 0 ? ($n(va(n.hashfn) === "Function", "Expected options.hashfn to be a Function"), n.xbuf !== void 0 && zt("options.xbuf", n.xbuf, 32), n.ybuf !== void 0 && zt("options.ybuf", n.ybuf, 32), zt("output", i)) : i = Jn(i, 32), t.ecdh(i, e, r, n.data, n.hashfn, n.xbuf, n.ybuf)) {
      case 0:
        return i;
      case 1:
        throw new Error(Vt.PUBKEY_PARSE);
      case 2:
        throw new Error(Vt.ECDH);
    }
  }
});
const TN = Xu().ec, bi = new TN("secp256k1"), jt = bi.curve, lr = jt.n.constructor;
function ON(t, e) {
  let r = new lr(e);
  if (r.cmp(jt.p) >= 0)
    return null;
  r = r.toRed(jt.red);
  let n = r.redSqr().redIMul(r).redIAdd(jt.b).redSqrt();
  return t === 3 !== n.isOdd() && (n = n.redNeg()), bi.keyPair({ pub: { x: r, y: n } });
}
function kN(t, e, r) {
  let n = new lr(e), i = new lr(r);
  if (n.cmp(jt.p) >= 0 || i.cmp(jt.p) >= 0 || (n = n.toRed(jt.red), i = i.toRed(jt.red), (t === 6 || t === 7) && i.isOdd() !== (t === 7)))
    return null;
  const o = n.redSqr().redIMul(n);
  return i.redSqr().redISub(o.redIAdd(jt.b)).isZero() ? bi.keyPair({ pub: { x: n, y: i } }) : null;
}
function qi(t) {
  const e = t[0];
  switch (e) {
    case 2:
    case 3:
      return t.length !== 33 ? null : ON(e, t.subarray(1, 33));
    case 4:
    case 6:
    case 7:
      return t.length !== 65 ? null : kN(e, t.subarray(1, 33), t.subarray(33, 65));
    default:
      return null;
  }
}
function co(t, e) {
  const r = e.encode(null, t.length === 33);
  for (let n = 0; n < t.length; ++n)
    t[n] = r[n];
}
var CN = {
  contextRandomize() {
    return 0;
  },
  privateKeyVerify(t) {
    const e = new lr(t);
    return e.cmp(jt.n) < 0 && !e.isZero() ? 0 : 1;
  },
  privateKeyNegate(t) {
    const e = new lr(t), r = jt.n.sub(e).umod(jt.n).toArrayLike(Uint8Array, "be", 32);
    return t.set(r), 0;
  },
  privateKeyTweakAdd(t, e) {
    const r = new lr(e);
    if (r.cmp(jt.n) >= 0 || (r.iadd(new lr(t)), r.cmp(jt.n) >= 0 && r.isub(jt.n), r.isZero()))
      return 1;
    const n = r.toArrayLike(Uint8Array, "be", 32);
    return t.set(n), 0;
  },
  privateKeyTweakMul(t, e) {
    let r = new lr(e);
    if (r.cmp(jt.n) >= 0 || r.isZero())
      return 1;
    r.imul(new lr(t)), r.cmp(jt.n) >= 0 && (r = r.umod(jt.n));
    const n = r.toArrayLike(Uint8Array, "be", 32);
    return t.set(n), 0;
  },
  publicKeyVerify(t) {
    return qi(t) === null ? 1 : 0;
  },
  publicKeyCreate(t, e) {
    const r = new lr(e);
    if (r.cmp(jt.n) >= 0 || r.isZero())
      return 1;
    const n = bi.keyFromPrivate(e).getPublic();
    return co(t, n), 0;
  },
  publicKeyConvert(t, e) {
    const r = qi(e);
    if (r === null)
      return 1;
    const n = r.getPublic();
    return co(t, n), 0;
  },
  publicKeyNegate(t, e) {
    const r = qi(e);
    if (r === null)
      return 1;
    const n = r.getPublic();
    return n.y = n.y.redNeg(), co(t, n), 0;
  },
  publicKeyCombine(t, e) {
    const r = new Array(e.length);
    for (let i = 0; i < e.length; ++i)
      if (r[i] = qi(e[i]), r[i] === null)
        return 1;
    let n = r[0].getPublic();
    for (let i = 1; i < r.length; ++i)
      n = n.add(r[i].pub);
    return n.isInfinity() ? 2 : (co(t, n), 0);
  },
  publicKeyTweakAdd(t, e, r) {
    const n = qi(e);
    if (n === null)
      return 1;
    if (r = new lr(r), r.cmp(jt.n) >= 0)
      return 2;
    const i = n.getPublic().add(jt.g.mul(r));
    return i.isInfinity() ? 2 : (co(t, i), 0);
  },
  publicKeyTweakMul(t, e, r) {
    const n = qi(e);
    if (n === null)
      return 1;
    if (r = new lr(r), r.cmp(jt.n) >= 0 || r.isZero())
      return 2;
    const i = n.getPublic().mul(r);
    return co(t, i), 0;
  },
  signatureNormalize(t) {
    const e = new lr(t.subarray(0, 32)), r = new lr(t.subarray(32, 64));
    return e.cmp(jt.n) >= 0 || r.cmp(jt.n) >= 0 ? 1 : (r.cmp(bi.nh) === 1 && t.set(jt.n.sub(r).toArrayLike(Uint8Array, "be", 32), 32), 0);
  },
  // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
  // Adapted for Uint8Array instead Buffer
  signatureExport(t, e) {
    const r = e.subarray(0, 32), n = e.subarray(32, 64);
    if (new lr(r).cmp(jt.n) >= 0 || new lr(n).cmp(jt.n) >= 0)
      return 1;
    const { output: i } = t;
    let o = i.subarray(4, 37);
    o[0] = 0, o.set(r, 1);
    let a = 33, s = 0;
    for (; a > 1 && o[s] === 0 && !(o[s + 1] & 128); --a, ++s)
      ;
    if (o = o.subarray(s), o[0] & 128 || a > 1 && o[0] === 0 && !(o[1] & 128))
      return 1;
    let f = i.subarray(39, 72);
    f[0] = 0, f.set(n, 1);
    let u = 33, c = 0;
    for (; u > 1 && f[c] === 0 && !(f[c + 1] & 128); --u, ++c)
      ;
    return f = f.subarray(c), f[0] & 128 || u > 1 && f[0] === 0 && !(f[1] & 128) ? 1 : (t.outputlen = 6 + a + u, i[0] = 48, i[1] = t.outputlen - 2, i[2] = 2, i[3] = o.length, i.set(o, 4), i[4 + a] = 2, i[5 + a] = f.length, i.set(f, 6 + a), 0);
  },
  // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
  // Adapted for Uint8Array instead Buffer
  signatureImport(t, e) {
    if (e.length < 8 || e.length > 72 || e[0] !== 48 || e[1] !== e.length - 2 || e[2] !== 2)
      return 1;
    const r = e[3];
    if (r === 0 || 5 + r >= e.length || e[4 + r] !== 2)
      return 1;
    const n = e[5 + r];
    if (n === 0 || 6 + r + n !== e.length || e[4] & 128 || r > 1 && e[4] === 0 && !(e[5] & 128) || e[r + 6] & 128 || n > 1 && e[r + 6] === 0 && !(e[r + 7] & 128))
      return 1;
    let i = e.subarray(4, 4 + r);
    if (i.length === 33 && i[0] === 0 && (i = i.subarray(1)), i.length > 32)
      return 1;
    let o = e.subarray(6 + r);
    if (o.length === 33 && o[0] === 0 && (o = o.slice(1)), o.length > 32)
      throw new Error("S length is too long");
    let a = new lr(i);
    a.cmp(jt.n) >= 0 && (a = new lr(0));
    let s = new lr(e.subarray(6 + r));
    return s.cmp(jt.n) >= 0 && (s = new lr(0)), t.set(a.toArrayLike(Uint8Array, "be", 32), 0), t.set(s.toArrayLike(Uint8Array, "be", 32), 32), 0;
  },
  ecdsaSign(t, e, r, n, i) {
    if (i) {
      const s = i;
      i = (f) => {
        const u = s(e, r, null, n, f);
        if (!(u instanceof Uint8Array && u.length === 32))
          throw new Error("This is the way");
        return new lr(u);
      };
    }
    const o = new lr(r);
    if (o.cmp(jt.n) >= 0 || o.isZero())
      return 1;
    let a;
    try {
      a = bi.sign(e, r, { canonical: !0, k: i, pers: n });
    } catch {
      return 1;
    }
    return t.signature.set(a.r.toArrayLike(Uint8Array, "be", 32), 0), t.signature.set(a.s.toArrayLike(Uint8Array, "be", 32), 32), t.recid = a.recoveryParam, 0;
  },
  ecdsaVerify(t, e, r) {
    const n = { r: t.subarray(0, 32), s: t.subarray(32, 64) }, i = new lr(n.r), o = new lr(n.s);
    if (i.cmp(jt.n) >= 0 || o.cmp(jt.n) >= 0)
      return 1;
    if (o.cmp(bi.nh) === 1 || i.isZero() || o.isZero())
      return 3;
    const a = qi(r);
    if (a === null)
      return 2;
    const s = a.getPublic();
    return bi.verify(e, n, s) ? 0 : 3;
  },
  ecdsaRecover(t, e, r, n) {
    const i = { r: e.slice(0, 32), s: e.slice(32, 64) }, o = new lr(i.r), a = new lr(i.s);
    if (o.cmp(jt.n) >= 0 || a.cmp(jt.n) >= 0)
      return 1;
    if (o.isZero() || a.isZero())
      return 2;
    let s;
    try {
      s = bi.recoverPubKey(n, i, r);
    } catch {
      return 2;
    }
    return co(t, s), 0;
  },
  ecdh(t, e, r, n, i, o, a) {
    const s = qi(e);
    if (s === null)
      return 1;
    const f = new lr(r);
    if (f.cmp(jt.n) >= 0 || f.isZero())
      return 2;
    const u = s.getPublic().mul(f);
    if (i === void 0) {
      const c = u.encode(null, !0), d = bi.hash().update(c).digest();
      for (let l = 0; l < 32; ++l)
        t[l] = d[l];
    } else {
      o || (o = new Uint8Array(32));
      const c = u.getX().toArray("be", 32);
      for (let y = 0; y < 32; ++y)
        o[y] = c[y];
      a || (a = new Uint8Array(32));
      const d = u.getY().toArray("be", 32);
      for (let y = 0; y < 32; ++y)
        a[y] = d[y];
      const l = i(o, a, n);
      if (!(l instanceof Uint8Array && l.length === t.length))
        return 2;
      t.set(l);
    }
    return 0;
  }
}, PN = RN(CN), wi = nu(), an = Et.Buffer, Id = $p(), q1 = MN, NN = qu, to = PN, UN = an.from("Bitcoin seed", "utf8"), au = 2147483648, FN = 78, s4 = { private: 76066276, public: 76067358 };
function Er(t) {
  this.versions = t || s4, this.depth = 0, this.index = 0, this._privateKey = null, this._publicKey = null, this.chainCode = null, this._fingerprint = 0, this.parentFingerprint = 0;
}
Object.defineProperty(Er.prototype, "fingerprint", { get: function() {
  return this._fingerprint;
} });
Object.defineProperty(Er.prototype, "identifier", { get: function() {
  return this._identifier;
} });
Object.defineProperty(Er.prototype, "pubKeyHash", { get: function() {
  return this.identifier;
} });
Object.defineProperty(Er.prototype, "privateKey", {
  get: function() {
    return this._privateKey;
  },
  set: function(t) {
    wi.equal(t.length, 32, "Private key must be 32 bytes."), wi(to.privateKeyVerify(t) === !0, "Invalid private key"), this._privateKey = t, this._publicKey = an.from(to.publicKeyCreate(t, !0)), this._identifier = u4(this.publicKey), this._fingerprint = this._identifier.slice(0, 4).readUInt32BE(0);
  }
});
function f4(t, e) {
  t._publicKey = an.from(e), t._identifier = u4(e), t._fingerprint = t._identifier.slice(0, 4).readUInt32BE(0), t._privateKey = null;
}
Object.defineProperty(Er.prototype, "publicKey", {
  get: function() {
    return this._publicKey;
  },
  set: function(t) {
    wi(t.length === 33 || t.length === 65, "Public key must be 33 or 65 bytes."), wi(to.publicKeyVerify(t) === !0, "Invalid public key");
    const e = t.length === 65 ? to.publicKeyConvert(t, !0) : t;
    f4(this, e);
  }
});
Object.defineProperty(Er.prototype, "privateExtendedKey", {
  get: function() {
    return this._privateKey ? q1.encode(c4(this, this.versions.private, an.concat([an.alloc(1, 0), this.privateKey]))) : null;
  }
});
Object.defineProperty(Er.prototype, "publicExtendedKey", {
  get: function() {
    return q1.encode(c4(this, this.versions.public, this.publicKey));
  }
});
Er.prototype.derive = function(t) {
  if (t === "m" || t === "M" || t === "m'" || t === "M'")
    return this;
  var e = t.split("/"), r = this;
  return e.forEach(function(n, i) {
    if (i === 0) {
      wi(/^[mM]{1}/.test(n), 'Path must start with "m" or "M"');
      return;
    }
    var o = n.length > 1 && n[n.length - 1] === "'", a = parseInt(n, 10);
    wi(a < au, "Invalid index"), o && (a += au), r = r.deriveChild(a);
  }), r;
};
Er.prototype.deriveChild = function(t) {
  var e = t >= au, r = an.allocUnsafe(4);
  r.writeUInt32BE(t, 0);
  var n;
  if (e) {
    wi(this.privateKey, "Could not derive hardened child key");
    var i = this.privateKey, o = an.alloc(1, 0);
    i = an.concat([o, i]), n = an.concat([i, r]);
  } else
    n = an.concat([this.publicKey, r]);
  var a = Id.createHmac("sha512", this.chainCode).update(n).digest(), s = a.slice(0, 32), f = a.slice(32), u = new Er(this.versions);
  if (this.privateKey)
    try {
      u.privateKey = an.from(to.privateKeyTweakAdd(an.from(this.privateKey), s));
    } catch {
      return this.deriveChild(t + 1);
    }
  else
    try {
      u.publicKey = an.from(to.publicKeyTweakAdd(an.from(this.publicKey), s, !0));
    } catch {
      return this.deriveChild(t + 1);
    }
  return u.chainCode = f, u.depth = this.depth + 1, u.parentFingerprint = this.fingerprint, u.index = t, u;
};
Er.prototype.sign = function(t) {
  return an.from(to.ecdsaSign(Uint8Array.from(t), Uint8Array.from(this.privateKey)).signature);
};
Er.prototype.verify = function(t, e) {
  return to.ecdsaVerify(
    Uint8Array.from(e),
    Uint8Array.from(t),
    Uint8Array.from(this.publicKey)
  );
};
Er.prototype.wipePrivateData = function() {
  return this._privateKey && Id.randomBytes(this._privateKey.length).copy(this._privateKey), this._privateKey = null, this;
};
Er.prototype.toJSON = function() {
  return {
    xpriv: this.privateExtendedKey,
    xpub: this.publicExtendedKey
  };
};
Er.fromMasterSeed = function(t, e) {
  var r = Id.createHmac("sha512", UN).update(t).digest(), n = r.slice(0, 32), i = r.slice(32), o = new Er(e);
  return o.chainCode = i, o.privateKey = n, o;
};
Er.fromExtendedKey = function(t, e, r) {
  e = e || s4, r = r || !1;
  var n = new Er(e), i = q1.decode(t), o = i.readUInt32BE(0);
  wi(o === e.private || o === e.public, "Version mismatch: does not match private or public"), n.depth = i.readUInt8(4), n.parentFingerprint = i.readUInt32BE(5), n.index = i.readUInt32BE(9), n.chainCode = i.slice(13, 45);
  var a = i.slice(45);
  return a.readUInt8(0) === 0 ? (wi(o === e.private, "Version mismatch: version does not match private"), n.privateKey = a.slice(1)) : (wi(o === e.public, "Version mismatch: version does not match public"), r ? f4(n, a) : n.publicKey = a), n;
};
Er.fromJSON = function(t) {
  return Er.fromExtendedKey(t.xpriv);
};
function c4(t, e, r) {
  var n = an.allocUnsafe(FN);
  n.writeUInt32BE(e, 0), n.writeUInt8(t.depth, 4);
  var i = t.depth ? t.parentFingerprint : 0;
  return n.writeUInt32BE(i, 5), n.writeUInt32BE(t.index, 9), t.chainCode.copy(n, 13), r.copy(n, 45), n;
}
function u4(t) {
  var e = Id.createHash("sha256").update(t).digest();
  return new NN().update(e).digest();
}
Er.HARDENED_OFFSET = au;
var LN = Er, Bd = {};
Object.defineProperty(Bd, "__esModule", {
  value: !0
});
Bd.default = void 0;
Bd.fromMasterSeed = zN;
var jN = d4(p1), su = d4(LN);
function d4(t) {
  return t && t.__esModule ? t : { default: t };
}
function DN(t, e, r) {
  return e = $N(e), e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
function $N(t) {
  var e = qN(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
function qN(t, e) {
  if (typeof t != "object" || t === null)
    return t;
  var r = t[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(t, e || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function zN() {
  return ei.create(su.default.fromMasterSeed.apply(su.default, arguments));
}
class ei {
  constructor(e) {
    this._hdkey = e;
  }
  static create(e) {
    return new ei(e);
  }
  static fromJSON(e) {
    typeof e == "string" && (e = JSON.parse(e));
    const r = su.default.fromJSON(e);
    return new ei(r);
  }
  static fromXPub(e, {
    skipVerification: r = !1
  } = {}) {
    const n = su.default.fromExtendedKey(e, null, r);
    return new ei(n);
  }
  static fromXPriv(...e) {
    return ei.fromXPub(...e);
  }
  derive(e) {
    if (typeof e == "number") {
      if (!Number.isSafeInteger(e))
        throw new RangeError("number must be safe integer");
      return ei.create(this._hdkey.deriveChild(e));
    }
    if (typeof e == "string")
      return ei.create(this._hdkey.derive(e));
    throw new TypeError("unknown type, expected a number or a path");
  }
  wipePrivateData() {
    this._hdkey.wipePrivateData();
  }
  inspect() {
    return this.toJSON();
  }
  toJSON() {
    return this._hdkey.toJSON();
  }
  toString() {
    return JSON.stringify(this.inspect(), null, 2);
  }
  get privateKey() {
    return this._hdkey.privateKey;
  }
  get publicKey() {
    return this._hdkey.publicKey;
  }
  get xPub() {
    return this._hdkey.publicExtendedKey;
  }
  get identifier() {
    return this._hdkey.identifier;
  }
}
Bd.default = ei;
DN(ei, "memoizedFromXPub", (0, jN.default)(ei.fromXPub));
var l4 = { exports: {} };
(function(t) {
  (function(e, r, n) {
    t.exports ? t.exports = n() : r[e] = n();
  })("urljoin", yt, function() {
    function e(r) {
      var n = [];
      if (r.length === 0)
        return "";
      if (typeof r[0] != "string")
        throw new TypeError("Url must be a string. Received " + r[0]);
      if (r[0].match(/^[^/:]+:\/*$/) && r.length > 1) {
        var i = r.shift();
        r[0] = i + r[0];
      }
      r[0].match(/^file:\/\/\//) ? r[0] = r[0].replace(/^([^/:]+):\/*/, "$1:///") : r[0] = r[0].replace(/^([^/:]+):\/*/, "$1://");
      for (var o = 0; o < r.length; o++) {
        var a = r[o];
        if (typeof a != "string")
          throw new TypeError("Url must be a string. Received " + a);
        a !== "" && (o > 0 && (a = a.replace(/^[\/]+/, "")), o < r.length - 1 ? a = a.replace(/[\/]+$/, "") : a = a.replace(/[\/]+$/, "/"), n.push(a));
      }
      var s = n.join("/");
      s = s.replace(/\/(\?|&|#[^!])/g, "$1");
      var f = s.split("?");
      return s = f.shift() + (f.length > 0 ? "?" : "") + f.join("&"), s;
    }
    return function() {
      var r;
      return typeof arguments[0] == "object" ? r = arguments[0] : r = [].slice.call(arguments), e(r);
    };
  });
})(l4);
var KN = l4.exports;
const WN = /* @__PURE__ */ sn(KN);
function HN(t) {
  return t ? `?${Object.entries(t).map(([e, r]) => `${encodeURIComponent(e)}=${encodeURIComponent(r)}`).join("&")}` : "";
}
function GN({ fetch: t }) {
  async function e(n, i, o, a) {
    if (o.body)
      throw new Error("unexpected pre-set body option");
    const s = await r.fetch(i, {
      ...o,
      method: n,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...o.headers
      },
      ...a ? { body: JSON.stringify(a) } : {}
    });
    if (s.status >= 200 && s.status < 300)
      return o.responseAs === "response" ? s : s.status === 204 ? null : o.responseAs === "text" ? s.text() : s.json();
    const f = new Error(s.statusText);
    throw f.response = s, f;
  }
  function r(n, i = {}) {
    const o = (a, s = {}) => {
      const u = `${n}`.endsWith("/") ? `${n}${a}` : `${n}/${a}`;
      return r(u, { ...i, ...s });
    };
    return o.get = (a) => e("GET", n + HN(a), i), o.post = (a) => e("POST", n, i, a), o.put = (a) => e("PUT", n, i, a), o.patch = (a) => e("PATCH", n, i, a), o.delete = () => e("DELETE", n, i), o;
  }
  return r.fetch = t, r;
}
var VN = GN;
const YN = VN;
var JN = YN({
  fetch: typeof fetch > "u" ? null : fetch.bind(globalThis)
}), XN = fetch.bind(globalThis);
const ZN = JN, QN = XN;
var As = { fetch: QN, WebSocket, fetchival: ZN }, np = { exports: {} }, f0, M2;
function eU() {
  if (M2)
    return f0;
  M2 = 1;
  var t = 1e3, e = t * 60, r = e * 60, n = r * 24, i = n * 7, o = n * 365.25;
  f0 = function(c, d) {
    d = d || {};
    var l = typeof c;
    if (l === "string" && c.length > 0)
      return a(c);
    if (l === "number" && isFinite(c))
      return d.long ? f(c) : s(c);
    throw new Error(
      "val is not a non-empty string or a valid number. val=" + JSON.stringify(c)
    );
  };
  function a(c) {
    if (c = String(c), !(c.length > 100)) {
      var d = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        c
      );
      if (d) {
        var l = parseFloat(d[1]), h = (d[2] || "ms").toLowerCase();
        switch (h) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return l * o;
          case "weeks":
          case "week":
          case "w":
            return l * i;
          case "days":
          case "day":
          case "d":
            return l * n;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return l * r;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return l * e;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return l * t;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return l;
          default:
            return;
        }
      }
    }
  }
  function s(c) {
    var d = Math.abs(c);
    return d >= n ? Math.round(c / n) + "d" : d >= r ? Math.round(c / r) + "h" : d >= e ? Math.round(c / e) + "m" : d >= t ? Math.round(c / t) + "s" : c + "ms";
  }
  function f(c) {
    var d = Math.abs(c);
    return d >= n ? u(c, d, n, "day") : d >= r ? u(c, d, r, "hour") : d >= e ? u(c, d, e, "minute") : d >= t ? u(c, d, t, "second") : c + " ms";
  }
  function u(c, d, l, h) {
    var y = d >= l * 1.5;
    return Math.round(c / l) + " " + h + (y ? "s" : "");
  }
  return f0;
}
function tU(t) {
  r.debug = r, r.default = r, r.coerce = f, r.disable = o, r.enable = i, r.enabled = a, r.humanize = eU(), r.destroy = u, Object.keys(t).forEach((c) => {
    r[c] = t[c];
  }), r.names = [], r.skips = [], r.formatters = {};
  function e(c) {
    let d = 0;
    for (let l = 0; l < c.length; l++)
      d = (d << 5) - d + c.charCodeAt(l), d |= 0;
    return r.colors[Math.abs(d) % r.colors.length];
  }
  r.selectColor = e;
  function r(c) {
    let d, l = null, h, y;
    function b(...w) {
      if (!b.enabled)
        return;
      const A = b, M = Number(/* @__PURE__ */ new Date()), N = M - (d || M);
      A.diff = N, A.prev = d, A.curr = M, d = M, w[0] = r.coerce(w[0]), typeof w[0] != "string" && w.unshift("%O");
      let G = 0;
      w[0] = w[0].replace(/%([a-zA-Z%])/g, (J, oe) => {
        if (J === "%%")
          return "%";
        G++;
        const ee = r.formatters[oe];
        if (typeof ee == "function") {
          const ae = w[G];
          J = ee.call(A, ae), w.splice(G, 1), G--;
        }
        return J;
      }), r.formatArgs.call(A, w), (A.log || r.log).apply(A, w);
    }
    return b.namespace = c, b.useColors = r.useColors(), b.color = r.selectColor(c), b.extend = n, b.destroy = r.destroy, Object.defineProperty(b, "enabled", {
      enumerable: !0,
      configurable: !1,
      get: () => l !== null ? l : (h !== r.namespaces && (h = r.namespaces, y = r.enabled(c)), y),
      set: (w) => {
        l = w;
      }
    }), typeof r.init == "function" && r.init(b), b;
  }
  function n(c, d) {
    const l = r(this.namespace + (typeof d > "u" ? ":" : d) + c);
    return l.log = this.log, l;
  }
  function i(c) {
    r.save(c), r.namespaces = c, r.names = [], r.skips = [];
    let d;
    const l = (typeof c == "string" ? c : "").split(/[\s,]+/), h = l.length;
    for (d = 0; d < h; d++)
      l[d] && (c = l[d].replace(/\*/g, ".*?"), c[0] === "-" ? r.skips.push(new RegExp("^" + c.slice(1) + "$")) : r.names.push(new RegExp("^" + c + "$")));
  }
  function o() {
    const c = [
      ...r.names.map(s),
      ...r.skips.map(s).map((d) => "-" + d)
    ].join(",");
    return r.enable(""), c;
  }
  function a(c) {
    if (c[c.length - 1] === "*")
      return !0;
    let d, l;
    for (d = 0, l = r.skips.length; d < l; d++)
      if (r.skips[d].test(c))
        return !1;
    for (d = 0, l = r.names.length; d < l; d++)
      if (r.names[d].test(c))
        return !0;
    return !1;
  }
  function s(c) {
    return c.toString().substring(2, c.toString().length - 2).replace(/\.\*\?$/, "*");
  }
  function f(c) {
    return c instanceof Error ? c.stack || c.message : c;
  }
  function u() {
    console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
  }
  return r.enable(r.load()), r;
}
var rU = tU;
(function(t, e) {
  e.formatArgs = n, e.save = i, e.load = o, e.useColors = r, e.storage = a(), e.destroy = /* @__PURE__ */ (() => {
    let f = !1;
    return () => {
      f || (f = !0, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  })(), e.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
  ];
  function r() {
    return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  function n(f) {
    if (f[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + f[0] + (this.useColors ? "%c " : " ") + "+" + t.exports.humanize(this.diff), !this.useColors)
      return;
    const u = "color: " + this.color;
    f.splice(1, 0, u, "color: inherit");
    let c = 0, d = 0;
    f[0].replace(/%[a-zA-Z%]/g, (l) => {
      l !== "%%" && (c++, l === "%c" && (d = c));
    }), f.splice(d, 0, u);
  }
  e.log = console.debug || console.log || (() => {
  });
  function i(f) {
    try {
      f ? e.storage.setItem("debug", f) : e.storage.removeItem("debug");
    } catch {
    }
  }
  function o() {
    let f;
    try {
      f = e.storage.getItem("debug");
    } catch {
    }
    return !f && typeof Ye < "u" && "env" in Ye && (f = Ye.env.DEBUG), f;
  }
  function a() {
    try {
      return localStorage;
    } catch {
    }
  }
  t.exports = rU(e);
  const { formatters: s } = t.exports;
  s.j = function(f) {
    try {
      return JSON.stringify(f);
    } catch (u) {
      return "[UnexpectedJSONParseError]: " + u.message;
    }
  };
})(np, np.exports);
var nU = np.exports;
const iU = /* @__PURE__ */ sn(nU);
var z1 = { exports: {} };
const oU = (t, e) => Math.floor(Math.random() * (e - t + 1) + t), R2 = () => {
  const t = new Error("Delay aborted");
  return t.name = "AbortError", t;
}, fu = ({ clearTimeout: t, setTimeout: e, willResolve: r }) => (n, { value: i, signal: o } = {}) => {
  if (o && o.aborted)
    return Promise.reject(R2());
  let a, s, f;
  const u = t || clearTimeout, c = () => {
    u(a), f(R2());
  }, d = () => {
    o && o.removeEventListener("abort", c);
  }, l = new Promise((h, y) => {
    s = () => {
      d(), r ? h(i) : y(i);
    }, f = y, a = (e || setTimeout)(s, n);
  });
  return o && o.addEventListener("abort", c, { once: !0 }), l.clear = () => {
    u(a), a = null, s();
  }, l;
}, Za = fu({ willResolve: !0 });
Za.reject = fu({ willResolve: !1 });
Za.range = (t, e, r) => Za(oU(t, e), r);
Za.createWithTimers = ({ clearTimeout: t, setTimeout: e }) => {
  const r = fu({ clearTimeout: t, setTimeout: e, willResolve: !0 });
  return r.reject = fu({ clearTimeout: t, setTimeout: e, willResolve: !1 }), r;
};
z1.exports = Za;
z1.exports.default = Za;
var aU = z1.exports;
const sU = /* @__PURE__ */ sn(aU);
var fU = function(t, e) {
  const r = Object.assign({ concurrency: 1 }, e).concurrency;
  if (typeof r != "number" || isNaN(r) || r <= 0)
    throw new TypeError(`Invalid concurrency value: ${r}`);
  let n = 0;
  const i = [];
  function o() {
    i.length > 0 ? i.shift().resolve() : n -= 1;
  }
  return function() {
    let a;
    return n >= r ? a = new Promise((s) => i.push({ resolve: s })) : (a = Promise.resolve(), n += 1), a.then(() => t.apply(this, arguments)).then((s) => (o(), s), (s) => {
      throw o(), s;
    });
  };
};
const cU = /* @__PURE__ */ sn(fU), uU = "wss://solana.a.exodus.io/ws", dU = ta("15s"), lU = ta("60s"), hU = ta("50s"), li = iU("exodus:solana-api");
class pU {
  constructor({
    endpoint: e = uU,
    address: r,
    tokensAddresses: n = [],
    callback: i,
    onMsg: o,
    reconnectCallback: a = () => {
    },
    reconnectDelay: s = dU
  }) {
    this.address = r, this.tokensAddresses = n, this.endpoint = e, this.callback = i, this.onMsg = o, this.reconnectCallback = a, this.reconnectDelay = s, this.shutdown = !1, this.ws = null, this.rpcQueue = {}, this.messageQueue = [], this.inProcessMessages = !1, this.pingTimeout = null, this.reconnectTimeout = null, this.txCache = {}, this.seq = 0, this.sendMessage = cU(
      async (f, u = []) => new Promise((c, d) => {
        if (this.isClosed || this.shutdown)
          return d(new Error("connection not started"));
        const l = ++this.seq;
        this.rpcQueue[l] = { resolve: c, reject: d }, this.rpcQueue[l].timeout = setTimeout(() => {
          delete this.rpcQueue[l], console.log(`solana ws: reply timeout (${f}) - ${JSON.stringify(u)} - ${l}`), c(null);
        }, hU), typeof this.rpcQueue[l].timeout.unref == "function" && this.rpcQueue[l].timeout.unref(), this.ws.send(JSON.stringify({ jsonrpc: "2.0", method: f, params: u, id: l }));
      }),
      { concurrency: 15 }
    );
  }
  newSocket(e) {
    const r = new URL(e);
    r.protocol = "wss:", e = `${r}`, li("Opening WS to:", e);
    const n = new As.WebSocket(`${e}`);
    return n.addEventListener("message", this.onMessage.bind(this)), n.addEventListener("open", this.onOpen.bind(this)), n.addEventListener("close", this.onClose.bind(this)), n.addEventListener("error", this.onError.bind(this)), n;
  }
  get isConnecting() {
    return !!(this.ws && this.ws.readyState === As.WebSocket.CONNECTING);
  }
  get isOpen() {
    return !!(this.ws && this.ws.readyState === As.WebSocket.OPEN);
  }
  get isClosing() {
    return !!(this.ws && this.ws.readyState === As.WebSocket.CLOSING);
  }
  get isClosed() {
    return !this.ws || this.ws.readyState === As.WebSocket.CLOSED;
  }
  get running() {
    return !!(!this.isClosed || this.inProcessMessages || this.messageQueue.length > 0);
  }
  get connectionState() {
    return this.isConnecting ? "CONNECTING" : this.isOpen ? "OPEN" : this.isClosing ? "CLOSING" : this.isClosed ? "CLOSED" : "NONE";
  }
  doPing() {
    this.ws && (this.ws.ping(), this.pingTimeout = setTimeout(this.doPing.bind(this), lU));
  }
  doRestart() {
    this.reconnectTimeout = setTimeout(async () => {
      try {
        li("reconnecting ws..."), this.start(), await this.reconnectCallback();
      } catch (e) {
        console.log(`Error in reconnect callback: ${e.message}`);
      }
    }, this.reconnectDelay);
  }
  onMessage(e) {
    try {
      const r = JSON.parse(e.data);
      if (li("new ws msg:", r), r.error)
        tt.get(this.rpcQueue, r.id) ? (this.rpcQueue[r.id].reject(new Error(r.error.message)), clearTimeout(this.rpcQueue[r.id].timeout), delete this.rpcQueue[r.id]) : li("Unsupported WS message:", r.error.message);
      else {
        if (tt.get(this.rpcQueue, r.id))
          clearTimeout(this.rpcQueue[r.id].timeout), this.rpcQueue[r.id].resolve(r.result), delete this.rpcQueue[r.id];
        else if (r.method) {
          const n = { method: r.method, ...tt.get(r, "params.result", r.result) };
          li("pushing msg to queue", n), this.messageQueue.push(n);
        }
        this.processMessages(r);
      }
    } catch (r) {
      li(r), li("Cannot parse msg:", e.data);
    }
  }
  onOpen(e) {
    li("Opened WS"), [...this.tokensAddresses, this.address].forEach((n) => {
      this.ws.send(
        JSON.stringify({
          jsonrpc: "2.0",
          method: "accountSubscribe",
          params: [
            n,
            {
              encoding: "jsonParsed"
            }
          ],
          id: ++this.seq
        })
      ), this.ws.send(
        JSON.stringify({
          jsonrpc: "2.0",
          method: "logsSubscribe",
          params: [{ mentions: [n] }, { commitment: "finalized" }],
          id: ++this.seq
        })
      );
    });
  }
  onError(e) {
    li("Error on WS:", e.data);
  }
  onClose(e) {
    li("Closing WS"), clearTimeout(this.pingTimeout), clearTimeout(this.reconnectTimeout), this.shutdown || this.doRestart();
  }
  async processMessages(e) {
    if (this.onMsg && await this.onMsg(e), this.inProcessMessages)
      return null;
    this.inProcessMessages = !0;
    try {
      for (; this.messageQueue.length > 0; ) {
        const r = this.messageQueue.splice(0, this.messageQueue.length);
        await this.callback(r);
      }
    } catch (r) {
      console.log(`Solana: error processing streams: ${r.message}`);
    } finally {
      this.inProcessMessages = !1;
    }
  }
  async close() {
    clearTimeout(this.reconnectTimeout), clearTimeout(this.pingTimeout), this.ws && (this.isConnecting || this.isOpen) && (await this.ws.close(), this.ws.terminate && await this.ws.terminate());
  }
  async start() {
    try {
      if (!this.isClosed || this.shutdown)
        return;
      this.ws = this.newSocket(this.endpoint);
    } catch (e) {
      console.log("Solana: error starting WS:", e), this.doRestart();
    }
  }
  async stop() {
    if (!this.shutdown)
      for (this.shutdown = !0, await this.close(); this.running; )
        await sU(ta("50ms"));
  }
}
const yU = Ov.default || Ov, bU = "https://solana.a.exodus.io", gU = "wss://solana.a.exodus.io/ws", vU = !0;
class mU {
  constructor({ rpcUrl: e, wsUrl: r, assets: n, txsLimit: i }) {
    /**
     * Broadcast a signed transaction
     */
    Le(this, "broadcastTransaction", async (e, r) => {
      console.log("Solana broadcasting TX:", e);
      const i = [e, { ...{ encoding: "base64", preflightCommitment: "confirmed" }, ...r }], o = ["Blockhash not found"];
      return Ck(
        async () => {
          try {
            const s = await this.rpcCall("sendTransaction", i, { forceHttp: !0 });
            return console.log(`tx ${JSON.stringify(s)} sent!`), s || null;
          } catch (s) {
            throw s.message && !o.some((f) => s.message.includes(f)) && (s.finalError = !0), console.warn("Error broadcasting tx. Retrying...", s), s;
          }
        },
        { delayTimesMs: ["6s", "6s", "8s", "10s"] }
      )();
    });
    Le(this, "simulateTransaction", async (e, r) => {
      const {
        value: { accounts: n, unitsConsumed: i, err: o }
      } = await this.rpcCall("simulateTransaction", [e, r]);
      return { accounts: n, unitsConsumed: i, err: o };
    });
    Le(this, "resolveSimulationSideEffects", async (e, r) => {
      const n = [], i = [], o = e.map(async (l) => {
        const h = await this.getBalance(l.address);
        return {
          name: "SOL",
          symbol: "SOL",
          balance: S2(l.amount, h),
          decimal: oN,
          type: "SOL"
        };
      }), a = (l, h) => async (...y) => {
        try {
          return await l.apply(this, y);
        } catch (b) {
          if (b.message && b.message.includes("could not find account"))
            return h;
          throw b;
        }
      }, s = a(this.getTokenBalance, "0"), f = a(this.getDecimals, 0), u = a(this.getSupply, "0"), c = r.map(async (l) => {
        try {
          const [h, y, b] = await Promise.all([
            this.getMetaplexMetadata(l.mint),
            s(l.address),
            f(l.mint)
          ]), w = h || { name: null, symbol: null };
          let A = /* @__PURE__ */ Object.create(null);
          if (b === 0 && await u(l.mint) === "1") {
            const N = l.mint;
            A = {
              id: `solana:${N}`,
              compositeId: N
            };
          }
          return {
            balance: S2(l.amount, y),
            decimal: b,
            nft: A,
            address: l.address,
            mint: l.mint,
            name: w.name,
            symbol: w.symbol,
            type: "TOKEN"
          };
        } catch (h) {
          return console.warn(h), {
            balance: null
          };
        }
      });
      return (await Promise.all([...o, ...c])).forEach((l) => {
        l.balance !== null && (l.balance > 0 ? n.push(l) : i.push(l));
      }), {
        willReceive: n,
        willSend: i
      };
    });
    Le(this, "simulateUnsignedTransaction", async ({ message: e, transactionMessage: r }) => {
      const { config: n, accountAddresses: i } = uN(
        r || e
      ), o = new Array(e.header.numRequiredSignatures || 1).fill(null), a = bN(
        Ie.from(e.serialize()),
        o
      ).toString("base64"), { accounts: s, unitsConsumed: f, err: u } = await this.simulateTransaction(a, {
        ...n,
        replaceRecentBlockhash: !0,
        sigVerify: !1
      });
      return {
        accounts: s,
        accountAddresses: i,
        unitsConsumed: f,
        err: u
      };
    });
    /**
     * Simulate transaction and return side effects
     */
    Le(this, "simulateAndRetrieveSideEffects", async (e, r, n) => {
      const { accounts: i, accountAddresses: o } = await this.simulateUnsignedTransaction({
        message: e,
        transactionMessage: n
      }), { solAccounts: a, tokenAccounts: s } = lN(
        i,
        o,
        r
      );
      return this.resolveSimulationSideEffects(a, s);
    });
    this.setServer(e), this.setWsEndpoint(r), this.setTokens(n), this.tokensToSkip = {}, this.txsLimit = i, this.connections = {}, this.getSupply = tt.memoize(async (o) => {
      const a = await this.rpcCall("getTokenSupply", [o]);
      return tt.get(a, "value.amount");
    });
  }
  setServer(e) {
    this.rpcUrl = e || bU, this.api = yU(this.rpcUrl);
  }
  setWsEndpoint(e) {
    this.wsUrl = e || gU;
  }
  setTokens(e = {}) {
    const r = tt.pickBy(e, (n) => n.assetType === "SOLANA_TOKEN");
    this.tokens = new Map(Object.values(r).map((n) => [n.mintAddress, n]));
  }
  request(e, r = "application/json") {
    return k1(WN(this.rpcUrl, e)).headers({
      "Content-Type": r
    });
  }
  async watchAddress({
    address: e,
    tokensAddresses: r = [],
    onMessage: n,
    handleAccounts: i,
    handleTransfers: o,
    handleReconnect: a,
    reconnectDelay: s
  }) {
    if (this.connections[e])
      return;
    const f = new pU({
      endpoint: this.wsUrl,
      address: e,
      tokensAddresses: r,
      onMsg: (u) => n(u),
      callback: (u) => this.handleUpdates({ updates: u, address: e, handleAccounts: i, handleTransfers: o }),
      reconnectCallback: a,
      reconnectDelay: s
    });
    return this.connections[e] = f, f.start();
  }
  async unwatchAddress({ address: e }) {
    this.connections[e] && (await this.connections[e].stop(), delete this.connections[e]);
  }
  async handleUpdates({ updates: e, address: r, handleAccounts: n, handleTransfers: i }) {
    if (i)
      return i(e);
  }
  async rpcCall(e, r = [], { address: n = "", forceHttp: i = vU } = {}) {
    const o = this.connections[n] || tt.sample(Object.values(this.connections));
    return tt.get(o, "isOpen") && !tt.get(o, "shutdown") && !i ? o.sendMessage(e, r) : this.api.post({ method: e, params: r });
  }
  getTokenByAddress(e) {
    return this.tokens.get(e);
  }
  isTokenSupported(e) {
    return this.tokens.has(e);
  }
  async getEpochInfo() {
    const { epoch: e } = await this.rpcCall("getEpochInfo");
    return Number(e);
  }
  async getStakeActivation(e) {
    const { state: r } = await this.rpcCall("getStakeActivation", [e]);
    return r;
  }
  async getRecentBlockHash(e) {
    const r = await this.rpcCall(
      "getLatestBlockhash",
      [{ commitment: e || "finalized", encoding: "jsonParsed" }],
      { forceHttp: !0 }
    );
    return tt.get(r, "value.blockhash");
  }
  // Transaction structure: https://docs.solana.com/apps/jsonrpc-api#transaction-structure
  async getTransactionById(e) {
    return this.rpcCall("getTransaction", [
      e,
      { encoding: "jsonParsed", maxSupportedTransactionVersion: 0 }
    ]);
  }
  async getFee() {
    const e = await this.rpcCall("getRecentBlockhash", [
      { commitment: "finalized", encoding: "jsonParsed" }
    ]);
    return tt.get(e, "value.feeCalculator.lamportsPerSignature");
  }
  async getPriorityFee(e) {
    return (await this.rpcCall("getPriorityFeeEstimate", [
      { transaction: e, options: { recommended: !0 } }
    ])).priorityFeeEstimate;
  }
  async getBalance(e) {
    const r = await this.rpcCall("getBalance", [e, { encoding: "jsonParsed" }], {
      address: e
    });
    return tt.get(r, "value", 0);
  }
  async getBlockTime(e) {
    return this.rpcCall("getBlockTime", [e]);
  }
  async getConfirmedSignaturesForAddress(e, { until: r, before: n, limit: i } = {}) {
    return r = r || void 0, this.rpcCall("getSignaturesForAddress", [e, { until: r, before: n, limit: i }], { address: e });
  }
  /**
   * Get transactions from an address
   */
  async getTransactions(e, { cursor: r, before: n, limit: i, includeUnparsed: o = !1 } = {}) {
    i = i || this.txsLimit;
    let a = [];
    try {
      const f = r, u = await this.getTokenAccountsByOwner(e), c = u.filter(({ tokenName: b }) => b !== "unknown").map(({ tokenAccountAddress: b }) => b), d = [e, ...c];
      let h = (await Promise.all(
        d.map(
          (b) => this.getConfirmedSignaturesForAddress(b, {
            until: f,
            before: n,
            limit: i
          })
        )
      )).flat();
      h = tt.uniqBy(h, "signature"), (await Promise.all(h.map((b) => this.getTransactionById(b.signature)))).forEach((b) => {
        if (!b)
          return;
        const w = b.blockTime * 1e3, A = this.parseTransaction(e, b, u, {
          includeUnparsed: o
        });
        !A.from && !o || (A.dexTxs && (A.dexTxs.forEach((M) => {
          a.push({
            timestamp: w,
            date: new Date(w),
            ...M
          });
        }), delete A.dexTxs), a.push({
          timestamp: w,
          date: new Date(w),
          ...A
        }));
      });
    } catch (f) {
      throw console.warn("Solana error:", f), f;
    }
    a = tt.orderBy(a, ["timestamp"], ["desc"]);
    const s = a[0] ? a[0].id : r;
    return { transactions: a, newCursor: s };
  }
  parseTransaction(e, r, n, { includeUnparsed: i = !1 } = {}) {
    var oe;
    let { fee: o, preBalances: a, postBalances: s, preTokenBalances: f, postTokenBalances: u, innerInstructions: c } = r.meta;
    a = a || [], s = s || [], f = f || [], u = u || [], c = c || [];
    let { instructions: d, accountKeys: l } = r.transaction.message;
    const h = () => {
      const ee = l.findIndex((ye) => ye.pubkey === e), ae = ee === 0 ? o : 0;
      return {
        unparsed: !0,
        amount: ee === -1 ? 0 : s[ee] - a[ee] + ae,
        fee: ae,
        data: {
          meta: r.meta
        }
      };
    }, y = () => {
      const ee = f.filter(
        (ye) => ye.owner === e
      );
      return u.filter(
        (ye) => ye.owner === e
      ).map((ye) => {
        const pe = n.find(
          (j) => j.mintAddress === ye.mint
        ), te = ee.find(
          (j) => j.accountIndex === ye.accountIndex
        ), F = new Ni(tt.get(te, "uiTokenAmount.amount", "0"), 10), B = new Ni(tt.get(ye, "uiTokenAmount.amount", "0"), 10).sub(F);
        if (!pe || B.isZero())
          return null;
        const P = c.find((j) => {
          const k = B.isNeg() ? e : null;
          return j.token.mintAddress === pe.mintAddress && k === j.owner;
        });
        if (!P)
          return null;
        const { from: L, to: x, owner: C } = P;
        return {
          id: r.transaction.signatures[0],
          slot: r.slot,
          owner: C,
          from: L,
          to: x,
          amount: B.abs().toString(),
          // inconsistent with the rest, but it can and did overflow
          fee: 0,
          token: pe,
          data: {
            inner: !0
          }
        };
      }).filter((ye) => !!ye);
    };
    d = d.filter((ee) => ee.parsed).map((ee) => ({
      program: ee.program,
      // system or spl-token
      type: ee.parsed.type,
      // transfer, createAccount, initializeAccount
      ...ee.parsed.info
    }));
    let b = tt.find(d, (ee) => [ee.source, ee.destination].includes(e) ? ee.program === "system" && ee.type === "transfer" : !1);
    const w = b || (oe = d.find(
      ({ type: ee, owner: ae, destination: ye }) => ee === "closeAccount" && ae === e && ye === e
    )) == null ? void 0 : oe.account;
    c = c.reduce((ee, ae) => [...ee, ...ae.instructions], []).map((ee) => {
      const ae = tt.get(ee, "parsed.type");
      if (!(ee.parsed && ee.program === "spl-token" && ["transfer", "transferChecked", "transferCheckedWithFee"].includes(ae)))
        return null;
      const pe = tt.get(ee, "parsed.info.source"), te = tt.get(ee, "parsed.info.destination"), F = Number(
        tt.get(ee, "parsed.info.amount", 0) || tt.get(ee, "parsed.info.tokenAmount.amount", 0)
      ), v = r.transaction.signatures[0];
      if (w && te === w) {
        const x = (C) => C && C === w ? e : C;
        b = {
          id: v,
          from: x(pe),
          to: x(te),
          amount: F,
          fee: o
        };
        return;
      }
      const B = n.find(({ tokenAccountAddress: x }) => [pe, te].includes(x));
      if (!B)
        return;
      const P = n.some(({ tokenAccountAddress: x }) => [pe].includes(x)), L = {
        id: v,
        slot: r.slot,
        owner: P ? e : null,
        from: pe,
        to: te,
        amount: F,
        token: B,
        fee: P ? o : 0
      };
      return B ? L : null;
    }).filter((ee) => !!ee);
    const A = tt.find(d, { program: "system", type: "createAccountWithSeed" }), M = tt.find(d, { program: "stake", type: "withdraw" }), N = tt.find(d, { program: "stake", type: "deactivate" }), G = b && f.length === 0 && u.length === 0;
    let z = {};
    if (G) {
      const ee = e === b.source;
      z = {
        owner: b.source,
        from: b.source,
        to: b.destination,
        amount: b.lamports,
        // number
        fee: ee ? o : 0
      };
    } else if (A)
      z = {
        owner: A.base,
        from: A.base,
        to: A.base,
        amount: A.lamports,
        fee: o,
        staking: {
          method: "createAccountWithSeed",
          seed: A.seed,
          stakeAddresses: [A.newAccount],
          stake: A.lamports
        }
      };
    else if (M) {
      const ee = tt.map(
        tt.filter(d, { program: "stake", type: "withdraw" }),
        "stakeAccount"
      );
      z = {
        owner: M.withdrawAuthority,
        from: M.stakeAccount,
        to: M.destination,
        amount: M.lamports,
        fee: o,
        staking: {
          method: "withdraw",
          stakeAddresses: ee,
          stake: M.lamports
        }
      };
    } else if (N) {
      const ee = tt.map(
        tt.filter(d, { program: "stake", type: "deactivate" }),
        "stakeAccount"
      );
      z = {
        owner: N.stakeAuthority,
        from: N.stakeAuthority,
        to: N.stakeAccount,
        // obsolete
        amount: 0,
        fee: o,
        staking: {
          method: "undelegate",
          stakeAddresses: ee
        }
      };
    } else {
      $e(
        Array.isArray(n),
        "tokenAccountsByOwner is required when parsing token tx"
      );
      const ee = tt.filter(d, ({ program: ae, type: ye }) => ae === "spl-token" && ["transfer", "transferChecked", "transferCheckedWithFee"].includes(ye)).map((ae) => {
        let ye = tt.find(n, { tokenAccountAddress: ae.source });
        const pe = !!ye;
        if (pe || (ye = tt.find(n, {
          tokenAccountAddress: ae.destination
        })), !ye)
          return null;
        const te = pe ? e : null;
        return delete ye.balance, delete ye.owner, {
          owner: te,
          token: ye,
          from: ae.source,
          to: ae.destination,
          amount: Number(ae.amount || tt.get(ae, "tokenAmount.amount", 0)),
          // supporting types: transfer, transferChecked, transferCheckedWithFee
          fee: pe ? o : 0
          // in lamports
        };
      });
      if (ee.length > 0)
        z = ee.reduce((ae, ye) => ye ? ae.token ? (ae.token.ticker === ye.token.ticker && (ae.amount += ye.amount), ae) : ye : ae, {});
      else if (f && u) {
        const ae = tt.mapKeys(l, (te, F) => F);
        Object.values(ae).forEach((te) => {
          const F = !!tt.find(n, {
            tokenAccountAddress: te.pubkey
          });
          te.owner = F ? e : null;
        });
        const ye = f.filter((te) => ae[te.accountIndex].owner === e && this.isTokenSupported(te.mint)), pe = u.filter((te) => ae[te.accountIndex].owner === e && this.isTokenSupported(te.mint));
        (ye.length > 0 || pe.length > 0 || b) && (z = {}, i && c.length > 0 ? (z = h(), z.dexTxs = y()) : (b && (z = b.from && b.to ? b : {
          owner: b.source,
          from: b.source,
          to: b.destination,
          amount: b.lamports,
          // number
          fee: e === b.source ? o : 0
        }), c.length > 0 && (z.dexTxs = c, !z.from && !b && (z = z.dexTxs[0], z.dexTxs = c.slice(1)))));
      }
    }
    return Object.keys(z).length === 0 && i && (z = h()), {
      id: r.transaction.signatures[0],
      slot: r.slot,
      error: r.meta.err !== null,
      ...z
    };
  }
  async getWalletTokensList({ tokenAccounts: e }) {
    const r = [];
    for (const n of e) {
      const i = n.mintAddress;
      if (!this.tokensToSkip[i] && n.balance !== "0") {
        if (!this.tokens.has(i) && await this.getSupply(i) === "1") {
          this.tokensToSkip[i] = !0;
          continue;
        }
        r.push(i);
      }
    }
    return r;
  }
  async getTokenAccountsByOwner(e, r) {
    const [{ value: n }, { value: i }] = await Promise.all([
      this.rpcCall(
        "getTokenAccountsByOwner",
        [e, { programId: i0.toBase58() }, { encoding: "jsonParsed" }],
        { address: e }
      ),
      this.rpcCall(
        "getTokenAccountsByOwner",
        [e, { programId: fc.toBase58() }, { encoding: "jsonParsed" }],
        { address: e }
      )
    ]), o = [...n, ...i], a = [];
    for (const s of o) {
      const { pubkey: f, account: u } = s, c = tt.get(u, "data.parsed.info.mint"), d = this.getTokenByAddress(c) || {
        name: "unknown",
        ticker: "UNKNOWN",
        decimals: 0
      }, l = tt.get(u, "data.parsed.info.tokenAmount.amount", "0"), h = tt.get(u, "owner", null), { feeBasisPoints: y = 0, maximumFee: b = 0 } = h === fc.toBase58() ? await this.getTokenFeeBasisPoints(c) : {};
      a.push({
        tokenAccountAddress: f,
        owner: e,
        tokenName: d.name,
        ticker: d.ticker,
        balance: l,
        mintAddress: c,
        tokenProgram: h,
        decimals: d.decimals,
        feeBasisPoints: y,
        maximumFee: b
      });
    }
    return r ? a.filter(({ ticker: s }) => s === r) : a;
  }
  async getTokensBalance({ address: e, filterByTokens: r = [], tokenAccounts: n }) {
    return (n || await this.getTokenAccountsByOwner(e)).reduce((o, { tokenName: a, balance: s }) => (a === "unknown" || r.length > 0 && !r.includes(a) || (o[a] ? o[a] += Number(s) : o[a] = Number(s)), o), {});
  }
  async isAssociatedTokenAccountActive(e) {
    try {
      return await this.rpcCall("getTokenAccountBalance", [e]), !0;
    } catch {
      return !1;
    }
  }
  // Returns account balance of a SPL Token account.
  async getTokenBalance(e) {
    const r = await this.rpcCall("getTokenAccountBalance", [e]);
    return tt.get(r, "value.amount");
  }
  async getAccountInfo(e, r = "jsonParsed") {
    const { value: n } = await this.rpcCall(
      "getAccountInfo",
      [e, { encoding: r, commitment: "single" }],
      { address: e }
    );
    return n;
  }
  async isSpl(e) {
    const { owner: r } = await this.getAccountInfo(e);
    return [i0.toBase58(), fc.toBase58()].includes(r);
  }
  async getTokenFeeBasisPoints(e) {
    const r = await this.getAccountInfo(e), { transferFeeBasisPoints: n, maximumFee: i } = tt.get(
      r,
      "data.parsed.info.extensions[0].state.newerTransferFee",
      { transferFeeBasisPoints: 0, maximumFee: 0 }
    );
    return { feeBasisPoints: n, maximumFee: i };
  }
  async getMetaplexMetadata(e) {
    const r = sN(e), n = await this.getAccountInfo(r, "base64"), i = tt.get(n, "data[0]");
    return i ? fN(Ie.from(i, "base64")) : null;
  }
  async getDecimals(e) {
    const r = await this.rpcCall("getTokenSupply", [e]);
    return tt.get(r, "value.decimals", null);
  }
  async getAddressType(e) {
    const r = await this.getAccountInfo(e);
    if (r === null)
      return null;
    const n = {
      executable: r.executable,
      owner: r.owner,
      lamports: r.lamports
    };
    return n.owner === rN.toBase58() ? "solana" : n.owner === i0.toBase58() ? "token" : n.owner === fc.toBase58() ? "token-2022" : null;
  }
  async getTokenAddressOwner(e) {
    const r = await this.getAccountInfo(e);
    return tt.get(r, "data.parsed.info.owner", null);
  }
  async getAddressMint(e) {
    const r = await this.getAccountInfo(e);
    return tt.get(r, "data.parsed.info.mint", null);
  }
  async isTokenAddress(e) {
    const r = await this.getAddressType(e);
    return ["token", "token-2022"].includes(r);
  }
  async isSOLaddress(e) {
    return await this.getAddressType(e) === "solana";
  }
  async getStakeAccountsInfo(e) {
    const r = [
      nN.toBase58(),
      {
        filters: [
          {
            memcmp: {
              offset: 12,
              bytes: e
            }
          }
        ],
        encoding: "jsonParsed"
      }
    ], n = await this.rpcCall("getProgramAccounts", r, { address: e }), i = {};
    let o = 0, a = 0, s = 0, f = 0, u = 0;
    for (const c of n) {
      const d = c.pubkey, l = tt.get(c, "account.lamports", 0), h = tt.get(c, "account.data.parsed.info.stake.delegation", {});
      i[d] = h, i[d].lamports = l, i[d].activationEpoch = Number(i[d].activationEpoch) || 0, i[d].deactivationEpoch = Number(i[d].deactivationEpoch) || 0;
      let y = "inactive";
      h.activationEpoch && (y = await this.getStakeActivation(d)), i[d].state = y, i[d].isDeactivating = y === "deactivating", i[d].canWithdraw = y === "inactive", i[d].stake = Number(i[d].stake) || 0, o += i[d].stake, a += ["active", "activating"].includes(i[d].state) ? l : 0, s += i[d].state === "activating" ? l : 0, f += i[d].canWithdraw ? l : 0, u += i[d].isDeactivating ? l : 0;
    }
    return { accounts: i, totalStake: o, locked: a, withdrawable: f, pending: u, activating: s };
  }
  async getRewards(e = []) {
    if (e.length === 0)
      return 0;
    const r = await this.request("rewards").post({ addresses: e }).error(500, () => ({})).error(400, () => ({})).json();
    return Object.values(r).reduce((n, i) => n + i, 0);
  }
  async getMinimumBalanceForRentExemption(e) {
    return this.rpcCall("getMinimumBalanceForRentExemption", [e]);
  }
  async getProgramAccounts(e, r) {
    return this.rpcCall("getProgramAccounts", [e, r]);
  }
  async getMultipleAccounts(e, r) {
    const n = await this.rpcCall("getMultipleAccounts", [e, r]);
    return n && n.value ? n.value : [];
  }
  async getFeeForMessage(e, r) {
    const n = await this.rpcCall("getFeeForMessage", [
      Ie.from(e.serialize()).toString("base64"),
      { commitment: r }
    ]);
    return tt.get(n, "value");
  }
}
function wU(t) {
  return t.pathArray[0] === 2;
}
function xU(t) {
  return t.pathArray[0] === 1;
}
function _U(t) {
  return t.pathArray[0] === 0;
}
const EU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isChangeAddress: xU,
  isExchangeAddress: wU,
  isReceiveAddress: _U
}, Symbol.toStringTag, { value: "Module" })), _a = class _a {
  constructor(e, r) {
    Le(this, "address");
    Le(this, "meta");
    this.address = e, this.meta = r || {};
  }
  static create(e, r) {
    return Object.freeze(new _a(e, r));
  }
  static fromJSON(e) {
    return typeof e == "string" && (e = JSON.parse(e)), _a.create(e.address, e.meta || e.path);
  }
  get pathArray() {
    return EN.fromString(this.meta.path || "m/0/0").toPathArray();
  }
  toJSON() {
    return {
      address: this.address,
      meta: this.meta
    };
  }
  // $FlowFixMe
  toString() {
    return this.address;
  }
  // $FlowFixMe
  get [Symbol.toStringTag]() {
    return this.address;
  }
  static isAddress(e) {
    return typeof e == "object" && (e instanceof _a || "address" in e && "meta" in e);
  }
};
Le(_a, "util", EU);
let mi = _a;
const h4 = {
  construct: (t, e) => new Proxy(new t(...e), h4),
  set: (t, e, r) => {
    const n = `Trying to set value of property (${e}) of frozen object.`;
    typeof Ye > "u" ? (console.warn.bind(console) || console.error.bind(console) || console.log.bind(console))(n) : Ye.emitWarning(n, "ProxyFreezeWarning");
  }
};
function SU(t) {
  if (typeof t != "function" && typeof t != "object")
    throw new Error("proxyFreeze only supports constructor functions or objects.");
  return new Proxy(t, h4);
}
var AU = SU;
const p4 = /* @__PURE__ */ sn(AU), hi = class hi {
  constructor() {
    Le(this, "_data");
    this._data = /* @__PURE__ */ new Map();
  }
  static fromArray(e) {
    const r = e.map((i) => {
      if (typeof i == "string")
        return mi.create(i);
      if (typeof i == "object")
        return mi.fromJSON(i);
      if (i instanceof mi)
        return i;
      throw console.dir(i), new Error("AddressSet#fromArray(): unknown type");
    }), n = new hi();
    for (const i of r)
      n._data.set(i.address, i);
    return n;
  }
  // TODO: bug if address like
  add(e) {
    $e(mi.isAddress(e), "Must be an instance of an Address.");
    const r = new hi();
    return r._data = new Map(this._data), r._data.set(e.address, e), r;
  }
  delete(e) {
    return this.remove(e);
  }
  get(e) {
    return this._data.get(String(e));
  }
  has(e) {
    return !!this._data.get(String(e));
  }
  // TODO: should deprecate and use 'delete()' to be consistent Set and Map interface
  remove(e) {
    const r = this.get(e);
    if (!r)
      return this;
    const n = new hi();
    return n._data = new Map(this._data), n._data.delete(r.address), n;
  }
  sort(e) {
    let r = [...this];
    return r = r.sort(e), hi.fromArray(r);
  }
  toArray() {
    return [...this._data.values()];
  }
  toAddressStrings() {
    return [...this._data.keys()];
  }
  // $FlowFixMe
  toString() {
    return [...this._data.keys()].join(", ");
  }
  union(e) {
    const r = [...this], n = [...e], i = [...r, ...n];
    return hi.fromArray(i);
  }
  // $FlowFixMe
  [Symbol.iterator]() {
    return this._data.values();
  }
  get size() {
    return this._data.size;
  }
};
Le(hi, "EMPTY", hi.fromArray([])), Le(hi, "PATH_SORTER", (e, r) => {
  const n = e.pathArray, i = r.pathArray;
  if (n[0] < i[0])
    return -1;
  if (n[0] > i[0])
    return 1;
  if (n[0] === i[0])
    return n[1] < i[1] ? -1 : n[1] > i[1] ? 1 : 0;
});
let ri = hi;
const { mapValues: IU, uniqBy: RL, isEmpty: TL, isArray: OL } = tt, BU = (t) => IU(t.units, (e) => e.power), { isEqual: T2, isEmpty: MU, isString: RU, merge: TU, omit: OU, mapValues: O2 } = tt, k2 = Symbol("Tx");
class Uo {
  constructor({ json: e, initSymbol: r }) {
    const {
      txId: n,
      error: i,
      date: o,
      confirmations: a,
      dropped: s,
      coinAmount: f,
      coinName: u,
      feeAmount: c,
      feeCoinName: d,
      selfSend: l,
      from: h,
      to: y,
      meta: b,
      data: w,
      tokens: A,
      token: M,
      // legacy
      addresses: N,
      currencies: G
    } = e;
    $e(r === k2, "Tx: please use Tx.fromJSON()."), $e(!MU(G), "Tx: `currencies` is required"), $e(!h || Array.isArray(h), "Tx: `from` has to be an array."), $e(!y || RU(y), "Tx: `to` has to be a string."), $e(!A || Array.isArray(A), "Tx: `tokens` has to be an array."), $e(
      !N || Array.isArray(N) || N instanceof ri,
      "Tx: unknown `addresses` type"
    ), $e(!f || u, "Tx: `coinName` is required with `coinAmount`"), $e(!c || d, "Tx: `feeCoinName` is required with `feeAmount`"), this.currencies = O2(
      G,
      (z) => z instanceof xi ? z : xi.create(z)
    ), this.txId = n, this.error = i || null, this.date = o ? new Date(o) : /* @__PURE__ */ new Date(), this.confirmations = typeof a == "number" ? a : -1, s !== void 0 && (this.dropped = !!s && this.confirmations <= 0), f && ($e(this.currencies[u], `Tx: currency for ${u} missing`), this.coinAmount = C2(f, this.currencies[u]), this.coinName = u), c && ($e(this.currencies[d], `Tx: currency for ${d} missing`), this.feeAmount = C2(c, this.currencies[d]), this.feeCoinName = d), this.selfSend = l || !1, this.from = h || [], y && (this.to = y), this.tokens = A || (M ? [M] : []), this.data = w || {}, this.meta = b ? { ...b } : {}, this.addresses = Array.isArray(N) ? ri.fromArray(N) : N instanceof ri ? N : ri.EMPTY, this.version = 1;
  }
  static fromJSON(e) {
    const r = typeof e == "string" ? JSON.parse(e) : e, n = new Uo({ json: r, initSymbol: k2 });
    return p4(n);
  }
  clone() {
    return Uo.fromJSON(this);
  }
  equals(e) {
    return this === e || T2(this.toJSON(), e.toJSON());
  }
  /*
  inspect(): string {
    if (this.coinAmount)
      return `<Tx ${this.txId.slice(0, 6)}... ${this.date.toISOString()} ${this.coinAmount.toString()} >`
    else return `<Tx ${this.txId.slice(0, 6)}... ${this.date.toISOString()} >`
  }
  */
  toJSON() {
    const e = { ...this };
    return this.coinAmount && (e.coinAmount = this.coinAmount.toDefaultString({ unit: !0 })), this.feeAmount && (e.feeAmount = this.feeAmount.toDefaultString({ unit: !0 })), e.date = e.date.toISOString(), this.addresses && (e.addresses = [...this.addresses].map((r) => r.toJSON()), e.addresses.length === 0 && delete e.addresses), e.selfSend || delete e.selfSend, e.from.length === 0 && delete e.from, Object.keys(e.data).length === 0 && delete e.data, e.error || delete e.error, Object.keys(e.meta).length === 0 && delete e.meta, e.tokens.length === 0 && delete e.tokens, e.currencies = O2(this.currencies, BU), e;
  }
  toString() {
    return String(this.txId);
  }
  update(e) {
    const r = this.toJSON();
    return e = OU(e, ["version"]), Object.keys(e).every((i) => T2(r[i], e[i])) ? this : Uo.fromJSON(TU({}, r, e));
  }
  get accepted() {
    return (this.received || this.sent && this.confirmations >= 0) && !this.dropped;
  }
  get confirmed() {
    return this.confirmations > 0;
  }
  get pending() {
    return this.confirmations <= 0 && !this.dropped;
  }
  get failed() {
    return this.error || this.dropped;
  }
  get sent() {
    return !!(this.coinAmount.isNegative || this.to || this.selfSend);
  }
  get received() {
    return !this.sent;
  }
  // Legacy; previously each TX could only have one corresponding token
  get token() {
    return this.tokens[0] || null;
  }
}
function C2(t, e) {
  return $e(e instanceof xi, "Currency must be an instance of UnitType"), zo(t) ? t : e.parse(typeof t == "string" ? t : t.value + " " + t.unit);
}
const { differenceBy: kU, groupBy: CU, isEqual: PU, sortBy: Is, uniq: NU, uniqBy: UU } = tt;
var sL;
const Ar = class Ar {
  // never call with 'new' outside of this class
  constructor({ currency: e } = {}) {
    Le(this, sL, function* () {
      const r = this.toArray();
      for (const n of r)
        yield n;
    });
    this.currency = e, this._data = null;
  }
  static createEmpty(e) {
    return Ar.fromArray([], e);
  }
  static fromArray(e, { addressMap: r, ...n } = {}) {
    const i = n.currency || FU(e);
    i == null && e == null ? console.warn("UtxoCollection.fromArray(): both currency and utxoArray are null.") : i == null && e.length === 0 && console.warn("UtxoCollection.fromArray(): currency is null and utxoArray has zero items."), e = UU(e, (s) => `${s.txId}:${s.vout}`);
    const o = e.map((s) => ($e(s.address, "utxo.address must be provided"), $e(
      s.address instanceof mi || r,
      "Must pass addressMap if utxo.address is not of type Address"
    ), s.address = s.address instanceof mi ? s.address : r[s.address], {
      ...s,
      value: zo(s.value) ? s.value : i.parse(s.value)
    }));
    var a = new Ar({ currency: i });
    return a._data = Object.freeze(CU(o, (s) => s.address.toString())), a;
  }
  static fromJSON(e, { currency: r }) {
    typeof e == "string" && (e = JSON.parse(e));
    const n = {};
    Object.keys(e).forEach((o) => {
      const a = new mi(e[o].address, { path: e[o].path }), s = Is(
        e[o].utxos,
        (f) => r.parse(f.value).toDefaultNumber()
      );
      n[o] = s.map((f) => ({
        ...f,
        address: a,
        value: r.parse(f.value)
      }));
    });
    const i = new Ar({ currency: r });
    return i._data = Object.freeze(n), i;
  }
  clone() {
    return Ar.fromArray(this.toArray(), { ...this });
  }
  equals(e) {
    return PU(this.toJSON(), e.toJSON());
  }
  // TODO: decide, compliment or symmetric difference
  // i.e => (A - B) or... (A - B) U (B - A) therefore, you could call A.difference(B) or
  // B.difference(A)
  // current implementation does A - B
  difference(e) {
    const r = (a) => {
      const s = {};
      return a.toArray().forEach((f) => {
        const u = `${f.txId}/${f.vout}`;
        s[u] = f;
      }), s;
    }, n = r(this), i = r(e), o = [];
    return Object.keys(n).forEach((a) => {
      i[a] || o.push(n[a]);
    }), Ar.fromArray(o, { ...this });
  }
  getAddressUtxos(e) {
    return $e(e.toString() in this._data, `${e} is not present in this UTXO collection`), Ar.fromArray(this._data[e], { ...this });
  }
  getTxIdUtxos(e) {
    var r = this.toArray().filter((n) => n.txId === e);
    return Ar.fromArray(r, { ...this });
  }
  getAddressesForTxId(e) {
    const n = this.toArray().filter((i) => i.txId === e).map((i) => i.address);
    return ri.fromArray(n);
  }
  // TODO: deprecate
  getAddressPathsMap() {
    return [...this.addresses].reduce((e, r) => Object.assign(e, { [r.toString()]: r.meta.path }), {});
  }
  hasAddressUtxos(e) {
    return String(e) in this._data;
  }
  inspect() {
    return `<UtxoCollection size: ${this.size}, value: ${this.value.toString()}>`;
  }
  isEmpty() {
    return this._data == null || Object.keys(this._data).length === 0;
  }
  // any utxos associated with an address replace current address utxos
  // the use case is from checking a blockchain API
  // future use case: SPV and then would need to merge individual utxos
  merge(e) {
    let r = this;
    for (const n of e.addresses)
      r = r.setAddressUtxos(n, e.getAddressUtxos(n));
    return r;
  }
  removeAddressUtxos(e) {
    const r = { ...this._data };
    delete r[e.toString()];
    const n = new Ar({ ...this });
    return n._data = Object.freeze(r), n;
  }
  // NOTE: dust checking is not handled here, it's handled
  // TODO: this algorithm is very naive right now. May want to consider optimizations akin to CS Knapsack Problem
  select(e, r) {
    const n = Ar.createEmpty({ currency: this.currency });
    if (e.gt(this.value))
      return [n, this.clone()];
    const i = (u, c) => {
      let d = n, l = n;
      if (u.size === 0)
        return [d, l];
      const h = c.defaultUnit.unitName === "BTC" ? Is(
        u.toArray(),
        (A) => !A.confirmations,
        (A) => A.value.toDefaultNumber()
      ) : Is(u.toArray(), (A) => A.value.toDefaultNumber()), y = [];
      let w = h[0].value.unitType.ZERO;
      for (const A of h)
        if (y.push(A), w = w.add(A.value), w.gte(c))
          return d = Ar.fromArray(y, { ...this }), l = u.difference(d), [d, l];
      return d = Ar.fromArray(y, { ...this }), l = u.difference(d), [d, l];
    };
    let [o, a] = i(this, e);
    const s = r({ inputs: o }), f = e.add(s);
    if (f.gt(o.value))
      if (f.lte(this.value)) {
        const u = r({ inputs: a });
        if (f.add(u).gte(this.value))
          return [this, n];
        const [d, l] = i(a, s.add(u));
        a = l, o = o.union(d);
      } else
        return [n, this];
    return [o, a];
  }
  updateConfirmations(e) {
    return Ar.fromArray(
      this.toArray().map((r) => {
        const n = e.find((i) => i.txId === r.txId);
        return n && (r.confirmations = n.confirmations), r;
      }),
      { ...this }
    );
  }
  addUtxo(e, r) {
    return Ar.fromArray([...this.toArray(), e], { addressMap: r });
  }
  setAddressUtxos(e, r, { addressMap: n } = {}) {
    if (Array.isArray(r))
      return r.length === 0 ? this.removeAddressUtxos(e) : Ar.fromArray(r, { ...this, addressMap: n });
    if ($e(r instanceof Ar, "utxos must be an Array or UtxoCollection"), r.size === 0)
      return this.removeAddressUtxos(e);
    const i = { ...this._data, [e.toString()]: r.toArray() }, o = new Ar({ ...this });
    return o._data = Object.freeze(i), o;
  }
  toArray() {
    return Object.values(this._data).flat();
  }
  toPriorityOrderedArray(e = !1) {
    return Is(
      this.toArray(),
      (r) => !r.confirmations && r.rbfEnabled,
      (r) => !r.confirmations,
      (r) => r.value.toDefaultNumber() * (e ? -1 : 1)
    );
  }
  toJSON() {
    const e = {};
    return [...this.addresses].forEach((r) => {
      const n = r.toString(), i = Is(this._data[n], (o) => o.value.toDefaultNumber());
      e[n] = {
        address: n,
        path: r.meta.path,
        utxos: i.map((o) => (o = { ...o, value: o.value.toString() }, delete o.address, o))
      };
    }), e;
  }
  // does not overwrite exiting data
  union(e) {
    const r = this.toArray(), n = e.toArray();
    return Ar.fromArray([...r, ...n], { ...this });
  }
  // does not overwrite exiting data
  filter(e) {
    return Ar.fromArray(this.toArray().filter(e), { ...this });
  }
  // overwrite existing data
  unionOverwrite(e) {
    const r = this.toArray(), n = e.toArray(), o = [...kU(r, n, (a) => `${a.txId}:${a.vout}`), ...n];
    return Ar.fromArray(o, { ...this });
  }
  get addresses() {
    if (this._addresses)
      return this._addresses;
    const e = [];
    return Object.entries(this._data).forEach(([r, n]) => {
      Array.isArray(n) && n.length !== 0 && e.push(n[0].address || mi.create(r));
    }), e.length === 0 ? (this._addresses = ri.EMPTY, this._addresses) : (e.sort(ri.PATH_SORTER), this._addresses = ri.fromArray(e), this._addresses);
  }
  // TODO: DEPRECATE
  get empty() {
    return this._data == null || Object.keys(this._data).length === 0;
  }
  get size() {
    return typeof this._size == "number" ? this._size : (this._size = this.toArray().length, this._size);
  }
  get txIds() {
    return NU(this.toArray().map((e) => e.txId));
  }
  get value() {
    return this._value ? this._value : (this._value = this.toArray().reduce((e, r) => e.add(r.value), this.currency.ZERO), this._value);
  }
};
sL = Symbol.iterator;
let cu = Ar;
function FU(t) {
  if (Array.isArray(t)) {
    for (const e of t)
      if (typeof e.value == "object" && e.value.unitType)
        return e.value.unitType;
  }
}
function LU(t) {
  return [...t].sort((e, r) => {
    if (!y4(e.date, r.date))
      throw new TypeError("TxSet.util.sortByAsc() objects must be Dates or numbers");
    return e.date - r.date;
  });
}
function jU(t) {
  return [...t].sort((e, r) => {
    if (!y4(e.date, r.date))
      throw new TypeError("TxSet.util.sortByAsc() objects must be Dates or numbers");
    return r.date - e.date;
  });
}
function y4(t, e) {
  return t instanceof Date && e instanceof Date || typeof t == "number" && typeof e == "number";
}
const DU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  sortByAsc: LU,
  sortByDesc: jU
}, Symbol.toStringTag, { value: "Module" })), b4 = Symbol("TxSet"), uo = ({ txs: t }) => new uu({ txs: t, initSymbol: b4 }), P2 = {}, Ea = class Ea {
  // private constructor, don't call it directly! Use static factory methods.
  constructor({ txs: e, initSymbol: r }) {
    $e(r === b4, "please use TxSet.EMPTY or TxSet.fromArray()"), $e(e, "txs are required when constructing TxSet"), $e(e instanceof Map, "txs must be a Map");
    const n = [...e.values()];
    n.sort(N2), this._txs = new Map(n.map((i) => [i.txId, i])), this._order = n.map((i) => i.txId), this.addresses = ri.fromArray(n.flatMap((i) => [...i.addresses]));
  }
  static fromArray(e = []) {
    if (!Array.isArray(e))
      return console.warn("Unexpected non-array value:", e), Ea.EMPTY;
    e = e.map((n) => n instanceof Uo ? n : Uo.fromJSON(n));
    const r = new Map(e.map((n) => [n.txId, n]));
    return uo({ txs: r });
  }
  // NOTE: subtle bug here, if new Tx is added with same ID, but slightly older date
  // will get replaced by current Tx object with same ID and not the one just added
  add(e) {
    const r = this.get(e.txId);
    if (r && N2(r, e) > 0)
      return this;
    const n = new Map(this._txs);
    return n.set(e.txId, e), uo({ txs: n });
  }
  clone() {
    return uo({ txs: new Map(this._txs) });
  }
  delete(e) {
    const r = this.get(e);
    if (!r)
      return this;
    const n = new Map(this._txs);
    return n.delete(r.txId), uo({ txs: n });
  }
  // key txId comparison only
  equals(e) {
    return this._order.length !== e._order.length ? !1 : this._order.every((r, n) => r === e._order[n]);
  }
  deepEquals(e) {
    return this === e ? !0 : this.size !== e.size ? !1 : [...this].every((r) => {
      const n = e.get(r);
      if (n)
        return r === n || r.equals(n);
    });
  }
  get(e) {
    return this._txs.get(String(e));
  }
  getAt(e) {
    return this.get(this._order[e]);
  }
  has(e) {
    return this._txs.has(String(e));
  }
  toJSON() {
    return [...this].map((e) => e.toJSON());
  }
  // TODO: consider merging txs together
  union(e) {
    const r = [...this], n = [...e], i = [...r, ...n], o = Ea.fromArray(i);
    return this.deepEquals(o) ? this : o;
  }
  // used from a rescan
  // TODO: optimize
  update(e) {
    if (e instanceof Ea && e.deepEquals(this))
      return this;
    const r = new Map(
      [...e].map((n) => {
        const i = this.get(n.txId), o = { ...i, ...n };
        i && (Math.sign(o.coinAmount.toNumber()) === Math.sign(i.coinAmount.toNumber()) && // only use old when signs are the same and there is no fee
        !o.feeAmount && (o.coinAmount = i.coinAmount), i.meta && (o.meta = { ...i.meta }));
        const a = Uo.fromJSON(o);
        return [a.txId, a];
      })
    );
    return uo({ txs: r });
  }
  updateTxsProperties(e) {
    const r = new Map(this._txs);
    let n = !1;
    for (const i of e) {
      const o = r.get(i.txId);
      if (o) {
        const a = o.update(i);
        o.equals(a) || (r.set(i.txId, a), n = !0);
      }
    }
    return n ? uo({ txs: r }) : this;
  }
  getMutations() {
    if (this._mutations)
      return this._mutations;
    let e;
    return this._mutations = [...this].map((r) => {
      try {
        return e === void 0 && (e = r.coinAmount.unitType.ZERO), r.dropped || r.data.replacedBy || (r.error || (e = e.add(r.coinAmount)), r.feeAmount && r.feeAmount.unitType.equals(r.coinAmount.unitType) && (e = e.sub(r.feeAmount))), e.isNegative && !P2[r.txId] && (console.warn("negative balance in mutations calculation", {
          tx: r,
          balance: e
        }), P2[r.txId] = r.txId), { tx: r, balance: e };
      } catch (n) {
        throw r && (console.warn("failed to calculate mutation for tx", r.toJSON()), Object.assign(n, {
          asset: r.coinName,
          extraInfo: JSON.stringify(r.toJSON())
        })), n;
      }
    }), this._mutations;
  }
  [Symbol.iterator]() {
    return this._txs.values();
  }
  get size() {
    return this._txs.size;
  }
};
Le(Ea, "util", DU);
let uu = Ea;
uu.EMPTY = uo({ txs: /* @__PURE__ */ new Map() });
function N2(t, e) {
  let r = t.date - e.date;
  return r === 0 && (r = t.txId.localeCompare(e.txId)), r;
}
const { isEqual: U2, set: g4 } = tt;
class Qa {
  constructor(e = {}) {
    $e(typeof e.txId == "string", `expected "txId", received: ${e.txId}`), Object.assign(this, e), this.txId = e.txId, this.message = e.message || "";
  }
  static fromJSON(e) {
    return typeof e == "string" && (e = JSON.parse(e)), new Qa(e);
  }
  toJSON() {
    const e = { ...this };
    if (this.sends) {
      e.sends = {};
      for (const [r, n] of Object.entries(this.sends))
        e.sends[r] = { ...n };
    }
    return e;
  }
  toString() {
    return String(this.txId);
  }
  equals(e) {
    return e ? this === e || U2(this.toJSON(), e.toJSON()) : !1;
  }
  update(e) {
    if (e = $U(e), e.txId && e.txId !== this.txId)
      throw new Error('"txId" cannot be changed once it is set');
    const r = this.toJSON();
    return Object.keys(e).every((i) => U2(r[i], e[i])) ? this : Qa.fromJSON({ ...r, ...e });
  }
  getMessage({ to: e } = {}) {
    if (e && this.sends) {
      const r = Object.entries(this.sends);
      for (const [n, { message: i }] of r)
        if (n.toLowerCase() === e.toLowerCase() && i)
          return i;
    }
    return this.message || "";
  }
  setMessage({ to: e, message: r }) {
    if ($e(typeof r == "string", 'expected string "message"'), !e)
      return this.update({ message: r });
    const n = this.toJSON();
    qU({ personalNote: n, to: e });
    const i = g4(n, ["sends", e, "message"], r);
    return this.update(i);
  }
}
const $U = (t) => t instanceof Qa ? t.toJSON() : t, qU = ({ personalNote: t, to: e }) => {
  delete t.message, t.sends && Object.keys(t.sends || {}).forEach((r) => {
    const n = r.toLowerCase();
    r !== n && n === e && g4(t, ["sends", r, "message"], null);
  });
};
class Ki {
  constructor(e) {
    if (this._items = /* @__PURE__ */ new Map(), e)
      for (const r of e) {
        const n = F2(r);
        this._items.set(String(n), n);
      }
  }
  static fromArray(e) {
    return e == null ? Ki.EMPTY : new Ki(e);
  }
  // overwrites existing
  add(e) {
    if (e = zU(e), e.length === 0)
      return this;
    const r = Ki.fromArray(e), n = /* @__PURE__ */ new Set(), i = [];
    if ([...r].forEach((a) => {
      const s = this.get(a);
      if (!s) {
        i.push(a);
        return;
      }
      s.equals(a) || (i.push(a), n.add(s));
    }), i.length === 0)
      return this;
    const o = [...[...this].filter((a) => !n.has(a)), ...i];
    return Ki.fromArray(o);
  }
  clone() {
    return Ki.fromArray([...this]);
  }
  // key id comparison only
  equals(e) {
    return this === e ? !0 : this.size !== e.size ? !1 : [...this].every((r) => {
      const n = e.get(r);
      return n && n.equals(r);
    });
  }
  get(e) {
    const r = typeof e == "string" ? e : e.txId;
    if (!r)
      throw new Error("expected txId or Object/PersonalNote with property txId");
    return this._items.get(r);
  }
  has(e) {
    return this._items.has(String(e));
  }
  toJSON() {
    return [...this].map((e) => e.toJSON());
  }
  // adds and/or updates notes
  update(e) {
    const r = e.map((n) => {
      const i = this.get(n);
      return i ? i.update(n) : F2(n);
    });
    return this.add(r);
  }
  [Symbol.iterator]() {
    return this._items.values();
  }
  get size() {
    return this._items.size;
  }
}
Ki.EMPTY = new Ki();
const F2 = (t) => t instanceof Qa ? t : Qa.fromJSON(t), zU = (t) => Array.isArray(t) ? t : [t].flat(), { isEqual: L2, isNil: KU, merge: WU } = tt, Ac = "exodus", Ic = "seed", v4 = "trezor", m4 = "ledger", w4 = "ftx", j2 = [w4], HU = [v4, m4], D2 = [Ac, Ic], $2 = Object.freeze({
  exodus: "#7b39ff",
  seed: "#7b39ff",
  trezor: "#30d968",
  ledger: "#f5e400",
  ftx: "#00b4c2"
}), q2 = Object.freeze({
  exodus: "exodus",
  seed: "exodus",
  trezor: "trezor",
  ledger: "trezor",
  // don't have one yet
  ftx: "ftx"
}), c0 = 100, GU = (t) => t[0].toUpperCase() + t.slice(1), VU = ({ source: t, index: e }) => e === 0 ? GU(t) : "", YU = (t) => typeof t == "string" && /^#[\dA-Fa-f]{3,6}$/.test(t), JU = ["id", "source", "index", "isMultisig"], on = class on {
  constructor({
    source: e,
    index: r,
    id: n,
    label: i,
    model: o,
    lastConnected: a,
    is2FA: s,
    color: f,
    icon: u,
    compatibilityMode: c,
    seedId: d,
    enabled: l = !0,
    isMultisig: h = !1
  }) {
    /** @type {string} 'exodus' | 'trezor' | 'ledger' | 'ftx' | 'seed' */
    Le(this, "source");
    /** @type {?number} */
    Le(this, "index");
    /** @type {?string} */
    Le(this, "id");
    /** @type {string} */
    Le(this, "label");
    /** @type {?string} */
    Le(this, "model");
    /** @type {?number} */
    Le(this, "lastConnected");
    /** @type {?boolean} */
    Le(this, "is2FA");
    /** @type {?string} */
    Le(this, "color");
    /** @type {?string} */
    Le(this, "icon");
    /** @type {boolean} */
    Le(this, "enabled");
    /** @type {?string} */
    Le(this, "seedId");
    /** @type {?string} */
    Le(this, "compatibilityMode");
    /** @type {boolean} */
    Le(this, "isMultisig");
    const y = j2.includes(e), b = D2.includes(e);
    if ($e(e, 'expected "source" for a wallet account'), $e(!(r == null && !y), 'expected "index" for a wallet account'), $e(n || b, 'expected option "id" for a non-software wallet account'), $e(!b || !n, 'unexpected option "id" for a software wallet account'), $e(
      !(b && a),
      'unexpected option "lastConnected" for a software wallet account'
    ), $e(
      !c || !y,
      "compatibilityMode can not be provided for custodial wallet accounts"
    ), $e(!b || !o, 'unexpected option "model" for a software wallet account'), $e(e === Ac || !s, "is2FA: true is only valid for an exodus walletAccount"), $e(e !== Ic || d, 'expected option "seedId" for seed wallet account'), f = f || $2[e], u = u || q2[e], i = i || VU({ source: e, index: r }), i.length > c0 && (i = i.slice(0, c0)), !YU(f))
      throw new Error('expected "color" to be a hex string');
    if (typeof u != "string" || u.length === 0)
      throw new Error('expected "icon" to be a non-empty string');
    return this.source = e, this.index = KU(r) ? null : r, this.id = n, this.seedId = d, this.label = i || "", this.model = o, this.lastConnected = a, this.is2FA = s, this.color = f, this.icon = u, this.enabled = l, this.compatibilityMode = c ?? (this.isHardware ? this.source : void 0), this.isMultisig = h, p4(this);
  }
  toString() {
    return [
      this.source,
      this.index,
      ...this.source === Ic ? [this.seedId, this.compatibilityMode] : [this.id]
    ].filter((e) => e != null).join("_");
  }
  toJSON() {
    const e = {
      source: this.source,
      index: this.index,
      label: this.label,
      model: this.model,
      lastConnected: this.lastConnected,
      is2FA: this.is2FA,
      color: this.color,
      icon: this.icon,
      enabled: this.enabled,
      compatibilityMode: this.compatibilityMode,
      seedId: this.seedId,
      isMultisig: this.isMultisig
    };
    return this.id != null && (e.id = this.id), e;
  }
  /**
   * @param {WalletAccount} otherWalletAccount WalletAccount to compare with
   * @returns {boolean} true if they are identical
   */
  equals(e) {
    return this === e || L2(this.toJSON(), e.toJSON());
  }
  /**
   * @param {WalletAccount | object} fields wallet account instance or object with wallet account properties
   * @returns {WalletAccount} a new wallet account instance with the updated properties
   */
  update(e) {
    e instanceof on && (e = e.toJSON());
    const r = this.toJSON();
    return Object.keys(e).every((i) => L2(r[i], e[i])) ? this : (JU.forEach((i) => {
      if (e[i] && e[i] !== this[i])
        throw new Error(`property "${i}" is immutable`);
    }), new on(WU({}, r, e)));
  }
  /** @type {boolean} */
  get isSoftware() {
    return D2.includes(this.source);
  }
  /** @type {boolean} */
  get isHardware() {
    return HU.includes(this.source);
  }
  /** @type {boolean} */
  get isCustodial() {
    return j2.includes(this.source);
  }
  /** @type {string} */
  static get DEFAULT_NAME() {
    return on.DEFAULT.toString();
  }
  /** @type {WalletAccount} */
  static get DEFAULT() {
    return new on({
      source: Ac,
      index: 0
    });
  }
  static defaultWith(e) {
    return new on({ ...on.DEFAULT, ...e });
  }
};
Le(on, "LABEL_MAX_LENGTH", c0), Le(on, "DEFAULT_COLORS", $2), Le(on, "DEFAULT_ICONS", q2), Le(on, "EXODUS_SRC", Ac), Le(on, "SEED_SRC", Ic), Le(on, "TREZOR_SRC", v4), Le(on, "LEDGER_SRC", m4), Le(on, "FTX_SRC", w4);
let Ho = on;
const { mapValues: z2, mergeWith: XU } = tt, K2 = (t) => t instanceof Ho ? t : new Ho(t);
class Vs {
  constructor(e = {}) {
    this._byName = z2(e, K2);
  }
  toJSON() {
    return z2(this._byName, (e) => e.toJSON());
  }
  /**
   * @param {string | WalletAccount} name of the wallet account to get
   * @returns {WalletAccount | void} the wallet account instance if present
   */
  get(e) {
    if (e instanceof Ho && (e = e.toString()), this._byName.hasOwnProperty(e))
      return this._byName[e];
  }
  names() {
    return Object.keys(this._byName);
  }
  /**
   * @param {WalletAccountSet | object} walletAccountsByName data to update in the set
   * @returns {WalletAccountSet} a new instance with the updated data
   */
  update(e) {
    e instanceof Vs && (e = e.toJSON());
    const r = XU(
      { ...this._byName },
      e,
      (n, i) => n ? n.update(i) : K2(i)
    );
    return new Vs(r);
  }
  /**
   * @param {WalletAccountSet} walletAccountsByName wallet account set to compare against
   * @returns {boolean} true if the sets are identical
   */
  equals(e) {
    if (this === e)
      return !0;
    const r = Object.keys(e.toJSON()).sort(), n = this.names().sort();
    return r.length !== n.length ? !1 : n.every((i) => {
      const o = this.get(i), a = e.get(i);
      return a && o.equals(a);
    });
  }
}
Vs.EMPTY = new Vs();
function ZU(t = []) {
  const e = [
    ...t,
    {
      type: "date",
      test: (o) => o instanceof Date,
      serialize: (o) => o.toJSON(),
      deserialize: (o) => new Date(o)
    },
    {
      type: "buffer",
      test: (o) => o instanceof Ie,
      serialize: (o) => o.toString("base64"),
      deserialize: (o) => Ie.from(o, "base64")
    },
    {
      type: "uint8array",
      test: (o) => o instanceof Uint8Array,
      serialize: (o) => Ie.from(o).toString("base64"),
      deserialize: (o) => {
        const a = Ie.from(o, "base64"), s = new Uint8Array(a.length);
        return s.set(a), s;
      }
    },
    {
      type: "array",
      test: po.isArray,
      serialize: (o) => o.map((a) => n(a)),
      deserialize: (o) => o.map((a) => i(a))
    },
    {
      type: "object",
      test: po.isObject,
      serialize: (o) => po.mapValues(o, (a) => n(a)),
      deserialize: (o) => po.mapValues(o, (a) => i(a))
    }
  ], r = new Set(e.map((o) => o.type)), n = (o) => {
    const a = e.find((s) => s.test(o));
    return a ? { t: a.type, v: a.serialize(o) } : o;
  }, i = (o) => po.isObject(o) && Object.keys(o).length === 2 && "v" in o && r.has(o.t) ? e.find((a) => a.type === o.t).deserialize(o.v) : o;
  return { serialize: n, deserialize: i };
}
const { mapValues: QU } = tt, W2 = (t) => QU(t.units, (e) => e.power), eF = [
  {
    type: "numberunit",
    test: (t) => t instanceof Ka,
    serialize: (t) => ({ v: t.toString(), u: W2(t.unitType) }),
    deserialize: (t) => xi.create(t.u).parse(t.v)
  },
  {
    type: "utxocollection",
    test: (t) => t instanceof cu,
    serialize: (t) => ({ v: t.toJSON(), u: W2(t.currency) }),
    deserialize: (t) => cu.fromJSON(t.v, { currency: xi.create(t.u) })
  }
], { serialize: du, deserialize: lu } = ZU(eF), { get: u0, isPlainObject: tF, isString: rF } = tt, nF = {
  aero: ["failed", "overdue", "expired"],
  ch: ["failed", "overdue", "expired"],
  chf: ["failed", "overdue", "expired"],
  cic: ["failed", "overdue", "expired"],
  cn: ["failed", "expired"],
  "inch-eth": ["failed"],
  "inch-bsc": ["failed"],
  "inch-matic": ["failed"],
  cs: ["failed", "timeout"],
  csus: ["failed", "timeout"],
  sw: ["failed", "expired"],
  fa: ["cancelled"],
  he: ["failed", "overdue", "hold", "expired"],
  fox: ["failed", "timeout", "unknown"],
  ne: ["canceled"],
  nrnb: ["overdue", "error"]
}, H2 = {
  // end states, can't be changed, we stop checking
  aero: ["refunded"],
  ch: ["refunded"],
  chf: ["refunded"],
  cic: ["refunded"],
  cn: ["refunded"],
  cs: ["refunded"],
  csus: ["refunded"],
  sw: ["refunded"],
  fa: ["refunded"],
  he: ["refunded"],
  fox: ["cancelled"],
  ne: ["refunded"],
  nrnb: ["refunded"]
}, iF = /* @__PURE__ */ new Set(["optimistic-complete", "potential-complete"]), G2 = Symbol("Order");
class Ys {
  constructor(e, r) {
    if ($e(r === G2, "please use Order.fromJSON()"), this.orderId = e.orderId, $e(typeof this.orderId == "string", `orderId must be a string, received: ${this.orderId}`), e.fromAmount !== void 0 && !zo(e.fromAmount))
      throw new Error("fromAmount must be of type: NumberUnit");
    if (e.toAmount !== void 0 && !zo(e.toAmount))
      throw new Error("toAmount must be of type: NumberUnit");
    this.status = e.status || "", e.errorDetails && (this.errorDetails = e.errorDetails), this.date = e.date ? e.date instanceof Date ? e.date : new Date(e.date) : /* @__PURE__ */ new Date(), e.fromTxId && (this.fromTxId = e.fromTxId), e.toTxId && (this.toTxId = e.toTxId), e.txIds && (this.txIds = e.txIds), e.fromAsset && (this.fromAsset = String(e.fromAsset)), e.fromAmount && (this.fromAmount = e.fromAmount), e.toAsset && (this.toAsset = String(e.toAsset)), e.toAmount && (this.toAmount = e.toAmount), this.fromWalletAccount = e.fromWalletAccount || Ho.DEFAULT_NAME, this.toWalletAccount = e.toWalletAccount || Ho.DEFAULT_NAME, e.svc || console.log(`${e.orderId} has no 'svc' field set.`), this.svc = e.svc || "ss", e.svcOptions && (this.svcOptions = e.svcOptions), e.message !== void 0 && e.message !== "null" && (this.message = e.message), typeof e.synced == "boolean" && (this.synced = e.synced), typeof e.region == "string" && (this.region = e.region), typeof e.displaySvc == "string" && (this.displaySvc = e.displaySvc), this.toTxId = e.toTxId, this.potentialToTxIds = e.potentialToTxIds || [], this._version = 1;
  }
  static fromJSON(e) {
    $e(
      e && (rF(e) || tF(e)),
      "fromJSON: requires a string or a plain object"
    ), typeof e == "string" && (e = JSON.parse(e));
    const r = e.fromAmount ? lu(e.fromAmount) : void 0, n = e.toAmount ? lu(e.toAmount) : void 0;
    return new Ys({ ...e, fromAmount: r, toAmount: n }, G2);
  }
  inspect() {
    return `[Order ${this.orderId}]`;
  }
  toJSON() {
    const e = { ...this, date: this.date.toISOString() };
    return e.fromAmount && (e.fromAmount = du(e.fromAmount)), e.toAmount && (e.toAmount = du(e.toAmount)), e._version = 1, e;
  }
  // @deprecated
  toJSONLegacy() {
    console.log(
      "Order: calling deprecated function order.toJSONLegacy(), use orderToJSONLegacy() instead"
    );
    const e = { ...this, date: this.date.toISOString() };
    return e.fromAmount && (e.fromAmount = e.fromAmount.toString()), e.toAmount && (e.toAmount = e.toAmount.toString()), delete e._version, e;
  }
  toString() {
    return String(this.orderId);
  }
  update(e) {
    return Ys.fromJSON({ ...this.toJSON(), ...e });
  }
  // this.status is the raw field provided by the exchange service
  // exodusStatus is used to map to the interface, customer only
  // cares if an exchange is in progress, complete, or failed... nothing else
  get exodusStatus() {
    return this.status === "e2e-syncing" ? "syncing" : this.status === "complete-verified" ? "complete" : this.status === "failed-final" || u0(H2, this.svc, []).includes(this.status) ? "failed" : "in-progress";
  }
  get error() {
    return u0(nF, this.svc, []).includes(this.status) || u0(H2, this.svc, []).includes(this.status) ? !0 : this.status === "failed-final";
  }
  get finalized() {
    return ["failed-final", "complete-verified"].includes(this.status);
  }
  get floatingRate() {
    return this.svc === "ch" && this.status !== "complete-verified";
  }
  get hasOptimisticStatus() {
    return iF.has(this.status);
  }
  get exchangeApp() {
    return this.svc === "ftx" ? "ftx" : "exodus";
  }
}
const x4 = Symbol("OrderSet"), ma = ({ items: t }) => new Ca({ items: t, initSymbol: x4 });
class Ca {
  constructor({ items: e, initSymbol: r }) {
    $e(r === x4, "please use OrderSet.EMPTY or OrderSet.fromArray()"), $e(e instanceof Map, "items must be a Map");
    const n = [...e.values()];
    n.sort((o, a) => a.date - o.date);
    const i = /* @__PURE__ */ new Map();
    for (const o of n)
      o.txIds && o.txIds.forEach(({ txId: a }) => {
        d0(i, a, o.orderId);
      }), d0(i, o.fromTxId, o.orderId), d0(i, o.toTxId, o.orderId);
    this._items = new Map(n.map((o) => [String(o), o])), this._txMap = i, this._sortOrder = n.map((o) => o.orderId);
  }
  // TODO: there is a bug if both sets have the same orderId but different fields
  // consider a merge in this scenario?
  static fromArray(e) {
    return e == null ? Ca.EMPTY : ma({
      items: new Map(e.map(oF).map((r) => [String(r), r]))
    });
  }
  add(e) {
    return this.addBulk([e]);
  }
  // TODO: optimize, this seems pretty inefficient
  // there may be a bug here if an Order with the same orderId is added
  addBulk(e) {
    if (!e)
      return this;
    for (const r of e)
      this.get(r) && console.log("OrderSet#add() already has #{item.orderId}");
    return ma({
      items: new Map([...this._items.values(), ...e].map((r) => [String(r), r]))
    });
  }
  clone() {
    return ma({ items: new Map(this._items) });
  }
  delete(e) {
    const r = this.get(e);
    if (!r)
      return this;
    const n = new Map(this._items);
    return n.delete(r.orderId), ma({ items: n });
  }
  // key id comparison only
  equals(e) {
    if (this._sortOrder.length !== e._sortOrder.length)
      return !1;
    const r = this._sortOrder.length;
    for (let n = 0; n < r; ++n)
      if (this._sortOrder[n] !== e._sortOrder[n])
        return !1;
    return !0;
  }
  get(e) {
    return this._items.get(String(e));
  }
  getAt(e) {
    return this.get(this._sortOrder[e]);
  }
  // should be used by default unless you intend to get multiple orders back for the same txid
  getByTxId(e, r = 0) {
    const n = this._txMap.get(e) || [];
    return this._items.get(n[r]);
  }
  // used when multiple exchanges are returned in the same TX
  getAllByTxId(e) {
    return (this._txMap.get(e) || []).map((n) => this._items.get(n));
  }
  has(e) {
    return this._items.has(String(e));
  }
  toJSON() {
    return [...this].map((e) => e.toJSON());
  }
  filter(e) {
    return Ca.fromArray([...this].filter(e));
  }
  // @deprecated
  toJSONLegacy() {
    return console.log(
      "OrderSet: calling deprecated function orderSet.toJSONLegacy(), use orderSetToJSONLegacy() instead"
    ), [...this].map((e) => e.toJSONLegacy());
  }
  // NOTE: precondition that both sets are mutually exclusive
  // in the event they are not, the resulting set would not contain data
  // from both orders, it would contain the data in the otherSet
  // this behavior may need to be changed
  union(e) {
    const r = [...this], n = [...e], i = [...r, ...n];
    return Ca.fromArray(i);
  }
  // TODO: consider treating this an upsert i.e. if Order does not exist, add it
  update(e) {
    const r = new Map(this._items);
    for (const n of e) {
      const i = r.get(String(n));
      if (!i) {
        console.log("OrderSet#update() order does not contain an `orderId`. Skipping...");
        continue;
      }
      r.set(String(n), i.update(n));
    }
    return ma({ items: r });
  }
  [Symbol.iterator]() {
    return this._items.values();
  }
  get size() {
    return this._items.size;
  }
}
Ca.EMPTY = ma({ items: /* @__PURE__ */ new Map() });
function oF(t) {
  return t instanceof Ys ? t : Ys.fromJSON(t);
}
function d0(t, e, r) {
  if (e) {
    const n = t.get(e) || [];
    if (n.includes(r))
      return;
    t.set(e, [...n, r]);
  }
}
const aF = {
  __proto__: null,
  buy: "buy",
  sell: "sell"
}, Cr = {
  __proto__: null,
  complete: "complete",
  failed: "failed",
  in_progress: "in-progress",
  initiated: "initiated"
}, ua = {
  __proto__: null,
  blockchain: "blockchain",
  moonpay: "moonpay",
  onramper: "onramper",
  paypal: "paypal",
  ramp: "ramp",
  sardine: "sardine"
}, da = {
  __proto__: null,
  completed: "completed",
  failed: "failed",
  pending: "pending",
  waiting_authorization: "waitingAuthorization",
  waiting_deposit: "waitingForDeposit",
  waiting_payment: "waitingPayment"
}, sF = {
  __proto__: null,
  [Cr.complete]: [da.completed],
  [Cr.failed]: [da.failed],
  [Cr.in_progress]: [
    da.waiting_payment,
    da.pending,
    da.waiting_authorization,
    da.waiting_deposit
  ]
}, cc = {
  __proto__: null,
  completed: "COMPLETED",
  failed: "FAILED",
  initiated: "INITIATED",
  pending: "PENDING"
}, fF = {
  __proto__: null,
  [Cr.complete]: [cc.completed],
  [Cr.failed]: [cc.failed],
  [Cr.in_progress]: [cc.pending],
  [Cr.initiated]: [cc.initiated]
}, Ln = {
  __proto__: null,
  cancelled: "CANCELLED",
  expired: "EXPIRED",
  fiat_received: "FIAT_RECEIVED",
  fiat_sent: "FIAT_SENT",
  initialized: "INITIALIZED",
  payment_executed: "PAYMENT_EXECUTED",
  payment_failed: "PAYMENT_FAILED",
  payment_in_progress: "PAYMENT_IN_PROGRESS",
  payment_started: "PAYMENT_STARTED",
  released: "RELEASED",
  releasing: "RELEASING",
  review_rejected: "REVIEW_REJECTED"
}, cF = {
  __proto__: null,
  [Cr.complete]: [Ln.released],
  [Cr.failed]: [
    Ln.cancelled,
    Ln.expired,
    Ln.payment_failed,
    Ln.review_rejected
  ],
  [Cr.in_progress]: [
    Ln.fiat_received,
    Ln.fiat_sent,
    Ln.initialized,
    Ln.payment_executed,
    Ln.payment_in_progress,
    Ln.payment_started,
    Ln.releasing
  ]
}, la = {
  __proto__: null,
  complete: "Complete",
  declined: "Declined",
  draft: "Draft",
  expired: "Expired",
  processed: "Processed",
  user_custody: "UserCustody"
}, uF = {
  __proto__: null,
  [Cr.complete]: [la.complete],
  [Cr.failed]: [la.declined, la.expired],
  [Cr.in_progress]: [
    la.draft,
    la.user_custody,
    la.processed
  ]
}, uc = {
  __proto__: null,
  completed: "COMPLETED",
  failed: "FAILED",
  pending: "PENDING",
  withdrawing: "WITHDRAWING"
}, dF = {
  __proto__: null,
  [Cr.complete]: [uc.completed],
  [Cr.failed]: [uc.failed],
  [Cr.in_progress]: [
    uc.pending,
    uc.withdrawing
  ]
}, ha = {
  __proto__: null,
  new: "new",
  pending: "pending",
  paid: "paid",
  completed: "completed",
  canceled: "canceled",
  failed: "failed"
}, lF = {
  __proto__: null,
  [Cr.complete]: [ha.completed],
  [Cr.failed]: [ha.failed, ha.canceled],
  [Cr.in_progress]: [
    ha.new,
    ha.paid,
    ha.pending
  ]
}, V2 = {
  __proto__: null,
  [ua.blockchain]: dF,
  [ua.onramper]: lF,
  [ua.moonpay]: sF,
  [ua.paypal]: fF,
  [ua.ramp]: cF,
  [ua.sardine]: uF
}, { isEqual: hF } = tt, Y2 = Symbol("FiatOrder");
var cf, op;
const Sa = class Sa {
  constructor(e, r) {
    Ve(this, cf);
    Sa.validate(e, r), Object.assign(this, e), this.exodusStatus === "complete" && this.errorMessage && (console.log("ignoring error given error complete"), delete this.errorMessage);
  }
  get exodusStatus() {
    const e = V2[this.provider], r = Object.entries(e).find(
      ([, n]) => n.includes(this.status)
    );
    return r ? r[0] : "in-progress";
  }
  get error() {
    return !!this.errorMessage;
  }
  get isBuy() {
    return this.orderType === "buy";
  }
  get isSell() {
    return this.orderType === "sell";
  }
  get cryptoAmount() {
    return this.isBuy ? this.toAmount : this.fromAmount;
  }
  get cryptoAsset() {
    return this.isBuy ? this.toAsset : this.fromAsset;
  }
  get txIds() {
    return this.txId ? [this.txId] : [];
  }
  static fromJSON(e) {
    const r = e.orderType === aF.buy;
    return new Sa(
      {
        ...e,
        date: e.date instanceof Date ? e.date : new Date(e.date),
        ...r ? { toAmount: lu(e.toAmount) } : { fromAmount: lu(e.fromAmount) }
      },
      Y2
    );
  }
  equals(e) {
    const r = new Set(Object.keys(e)), n = new Set(Object.keys(this.toJSON()));
    return n.size === r.size && [...n].every((o) => r.has(o)) ? fn(this, cf, op).call(this, e) : !1;
  }
  inspect() {
    return `[${this.constructor.name} ${this.orderId}]`;
  }
  toJSON() {
    return {
      ...this,
      date: this.date.toISOString(),
      ...this.isBuy ? { toAmount: du(this.toAmount) } : { fromAmount: du(this.fromAmount) }
    };
  }
  toString() {
    return this.orderId;
  }
  update(e) {
    return fn(this, cf, op).call(this, e) ? this : Sa.fromJSON({ ...this.toJSON(), ...e });
  }
};
cf = new WeakSet(), op = function(e) {
  return Object.keys(e).every((r) => {
    var i;
    const n = e[r];
    return n instanceof Date ? this[r].toISOString() === n.toISOString() : zo(n) ? (i = this[r]) == null ? void 0 : i.equals(n) : hF(this[r], e[r]);
  });
}, Le(Sa, "validate", (e, r) => {
  $e(r === Y2, "please use Order.fromJSON()"), $e(typeof e.orderId == "string", 'expected string "orderId"'), $e(
    ["buy", "sell"].includes(e.orderType),
    'expected "orderType" of value "buy" | "sell"'
  ), $e(typeof e.provider == "string" && V2[e.provider], "invalid provider"), $e(typeof e.status == "string", 'expected string "status"'), $e(
    typeof e.fromAddress == "string" || e.fromAddress === null,
    'expected string or null "fromAddress"'
  ), $e(
    typeof e.fromWalletAccount == "string" || e.fromWalletAccount === null,
    'expected string or null "fromWalletAccount"'
  ), $e(
    typeof e.fromAmount == "number" || e.fromAmount instanceof Ka,
    'expected number or NumberUnit "fromAmount"'
  ), $e(typeof e.fromAsset == "string", 'expected string "fromAsset"'), $e(
    typeof e.toAddress == "string" || e.toAddress === null,
    'expected string or null "toAddress"'
  ), $e(
    typeof e.toWalletAccount == "string" || e.toWalletAccount === null,
    'expected string or null "toWalletAccount"'
  ), $e(
    typeof e.toAmount == "number" || e.toAmount instanceof Ka,
    'expected number or NumberUnit "toAmount"'
  ), $e(typeof e.toAsset == "string", 'expected string "toAsset"'), $e(typeof e.fiatValue == "number", 'expected number "fiatValue"'), $e(typeof e.providerRate == "number", 'expected number "providerRate"'), $e(typeof e.exodusRate == "number", 'expected number "exodusRate"'), e.feesWereSubsidized !== void 0 && $e(typeof e.feesWereSubsidized == "boolean", 'expected boolean "feesWereSubsidized"'), e.errorMessage && $e(typeof e.errorMessage == "string", 'expected string "errorMessage"'), e.fees && $e(typeof e.fees == "object", 'expected object "fees"'), e.hideInHistory !== void 0 && $e(typeof e.hideInHistory == "boolean", 'expected boolean "hideInHistory"'), e.supportMessage != null && $e(typeof e.supportMessage == "string", 'expected string "supportMessage"'), e.showedFailureBanner !== void 0 && $e(
    typeof e.showedFailureBanner == "boolean",
    'expected boolean "showedFailureBanner"'
  );
});
let ip = Sa;
const l0 = Symbol("FiatOrderSet");
var Fa, Bc, La, Mc;
const Qn = class Qn {
  constructor({ items: e, initSymbol: r }) {
    Ve(this, Fa);
    Ve(this, La);
    $e(
      r === l0,
      "please use FiatOrderSet.EMPTY or FiatOrderSet.fromArray()"
    );
    const n = [...e.values()];
    n.sort((i, o) => o.date - i.date), this._items = e, this._sortOrder = n.map((i) => i.orderId), this._txMap = /* @__PURE__ */ new Map();
    for (const i of n) {
      if (!i.txId)
        continue;
      const o = fn(this, Fa, Bc).call(this, i.txId);
      o.includes(String(i)) || this._txMap.set(i.txId, [...o, String(i)]);
    }
  }
  static fromArray(e) {
    if (!e || Array.isArray(e) && e.length === 0)
      return Qn.EMPTY;
    const r = [], n = /* @__PURE__ */ new Map();
    for (const i of e)
      try {
        const o = pF(i);
        n.set(String(o), o);
      } catch (o) {
        r.push([o, i]);
      }
    return r.length > 0 && console.warn("FiatOrderSet failed to convert object to FiatOrder", r), new Qn({ items: n, initSymbol: l0 });
  }
  add(e) {
    if (!this.has(e))
      return Qn.fromArray([...this, e]);
  }
  clone() {
    return Qn.fromArray(this.toJSON());
  }
  delete(e) {
    if (this.has(e))
      return Qn.fromArray(this.toJSON().filter(({ orderId: r }) => r !== String(e)));
  }
  // key id comparison only
  equals(e) {
    var r;
    if (this.size !== e.size)
      return !1;
    for (let n = 0; n < this.size; ++n)
      if (fn(this, La, Mc).call(this, n) !== fn(r = e, La, Mc).call(r, n))
        return !1;
    return !0;
  }
  has(e) {
    return this._items.has(String(e));
  }
  get(e) {
    return this._items.get(String(e));
  }
  getAt(e) {
    return this.get(fn(this, La, Mc).call(this, e));
  }
  // should be used by default unless you intend to get multiple orders back for the same txid
  getByTxId(e, r = 0) {
    const n = fn(this, Fa, Bc).call(this, e);
    return this.get(n[r]);
  }
  getAllByTxId(e) {
    return fn(this, Fa, Bc).call(this, e).map((r) => this.get(r));
  }
  toJSON() {
    return [...this].map((e) => e.toJSON());
  }
  [Symbol.iterator]() {
    return this._items.values();
  }
  get size() {
    return this._items.size;
  }
  // NOTE: precondition that both sets are mutually exclusive
  // in the event they are not, the resulting set would not contain data
  // from both orders, it would contain the data in the otherSet
  // this behavior may need to be changed
  union(e) {
    const r = [...this], n = [...e], i = [...r, ...n];
    return Qn.fromArray(i);
  }
  update(e) {
    const r = [];
    for (const n of e) {
      const i = this.get(n);
      if (i) {
        const o = i.update({ ...n });
        i !== o && r.push(o);
      }
    }
    return r.length === 0 ? this : Qn.fromArray([...this.toJSON(), ...r]);
  }
};
Fa = new WeakSet(), Bc = function(e) {
  return this._txMap.get(e) || [];
}, La = new WeakSet(), Mc = function(e) {
  return this._sortOrder[e];
}, Le(Qn, "EMPTY", new Qn({ items: /* @__PURE__ */ new Map(), initSymbol: l0 }));
let ap = Qn;
function pF(t) {
  return t instanceof ap ? t : ip.fromJSON(t);
}
ta("2m");
ta("30s");
ta("30s");
const yF = QO(u9(lk, (t) => t.name));
new mU({ assets: yF });
class bF extends Error {
  constructor() {
    super("Versioned transactions are not supported."), this.name = "VERSIONED_TRANSACTION_UNSUPPORTED";
  }
}
const gF = /* @__PURE__ */ new Set(["legacy", 0]);
function sp(t) {
  return _4(t) ? Ie.from(t.serialize({ requireAllSignatures: !1 })) : Ie.from(t.serialize());
}
function h0(t) {
  return sp(t).toString("base64");
}
function Rc(t) {
  try {
    return o7.from(t);
  } catch {
    if (!$c)
      throw new bF();
    return $c.deserialize(Uint8Array.from(t));
  }
}
function J2(t) {
  const e = Ie.from(t, "base64");
  return Rc(e);
}
function _4(t) {
  return !Number.isInteger(t.version);
}
function X2(t, e) {
  t.signatures = e.signatures;
}
var Wi, Bo, Su, ja;
class vF extends yp {
  constructor({ transport: r, accountsObservable: n }) {
    super({ transport: r });
    Ve(this, Wi, null);
    Ve(this, Bo, () => {
      if (!this.isConnected)
        throw new J7();
    });
    Ve(this, Su, (r) => {
      var i;
      const n = new wt(r[0]);
      (i = Se(this, Wi)) != null && i.equals(n) || (Nt(this, Wi, n), this.emitAndIgnoreErrors("accountChanged", n));
    });
    Ve(this, ja, async (r, n = !1) => {
      let i = "";
      const o = r.filter(_4);
      for (const a of o)
        a.feePayer || (a.feePayer = this.publicKey), !a.signatures.length && (!a.recentBlockhash || n) && (i || (i = await this._callRpcMethod("sol_getLatestBlockhash", ["finalized"])), a.recentBlockhash = i);
    });
    Le(this, "connect", async ({ onlyIfTrusted: r = !1 } = {}) => {
      const n = await this._callRpcMethod("sol_connect", [r]), i = Q7(n);
      return Nt(this, Wi, i), this.emitAndIgnoreErrors("connect", i), { publicKey: i };
    });
    Le(this, "disconnect", () => {
      this.isConnected && (Nt(this, Wi, null), this.emitAndIgnoreErrors("disconnect"));
    });
    Le(this, "signTransaction", async (r) => {
      Se(this, Bo).call(this);
      const n = r instanceof Uint8Array, i = n ? Rc(r) : r;
      await Se(this, ja).call(this, [i]);
      const o = h0(i), a = await this._callRpcMethod("sol_signTransaction", [o]), s = J2(a);
      return X2(i, s), n ? sp(i) : i;
    });
    Le(this, "signAllTransactions", async (r) => {
      Se(this, Bo).call(this);
      const n = r[0] instanceof Uint8Array, i = n ? r.map((f) => Rc(f)) : r;
      await Se(this, ja).call(this, i);
      const o = i.map((f) => h0(f)), s = (await this._callRpcMethod("sol_signAllTransactions", [o])).map((f) => J2(f));
      return i.forEach((f, u) => {
        const c = s[u];
        X2(f, c);
      }), n ? i.map((f) => sp(f)) : i;
    });
    Le(this, "signAndSendTransaction", async (r, n = {}) => {
      Se(this, Bo).call(this);
      const i = r instanceof Uint8Array, o = i ? Rc(r) : r;
      await Se(this, ja).call(this, [o], !0);
      const a = h0(o), f = await this._callRpcMethod("sol_signAndSendTransaction", [a, n]);
      return { signature: i ? a9(f) : f };
    });
    Le(this, "signMessage", async (r, n = "utf8") => {
      if (Se(this, Bo).call(this), !["hex", "utf8"].includes(n))
        throw new X7();
      const o = e9(r), a = await this._callRpcMethod("sol_signMessage", [o, n]);
      return { signature: s9(a), publicKey: this.publicKey };
    });
    Le(this, "postMessage", () => {
      throw new Y7();
    });
    Le(this, "request", (r) => {
      const { method: n, params: i = [] } = r;
      if (n === "isConnected")
        return this._callRpcMethod("sol_isConnected", []);
      if (![
        "connect",
        "disconnect",
        "signTransaction",
        "signAllTransactions",
        "signAndSendTransaction",
        "signMessage",
        "postMessage"
      ].includes(n))
        throw new Z7();
      return this[n](...i);
    });
    this.on("connect", () => {
      const i = n.observe((o) => {
        Se(this, Su).call(this, o);
      });
      this.on("disconnect", i);
    });
  }
  get supportedTransactionVersions() {
    return gF;
  }
  get publicKey() {
    return Se(this, Wi);
  }
  get isConnected() {
    return !!this.publicKey;
  }
}
Wi = new WeakMap(), Bo = new WeakMap(), Su = new WeakMap(), ja = new WeakMap();
const E4 = "solana:signAndSendTransaction", S4 = "solana:signMessage", A4 = "solana:signTransaction", mF = "standard:connect", wF = "standard:disconnect", xF = "standard:events", _F = "solana:mainnet", K1 = [_F];
function p0(t) {
  return K1.includes(t);
}
const EF = K1, SF = [
  E4,
  A4,
  S4
];
var uf, df, lf, hf, pf, yf;
const W1 = class W1 {
  constructor({ address: e, publicKey: r, label: n, icon: i }) {
    Ve(this, uf, void 0);
    Ve(this, df, void 0);
    Ve(this, lf, void 0);
    Ve(this, hf, void 0);
    Ve(this, pf, void 0);
    Ve(this, yf, void 0);
    Nt(this, uf, e), Nt(this, df, r), Nt(this, lf, EF), Nt(this, hf, SF), Nt(this, pf, n), Nt(this, yf, i), new.target === W1 && Object.freeze(this);
  }
  get address() {
    return Se(this, uf);
  }
  get publicKey() {
    return Se(this, df).slice();
  }
  get chains() {
    return Se(this, lf).slice();
  }
  get features() {
    return Se(this, hf).slice();
  }
  get label() {
    return Se(this, pf);
  }
  get icon() {
    return Se(this, yf);
  }
};
uf = new WeakMap(), df = new WeakMap(), lf = new WeakMap(), hf = new WeakMap(), pf = new WeakMap(), yf = new WeakMap();
let fp = W1;
function AF(t, e) {
  return IF(t, e);
}
function IF(t, e) {
  if (t === e)
    return !0;
  const r = t.length;
  if (r !== e.length)
    return !1;
  for (let n = 0; n < r; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
var Hi, Au, bf, gf, qr, yn, Iu, vf, cp, Bu, I4, Mo, mf, Mu, Ru, Tu, wf, Ou, xf;
class BF extends ym {
  constructor({ provider: r, name: n, icon: i }) {
    super({ name: n, icon: i });
    Ve(this, vf);
    Ve(this, Bu);
    Ve(this, Hi, /* @__PURE__ */ Object.create(null));
    Ve(this, Au, "1.0.0");
    Ve(this, bf, void 0);
    Ve(this, gf, void 0);
    Ve(this, qr, null);
    Ve(this, yn, void 0);
    Ve(this, Iu, (r, n) => {
      var i;
      return (i = Se(this, Hi)[r]) != null && i.push(n) || (Se(this, Hi)[r] = [n]), () => fn(this, Bu, I4).call(this, r, n);
    });
    Ve(this, Mo, () => {
      var n;
      const r = (n = Se(this, yn).publicKey) == null ? void 0 : n.toBase58();
      if (r) {
        const i = Se(this, yn).publicKey.toBytes(), o = Se(this, qr);
        (!o || o.address !== r || !AF(o.publicKey, i)) && (Nt(this, qr, new fp({ address: r, publicKey: i })), fn(this, vf, cp).call(this, "change", { accounts: this.accounts }));
      }
    });
    Ve(this, mf, () => {
      Se(this, qr) && (Nt(this, qr, null), fn(this, vf, cp).call(this, "change", { accounts: this.accounts }));
    });
    Ve(this, Mu, () => {
      Se(this, yn).publicKey ? Se(this, Mo).call(this) : Se(this, mf).call(this);
    });
    Ve(this, Ru, async ({ silent: r } = {}) => (Se(this, qr) || await Se(this, yn).connect(r ? { onlyIfTrusted: !0 } : void 0), Se(this, Mo).call(this), { accounts: this.accounts }));
    Ve(this, Tu, async () => {
      await Se(this, yn).disconnect();
    });
    Ve(this, wf, async (...r) => {
      if (!Se(this, qr))
        throw new Error("not connected");
      const n = [];
      if (r.length === 1) {
        const { transaction: i, account: o, chain: a, options: s } = r[0], { minContextSlot: f, preflightCommitment: u, skipPreflight: c, maxRetries: d } = s || {};
        if (o !== Se(this, qr))
          throw new Error("invalid account");
        if (!p0(a))
          throw new Error("invalid chain");
        const { signature: l } = await Se(this, yn).signAndSendTransaction(i, {
          maxRetries: d,
          minContextSlot: f,
          preflightCommitment: u,
          skipPreflight: c
        });
        n.push({ signature: l });
      } else if (r.length > 1)
        for (const i of r)
          n.push(...await Se(this, wf).call(this, i));
      return n;
    });
    Ve(this, Ou, async (...r) => {
      if (!Se(this, qr))
        throw new Error("not connected");
      const n = [];
      if (r.length === 1) {
        const { transaction: i, account: o, chain: a } = r[0];
        if (o !== Se(this, qr))
          throw new Error("invalid account");
        if (a && !p0(a))
          throw new Error("invalid chain");
        const s = await Se(this, yn).signTransaction(i);
        n.push({ signedTransaction: s });
      } else if (r.length > 1) {
        let i;
        for (const s of r) {
          if (s.account !== Se(this, qr))
            throw new Error("invalid account");
          if (s.chain) {
            if (!p0(s.chain))
              throw new Error("invalid chain");
            if (i) {
              if (s.chain !== i)
                throw new Error("conflicting chain");
            } else
              i = s.chain;
          }
        }
        const o = r.map(({ transaction: s }) => s), a = await Se(this, yn).signAllTransactions(o);
        n.push(...a.map((s) => ({
          signedTransaction: s
        })));
      }
      return n;
    });
    Ve(this, xf, async (...r) => {
      if (!Se(this, qr))
        throw new Error("not connected");
      const n = [];
      if (r.length === 1) {
        const { message: i, account: o } = r[0];
        if (o !== Se(this, qr))
          throw new Error("invalid account");
        const { signature: a } = await Se(this, yn).signMessage(i);
        n.push({ signedMessage: i, signature: a });
      } else if (r.length > 1)
        for (const i of r)
          n.push(...await Se(this, xf).call(this, i));
      return n;
    });
    if (!r)
      throw new Error("Solana Provider is required!");
    Nt(this, bf, n), Nt(this, gf, i), Nt(this, yn, r), r.on("connect", Se(this, Mo), this), r.on("disconnect", Se(this, mf), this), r.on("accountChanged", Se(this, Mu), this), Se(this, Mo).call(this);
  }
  get version() {
    return Se(this, Au);
  }
  get name() {
    return Se(this, bf);
  }
  get icon() {
    return Se(this, gf);
  }
  get chains() {
    return K1.slice();
  }
  get features() {
    const { supportedTransactionVersions: r } = Se(this, yn);
    return {
      [mF]: {
        version: "1.0.0",
        connect: Se(this, Ru)
      },
      [wF]: {
        version: "1.0.0",
        disconnect: Se(this, Tu)
      },
      [xF]: {
        version: "1.0.0",
        on: Se(this, Iu)
      },
      [E4]: {
        version: "1.0.0",
        supportedTransactionVersions: Array.from(r),
        signAndSendTransaction: Se(this, wf)
      },
      [A4]: {
        version: "1.0.0",
        supportedTransactionVersions: Array.from(r),
        signTransaction: Se(this, Ou)
      },
      [S4]: {
        version: "1.0.0",
        signMessage: Se(this, xf)
      }
    };
  }
  get accounts() {
    return Se(this, qr) ? [Se(this, qr)] : [];
  }
}
Hi = new WeakMap(), Au = new WeakMap(), bf = new WeakMap(), gf = new WeakMap(), qr = new WeakMap(), yn = new WeakMap(), Iu = new WeakMap(), vf = new WeakSet(), cp = function(r, ...n) {
  var i;
  (i = Se(this, Hi)[r]) == null || i.forEach((o) => o.apply(null, n));
}, Bu = new WeakSet(), I4 = function(r, n) {
  var i;
  Se(this, Hi)[r] = (i = Se(this, Hi)[r]) == null ? void 0 : i.filter((o) => n !== o);
}, Mo = new WeakMap(), mf = new WeakMap(), Mu = new WeakMap(), Ru = new WeakMap(), Tu = new WeakMap(), wf = new WeakMap(), Ou = new WeakMap(), xf = new WeakMap();
var MF = ({ transport: t, accountsObservable: e, injectWindow: r = !1, walletStandard: n = !0 }) => {
  let i = new vF({ transport: t, accountsObservable: e });
  return i.defineFlag(Da), pp(i, dp, Da), n && gm(new BF({ name: lp, icon: hp, provider: i })), r && (window.solana = i), i;
};
const y0 = () => {
  let t = [];
  function e(n) {
    t.forEach((i) => i(n));
  }
  function r(n) {
    return t.push(n), () => {
      t = t.filter((i) => i !== n);
    };
  }
  return { notify: e, observe: r };
};
function RF(t, e) {
  const { bitcoin: r, ethereum: n, solana: i } = e;
  let o;
  if (r) {
    const f = y0();
    o = a8({
      accountsObservable: f,
      transport: t,
      injectWindow: r.dangerouslyInjectWindow,
      walletStandard: r.walletStandard
    }), window.addEventListener("message", (u) => {
      u.origin === bn && u.data === "wallet:locked" && f.notify([]);
    });
  }
  let a;
  if (n) {
    const f = y0();
    a = w8({
      transport: t,
      accountsObservable: f,
      injectWindow: n.dangerouslyInjectWindow,
      eip6963: n.eip6963
    }), window.addEventListener("message", (u) => {
      u.origin === bn && u.data === "wallet:locked" && f.notify([]);
    });
  }
  let s;
  if (i) {
    const f = y0();
    s = MF({
      transport: t,
      accountsObservable: f,
      injectWindow: i.dangerouslyInjectWindow,
      walletStandard: i.walletStandard
    }), window.addEventListener("message", (u) => {
      u.origin === bn && u.data === "wallet:locked" && s.disconnect();
    });
  }
  return {
    bitcoin: o,
    ethereum: a,
    solana: s
  };
}
const b0 = "requests", TF = "0x[0-9a-fA-F]+", OF = new RegExp(
  [
    //
    `${TF}_eth_accounts`
    // To allow Wagmi to reconnect on refresh.
  ].join("|"),
  "g"
), kF = () => {
  const t = (o, a) => {
    window.localStorage.setItem(`${b0}:${o}`, JSON.stringify(a));
  }, e = (o, a) => {
    OF.test(o) && t(o, a);
  }, r = (o) => {
    const a = window.localStorage.getItem(`${b0}:${o}`);
    if (!a)
      return a;
    let s = a;
    try {
      s = JSON.parse(a);
    } catch {
    }
    return s;
  };
  return { saveResponse: e, fetchResponse: (o) => r(o), clear: () => {
    Object.keys(window.localStorage).filter((o) => o.startsWith(`${b0}:`)).forEach((o) => window.localStorage.removeItem(o));
  } };
}, CF = () => {
  let t = m0(), e = null;
  return t.resolved = !1, {
    awaitReady: () => t.promise,
    getState: () => e,
    isReady: () => !!t.resolved,
    setReady: (s = "success") => {
      t.resolve(), t.resolved = !0, e = s;
    },
    resetReady: () => {
      t = m0(), t.resolved = !1, e = null;
    }
  };
};
function PF(t) {
  return t ? `${bn}?appId=${t}` : bn;
}
function NF(t) {
  const e = document.createElement("iframe"), r = PF(t);
  return e.setAttribute("src", r), e.style.width = "100%", e.style.height = "100%", e.style.display = "none", e.style.border = "none", e.style.colorScheme = "normal", e.allow = "clipboard-write; publickey-credentials-get *", e;
}
const dc = (t) => t != null && typeof t == "object", B4 = (t, e) => {
  if (!dc(t) || !dc(e))
    return t === e;
  const r = Object.keys(t), n = Object.keys(e);
  if (r.length !== n.length)
    return !1;
  for (const i of r) {
    const o = t[i], a = e[i], s = dc(o) && dc(a);
    if (s && !B4(o, a) || !s && o !== a)
      return !1;
  }
  return !0;
}, UF = "linear-gradient(193deg, rgba(211, 221, 108, 0.15) 8.94%, rgba(211, 221, 108, 0.00) 24.81%, rgba(217, 177, 216, 0.00) 63.19%, rgba(217, 177, 216, 0.28) 93.8%), linear-gradient(180deg, #FFF 62.19%, #F5F5F5 91%)", FF = 540, LF = '<svg width="104" height="113" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" width="98" height="98" rx="49" fill="url(#passkeys-a)" style="mix-blend-mode:darken"/><g filter="url(#passkeys-b)"><rect x="12" y="9" width="80" height="80" rx="40" fill="#fff" shape-rendering="crispEdges"/><rect x="12.5" y="9.5" width="79" height="79" rx="39.5" stroke="url(#passkeys-c)" stroke-opacity=".09" shape-rendering="crispEdges"/><g clip-path="url(#passkeys-d)"><g filter="url(#passkeys-e)"><rect x="35" y="32" width="34" height="32" rx="9" fill="#181818"/><rect x="35.4" y="32.4" width="33.2" height="31.2" rx="8.6" stroke="url(#passkeys-f)" stroke-opacity=".09" stroke-width=".8"/></g><rect x="51" y="38" width="12" height="11" rx="3" fill="#fff"/></g></g><defs><linearGradient id="passkeys-a" x1="82.625" y1="40.425" x2="-2.155" y2="77.7" gradientUnits="userSpaceOnUse"><stop stop-color="#D3DD6C"/><stop offset=".088" stop-color="#CEBFA2"/><stop offset=".286" stop-color="#CEB0C8" stop-opacity=".5"/><stop offset=".583" stop-color="#CFCAC6" stop-opacity="0"/></linearGradient><linearGradient id="passkeys-c" x1="52" y1="9" x2="52" y2="89" gradientUnits="userSpaceOnUse"><stop stop-color="#151515" stop-opacity="0"/><stop offset=".681" stop-color="#151515"/></linearGradient><linearGradient id="passkeys-f" x1="52" y1="32" x2="52" y2="64" gradientUnits="userSpaceOnUse"><stop stop-color="#151515" stop-opacity="0"/><stop offset=".681" stop-color="#151515"/></linearGradient><filter id="passkeys-b" x="0" y="7" width="104" height="106" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="2" in="SourceAlpha" result="effect1_dropShadow_2288_4118"/><feOffset dy="2"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2288_4118"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="2" in="SourceAlpha" result="effect2_dropShadow_2288_4118"/><feOffset dy="4"/><feGaussianBlur stdDeviation="4"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"/><feBlend in2="effect1_dropShadow_2288_4118" result="effect2_dropShadow_2288_4118"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius=".635" in="SourceAlpha" result="effect3_dropShadow_2288_4118"/><feOffset dy=".635"/><feGaussianBlur stdDeviation=".635"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend in2="effect2_dropShadow_2288_4118" result="effect3_dropShadow_2288_4118"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius=".635" in="SourceAlpha" result="effect4_dropShadow_2288_4118"/><feOffset dy="1.27"/><feGaussianBlur stdDeviation="1.27"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"/><feBlend in2="effect3_dropShadow_2288_4118" result="effect4_dropShadow_2288_4118"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="2" in="SourceAlpha" result="effect5_dropShadow_2288_4118"/><feOffset dy="4"/><feGaussianBlur stdDeviation="3"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"/><feBlend in2="effect4_dropShadow_2288_4118" result="effect5_dropShadow_2288_4118"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="4" in="SourceAlpha" result="effect6_dropShadow_2288_4118"/><feOffset dy="12"/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend in2="effect5_dropShadow_2288_4118" result="effect6_dropShadow_2288_4118"/><feBlend in="SourceGraphic" in2="effect6_dropShadow_2288_4118" result="shape"/></filter><filter id="passkeys-e" x="30.2" y="30.4" width="43.6" height="41.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="1.6" in="SourceAlpha" result="effect1_dropShadow_2288_4118"/><feOffset dy="1.6"/><feGaussianBlur stdDeviation="1.6"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2288_4118"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="1.6" in="SourceAlpha" result="effect2_dropShadow_2288_4118"/><feOffset dy="3.2"/><feGaussianBlur stdDeviation="3.2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"/><feBlend in2="effect1_dropShadow_2288_4118" result="effect2_dropShadow_2288_4118"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_2288_4118" result="shape"/></filter><clipPath id="passkeys-d"><path fill="#fff" transform="translate(32 29)" d="M0 0h40v40H0z"/></clipPath></defs></svg>', jF = '<svg width="104" height="112" viewBox="0 0 104 112" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="52" cy="48" r="48" fill="url(#paint0_linear_7014_172)" style="mix-blend-mode:darken"/><g filter="url(#filter0_dddddd_7014_172)"><circle cx="52" cy="48" r="40" fill="#181818"/><circle cx="52" cy="48" r="39.5" stroke="url(#paint1_linear_7014_172)" stroke-opacity="0.09"/></g><ellipse cx="41.6512" cy="47.6512" rx="7.65123" ry="7.65123" fill="white"/><ellipse cx="62.349" cy="47.6512" rx="7.65123" ry="7.65123" fill="white"/><ellipse cx="1.69244" cy="1.69244" rx="1.69244" ry="1.69244" transform="matrix(1 0 0 -1 64.335 50.4112)" fill="#181818"/><ellipse cx="1.69244" cy="1.69244" rx="1.69244" ry="1.69244" transform="matrix(1 0 0 -1 42.8979 50.4112)" fill="#181818"/><ellipse cx="10" cy="10" rx="10" ry="10" transform="matrix(1 0 0 -1 52.437 40)" fill="#181818"/><ellipse cx="10" cy="10" rx="10" ry="10" transform="matrix(1 0 0 -1 31 40)" fill="#181818"/><defs><filter id="filter0_dddddd_7014_172" x="0" y="6" width="104" height="106" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect1_dropShadow_7014_172"/><feOffset dy="2"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7014_172"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect2_dropShadow_7014_172"/><feOffset dy="4"/><feGaussianBlur stdDeviation="4"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"/><feBlend mode="normal" in2="effect1_dropShadow_7014_172" result="effect2_dropShadow_7014_172"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="0.635" operator="erode" in="SourceAlpha" result="effect3_dropShadow_7014_172"/><feOffset dy="0.635"/><feGaussianBlur stdDeviation="0.635"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend mode="normal" in2="effect2_dropShadow_7014_172" result="effect3_dropShadow_7014_172"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="0.635" operator="erode" in="SourceAlpha" result="effect4_dropShadow_7014_172"/><feOffset dy="1.27"/><feGaussianBlur stdDeviation="1.27"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"/><feBlend mode="normal" in2="effect3_dropShadow_7014_172" result="effect4_dropShadow_7014_172"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect5_dropShadow_7014_172"/><feOffset dy="4"/><feGaussianBlur stdDeviation="3"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"/><feBlend mode="normal" in2="effect4_dropShadow_7014_172" result="effect5_dropShadow_7014_172"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feMorphology radius="4" operator="erode" in="SourceAlpha" result="effect6_dropShadow_7014_172"/><feOffset dy="12"/><feGaussianBlur stdDeviation="8"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"/><feBlend mode="normal" in2="effect5_dropShadow_7014_172" result="effect6_dropShadow_7014_172"/><feBlend mode="normal" in="SourceGraphic" in2="effect6_dropShadow_7014_172" result="shape"/></filter><linearGradient id="paint0_linear_7014_172" x1="82" y1="39.6" x2="-1.05" y2="76.1139" gradientUnits="userSpaceOnUse"><stop stop-color="#D3DD6C"/><stop offset="0.0877097" stop-color="#CEBFA2"/><stop offset="0.285812" stop-color="#CEB0C8" stop-opacity="0.5"/><stop offset="0.582843" stop-color="#CFCAC6" stop-opacity="0"/></linearGradient><linearGradient id="paint1_linear_7014_172" x1="52" y1="8" x2="52" y2="88" gradientUnits="userSpaceOnUse"><stop stop-color="#151515" stop-opacity="0"/><stop offset="0.681179" stop-color="#151515"/></linearGradient></defs></svg>';
class DF {
  constructor() {
    Le(this, "parseFromString", () => "");
  }
}
const $F = new (typeof window > "u" ? DF : DOMParser)();
function Z2(t) {
  return $F.parseFromString(t, "image/svg+xml").firstChild;
}
const Q2 = {
  popup: Z2(LF),
  private: Z2(jF)
};
function up({ element: t, style: e }) {
  Object.assign(t.style, e);
}
function em(t) {
  const { element: e } = t;
  e.style.cssText = "", up(t);
}
function qF() {
  const t = {
    default: [],
    fullScreen: []
  }, e = window.matchMedia(`(max-width: ${FF}px)`), r = (o, a) => {
    Object.entries(a).forEach(([s, f]) => t[s].push({ element: o, style: f })), em({ element: o, style: a.default }), e.matches && up({ element: o, style: a.fullScreen });
  }, n = () => {
    if (e.matches) {
      t.fullScreen.forEach(up);
      return;
    }
    t.default.forEach(em);
  };
  return e.addEventListener("change", n), {
    registerStyles: r,
    removeResponsiveListeners: () => {
      e.removeEventListener("change", n);
    }
  };
}
const zF = {
  background: "#181818",
  color: "#fff",
  padding: "14px",
  border: "none",
  borderRadius: "12px",
  width: "100%"
}, KF = {
  border: "none",
  color: "#181818",
  background: "none"
}, WF = {
  primary: zF,
  secondary: KF
};
function HF() {
  const t = document.createElement("div");
  return t.style.background = "rgba(0, 0, 0, 0.5)", t.style.bottom = "0", t.style.left = "0", t.style.opacity = "0", t.style.overflow = "auto", t.style.position = "fixed", t.style.display = "flex", t.style.alignItems = "flex-start", t.style.right = "0", t.style.top = "0", t.style.transition = "opacity 0.3s ease-in-out", t.style.zIndex = "999999999", setTimeout(() => t.style.opacity = "1", 100), t;
}
function GF({ width: t = 400, height: e = 430, registerStyles: r }) {
  const n = document.createElement("div");
  return n.ariaModal = "true", n.role = "dialog", n.tabIndex = -1, n.dataset.clickOutsideContext = "wallet-widget", r(n, {
    default: {
      boxSizing: "border-box",
      alignItems: "center",
      background: UF,
      borderRadius: "32px",
      color: "black",
      display: "flex",
      flexDirection: "column",
      fontWeight: "500",
      gap: "16px",
      margin: "10vh auto",
      minHeight: `${e}px`,
      outline: "none",
      padding: "40px",
      position: "relative",
      width: `${t}px`
    },
    fullScreen: {
      alignSelf: "flex-end",
      width: "100%",
      maxHeight: "85vh",
      margin: "0",
      padding: "40px 24px 24px",
      borderBottomLeftRadius: "0",
      borderBottomRightRadius: "0"
    }
  }), n;
}
function tm({ value: t, size: e = 18, color: r = "#000" }) {
  const n = document.createElement("p");
  return n.textContent = t, n.style.color = r, n.style.fontSize = `${e}px`, n.style.lineHeight = "110%", n.style.textAlign = "center", n;
}
function rm({ value: t, variant: e = "primary" }) {
  const r = document.createElement("button"), n = WF[e] || {};
  return r.textContent = t, r.style.cursor = "pointer", r.style.fontSize = "16px", Object.assign(r.style, n), r;
}
function VF({ title: t, message: e }) {
  const r = document.createElement("div");
  r.style.alignItems = "center", r.style.display = "flex", r.style.flex = "1", r.style.flexDirection = "column", r.style.gap = "16px";
  const n = tm({ value: t, size: 24 }), i = tm({
    value: e,
    size: 18,
    color: "#737373"
  });
  return r.append(n), r.append(i), r;
}
function nm({ title: t, message: e, icon: r = "popup", acceptText: n = "Continue", cancelText: i = "Cancel" }) {
  const { registerStyles: o, removeResponsiveListeners: a } = qF(), s = HF(), f = GF({ registerStyles: o }), u = VF({ title: t, message: e }), c = rm({ value: n, variant: "primary" }), d = rm({
    value: i,
    variant: "secondary"
  });
  return Q2[r] && f.append(Q2[r] || void 0), f.append(u), f.append(c), i && f.append(d), s.append(f), document.body.append(s), new Promise((l) => {
    const h = (y) => () => {
      a(), s.remove(), l(y);
    };
    c.addEventListener("click", h(!0)), i && d.addEventListener("click", h(!1));
  });
}
const YF = typeof window < "u", JF = YF ? /\(.*Win.*\)/.test(navigator.userAgent) : !1, im = JF ? 456 : 424, om = 664, XF = async ({ target: t }) => new Promise((r) => {
  const n = window.screen.width / 2 - im / 2, i = window.screen.height / 2 - om / 2, o = window.open(t, "popup", `toolbar=no,location=no,status=no,menubar=no,resizable=no,scrollbars=no,width=${im},height=${om},top=${i},left=${n},`);
  if (!o) {
    r(null);
    return;
  }
  const a = (s) => {
    s.origin !== t || s.data !== "rpc:ready" || (window.removeEventListener("message", a), r(o));
  };
  window.addEventListener("message", a), o.focus();
});
function ZF() {
  const t = document.querySelector(
    'head > meta[property="og:site_name"]'
  );
  if (t)
    return t.content;
  const e = document.querySelector(
    'head > meta[name="title"]'
  );
  return e ? e.content : document.title;
}
async function QF() {
  return {
    title: ZF()
  };
}
const M4 = (t, e) => JSON.stringify({
  jsonrpc: "2.0",
  id: t,
  result: e
}), am = (t, e) => JSON.stringify({
  jsonrpc: "2.0",
  id: t,
  error: e
}), eL = (t, e, r) => JSON.stringify({
  jsonrpc: "2.0",
  id: t,
  method: e,
  params: r
}), tL = (t, e, r) => {
  const n = new URL(t);
  return n.searchParams.append(e, r), n.toString();
}, rL = (t) => {
  if (t.length < 2)
    throw new Error("URL count needs to be at least 2.");
  const { origin: e, protocol: r } = new URL(t[0]);
  if (!e || e === "null" || r !== "https:")
    throw new Error("Reference URL is invalid.");
  for (const n of t)
    if (!(n instanceof URL || typeof n == "string") || e !== new URL(n).origin)
      return !1;
  return !0;
}, sm = (t, e, r) => {
  const { data: n, origin: i } = t;
  return !(!r.includes(i) || typeof n != "object" || n.type !== e);
}, nL = (t) => !rL([lm, t]), iL = ({
  getIframe: t
}) => {
  let e, r, n;
  const i = QF();
  let o;
  i.then((b) => {
    o = b;
  });
  const a = async ({ target: b }) => {
    if ((!e || e != null && e.closed) && (n = void 0), n)
      return n.then((w) => (e.focus(), w));
    if (nL(b))
      throw new Error(`The target URL is forbidden: ${b}`);
    return r = b, e = await XF({ target: b }), e ? { success: !0, error: null } : { success: !1, error: "popup blocked" };
  }, s = async () => {
    await n, n = void 0, r = void 0, e == null || e.close();
  }, f = ({ id: b, response: w }) => {
    const A = M4(b, w), M = { type: w0, input: A }, { element: N, url: G } = t();
    N.contentWindow.postMessage(M, G);
  }, u = async ({ id: b, params: w }) => {
    const A = await nm(w);
    return f({ id: b, response: A });
  }, c = async ({ id: b, params: w }) => (await nm({ cancelText: "", acceptText: "Close", ...w }), f({ id: b, response: !0 })), d = async ({ id: b, method: w, params: A }) => {
    const { target: M, ...N } = A, G = await a({ target: M });
    if (!G.success)
      return f({ id: b, response: G });
    await n, await i;
    const z = {
      type: w0,
      input: eL(b, w, {
        ...N,
        metadata: o
      })
    };
    e.postMessage(z, r);
  }, l = {
    confirm: u,
    notify: c
  };
  return { handleRequest: async (b) => {
    const { id: w, method: A, params: M } = JSON.parse(b.data.input);
    return (l[A] || d)({ id: w, method: A, params: M });
  }, handleResponse: (b) => {
    const { element: w, url: A } = t();
    w.contentWindow.postMessage(b.data, A), s();
  }, handleDetach: s };
}, R4 = typeof window < "u", oL = {
  providers: {},
  renderWidget: async () => {
    throw new Error(
      "`renderWidget` is not available in non-browser environments."
    );
  },
  setWidgetConfig: async () => {
    throw new Error(
      "`setWidgetConfig` is not available in non-browser environments."
    );
  },
  experimental_expand: () => {
    throw new Error(
      "`experimental_expand` is not available in non-browser environments."
    );
  },
  experimental_destroyWidget: () => {
    throw new Error(
      "`experimental_destroyWidget` is not available in non-browser environments."
    );
  }
}, aL = Ye.env.NODE_ENV === "test";
let Bs = null;
const kL = (t) => {
  if (!R4)
    return oL;
  if (Bs && !aL)
    return console.warn(
      "@passkeys/core: 'createWallet' was called more than once. This is not supported."
    ), Bs;
  const { appId: e, providers: r, networks: n } = j4(t), i = NF(e), o = kF(), a = /* @__PURE__ */ new Map(), { awaitReady: s, isReady: f, getState: u, setReady: c, resetReady: d } = CF(), l = (L) => {
    L.origin === bn && L.data === D4 && c();
  };
  window.addEventListener("message", l), window.addEventListener("securitypolicyviolation", function(L) {
    L.blockedURI === bn && c("refused");
  });
  const h = (L) => {
    L.origin === bn && L.data === $4 && o.clear();
  };
  window.addEventListener("message", h);
  const { handleRequest: y, handleResponse: b, handleDetach: w } = iL({
    getIframe: () => ({
      element: i,
      url: bn
    })
  }), A = async (L) => {
    if (!sm(L, w0, [bn, lm]))
      return;
    !!JSON.parse(L.data.input).method ? await y(L) : await b(L);
  };
  window.addEventListener("message", A);
  const M = async (L) => {
    const x = JSON.parse(L);
    if (u() === "refused") {
      window.postMessage({
        type: qf,
        input: am(x.id, J1)
      });
      return;
    }
    if (a.set(x.id, { input: L, payload: x, deferred: m0() }), !f()) {
      const C = x.method, j = o.fetchResponse(C);
      if (j) {
        window.postMessage({
          type: qf,
          input: M4(x.id, j),
          fromCache: !0
        });
        return;
      }
    }
    if (await s(), u() === "refused") {
      window.postMessage({
        type: qf,
        input: am(x.id, J1)
      });
      return;
    }
    i.contentWindow.postMessage(
      {
        type: K4,
        input: L
      },
      bn
    );
  }, N = /* @__PURE__ */ new Set(), z = { write: M, on: (L, x) => {
    const C = (j) => {
      if (!sm(j, qf, [
        bn,
        window.location.origin
      ]))
        return;
      const k = JSON.parse(j.data.input), g = a.get(k.id);
      if (g) {
        const { method: R } = g.payload, X = k.result;
        o.saveResponse(R, X), g.deferred.resolve(), a.delete(k.id);
      }
      x(j.data.input);
    };
    N.add(C), window.addEventListener("message", C);
  } };
  let J;
  const oe = (L) => {
    i.contentWindow.postMessage(
      { type: z4, config: L },
      bn
    );
  }, ee = (L) => {
    !L || B4(L, J) || (J = L, f() && oe(L));
  };
  let ae = Promise.resolve();
  const ye = async (L) => {
    await ae, i.parentElement !== L && (await s(), d(), await Promise.allSettled(
      [...a.values()].map(({ deferred: x }) => x.promise)
    ), i.style.display = "initial", i.src = tL(
      i.src,
      "theme",
      JSON.stringify((J == null ? void 0 : J.theme) || {})
    ), L.append(i), await s(), J && oe(J));
  }, pe = () => {
    ae = Promise.resolve(), d(), document.body.append(i), i.style.display = "none", a.forEach(({ input: L }) => M(L)), w();
  }, te = async (L) => L ? (ae = ye(L), ae) : pe(), F = async ({ path: L } = {}) => {
    await s(), L && i.contentWindow.postMessage(
      { type: q4, path: L },
      bn
    ), window.postMessage({ type: "wallet:resize", expanded: !0 });
  }, v = () => {
    [
      ...N,
      l,
      h,
      A
    ].forEach(
      (x) => window.removeEventListener("message", x)
    ), N.clear(), a.clear(), o.clear(), i.remove(), Bs = null;
  };
  document.body.append(i);
  let B = r;
  return n && (B = n, console.warn("`networks` option is deprecated, use `providers` instead.")), Bs = {
    providers: RF(z, B),
    renderWidget: te,
    setWidgetConfig: ee,
    // eslint-disable-next-line camelcase
    experimental_expand: F,
    // eslint-disable-next-line camelcase
    experimental_destroyWidget: v
  }, Bs;
};
R4 && Object.defineProperty(window, "__passkeys-core-version__", {
  value: F4,
  writable: !1,
  enumerable: !1
});
export {
  kL as createWallet
};
